import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import io from 'socket.io-client';
import Select from 'react-select';
import { Line, Doughnut, Bar, Pie, Scatter } from 'react-chartjs-2';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ProgressBar } from "react-bootstrap";
import GaugeChart from 'react-gauge-chart';
import { useLocation } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';           // ← DOAR AICI, o singură dată
import 'react-datepicker/dist/react-datepicker.css';
import Picker from 'emoji-picker-react'; 
import axios from 'axios';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import Compressor from 'compressorjs';
import "chart.js/auto";
import Calendar from "react-calendar";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import html2canvas from "html2canvas";
import { v4 as uuidv4 } from 'uuid'; 
import polyline from '@mapbox/polyline';
import moment from 'moment';
import QRCode from 'react-qr-code';
import autoTable from 'jspdf-autotable';
import { Rnd } from 'react-rnd';
import ReactDOM from 'react-dom';
import { createPortal } from 'react-dom';
import { useNotification } from '../../shared/NotificationContext';
import styles from '../../styles/UltimatePage.module.css';
import Loader from '../../shared/Loader';
import Notifications from '../../shared/NotificationsSettings';
import ChartMenu from '../../shared/ChartMenu';
import TwoFactorNotification from '../../shared/TwoFactorNotification';
import NotificationCenter from '../../shared/NotificationCenter';
import DeleteNotifications from '../../shared/DeleteNotifications';
import EmailPanel from '../../shared/EmailPanel';

import { PDFDownloadLink, PDFViewer, Document, Page, Text, View } from '@react-pdf/renderer';
import { pdf } from '@react-pdf/renderer';
import { 
  Document as DocxDocument, 
  Packer, 
  Paragraph, 
  Table as DocxTable, 
  TableRow as DocxTableRow, 
  TableCell as DocxTableCell, 
  TextRun, 
  HeadingLevel, 
  WidthType 
} from 'docx';
// ← ȘTERS al doilea import saveAs de aici
import InvoicePDF from './InvoicePDF';
import PdfViewerWithSelect from "./PdfViewerWithSelect";
import {
  Chart as ChartJS,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  ArcElement
} from 'chart.js';
import {
  BarChart,
  XAxis,
  YAxis,
  LineChart,
  CartesianGrid,
  PieChart,
  Cell
} from "recharts";
import { GoogleMap, LoadScript, Marker, Polyline, Circle } from '@react-google-maps/api';
import { Chart, registerables } from "chart.js";
import { getTimeWindowDP, resolveDriverName } from "../../../utils/dashboard";


// Înregistrăm ArcElement împreună cu celelalte elemente
ChartJS.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Legend,
  Title
);

axios.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
const socket = io('https://api-backend.full-trucking-service.com', {
  transports: ['websocket', 'polling'],
  secure: true, // Asigură conexiuni securizate în mediul de producție
  reconnect: true, // Activează reconectarea automată în cazul întreruperii
  timeout: 20000, // Timpul maxim de conectare înainte de timeout (în milisecunde)
  reconnectionAttempts: 5, // Numărul de încercări de reconectare înainte de a renunța
  reconnectionDelay: 1000, // Întârziere între reconectări (în milisecunde)
  rejectUnauthorized: false, // Permite conexiuni securizate fără a respinge cererile nesemnate
});



const apiUrl = process.env.REACT_APP_API_URL || 'https://api-backend.full-trucking-service.com/api';

const PremiumPage = () => {
  
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [activeSection, setActiveSection] = useState('dashboard'); // Default la dashboard
  const [lastInteractionTime, setLastInteractionTime] = useState(Date.now());
  const inactivityTimeoutRef = useRef(null);
  const refreshOnNextInteractionRef = useRef(false);
  const [selectedLoadId, setSelectedLoadId] = useState(null);
  
  const [drivers, setDrivers] = useState([]);
  const [trucks, setTrucks] = useState([]);
  const [trailers, setTrailers] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [shippers, setShippers] = useState([]);
  const [consignees, setConsignees] = useState([]);
  const [loads, setLoads] = useState([]);
  const [driverPays, setDriverPays] = useState([]);
  const [dashboardData, setDashboardData] = useState({});
  const [loadNumber, setLoadNumber] = useState('');
  const [dispatcher, setDispatcher] = useState('');
  const [brokerName, setBrokerName] = useState('');
  const [brokerAddress, setBrokerAddress] = useState('');
  const [rate, setRate] = useState('');
  const [equipment, setEquipment] = useState('');
  const [driver, setDriver] = useState('');
  const [truck, setTruck] = useState('');
  const [trailer, setTrailer] = useState('');
  const [status, setStatus] = useState('');
  const [shipperName, setShipperName] = useState('');
  const [shipperAddress, setShipperAddress] = useState('');
  const [consigneeName, setConsigneeName] = useState('');
  const [consigneeAddress, setConsigneeAddress] = useState('');
  const [miles, setMiles] = useState('');
  const [dh, setDH] = useState('');
  const [notes, setNotes] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [messages, setMessages] = useState([]);
  const [startDate, setStartDate] = useState('');  // Definim startDate
  const [endDate, setEndDate] = useState('');  
  const [loading, setLoading] = useState(false);
  const [dispatchers, setDispatchers] = useState([]); // Definește `dispatchers`
  const [currentUserId, setCurrentUserId] = useState(null); // Definește `currentUserId`
  const [currentUserRole, setCurrentUserRole] = useState(null); // Definește `currentUserRole`
  const [hasTwoFactorAuth, setHasTwoFactorAuth] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const location = useLocation(); // Inițializează useLocation
  const userRole = location.state?.role || 'client'; // Setează 'client' ca rol implicit
  const [isLoading, setIsLoading] = useState(true); // Stare pentru controlul procesului de încărcare
  const [isInitialized, setIsInitialized] = useState(false); // Controlăm complet procesul de inițializare
  const [isTwoFactorEnabled, setIsTwoFactorEnabled] = useState(false);
  const [twoFactorWarning, setTwoFactorWarning] = useState(false);
  const { notify } = useNotification();
  const [fuelReports, setFuelReports] = useState([]);
const [iftaReports, setIftaReports] = useState([]);
const [userSettings, setUserSettings] = useState({});

  const [kpiData, setKpiData] = useState({
  utilizationRate: 0,
  revenuePerTruck: 0,
  revenuePerDriver: 0,
  profitMargin: 0,
  operatingRatio: 0,
  iftaCompliance: 0,
  driverTurnover: 0,
  payPerMile: 0,
  maintCostPerMile: 0,
  fuelEfficiency: 0,
  nextServiceDue: 0,
  topClients: [],
  repeatLoads: 0,
  loadsPerDispatcher: 0,
  revenuePerDispatcher: 0,
});
useEffect(() => {
  fetchTheme();
}, []);

const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

useEffect(() => {
  fetchTheme();
}, []);

const fetchTheme = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };

    const apiUrl = "https://api-backend.full-trucking-service.com/api";

    const res = await axios.get(`${apiUrl}/settings`, config);

    if (res.data.theme) {
      setTheme(res.data.theme);
    }
  } catch (err) {
    console.log("Error fetching theme:", err);
  }
};


  const [isInteractionAllowed, setIsInteractionAllowed] = useState(false);
  const [unreadMessages, setUnreadMessages] = useState(() => {
    const saved = localStorage.getItem("unreadMessages");
    try {
      const parsed = JSON.parse(saved);
      return typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch {
      return {};
    }
  });
  
  const audioRef = useRef(null);
  
  const getToken = () => {
    return sessionStorage.getItem('token') || localStorage.getItem('token');
  };
  
  const socketRef = useRef(null);
  const clientId = localStorage.getItem('clientId');
  const [newMessageNotification, setNewMessageNotification] = useState(null);

// 🔥 Funcție pentru afișarea notificării vizuale
const showNewMessageNotification = (data) => {
  setNewMessageNotification(`${data.sender}: ${data.message}`);

  setTimeout(() => {
    setNewMessageNotification(null);
  }, 5000); // 🔥 Se ascunde după 5 secunde
};


  const handleNavigateToSection = (section, loadId = null) => {
    setActiveSection(section);
    setSelectedLoadId(loadId); // Setăm `loadId` pentru secțiunea `LoadManager`
  };

  const savedPermissions = JSON.parse(localStorage.getItem('permissions')) || [];

const accessibleModules =
  savedPermissions && savedPermissions.length > 0
    ? savedPermissions // ✅ Folosește permisiunile reale din DB
    : userRole === "client"
    ? [
        "dashboard",
        "exports",
         "imports",
        "driver-dashboard",
        "truck-dashboard",

        "accounting-manager",
        "driver-pay",
        "driverpay-manager",
        "fleet-report",
        "payroll-employee",
        "payroll-manager",
        "invoice",
        "receivedInvoices",
        "balanceSheet",
        "ifta",
        "fuel-report",
        "truckandtrailer",

        "drivers",
        "trucks",
        "trailers",
        "shippers",
        "consignee",
        "brokers",
        "employees",

        "load-manager",
        "load-finder",
        "trucking",
        
        "settings",
        "add-new-load",
      ]
    : [];

  
    const queryParams = new URLSearchParams(window.location.search);
    const activeTab = queryParams.get('tab') || 'default'; // Default poate fi un alt tab implicit.
  

    useEffect(() => {
      if (activeTab === 'add-new-load') {
        setActiveSection('add-new-load');
      }
    }, [activeTab]);
  
    useEffect(() => {
      if (activeSection === 'settings' && !isTwoFactorEnabled) {
        const element = document.querySelector('.twoFactorWarningsettings');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }, [activeSection, isTwoFactorEnabled]);
    

    useEffect(() => {
      const resetInactivityTimer = () => {
        setLastInteractionTime(Date.now());
  
        if (refreshOnNextInteractionRef.current) {
          refreshOnNextInteractionRef.current = false;
          window.location.reload();
        }
  
        if (inactivityTimeoutRef.current) {
          clearTimeout(inactivityTimeoutRef.current);
        }
  
        inactivityTimeoutRef.current = setTimeout(() => {
          refreshOnNextInteractionRef.current = true;
        }, 10 * 60 * 1000); // 10 minute
      };
  
      document.addEventListener("mousemove", resetInactivityTimer);
      document.addEventListener("keydown", resetInactivityTimer);
      document.addEventListener("scroll", resetInactivityTimer);
      document.addEventListener("click", resetInactivityTimer);
  
      return () => {
        document.removeEventListener("mousemove", resetInactivityTimer);
        document.removeEventListener("keydown", resetInactivityTimer);
        document.removeEventListener("scroll", resetInactivityTimer);
        document.removeEventListener("click", resetInactivityTimer);
  
        if (inactivityTimeoutRef.current) {
          clearTimeout(inactivityTimeoutRef.current);
        }
      };
    }, []);
    // === KPI CALCULATOR ===
const calculateKPIData = (drivers, trucks, loads, driverPays, iftaReports, brokers) => {
  if (!loads || loads.length === 0) {
    setKpiData({
      utilizationRate: 0,
      revenuePerTruck: 0,
      revenuePerDriver: 0,
      profitMargin: 0,
      operatingRatio: 0,
      iftaCompliance: 0,
      driverTurnover: 0,
      payPerMile: 0,
      maintCostPerMile: 0,
      fuelEfficiency: 0,
      nextServiceDue: 0,
      topClients: [],
      repeatLoads: 0,
      loadsPerDispatcher: 0,
      revenuePerDispatcher: 0,
    });
    return;
  }

  // aici bagi calculele (fix cum ți le-am rescris mai sus)
};


  const fetchData = async () => {
  try {
    const token = localStorage.getItem('token');
    const tokenExpiration = localStorage.getItem('tokenExpiration');

    if (!token || !tokenExpiration || new Date() >= new Date(tokenExpiration)) {
      notify('Session expired. Please log in again.', 'error');
      navigate('/login');
      return;
    }

    // verifică dacă există cache în localStorage
    const cached = localStorage.getItem("dashboardData");
// în fetchData, după ce citești din localStorage:
if (cached) {
  const parsed = JSON.parse(cached);
  setUserSettings(parsed.userSettings || {});
  setDrivers(parsed.drivers || []);
  setTrucks(parsed.trucks || []);
  setTrailers(parsed.trailers || []);
  setBrokers(parsed.brokers || []);
  setShippers(parsed.shippers || []);
  setConsignees(parsed.consignees || []);
  setLoads(parsed.loads || []);
  setDriverPays(parsed.driverPays || []);
  calculateDashboardData(
    parsed.drivers,
    parsed.trucks,
    parsed.loads,
    parsed.iftaReports
  );
  // NU mai face return aici
}

// indiferent dacă există cache sau nu, refă requestul real:
const config = {
  headers: {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  },
  withCredentials: true,
};

const [
  userSettingsRes,
  driversRes,
  trucksRes,
  trailersRes,
  brokersRes,
  shippersRes,
  consigneesRes,
  loadsRes,
  driverPaysRes,
  iftaReportsRes,
  fuelReportsRes
] = await Promise.all([
  axios.get(`${apiUrl}/settings`, config),
  axios.get(`${apiUrl}/drivers`, config),
  axios.get(`${apiUrl}/trucks`, config),
  axios.get(`${apiUrl}/trailers`, config),
  axios.get(`${apiUrl}/brokers`, config),
  axios.get(`${apiUrl}/shippers`, config),
  axios.get(`${apiUrl}/consignees`, config),
  axios.get(`${apiUrl}/loads`, config),
  axios.get(`${apiUrl}/driverpays`, config),
  axios.get(`${apiUrl}/ifta`, config),
  axios.get(`${apiUrl}/fuel-reports`, config),
]);

setUserSettings(userSettingsRes.data);
setDrivers(driversRes.data);
setTrucks(trucksRes.data);
setTrailers(trailersRes.data);
setBrokers(brokersRes.data);
setShippers(shippersRes.data);
setConsignees(consigneesRes.data);
setLoads(loadsRes.data);
setDriverPays(driverPaysRes.data);
setIftaReports(iftaReportsRes.data);
setFuelReports(fuelReportsRes.data);

calculateDashboardData(
  driversRes.data,
  trucksRes.data,
  loadsRes.data,
  iftaReportsRes.data
);

calculateKPIData(
  driversRes.data,
  trucksRes.data,
  loadsRes.data,
  driverPaysRes.data,
  iftaReportsRes.data,
  brokersRes.data,
  fuelReportsRes.data
);

// actualizează cache-ul cu date proaspete
localStorage.setItem("dashboardData", JSON.stringify({
  userSettings: userSettingsRes.data,
  drivers: driversRes.data,
  trucks: trucksRes.data,
  trailers: trailersRes.data,
  brokers: brokersRes.data,
  shippers: shippersRes.data,
  consignees: consigneesRes.data,
  loads: loadsRes.data,
  driverPays: driverPaysRes.data,
  iftaReports: iftaReportsRes.data,
  fuelReports: fuelReportsRes.data,
}));

  } catch (error) {
    notify('Failed to fetch data. Please try again later.', 'error');
  }
};
useEffect(() => {
  const fetchLoads = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      };

      const res = await axios.get(`${apiUrl}/loads`, config);
      setLoads(res.data); // ✅ încărcăm toate loadurile din DB
    } catch (err) {
      console.error("Error fetching loads:", err);
      notify("Could not fetch loads", "error");
    }
  };

  fetchLoads();
}, []); // rulează doar la mount
    useEffect(() => {
      const fetchTwoFactorAuthStatus = async () => {
        const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    
        if (!token) {
         
          setHasTwoFactorAuth(false); // Presupunem că 2FA nu este activat
          setIsInitialized(true); // Marcam inițializarea ca fiind completă
          return;
        }
    
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        };
    
        try {
          const response = await axios.get(`${apiUrl}/settings`, config);
          const settings = response.data;
    
          if (settings && typeof settings.twoFactorAuthEnabled === 'boolean') {
            setHasTwoFactorAuth(settings.twoFactorAuthEnabled);
          } else {
          
            setHasTwoFactorAuth(false); // Implicit presupunem că 2FA nu este activat
          }
        } catch (error) {
    
          setHasTwoFactorAuth(false); // Implicit presupunem că 2FA nu este activat
        } finally {
          setIsInitialized(true); // Marcam inițializarea ca fiind completă
        }
      };
    
      fetchTwoFactorAuthStatus();
    }, [apiUrl]);
    
    useEffect(() => {
      const enableAudio = () => setIsInteractionAllowed(true);
      document.addEventListener("click", enableAudio);
      return () => document.removeEventListener("click", enableAudio);
    }, []);
    
    useEffect(() => {
      const values = unreadMessages ? Object.values(unreadMessages) : [];
      if (values.some((count) => count > 0) && isInteractionAllowed) {
        audioRef.current.play().catch((err) => console.error("🔇 Audio playback error:", err));
      }
    }, [unreadMessages]);
    
  const handleSendMessage = (message) => {
    if (message.trim() !== '') {
      setMessages((prevMessages) => [
        ...prevMessages,
        { from: 'me', message },
      ]);
    }
  };


  useEffect(() => {
    localStorage.setItem("unreadMessages", JSON.stringify(unreadMessages));
  }, [unreadMessages]);


  useEffect(() => {
    // Exemplu de apel API pentru a obține dispatchers și datele utilizatorului
    const fetchData = async () => {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token'); // Obține token-ul de autentificare
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`, // Include token-ul cu prefixul Bearer
          'Content-Type': 'application/json',
        },
        withCredentials: true, // Permite trimiterea cookie-urilor pentru autentificare
      };
    
      try {
        // Apel pentru a obține lista de dispatchers
        const dispatchersData = await axios.get('https://api-backend.full-trucking-service.com/api/dispatchers', config);
        setDispatchers(dispatchersData.data);
    
        // Apel pentru a obține datele utilizatorului curent
        const userData = await axios.get('https://api-backend.full-trucking-service.com/api/current-user', config);
        setCurrentUserId(userData.data.id);
        setCurrentUserRole(userData.data.role);
      } catch (error) {

      }
    };
    fetchData();
  }, []);
  const calculateDashboardData = (drivers = [], trucks = [], loads = [], iftaReports = []) => {
    const totalDrivers = Array.isArray(drivers) ? drivers.length : 0;
    const totalLoads = Array.isArray(loads) ? loads.length : 0;
    const totalMiles = Array.isArray(loads)
      ? loads.reduce((sum, load) => sum + parseFloat(load.miles || 0), 0)
      : 0;
    const totalDH = Array.isArray(loads)
      ? loads.reduce((sum, load) => sum + parseFloat(load.dh || 0), 0)
      : 0;
    const totalRevenue = Array.isArray(loads)
      ? loads.reduce((sum, load) => sum + parseFloat(load.rate || 0), 0)
      : 0;
  
    const totalIFTAFuelTax = Array.isArray(iftaReports)
      ? iftaReports.reduce((sum, report) => sum + parseFloat(report.totalFuelTax || 0), 0)
      : 0;
    const totalIFTAFuelCost = Array.isArray(iftaReports)
      ? iftaReports.reduce((sum, report) => sum + parseFloat(report.totalFuelCost || 0), 0)
      : 0;
  
    const upcomingLicenseExpirations = Array.isArray(drivers)
      ? drivers.filter(driver =>
          new Date(driver.licenseExpiryDate) < new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
        ).length
      : 0;
  
    setDashboardData({
      totalDrivers,
      totalLoads,
      totalMiles,
      totalDH,
      totalRevenue,
      totalIFTAFuelTax,
      totalIFTAFuelCost,
      upcomingLicenseExpirations,
      loads, // Include loads data for later use
      drivers, // Include drivers data for later use
      iftaReports, // Include IFTA data for later use
    });
  };
  
  
  function handleImageUpload(event) {
    const file = event.target.files[0];
  
    if (!file) return;
  
    new Compressor(file, {
      quality: 0.6, // Nivel de compresie (0-1), 0.6 înseamnă 60% din calitatea originală
      maxWidth: 1000, // Lățimea maximă a imaginii (în funcție de nevoie)
      success(result) {
        // Trimite imaginea comprimata la server
        const formData = new FormData();
        formData.append('image', result);
  
        fetch('/api/logo', {
          method: 'PUT',
          body: formData,
        })
        .then(response => response.json())
        .then(data => {
      
        })
        .catch(error => {
       
        });
      },
      error(err) {
   
      },
    });
  }
  
  useEffect(() => {
    fetchData();
  }, []);
  const handleUpdateDriver = async (updatedDriver) => {
    try {
      const response = await axios.put(`${apiUrl}/drivers/${updatedDriver._id}`, updatedDriver, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });
  
      if (!response || response.status !== 200) {
        throw new Error('Failed to update driver');
      }
  
      const updatedData = response.data;
      setDrivers((prevDrivers) =>
        prevDrivers.map((driver) => (driver._id === updatedDriver._id ? updatedData : driver))
      );
notify('Driver information has been updated successfully!' , 'succes');
    } catch (error) {

      notify('Failed to update driver' , 'error');
    }
  };
  
  const openSection = (section) => {
    setTimeout(() => {
      setActiveSection(section);
    }, 1000);
  };
  
  
   
  const closeSection = () => setActiveSection(null);

const handleLogout = async () => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://api-backend.full-trucking-service.com/api';

    // 1. Cererea de logout către backend
    await axios.post(`${apiUrl}/logout`, {}, { withCredentials: true });

  } catch (error) {
    // Continuăm cu curățarea chiar dacă backend-ul pică
    console.warn('Backend logout failed, continuing with client cleanup...');
  } finally {
    // 2. localStorage & sessionStorage
    localStorage.clear();
    sessionStorage.clear();

    // 3. Șterge toate cookie-urile accesibile din JS
    document.cookie.split(';').forEach((cookie) => {
      const name = cookie.split('=')[0].trim();
      // Șterge pentru path-ul curent și root
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
    });

    // 4. IndexedDB (dacă folosești Dexie, PouchDB, etc.)
    try {
      const dbs = await indexedDB.databases?.() ?? [];
      await Promise.all(dbs.map(({ name }) => indexedDB.deleteDatabase(name)));
    } catch (_) {}

    // 5. Cache API / Service Workers
    try {
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((key) => caches.delete(key)));
      }

      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((sw) => sw.unregister()));
      }
    } catch (_) {}

    // 6. Curăță state-ul Redux / Zustand / Context (dacă ai store global)
    // store.dispatch(resetStore());  // Redux
    // useAuthStore.getState().reset(); // Zustand

    // 7. Redirecționează și înlocuiește history (fără Back după logout)
    window.location.replace('/login');
  }
};

  const updateUserSettings = async (settings) => {
    setLoading(true); // Pornește animația
    
    const token = sessionStorage.getItem('token');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    };
  
    try {
      const response = await axios.put(`${apiUrl}/settings`, settings, config);
      setUserSettings(response.data.client);

     notify('Settings updated successfully!', 'success');
    } catch (error) {

      if (error.response && error.response.status === 401) {
notify('Unauthorized access. Please log in again.' , 'error');
        navigate('/login');
      }
    } finally {
      setLoading(false); // Oprește animația după finalizarea cererii
    }
  };
  
 

  const handleAddLoad = async (load) => {
    try {
        if (!load.loadNumber || !load.brokerName || !load.brokerAddress || !load.rate || !load.miles || !load.dh) {
           notify('Please fill in all required fields.' , 'error');
            return;
        }

        // Elimina virgula și convertește rate într-un număr
        const cleanedRate = parseFloat(load.rate.replace(/,/g, ''));
        
        const loadData = {
            ...load,
            rate: cleanedRate,  // Asigură-te că `rate` este un număr
            miles: parseFloat(load.miles), // Adaugă miles și convertește în număr
            dh: parseFloat(load.dh), // Adaugă dh și convertește în număr
        };

        const config = { headers: { 'Content-Type': 'application/json' }, withCredentials: true };
        const response = await axios.post(`${apiUrl}/loads`, loadData, config);

        setLoads([...loads, response.data]);
    } catch (error) {

    }
};

  
  
  
const handleAddDriverPay = async (driverPayData) => {
  try {
    const response = await axios.post('https://api-backend.full-trucking-service.com/api/driverpays', driverPayData, {
      withCredentials: true, // Dacă folosești autentificare
    });
 
  } catch (error) {

  }
};




return (
<div className={`${styles.ultimatePage} ${
  theme === 'light' ? styles.ultimatePageLight : ''
}`}>




    
    <header className={styles.headerultimatePage}>
      <div className={styles.logoultimatePage} onClick={() => navigate('')}>
        <span className={styles.logoPart1ultimatePage}>Full</span>{' '}
        <span className={styles.logoPart2ultimatePage}>Trucking</span>{' '}
        <span className={styles.logoPart1ultimatePage}>Service</span>
      </div>

 {/* 🔥 Icon hamburger */}
  <div className={styles.hamburgerUltimate} onClick={() => setIsMenuOpen(!isMenuOpen)}>
    ☰
  </div>

      
      <nav className={`${styles.navultimatePage} ${isMenuOpen ? styles.activeUltimate : ''}`}>
        <ul className={styles.mainMenuultimatePage}>
          {accessibleModules.includes('dashboard') && <li onClick={() => openSection('dashboard')}>Dashboard</li>}
{(accessibleModules.includes('exports') || accessibleModules.includes('imports')) && (
  <li>
    Data Center
    <ul className={styles.subMenuultimatePage}>
      {accessibleModules.includes('exports') && (
        <li onClick={() => openSection('exports')}>Data Export Center</li>
      )}
      {accessibleModules.includes('imports') && (
        <li onClick={() => openSection('imports')}>Data Import Center</li>
      )}
    </ul>
  </li>
)}

          {accessibleModules.includes('accounting-manager') && (
            <li>
              Finance
              <ul className={styles.subMenuultimatePage}>
                <li onClick={() => openSection('accounting-manager')}>Accounting Manager</li>
                <li onClick={() => openSection('driver-pay')}>Driver Pay</li>
                <li onClick={() => openSection('driverpay-manager')}>Driver Pay Manager</li>
               <li onClick={() => openSection('fleet-report')}>Fleet Report</li>
               <li onClick={() => openSection('fleet-report-manager')}>Fleet Report Manager</li>
                <li onClick={() => openSection('payroll-employee')}>Payroll</li> {/* ✅ Asta e cheia pentru PayrollEmployee */}
                <li onClick={() => openSection('payroll-manager')}>Payroll Manager</li>
                <li onClick={() => openSection('invoice')}>Invoice</li>
                <li onClick={() => openSection('receivedInvoices')}>Received Invoices</li>
                <li onClick={() => openSection('balanceSheet')}>Balance Sheet</li>
                <li onClick={() => openSection('ifta')}>IFTA Manual</li>
                <li onClick={() => openSection('fuel-report')}>Fuel Report</li>
                <li onClick={() => openSection('truckandtrailer')}>Additions and Deductions</li>
               
              </ul>
            </li>
          )}
          {accessibleModules.includes('drivers') && (
            <li>
              Operations
              <ul className={styles.subMenuultimatePage}>
                <li onClick={() => openSection('drivers')}>Drivers</li>
                <li onClick={() => openSection('trucks')}>Fleet</li>
                <li onClick={() => openSection('trailers')}>Trailers</li>
                <li onClick={() => openSection('shippers')}>Shippers</li>
                <li onClick={() => openSection('consignee')}>Consignees</li>
                <li onClick={() => openSection('brokers')}>Brokers</li>
                <li onClick={() => openSection('employees')}>Employees</li>
         
         
              </ul>
            </li>
          )}
          {accessibleModules.includes('load-manager') && (
            <li>
              Logistics
              <ul className={styles.subMenuultimatePage}>
                <li onClick={() => openSection('load-manager')}>Load Scheduler</li>
                <li onClick={() => openSection('load-finder')}>Load Tracker</li>
              </ul>
            </li>
          )}
 

          {accessibleModules.includes('settings') && <li onClick={() => openSection('settings')}>Settings</li>}
          {accessibleModules.includes('add-new-load') && (
            <li>
              <button className={styles.buttonultimatePage} onClick={() => openSection('add-new-load')}>
                Load Entry
              </button>
            </li>
          )}
          <li>
            <button className={styles.buttonultimatePage} onClick={handleLogout}>Logout</button>
          </li>
        </ul>
      </nav>
    </header>


{isInitialized && !hasTwoFactorAuth && (
  <TwoFactorNotification 
    hasTwoFactorAuth={hasTwoFactorAuth}
    onNavigateToSection={handleNavigateToSection}
  />)}

{isInitialized && (
<NotificationCenter onNavigateToSection={handleNavigateToSection} />

)}



    <main>
    {activeSection === 'dashboard' && (
    <Dashboard
      dashboardData={dashboardData}
      drivers={drivers}
      trucks={trucks}
      loads={loads}
      onNavigate={setActiveSection}
      shippers={shippers}
      brokers={brokers}
      consignees={consignees}
    />
  )}
  
  {activeSection === 'exports' && <Exports />}

  {activeSection === 'imports' &&  // Trebuie să fie ceva de genul:
<Imports
  theme={theme}
  loads={loads}        // ← acestea trebuie să aibă date
  drivers={drivers}
  trucks={trucks}
  trailers={trailers}
  employees={employees}
  brokers={brokers}
/>}

 {activeSection === 'load-dashboard' && (
  <LoadsDashboard
    drivers={drivers}
    loads={loads}
    onNavigate={setActiveSection}
    shippers={shippers}
    consignees={consignees}
    trucks={trucks}
  />
)}
{activeSection === 'driver-dashboard' && (
  <DriverDashboard 
    drivers={drivers}
    loads={loads}
    trucks={trucks}
    onNavigate={setActiveSection}
  />
)}
{activeSection === 'truck-dashboard' && (  // ✅ Adăugat TruckDashboard
        <TruckDashboard 
            trucks={trucks}
            setTrucks={setTrucks}
            onNavigate={setActiveSection}
        />
    )}

      {activeSection === 'drivers' && <Drivers drivers={drivers} setDrivers={setDrivers} trucks={trucks} />}
      {activeSection === 'trucks' && <Trucks trucks={trucks} setTrucks={setTrucks} drivers={drivers} trailers={trailers} />}
      {activeSection === 'trailers' && <Trailers trailers={trailers} setTrailers={setTrailers} />}
      {activeSection === 'brokers' && <Brokers brokers={brokers} setBrokers={setBrokers} />}
      {activeSection === 'employees' && <Employees employees={employees} setEmployees={setEmployees} />}
      {activeSection === 'shippers' && <Shippers shippers={shippers} setShippers={setShippers} />}
      {activeSection === 'consignee' && <Consignees consignees={consignees} setConsignees={setConsignees} />}
      {activeSection === 'load-manager' && (
        <LoadManager
          loads={loads}
          setLoads={setLoads}
          selectedLoadId={selectedLoadId} // Transmitem loadId-ul selectat
        />
      )}
      {activeSection === 'invoice' && <Invoice
       loads={loads}
      setLoads={setLoads}
      settings={userSettings}
      drivers={drivers}
      trucks={trucks}
      brokers={brokers}
      shippers={shippers}
      consignees={consignees}
         />}
         {activeSection === 'receivedInvoices' && <ReceivedInvoices />}
      {activeSection === 'load-finder' && <LoadFinder loads={loads} />}
      {activeSection === 'accounting-manager' && <AccountingManager loads={loads} drivers={drivers} />}
      {activeSection === 'driver-pay' && <DriverPay drivers={drivers} trucks={trucks} loads={loads} onAddDriverPay={handleAddDriverPay} />}
      {activeSection === 'driverpay-manager' && <DriverPayManager drivers={drivers} trucks={trucks}  />}
      {activeSection === 'fleet-report' && <FleetReport drivers={drivers} trucks={trucks} loads={loads} />}
      {activeSection === 'fleet-report-manager' && <FleetReportManager trucks={trucks} />}
      {activeSection === 'payroll-employee' && <PayrollEmployee employees={employees} />}
      {activeSection === 'payroll-manager' && <PayrollManager employees={employees} />}
      {activeSection === 'fuel-report' && <FuelReport drivers={drivers} trucks={trucks} />}
     {activeSection === 'settings' && <Settings settings={userSettings} updateUserSettings={updateUserSettings} drivers={drivers} />}
      {activeSection === 'add-new-load' && <AddLoad
  onClose={closeSection}
  onAddLoad={handleAddLoad}
  drivers={drivers}
  trucks={trucks}
  trailers={trailers}
  brokers={brokers}
  shippers={shippers}
  consignees={consignees}

  dispatchers={dispatchers} // Asigură-te că `dispatchers` este definit în componenta principală
  currentUserId={currentUserId} // Obține `currentUserId` și `currentUserRole` din starea sau props
  currentUserRole={currentUserRole}
/>
}      {activeSection === 'ifta' && <IFTA />}
     
{activeSection === 'balanceSheet' && (
  <BalanceSheet/>
)}
{activeSection === 'truckandtrailer' && (
  <TruckAndTrailers />
)}
    </main>

  </div>
);
};

const DriverDashboard = ({ onNavigate }) => {
  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [driverDetails, setDriverDetails] = useState(null);
  const [loading, setLoading] = useState(false);
 const [isSidebarOpen, setIsSidebarOpen] = useState(false);
 const [userSettings, setUserSettings] = useState({});
   const [updatedSettings, setUpdatedSettings] = useState({});
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

 // pentru Add Widget modal
const [showAddModal, setShowAddModal] = useState(false);
const [charts, setCharts] = useState([]);
  const [timeRange, setTimeRange] = useState("month");
  const [customStartDate, setCustomStartDate] = useState("");
  const [customEndDate, setCustomEndDate] = useState("");
  const [showMore, setShowMore] = useState(false);
const [showLoadsModal, setShowLoadsModal] = useState(false);
const [driverLoadsList, setDriverLoadsList] = useState([]);
const [totalDriverPay, setTotalDriverPay] = useState(0);
const [driverLoads, setDriverLoads] = useState({ completed: 0, open: 0 });
  const [rateEvolution, setRateEvolution] = useState({ labels: [], values: [] });
  const [fuelUsage, setFuelUsage] = useState(0);
  const [loads, setLoads] = useState([]);
const [avgLoadDistanceData, setAvgLoadDistanceData] = useState([]);
const [loadsPerWeekData, setLoadsPerWeekData] = useState([]);
const [revenueVsFuelData, setRevenueVsFuelData] = useState([]);
const [deadheadData, setDeadheadData] = useState([]);
const [topBrokersData, setTopBrokersData] = useState([]);
const [onTimeDeliveryData, setOnTimeDeliveryData] = useState([]);
const [earningsShareData, setEarningsShareData] = useState([]);
const [driverLoadsData, setDriverLoadsData] = useState([]);
const [driverFuelAggregated, setDriverFuelAggregated] = useState(null);
const [driverPayDetail, setDriverPayDetail]           = useState(null);
const [isLoadingFuelAgg, setIsLoadingFuelAgg]         = useState(false);
const [isLoadingDPDetail, setIsLoadingDPDetail]       = useState(false);
// dacă ai nevoie de clientId (ex: pentru requests la backend)
const [clientId, setClientId] = useState(null);
const [revenueVsFuelTimeline, setRevenueVsFuelTimeline] = useState({
  labels: [],
  revenue: [],
  fuel: []
});

// dacă folosești KPI-uri
const [kpiData, setKpiData] = useState([]);

// charts (toate metricele într-un singur array)




const allChartOptions = [
  { key: "avgLoadDistance", label: "Average Load Distance" },
  { key: "loadsPerWeek", label: "Loads per Week" },
  { key: "revenueVsFuel", label: "Revenue vs Fuel Cost" },
  { key: "deadhead", label: "Deadhead %" },
  { key: "topBrokers", label: "Top Brokers" },
  { key: "onTimeDelivery", label: "On-Time Delivery %" },
  { key: "earningsShare", label: "Driver Earnings Share" }
];


const [centsPerMile, setCentsPerMile] = useState({ labels: [], values: [] });
const [earningsPerMile, setEarningsPerMile] = useState([]);
const [avgLoadDistance, setAvgLoadDistance] = useState([]);
  const [totalPay, setTotalPay] = useState(0);
  const [activeSection, setActiveSection] = useState('driver-dashboard');
 const [driverPays, setDriverPays] = useState({}); 

const [chartTypes, setChartTypes] = useState({
  loadStatus: "Pie",
  rateEvolution: "Line",
  fuelUsage: "Doughnut",
  totalPay: "Bar",
  driverPay: "Bar",           // pentru fiecare driver
  centsPerMile: "Bar",        // 👈 default CPM
  earningsPerMile: "Bar",     // 👈 default Earnings per Mile
  avgLoadDistance: "Bar",     // 👈 Average Load Distance
  loadsPerWeek: "Column",     // 👈 Loads per Week
  revenueVsFuel: "Line",      // 👈 Revenue vs Fuel Cost
  deadheadPercent: "Doughnut",// 👈 Deadhead %
  topBrokers: "Bar",          // 👈 Top Brokers
  onTimeDelivery: "Bar",      // 👈 On-Time Delivery %
  earningsShare: "Pie"        // 👈 Driver Earnings Share
});



  const apiUrl = "https://api-backend.full-trucking-service.com/api";
  const token = sessionStorage.getItem("token");

  const config = {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  };

  useEffect(() => {
    fetchDrivers();
  }, []);

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const apiUrl = 'https://api-backend.full-trucking-service.com/api';

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || 'dark');
    } catch (err) {
      setTheme('dark');
    }
  };

  fetchTheme();
}, []);

  const handleChartTypeChange = (chartKey, newType) => {
    setChartTypes(prev => ({ ...prev, [chartKey]: newType }));
  };
  
 const downloadChartAsPDF = (chartId, chartTitle) => {
  const input = document.getElementById(chartId);
  if (!input) {
   
    return;
  }

  html2canvas(input).then(canvas => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();

    if (!chartTitle || typeof chartTitle !== "string") {
      chartTitle = "Chart Export";
    }

    pdf.text(chartTitle, 10, 10);
    pdf.addImage(imgData, "PNG", 10, 20, 180, 100);
    pdf.save(`${chartTitle.replace(/\s+/g, "_")}.pdf`);
  }).catch(error => {
   
  });
};

const getDateRange = () => {
  let startDate = new Date();
  let endDate   = new Date();

  if (timeRange === "custom" && customStartDate && customEndDate) {
    return { startDate: new Date(customStartDate), endDate: new Date(customEndDate) };
  }
  switch (timeRange) {
    case "day":   startDate.setHours(0, 0, 0, 0); break;
    case "week":  startDate.setDate(endDate.getDate() - 7); break;
    case "month": startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1); break;
    case "year":  startDate = new Date(startDate.getFullYear(), 0, 1); break;
    default:      startDate = new Date(0);
  }
  return { startDate, endDate };
};

// ── Fetch când se schimbă driver/timeRange ────────────────────────────────────
useEffect(() => {
  if (!selectedDriver?._id) return;

  const { startDate, endDate } = getDateRange();
  const s = startDate.toISOString();
  const e = endDate.toISOString();

  // Fuel aggregated
  const fetchFuelAgg = async () => {
    try {
      setIsLoadingFuelAgg(true);
      const res = await axios.get(
        `${apiUrl}/dashboard/driver/${selectedDriver._id}/fuel-aggregated`,
        { ...config, params: { startDate: s, endDate: e } }
      );
      setDriverFuelAggregated(res.data);
    } catch (err) {
      console.error("❌ fuel aggregated error:", err);
      setDriverFuelAggregated(null);
    } finally {
      setIsLoadingFuelAgg(false);
    }
  };

  // DriverPay detail
  const fetchDPDetail = async () => {
    try {
      setIsLoadingDPDetail(true);
      const res = await axios.get(
        `${apiUrl}/dashboard/driver/${selectedDriver._id}/driverpay-detail`,
        { ...config, params: { startDate: s, endDate: e } }
      );
      setDriverPayDetail(res.data);
    } catch (err) {
      console.error("❌ driverpay detail error:", err);
      setDriverPayDetail(null);
    } finally {
      setIsLoadingDPDetail(false);
    }
  };

  fetchFuelAgg();
  fetchDPDetail();
}, [selectedDriver, timeRange, customStartDate, customEndDate]);

const handleDownloadExcelDriverDashboard = () => {
  if (!driverDetails) return;

  const workbook = XLSX.utils.book_new();

  const completedLoadsRaw = (driverLoadsData || []).filter(
  load => load.status?.toLowerCase() === "completed"
);

const totalRateCompleted = completedLoadsRaw.reduce((sum, l) => sum + (l.rate || 0), 0);
const totalMilesCompleted = completedLoadsRaw.reduce((sum, l) => sum + (l.miles || 0), 0);

const completedLoads = completedLoadsRaw.map(load => ({
  "Load Number": load.loadNumber,
  "Status": load.status,
  "Rate": load.rate,
  "Miles": load.miles,
  "Total Rate": totalRateCompleted,
  "Total Miles": totalMilesCompleted,
  "Driver": `${driverDetails.firstName} ${driverDetails.lastName}`,
  "Truck": load.truck?.plate || "N/A",
  "Completed At": new Date(load.updatedAt || load.date).toLocaleString(),
  "Shipper": load.shippers?.map(s => s.address).join(", ") || "N/A",
  "Consignee": load.consignees?.map(c => c.address).join(", ") || "N/A",
  "Notes": load.notes || ""
}));

  const wsCompleted = XLSX.utils.json_to_sheet(completedLoads);
  XLSX.utils.book_append_sheet(workbook, wsCompleted, "Completed Loads");

  // === Sheet 2: Open Loads ===
  const openLoads = (driverLoadsData || []).filter(
    load => load.status?.toLowerCase() !== "completed" && load.status?.toLowerCase() !== "canceled"
  ).map(load => ({
    "Load Number": load.loadNumber,
    "Status": load.status,
    "Rate": load.rate,
    "Miles": load.miles,
    "Driver": `${driverDetails.firstName} ${driverDetails.lastName}`,
    "Truck": load.truck?.plate || "N/A",
    "Created At": new Date(load.createdAt).toLocaleString(),
    "Updated At": new Date(load.updatedAt).toLocaleString(),
    "Shipper": load.shippers?.map(s => s.address).join(", ") || "N/A",
    "Consignee": load.consignees?.map(c => c.address).join(", ") || "N/A",
    "Notes": load.notes || ""
  }));
  const wsOpen = XLSX.utils.json_to_sheet(openLoads);
  XLSX.utils.book_append_sheet(workbook, wsOpen, "Open Loads");

const driverPayDetails = completedLoadsRaw.map(load => ({
  "Load Number": load.loadNumber,
  "Rate": load.rate || 0,
  "Miles": load.miles || 0,
  "Completed At": new Date(load.updatedAt || load.date).toLocaleString()
}));

driverPayDetails.push({
  "Load Number": "TOTAL",
  "Rate": totalRateCompleted,
  "Miles": totalMilesCompleted,
  "Completed At": "-"
});


  // totalul DriverPay (suma rate-urilor)
  const totalDriverPay = completedLoads.reduce((sum, load) => sum + (load.rate || 0), 0);

  driverPayDetails.push({
    "Load Number": "TOTAL",
    "Rate": totalDriverPay,
    "Miles": completedLoads.reduce((sum, l) => sum + (l.miles || 0), 0),
    "Completed At": "-"
  });

  const wsDriverPay = XLSX.utils.json_to_sheet(driverPayDetails);
  XLSX.utils.book_append_sheet(workbook, wsDriverPay, "DriverPay");

  // === Sheet 4: Fuel Usage ===
  const fuelData = [{
    "Driver": `${driverDetails.firstName} ${driverDetails.lastName}`,
    "Fuel Usage": fuelUsage || 0,
    "Period": timeRange || "N/A",
  }];
  const wsFuel = XLSX.utils.json_to_sheet(fuelData);
  XLSX.utils.book_append_sheet(workbook, wsFuel, "Fuel");

  // === Sheet 5: Rate Evolution ===
  if (rateEvolution?.labels?.length) {
    const rateData = rateEvolution.labels.map((label, idx) => ({
      "Date": label,
      "Rate": rateEvolution.values[idx],
    }));
    const wsRate = XLSX.utils.json_to_sheet(rateData);
    XLSX.utils.book_append_sheet(workbook, wsRate, "Rate Evolution");
  }

  // === Salvare ===
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `DriverDashboard_${driverDetails.firstName}_${driverDetails.lastName}.xlsx`);
};


const handleDownloadPdfDriverDashboard = () => {
  if (!driverDetails) return;

  const doc = new jsPDF();
  const driverName = `${driverDetails.firstName} ${driverDetails.lastName}`;

  const completedLoads = (driverLoadsData || []).filter(
    load => load.status?.toLowerCase() === "completed"
  );
  const openLoads = (driverLoadsData || []).filter(
    load => load.status?.toLowerCase() !== "completed" && load.status?.toLowerCase() !== "canceled"
  );

  const totalDriverPay = completedLoads.reduce((sum, load) => sum + (load.rate || 0), 0);

  // Titlu
  doc.setFontSize(18);
  doc.text(`Driver Dashboard Report: ${driverName}`, 14, 20);

  // Rezumat
  doc.setFontSize(12);
  doc.text(`${driverName} has ${completedLoads.length} Completed Loads and ${openLoads.length} Open Loads.`, 14, 30);
  doc.text(`Total DriverPay: $${totalDriverPay}`, 14, 38);
  doc.text(`Fuel Usage: ${fuelUsage || 0} L`, 14, 46);

  // === Completed Loads Table
  if (completedLoads.length > 0) {
    const completedData = completedLoads.map(load => [
      load.loadNumber,
      load.rate,
      load.miles,
      new Date(load.updatedAt || load.date).toLocaleDateString()
    ]);

    completedData.push([
      "TOTAL",
      totalDriverPay,
      completedLoads.reduce((s, l) => s + (l.miles || 0), 0),
      "-"
    ]);

    doc.autoTable({
      head: [["Completed Load #", "Rate", "Miles", "Completed At"]],
      body: completedData,
      startY: 60,
    });
  }

  // === Open Loads Table
  if (openLoads.length > 0) {
    const openData = openLoads.map(load => [
      load.loadNumber,
      load.status,
      load.rate,
      load.miles,
      new Date(load.createdAt).toLocaleDateString()
    ]);

    doc.autoTable({
      head: [["Open Load #", "Status", "Rate", "Miles", "Created At"]],
      body: openData,
      startY: doc.lastAutoTable.finalY + 10,
    });
  }

  doc.save(`DriverDashboard_${driverDetails.firstName}_${driverDetails.lastName}.pdf`);
};


  const fetchDrivers = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/drivers`, config);
      setDrivers(response.data || []);
    } catch (error) {
     
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedDriver) {
      fetchDriverDetails(selectedDriver._id);
    }
  }, [selectedDriver]);

  const fetchDriverDetails = async (driverId) => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/drivers/${driverId}`, config);
      setDriverDetails(response.data || {});
      fetchDriverStats(driverId);
    } catch (error) {
      
      setDriverDetails({});
    } finally {
      setLoading(false);
    }
  };

const handleShowLoads = async (driverId) => {
  try {
    const response = await axios.get(
      `https://api-backend.full-trucking-service.com/api/loads/by-assignment?driverId=${driverId}`,
      config
    );

    setDriverLoadsList(response.data || []);
    setShowLoadsModal(true);
  } catch (err) {
    console.error("Error fetching driver loads:", err);
    setDriverLoadsList([]);
    setShowLoadsModal(true);
  }
};


  useEffect(() => {
    if (selectedDriver) {
      fetchDriverStats(selectedDriver._id);
    }
  }, [selectedDriver, timeRange, customStartDate, customEndDate]);
  
const fetchDriverLoadStatusData = async (driverId) => {
  try {
    const loadsResponse = await axios.get(
      `${apiUrl}/loads/by-assignment?driverId=${driverId}`,
      config
    );

    const filtered = (loadsResponse.data || []).filter(load => {
      // în DB câmpul e "driver", care poate fi fie un ObjectId simplu, fie un obiect populat
      const loadDriverId =
        load.driver?._id?.toString() || load.driver?.toString();

      return loadDriverId === driverId.toString();
    });

    console.log("DEBUG filtered loads for driver:", driverId, filtered);

    setDriverLoadsData(filtered);
  } catch (err) {
    console.error("Error fetching driver load status data:", err);
    setDriverLoadsData([]);
  }
};


useEffect(() => {
  if (selectedDriver?._id) {
    fetchDriverLoadStatusData(selectedDriver._id);
  }
}, [selectedDriver]);

const fetchDriverStats = async (driverId) => {
  try {
    let startDate = new Date();
    let endDate = new Date();

    if (timeRange !== "custom") {
      switch (timeRange) {
        case "day":
          break;
        case "week":
          startDate.setDate(endDate.getDate() - 7);
          break;
        case "month":
          startDate.setDate(1);
          break;
        case "year":
          startDate = new Date(startDate.getFullYear(), 0, 1);
          break;
      }
    } else if (customStartDate && customEndDate) {
      startDate = new Date(customStartDate);
      endDate = new Date(customEndDate);
    }

    // ✅ Loads DOAR pentru driverul selectat
    const loadsResponse = await axios.get(
      `${apiUrl}/loads/by-assignment?driverId=${driverId}`,
      config
    );

    const loads = (loadsResponse.data || []).filter(load => {
      const loadDate = new Date(load.date || load.createdAt);
      return loadDate >= startDate && loadDate <= endDate;
    });
    
    // ✅ Earnings per Mile
    if (loads.length > 0) {
      const totalMiles = loads.reduce((acc, load) => acc + (Number(load.miles) || 0), 0);
      const totalEarnings = loads.reduce((acc, load) => acc + (Number(load.rate) || 0), 0);

      const earningsPerMile = totalMiles > 0 
        ? totalEarnings / totalMiles 
        : 0;

      setEarningsPerMile([{
        driver: selectedDriver.firstName + " " + selectedDriver.lastName,
        value: parseFloat(earningsPerMile.toFixed(2))
      }]);
    } else {
      setEarningsPerMile([]);
    }

    // ✅ calcule pentru Load Status
    setDriverLoads({
      complete: loads.filter(load => load.status?.toLowerCase() === "completed").length,
      canceled: loads.filter(load => load.status?.toLowerCase() === "canceled").length,
      open: loads.filter(load => !["completed", "canceled"].includes(load.status?.toLowerCase())).length,
    });

    // ✅ calcule pentru Rate Evolution
    const rateData = {};
    loads.forEach(load => {
      const date = new Date(load.date || load.createdAt);
      const label = date.toLocaleDateString("en-US", { month: "short", year: "numeric" });
      rateData[label] = (rateData[label] || 0) + (parseFloat(load.rate) || 0);
    });

    setRateEvolution({
      labels: Object.keys(rateData),
      values: Object.values(rateData)
    });

    // ✅ Average Load Distance
    const avgDistance = loads.length > 0
      ? loads.reduce((acc, load) => acc + (Number(load.miles) || 0), 0) / loads.length
      : 0;

    const driverLabel = selectedDriver
      ? [selectedDriver.firstName, selectedDriver.lastName].filter(Boolean).join(" ")
      : "Unknown";

    setAvgLoadDistance([{
      driver: driverLabel,
      value: parseFloat(avgDistance?.toFixed(2)) || 0
    }]);

    // ✅ Fuel Usage
    const fuelResponse = await axios.get(
      `https://api-backend.full-trucking-service.com/api/fuel-reports/driver/${driverId}`,
      config
    );

    const fuelReports = (fuelResponse.data || []).filter(report => {
      const reportDate = new Date(report.createdAt);
      return reportDate >= startDate && reportDate <= endDate;
    });

    setFuelUsage(
      fuelReports.reduce((acc, report) => acc + (parseFloat(report.grandTotal) || 0), 0)
    );

    // ✅ Payroll
    const payrollResponse = await axios.get(`${apiUrl}/totalpays?driverId=${driverId}`, config);
    const payrolls = (payrollResponse.data || []).filter(pay => {
      const payDate = new Date(pay.startDate);
      return payDate >= startDate && payDate <= endDate;
    });

    setTotalPay(
      payrolls.reduce((acc, pay) => acc + (parseFloat(pay.totalWithAdjustments) || 0), 0)
    );

const revenue = loads.reduce((acc, l) => acc + (Number(l.rate || l.totalRate || l.revenue || 0)), 0);
const fuelTotal = fuelReports.reduce((acc, r) => acc + (Number(r.grandTotal || r.totalCost || r.amount || 0)), 0);

console.log("DEBUG Revenue vs Fuel Cost:", { revenue, fuelTotal, loadsCount: loads.length, fuelCount: fuelReports.length });

setRevenueVsFuelData([
  { category: "Revenue", value: revenue },
  { category: "Fuel Cost", value: fuelTotal }
]);

// ✅ Deadhead %
const totalMiles = loads.reduce((acc, l) => acc + (Number(l.miles || l.distance || 0)), 0);
const totalDh = loads.reduce((acc, l) => acc + (Number(l.dh || l.deadheadMiles || l.emptyMiles || 0)), 0);

setDeadheadData([{
  driver: driverLabel,
  value: totalMiles > 0 ? (totalDh / totalMiles) * 100 : 0
}]);

// ✅ Top Brokers
const brokers = {};
loads.forEach(l => {
  const brokerName = l.broker?.name || l.brokerName || "Unknown";
  brokers[brokerName] = (brokers[brokerName] || 0) + (Number(l.rate || l.totalRate || 0));
});

setTopBrokersData(
  Object.entries(brokers).map(([broker, value]) => ({ broker, value }))
);

const cpmData = {};
loads.forEach(load => {
  const miles = Number(load.miles) || 0;
  const rate = Number(load.rate) || 0;
  if (miles > 0 && rate > 0) {
    const cpm = (rate / miles) * 100;

    const date = new Date(load.date || load.createdAt);
    const label = date.toLocaleDateString("en-US", { month: "short", year: "numeric" });

    if (!cpmData[label]) cpmData[label] = [];
    cpmData[label].push(cpm);
  }
});

const labels = Object.keys(cpmData);
const values = labels.map(label => {
  const arr = cpmData[label];
  const avg = arr.reduce((a, b) => a + b, 0) / arr.length;
  return parseFloat(avg.toFixed(2));
});
// === Revenue vs Fuel timeline ===
const revenueFuelTimeline = {};
loads.forEach(load => {
  const date = new Date(load.date || load.createdAt);
  const label = date.toLocaleDateString("en-US", { month: "short", day: "numeric" });

  if (!revenueFuelTimeline[label]) {
    revenueFuelTimeline[label] = { revenue: 0, fuel: 0 };
  }
  revenueFuelTimeline[label].revenue += parseFloat(load.rate) || 0;
});

// Fuel timeline
fuelReports.forEach(report => {
  const date = new Date(report.createdAt);
  const label = date.toLocaleDateString("en-US", { month: "short", day: "numeric" });

  if (!revenueFuelTimeline[label]) {
    revenueFuelTimeline[label] = { revenue: 0, fuel: 0 };
  }
  revenueFuelTimeline[label].fuel += parseFloat(report.grandTotal) || 0;
});

// Salvăm timeline
setRevenueVsFuelTimeline({
  labels: Object.keys(revenueFuelTimeline),
  revenue: Object.values(revenueFuelTimeline).map(v => v.revenue),
  fuel: Object.values(revenueFuelTimeline).map(v => v.fuel),
});


setCentsPerMile({ labels, values });
  } catch (error) {
    console.error("Error fetching driver stats:", error);
  }
};

const fetchDriverPays = async () => {
  try {
    const response = await axios.get(
      "https://api-backend.full-trucking-service.com/api/driverpays?raw=1",
      config
    );

    const driverPayData = response.data || [];

    // grupăm după driverId
    const grouped = driverPayData.reduce((acc, dp) => {
      const id = dp.driverId;
      const amount = dp.totalWithAdjustments || dp.totalPay || 0;
      acc[id] = (acc[id] || 0) + amount;
      return acc;
    }, {});

    setDriverPays(grouped);
  } catch (err) {
    console.error("❌ Error fetching driver pays:", err);
    setDriverPays({});
  }
};

useEffect(() => {
  fetchDriverPays();
}, []);


const fetchAllLoads = async () => {
  try {
    const response = await axios.get(
      "https://api-backend.full-trucking-service.com/api/loads",
      config
    );
    setLoads(response.data || []);
  } catch (err) {
    console.error("❌ Error fetching all loads:", err);
    setLoads([]);
  }
};

useEffect(() => {
  fetchAllLoads();
}, []);


useEffect(() => {
  if (!loads || loads.length === 0 || !drivers || drivers.length === 0) return;

  const data = loads
    .filter(load => Number(load.miles) > 0 && Number(load.rate) > 0)
    .map(load => {
      const miles = Number(load.miles) || 0;
      const rate = Number(load.rate) || 0;
      const cpm = miles > 0 ? (rate / miles) * 100 : 0;

      // caut driver-ul după id
      const driverInfo = drivers.find(d => d._id === load.driverId);
      const driverName = driverInfo
        ? `${driverInfo.firstName} ${driverInfo.lastName}`
        : "Unknown";

      return {
        id: load._id,
        driver: driverName,
        value: parseFloat(cpm.toFixed(2))
      };
    });

  console.log("📊 Cents per Mile data (with drivers):", data);
  setCentsPerMile(data);
}, [loads, drivers]);

const handleAddWidget = async (metric) => {
  try {
    const payload = {
      clientId,
      type: "chart",
      metric, // ex: "averageLoadDistance"
      value: kpiData[metric] || [], // aici trebuie să mapezi valorile corecte
      chartType: "bar" // default, dar îl poți schimba pe viitor
    };

    const res = await axios.post(
      "https://api-backend.full-trucking-service.com/api/widgets",
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setCharts([...charts, res.data]);
    setShowAddModal(false);
  } catch (err) {
    console.error("❌ Error saving widget:", err);
  }
};
useEffect(() => {
  if (!loads || loads.length === 0) return;

  // === Average Load Distance ===
  const avgDistance = {};
  loads.forEach(l => {
    const label = new Date(l.createdAt).toLocaleDateString("en-US", { month: "short", year: "numeric" });
    if (!avgDistance[label]) avgDistance[label] = { total: 0, count: 0 };
    avgDistance[label].total += Number(l.miles) || 0;
    avgDistance[label].count++;
  });
  setAvgLoadDistanceData(
    Object.entries(avgDistance).map(([label, obj]) => ({
      period: label,
      value: obj.total / obj.count
    }))
  );

  // === Loads per Month ===
  const loadsByMonth = {};
  loads.forEach(l => {
    const label = new Date(l.createdAt).toLocaleDateString("en-US", { month: "short", year: "numeric" });
    if (!loadsByMonth[label]) loadsByMonth[label] = 0;
    loadsByMonth[label]++;
  });
  setLoadsPerWeekData(
    Object.entries(loadsByMonth).map(([period, count]) => ({ period, count }))
  );

  // === Revenue vs Fuel ===
  const revFuel = {};
  loads.forEach(l => {
    const label = new Date(l.createdAt).toLocaleDateString("en-US", { month: "short", year: "numeric" });
    if (!revFuel[label]) revFuel[label] = { revenue: 0, fuel: 0 };
    revFuel[label].revenue += Number(l.rate) || 0;
    revFuel[label].fuel += Number(l.fuelCost) || 0;
  });
  setRevenueVsFuelData(
    Object.entries(revFuel).map(([period, obj]) => ({
      period,
      revenue: obj.revenue,
      fuel: obj.fuel
    }))
  );

  // === Deadhead % ===
  const deadhead = {};
  loads.forEach(l => {
    const label = new Date(l.createdAt).toLocaleDateString("en-US", { month: "short", year: "numeric" });
    if (!deadhead[label]) deadhead[label] = { totalDead: 0, totalMiles: 0 };
    deadhead[label].totalDead += Number(l.deadheadMiles) || 0;
    deadhead[label].totalMiles += Number(l.miles) || 0;
  });
  setDeadheadData(
    Object.entries(deadhead).map(([period, obj]) => ({
      period,
      value: obj.totalMiles > 0 ? (obj.totalDead / obj.totalMiles) * 100 : 0
    }))
  );

  // === Top Brokers === (nu are legătură cu lunile, păstrăm grupare pe broker)
  const brokers = {};
  loads.forEach(l => {
    if (!l.broker?.name) return;
    if (!brokers[l.broker.name]) brokers[l.broker.name] = 0;
    brokers[l.broker.name] += Number(l.rate) || 0;
  });
  setTopBrokersData(
    Object.entries(brokers).map(([broker, value]) => ({ broker, value }))
  );

  // === On-Time Delivery % ===
  const onTime = {};
  loads.forEach(l => {
    const label = new Date(l.createdAt).toLocaleDateString("en-US", { month: "short", year: "numeric" });
    if (!onTime[label]) onTime[label] = { onTime: 0, total: 0 };
    onTime[label].onTime += Number(l.onTimeDeliveries) || 0;
    onTime[label].total += Number(l.totalDeliveries) || 0;
  });
  setOnTimeDeliveryData(
    Object.entries(onTime).map(([period, obj]) => ({
      period,
      value: obj.total > 0 ? (obj.onTime / obj.total) * 100 : 0
    }))
  );

  // === Earnings Share ===
  const earnings = {};
  loads.forEach(l => {
    const label = new Date(l.createdAt).toLocaleDateString("en-US", { month: "short", year: "numeric" });
    if (!earnings[label]) earnings[label] = 0;
    earnings[label] += Number(l.rate) || 0;
  });
  setEarningsShareData(
    Object.entries(earnings).map(([period, value]) => ({ period, value }))
  );

}, [loads]);


useEffect(() => {
  if (!loads || loads.length === 0) return;

  const dataByDriver = {};

  loads.forEach(load => {
    const driverName = load.driver?.firstName + " " + load.driver?.lastName || "Unknown";
    const miles = Number(load.miles) || 0;
    const rate = Number(load.rate) || 0;

    if (!dataByDriver[driverName]) {
      dataByDriver[driverName] = { totalMiles: 0, totalEarnings: 0 };
    }

    dataByDriver[driverName].totalMiles += miles;
    dataByDriver[driverName].totalEarnings += rate;
  });

  const formatted = Object.entries(dataByDriver).map(([driver, values]) => {
    const earningsPerMile = values.totalMiles > 0 
      ? values.totalEarnings / values.totalMiles 
      : 0;
    return { driver, value: parseFloat(earningsPerMile.toFixed(2)) };
  });

  console.log("💰 Earnings per Mile data:", formatted);
  setEarningsPerMile(formatted);
}, [loads]);

useEffect(() => {
  const savedCharts = localStorage.getItem("driverDashboardCharts");
  if (savedCharts) {
    setCharts(JSON.parse(savedCharts));
  }
}, []);

const getDriverOpenLoadStatus = (driverDetails) => {
  if (!driverDetails) return "";

  const safeLoads = Array.isArray(driverLoadsData) ? driverLoadsData : [];
  const driverName = `${driverDetails.firstName || ""} ${driverDetails.lastName || ""}`.trim();

  // ✅ Open loads pentru acest șofer
  const openLoads = safeLoads.filter(
    load => !["completed", "canceled"].includes(load.status?.toLowerCase())
  );

  if (openLoads.length > 0) {
    const openLoad = openLoads[0];
    const openedAt = new Date(openLoad.date || openLoad.createdAt);
    const diffDays = Math.floor((Date.now() - openedAt.getTime()) / (1000 * 60 * 60 * 24));
    return `Driver ${driverName} has an Open Load (#${openLoad.loadNumber || openLoad._id}) open for ${diffDays} days.`;
  } else if (safeLoads.length > 0) {
    const sorted = [...safeLoads].sort(
      (a, b) => new Date(b.date || b.updatedAt || b.createdAt) - new Date(a.date || a.updatedAt || a.createdAt)
    );
    const lastLoad = sorted[0];
    const closedAt = new Date(lastLoad.date || lastLoad.updatedAt || lastLoad.createdAt);
    const diffDays = Math.floor((Date.now() - closedAt.getTime()) / (1000 * 60 * 60 * 24));
    return `Driver ${driverName} has not done a load for ${diffDays} days. Last load was (#${lastLoad.loadNumber || lastLoad._id}) on ${closedAt.toLocaleDateString("en-US")}.`;
  } else {
    return `Driver ${driverName} has no load history.`;
  }
};


  return (
<div
  className={`${styles.driverdashboard} ${
    theme === 'light' ? styles.driverdashboardLight : ''
  }`}
>


      {/* Side Menu */}
      <div className={styles.sidebarToggleDriver} onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
  ☰
</div>

      <aside className={`${styles.sidebardriverdashboard} ${isSidebarOpen ? styles.sidebarOpenDriver : ''}`}>
  <ul>
    <li onClick={() => onNavigate('dashboard')}>Overview</li>
    <li onClick={() => onNavigate('driver-dashboard')}>Drivers</li>
    <li onClick={() => onNavigate('truck-dashboard')}>Trucks</li>
    <li onClick={() => onNavigate('load-dashboard')}>Loads</li>
  </ul>
</aside>



      {/* ✅ Lista șoferilor */}
      <div className={styles.mainContentdriverdashboard}>
        <h2 className={styles.titledriverdashboard}>Driver Dashboard</h2>

        <input type="text" placeholder="Search..." className={styles.searchBardriverdashboard} />

        {loading ? (
          <p>Loading...</p>
        ) : !selectedDriver ? (
          <table className={styles.tabledriverdashboard}>
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Truck</th>
                <th>Email</th>
                <th>Phone</th>
                <th>View Details</th>
              </tr>
            </thead>
            <tbody>
              {drivers.map((driver) => (
                <tr key={driver._id}>
                  <td>{driver.firstName || "No data"}</td>
                  <td>{driver.lastName || "No data"}</td>
                  <td>{driver.truckNumber || "No data"}</td>
                  <td>{driver.email || "No data"}</td>
                  <td>{driver.phone || "No data"}</td>
                  <td>
                    <button onClick={() => setSelectedDriver(driver)}>View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <>
            <button className={styles.backButtondriverdashboard} onClick={() => setSelectedDriver(null)}>⬅ Back to Drivers</button>

{driverDetails ? (
  <div className={styles.detailsSectiondriverdashboard}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <h3>
        Driver: {driverDetails.firstName} {driverDetails.lastName}
      </h3>
      <button 
        className={styles.seeLoadsButton} 
        onClick={() => handleShowLoads(driverDetails._id)}
      >
        See the Loads
      </button>
    </div>

    {/* Toggle details */}
    {!showMore ? (
      <button 
        className={styles.seeMoreButton} 
        onClick={() => setShowMore(true)}
      >
        See more about {driverDetails.firstName}
      </button>
    ) : (
      <>
        <div className={styles.driverExtraDetails}>
          <p><strong>Email:</strong> {driverDetails.email || "N/A"}</p>
          <p><strong>Phone:</strong> {driverDetails.phone || "N/A"}</p>
          <p><strong>Address:</strong> {driverDetails.address || "N/A"}</p>
          <p><strong>Truck:</strong> {driverDetails.truckNumber || "N/A"}</p>
          <p><strong>License Number:</strong> {driverDetails.licenseNumber || "N/A"}</p>
          <p><strong>License Expiry Date:</strong> {driverDetails.licenseExpiryDate || "N/A"}</p>
          <p><strong>Last Drug Test:</strong> {driverDetails.lastDrugTestDate || "N/A"}</p>
          <p><strong>Hire Date:</strong> {driverDetails.hireDate || "N/A"}</p>
          <p><strong>Termination Date:</strong> {driverDetails.terminationDate || "N/A"}</p>
          <p><strong>Settlement:</strong> {driverDetails.settlement || "N/A"}</p>
          <p><strong>Birthday:</strong> {driverDetails.dateOfBirth || "N/A"}</p>
          <p><strong>License Type:</strong> {driverDetails.licenseType || "N/A"}</p>
          <p><strong>License State:</strong> {driverDetails.licenseState || "N/A"}</p>
          <p><strong>Last Medical:</strong> {driverDetails.lastMedical || "N/A"}</p>
          <p><strong>Next Medical:</strong> {driverDetails.nextMedical || "N/A"}</p>
          <p><strong>Last Alcohol Test:</strong> {driverDetails.lastAlcoholTest || "N/A"}</p>
          <p><strong>Fuel Card Number:</strong> {driverDetails.fuelCardNumber || "N/A"}</p>
          <p><strong>Fuel Card Expires:</strong> {driverDetails.fuelCardExpires || "N/A"}</p>
          <p><strong>Fleet Division:</strong> {driverDetails.fleetDivision || "N/A"}</p>
        </div>

        <button 
          className={styles.hideMoreDriverButton} 
          onClick={() => setShowMore(false)}
        >
          Hide details
        </button>
      </>
    )}
  </div>
) : (
  <p>No details available.</p>
)}
<div className={styles.driverLoadStatusBox}>
  {driverDetails ? (
    <p>{getDriverOpenLoadStatus(driverDetails, loads || [])}</p>
  ) : (
    <p>No driver selected.</p>
  )}
</div>

{showLoadsModal && (
  <div className={styles.DriverDashboardLoadOverlay}>
    <div className={styles.DriverDashboardLoadModal}>
      <button 
        className={styles.DriverDashboardLoadClose} 
        onClick={() => setShowLoadsModal(false)}
      >
        ✕
      </button>

      <h3 className={styles.DriverDashboardLoadTitle}>
        Loads for {driverDetails.firstName} {driverDetails.lastName}
      </h3>

      {driverLoadsList.length > 0 ? (
        <div className={styles.DriverDashboardLoadWrapper}>
          <table className={styles.DriverDashboardLoadTable}>
            <thead>
              <tr>
                <th>Load #</th>
                <th>Status</th>
                <th>Rate</th>
                <th>Miles</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {driverLoadsList.map(load => (
                <tr key={load._id}>
                  <td>{load.loadNumber || "-"}</td>
                  <td>
<span
  className={
    ["completed", "complete"].includes(load.status?.toLowerCase())
      ? styles.DriverDashboardStatusComplete
      : load.status?.toLowerCase() === "canceled"
      ? styles.DriverDashboardStatusCanceled
      : styles.DriverDashboardStatusOpen
  }
>
  {["completed", "complete"].includes(load.status?.toLowerCase())
    ? "Completed"
    : load.status?.toLowerCase() === "canceled"
    ? "Canceled"
    : "Open"}
</span>



                  </td>
                  <td>${load.rate || "-"}</td>
                  <td>{load.miles || "-"}</td>
                  <td>{new Date(load.date || load.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className={styles.DriverDashboardNoLoads}>No loads found for this driver.</p>
      )}
    </div>
  </div>
)}


{showAddModal && (
  <div className={styles.ModalDriverDashboardOverlay}>
    <div className={styles.ModalDriverDashboardContent}>
      <div className={styles.ModalDriverDashboardHeader}>
        <h3>Select Widgets</h3>
        <button 
          className={styles.ModalDriverDashboardClose} 
          onClick={() => setShowAddModal(false)}
        >
          ✖
        </button>
      </div>

      <div className={styles.ModalDriverDashboardOptions}>
        {allChartOptions.map(opt => (
          <label 
            key={opt.key} 
            className={styles.ModalDriverDashboardOption}
          >
            <input
              type="checkbox"
              checked={charts.includes(opt.key)}
              onChange={e => {
                if (e.target.checked) {
                  setCharts([...charts, opt.key]);
                } else {
                  setCharts(charts.filter(c => c !== opt.key));
                }
              }}
            />
            {opt.label}
          </label>
        ))}
      </div>

   <button 
  className={styles.ModalDriverDashboardDone}
  onClick={() => {
    localStorage.setItem("driverDashboardCharts", JSON.stringify(charts)); // salvează
    setShowAddModal(false);
  }}
>
  Done
</button>
    </div>
  </div>
)}
<div style={{ display: "flex", gap: "10px" }}>
  <button 
    onClick={handleDownloadExcelDriverDashboard}
    style={{ padding: "8px 14px", backgroundColor: "#22c55e", color: "white", border: "none", borderRadius: "6px", cursor: "pointer" }}
  >
    Download Excel Driver Dashboard
  </button>
  <button 
    onClick={handleDownloadPdfDriverDashboard}
    style={{ padding: "8px 14px", backgroundColor: "#3b82f6", color: "white", border: "none", borderRadius: "6px", cursor: "pointer" }}
  >
    Download PDF Driver Dashboard
  </button>
</div>

<div className={styles.chartControlsdriverdashboard}>
            <label>Time Range:</label>
            <select value={timeRange} onChange={(e) => setTimeRange(e.target.value)}>
              <option value="day">Today</option>
              <option value="week">This Week</option>
              <option value="month">This Month</option>
              <option value="year">This Year</option>
              <option value="custom">Custom Range</option>
            </select>

            {timeRange === "custom" && (
              <div>
                <input type="date" value={customStartDate} onChange={(e) => setCustomStartDate(e.target.value)} />
                <input type="date" value={customEndDate} onChange={(e) => setCustomEndDate(e.target.value)} />
              </div>
            )}
          </div>
<button 
  className={styles.addWidgetButton} 
  onClick={() => setShowAddModal(true)}
>
  + Add New Widget
</button>
<div className={styles.chartsGrid}>
  {/* === Average Load Distance === */}
{charts.includes("avgLoadDistance") && (
  <div className={styles.chartContainerdriverdashboard}>
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>Average Load Distance</h4>
      <div className={styles.chartMenuWrapper}>
        <ChartMenu
          chartKey="avgLoadDistance"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
    </div>

    <div className={styles.chartContentdriverdashboard}>
      {/* === BAR (orizontal) === */}
      {chartTypes.avgLoadDistance === "Bar" && (
        <Bar
          data={{
            labels: avgLoadDistanceData.map(d => d.period),   // <<--- lunile
            datasets: [{
              label: "Average Miles",
              data: avgLoadDistanceData.map(d => d.value),   // <<--- valorile
              backgroundColor: "#3b82f6",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* === COLUMN (vertical) === */}
      {chartTypes.avgLoadDistance === "Column" && (
        <Bar
          data={{
            labels: avgLoadDistanceData.map(d => d.period),
            datasets: [{
              label: "Average Miles",
              data: avgLoadDistanceData.map(d => d.value),
              backgroundColor: "#22c55e",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "x" }}
        />
      )}

      {/* === LINE === */}
      {chartTypes.avgLoadDistance === "Line" && (
        <Line
          data={{
            labels: avgLoadDistanceData.map(d => d.period),
            datasets: [{
              label: "Average Miles",
              data: avgLoadDistanceData.map(d => d.value),
              borderColor: "#3b82f6",
              backgroundColor: "rgba(59,130,246,0.3)",
              tension: 0.4,
              fill: true,
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* === PIE === */}
      {chartTypes.avgLoadDistance === "Pie" && (
        <Pie
          data={{
            labels: avgLoadDistanceData.map(d => d.period),
            datasets: [{
              data: avgLoadDistanceData.map(d => d.value),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chartTypes.avgLoadDistance === "Doughnut" && (
        <Doughnut
          data={{
            labels: avgLoadDistanceData.map(d => d.period),
            datasets: [{
              data: avgLoadDistanceData.map(d => d.value),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === GAUGE === */}
      {chartTypes.avgLoadDistance === "Gauge" && (
        <GaugeChart 
          id="avgLoadGauge"
          nrOfLevels={20}
          percent={avgLoadDistanceData.length ? avgLoadDistanceData[0].value / 1000 : 0}
          colors={["#ef4444","#22c55e"]}
        />
      )}
    </div>
  </div>
)}

{/* === Loads per Week === */}
{charts.includes("loadsPerWeek") && (
  <div className={styles.chartContainerdriverdashboard}>
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>Loads per Week</h4>
      <div className={styles.chartMenuWrapper}>
        <ChartMenu
          chartKey="loadsPerWeek"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
    </div>

    <div className={styles.chartContentdriverdashboard}>
      {/* === BAR (orizontal) === */}
      {chartTypes.loadsPerWeek === "Bar" && (
        <Bar
          data={{
            labels: loadsPerWeekData.map(d => d.period),
            datasets: [{
              label: "Loads",
              data: loadsPerWeekData.map(d => d.count),
              backgroundColor: "#22c55e",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* === COLUMN (vertical) === */}
      {chartTypes.loadsPerWeek === "Column" && (
        <Bar
          data={{
            labels: loadsPerWeekData.map(d => d.period),
            datasets: [{
              label: "Loads",
              data: loadsPerWeekData.map(d => d.count),
              backgroundColor: "#3b82f6",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "x" }}
        />
      )}

      {/* === LINE === */}
      {chartTypes.loadsPerWeek === "Line" && (
        <Line
          data={{
            labels: loadsPerWeekData.map(d => d.period),
            datasets: [{
              label: "Loads",
              data: loadsPerWeekData.map(d => d.count),
              borderColor: "#22c55e",
              backgroundColor: "rgba(34,197,94,0.3)",
              tension: 0.4,
              fill: true,
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* === PIE === */}
      {chartTypes.loadsPerWeek === "Pie" && (
        <Pie
          data={{
            labels: loadsPerWeekData.map(d => d.period),
            datasets: [{
              data: loadsPerWeekData.map(d => d.count),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chartTypes.loadsPerWeek === "Doughnut" && (
        <Doughnut
          data={{
            labels: loadsPerWeekData.map(d => d.period),
            datasets: [{
              data: loadsPerWeekData.map(d => d.count),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === GAUGE === */}
      {chartTypes.loadsPerWeek === "Gauge" && (
        <GaugeChart 
          id="loadsPerWeekGauge"
          nrOfLevels={20}
          percent={loadsPerWeekData.length ? loadsPerWeekData[0].count / 100 : 0}
          colors={["#ef4444","#22c55e"]}
        />
      )}
    </div>
  </div>
)}

{/* === Revenue vs Fuel Cost === */}
{charts.includes("revenueVsFuel") && (
  <div className={styles.chartContainerdriverdashboard}>
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>Revenue vs Fuel Cost</h4>
      <div className={styles.chartMenuWrapper}>
        <ChartMenu
          chartKey="revenueVsFuel"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
    </div>

    <div className={styles.chartContentdriverdashboard}>
      {/* === COLUMN === */}
      {chartTypes.revenueVsFuel === "Column" && (
        <Bar
          data={{
            labels: revenueVsFuelData.map(d => d.category),   // <-- aici category
            datasets: [{
              label: "Amount",
              data: revenueVsFuelData.map(d => d.value),
              backgroundColor: ["#3b82f6", "#ef4444"],        // revenue = albastru, fuel = roșu
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* === BAR === */}
      {chartTypes.revenueVsFuel === "Bar" && (
        <Bar
          data={{
            labels: revenueVsFuelData.map(d => d.category),
            datasets: [{
              label: "Amount",
              data: revenueVsFuelData.map(d => d.value),
              backgroundColor: ["#3b82f6", "#ef4444"],
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

{/* === LINE (pe timp) === */}
{chartTypes.revenueVsFuel === "Line" && (
  <Line
    data={{
      labels: revenueVsFuelTimeline.labels,
      datasets: [
        {
          label: "Revenue",
          data: revenueVsFuelTimeline.revenue,
          borderColor: "#22c55e",
          backgroundColor: "rgba(34,197,94,0.3)",
          fill: false,
          tension: 0.4,
        },
        {
          label: "Fuel Cost",
          data: revenueVsFuelTimeline.fuel,
          borderColor: "#ef4444",
          backgroundColor: "rgba(239,68,68,0.3)",
          fill: false,
          tension: 0.4,
        }
      ],
    }}
    options={{
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          title: { display: true, text: "Time" }
        },
        y: {
          title: { display: true, text: "Amount ($)" }
        }
      }
    }}
  />
)}


      {/* === PIE === */}
      {chartTypes.revenueVsFuel === "Pie" && (
        <Pie
          data={{
            labels: revenueVsFuelData.map(d => d.category),
            datasets: [{
              data: revenueVsFuelData.map(d => d.value),
              backgroundColor: ["#3b82f6", "#ef4444"],
            }],
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chartTypes.revenueVsFuel === "Doughnut" && (
        <Doughnut
          data={{
            labels: revenueVsFuelData.map(d => d.category),
            datasets: [{
              data: revenueVsFuelData.map(d => d.value),
              backgroundColor: ["#3b82f6", "#ef4444"],
            }],
          }}
        />
      )}

      {/* === GAUGE === */}
      {chartTypes.revenueVsFuel === "Gauge" && (
        <GaugeChart
          id="revenueVsFuelGauge"
          nrOfLevels={20}
          percent={revenueVsFuelData.length ? revenueVsFuelData[0].value / (revenueVsFuelData[0].value + revenueVsFuelData[1].value) : 0}
          colors={["#ef4444", "#22c55e"]}
        />
      )}
    </div>
  </div>
)}

{/* === Deadhead % === */}
{charts.includes("deadhead") && (
  <div className={styles.chartContainerdriverdashboard}>
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>Deadhead %</h4>
      <div className={styles.chartMenuWrapper}>
        <ChartMenu
          chartKey="deadhead"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
    </div>

    <div className={styles.chartContentdriverdashboard}>
      {/* === BAR (orizontal) === */}
      {chartTypes.deadhead === "Bar" && (
        <Bar
          data={{
            labels: deadheadData.map((_, i) => `Load ${i+1}`),
            datasets: [{
              label: "Deadhead %",
              data: deadheadData.map(d => d.value),
              backgroundColor: "#f59e0b",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* === COLUMN (vertical) === */}
      {chartTypes.deadhead === "Column" && (
        <Bar
          data={{
            labels: deadheadData.map((_, i) => `Load ${i+1}`),
            datasets: [{
              label: "Deadhead %",
              data: deadheadData.map(d => d.value),
              backgroundColor: "#f59e0b",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "x" }}
        />
      )}

      {/* === LINE === */}
      {chartTypes.deadhead === "Line" && (
        <Line
          data={{
            labels: deadheadData.map((_, i) => `Load ${i+1}`),
            datasets: [{
              label: "Deadhead %",
              data: deadheadData.map(d => d.value),
              borderColor: "#f59e0b",
              backgroundColor: "rgba(245,158,11,0.3)",
              tension: 0.4,
              fill: true,
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* === PIE === */}
      {chartTypes.deadhead === "Pie" && (
        <Pie
          data={{
            labels: deadheadData.map((_, i) => `Load ${i+1}`),
            datasets: [{
              data: deadheadData.map(d => d.value),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chartTypes.deadhead === "Doughnut" && (
        <Doughnut
          data={{
            labels: deadheadData.map((_, i) => `Load ${i+1}`),
            datasets: [{
              data: deadheadData.map(d => d.value),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === GAUGE === */}
      {chartTypes.deadhead === "Gauge" && (
        <GaugeChart 
          id="deadheadGauge"
          nrOfLevels={20}
          percent={deadheadData.length ? deadheadData[0].value / 100 : 0}
          colors={["#ef4444","#22c55e"]}
        />
      )}
    </div>
  </div>
)}

{/* === On-Time Delivery % === */}
{charts.includes("onTimeDelivery") && (
  <div className={styles.chartContainerdriverdashboard}>
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>On-Time Delivery %</h4>
      <div className={styles.chartMenuWrapper}>
        <ChartMenu
          chartKey="onTimeDelivery"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
    </div>

    <div className={styles.chartContentdriverdashboard}>
      {/* === BAR (orizontal) === */}
      {chartTypes.onTimeDelivery === "Bar" && (
        <Bar
          data={{
            labels: onTimeDeliveryData.map(d => d.driver || ""),
            datasets: [{
              label: "On-Time %",
              data: onTimeDeliveryData.map(d => d.value ?? 0),
              backgroundColor: "#22c55e",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* === COLUMN (vertical) === */}
      {chartTypes.onTimeDelivery === "Column" && (
        <Bar
          data={{
            labels: onTimeDeliveryData.map(d => d.driver || ""),
            datasets: [{
              label: "On-Time %",
              data: onTimeDeliveryData.map(d => d.value ?? 0),
              backgroundColor: "#22c55e",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "x" }}
        />
      )}

      {/* === LINE === */}
      {chartTypes.onTimeDelivery === "Line" && (
        <Line
          data={{
            labels: onTimeDeliveryData.map(d => d.driver || ""),
            datasets: [{
              label: "On-Time %",
              data: onTimeDeliveryData.map(d => d.value ?? 0),
              borderColor: "#22c55e",
              backgroundColor: "rgba(34,197,94,0.3)",
              tension: 0.4,
              fill: true,
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* === PIE === */}
      {chartTypes.onTimeDelivery === "Pie" && (
        <Pie
          data={{
            labels: onTimeDeliveryData.map(d => d.driver || ""),
            datasets: [{
              data: onTimeDeliveryData.map(d => d.value ?? 0),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chartTypes.onTimeDelivery === "Doughnut" && (
        <Doughnut
          data={{
            labels: onTimeDeliveryData.map(d => d.driver || ""),
            datasets: [{
              data: onTimeDeliveryData.map(d => d.value ?? 0),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === GAUGE === */}
      {chartTypes.onTimeDelivery === "Gauge" && (
        <GaugeChart 
          id="onTimeDeliveryGauge"
          nrOfLevels={20}
          percent={onTimeDeliveryData.length ? (onTimeDeliveryData[0].value ?? 0) / 100 : 0}
          colors={["#ef4444","#22c55e"]}
        />
      )}
    </div>
  </div>
)}

{/* === Driver Earnings Share === */}
{charts.includes("earningsShare") && (
  <div className={styles.chartContainerdriverdashboard}>
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>Driver Earnings Share</h4>
      <div className={styles.chartMenuWrapper}>
        <ChartMenu
          chartKey="earningsShare"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
    </div>

    <div className={styles.chartContentdriverdashboard}>
      {/* === BAR (orizontal) === */}
      {chartTypes.earningsShare === "Bar" && (
        <Bar
          data={{
            labels: earningsShareData.map(d => d.driver || ""),
            datasets: [{
              label: "Earnings",
              data: earningsShareData.map(d => d.value ?? 0),
              backgroundColor: "#f59e0b",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* === COLUMN (vertical) === */}
      {chartTypes.earningsShare === "Column" && (
        <Bar
          data={{
            labels: earningsShareData.map(d => d.driver || ""),
            datasets: [{
              label: "Earnings",
              data: earningsShareData.map(d => d.value ?? 0),
              backgroundColor: "#f59e0b",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "x" }}
        />
      )}

      {/* === LINE === */}
      {chartTypes.earningsShare === "Line" && (
        <Line
          data={{
            labels: earningsShareData.map(d => d.driver || ""),
            datasets: [{
              label: "Earnings",
              data: earningsShareData.map(d => d.value ?? 0),
              borderColor: "#f59e0b",
              backgroundColor: "rgba(245,158,11,0.3)",
              tension: 0.4,
              fill: true,
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* === PIE === */}
      {chartTypes.earningsShare === "Pie" && (
        <Pie
          data={{
            labels: earningsShareData.map(d => d.driver || ""),
            datasets: [{
              data: earningsShareData.map(d => d.value ?? 0),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chartTypes.earningsShare === "Doughnut" && (
        <Doughnut
          data={{
            labels: earningsShareData.map(d => d.driver || ""),
            datasets: [{
              data: earningsShareData.map(d => d.value ?? 0),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === GAUGE === */}
      {chartTypes.earningsShare === "Gauge" && (
        <GaugeChart 
          id="earningsShareGauge"
          nrOfLevels={20}
          percent={earningsShareData.length ? (earningsShareData[0].value ?? 0) / 10000 : 0}
          colors={["#ef4444","#22c55e"]}
        />
      )}
    </div>
  </div>
)}

{/* === Top Brokers === */}
{charts.includes("topBrokers") && (
  <div className={styles.chartContainerdriverdashboard}>
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>Top Brokers</h4>
      <div className={styles.chartMenuWrapper}>
        <ChartMenu
          chartKey="topBrokers"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
    </div>

    <div className={styles.chartContentdriverdashboard}>
      {/* === BAR (orizontal) === */}
      {chartTypes.topBrokers === "Bar" && (
        <Bar
          data={{
            labels: topBrokersData.map(d => d.broker || ""),
            datasets: [{
              label: "Loads",
              data: topBrokersData.map(d => d.value ?? 0),
              backgroundColor: "#6366f1",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* === COLUMN (vertical) === */}
      {chartTypes.topBrokers === "Column" && (
        <Bar
          data={{
            labels: topBrokersData.map(d => d.broker || ""),
            datasets: [{
              label: "Loads",
              data: topBrokersData.map(d => d.value ?? 0),
              backgroundColor: "#6366f1",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "x" }}
        />
      )}

      {/* === LINE === */}
      {chartTypes.topBrokers === "Line" && (
        <Line
          data={{
            labels: topBrokersData.map(d => d.broker || ""),
            datasets: [{
              label: "Loads",
              data: topBrokersData.map(d => d.value ?? 0),
              borderColor: "#6366f1",
              backgroundColor: "rgba(99,102,241,0.3)",
              tension: 0.4,
              fill: true,
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* === PIE === */}
      {chartTypes.topBrokers === "Pie" && (
        <Pie
          data={{
            labels: topBrokersData.map(d => d.broker || ""),
            datasets: [{
              data: topBrokersData.map(d => d.value ?? 0),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chartTypes.topBrokers === "Doughnut" && (
        <Doughnut
          data={{
            labels: topBrokersData.map(d => d.broker || ""),
            datasets: [{
              data: topBrokersData.map(d => d.value ?? 0),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === GAUGE === */}
      {chartTypes.topBrokers === "Gauge" && (
        <GaugeChart 
          id="topBrokersGauge"
          nrOfLevels={20}
          percent={topBrokersData.length ? (topBrokersData[0].value ?? 0) / 100 : 0}
          colors={["#ef4444","#22c55e"]}
        />
      )}
    </div>
  </div>
)}
</div>

<div className={styles.chartsGrid}>
  {/* 📊 Load Status */}
<div className={styles.chartContainerdriverdashboard} id="loadStatus">
  <div className={styles.chartHeaderdriverdashboard}>
  <h4>Load Status Comparison</h4>
  <div className={styles.chartMenuWrapper}>
    <ChartMenu
      chartKey="loadStatus"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
</div>


  <div className={styles.chartContentdriverdashboard} style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}>
    
    {/* ✅ Bar Chart */}
    {chartTypes.loadStatus === "Bar" && (
      <Bar
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            label: "Load Status",
            data: [driverLoads.complete, driverLoads.canceled, driverLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Line Graph */}
    {chartTypes.loadStatus === "Line" && (
      <Line
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            label: "Load Status Over Time",
            data: [driverLoads.complete, driverLoads.canceled, driverLoads.open],
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59, 130, 246, 0.2)",
            tension: 0.4,
            fill: true,
            pointBackgroundColor: "#3b82f6",
            pointBorderWidth: 2,
            borderWidth: 2,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.loadStatus === "Pie" && (
      <Pie
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            data: [driverLoads.complete, driverLoads.canceled, driverLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

  {/* ✅ Gauge Chart */}
  {chartTypes.loadStatus === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Complete Loads", "Remaining Loads"],
          datasets: [{
            data: [driverLoads.complete, driverLoads.canceled + driverLoads.open],
            backgroundColor: ["#4caf50", "#e0e0e0"],
            borderWidth: 0
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180, // ✅ Face graficul semicircular (Gauge)
          rotation: -90, // ✅ Aliniază la bază ca un contor real
          cutout: "75%", // ✅ Grosimea semicercului
          plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
          },
        }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.loadStatus === "Column" && (
      <Bar
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            label: "Load Status",
            data: [driverLoads.complete, driverLoads.canceled, driverLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.loadStatus === "Doughnut" && (
      <Doughnut
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            data: [driverLoads.complete, driverLoads.canceled, driverLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  </div>
</div>


     {/* 📊 Rate Evolution */}
<div className={styles.chartContainerdriverdashboard} id="rateEvolution">
<div className={styles.chartHeaderdriverdashboard}>
  <h4>Rate Evolution Over Time</h4>
  <div className={styles.chartMenuWrapper}>
    <ChartMenu
      chartKey="rateEvolution"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
</div>

  <div className={styles.chartContentdriverdashboard} style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}>

    {/* ✅ Line Graph */}
    {chartTypes.rateEvolution === "Line" && (
      <Line
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            label: "Revenue ($)",
            data: rateEvolution.values,
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59, 130, 246, 0.2)",
            tension: 0.4,
            fill: true,
            pointBackgroundColor: "#3b82f6",
            pointBorderWidth: 2,
            borderWidth: 2,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  
    {/* ✅ Gauge Chart */}
    {chartTypes.rateEvolution === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Revenue Generated", "Remaining Target"],
          datasets: [{
            data: [rateEvolution.values.reduce((acc, val) => acc + val, 0), Math.max(100000 - rateEvolution.values.reduce((acc, val) => acc + val, 0), 0)], // Exemplu: 100.000 ca obiectiv
            backgroundColor: ["#4caf50", "#e0e0e0"],
            borderWidth: 0
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180, // ✅ Face graficul semicircular (Gauge)
          rotation: -90, // ✅ Aliniază la bază ca un contor real
          cutout: "75%", // ✅ Grosimea semicercului
          plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
          },
        }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
    {/* ✅ Bar Chart */}
    {chartTypes.rateEvolution === "Bar" && (
      <Bar
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            label: "Revenue ($)",
            data: rateEvolution.values,
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.rateEvolution === "Column" && (
      <Bar
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            label: "Revenue ($)",
            data: rateEvolution.values,
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.rateEvolution === "Pie" && (
      <Pie
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            data: rateEvolution.values,
            backgroundColor: ["#4caf50", "#ff5722", "#ffc107", "#3b82f6"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.rateEvolution === "Doughnut" && (
      <Doughnut
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            data: rateEvolution.values,
            backgroundColor: ["#4caf50", "#ff5722", "#ffc107", "#3b82f6"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  </div>
</div>

{/* 💰 Earnings per Mile */}
<div className={styles.chartContainerdriverdashboard} id="earningsPerMile">
  <div className={styles.chartHeaderdriverdashboard}>
    <h4>Earnings per Mile</h4>
    <div className={styles.chartMenuWrapper}>
      <ChartMenu
        chartKey="earningsPerMile"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>
  </div>

  <div
    className={styles.chartContentdriverdashboard}
    style={{
      width: "600px",
      height: "350px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    {/* ✅ Bar Chart */}
    {chartTypes.earningsPerMile === "Bar" && (
      <Bar
        data={{
          labels: earningsPerMile.map(e => e.driver),
          datasets: [{
            label: "Earnings per Mile ($)",
            data: earningsPerMile.map(e => e.value),
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.earningsPerMile === "Column" && (
      <Bar
        data={{
          labels: earningsPerMile.map(e => e.driver),
          datasets: [{
            label: "Earnings per Mile ($)",
            data: earningsPerMile.map(e => e.value),
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: "y", // face coloanele orizontale
        }}
      />
    )}

    {/* ✅ Line Chart */}
    {chartTypes.earningsPerMile === "Line" && (
      <Line
        data={{
          labels: earningsPerMile.map(e => e.driver),
          datasets: [{
            label: "Earnings per Mile ($)",
            data: earningsPerMile.map(e => e.value),
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59,130,246,0.3)",
            tension: 0.4,
            fill: true,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.earningsPerMile === "Pie" && (
      <Pie
        data={{
          labels: earningsPerMile.map(e => e.driver),
          datasets: [{
            data: earningsPerMile.map(e => e.value),
            backgroundColor: ["#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#6366f1"],
          }],
        }}
        
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.earningsPerMile === "Doughnut" && (
      <Doughnut
        data={{
          labels: earningsPerMile.map(e => e.driver),
          datasets: [{
            data: earningsPerMile.map(e => e.value),
            backgroundColor: ["#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#6366f1"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

{/* ✅ Gauge (semicircle) */}
{chartTypes.earningsPerMile === "Gauge" && (
  <Doughnut
    data={{
      labels: ["Avg Earnings/Mile", "Remaining to $3.00"],
      datasets: [{
        data: [
          earningsPerMile.reduce((a, e) => a + e.value, 0) / (earningsPerMile.length || 1),
          3 - (earningsPerMile.reduce((a, e) => a + e.value, 0) / (earningsPerMile.length || 1))
        ],
        backgroundColor: ["#3b82f6", "#e0e0e0"],
        borderWidth: 0,
      }],
    }}
    options={{
      responsive: true,
      maintainAspectRatio: false,
      circumference: 180,
      rotation: -90,
      cutout: "75%",
      plugins: {
        legend: { display: false },
      },
    }}
  />
)}

  </div>
</div>



{/* 📊 Cents per Mile */}
<div className={styles.chartContainerdriverdashboard} id="centsPerMile">
  <div className={styles.chartHeaderdriverdashboard}>
    <h4>Cents per Mile</h4>
    <div className={styles.chartMenuWrapper}>
      <ChartMenu
        chartKey="centsPerMile"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>
  </div>

  <div
    className={styles.chartContentdriverdashboard}
    style={{
      width: "600px",
      height: "350px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    {/* ✅ Bar Chart */}
    {chartTypes.centsPerMile === "Bar" && (
      <Bar
        data={{
          labels: centsPerMile.labels, // lunile/ziua
          datasets: [{
            label: "Cents per Mile",
            data: centsPerMile.values, // valorile CPM
            backgroundColor: "#22c55e",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.centsPerMile === "Column" && (
      <Bar
        data={{
          labels: centsPerMile.labels,
          datasets: [{
            label: "Cents per Mile",
            data: centsPerMile.values,
            backgroundColor: "#22c55e",
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: "y",
        }}
      />
    )}

    {/* ✅ Line Chart */}
    {chartTypes.centsPerMile === "Line" && (
      <Line
        data={{
          labels: centsPerMile.labels,
          datasets: [{
            label: "Cents per Mile",
            data: centsPerMile.values,
            borderColor: "#22c55e",
            backgroundColor: "rgba(34,197,94,0.3)",
            tension: 0.4,
            fill: true,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.centsPerMile === "Pie" && (
      <Pie
        data={{
          labels: centsPerMile.labels,
          datasets: [{
            data: centsPerMile.values,
            backgroundColor: ["#22c55e", "#3b82f6", "#f59e0b", "#ef4444", "#6366f1"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.centsPerMile === "Doughnut" && (
      <Doughnut
        data={{
          labels: centsPerMile.labels,
          datasets: [{
            data: centsPerMile.values,
            backgroundColor: ["#22c55e", "#3b82f6", "#f59e0b", "#ef4444", "#6366f1"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Gauge (semicircle) */}
    {chartTypes.centsPerMile === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Avg CPM", "Remaining to 300 CPM"],
          datasets: [{
            data: [
              centsPerMile.values.reduce((a, v) => a + v, 0) / (centsPerMile.values.length || 1),
              300 - (centsPerMile.values.reduce((a, v) => a + v, 0) / (centsPerMile.values.length || 1))
            ],
            backgroundColor: ["#22c55e", "#e0e0e0"],
            borderWidth: 0,
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180,
          rotation: -90,
          cutout: "75%",
          plugins: {
            legend: { display: false },
          },
        }}
      />
    )}
  </div>
</div>
{/* 📊 Fuel Usage */}
<div className={styles.chartContainerdriverdashboard} id="fuelUsage">
  <div className={styles.chartHeaderdriverdashboard}>
    <h4>Fuel Usage</h4>
    <div className={styles.chartMenuWrapper}>
      <ChartMenu
        chartKey="fuelUsage"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>
  </div>

  <div className={styles.chartContentdriverdashboard}
    style={{ minHeight: "350px", display: "flex", flexDirection: "column", gap: 16 }}
  >
    {isLoadingFuelAgg ? (
      <p style={{ color: "#94a3b8", textAlign: "center" }}>⏳ Loading fuel data...</p>
    ) : !driverFuelAggregated ? (
      <p style={{ color: "#94a3b8", textAlign: "center" }}>No fuel data available.</p>
    ) : (
      <>
        {/* ── Chart ── */}
        <div style={{ height: 280 }}>
          {chartTypes.fuelUsage === "Doughnut" && (
            <Doughnut
              data={{
                labels: [
                  "Fuel Amount", "DEF", "Reefer",
                  "Additives", "Oil", "Other Fees",
                  "DriverPay Fuel",
                ],
                datasets: [{
                  data: [
                    driverFuelAggregated.breakdown.fuelAmount,
                    driverFuelAggregated.breakdown.defAmount,
                    driverFuelAggregated.breakdown.reeferAmt,
                    driverFuelAggregated.breakdown.additives,
                    driverFuelAggregated.breakdown.oil,
                    driverFuelAggregated.breakdown.otherFees,
                    driverFuelAggregated.totalDriverPay,
                  ],
                  backgroundColor: [
                    "#3b82f6","#f59e0b","#8b5cf6",
                    "#14b8a6","#f43f5e","#64748b","#ef4444",
                  ],
                }],
              }}
              options={{ responsive: true, maintainAspectRatio: false }}
            />
          )}

          {(chartTypes.fuelUsage === "Bar" || chartTypes.fuelUsage === "Column") && (
            <Bar
              data={{
                labels: ["Fuel Reports", "DriverPay Fuel"],
                datasets: [{
                  label: "Total ($)",
                  data: [
                    driverFuelAggregated.totalFuelReport,
                    driverFuelAggregated.totalDriverPay,
                  ],
                  backgroundColor: ["#3b82f6", "#ef4444"],
                }],
              }}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: chartTypes.fuelUsage === "Column" ? "y" : "x",
              }}
            />
          )}

          {chartTypes.fuelUsage === "Pie" && (
            <Pie
              data={{
                labels: ["Fuel Reports", "DriverPay Fuel"],
                datasets: [{
                  data: [
                    driverFuelAggregated.totalFuelReport,
                    driverFuelAggregated.totalDriverPay,
                  ],
                  backgroundColor: ["#3b82f6", "#ef4444"],
                }],
              }}
              options={{ responsive: true, maintainAspectRatio: false }}
            />
          )}

          {chartTypes.fuelUsage === "Gauge" && (
            <Doughnut
              data={{
                labels: ["Total Fuel", ""],
                datasets: [{
                  data: [
                    driverFuelAggregated.grandTotal,
                    Math.max(10000 - driverFuelAggregated.grandTotal, 0),
                  ],
                  backgroundColor: ["#3b82f6", "#1e293b"],
                  borderWidth: 0,
                }],
              }}
              options={{
                responsive: true, maintainAspectRatio: false,
                circumference: 180, rotation: -90, cutout: "75%",
                plugins: { legend: { display: false } },
              }}
            />
          )}
        </div>

        {/* ── Summary totals ── */}
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", fontSize: 13 }}>
          {[
            { label: "Fuel Reports Total", value: driverFuelAggregated.totalFuelReport, color: "#3b82f6" },
            { label: "DriverPay Fuel",     value: driverFuelAggregated.totalDriverPay,  color: "#ef4444" },
            { label: "Grand Total",        value: driverFuelAggregated.grandTotal,       color: "#f59e0b" },
          ].map((item, i) => (
            <div key={i} style={{
              background: "rgba(255,255,255,0.04)",
              border: `1px solid ${item.color}44`,
              borderRadius: 8, padding: "8px 14px", flex: 1, minWidth: 120,
            }}>
              <div style={{ color: "#94a3b8", fontSize: 11, marginBottom: 4 }}>{item.label}</div>
              <div style={{ color: item.color, fontWeight: 700, fontSize: 15 }}>
                ${item.value.toFixed(2)}
              </div>
            </div>
          ))}
        </div>

        {/* ── Breakdown table ── */}
        <div style={{ overflowX: "auto", fontSize: 12 }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
                <th style={{ textAlign: "left",  padding: "5px 8px", color: "#94a3b8" }}>Category</th>
                <th style={{ textAlign: "right", padding: "5px 8px", color: "#94a3b8" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {[
                { label: "Fuel",       value: driverFuelAggregated.breakdown.fuelAmount, color: "#3b82f6" },
                { label: "DEF",        value: driverFuelAggregated.breakdown.defAmount,  color: "#f59e0b" },
                { label: "Reefer",     value: driverFuelAggregated.breakdown.reeferAmt,  color: "#8b5cf6" },
                { label: "Additives",  value: driverFuelAggregated.breakdown.additives,  color: "#14b8a6" },
                { label: "Oil",        value: driverFuelAggregated.breakdown.oil,        color: "#f43f5e" },
                { label: "Other Fees", value: driverFuelAggregated.breakdown.otherFees,  color: "#64748b" },
                { label: "Discount",   value: -driverFuelAggregated.breakdown.discount,  color: "#22c55e" },
              ].filter(r => r.value !== 0).map((row, i) => (
                <tr key={i} style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                  <td style={{ padding: "5px 8px", color: row.color }}>{row.label}</td>
                  <td style={{ padding: "5px 8px", textAlign: "right", color: row.color, fontWeight: 600 }}>
                    ${Math.abs(row.value).toFixed(2)}
                  </td>
                </tr>
              ))}
              {driverFuelAggregated.driverPayFuelItems.map((item, i) => (
                <tr key={`dp-${i}`} style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                  <td style={{ padding: "5px 8px", color: "#ef4444" }}>
                    DriverPay – {item.description} {item.settlement ? `(${item.settlement})` : ""}
                  </td>
                  <td style={{ padding: "5px 8px", textAlign: "right", color: "#ef4444", fontWeight: 600 }}>
                    ${item.totalToPay.toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    )}
  </div>
</div>
{/* 📊 DriverPay pentru driverul selectat */}
{selectedDriver && (
  <div className={styles.chartContainerdriverdashboard} id="driverPay">
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>DriverPay – {selectedDriver.firstName} {selectedDriver.lastName}</h4>
      <ChartMenu
        chartKey="driverPay"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>

    <div className={styles.chartContentdriverdashboard}
      style={{ minHeight: 350, display: "flex", flexDirection: "column", gap: 16 }}
    >
      {isLoadingDPDetail ? (
        <p style={{ color: "#94a3b8", textAlign: "center" }}>⏳ Loading...</p>
      ) : !driverPayDetail || driverPayDetail.settlements.length === 0 ? (
        <p style={{ color: "#94a3b8", textAlign: "center" }}>No DriverPay data for this period.</p>
      ) : (
        <>
          {/* ── Chart ── */}
          <div style={{ height: 280 }}>
            {(chartTypes.driverPay === "Bar" || chartTypes.driverPay === "Column") && (
              <Bar
                data={{
                  labels: driverPayDetail.settlements.map(s => s.settlementNumber),
                  datasets: [
                    { label: "Base Pay ($)",   data: driverPayDetail.settlements.map(s => s.basePay),         backgroundColor: "#3b82f6" },
                    { label: "Additions ($)",  data: driverPayDetail.settlements.map(s => s.totalAdditions),  backgroundColor: "#22c55e" },
                    { label: "Deductions ($)", data: driverPayDetail.settlements.map(s => s.totalDeductions), backgroundColor: "#ef4444" },
                    { label: "Net Pay ($)",    data: driverPayDetail.settlements.map(s => s.netPay),          backgroundColor: "#f59e0b" },
                  ],
                }}
                options={{
                  responsive: true, maintainAspectRatio: false,
                  indexAxis: chartTypes.driverPay === "Column" ? "y" : "x",
                  plugins: { legend: { position: "top" } },
                }}
              />
            )}

            {chartTypes.driverPay === "Line" && (
              <Line
                data={{
                  labels: driverPayDetail.settlements.map(s => s.settlementNumber),
                  datasets: [
                    { label: "Base Pay",   data: driverPayDetail.settlements.map(s => s.basePay),         borderColor: "#3b82f6", fill: false, tension: 0.3 },
                    { label: "Net Pay",    data: driverPayDetail.settlements.map(s => s.netPay),          borderColor: "#f59e0b", fill: false, tension: 0.3 },
                    { label: "Additions",  data: driverPayDetail.settlements.map(s => s.totalAdditions),  borderColor: "#22c55e", fill: false, tension: 0.3 },
                    { label: "Deductions", data: driverPayDetail.settlements.map(s => s.totalDeductions), borderColor: "#ef4444", fill: false, tension: 0.3 },
                  ],
                }}
                options={{ responsive: true, maintainAspectRatio: false }}
              />
            )}

            {(chartTypes.driverPay === "Pie" || chartTypes.driverPay === "Doughnut") && (() => {
              const C = chartTypes.driverPay === "Pie" ? Pie : Doughnut;
              return (
                <C
                  data={{
                    labels: Object.keys(driverPayDetail.allDeductionsByType),
                    datasets: [{
                      data: Object.values(driverPayDetail.allDeductionsByType),
                      backgroundColor: ["#ef4444","#f59e0b","#3b82f6","#8b5cf6","#22c55e","#14b8a6","#f43f5e"],
                    }],
                  }}
                  options={{ responsive: true, maintainAspectRatio: false }}
                />
              );
            })()}

            {chartTypes.driverPay === "Gauge" && (
              <Doughnut
                data={{
                  labels: ["Net Pay", ""],
                  datasets: [{
                    data: [
                      driverPayDetail.grandTotals.netPay,
                      Math.max(100000 - driverPayDetail.grandTotals.netPay, 0),
                    ],
                    backgroundColor: ["#f59e0b", "#1e293b"],
                    borderWidth: 0,
                  }],
                }}
                options={{
                  responsive: true, maintainAspectRatio: false,
                  circumference: 180, rotation: -90, cutout: "75%",
                  plugins: { legend: { display: false } },
                }}
              />
            )}
          </div>

          {/* ── Grand totals cards ── */}
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", fontSize: 13 }}>
            {[
              { label: "Base Pay",   value: driverPayDetail.grandTotals.basePay,         color: "#3b82f6" },
              { label: "+ Additions",value: driverPayDetail.grandTotals.totalAdditions,   color: "#22c55e" },
              { label: "- Deductions",value: driverPayDetail.grandTotals.totalDeductions, color: "#ef4444" },
              { label: "Net Pay",    value: driverPayDetail.grandTotals.netPay,           color: "#f59e0b" },
            ].map((c, i) => (
              <div key={i} style={{
                background: "rgba(255,255,255,0.04)",
                border: `1px solid ${c.color}44`,
                borderRadius: 8, padding: "8px 12px", flex: 1, minWidth: 100,
              }}>
                <div style={{ color: "#94a3b8", fontSize: 11, marginBottom: 3 }}>{c.label}</div>
                <div style={{ color: c.color, fontWeight: 700, fontSize: 14 }}>${c.value.toFixed(2)}</div>
              </div>
            ))}
          </div>

          {/* ── Deductions by type ── */}
          {Object.keys(driverPayDetail.allDeductionsByType).length > 0 && (
            <div style={{ fontSize: 12 }}>
              <div style={{ color: "#94a3b8", marginBottom: 6, fontWeight: 600, textTransform: "uppercase", fontSize: 11 }}>
                Deductions Breakdown
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {Object.entries(driverPayDetail.allDeductionsByType).map(([type, amt], i) => (
                  <div key={i} style={{
                    background: "rgba(239,68,68,0.08)",
                    border: "1px solid rgba(239,68,68,0.2)",
                    borderRadius: 6, padding: "5px 10px",
                    display: "flex", gap: 8, alignItems: "center",
                  }}>
                    <span style={{ color: "#cbd5e1" }}>{type}</span>
                    <span style={{ color: "#ef4444", fontWeight: 700 }}>${amt.toFixed(2)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ── Additions by type ── */}
          {Object.keys(driverPayDetail.allAdditionsByType).length > 0 && (
            <div style={{ fontSize: 12 }}>
              <div style={{ color: "#94a3b8", marginBottom: 6, fontWeight: 600, textTransform: "uppercase", fontSize: 11 }}>
                Additions Breakdown
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {Object.entries(driverPayDetail.allAdditionsByType).map(([type, amt], i) => (
                  <div key={i} style={{
                    background: "rgba(34,197,94,0.08)",
                    border: "1px solid rgba(34,197,94,0.2)",
                    borderRadius: 6, padding: "5px 10px",
                    display: "flex", gap: 8, alignItems: "center",
                  }}>
                    <span style={{ color: "#cbd5e1" }}>{type}</span>
                    <span style={{ color: "#22c55e", fontWeight: 700 }}>${amt.toFixed(2)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ── Per settlement table ── */}
          <div style={{ overflowX: "auto", fontSize: 12 }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
                  <th style={{ textAlign: "left",  padding: "5px 8px", color: "#94a3b8" }}>Settlement</th>
                  <th style={{ textAlign: "right", padding: "5px 8px", color: "#94a3b8" }}>Period</th>
                  <th style={{ textAlign: "right", padding: "5px 8px", color: "#3b82f6" }}>Base Pay</th>
                  <th style={{ textAlign: "right", padding: "5px 8px", color: "#22c55e" }}>+ Add.</th>
                  <th style={{ textAlign: "right", padding: "5px 8px", color: "#ef4444" }}>- Ded.</th>
                  <th style={{ textAlign: "right", padding: "5px 8px", color: "#f59e0b" }}>Net Pay</th>
                </tr>
              </thead>
              <tbody>
                {driverPayDetail.settlements.map((s, i) => (
                  <tr key={i} style={{
                    borderBottom: "1px solid rgba(255,255,255,0.05)",
                    background: i % 2 === 0 ? "rgba(255,255,255,0.02)" : "transparent",
                  }}>
                    <td style={{ padding: "5px 8px", color: "#f1f5f9", fontWeight: 600 }}>{s.settlementNumber}</td>
                    <td style={{ padding: "5px 8px", textAlign: "right", color: "#64748b", fontSize: 11 }}>
                      {new Date(s.startDate).toLocaleDateString()} – {new Date(s.endDate).toLocaleDateString()}
                    </td>
                    <td style={{ padding: "5px 8px", textAlign: "right", color: "#93c5fd" }}>${s.basePay.toFixed(2)}</td>
                    <td style={{ padding: "5px 8px", textAlign: "right", color: "#86efac" }}>+${s.totalAdditions.toFixed(2)}</td>
                    <td style={{ padding: "5px 8px", textAlign: "right", color: "#fca5a5" }}>-${s.totalDeductions.toFixed(2)}</td>
                    <td style={{ padding: "5px 8px", textAlign: "right", color: "#fbbf24", fontWeight: 700 }}>${s.netPay.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  </div>

)}
</div>



        </>
      )}
    </div>
    <EmailPanel />
  </div>
);
};

const TruckDashboard = ({ onNavigate }) => {
  const [trucks, setTrucks] = useState([]);
  const [selectedTruck, setSelectedTruck] = useState(null);
  const [truckDetails, setTruckDetails] = useState(null);
  const [loading, setLoading] = useState(false);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [showLoadsModal, setShowLoadsModal] = useState(false);
const [truckLoadsList, setTruckLoadsList] = useState([]);
const [showMore, setShowMore] = useState(false);
const [truckDriverPays, setTruckDriverPays] = useState([]);
const [truckRevenue, setTruckRevenue] = useState([]);
const [truckCosts, setTruckCosts] = useState({});
const [loads, setLoads] = useState([]);

  const [timeRange, setTimeRange] = useState("month");
  const [customStartDate, setCustomStartDate] = useState("");
  const [customEndDate, setCustomEndDate] = useState("");

  const [truckLoads, setTruckLoads] = useState({ complete: 0, canceled: 0, open: 0 });
  const [rateEvolution, setRateEvolution] = useState({ labels: [], values: [] });
  const [fuelUsage, setFuelUsage] = useState(0);
const allTruckChartOptions = [
  { key: "payrollPerMile", label: "Payroll per Mile" },
  { key: "profitLoss", label: "Profit / Loss" },
  { key: "avgRatePerLoad", label: "Average Rate per Load" },
];
const [charts, setCharts] = useState(() => {
  const saved = localStorage.getItem("truckDashboardCharts");
  return saved ? JSON.parse(saved) : [];
});
const [showAddModal, setShowAddModal] = useState(false);
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const apiUrl = 'https://api-backend.full-trucking-service.com/api';

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || 'dark');
    } catch (err) {
      setTheme('dark');
    }
  };

  fetchTheme();
}, []);


const [chartTypes, setChartTypes] = useState({
  loadStatus: "Pie",
  rateEvolution: "Line",
  fuelUsage: "Doughnut",
  totalDriverPay: "Bar",
  truckCosts: "Bar",  
  ratePerMile: "Bar",

  // 👇 noile charturi
  payrollPerMile: "Bar",
  profitLoss: "Bar",
  avgRatePerLoad: "Line",
});


  const apiUrl = "https://api-backend.full-trucking-service.com/api";
  const token = sessionStorage.getItem("token");

  const config = {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  };

  useEffect(() => {
    fetchTrucks();
  }, []);

useEffect(() => {
  const fetchTruckLoads = async () => {
    if (!selectedTruck?._id) return;
    try {
      const res = await axios.get(
        `${apiUrl}/loads/by-assignment?truckId=${selectedTruck._id}`,
        config
      );
      setTruckLoadsList(res.data || []);
    } catch (err) {
      console.error("❌ Error fetching truck loads:", err);
    }
  };
  fetchTruckLoads();
}, [selectedTruck]);


  const handleChartTypeChange = (chartKey, newType) => {
    setChartTypes(prev => ({ ...prev, [chartKey]: newType }));
  };
  
 const downloadChartAsPDF = (chartId, chartTitle) => {
  const input = document.getElementById(chartId);
  if (!input) {

    return;
  }

  html2canvas(input).then(canvas => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();

    if (!chartTitle || typeof chartTitle !== "string") {
      chartTitle = "Chart Export";
    }

    pdf.text(chartTitle, 10, 10);
    pdf.addImage(imgData, "PNG", 10, 20, 180, 100);
    pdf.save(`${chartTitle.replace(/\s+/g, "_")}.pdf`);
  }).catch(error => {
 
  });
};

const fetchLoads = async (truckId) => {
  try {
    let startDate = new Date();
    let endDate = new Date();

    // === 🔹 Setăm intervalul în funcție de timeRange ===
    if (timeRange !== "custom") {
      switch (timeRange) {
        case "day":
          break;
        case "week":
          startDate.setDate(endDate.getDate() - 7);
          break;
        case "month":
          startDate.setDate(1);
          break;
        case "year":
          startDate = new Date(startDate.getFullYear(), 0, 1);
          break;
      }
    } else if (customStartDate && customEndDate) {
      startDate = new Date(customStartDate);
      endDate = new Date(customEndDate);
    }

    // === 🔹 Fetch loads
    const response = await axios.get(
      `${apiUrl}/loads?truckId=${truckId}`,
      config
    );
    const data = response.data || [];

    // filtrează după interval de timp
    const filtered = data.filter(load => {
      const loadDate = new Date(load.date || load.createdAt);
      return loadDate >= startDate && loadDate <= endDate;
    });

    setLoads(filtered);
  } catch (err) {
    console.error("❌ Error fetching loads:", err);
    setLoads([]);
  }
};

useEffect(() => {
  if (selectedTruck?._id) {
    fetchLoads(selectedTruck._id);
  }
}, [selectedTruck, timeRange, customStartDate, customEndDate]);

const fetchTruckDriverPays = async (truckId) => {
  try {
    const response = await axios.get(
      `https://api-backend.full-trucking-service.com/api/driverpays?truckId=${truckId}`,
      config
    );
    setTruckDriverPays(response.data?.data || []);
  } catch (err) {
    console.error("Error fetching driver pays for truck:", err);
    setTruckDriverPays([]);
  }
};

// 📌 Fetch driver pays când selectezi un truck
useEffect(() => {
  if (truckDetails?._id) {
    fetchTruckDriverPays(truckDetails._id);
  }
}, [truckDetails?._id]);


const handleDownloadExcelTruckDashboard = () => {
  if (!truckDetails) return;

  const workbook = XLSX.utils.book_new();

  // === Sheet 1: Completed Loads ===
  const completedLoads = (truckLoadsList || []).filter(
    load => load.status?.toLowerCase() === "completed"
  ).map(load => ({
    "Load Number": load.loadNumber,
    "Status": load.status,
    "Rate": load.rate,
    "Miles": load.miles,
    "Driver": load.driver ? `${load.driver.firstName || ""} ${load.driver.lastName || ""}` : "N/A",
    "Truck": truckDetails.truckNumber || truckDetails.licensePlate || "N/A",
    "Completed At": new Date(load.updatedAt || load.date).toLocaleString(),
    "Shipper": load.shippers?.map(s => s.address).join(", ") || "N/A",
    "Consignee": load.consignees?.map(c => c.address).join(", ") || "N/A",
    "Notes": load.notes || ""
  }));
  const wsCompleted = XLSX.utils.json_to_sheet(completedLoads);
  XLSX.utils.book_append_sheet(workbook, wsCompleted, "Completed Loads");

  // === Sheet 2: Open Loads ===
  const openLoads = (truckLoadsList || []).filter(
    load => load.status?.toLowerCase() !== "completed" && load.status?.toLowerCase() !== "canceled"
  ).map(load => ({
    "Load Number": load.loadNumber,
    "Status": load.status,
    "Rate": load.rate,
    "Miles": load.miles,
    "Driver": load.driver ? `${load.driver.firstName || ""} ${load.driver.lastName || ""}` : "N/A",
    "Truck": truckDetails.truckNumber || truckDetails.licensePlate || "N/A",
    "Created At": new Date(load.createdAt).toLocaleString(),
    "Updated At": new Date(load.updatedAt).toLocaleString(),
    "Shipper": load.shippers?.map(s => s.address).join(", ") || "N/A",
    "Consignee": load.consignees?.map(c => c.address).join(", ") || "N/A",
    "Notes": load.notes || ""
  }));
  const wsOpen = XLSX.utils.json_to_sheet(openLoads);
  XLSX.utils.book_append_sheet(workbook, wsOpen, "Open Loads");

  // === Sheet 3: Truck Costs (dacă ai metrici) ===
  const truckCostsData = [{
    "Truck": truckDetails.truckNumber || truckDetails.licensePlate || "N/A",
    "Total Completed Loads": completedLoads.length,
    "Total Miles": completedLoads.reduce((s, l) => s + (l["Miles"] || 0), 0),
    "Total Rate": completedLoads.reduce((s, l) => s + (l["Rate"] || 0), 0),
  }];
  const wsTruckCosts = XLSX.utils.json_to_sheet(truckCostsData);
  XLSX.utils.book_append_sheet(workbook, wsTruckCosts, "Truck Costs");

  // === Salvare ===
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `TruckDashboard_${truckDetails.truckNumber || truckDetails.licensePlate}.xlsx`);
};

const handleDownloadPdfTruckDashboard = () => {
  if (!truckDetails) return;

  const doc = new jsPDF();
  const truckName = truckDetails.truckNumber || truckDetails.licensePlate || "Truck";

  const completedLoads = (truckLoadsList || []).filter(
    load => load.status?.toLowerCase() === "completed"
  );
  const openLoads = (truckLoadsList || []).filter(
    load => load.status?.toLowerCase() !== "completed" && load.status?.toLowerCase() !== "canceled"
  );

  const totalRate = completedLoads.reduce((sum, load) => sum + (load.rate || 0), 0);

  // Titlu
  doc.setFontSize(18);
  doc.text(`Truck Dashboard Report: ${truckName}`, 14, 20);

  // Rezumat
  doc.setFontSize(12);
  doc.text(`${truckName} has ${completedLoads.length} Completed Loads and ${openLoads.length} Open Loads.`, 14, 30);
  doc.text(`Total Revenue: $${totalRate}`, 14, 38);

  // === Completed Loads Table
  if (completedLoads.length > 0) {
    const completedData = completedLoads.map(load => [
      load.loadNumber,
      load.rate,
      load.miles,
      new Date(load.updatedAt || load.date).toLocaleDateString()
    ]);

    completedData.push([
      "TOTAL",
      totalRate,
      completedLoads.reduce((s, l) => s + (l.miles || 0), 0),
      "-"
    ]);

    doc.autoTable({
      head: [["Completed Load #", "Rate", "Miles", "Completed At"]],
      body: completedData,
      startY: 60,
    });
  }

  // === Open Loads Table
  if (openLoads.length > 0) {
    const openData = openLoads.map(load => [
      load.loadNumber,
      load.status,
      load.rate,
      load.miles,
      new Date(load.createdAt).toLocaleDateString()
    ]);

    doc.autoTable({
      head: [["Open Load #", "Status", "Rate", "Miles", "Created At"]],
      body: openData,
      startY: doc.lastAutoTable.finalY + 10,
    });
  }

  doc.save(`TruckDashboard_${truckName}.pdf`);
};

  const fetchTrucks = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/trucks`, config);
      setTrucks(response.data || []);
    } catch (error) {
     
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedTruck) {
      fetchTruckDetails(selectedTruck._id);
    }
  }, [selectedTruck ]);

// ✅ Calculăm Rate per Mile
const ratePerMileData = loads
  .filter(load => load.miles > 0) // doar loaduri cu mile > 0
  .map(load => ({
    date: new Date(load.date || load.createdAt).toLocaleDateString(),
    value: load.rate / load.miles // rate per mile
  }));

  
  const fetchTruckDetails = async (truckId) => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/trucks/${truckId}`, config);
      
      if (!response.data || Object.keys(response.data).length === 0) {
        console.warn("No truck details found");
        setTruckDetails(null);
        return;
      }
  
      setTruckDetails(response.data);
      fetchTruckStats(truckId);
    } catch (error) {
   
      setTruckDetails(null);
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    if (selectedTruck) {
      fetchTruckStats(selectedTruck._id);
    }
  }, [selectedTruck, timeRange, customStartDate, customEndDate]);


  

const handleShowTruckLoads = async (truckId) => {
  try {
    const response = await axios.get(
      `https://api-backend.full-trucking-service.com/api/loads/by-assignment?truckId=${truckId}`,
      config
    );
    setTruckLoadsList(response.data || []);
    setShowLoadsModal(true);
  } catch (err) {
    console.error("Error fetching truck loads:", err);
    setTruckLoadsList([]);
    setShowLoadsModal(true);
  }
};


const getTruckOpenLoadStatus = (truckDetails, truckLoadsList) => {
  if (!truckDetails) return "";

  const safeLoads = Array.isArray(truckLoadsList) ? truckLoadsList : [];
  const truckName = truckDetails.truckNumber || truckDetails.licensePlate || "Truck";

  // ✅ Open loads pentru acest truck
  const openLoads = safeLoads.filter(
    load => !["completed", "canceled"].includes(load.status?.toLowerCase())
  );

  if (openLoads.length > 0) {
    const openLoad = openLoads[0];
    const openedAt = new Date(openLoad.date || openLoad.createdAt);
    const diffDays = Math.floor((Date.now() - openedAt.getTime()) / (1000 * 60 * 60 * 24));
    return `Truck ${truckName} has an Open Load (#${openLoad.loadNumber || openLoad._id}) open for ${diffDays} days.`;
  } else if (safeLoads.length > 0) {
    const sorted = [...safeLoads].sort(
      (a, b) => new Date(b.date || b.updatedAt || b.createdAt) - new Date(a.date || a.updatedAt || a.createdAt)
    );
    const lastLoad = sorted[0];
    const closedAt = new Date(lastLoad.date || lastLoad.updatedAt || lastLoad.createdAt);
    const diffDays = Math.floor((Date.now() - closedAt.getTime()) / (1000 * 60 * 60 * 24));
    return `Truck ${truckName} has not done a load for ${diffDays} days. Last load was (#${lastLoad.loadNumber || lastLoad._id}) on ${closedAt.toLocaleDateString("en-US")}.`;
  } else {
    return `Truck ${truckName} has no load history.`;
  }
};


const fetchTruckStats = async (truckId) => {
  try {
    let startDate = new Date();
    let endDate = new Date();

    // === 🔹 Setăm intervalul în funcție de timeRange ===
    if (timeRange !== "custom") {
      switch (timeRange) {
        case "day":
          break;
        case "week":
          startDate.setDate(endDate.getDate() - 7);
          break;
        case "month":
          startDate.setDate(1);
          break;
        case "year":
          startDate = new Date(startDate.getFullYear(), 0, 1);
          break;
      }
    } else if (customStartDate && customEndDate) {
      startDate = new Date(customStartDate);
      endDate = new Date(customEndDate);
    }

    // === 🔹 Loads (Revenue + Status) ===
    const loadsResponse = await axios.get(
      `${apiUrl}/loads/by-assignment?truckId=${truckId}`,
      config
    );
    const loads = (loadsResponse.data || []).filter(load => {
      const loadDate = new Date(load.date || load.createdAt);
      return loadDate >= startDate && loadDate <= endDate;
    });

    // ✅ Status (Complete / Canceled / Open)
    setTruckLoads({
      complete: loads.filter(load => load.status?.toLowerCase() === "complete").length,
      canceled: loads.filter(load => load.status?.toLowerCase() === "canceled").length,
      open: loads.filter(load => !["complete", "canceled"].includes(load.status?.toLowerCase())).length,
    });

    // ✅ Revenue
    const revenue = loads.reduce((acc, load) => acc + (parseFloat(load.rate) || 0), 0);
    setTruckRevenue(revenue);

    // ✅ Rate Evolution
    const rateData = {};
    loads.forEach(load => {
      const date = new Date(load.date || load.createdAt);
      const label = date.toLocaleDateString("en-US", { month: "short", year: "numeric" });
      rateData[label] = (rateData[label] || 0) + (parseFloat(load.rate) || 0);
    });
    setRateEvolution({ labels: Object.keys(rateData), values: Object.values(rateData) });

    // === 🔹 Fuel Reports ===
    const fuelResponse = await axios.get(
      `${apiUrl}/fuel-reports/truck/${truckId}`,
      config
    );
    const fuelReports = (fuelResponse.data || []).filter(report => {
      const reportDate = new Date(report.createdAt);
      return reportDate >= startDate && reportDate <= endDate;
    });
    setFuelUsage(
      fuelReports.reduce((acc, report) => acc + (parseFloat(report.grandTotal) || 0), 0)
    );
const truckResponse = await axios.get(`${apiUrl}/trucks/${truckId}`, config);
const truck = truckResponse.data;

if (truck && truck.reports) {
  const aggregatedCosts = truck.reports.reduce(
    (acc, rep) => {
      acc.insuranceCost += rep.insuranceCost || 0;
      acc.maintenanceCost += rep.maintenanceCost || 0;
      acc.leasingRate += rep.leasingRate || 0;
      acc.purchaseCost += rep.purchaseCost || 0;
      acc.serviceCosts += rep.serviceCosts || 0;
      acc.maut += rep.maut || 0;
      return acc;
    },
    { insuranceCost: 0, maintenanceCost: 0, leasingRate: 0, purchaseCost: 0, serviceCosts: 0, maut: 0 }
  );

  setTruckCosts(aggregatedCosts);
}

    // === 🔹 DriverPays ===
    const paysResponse = await axios.get(
      `${apiUrl}/driverpays?truckId=${truckId}`,
      config
    );
    const driverPays = (paysResponse.data?.data || []).filter(pay => {
      const payDate = new Date(pay.createdAt);
      return payDate >= startDate && payDate <= endDate;
    });
    setTruckDriverPays(driverPays);

  } catch (error) {
    console.error("❌ Error fetching truck stats:", error);
    setTruckLoads({ complete: 0, canceled: 0, open: 0 });
    setRateEvolution({ labels: [], values: [] });
    setFuelUsage(0);
    setTruckRevenue(0);
    setTruckDriverPays([]);
  }
};


// ✅ Payroll per Mile
const payrollPerMile = truckDriverPays.length && loads.length
  ? (
      truckDriverPays.reduce(
        (s, p) => s + (parseFloat(p.totalWithAdjustments || p.totalPay) || 0), 
        0
      ) / loads.reduce((s, l) => s + (parseFloat(l.miles) || 0), 0)
    ).toFixed(2)
  : 0;

// ✅ Profit / Loss
const totalCosts = Object.values(truckCosts || {}).reduce((a, b) => a + (b || 0), 0);
const profitLoss = (truckRevenue || 0) - totalCosts;

// ✅ Average Rate per Load
const avgRatePerLoad = loads.length
  ? (
      loads.reduce((a, l) => a + (parseFloat(l.rate) || 0), 0) / loads.length
    ).toFixed(2)
  : 0;
       return (
    <div
  className={`${styles.truckdashboard} ${
    theme === 'light' ? styles.truckdashboardLight : ''
  }`}
>

      {/* Side Menu */}
      <div className={styles.sidebarToggleTruck} onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
  ☰
</div>

      <aside className={`${styles.sidebartruckdashboard} ${isSidebarOpen ? styles.sidebarOpenTruck : ''}`}>
  <ul>
    <li onClick={() => onNavigate('dashboard')}>Overview</li>
    <li onClick={() => onNavigate('driver-dashboard')}>Drivers</li>
    <li onClick={() => onNavigate('truck-dashboard')}>Trucks</li>
    <li onClick={() => onNavigate('load-dashboard')}>Loads</li>
  </ul>
</aside>


      {/* ✅ Main Content */}
      <div className={styles.mainContenttruckdashboard}>
        <h2 className={styles.titletruckdashboard}>Truck Dashboard</h2>

        {/* 📌 Truck Table */}
        {!selectedTruck ? (
          <table className={styles.tabletruckdashboard}>
            <thead>
              <tr>
                <th>Truck Number</th>
                <th>Model</th>
                <th>Year</th>
                <th>VIN</th>
                <th>License Plate</th>
                <th>View Details</th>
              </tr>
            </thead>
            <tbody>
              {trucks.map(truck => (
                <tr key={truck._id}>
                  <td>{truck.truckNumber}</td>
                  <td>{truck.truckType}</td>
                  <td>{truck.year}</td>
                  <td>{truck.VIN}</td>
                  <td>{truck.licensePlate}</td>
                  <td>
                    <button onClick={() => setSelectedTruck(truck)}>View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <>
            {/* 📌 Truck Details */}
            <button className={styles.backButtontruckdashboard} onClick={() => setSelectedTruck(null)}>⬅ Back to Trucks</button>
            <div className={styles.detailsSectiontruckdashboard}>
{truckDetails ? (
  <div>
    {/* HEADER cu Truck Number, See More și See Loads */}
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      {/* Stânga: Titlu + buton sub el */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px" }}>
        <h3>Truck: {truckDetails.truckNumber}</h3>
        {!showMore ? (
          <button 
            className={styles.seeMoreButton} 
            onClick={() => setShowMore(true)}
          >
            See More About the Truck ({truckDetails.truckNumber})
          </button>
        ) : (
          <button 
            className={styles.hideMoreDriverButton} 
            onClick={() => setShowMore(false)}
          >
            Hide details about the Truck ({truckDetails.truckNumber})
          </button>
        )}
      </div>

      {/* Dreapta: buton See Loads */}
      <button 
        className={styles.seeLoadsButton} 
        onClick={() => handleShowTruckLoads(truckDetails._id)}
      >
        See Loads
      </button>
    </div>

    {/* DETALII vizibile doar când e activ showMore */}
    {showMore && (
      <>
        <p><strong>Model:</strong> {truckDetails.truckType || "No data"}</p>
        <p><strong>Year:</strong> {truckDetails.year || "No data"}</p>
        <p><strong>VIN:</strong> {truckDetails.VIN || "No data"}</p>
        <p><strong>License Plate:</strong> {truckDetails.licensePlate || "No data"}</p>
        <p><strong>Insurance Expiry:</strong> {truckDetails.insuranceExpiryDate || "No data"}</p>
      </>
    )}
  </div>
) : (
  <p>Loading truck details...</p>
)}


            </div>
{showLoadsModal && (
  <div className={styles.DriverDashboardLoadOverlay}>
    <div className={styles.DriverDashboardLoadModal}>
      <button 
        className={styles.DriverDashboardLoadClose} 
        onClick={() => setShowLoadsModal(false)}
      >
        ✕
      </button>

      <h3 className={styles.DriverDashboardLoadTitle}>
        Loads for {truckDetails.truckNumber}
      </h3>

      {truckLoadsList.length > 0 ? (
        <div className={styles.DriverDashboardLoadWrapper}>
          <table className={styles.DriverDashboardLoadTable}>
            <thead>
              <tr>
                <th>Load #</th>
                <th>Status</th>
                <th>Rate</th>
                <th>Miles</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {truckLoadsList.map(load => (
                <tr key={load._id}>
                  <td>{load.loadNumber || "-"}</td>
                  <td>{load.status || "-"}</td>
                  <td>${load.rate || "-"}</td>
                  <td>{load.miles || "-"}</td>
                  <td>{new Date(load.date || load.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className={styles.TruckDashboardNoLoads}>No loads found for this truck.</p>
      )}
    </div>
  </div>
)}
          <div className={styles.driverLoadStatusBox}>
  {truckDetails ? (
    <p>{getTruckOpenLoadStatus(truckDetails, truckLoadsList || [])}</p>
  ) : (
    <p>No truck selected.</p>
  )}
</div>
<div style={{ display: "flex", gap: "10px" }}>
  <button 
    onClick={handleDownloadExcelTruckDashboard}
    style={{ padding: "8px 14px", backgroundColor: "#22c55e", color: "white", border: "none", borderRadius: "6px", cursor: "pointer" }}
  >
    Download Excel Truck Dashboard
  </button>
  <button 
    onClick={handleDownloadPdfTruckDashboard}
    style={{ padding: "8px 14px", backgroundColor: "#3b82f6", color: "white", border: "none", borderRadius: "6px", cursor: "pointer" }}
  >
    Download PDF Truck Dashboard
  </button>
</div>

            <div className={styles.chartControlstruckdashboard}>
            <label>Time Range:</label>
            <select value={timeRange} onChange={(e) => setTimeRange(e.target.value)}>
              <option value="day">Today</option>
              <option value="week">This Week</option>
              <option value="month">This Month</option>
              <option value="year">This Year</option>
              <option value="custom">Custom Range</option>
            </select>

            {timeRange === "custom" && (
              <div>
                <input type="date" value={customStartDate} onChange={(e) => setCustomStartDate(e.target.value)} />
                <input type="date" value={customEndDate} onChange={(e) => setCustomEndDate(e.target.value)} />
              </div>
            )}
          </div>
          

          <button 
  className={styles.addWidgetButton} 
  onClick={() => setShowAddModal(true)}
>
  + Add New Widget
</button>
{showAddModal && (
  <div className={styles.ModalDriverDashboardOverlay}>
    <div className={styles.ModalDriverDashboardContent}>
      <div className={styles.ModalDriverDashboardHeader}>
        <h3>Select Widgets</h3>
        <button 
          className={styles.ModalDriverDashboardClose} 
          onClick={() => setShowAddModal(false)}
        >
          ✖
        </button>
      </div>

      <div className={styles.ModalDriverDashboardOptions}>
        {allTruckChartOptions.map(opt => (
          <label key={opt.key} className={styles.ModalDriverDashboardOption}>
            <input
              type="checkbox"
              checked={charts.includes(opt.key)}
              onChange={e => {
                if (e.target.checked) {
                  setCharts([...charts, opt.key]);
                } else {
                  setCharts(charts.filter(c => c !== opt.key));
                }
              }}
            />
            {opt.label}
          </label>
        ))}
      </div>

      <button 
        className={styles.ModalDriverDashboardDone}
        onClick={() => {
          localStorage.setItem("truckDashboardCharts", JSON.stringify(charts));
          setShowAddModal(false);
        }}
      >
        Done
      </button>
    </div>
  </div>
)}

<div className={styles.chartsGrid}>
  {/* === Payroll per Mile === */}
  {charts.includes("payrollPerMile") && (
    <div className={styles.chartContainerdriverdashboard}>
      <div className={styles.chartHeaderdriverdashboard}>
        <h4>Payroll per Mile</h4>
        <ChartMenu
          chartKey="payrollPerMile"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
      <div className={styles.chartContentdriverdashboard}>
        {chartTypes.payrollPerMile === "Bar" && (
          <Bar
            data={{
              labels: ["Payroll per Mile"],
              datasets: [{ label: "$/mile", data: [payrollPerMile], backgroundColor: "#3b82f6" }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.payrollPerMile === "Column" && (
          <Bar
            data={{
              labels: ["Payroll per Mile"],
              datasets: [{ label: "$/mile", data: [payrollPerMile], backgroundColor: "#3b82f6" }],
            }}
            options={{ indexAxis: "x", responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.payrollPerMile === "Line" && (
          <Line
            data={{
              labels: ["Payroll per Mile"],
              datasets: [{ label: "$/mile", data: [payrollPerMile], borderColor: "#3b82f6", backgroundColor: "rgba(59,130,246,0.3)", tension: 0.4 }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.payrollPerMile === "Pie" && (
          <Pie
            data={{
              labels: ["Payroll per Mile"],
              datasets: [{ data: [payrollPerMile], backgroundColor: ["#3b82f6"] }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.payrollPerMile === "Doughnut" && (
          <Doughnut
            data={{
              labels: ["Payroll per Mile"],
              datasets: [{ data: [payrollPerMile], backgroundColor: ["#3b82f6"] }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.payrollPerMile === "Gauge" && (
          <Doughnut
            data={{
              labels: ["Used", "Remaining"],
              datasets: [{
                data: [payrollPerMile, Math.max(5 - payrollPerMile, 0)],
                backgroundColor: ["#3b82f6", "#e5e7eb"],
              }],
            }}
            options={{ rotation: -90, circumference: 180, responsive: true, maintainAspectRatio: false }}
          />
        )}
      </div>
    </div>
  )}

  {/* === Profit / Loss === */}
  {charts.includes("profitLoss") && (
    <div className={styles.chartContainerdriverdashboard}>
      <div className={styles.chartHeaderdriverdashboard}>
        <h4>Profit / Loss</h4>
        <ChartMenu
          chartKey="profitLoss"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
      <div className={styles.chartContentdriverdashboard}>
        {chartTypes.profitLoss === "Bar" && (
          <Bar
            data={{
              labels: ["Profit / Loss"],
              datasets: [{ label: "Amount", data: [profitLoss], backgroundColor: profitLoss >= 0 ? "#22c55e" : "#ef4444" }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.profitLoss === "Column" && (
          <Bar
            data={{
              labels: ["Profit / Loss"],
              datasets: [{ label: "Amount", data: [profitLoss], backgroundColor: profitLoss >= 0 ? "#22c55e" : "#ef4444" }],
            }}
            options={{ indexAxis: "x", responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.profitLoss === "Line" && (
          <Line
            data={{
              labels: ["Profit / Loss"],
              datasets: [{ label: "Amount", data: [profitLoss], borderColor: profitLoss >= 0 ? "#22c55e" : "#ef4444", backgroundColor: "rgba(34,197,94,0.3)", tension: 0.4 }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.profitLoss === "Pie" && (
          <Pie
            data={{
              labels: ["Profit / Loss"],
              datasets: [{ data: [profitLoss], backgroundColor: [profitLoss >= 0 ? "#22c55e" : "#ef4444"] }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.profitLoss === "Doughnut" && (
          <Doughnut
            data={{
              labels: ["Profit / Loss"],
              datasets: [{ data: [profitLoss], backgroundColor: [profitLoss >= 0 ? "#22c55e" : "#ef4444"] }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.profitLoss === "Gauge" && (
          <Doughnut
            data={{
              labels: ["Value", "Remaining"],
              datasets: [{
                data: [Math.abs(profitLoss), Math.max(10000 - Math.abs(profitLoss), 0)],
                backgroundColor: [profitLoss >= 0 ? "#22c55e" : "#ef4444", "#e5e7eb"],
              }],
            }}
            options={{ rotation: -90, circumference: 180, responsive: true, maintainAspectRatio: false }}
          />
        )}
      </div>
    </div>
  )}

  {/* === Average Rate per Load === */}
  {charts.includes("avgRatePerLoad") && (
    <div className={styles.chartContainerdriverdashboard}>
      <div className={styles.chartHeaderdriverdashboard}>
        <h4>Average Rate per Load</h4>
        <ChartMenu
          chartKey="avgRatePerLoad"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
      <div className={styles.chartContentdriverdashboard}>
        {chartTypes.avgRatePerLoad === "Bar" && (
          <Bar
            data={{
              labels: ["Avg Rate per Load"],
              datasets: [{ label: "$", data: [avgRatePerLoad], backgroundColor: "#6366f1" }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.avgRatePerLoad === "Column" && (
          <Bar
            data={{
              labels: ["Avg Rate per Load"],
              datasets: [{ label: "$", data: [avgRatePerLoad], backgroundColor: "#6366f1" }],
            }}
            options={{ indexAxis: "x", responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.avgRatePerLoad === "Line" && (
          <Line
            data={{
              labels: ["Avg Rate per Load"],
              datasets: [{ label: "$", data: [avgRatePerLoad], borderColor: "#6366f1", backgroundColor: "rgba(99,102,241,0.3)", tension: 0.4 }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.avgRatePerLoad === "Pie" && (
          <Pie
            data={{
              labels: ["Avg Rate per Load"],
              datasets: [{ data: [avgRatePerLoad], backgroundColor: ["#6366f1"] }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.avgRatePerLoad === "Doughnut" && (
          <Doughnut
            data={{
              labels: ["Avg Rate per Load"],
              datasets: [{ data: [avgRatePerLoad], backgroundColor: ["#6366f1"] }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.avgRatePerLoad === "Gauge" && (
          <Doughnut
            data={{
              labels: ["Value", "Remaining"],
              datasets: [{
                data: [avgRatePerLoad, Math.max(10 - avgRatePerLoad, 0)],
                backgroundColor: ["#6366f1", "#e5e7eb"],
              }],
            }}
            options={{ rotation: -90, circumference: 180, responsive: true, maintainAspectRatio: false }}
          />
        )}
      </div>
    </div>
  )}
</div>


<div className={styles.chartsGrid}>
  {/* 📊 Load Status */}
<div className={styles.chartContainertruckdashboard} id="loadStatus">
  <div className={styles.chartHeadertruckdashboard}>
    <h4>Load Status Comparison</h4>
    <div className={styles.chartMenuWrapper}>
    <ChartMenu
      chartKey="loadStatus"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
  </div>

  <div className={styles.chartContenttruckdashboard} style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}>
    
    {/* ✅ Bar Chart */}
    {chartTypes.loadStatus === "Bar" && (
      <Bar
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            label: "Load Status",
            data: [truckLoads.complete, truckLoads.canceled, truckLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Line Graph */}
    {chartTypes.loadStatus === "Line" && (
      <Line
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            label: "Load Status Over Time",
            data: [truckLoads.complete, truckLoads.canceled, truckLoads.open],
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59, 130, 246, 0.2)",
            tension: 0.4,
            fill: true,
            pointBackgroundColor: "#3b82f6",
            pointBorderWidth: 2,
            borderWidth: 2,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.loadStatus === "Pie" && (
      <Pie
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            data: [truckLoads.complete, truckLoads.canceled, truckLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

  {/* ✅ Gauge Chart */}
  {chartTypes.loadStatus === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Complete Loads", "Remaining Loads"],
          datasets: [{
            data: [truckLoads.complete, truckLoads.canceled + truckLoads.open],
            backgroundColor: ["#4caf50", "#e0e0e0"],
            borderWidth: 0
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180, // ✅ Face graficul semicircular (Gauge)
          rotation: -90, // ✅ Aliniază la bază ca un contor real
          cutout: "75%", // ✅ Grosimea semicercului
          plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
          },
        }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.loadStatus === "Column" && (
      <Bar
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            label: "Load Status",
            data: [truckLoads.complete, truckLoads.canceled, truckLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.loadStatus === "Doughnut" && (
      <Doughnut
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            data: [truckLoads.complete, truckLoads.canceled, truckLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  </div>
</div>


     {/* 📊 Rate Evolution */}
<div className={styles.chartContainertruckdashboard} id="rateEvolution">
  <div className={styles.chartHeadertruckdashboard}>
   
    <h4>Rate Evolution Over Time</h4>
     <div className={styles.chartMenuWrapper}>
    <ChartMenu
      chartKey="rateEvolution"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
  </div>
  <div className={styles.chartContenttruckdashboard} style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}>

    {/* ✅ Line Graph */}
    {chartTypes.rateEvolution === "Line" && (
      <Line
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            label: "Revenue ($)",
            data: rateEvolution.values,
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59, 130, 246, 0.2)",
            tension: 0.4,
            fill: true,
            pointBackgroundColor: "#3b82f6",
            pointBorderWidth: 2,
            borderWidth: 2,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  
    {/* ✅ Gauge Chart */}
    {chartTypes.rateEvolution === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Revenue Generated", "Remaining Target"],
          datasets: [{
            data: [rateEvolution.values.reduce((acc, val) => acc + val, 0), Math.max(100000 - rateEvolution.values.reduce((acc, val) => acc + val, 0), 0)], // Exemplu: 100.000 ca obiectiv
            backgroundColor: ["#4caf50", "#e0e0e0"],
            borderWidth: 0
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180, // ✅ Face graficul semicircular (Gauge)
          rotation: -90, // ✅ Aliniază la bază ca un contor real
          cutout: "75%", // ✅ Grosimea semicercului
          plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
          },
        }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
    {/* ✅ Bar Chart */}
    {chartTypes.rateEvolution === "Bar" && (
      <Bar
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            label: "Revenue ($)",
            data: rateEvolution.values,
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.rateEvolution === "Column" && (
      <Bar
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            label: "Revenue ($)",
            data: rateEvolution.values,
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.rateEvolution === "Pie" && (
      <Pie
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            data: rateEvolution.values,
            backgroundColor: ["#4caf50", "#ff5722", "#ffc107", "#3b82f6"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.rateEvolution === "Doughnut" && (
      <Doughnut
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            data: rateEvolution.values,
            backgroundColor: ["#4caf50", "#ff5722", "#ffc107", "#3b82f6"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  </div>
</div>
{/* 📊 Fuel Usage */}
<div className={styles.chartContainertruckdashboard} id="fuelUsage">
  <div className={styles.chartHeadertruckdashboard}>
    <h4>Fuel Usage</h4>
    <div className={styles.chartMenuWrapper}>
    <ChartMenu
      chartKey="fuelUsage"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
</div>
  <div className={styles.chartContenttruckdashboard} style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}>
    
    {/* ✅ Doughnut Chart */}
    {chartTypes.fuelUsage === "Doughnut" && (
      <Doughnut
        data={{
          labels: ["Fuel Used"],
          datasets: [{
            data: [fuelUsage],
            backgroundColor: ["#3b82f6"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Bar Chart */}
    {chartTypes.fuelUsage === "Bar" && (
      <Bar
        data={{
          labels: ["Fuel Usage"],
          datasets: [{
            label: "Total Fuel ($)",
            data: [fuelUsage],
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.fuelUsage === "Column" && (
      <Bar
        data={{
          labels: ["Fuel Usage"],
          datasets: [{
            label: "Total Fuel ($)",
            data: [fuelUsage],
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.fuelUsage === "Pie" && (
      <Pie
        data={{
          labels: ["Fuel Used"],
          datasets: [{
            data: [fuelUsage],
            backgroundColor: ["#3b82f6"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

     {/* ✅ Gauge Chart */}
     {chartTypes.fuelUsage === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Fuel Used", "Remaining"],
          datasets: [{
            data: [fuelUsage, Math.max(10000 - fuelUsage, 0)], // Exemplu: 10.000 este limita maximă
            backgroundColor: ["#3b82f6", "#e0e0e0"],
            borderWidth: 0
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180, // ✅ Face graficul semicircular (Gauge)
          rotation: -90, // ✅ Aliniază la bază ca un contor real
          cutout: "75%", // ✅ Grosimea semicercului
          plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
          },
        }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Line Chart */}
    {chartTypes.fuelUsage === "Line" && (
      <Line
        data={{
          labels: ["Fuel Usage"],
          datasets: [{
            label: "Fuel ($)",
            data: [fuelUsage],
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59, 130, 246, 0.2)",
            tension: 0.4,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  </div>
</div>

{/* 📊 Total Driver Pay */}
<div className={styles.chartContainertruckdashboard} id="totalDriverPay">
  <div className={styles.chartHeadertruckdashboard}>
    <h4>Total Driver Pay for Truck {truckDetails?.truckNumber}</h4>
    <div className={styles.chartMenuWrapper}>
    <ChartMenu
      chartKey="totalDriverPay"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
</div>
  <div 
    className={styles.chartContenttruckdashboard} 
    style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}
  >
    {truckDriverPays.length > 0 ? (
      <>
        {/* ✅ Bar Chart */}
        {chartTypes.totalDriverPay === "Bar" && (
          <Bar
            data={{
              labels: truckDriverPays.map(pay => 
                `${new Date(pay.startDate).toLocaleDateString()} - ${new Date(pay.endDate).toLocaleDateString()}`
              ),
              datasets: [{
                label: "Driver Pay ($)",
                data: truckDriverPays.map(pay => pay.totalWithAdjustments || pay.totalPay || 0),
                backgroundColor: "#3b82f6",
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ✅ Column Chart */}
        {chartTypes.totalDriverPay === "Column" && (
          <Bar
            data={{
              labels: truckDriverPays.map(pay => 
                `${new Date(pay.startDate).toLocaleDateString()} - ${new Date(pay.endDate).toLocaleDateString()}`
              ),
              datasets: [{
                label: "Driver Pay ($)",
                data: truckDriverPays.map(pay => pay.totalWithAdjustments || pay.totalPay || 0),
                backgroundColor: "#3b82f6",
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
          />
        )}

        {/* ✅ Pie Chart */}
        {chartTypes.totalDriverPay === "Pie" && (
          <Pie
            data={{
              labels: truckDriverPays.map(pay => 
                `${new Date(pay.startDate).toLocaleDateString()} - ${new Date(pay.endDate).toLocaleDateString()}`
              ),
              datasets: [{
                data: truckDriverPays.map(pay => pay.totalWithAdjustments || pay.totalPay || 0),
                backgroundColor: ["#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#6366f1"],
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ✅ Doughnut Chart */}
        {chartTypes.totalDriverPay === "Doughnut" && (
          <Doughnut
            data={{
              labels: truckDriverPays.map(pay => 
                `${new Date(pay.startDate).toLocaleDateString()} - ${new Date(pay.endDate).toLocaleDateString()}`
              ),
              datasets: [{
                data: truckDriverPays.map(pay => pay.totalWithAdjustments || pay.totalPay || 0),
                backgroundColor: ["#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#6366f1"],
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ✅ Gauge Chart */}
        {chartTypes.totalDriverPay === "Gauge" && (
          <Doughnut
            data={{
              labels: ["Total Pay Earned", "Remaining to Goal"],
              datasets: [{
                data: [
                  truckDriverPays.reduce((sum, p) => sum + (p.totalWithAdjustments || p.totalPay || 0), 0),
                  Math.max(100000 - truckDriverPays.reduce((sum, p) => sum + (p.totalWithAdjustments || p.totalPay || 0), 0), 0)
                ],
                backgroundColor: ["#3b82f6", "#e0e0e0"],
                borderWidth: 0
              }],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              circumference: 180,
              rotation: -90,
              cutout: "75%",
              plugins: { legend: { display: false }, tooltip: { enabled: true } },
            }}
          />
        )}

        {/* ✅ Line Chart */}
        {chartTypes.totalDriverPay === "Line" && (
          <Line
            data={{
              labels: truckDriverPays.map(pay => 
                `${new Date(pay.startDate).toLocaleDateString()}`
              ),
              datasets: [{
                label: "Driver Pay ($)",
                data: truckDriverPays.map(pay => pay.totalWithAdjustments || pay.totalPay || 0),
                borderColor: "#3b82f6",
                backgroundColor: "rgba(59, 130, 246, 0.2)",
                tension: 0.4,
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}
      </>
    ) : (
      <p>No DriverPays found for this truck.</p>
    )}
  </div>
</div>
{/* 📊 Truck Costs */}
<div className={styles.chartContainertruckdashboard} id="truckCosts">
  <div className={styles.chartHeadertruckdashboard}>
  <h4>Truck Costs</h4>
  <div className={styles.chartMenuWrapper}>
    
    <ChartMenu
      chartKey="truckCosts"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
    </div>

  <div
    className={styles.chartContenttruckdashboard}
    style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}
  >
    {/* ✅ Bar Chart */}
    {chartTypes.truckCosts === "Bar" && (
      <Bar
        data={{
          labels: ["Insurance", "Maintenance", "Leasing", "Purchase", "Service", "Maut"],
          datasets: [
            {
              label: "Cost ($)",
              data: [
                truckCosts.insuranceCost,
                truckCosts.maintenanceCost,
                truckCosts.leasingRate,
                truckCosts.purchaseCost,
                truckCosts.serviceCosts,
                truckCosts.maut,
              ],
              backgroundColor: ["#22c55e", "#3b82f6", "#f59e0b", "#ef4444", "#6366f1", "#14b8a6"],
            },
          ],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.truckCosts === "Column" && (
      <Bar
        data={{
          labels: ["Insurance", "Maintenance", "Leasing", "Purchase", "Service", "Maut"],
          datasets: [
            {
              label: "Cost ($)",
              data: [
                truckCosts.insuranceCost,
                truckCosts.maintenanceCost,
                truckCosts.leasingRate,
                truckCosts.purchaseCost,
                truckCosts.serviceCosts,
                truckCosts.maut,
              ],
              backgroundColor: ["#22c55e", "#3b82f6", "#f59e0b", "#ef4444", "#6366f1", "#14b8a6"],
            },
          ],
        }}
        options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.truckCosts === "Pie" && (
      <Pie
        data={{
          labels: ["Insurance", "Maintenance", "Leasing", "Purchase", "Service", "Maut"],
          datasets: [
            {
              data: [
                truckCosts.insuranceCost,
                truckCosts.maintenanceCost,
                truckCosts.leasingRate,
                truckCosts.purchaseCost,
                truckCosts.serviceCosts,
                truckCosts.maut,
              ],
              backgroundColor: ["#22c55e", "#3b82f6", "#f59e0b", "#ef4444", "#6366f1", "#14b8a6"],
            },
          ],
        }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.truckCosts === "Doughnut" && (
      <Doughnut
        data={{
          labels: ["Insurance", "Maintenance", "Leasing", "Purchase", "Service", "Maut"],
          datasets: [
            {
              data: [
                truckCosts.insuranceCost,
                truckCosts.maintenanceCost,
                truckCosts.leasingRate,
                truckCosts.purchaseCost,
                truckCosts.serviceCosts,
                truckCosts.maut,
              ],
              backgroundColor: ["#22c55e", "#3b82f6", "#f59e0b", "#ef4444", "#6366f1", "#14b8a6"],
            },
          ],
        }}
      />
    )}

    {/* ✅ Gauge Chart */}
    {chartTypes.truckCosts === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Costs", "Remaining to Goal"],
          datasets: [
            {
              data: [
                Object.values(truckCosts).reduce((a, b) => a + b, 0),
                Math.max(100000 - Object.values(truckCosts).reduce((a, b) => a + b, 0), 0),
              ],
              backgroundColor: ["#ef4444", "#e0e0e0"],
              borderWidth: 0,
            },
          ],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180,
          rotation: -90,
          cutout: "75%",
          plugins: { legend: { display: false } },
        }}
      />
    )}

    {/* ✅ Line Chart */}
    {chartTypes.truckCosts === "Line" && (
      <Line
        data={{
          labels: ["Insurance", "Maintenance", "Leasing", "Purchase", "Service", "Maut"],
          datasets: [
            {
              label: "Cost ($)",
              data: [
                truckCosts.insuranceCost,
                truckCosts.maintenanceCost,
                truckCosts.leasingRate,
                truckCosts.purchaseCost,
                truckCosts.serviceCosts,
                truckCosts.maut,
              ],
              borderColor: "#3b82f6",
              backgroundColor: "rgba(59,130,246,0.2)",
              tension: 0.4,
            },
          ],
        }}
      />
    )}
  </div>
</div>
{/* 📊 Rate per Mile */}
<div className={styles.chartContainertruckdashboard} id="ratePerMile">
  <div className={styles.chartHeadertruckdashboard}>
    <h4>Rate per Mile</h4>
    <div className={styles.chartMenuWrapper}>
      <ChartMenu
        chartKey="ratePerMile"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>
  </div>

  <div
    className={styles.chartContenttruckdashboard}
    style={{
      width: "600px",
      height: "350px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    {ratePerMileData.length > 0 ? (
      <>
        {/* ✅ Bar Chart */}
        {chartTypes.ratePerMile === "Bar" && (
          <Bar
            data={{
              labels: ratePerMileData.map((r) => r.date),
              datasets: [
                {
                  label: "Rate per Mile ($)",
                  data: ratePerMileData.map((r) => r.value),
                  backgroundColor: "#3b82f6",
                },
              ],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ✅ Column Chart */}
        {chartTypes.ratePerMile === "Column" && (
          <Bar
            data={{
              labels: ratePerMileData.map((r) => r.date),
              datasets: [
                {
                  label: "Rate per Mile ($)",
                  data: ratePerMileData.map((r) => r.value),
                  backgroundColor: "#3b82f6",
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              indexAxis: "y",
            }}
          />
        )}

        {/* ✅ Pie Chart */}
        {chartTypes.ratePerMile === "Pie" && (
          <Pie
            data={{
              labels: ratePerMileData.map((r) => r.date),
              datasets: [
                {
                  data: ratePerMileData.map((r) => r.value),
                  backgroundColor: [
                    "#3b82f6",
                    "#22c55e",
                    "#f59e0b",
                    "#ef4444",
                    "#6366f1",
                  ],
                },
              ],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ✅ Doughnut Chart */}
        {chartTypes.ratePerMile === "Doughnut" && (
          <Doughnut
            data={{
              labels: ratePerMileData.map((r) => r.date),
              datasets: [
                {
                  data: ratePerMileData.map((r) => r.value),
                  backgroundColor: [
                    "#3b82f6",
                    "#22c55e",
                    "#f59e0b",
                    "#ef4444",
                    "#6366f1",
                  ],
                },
              ],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ✅ Gauge Chart */}
        {chartTypes.ratePerMile === "Gauge" && (
          <Doughnut
            data={{
              labels: ["Avg Rate/Mile", "Gap to $5.00"],
              datasets: [
                {
                  data: [
                    ratePerMileData.reduce((a, b) => a + b.value, 0) /
                      ratePerMileData.length,
                    Math.max(
                      5 -
                        ratePerMileData.reduce((a, b) => a + b.value, 0) /
                          ratePerMileData.length,
                      0
                    ),
                  ],
                  backgroundColor: ["#22c55e", "#e0e0e0"],
                  borderWidth: 0,
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              circumference: 180,
              rotation: -90,
              cutout: "75%",
              plugins: { legend: { display: false } },
            }}
          />
        )}

        {/* ✅ Line Chart */}
        {chartTypes.ratePerMile === "Line" && (
          <Line
            data={{
              labels: ratePerMileData.map((r) => r.date),
              datasets: [
                {
                  label: "Rate per Mile ($)",
                  data: ratePerMileData.map((r) => r.value),
                  borderColor: "#3b82f6",
                  backgroundColor: "rgba(59,130,246,0.2)",
                  tension: 0.4,
                },
              ],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}
      </>
    ) : (
      <p>No loads found for this truck.</p>
    )}
  </div>
</div>

</div>
        </>
      )}
    </div>
    <EmailPanel />
  </div>
);
};

const Dashboard = ({ onNavigate, drivers = [], trucks = [], loads = [], fuelReports = [], iftaReports = [], driverPays = [] }) => {
  const navigate = useNavigate()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [isLoadingDashboard, setIsLoadingDashboard] = useState(true);
const [userSettings, setUserSettings] = useState({});

// --- EMPLOYEES / PAYROLLS ---
const [employees, setEmployees] = useState([]);
const [employeesPayrolls, setEmployeesPayrolls] = useState([]); // [{ name, total }]
// --- DRIVERPAYS (din colectia DriverPay) ---
const [driverPaysAll, setDriverPaysAll] = useState([]);
const [kpiData, setKpiData] = useState({});
const [brokers, setBrokers] = useState([]);
const [selectedItem, setSelectedItem] = useState(null);
const [clientData, setClientData] = useState(null);
const [aiSuggestion, setAiSuggestion] = useState([]);
const [showAIModal, setShowAIModal] = useState(false);
const [isThinking, setIsThinking] = useState(false);
  const [loading, setLoading] = useState(false);
  const [plan, setPlan] = useState("");
  const [open, setOpen] = useState(false);
  const [showStrategyModal, setShowStrategyModal] = useState(false);
const [loadingStrategy, setLoadingStrategy] = useState(false);
const [planText, setPlanText] = useState("");
// === STATE PENTRU DRIVER/TRUCK DETALII ===
const [selectedDriver, setSelectedDriver] = useState(null);
const [selectedTruck, setSelectedTruck] = useState(null);
const [lastLoads, setLastLoads] = useState([]);
const [lastLoad, setLastLoad] = useState(null);

const [routeData, setRouteData] = useState(null);
const [shipperMarker, setShipperMarker] = useState(null);
const [consigneeMarker, setConsigneeMarker] = useState(null);
const [overviewOpen, setOverviewOpen] = useState(false);
const [fuelCostsAggregated, setFuelCostsAggregated] = useState([]);
const [isLoadingFuelAggregated, setIsLoadingFuelAggregated] = useState(true);
const [driverPayAggregated, setDriverPayAggregated] = useState([]);
const [isLoadingDriverPayAggregated, setIsLoadingDriverPayAggregated] = useState(true);

// === derive daysAgo (NU rescrie lastLoad) ===
let daysAgo = null;
if (lastLoad) {
  const loadDate = new Date(lastLoad.createdAt);
  daysAgo = Math.floor(
    (Date.now() - loadDate.getTime()) / (1000 * 60 * 60 * 24)
  );
}

// ✅ Google Maps API key
const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  const [dashboardData, setDashboardData] = useState({
    
    totalDrivers: 0,
    totalTrucks: 0,
    totalLoads: 0,
    totalMiles: 0,
    totalRevenue: 0,
    loadsPerDriver: [],
    loadsPerTruck: [],
    monthlyRevenue: [],
    fuelPerMile: 0,
    topRates: [],
    completeLoads: 0,
    canceledLoads: 0,
    incompleteLoads: 0,
    fuelCosts: [],
    driverPayments: [],
 
  });
  const [progressGoals, setProgressGoals] = useState(() => {
    return JSON.parse(localStorage.getItem("progressGoals")) || [];
  });
  const [goal, setGoal] = useState(50000);
  const [selectedGoal, setSelectedGoal] = useState(null);
  const [newGoalType, setNewGoalType] = useState("monthly");
  const [newGoalValue, setNewGoalValue] = useState(50000);
  const [calendarDate, setCalendarDate] = useState(new Date());
  const [tasks, setTasks] = useState([]);
  const [taskInput, setTaskInput] = useState("");
  const [newTask, setNewTask] = useState("");
  const [tasksByDate, setTasksByDate] = useState({}); // { "YYYY-M-D": [task, ...] }
const [isLoadingTasks, setIsLoadingTasks] = useState(false);
const [kpis, setKpis] = useState([]);
const [showAddModal, setShowAddModal] = useState(false);
const [newWidgetType, setNewWidgetType] = useState(""); // "chart" | "kpi" | "card"
const [charts, setCharts] = useState([]);
const [cards, setCards] = useState([]);
// sus în componentă, lângă celelalte state-uri
const [accountsReceivable, setAccountsReceivable] = useState([]); 

const [showAddTaskModal, setShowAddTaskModal] = useState(false);
const [showEditTaskModal, setShowEditTaskModal] = useState(false);
const [editTask, setEditTask] = useState(null); // task-ul curent pt edit
const [payrolls, setPayrolls] = useState([]);
const [maintenanceReports, setMaintenanceReports] = useState([]);
const [theme, setTheme] = useState(
  () => localStorage.getItem("theme") || sessionStorage.getItem("theme") || "dark"
);
// Formular Add/Edit Task
const [taskForm, setTaskForm] = useState({
  title: "",
  description: "",
  status: "open",
  priority: "medium",
  assignedTo: "",     // ObjectId sau "" (opțional)
});

// util: "2025-1-10"
const toDateKey = (d) => `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}`;
// util: verificare interval lunar curent
const getMonthRange = (date) => {
  const start = new Date(date.getFullYear(), date.getMonth(), 1);
  const end = new Date(date.getFullYear(), date.getMonth()+1, 0);
  // format string exact ca în model (String date)
  const startKey = `${start.getFullYear()}-${start.getMonth()+1}-${1}`;
  const endKey   = `${end.getFullYear()}-${end.getMonth()+1}-${end.getDate()}`;
  return { startKey, endKey };
};
  const [selectedDate, setSelectedDate] = useState(null);
  const [mapCenter, setMapCenter] = useState({ lat: 40.7128, lng: -74.006 });
  const [timeRange, setTimeRange] = useState(""); // By default, show monthly data
  const [customStartDate, setCustomStartDate] = useState(""); 
  const [customEndDate, setCustomEndDate] = useState("");
  const [activeSection, setActiveSection] = useState('dashboard'); // Dashboard implicit
  const [driverPayrolls, setDriverPayrolls] = useState([]);
  const [fuelCostsData, setFuelCostsData] = useState([]);
  const [isLoadingFuelData, setIsLoadingFuelData] = useState(true); // ⬅️ Flag pentru UI
  const [selectedDispatcher, setSelectedDispatcher] = useState(null);
const [modalOpen, setModalOpen] = useState(false);
const [activeLoad, setActiveLoad] = useState(null);
const [dispatchers, setDispatchers] = useState([]);
const [dispatcherTimeRange, setDispatcherTimeRange] = useState("month"); // Default pe lună
const [customDispatcherStartDate, setCustomDispatcherStartDate] = useState(""); 
const [customDispatcherEndDate, setCustomDispatcherEndDate] = useState("");
// calculează nr. de luni între două date
const diffInMonths = (a, b) => (b.getFullYear() - a.getFullYear()) * 12 + (b.getMonth() - a.getMonth());



  const apiUrl = 'https://api-backend.full-trucking-service.com/api'; 
  const token = sessionStorage.getItem("token");
  const clientId = localStorage.getItem('clientId'); 
 
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    withCredentials: true,
  };

  const formatCompact = (num) => {
  if (!num && num !== 0) return "—";
  const n = Number(num);
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(1)}K`;
  return `$${n.toFixed(2)}`;
};

const formatMiles = (num) => {
  const n = Number(num) || 0;
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return n.toFixed(0);
};

const formatMoney = (num) => {
  const n = Number(num) || 0;
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(1)}K`;
  return `$${n.toFixed(2)}`;
};

useEffect(() => {
  const savedTheme = localStorage.getItem("theme") || sessionStorage.getItem("theme") || "dark";
  setTheme(savedTheme);
  
  // ✅ Aplică pe body imediat
  document.body.setAttribute("data-theme", savedTheme);
  document.documentElement.setAttribute("data-theme", savedTheme);
  
  if (savedTheme === "light") {
    document.body.style.background = "#F4F5FB";
    document.documentElement.style.background = "#F4F5FB";
  } else {
    document.body.style.background = "#07070C";
    document.documentElement.style.background = "#07070C";
  }
}, []);

  const [chartTypes, setChartTypes] = useState({
    monthlyRevenue: "Line",
    completeLoads: "Doughnut",
    loadsPerDriver: "Bar",
    loadsPerTruck: "Bar",
    fuelCosts: "Line",
    driverPayrolls: "Bar",
    iftaTaxes: "Pie",
    iftaHistory: "Line",
  newChartKey: "Bar",
  driverPayComparison: "Bar",
  });
  
  const handleChartTypeChange = (chartKey, newType) => {
    setChartTypes(prev => ({ ...prev, [chartKey]: newType }));
  };

  const downloadChartAsPDF = (chartId, chartTitle) => {
    const input = document.getElementById(chartId);
    if (!input) {
    
      return;
    }
  
    html2canvas(input).then(canvas => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.text(chartTitle, 10, 10);
      pdf.addImage(imgData, "PNG", 10, 20, 180, 100);
      pdf.save(`${chartTitle}.pdf`);
    });
  };

  const getCoordinatesFromAddress = async (address) => {
  try {
    const response = await axios.get(
      "https://api-backend.full-trucking-service.com/api/geocode",
      { params: { address } }
    );

    if (response.data.status !== "OK" || !response.data.results.length) {
      return null;
    }

    const location = response.data.results[0].geometry.location;
    return { lat: location.lat, lng: location.lng };
  } catch (err) {
    console.error("❌ Geocoding failed for", address, err);
    return null;
  }
};

useEffect(() => {
  const fetchCoords = async () => {
    if (!lastLoads || lastLoads.length === 0) return;

    const load = lastLoads[0];
    const shipperAddr = load.shippers?.[0]?.address;
    const consigneeAddr = load.consignees?.[0]?.address;

    const shipperCoords = shipperAddr ? await getCoordinatesFromAddress(shipperAddr) : null;
    const consigneeCoords = consigneeAddr ? await getCoordinatesFromAddress(consigneeAddr) : null;

    if (shipperCoords) setMapCenter(shipperCoords); // 📌 centrezi harta pe shipper
    setRouteData({
      route: [shipperCoords, consigneeCoords].filter(Boolean),
    });
  };

  fetchCoords();
}, [lastLoads]);

const fetchLastLoads = async ({ driverId = null, truckId = null }) => {
  try {
    const response = await axios.get(
      `https://api-backend.full-trucking-service.com/api/loads/by-assignment`,
      {
        params: { driverId, truckId },
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (response.status === 200 && Array.isArray(response.data)) {
      const sliced = response.data.slice(0, 10);
      setLastLoads(sliced);
      setLastLoad(sliced.length > 0 ? sliced[0] : null); // ✅ updatează separat
    } else {
      setLastLoads([]);
      setLastLoad(null);
    }
  } catch (error) {
    console.error("❌ Error fetching loads:", error);
    setLastLoads([]);
    setLastLoad(null);
  }
};

useEffect(() => {
  const fetchFuelAggregated = async () => {
    try {
      setIsLoadingFuelAggregated(true);
      const res = await axios.get(
        "https://api-backend.full-trucking-service.com/api/dashboard/fuel-costs-aggregated",
        config
      );
      setFuelCostsAggregated(res.data || []);
    } catch (err) {
      console.error("❌ Failed to fetch aggregated fuel costs:", err);
      setFuelCostsAggregated([]);
    } finally {
      setIsLoadingFuelAggregated(false);
    }
  };

  fetchFuelAggregated();
}, []);

useEffect(() => {
  const fetchDriverPayAggregated = async () => {
    try {
      setIsLoadingDriverPayAggregated(true);
      const res = await axios.get(
        "https://api-backend.full-trucking-service.com/api/dashboard/driverpay-aggregated",
        config
      );
      setDriverPayAggregated(res.data || []);
    } catch (err) {
      console.error("❌ Failed to fetch driverpay aggregated:", err);
      setDriverPayAggregated([]);
    } finally {
      setIsLoadingDriverPayAggregated(false);
    }
  };

  fetchDriverPayAggregated();
}, []);
// când selectezi un șofer
useEffect(() => {
  if (selectedDriver) {
    fetchLastLoads({ driverId: selectedDriver._id });
  }
}, [selectedDriver]);

// când selectezi un camion
useEffect(() => {
  if (selectedTruck) {
    fetchLastLoads({ truckId: selectedTruck._id });
  }
}, [selectedTruck]);

  
  const fetchDispatchers = async () => {
    try {
      const clientId = localStorage.getItem('clientId');
      if (!clientId) {
    
        return;
      }
  
      const response = await axios.get(`${apiUrl}/dispatchers?clientId=${clientId}`, config);
  
      setDispatchers(response.data);
    } catch (error) {
   
    }
  };

  useEffect(() => {
    fetchDashboardData();
    fetchDispatchers();  // ✅ Asigură că se încarcă dispecerii
  }, []);
  
  
  const listDriverPays = useMemo(
  () => (Array.isArray(driverPaysAll) ? driverPaysAll : []),
  [driverPaysAll]
);

const driverPayComparison = useMemo(() => {
  const { startDate, endDate } = getTimeWindowDP(timeRange, customStartDate, customEndDate);

  const totalsByDriver = new Map();
  listDriverPays.forEach((dp) => {
    const s = dp.startDate ? new Date(dp.startDate) : null;
    const e = dp.endDate ? new Date(dp.endDate) : null;
    const created = dp.createdAt ? new Date(dp.createdAt) : null;

    const overlaps = (s && e)
      ? !(e < startDate || s > endDate)
      : (created ? (created >= startDate && created <= endDate) : true);

    if (!overlaps) return;

    const name = resolveDriverName(dp, drivers);
    const val = Number(dp.totalWithAdjustments ?? dp.totalPay ?? 0) || 0;
    totalsByDriver.set(name, (totalsByDriver.get(name) || 0) + val);
  });

  return Array.from(totalsByDriver.entries())
    .map(([name, total]) => ({ name, total }))
    .sort((a, b) => b.total - a.total);
}, [listDriverPays, drivers, timeRange, customStartDate, customEndDate]);

// REPLACE function fetchDriverPaysAll
const fetchDriverPaysAll = async () => {
  const acc = [];
  const limit = 200;  // ≤ hard-cap backend
  let page = 1;

  for (;;) {
    const res = await axios.get(`${apiUrl}/driverpays`, {
      ...config,
      params: { page, limit, raw: 1 }   // raw=1 => backend returnează direct array
    });
    const items = Array.isArray(res.data) ? res.data : [];
    if (!items.length) break;
    acc.push(...items);
    if (items.length < limit) break;    // ultima pagină
    page += 1;
  }

  setDriverPaysAll(acc);
};


useEffect(() => {
  fetchDriverPaysAll();
}, []);

const askAI = async () => {
  setShowAIModal(true);   // ✅ deschide modalul imediat
  setIsThinking(true);    // ✅ arată loader
  setAiSuggestion([]);    // ✅ curăță sugestiile vechi

  try {
    const res = await fetch(`${apiUrl}/ai/dashboard/suggestion`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ kpiData, dashboardData, fuelReports, drivers }),
    });
    const data = await res.json();

    setTimeout(() => { // mic delay să pară că GPT-ul "scrie"
      setAiSuggestion(data.suggestions || []);
      setIsThinking(false);
    }, 1200);
  } catch (err) {
    console.error("AI fetch failed:", err);
    setIsThinking(false);
    setAiSuggestion(["Failed to fetch AI suggestions."]);
  }
};


const parseCurrency = (val) => {
  if (!val) return 0;
  if (typeof val === "number") return val;
  return Number(String(val).replace(/[^0-9.-]+/g, "")); // elimină $, ¢, etc.
};

const calculateKPIData = (
  drivers = [],
  trucks = [],
  loads = [],
  driverPays = [],
  iftaReports = [],
  brokers = [],
  fuelReports = []
) => {


  // === Base counts ===
  const totalDrivers  = drivers?.length || 0;
  const totalTrucks   = trucks?.length || 0;
  const totalDispatch = brokers?.length || 0;

  // === Loads ===
  const totalMiles   = loads.reduce((a, l) => a + (Number(l.miles || 0) + Number(l.dh || 0)), 0);
  const totalRevenue = loads.reduce((a, l) => a + (Number(l.rate || 0)), 0);

const totalPayroll = driverPays.reduce((sum, pay) => {
  if (pay.totalWithAdjustments) return sum + parseCurrency(pay.totalWithAdjustments);
  if (pay.totalPay) return sum + parseCurrency(pay.totalPay);
  return sum;
}, 0);

const fuelFromReports = fuelReports.reduce(
  (sum, r) => sum + parseCurrency(r.grandTotal), 0
);

const totalFuelCosts = iftaReports.reduce(
  (a, f) => a + parseCurrency(f.fuelTaxPaid), 0
);



const totalIftaMiles   = iftaReports.reduce((a, f) => a + parseCurrency(f.milesDriven), 0);
const totalFuelGallons = iftaReports.reduce((a, f) => a + parseCurrency(f.fuelConsumed), 0);

  const totalFuel = fuelFromReports + totalFuelCosts;

  // === Maintenance ===
  const totalMaint = trucks.reduce((sum, t) => {
    if (!t?.serviceHistory?.length) return sum;
    return sum + t.serviceHistory.reduce((s, h) => s + (Number(h.cost) || 0), 0);
  }, 0);

  // === KPI ===
  const utilizationRate = totalTrucks > 0
    ? ((new Set(loads.map(l => String(l.truck))).size / totalTrucks) * 100).toFixed(2)
    : 0;

  const revenuePerTruck  = totalTrucks > 0 ? (totalRevenue / totalTrucks).toFixed(2) : 0;
  const revenuePerDriver = totalDrivers > 0 ? (totalRevenue / totalDrivers).toFixed(2) : 0;

  const totalCosts = totalPayroll + totalMaint + totalFuel;

  const profitMargin = totalRevenue > 0
    ? (((totalRevenue - totalCosts) / totalRevenue) * 100).toFixed(2)
    : 0;

  const operatingRatio = totalRevenue > 0
    ? ((totalCosts / totalRevenue) * 100).toFixed(2)
    : 0;

  const iftaCompliance = iftaReports.length
    ? ((iftaReports.filter(r => r.paidIfta === "Yes").length / iftaReports.length) * 100).toFixed(2)
    : 0;

  const driverTurnover = drivers.length
    ? ((drivers.filter(d => d.notMoreWorking && d.notMoreWorkingTime).length / drivers.length) * 100).toFixed(2)
    : 0;

  const payPerMile = totalMiles > 0 ? (totalPayroll / totalMiles).toFixed(2) : 0;
  const maintCostPerMile = totalMiles > 0 ? (totalMaint / totalMiles).toFixed(2) : 0;
  const fuelEfficiency = totalFuelGallons > 0 ? (totalIftaMiles / totalFuelGallons).toFixed(2) : 0;

  const nextServiceDue = trucks.length
    ? Math.min(...trucks.map(t => ((t.nextServiceMiles || 0) - (t.miles || 0)) || Infinity))
    : 0;

  const topClients = loads.length
    ? Object.entries(
        loads.reduce((acc, l) => {
          const name = l.brokerName || l.clientName || "Unknown";
          acc[name] = (acc[name] || 0) + (Number(l.rate || 0));
          return acc;
        }, {})
      ).sort((a, b) => b[1] - a[1]).slice(0, 5)
    : [];

  const repeatLoads = loads.length
    ? (() => {
        const byClient = {};
        loads.forEach(l => {
          const name = l.brokerName || l.clientName || "Unknown";
          byClient[name] = (byClient[name] || 0) + 1;
        });
        const repeat = Object.values(byClient).filter(c => c > 1).length;
        return ((repeat / Object.keys(byClient).length) * 100).toFixed(2);
      })()
    : 0;

  const loadsPerDispatcher = totalDispatch > 0
    ? (loads.length / totalDispatch).toFixed(2)
    : 0;

  const revenuePerDispatcher = totalDispatch > 0
    ? (totalRevenue / totalDispatch).toFixed(2)
    : 0;

  return {
    utilizationRate,
    revenuePerTruck,
    revenuePerDriver,
    profitMargin,
    operatingRatio,
    iftaCompliance,
    driverTurnover,
    payPerMile,
    maintCostPerMile,
    fuelEfficiency,
    nextServiceDue,
    topClients,
    repeatLoads,
    loadsPerDispatcher,
    revenuePerDispatcher,
  };
};


useEffect(() => {
  const hasData =
    (drivers?.length || 0) > 0 ||
    (trucks?.length || 0) > 0 ||
    (loads?.length || 0) > 0 ||
    (driverPaysAll?.length || 0) > 0 ||
    (iftaReports?.length || 0) > 0 ||
    (brokers?.length || 0) > 0 ||
    (fuelCostsData?.length || 0) > 0;

  if (hasData) {
    const kpiResult = calculateKPIData(
      drivers,
      trucks,
      loads,
      driverPaysAll,
      iftaReports,
      brokers,
      fuelCostsData
    );
    setKpiData(kpiResult);
  }
}, [drivers, trucks, loads, driverPaysAll, iftaReports, brokers, fuelCostsData]);


  const fetchEmployees = async () => {
  try {
    const res = await axios.get(`${apiUrl}/employees`, config);
    setEmployees(res.data || []);
  } catch (e) {
    setEmployees([]);
  }
};

useEffect(() => {
  fetchEmployees();
}, []);

const generatePlan = async () => {
  setLoadingStrategy(true);
  setPlanText("");
  try {
    const res = await axios.post(
      `${apiUrl}/ai/dashboard/strategie`,
      {}, // ← gol! backend fetch-uiește singur din DB
      config  // ← config cu Authorization header
    );
    setPlanText(res.data.plan || "");
  } catch (err) {
    console.error("AI fetch error", err);
    setPlanText("Failed to generate strategy. Please try again.");
  }
  setLoadingStrategy(false);
};

const downloadPDFStrategy = async (clientId) => {
  try {
    const res = await fetch(
      `https://api-backend.full-trucking-service.com/api/ai/dashboard/downloadStrategie?clientId=${clientId}`
    );

    if (!res.ok) throw new Error("Failed to fetch strategy");

    const data = await res.json();

    if (!data.plan) {
      alert("No strategy found!");
      return;
    }

    const doc = new jsPDF();

    // === HEADER simplu ===
    const addHeader = () => {
      doc.setFontSize(14);
      doc.text("AI Strategy Plan", 105, 20, { align: "center" });
    };

    // === FOOTER simplu ===
    const addFooter = () => {
      const pageHeight = doc.internal.pageSize.height;
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFontSize(8);
      doc.text(`Page ${pageCount}`, 10, pageHeight - 10);
      doc.text(
        "Generated by Full Trucking Service",
        105,
        pageHeight - 10,
        { align: "center" }
      );
    };

    addHeader();

    let startY = 40;

    // === Împărțim textul în linii pt PDF ===
    const lines = doc.splitTextToSize(data.plan, 180);

    doc.autoTable({
      startY,
      body: lines.map((line) => [line]),
      theme: "plain",
      styles: { fontSize: 10, textColor: "#000000", cellPadding: 2 },
      columnStyles: { 0: { halign: "left" } },
    });

    addFooter();

    // ✅ Salvăm PDF-ul
    doc.save("ai-strategy-plan.pdf");
  } catch (err) {
    console.error("PDF Download Error:", err);
  }
};

const getTimeWindow = () => {
  const now = new Date();
  let startDate = new Date(0); // all-time fallback
  let endDate = new Date();

  if (!timeRange) {
    // all time
    startDate = new Date(0);
  } else if (timeRange === "custom" && customStartDate && customEndDate) {
    startDate = new Date(customStartDate);
    endDate = new Date(customEndDate);
  } else {
    startDate = new Date();
    endDate = new Date();
    switch (timeRange) {
      case "day":
        // azi deja ok
        break;
      case "week":
        startDate.setDate(endDate.getDate() - 7);
        break;
      case "month":
        startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        break;
      case "year":
        startDate = new Date(now.getFullYear(), 0, 1);
        break;
      default:
        startDate = new Date(0);
    }
  }
  return { startDate, endDate };
};


const computeEmployeesPayrolls = useCallback(() => {
  const { startDate, endDate } = getTimeWindow();

  const rows = (employees || []).map(emp => {
    const fullName =
      `${emp.firstName || ""} ${emp.lastName || ""}`.trim() || (emp.email || "Unnamed");

    const sum = (emp.payrolls || []).reduce((acc, p) => {
      // filtrare după intervalul selectat
      const s = p.startDate ? new Date(p.startDate) : null;
      const e = p.endDate ? new Date(p.endDate) : null;

      // Dacă am ambele capete, folosim overlap logic cel mai sigur
      // (payroll intersectează fereastra [startDate, endDate])
      const overlaps =
        (s && e)
          ? !(e < startDate || s > endDate)
          : // dacă nu avem ambele date, permităm intrarea dacă createdAt e în interval
            (p.createdAt ? (new Date(p.createdAt) >= startDate && new Date(p.createdAt) <= endDate) : true);

      if (!overlaps) return acc;

      // alegem o valoare pentru payroll:
      const val = Number(p.total ?? p.gross ?? 0) || 0;
      return acc + val;
    }, 0);

    return { name: fullName, total: sum };
  });

  // poți ordona desc după total ca să fie mai clar:
  rows.sort((a, b) => b.total - a.total);

  setEmployeesPayrolls(rows);
}, [employees, timeRange, customStartDate, customEndDate]);

useEffect(() => {
  computeEmployeesPayrolls();
}, [computeEmployeesPayrolls]);


  const fetchDashboardData = async () => {
    try {
      setIsLoadingDashboard(true);
      const response = await axios.get("https://api-backend.full-trucking-service.com/api/dashboard", {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        withCredentials: true,
      });
  
    if (response.data) {
  setTasks((response.data.tasks || []).reduce((acc, task) => {
    acc[task.date] = task.tasks;
    return acc;
  }, {}));

  // 🔧 Normalizare goals ca să avem mereu id/type/value/progress
  const normalizedGoals = (response.data.goals || []).map((g) => ({
    id: String(g.id ?? g._id ?? g.goalId ?? ""),   // id sigur (string)
    type: g.type ?? "custom",
    value: Number(g.value) || 0,
    progress: Number(g.progress) || 0,
    _raw: g, // îl păstrăm în caz că îți trebuie
  }));

  setProgressGoals(normalizedGoals);
}

} catch (error) {
    // poți loga dacă vrei
  } finally {
    setIsLoadingDashboard(false); // 🟢 oprește loader
  }
};
useEffect(() => {
  if (!selectedGoal && progressGoals.length > 0) {
    setSelectedGoal(progressGoals[0]);
  }
}, [progressGoals]); // 🔹 scos `selectedGoal` din dependențe

const statusOptions = [
  { value: "open", label: "open" },
  { value: "in_progress", label: "in_progress" },
  { value: "done", label: "done" },
  { value: "canceled", label: "canceled" },
];
  const fetchDriverLoadStatus = async (driverId) => {
    try {
        const response = await axios.get(`${apiUrl}/loads/incomplete`, config);

        if (!response.data || response.data.length === 0) {
            setActiveLoad({ message: "No active load", lastLoadTime: "No data" });
            return;
        }

        // Filtrăm doar încărcăturile șoferului
        const driverLoads = response.data.filter(load => load.driver === driverId);

        if (driverLoads.length > 0) {
            setActiveLoad(driverLoads[0]);
            return;
        }

        // Preluăm toate încărcăturile pentru șofer
        const completedLoadsResponse = await axios.get(`${apiUrl}/loads`, config);

        if (!completedLoadsResponse.data || completedLoadsResponse.data.length === 0) {
            setActiveLoad({ message: "No loads history", lastLoadTime: "No data" });
            return;
        }

        // Selectăm doar încărcăturile finalizate sau anulate ale șoferului
        const completedLoads = completedLoadsResponse.data.filter(
            load => load.driver === driverId && ["Completed", "Cancelled"].includes(load.status)
        );

        if (completedLoads.length === 0) {
            setActiveLoad({ message: "No loads history", lastLoadTime: "No data" });
            return;
        }

        // Găsim cel mai recent load bazat pe `createdAt`
        const lastCompletedLoad = completedLoads.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        )[0];

        // Calculăm diferența de zile între `createdAt` și data actuală
        const lastLoadDate = new Date(lastCompletedLoad.createdAt);
        const today = new Date();
        const timeDiff = Math.floor((today - lastLoadDate) / (1000 * 60 * 60 * 24));

        setActiveLoad({ 
            message: "No active load", 
            lastLoadTime: timeDiff > 0 ? timeDiff : "Today"
        });

    } catch (error) {
      
        setActiveLoad({ message: "Error fetching data", lastLoadTime: "No data" });
    }
};


  const fetchFuelReportDashboard = async () => {
    try {
      setIsLoadingFuelData(true); // 🔄 Pornim indicatorul de încărcare
    
  
      const response = await axios.get(`${apiUrl}/fuel-reports`, config);
      
  
      if (!response.data || response.data.length === 0) {
        console.warn("No fuel reports found in database.");
        setIsLoadingFuelData(false);
        return;
      }
  
      if (!clientId) {

        setIsLoadingFuelData(false);
        return;
      }
  
      // 🔥 Filtrăm doar rapoartele pentru clientul curent
      const clientFuelReports = response.data.filter(
        report => report.clientId?.toString() === clientId.toString()
      );
  
   
  
      if (clientFuelReports.length === 0) {
        console.warn(" No fuel reports found for this client.");
        setIsLoadingFuelData(false);
        return;
      }
  
      // 🔥 Grupăm datele pentru chart
      const fuelData = clientFuelReports.reduce((acc, report) => {
        const date = new Date(report.createdAt).toLocaleDateString();
        if (!acc[date]) {
          acc[date] = { date, fuelSubtotal: 0, otherCosts: 0, grandTotal: 0 };
        }
  
        acc[date].fuelSubtotal += parseFloat(report.fuelSubtotal) || 0;
        acc[date].otherCosts += parseFloat(report.otherCosts) || 0;
        acc[date].grandTotal += parseFloat(report.grandTotal) || 0;
        return acc;
      }, {});
  
      const formattedFuelReports = Object.values(fuelData).sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );
  

  
      setFuelCostsData(formattedFuelReports); // ✅ Setăm datele DOAR dacă avem rezultate
      setIsLoadingFuelData(false);
      
    } catch (error) {
      
      setIsLoadingFuelData(false);
    }
  };
  
  // ✅ Apelăm doar dacă există `clientId`
  useEffect(() => {
    if (clientId) {
      fetchFuelReportDashboard();
    }
  }, [clientId]);
  

  
  const fetchDriverPayrolls = async () => {
    try {
      const response = await axios.get(`${apiUrl}/totalpays`, config);
  
      if (response.status === 200) {
     
  
        if (response.data.length === 0) {
          console.warn("No payroll data found in TotalPay collection");
        }
  
        // Grupăm plățile per șofer
        const payrollData = response.data.reduce((acc, pay) => {
          if (!pay.driverId) return acc;
          const driverName = `${pay.driverId.firstName} ${pay.driverId.lastName}`;
  
          if (!acc[driverName]) {
            acc[driverName] = 0;
          }
  
          acc[driverName] += pay.totalWithAdjustments;
          return acc;
        }, {});
  
       
  
        // Convertim în array pentru chart
        setDriverPayrolls(Object.keys(payrollData).map(name => ({
          name,
          total: payrollData[name]
        })));
      }
    } catch (error) {
   
    }
  };

  useEffect(() => {
    if (drivers.length > 0) {
      fetchDriverPayrolls();
    }
  }, [drivers]);
  

  const openDispatcherModal = (dispatcher) => {
    setSelectedDispatcher(dispatcher);
    setModalOpen(true);
  };
  
  const closeDispatcherModal = () => {
    setSelectedDispatcher(null);
    setModalOpen(false);
    setActiveLoad(null); // 📌 Resetăm și statusul load-ului
  };
  
  // Definim intervalul de timp selectat pentru DISPECERI
let dispatcherStartDate = new Date();
let dispatcherEndDate = new Date();

if (dispatcherTimeRange !== "custom") {
  switch (dispatcherTimeRange) {
    case "week":
      dispatcherStartDate.setDate(dispatcherEndDate.getDate() - 7);
      break;
    case "month":
      dispatcherStartDate.setDate(1);
      break;
    case "year":
      dispatcherStartDate = new Date(dispatcherEndDate.getFullYear(), 0, 1);
      break;
  }
} else if (customDispatcherStartDate && customDispatcherEndDate) {
  dispatcherStartDate = new Date(customDispatcherStartDate);
  dispatcherEndDate = new Date(customDispatcherEndDate);
}

  
  const fetchActiveLoad = async (entityId, type) => {
    try {
      const response = await axios.get(`${apiUrl}/loads/active?${type}Id=${entityId}`, config);
      if (response.data) {
        setActiveLoad(response.data);
      } else {
        setActiveLoad(null);
      }
    } catch (error) {
    
      setActiveLoad(null);
    }
  };

  const addNewGoal = async () => {
    if (!clientId || !newGoalType || !newGoalValue) return;
    try {
      const response = await axios.post(
        `${apiUrl}/dashboard/goals`,
        { type: newGoalType, value: newGoalValue, startDate: customStartDate, endDate: customEndDate },
        config
      );
  
      if (response.status === 201) {
     
        fetchDashboardData(); // 🔹 Actualizează dashboard-ul
      }
    } catch (error) {

    }
  };
  
  
  const updateProgress = async (goalId, value) => {
    if (!clientId) return;
    try {
      const response = await axios.post(`${apiUrl}/dashboard/goals/update`, {
        clientId,
        goalId,
        progress: value,
      }, config);
  
      if (response.data) {
        fetchDashboardData();
      }
    } catch (error) {
      
    }
  };
  
  // ===== TASKS API =====

// Fetch pe luna din calendar (pentru toate zilele)
const fetchTasksForMonth = async () => {
  try {
    setIsLoadingTasks(true);
    const { startKey, endKey } = getMonthRange(calendarDate);
    const res = await axios.get(`${apiUrl}/tasks?from=${startKey}&to=${endKey}`, config);

    const items = res.data?.items || res.data || []; // suportă ambele
    // grupăm pe date
    const grouped = items.reduce((acc, t) => {
      const k = t.date || "";
      if (!acc[k]) acc[k] = [];
      acc[k].push(t);
      return acc;
    }, {});
    setTasksByDate(grouped);
  } catch (err) {
    // console.error('fetchTasksForMonth', err);
  } finally {
    setIsLoadingTasks(false);
  }
};

// Create
const createTask = async () => {
  if (!selectedDate || !taskForm.title.trim()) return;
  try {
    setIsLoadingTasks(true);
    const payload = {
      title: taskForm.title.trim(),
      description: (taskForm.description || "").trim(),
      status: taskForm.status,
      priority: taskForm.priority,
      assignedTo: taskForm.assignedTo || null,
      date: selectedDate, // cheia tip "YYYY-M-D"
    };
    const res = await axios.post(`${apiUrl}/tasks`, payload, config);
    // reîncarcă luna
    await fetchTasksForMonth();
    setShowAddTaskModal(false);
    setTaskForm({ title: "", description: "", status: "open", priority: "medium", assignedTo: "" });
  } catch (err) {
    // console.error('createTask', err);
  } finally {
    setIsLoadingTasks(false);
  }
};

// Update “status” rapid din listă
const updateTaskStatus = async (taskId, newStatus) => {
  try {
    setIsLoadingTasks(true);
    await axios.put(`${apiUrl}/tasks/${taskId}`, { status: newStatus }, config);
    await fetchTasksForMonth();
  } catch (err) {
    // console.error('updateTaskStatus', err);
  } finally {
    setIsLoadingTasks(false);
  }
};

// Open edit modal (prefill)
const startEditTask = (task) => {
  setEditTask(task);
  setTaskForm({
    title: task.title || "",
    description: task.description || "",
    status: task.status || "open",
    priority: task.priority || "medium",
    assignedTo: task.assignedTo?._id || task.assignedTo || "",
  });
  setShowEditTaskModal(true);
};

// Confirm edit (PUT)
const saveEditTask = async () => {
  if (!editTask?._id) return;
  try {
    setIsLoadingTasks(true);
    await axios.put(`${apiUrl}/tasks/${editTask._id}`, {
      title: taskForm.title,
      description: taskForm.description,
      status: taskForm.status,
      priority: taskForm.priority,
      assignedTo: taskForm.assignedTo || null,
      date: editTask.date, // data nu se schimbă în acest flux
    }, config);
    await fetchTasksForMonth();
    setShowEditTaskModal(false);
    setEditTask(null);
  } catch (err) {
    // console.error('saveEditTask', err);
  } finally {
    setIsLoadingTasks(false);
  }
};

// Delete
const deleteTask = async (taskId) => {
  try {
    setIsLoadingTasks(true);
    await axios.delete(`${apiUrl}/tasks/${taskId}`, config);
    await fetchTasksForMonth();
    setShowEditTaskModal(false);
    setEditTask(null);
  } catch (err) {
    // console.error('deleteTask', err);
  } finally {
    setIsLoadingTasks(false);
  }
};


  useEffect(() => {
    const savedTasks = JSON.parse(localStorage.getItem("tasks")) || {};
    setTasks(savedTasks);
  }, []);

  useEffect(() => {
    localStorage.setItem("tasks", JSON.stringify(tasks));
  }, [tasks]);

  const getDaysInMonth = () => {
    const year = calendarDate.getFullYear();
    const month = calendarDate.getMonth();
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfMonth = () => {
    const year = calendarDate.getFullYear();
    const month = calendarDate.getMonth();
    return new Date(year, month, 1).getDay();
  };

  const handlePrevMonth = () => {
    setCalendarDate((prev) => new Date(prev.getFullYear(), prev.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCalendarDate((prev) => new Date(prev.getFullYear(), prev.getMonth() + 1, 1));
  };

  const handleDateClick = (date) => {
    setSelectedDate(date);
  };

  useEffect(() => {
  fetchTasksForMonth();
}, [calendarDate]); // reîncarcă task-urile când user-ul schimbă luna

  const handleTaskAdd = async () => {
    if (!clientId || !newTask || !selectedDate) return;
    try {
      const response = await axios.post(
        `${apiUrl}/dashboard/tasks`,
        { date: selectedDate, task: newTask },
        config
      );
  
      if (response.status === 201) {
       
        setNewTask(""); // 🔹 Golește input-ul după adăugare
        fetchDashboardData(); // 🔹 Actualizează dashboard-ul cu datele noi
      }
    } catch (error) {
      
    }
  };
  
  
const renderCalendarDays = () => {
  const totalDays = getDaysInMonth();
  const firstDayIndex = getFirstDayOfMonth();
  const days = [];

  const today = new Date();
  const todayKey = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;

  for (let i = 0; i < firstDayIndex; i++) {
    days.push(
      <div key={`empty-${i}`} className={styles.emptyultimatedashboardoverview}></div>
    );
  }

  for (let day = 1; day <= totalDays; day++) {
    const dateKey = `${calendarDate.getFullYear()}-${calendarDate.getMonth() + 1}-${day}`;
    const taskList = tasksByDate[dateKey] || [];

    // ✅ doar taskuri active (nu done/canceled)
    const hasActiveTasks = taskList.some(
      (t) => t.status !== "done" && t.status !== "canceled"
    );

    days.push(
      <div
        key={day}
        className={[
          styles.day,
          hasActiveTasks ? styles.taskDay : "",
          dateKey === todayKey ? styles.todayDay : "",
          selectedDate === dateKey ? styles.selectedDay : "",
        ].join(" ")}
        onClick={() => handleDateClick(dateKey)}
      >
        <span>{day}</span>
        {/* ❌ scos complet <p>{taskList.length} tasks</p> */}
      </div>
    );
  }

  return days;
};




  useEffect(() => {
    if (drivers.length && trucks.length && loads.length) {
      calculateDashboardData();
    }
  }, [drivers, trucks, loads, fuelReports, iftaReports, driverPays, timeRange, customStartDate, customEndDate]);  
  const calculateDashboardData = () => {
    if (!loads || loads.length === 0) {
        console.warn(" No load data available, setting default values.");
        setDashboardData((prevData) => ({
            ...prevData,
            completeLoads: 0,
            canceledLoads: 0,
            incompleteLoads: 0,
            totalDrivers: 0,
            totalTrucks: 0,
            totalLoads: 0,
            totalMiles: 0,
            totalRevenue: 0,
            loadsPerDriver: [],
            loadsPerTruck: [],
            monthlyRevenue: { labels: [], values: [] },
        }));
        return;
    }


    const now = new Date();
    let filteredLoads = [...loads];


    const driverLastLoad = {};
    loads.forEach(load => {
        if (load.status?.toLowerCase() === "complete" && load.driver) {
            const loadDate = new Date(load.deliveryTime || load.shippers?.[0]?.deliveryTime || load.createdAt);
            if (!driverLastLoad[load.driver] || loadDate > driverLastLoad[load.driver]) {
                driverLastLoad[load.driver] = loadDate;
            }
        }
    });
  
let startDate = new Date();
let endDate = new Date();

const getLoadDate = (load) =>
  new Date(load.date || load?.shippers?.[0]?.pickUpTime || load.createdAt);

if (!timeRange) {
  // All Time → ia de la primul load până la ultimul
  filteredLoads = [...loads];
  const allDates = loads.map(getLoadDate).filter(d => !isNaN(d));
  if (allDates.length) {
    startDate = new Date(Math.min(...allDates));
    endDate   = new Date(Math.max(...allDates));
  } else {
    startDate = new Date(0);
    endDate   = new Date();
  }
} else if (timeRange === "custom" && customStartDate && customEndDate) {
  startDate = new Date(customStartDate);
  endDate   = new Date(customEndDate);
  filteredLoads = loads.filter(load => {
    const ld = getLoadDate(load);
    return ld >= startDate && ld <= endDate;
  });
} else {
  const now = new Date();
  startDate = new Date();
  endDate   = new Date();
  switch (timeRange) {
    case "day": break;
    case "week": startDate.setDate(now.getDate() - 7); break;
    case "month": startDate = new Date(now.getFullYear(), now.getMonth(), 1); break;
    case "year":  startDate = new Date(now.getFullYear(), 0, 1); break;
  }
  filteredLoads = loads.filter(load => {
    const ld = getLoadDate(load);
    return ld >= startDate && ld <= endDate;
  });
}

// ✅ calculează spanOverYear **după** ce ai setat corect ferestrele
const today = new Date();
const clampedEnd = endDate > today ? today : endDate; // nu trecem în viitor
const spanOverYear = !timeRange && diffInMonths(startDate, clampedEnd) > 12;

// ✅ generează etichetele
const revenueData = {};
if (!timeRange) {
  if (spanOverYear) {
    // pe ani
    let current = new Date(startDate.getFullYear(), 0, 1);
    const last  = new Date(clampedEnd.getFullYear(), 0, 1);
    while (current <= last) {
      revenueData[String(current.getFullYear())] = 0;
      current.setFullYear(current.getFullYear() + 1);
    }
  } else {
    // pe luni
    let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    const last  = new Date(clampedEnd.getFullYear(), clampedEnd.getMonth(), 1);
    while (current <= last) {
      const label = current.toLocaleString("en-US", { month: "short", year: "numeric" });
      revenueData[label] = 0;
      current.setMonth(current.getMonth() + 1);
    }
  }
} else {
  // păstrezi logica ta existentă (dacă vrei, poți optimiza “year” să avanseze lună cu lună)
  let current = new Date(startDate);
  while (current <= endDate) {
    let label;
    switch (timeRange) {
      case "day":
        label = current.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
        current.setHours(current.getHours() + 1);
        break;
      case "week":
        label = current.toLocaleDateString("en-US", { weekday: "short", day: "numeric", month: "short" });
        current.setDate(current.getDate() + 1);
        break;
      case "month":
        label = `Week ${Math.ceil(current.getDate() / 7)} ${current.toLocaleString("en-US", { month: "short" })}`;
        current.setDate(current.getDate() + 1);
        break;
      case "year":
        label = current.toLocaleString("en-US", { month: "short", year: "numeric" });
        // 👉 pentru year e mai corect să avansezi cu o lună:
        current.setMonth(current.getMonth() + 1);
        break;
    }
    revenueData[label] = 0;
  }
}
filteredLoads.forEach(load => {
  const ld = getLoadDate(load);
  if (isNaN(ld)) return;

  let label;
  if (!timeRange) {
    label = spanOverYear
      ? String(ld.getFullYear())
      : ld.toLocaleString("en-US", { month: "short", year: "numeric" });
  } else {
    switch (timeRange) {
      case "day":
        label = ld.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
        break;
      case "week":
        label = ld.toLocaleDateString("en-US", { weekday: "short", day: "numeric", month: "short" });
        break;
      case "month":
        label = `Week ${Math.ceil(ld.getDate() / 7)} ${ld.toLocaleString("en-US", { month: "short" })}`;
        break;
      case "year":
        label = ld.toLocaleString("en-US", { month: "short", year: "numeric" });
        break;
      default:
        return; // ❗️nu mai băgăm în "Unknown"
    }
  }
  revenueData[label] = (revenueData[label] || 0) + (parseFloat(load.rate) || 0);
});

    // 🔹 Calculăm metricile DOAR pentru încărcăturile filtrate
    const totalDrivers = drivers.length;
    const totalTrucks = trucks.length;
    const totalLoads = filteredLoads.length;
    const totalMiles = filteredLoads.reduce((acc, load) => acc + (parseFloat(load.miles) || 0), 0);
    const totalRevenue = filteredLoads.reduce((acc, load) => acc + (parseFloat(load.rate) || 0), 0);
// 🔹 Revenue per Mile
const revenuePerMile = totalMiles > 0 ? totalRevenue / totalMiles : 0;

    const loadsPerDriver = drivers.map(driver => ({
        name: `${driver.firstName} ${driver.lastName}`,
        count: filteredLoads.filter(load => load.driver === driver._id).length,
    }));

    const loadsPerTruck = trucks.map(truck => ({
        name: truck.truckNumber,
        count: filteredLoads.filter(load => load.truck === truck._id).length,
    }));

// 🔹 Grupare load-uri pe zile
const loadsByDate = filteredLoads.reduce((acc, load) => {
  const date = new Date(load.createdAt).toLocaleDateString();
  if (!acc[date]) {
    acc[date] = { date, totalRevenue: 0, totalMiles: 0 };
  }
  acc[date].totalRevenue += parseFloat(load.rate) || 0;
  acc[date].totalMiles += parseFloat(load.miles) || 0;
  return acc;
}, {});

// 🔹 Convertim în array sortat
const loadsByDateArray = Object.values(loadsByDate).sort(
  (a, b) => new Date(a.date) - new Date(b.date)
);

    // 🔹 Compare Dispatchers Chart Data
const dispatcherStats = [];

dispatchers.forEach(dispatcher => {
    const dispatcherLoads = filteredLoads.filter(load => load.dispatcher === dispatcher._id);
    const totalRevenue = dispatcherLoads.reduce((acc, load) => acc + (parseFloat(load.rate) || 0), 0);

    dispatcherStats.push({
        name: `${dispatcher.firstName} ${dispatcher.lastName}`,
        loadCount: dispatcherLoads.length,
        totalRevenue
    });
});



    // ETA Delay Tracker
const avgTruckSpeed = 55; // mph - viteză medie estimată
let totalDelayHours = 0;
let delayCount = 0;

filteredLoads.forEach(load => {
    const pickup = new Date(load.shippers?.[0]?.pickUpTime || load.pickUpTime);
    const delivery = new Date(load.shippers?.[0]?.deliveryTime || load.deliveryTime);
    const miles = parseFloat(load.miles) || 0;

    if (!isNaN(pickup) && !isNaN(delivery) && miles > 0) {
        const plannedHours = (delivery - pickup) / (1000 * 60 * 60); // în ore
        const theoreticalHours = miles / avgTruckSpeed; // în ore

        const delay = plannedHours - theoreticalHours; // ore
        totalDelayHours += delay;
        delayCount++;
    }
});

const averageDelayHours = delayCount > 0 ? totalDelayHours / delayCount : 0;

// 🔹 Adăugăm în dashboardData

    // 🔹 Calculăm Dispatch Efficiency per dispatcher
const dispatchEfficiency = dispatchers.map(dispatcher => {
  const loadsAssigned = filteredLoads.filter(load => load.dispatcher === dispatcher._id).length;
  const efficiency = totalDrivers > 0 ? ((loadsAssigned / totalDrivers) * 100).toFixed(2) : 0;

  return {
    name: `${dispatcher.firstName} ${dispatcher.lastName}`,
    loadsAssigned,
    efficiency: parseFloat(efficiency)
  };
});


    // 🔹 Calculează performanța șoferilor
const driverPerformance = drivers.map(driver => {
    const driverLoads = filteredLoads.filter(load => load.driver === driver._id && load.status?.toLowerCase() === "completed");
    const totalRevenue = driverLoads.reduce((acc, load) => acc + (parseFloat(load.rate) || 0), 0);
    return {
        name: `${driver.firstName} ${driver.lastName}`,
        totalRevenue,
        completedLoads: driverLoads.length
    };
});

// 🔹 Calculează pentru camioane
const truckPerformance = trucks.map(truck => {
    const truckLoads = filteredLoads.filter(load => load.truck === truck._id && load.status?.toLowerCase() === "completed");
    const totalRevenue = truckLoads.reduce((acc, load) => acc + (parseFloat(load.rate) || 0), 0);
    return {
        name: truck.truckNumber,
        totalRevenue,
        completedLoads: truckLoads.length
    };
});

// 🔹 Sortează și ia top 3
const topDriversByRevenue = [...driverPerformance].sort((a, b) => b.totalRevenue - a.totalRevenue).slice(0, 3);
const topDriversByLoads = [...driverPerformance].sort((a, b) => b.completedLoads - a.completedLoads).slice(0, 3);

const topTrucksByRevenue = [...truckPerformance].sort((a, b) => b.totalRevenue - a.totalRevenue).slice(0, 3);
const topTrucksByLoads = [...truckPerformance].sort((a, b) => b.completedLoads - a.completedLoads).slice(0, 3);



    const validLoads = filteredLoads.map(load => {
        let formattedDate = "Unknown Date";

        // Verificăm mai multe surse pentru data încărcăturii
        const potentialDate = load.date || load.shippers?.[0]?.pickUpTime || load.createdAt;

        if (potentialDate) {
            const dateObj = new Date(potentialDate);
            if (!isNaN(dateObj.getTime())) {
                formattedDate = dateObj.toLocaleString("en-US", { month: "short", year: "numeric" });
            } else {
                console.warn(" Invalid date detected:", potentialDate);
            }
        }

        return {
            ...load,
            rate: !load.rate || isNaN(parseFloat(load.rate)) ? 0 : parseFloat(load.rate),
            date: formattedDate
        };
    });

    const monthlyRevenue = validLoads.reduce((acc, load) => {
        acc[load.date] = (acc[load.date] || 0) + load.rate;
        return acc;
    }, {});

    const fuelCosts = fuelReports.map(report => ({
      date: new Date(report.createdAt).toLocaleDateString(),
      total: report.grandTotal || 0,
      fuel: report.fuelSubtotal || 0,
      other: report.otherCosts || 0
    }));

    // 🔹 Calculăm plățile pentru șoferi
    const driverPayments = driverPays.map(pay => ({
      driver: `${pay.driver?.firstName || "No data"} ${pay.driver?.lastName || ""}`,
      totalPay: pay.totalPay || 0
    }));
// ---- PROFIT METRICS ----

// total fuel costs (din fuelReports map-uit mai sus în `fuelCosts`)
const totalFuelCosts = fuelCosts.reduce((acc, r) => acc + (parseFloat(r.total) || 0), 0);

// total driver pay (din driverPayments map-uit chiar mai sus)
const totalDriverPay = driverPayments.reduce((acc, p) => acc + (parseFloat(p.totalPay) || 0), 0);

// profit estimat pe întreg intervalul selectat
const estimatedProfit = totalRevenue - totalFuelCosts - totalDriverPay;
const bucketLabel = (dateObj) => {
  if (!timeRange) {
    // All Time
    return spanOverYear
      ? String(dateObj.getFullYear())                                         // ➜ ani
      : dateObj.toLocaleString("en-US", { month: "short", year: "numeric" }); // ➜ luni
  }

  switch (timeRange) {
    case "day":
      return dateObj.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
    case "week":
      return dateObj.toLocaleDateString("en-US", { weekday: "short", day: "numeric", month: "short" });
    case "month":
      return `Week ${Math.ceil(dateObj.getDate() / 7)} ${dateObj.toLocaleString("en-US", { month: "short" })}`;
    case "year":
      return dateObj.toLocaleString("en-US", { month: "short", year: "numeric" });
    default:
      return dateObj.toLocaleString("en-US", { month: "short", year: "numeric" });
  }
};


// agregăm fuel pe același set de label-uri ca revenueData
const labels = Object.keys(revenueData);
const fuelByLabel = Object.fromEntries(labels.map(l => [l, 0]));

fuelReports.forEach(report => {
  const d = new Date(report.createdAt);
  const l = bucketLabel(d);
  if (l in fuelByLabel) {
    fuelByLabel[l] += parseFloat(report.grandTotal || report.total || 0) || 0;
  }
});

// Notă: driverPays nu are date per plată; distribuim egal totalDriverPay pe numărul de etichete
const driverPayPerLabel = labels.length ? (totalDriverPay / labels.length) : 0;

// calculăm profit în timp pe aceleași etichete
const profitValues = labels.map(l => {
  const rev = revenueData[l] || 0;
  const fuel = fuelByLabel[l] || 0;
  return rev - fuel - driverPayPerLabel;
});


    const completeLoads = filteredLoads.filter(load => load.status?.toLowerCase() === "completed").length;
    const canceledLoads = filteredLoads.filter(load => 
      load.status?.toLowerCase() === "cancelled" || load.status?.toLowerCase() === "canceled"
  ).length;
  
   const incompleteLoads = filteredLoads.filter(load => 
    load.status && !["completed", "canceled", "cancelled"].includes(load.status.toLowerCase())
).length;
    setDashboardData({
      fuelCosts,
      driverPayments,
      totalDrivers: drivers.length,
      totalTrucks: trucks.length,
      totalLoads: filteredLoads.length,
      totalMiles: filteredLoads.reduce((acc, load) => acc + (parseFloat(load.miles) || 0), 0),
      totalRevenue: filteredLoads.reduce((acc, load) => acc + (parseFloat(load.rate) || 0), 0),
      loadsPerDriver: drivers.map(driver => ({
          name: `${driver.firstName} ${driver.lastName}`,
          count: filteredLoads.filter(load => load.driver === driver._id).length,
      })),
      loadsPerTruck: trucks.map(truck => ({
          name: truck.truckNumber,
          count: filteredLoads.filter(load => load.truck === truck._id).length,
      })),
      monthlyRevenue: {
          labels: Object.keys(revenueData),
          values: Object.values(revenueData),
      },
      completeLoads,  // ✅ Acum corect
      canceledLoads,  // ✅ Acum corect
      incompleteLoads,
      topDriversByRevenue,
  topDriversByLoads,
  topTrucksByRevenue,
  topTrucksByLoads,
  estimatedProfit,
fuelCosts,
  driverPayments,
   dispatchEfficiency,
   averageDelayHours: parseFloat(averageDelayHours.toFixed(2)),
averageDelayMinutes: parseFloat((averageDelayHours * 60).toFixed(0)),
revenuePerMile,
dispatcherComparison: dispatcherStats,
 loadsByDate: loadsByDateArray


    });
};


const saveKpi = async () => {
  const category = document.getElementById("category").value;
  const name = document.getElementById("name").value;
  const value = document.getElementById("value").value;
  const unit = document.getElementById("unit").value;
  const target = document.getElementById("target").value;

  try {
    const res = await axios.post(`${apiUrl}/kpi`, {
      category, name, value, unit, target
    }, config);

    setKpis([...kpis, res.data.result]);
    setShowAddModal(false);
  } catch (err) {
    console.error("❌ Error saving KPI", err);
  }
};

useEffect(() => {
  const fetchKpis = async () => {
    try {
if (!clientId) return;

const res = await axios.get(`${apiUrl}/widgets/${clientId}`, config);

      const widgets = (res.data || []).map(w => ({
        ...w,
        id: w._id   // aici facem alias la _id
      }));

      setKpis(widgets.filter(w => w.type === "kpi"));
      setCards(widgets.filter(w => w.type === "card"));
      setCharts(widgets.filter(w => w.type === "chart"));
    } catch (err) {
      console.error("❌ Error fetching KPIs", err);
    }
  };

  fetchKpis();
}, [clientData?._id]);

const handleAddWidget = async () => {
  let metric = "";

  if (newWidgetType === "kpi") {
    metric = document.getElementById("kpiMetric").value;
  } else if (newWidgetType === "card") {
    metric = document.getElementById("cardMetric").value;
  } else if (newWidgetType === "chart") {
    metric = document.getElementById("chartMetric").value;
  }

  const metricMap = {
    utilizationRate: "utilizationRate",
    revenuePerTruck: "revenuePerTruck",
    revenuePerDriver: "revenuePerDriver",
    profitMargin: "profitMargin",
    operatingRatio: "operatingRatio",
    iftaCompliance: "iftaCompliance",
    driverTurnover: "driverTurnover",
    payPerMile: "payPerMile",
    maintCostPerMile: "maintCostPerMile",
    fuelEfficiency: "fuelEfficiency",
    nextServiceDue: "nextServiceDue",
    repeatLoads: "repeatLoads",
    loadsPerDispatcher: "loadsPerDispatcher",
    revenuePerDispatcher: "revenuePerDispatcher",
    loadsPerDriver: "loadsPerDriver",
    loadsPerTruck: "loadsPerTruck"
  };

  const kpiKey = metricMap[metric] || metric;

  // aici diferențiem: dacă e chart => trimitem array, altfel number simplu
  let metricValue = null;

 if (newWidgetType === "chart") {
  const rawVal = kpiData[kpiKey];

  if (Array.isArray(rawVal)) {
    // dacă e deja array (ex: topClients)
    metricValue = rawVal;
  } else if (typeof rawVal === "object") {
    // dacă e obiect cu key:value → transformăm în array
    metricValue = Object.entries(rawVal).map(([name, total]) => ({ name, total }));
  } else {
    // fallback: single number → îl punem într-un array ca să nu crape bar chart
    metricValue = [{ name: kpiKey, total: Number(rawVal) || 0 }];
  }
} else {
  metricValue = kpiData[kpiKey] ?? 0;
}

  try {
    const payload = {
  clientId,
  type: newWidgetType, // "kpi" | "card" | "chart"
  metric: kpiKey,
  value: metricValue,
  chartType: newWidgetType === "chart" 
    ? (document.getElementById("chartType").value === "column" ? "bar" : document.getElementById("chartType").value)
    : null,
};
    const res = await axios.post(
      "https://api-backend.full-trucking-service.com/api/widgets",
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const savedWidget = res.data;

    if (savedWidget.type === "kpi") {
      setKpis([...kpis, savedWidget]);
    } else if (savedWidget.type === "card") {
      setCards([...cards, savedWidget]);
    } else if (savedWidget.type === "chart") {
      setCharts([...charts, savedWidget]);
    }

    setShowAddModal(false);
  } catch (err) {
    console.error("Error saving widget:", err);
  }
};


// la montare
useEffect(() => {
  if (!clientData?._id) return;

  const fetchWidgets = async () => {
    try {
      const res = await axios.get(
        `https://api-backend.full-trucking-service.com/api/widgets/${clientData._id}`
      );

      const all = res.data;
      setKpis(all.filter(w => w.type === "kpi"));
      setCards(all.filter(w => w.type === "card"));
      setCharts(all.filter(w => w.type === "chart"));
    } catch (err) {
      console.error("❌ Error fetching widgets", err);
    }
  };

  fetchWidgets();
}, [clientData]);



const handleDeleteKPI = async (id) => {
  try {
    await axios.delete(
      `https://api-backend.full-trucking-service.com/api/widgets/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setKpis(prev => prev.filter(w => w._id !== id && w.id !== id));
  } catch (err) {
    console.error("Error deleting KPI:", err);
  }
};

const handleDeleteCard = async (id) => {
  try {
    await axios.delete(
      `https://api-backend.full-trucking-service.com/api/widgets/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setCards(prev => prev.filter(w => w._id !== id && w.id !== id));
  } catch (err) {
    console.error("Error deleting Card:", err);
  }
};

const handleDeleteChart = async (id) => {
  try {
    await axios.delete(
      `https://api-backend.full-trucking-service.com/api/widgets/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setCharts(prev => prev.filter(w => w._id !== id && w.id !== id));
  } catch (err) {
    console.error("Error deleting Chart:", err);
  }
};


const computeAchievedForGoal = useCallback((goal) => {
  if (!goal) return 0;

  // dacă backend-ul ți-a salvat progress numeric și > 0, îl folosim ca atare
  const progressNum = Number(goal.progress);
  if (Number.isFinite(progressNum) && progressNum > 0) {
    return progressNum;
  }

  // altfel derivăm suma rate-urilor din loads pe intervalul goal-ului
  const now = new Date();
  let start = null;
  let end = null;

  if (goal.startDate && goal.endDate) {
    start = new Date(goal.startDate);
    end = new Date(goal.endDate);
  } else {
    // mapăm după tip: daily/weekly/monthly/yearly
    end = new Date(now);
    const type = String(goal.type || "").toLowerCase();
    switch (type) {
      case "daily":
        start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
        break;
      case "weekly":
        start = new Date(now);
        start.setDate(now.getDate() - 6);
        start.setHours(0, 0, 0, 0);
        break;
      case "monthly":
        start = new Date(now.getFullYear(), now.getMonth(), 1);
        break;
      case "yearly":
        start = new Date(now.getFullYear(), 0, 1);
        break;
      default:
        // fallback: tot istoricul
        start = new Date(0);
    }
  }

  const relevantLoads = (loads || []).filter((load) => {
    const d = new Date(load.date || load?.shippers?.[0]?.pickUpTime || load.createdAt);
    return !isNaN(d) && d >= start && d <= end;
  });

  const total = relevantLoads.reduce((acc, l) => acc + (parseFloat(l.rate) || 0), 0);
  return total;
}, [loads]);

  return (
    
 
<div
  className={`${styles.ultimatedashboardoverview} ${
  theme === 'light' ? styles.ultimatePageLight : ''
}`}
>



      {/* Side Menu */}
      <div className={styles.sidebarToggle} onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
  ☰
</div>

      <aside className={`${styles.sidebarultimatedashboardoverview} ${isSidebarOpen ? styles.sidebarOpen : ''}`}>
  <ul>
    <li onClick={() => onNavigate('dashboard')}>Overview</li>
    <li onClick={() => onNavigate('driver-dashboard')}>Drivers</li>
    <li onClick={() => onNavigate('truck-dashboard')}>Trucks</li>
    <li onClick={() => onNavigate('load-dashboard')}>Loads</li>
  </ul>
  
{/* AI Button */}
<div className={styles.aiButtonWrapper}>
  <button className={styles.aiButton} onClick={askAI}>
    Ask AI for Suggestions
  </button>
</div>




</aside>
<Loader isLoading={isLoadingDashboard} />


      {/* Main Content */}
      <div className={styles.mainContentultimatedashboardoverview}>
      <div className={styles.dashboardTitleContainer}>
</div>

{/* === Header Actions Row === */}
<div className={styles.headerActionsRow}>
  <button 
    className={styles.addWidgetButton} 
    onClick={() => setShowAddModal(true)}
  >
    + Add New Widget
  </button>

  <button
    onClick={() => {
      setShowStrategyModal(true);
      generatePlan();
    }}
    className={styles.strategyButton}
  >
    Make a Strategy Plan with AI
  </button>
</div>

{showStrategyModal && (
  <div className={styles.strategyOverlay}>
    <div className={styles.strategyPanel}>
      <button
        className={styles.closeButton}
        onClick={() => setShowStrategyModal(false)}
      >
        ✕
      </button>

      <h2 className={styles.strategyTitle}> AI Strategy Plan</h2>

      {loadingStrategy ? (
        <div style={{ textAlign: "center", padding: "60px 0" }}>
          <div className={styles.loaderBubbles}>
            <span></span><span></span><span></span>
          </div>
          <p style={{ marginTop: 20, color: "#9A9AAF", fontSize: "0.9rem" }}>
            Analyzing your operational data...
          </p>
        </div>
      ) : planText ? (
        <div className={styles.strategyContent}>
          {/* Parsăm textul în secțiuni după ## */}
          {planText.split(/\n(?=## )/).map((section, sIdx) => {
            const lines = section.trim().split("\n");
            const titleLine = lines[0];
            const bodyLines = lines.slice(1);

            const isHeader = titleLine.startsWith("##");
            const title = isHeader
              ? titleLine.replace(/^##\s*/, "")
              : null;

            // Culoare accent per secțiune
            const sectionColors = [
              "#F59E0B", "#3B82F6", "#34D399",
              "#F59E0B", "#A78BFA", "#F87171",
            ];
            const accentColor = sectionColors[sIdx % sectionColors.length];

            return (
              <div key={sIdx} style={{
                marginBottom: 28,
                background: "rgba(255,255,255,0.025)",
                border: `1px solid ${accentColor}22`,
                borderLeft: `3px solid ${accentColor}`,
                borderRadius: 10,
                padding: "16px 20px",
              }}>
                {title && (
                  <h3 style={{
                    fontFamily: "'Barlow Condensed', sans-serif",
                    fontSize: "1.05rem",
                    fontWeight: 700,
                    letterSpacing: "0.04em",
                    textTransform: "uppercase",
                    color: accentColor,
                    margin: "0 0 14px",
                    paddingBottom: 10,
                    borderBottom: `1px solid ${accentColor}22`,
                  }}>
                    {title}
                  </h3>
                )}

                <div style={{ fontSize: "0.875rem", lineHeight: 1.75, color: "#CBD5E1" }}>
                  {bodyLines.map((line, lIdx) => {
                    const trimmed = line.trim();
                    if (!trimmed) return <div key={lIdx} style={{ height: 6 }} />;

                    // Numerotate: "1. ..." sau bullet "- ..."
                    if (/^(\d+\.|[-•*])/.test(trimmed)) {
                      const text = trimmed.replace(/^(\d+\.|[-•*])\s*/, "");
                      const isNumbered = /^\d+\./.test(trimmed);
                      const num = isNumbered ? trimmed.match(/^(\d+)/)?.[1] : null;

                      return (
                        <div key={lIdx} style={{
                          display: "flex",
                          gap: 10,
                          marginBottom: 8,
                          alignItems: "flex-start",
                        }}>
                          <span style={{
                            flexShrink: 0,
                            width: 22, height: 22,
                            borderRadius: isNumbered ? 6 : "50%",
                            background: `${accentColor}22`,
                            border: `1px solid ${accentColor}44`,
                            color: accentColor,
                            fontSize: "0.7rem",
                            fontWeight: 700,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: 2,
                          }}>
                            {isNumbered ? num : "•"}
                          </span>
                          <span style={{ flex: 1 }}
                            dangerouslySetInnerHTML={{
                              __html: text
                                .replace(/\*\*(.+?)\*\*/g, `<strong style="color:#F4F4F6">$1</strong>`)
                                .replace(/\$[\d,.]+(\/\w+)?/g, s => `<span style="color:#34D399;font-weight:700">${s}</span>`)
                                .replace(/(\d+[\d,]*\.?\d*)\s*(miles|gallons|gal|loads|%)/gi, s => `<span style="color:${accentColor};font-weight:600">${s}</span>`),
                            }}
                          />
                        </div>
                      );
                    }

                    // Rând normal
                    return (
                      <p key={lIdx} style={{ margin: "4px 0" }}
                        dangerouslySetInnerHTML={{
                          __html: trimmed
                            .replace(/\*\*(.+?)\*\*/g, `<strong style="color:#F4F4F6">$1</strong>`)
                            .replace(/\$[\d,.]+(\/\w+)?/g, s => `<span style="color:#34D399;font-weight:700">${s}</span>`)
                            .replace(/(\d+[\d,]*\.?\d*)\s*(miles|gallons|gal|loads|%)/gi, s => `<span style="color:${accentColor};font-weight:600">${s}</span>`),
                        }}
                      />
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className={styles.noPlan}>No plan generated yet.</p>
      )}

      <div className={styles.strategyActions}>
        <button
          onClick={() => { setShowStrategyModal(false); setShowStrategyModal(true); generatePlan(); }}
          style={{
            padding: "10px 20px",
            borderRadius: "100px",
            border: "1px solid rgba(245,158,11,0.35)",
            background: "rgba(245,158,11,0.1)",
            color: "#FBBF24",
            fontFamily: "'Barlow Condensed', sans-serif",
            fontSize: "0.88rem",
            fontWeight: 700,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            cursor: "pointer",
            marginRight: 10,
          }}
        >
          Regenerate
        </button>
        <button
          onClick={() => downloadPDFStrategy(clientId)}
          className={styles.downloadButtonAI}
        >
          ⬇ Download PDF
        </button>
      </div>
    </div>
  </div>
)}

{showAddModal && (
  <div className={styles.modalOverlayDispatcher}>
    <div className={styles.modalContentDispatcher}>
      <h3>Add New Widget</h3>

      {/* Tipul widgetului */}
      <select value={newWidgetType} onChange={(e) => setNewWidgetType(e.target.value)}>
        <option value="">Select type...</option>
        <option value="chart">Chart</option>
        <option value="kpi">KPI</option>
        <option value="card">Card</option>
      </select>

      {/* Dacă e Chart */}
      {newWidgetType === "chart" && (
        <div>
          <h4>Select chart type:</h4>
          <select id="chartType">
            <option value="bar">Bar</option>
            <option value="line">Line</option>
            <option value="column">Column</option>
            <option value="doughnut">Doughnut</option>
            <option value="pie">Pie</option>
            <option value="gauge">Gauge</option>
          </select>

          <h4>Select chart metric:</h4>
          <select id="chartMetric">
            <option value="utilization">Utilization rate</option>
            <option value="revPerTruck">Revenue per truck/driver</option>
            <option value="profitMargin">Profit margin %</option>
            <option value="operatingRatio">Operating ratio (OR)</option>
            <option value="arAging">AR aging 30/60/90</option>
            <option value="ifta">IFTA compliance</option>
            <option value="driverTurnover">Driver turnover %</option>
            <option value="payPerMile">Avg pay per mile</option>
            <option value="maintCost">Maintenance cost per mile</option>
            <option value="fuelEff">Fuel efficiency MPG</option>
            <option value="nextService">Next service due</option>
            <option value="topClients">Top 5 clients by revenue</option>
            <option value="repeatLoads">Repeat loads %</option>
            <option value="loadsDispatcher">Loads per dispatcher</option>
            <option value="revDispatcher">Revenue per dispatcher</option>
          </select>
        </div>
      )}

      {/* Dacă e KPI */}
      {newWidgetType === "kpi" && (
        <div>
          <h4>Select KPI metric</h4>
          <select id="kpiMetric">
            <option value="utilization">Utilization rate</option>
            <option value="revPerTruck">Revenue per truck/driver</option>
            <option value="profitMargin">Profit margin %</option>
            <option value="operatingRatio">Operating ratio (OR)</option>
            <option value="arAging">AR aging 30/60/90</option>
            <option value="ifta">IFTA compliance</option>
            <option value="driverTurnover">Driver turnover %</option>
            <option value="payPerMile">Avg pay per mile</option>
            <option value="maintCost">Maintenance cost per mile</option>
            <option value="fuelEff">Fuel efficiency MPG</option>
            <option value="nextService">Next service due</option>
            <option value="topClients">Top 5 clients by revenue</option>
            <option value="repeatLoads">Repeat loads %</option>
            <option value="loadsDispatcher">Loads per dispatcher</option>
            <option value="revDispatcher">Revenue per dispatcher</option>
          </select>
        </div>
      )}

      {/* Dacă e Card */}
      {newWidgetType === "card" && (
        <div>
          <h4>Select card metric</h4>
          <select id="cardMetric">
            <option value="utilization">Utilization rate</option>
            <option value="revPerTruck">Revenue per truck/driver</option>
            <option value="profitMargin">Profit margin %</option>
            <option value="operatingRatio">Operating ratio (OR)</option>
            <option value="arAging">AR aging 30/60/90</option>
            <option value="ifta">IFTA compliance</option>
            <option value="driverTurnover">Driver turnover %</option>
            <option value="payPerMile">Avg pay per mile</option>
            <option value="maintCost">Maintenance cost per mile</option>
            <option value="fuelEff">Fuel efficiency MPG</option>
            <option value="nextService">Next service due</option>
            <option value="topClients">Top 5 clients by revenue</option>
            <option value="repeatLoads">Repeat loads %</option>
            <option value="loadsDispatcher">Loads per dispatcher</option>
            <option value="revDispatcher">Revenue per dispatcher</option>
          </select>
        </div>
      )}

      {/* Butoane */}
      <button onClick={handleAddWidget}>Add</button>
      <button onClick={() => setShowAddModal(false)}>Close</button>
    </div>
  </div>
)}

{showAIModal && (
  <div className={styles.modalOverlayDispatcher}>
    <div 
      className={styles.modalContentDispatcher} 
      style={{ maxWidth: 600, width: "100%", padding: "20px", borderRadius: "12px" }}
    >
      <button 
        className={styles.closeButtonDispatcher} 
        onClick={() => setShowAIModal(false)}
        style={{ position: "absolute", top: 15, right: 15 }}
      >
        ✕
      </button>

      <h3 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "15px" }}>
        AI Dashboard Insights
      </h3>

      {isThinking ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: 30, marginBottom: 30 }}>
          <div className={styles.loaderBubbles}>
            <span></span><span></span><span></span>
          </div>
        </div>
      ) : aiSuggestion.length > 0 ? (
        <ul style={{ marginTop: 10, listStyle: "none", padding: 0 }}>
          {aiSuggestion.map((s, i) => (
            <li 
              key={i} 
              style={{ 
                marginBottom: 12, 
                lineHeight: "1.6", 
                background: "rgba(255,255,255,0.05)", 
                padding: "10px 14px", 
                borderRadius: "8px", 
                
                animation: `fadeIn 0.3s ease forwards ${i * 0.2}s` 
              }}
            >
              {s}
            </li>
          ))}
        </ul>
      ) : (
        <p style={{ marginTop: 20, color: "#999" }}>No suggestions received.</p>
      )}
    </div>
  </div>
)}

{/* Select Time Range */}
<div className={styles.timeFilterultimatedashboardoverview}>
  <label htmlFor="timeRange">Select Time Range:</label>
  <select value={timeRange} onChange={(e) => setTimeRange(e.target.value)}>
      <option value="">All Time</option>
    <option value="day">Today</option>
    <option value="week">This Week</option>
    <option value="month">This Month</option>
    <option value="year">This Year</option>
    <option value="custom">Custom Range</option>
  </select>

  {timeRange === "custom" && (
    <div className={styles.customDatePickerultimatedashboardoverview}>
      <label>From: <input type="date" value={customStartDate} onChange={(e) => setCustomStartDate(e.target.value)} /></label>
      <label>To: <input type="date" value={customEndDate} onChange={(e) => setCustomEndDate(e.target.value)} /></label>
    </div>
  )}
</div>
<div className={styles.statsdashboardoverview}>
  <div className={styles.statCardultimatedashboardoverview}><h4>Total Drivers</h4><p>{dashboardData.totalDrivers}</p></div>
  <div className={styles.statCardultimatedashboardoverview}><h4>Total Trucks</h4><p>{dashboardData.totalTrucks}</p></div>
  <div className={styles.statultimatedashboardoverview}><h4>Total Loads</h4><p>{dashboardData.totalLoads}</p></div>
<div className={styles.statultimatedashboardoverview}>
  <h4>Total Miles</h4>
  <p>{formatMiles(dashboardData.totalMiles)}</p>
  <small>{Number(dashboardData.totalMiles || 0).toLocaleString()} mi</small>
</div>

<div className={styles.statultimatedashboardoverview}>
  <h4>Total Revenue</h4>
  <p>{formatMoney(dashboardData.totalRevenue)}</p>
  <small>${Number(dashboardData.totalRevenue || 0).toLocaleString()}</small>
</div>

<div className={styles.statultimatedashboardoverview}>
  <h4>Estimated Profit</h4>
  <p>{formatMoney(dashboardData.estimatedProfit)}</p>
  <small>${Number(dashboardData.estimatedProfit || 0).toLocaleString()}</small>
</div>

<div className={styles.statultimatedashboardoverview}>
  <h4>Revenue per Mile</h4>
  <p>{formatMoney(dashboardData.revenuePerMile)}</p>
  <small>per mile avg</small>
</div>

<div className={styles.statultimatedashboardoverview}>
  <h4>ETA Delay</h4>
  <p>{Number(dashboardData.averageDelayHours || 0).toFixed(1)}h</p>
  <small>{dashboardData.averageDelayMinutes ?? 0} min avg</small>
</div>
</div>


<div className={styles.sectionDivider} />
        <div className={styles.calendarSectionultimatedashboardoverview}>
          {/* Calendar */}
          <div className={styles.calendarContainerultimatedashboardoverview}>
            <div className={styles.calendarHeaderultimatedashboardoverview}>
  <button className={styles.calendarButton} onClick={handlePrevMonth}>
    <FaChevronLeft />
  </button>
  <h2>
    {calendarDate.toLocaleString("default", { month: "long", year: "numeric" })}
  </h2>
  <button className={styles.calendarButton} onClick={handleNextMonth}>
    <FaChevronRight />
  </button>
</div>

            <div className={styles.weekDaysultimatedashboardoverview}>
              {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map((day) => (
                <div key={day} className={styles.weekDayultimatedashboardoverview}>{day}</div>
              ))}
            </div>

            <div className={styles.calendarDaysultimatedashboardoverview}>{renderCalendarDays()}</div>
          </div>

       {/* Tasks Panel */}
{selectedDate && (
  <div className={styles.toDoListultimatedashboardoverview}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <h3>Tasks for {selectedDate}</h3>
      <button onClick={() => {
        setTaskForm({ title: "", description: "", status: "open", priority: "medium", assignedTo: "" });
        setShowAddTaskModal(true);
      }}>
        + Add Task
      </button>
    </div>

    {isLoadingTasks ? (
      <p>Loading tasks...</p>
    ) : (
      <>
        {Array.isArray(tasksByDate[selectedDate]) && tasksByDate[selectedDate].length > 0 ? (
          <ul style={{ listStyle: "none", padding: 0, marginTop: 10 }}>
            {tasksByDate[selectedDate].map((t) => (
              <li key={t._id} className={styles.taskCard}>
                <div className={styles.taskHeader}>
                  <span className={styles.taskTitle}>{t.title}</span>
                  <div className={styles.taskBadges}>
                    <span className={`${styles.badge} ${styles[`status_${t.status}`]}`}>{t.status}</span>
                    <span className={`${styles.badge} ${styles[`priority_${t.priority}`]}`}>{t.priority}</span>
                  </div>
                </div>

                {t.description ? <p className={styles.taskDesc}>{t.description}</p> : null}

                <div className={styles.taskActions}>
                  <select
                    value={t.status}
                    onChange={(e) => updateTaskStatus(t._id, e.target.value)}
                    className={styles.taskStatusSelect}
                    title="Quick status update"
                  >
                    <option value="open">open</option>
                    <option value="in_progress">in_progress</option>
                    <option value="done">done</option>
                    <option value="canceled">canceled</option>
                  </select>

                  <button onClick={() => startEditTask(t)}>Edit</button>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p>No tasks on this day yet.</p>
        )}
      </>
    )}
  </div>
)}
  </div>
{/* ========== ADD TASK MODAL ========== */}
{showAddTaskModal && (
  <div className={styles.modalOverlayDispatcher}>
    <div className={styles.modalContentDispatcher} style={{ maxWidth: 520, width: '100%' }}>
      <button className={styles.closeButtonDispatcher} onClick={() => setShowAddTaskModal(false)}>✕</button>
      <h3>Add New Task</h3>
      <p style={{ opacity: .8, marginTop: -6 }}>Date: <b>{selectedDate}</b></p>

      <div className={styles.formGroupultimateaddload}>
        <label>Title</label>
        <input
          value={taskForm.title}
          onChange={(e) => setTaskForm({ ...taskForm, title: e.target.value })}
          placeholder="Task title"
          className={styles.inputFieldultimateaddload}
        />
      </div>

      <div className={styles.formGroupultimateaddload}>
        <label>Description</label>
        <textarea
          value={taskForm.description}
          onChange={(e) => setTaskForm({ ...taskForm, description: e.target.value })}
          placeholder="Short description..."
          className={styles.textareaFieldultimateaddload}
        />
      </div>

      <div className={styles.formRowultimateaddload}>
        <div className={styles.formGroupultimateaddload}>
          <label>Status</label>
          <select
            value={taskForm.status}
            onChange={(e) => setTaskForm({ ...taskForm, status: e.target.value })}
            className={styles.selectFieldultimateaddload}
          >
            <option value="open">open</option>
            <option value="in_progress">in_progress</option>
            <option value="done">done</option>
            <option value="canceled">canceled</option>
          </select>
        </div>

        <div className={styles.formGroupultimateaddload}>
          <label>Priority</label>
          <select
            value={taskForm.priority}
            onChange={(e) => setTaskForm({ ...taskForm, priority: e.target.value })}
            className={styles.selectFieldultimateaddload}
          >
            <option value="low">low</option>
            <option value="medium">medium</option>
            <option value="high">high</option>
          </select>
        </div>
      </div>

      <div className={styles.formGroupultimateaddload}>
        <label>Assigned To</label>
        <select
          value={taskForm.assignedTo}
          onChange={(e) => setTaskForm({ ...taskForm, assignedTo: e.target.value })}
          className={styles.selectFieldultimateaddload}
        >
          <option value="">Unassigned</option>
          {/* Poți lista drivers + dispatchers, sau doar drivers */}
          {drivers.map(d => (
            <option key={d._id} value={d._id}>
              {d.firstName} {d.lastName}
            </option>
          ))}
          {dispatchers.map(d => (
            <option key={d._id} value={d._id}>
              {d.firstName} {d.lastName} (dispatcher)
            </option>
          ))}
        </select>
      </div>

      <button className={styles.addButtonConsigneeultimateaddload} onClick={createTask} disabled={isLoadingTasks}>
        {isLoadingTasks ? 'Saving...' : 'Add Task'}
      </button>
    </div>
  </div>
)}

{/* ========== EDIT TASK MODAL ========== */}
{showEditTaskModal && editTask && (
  <div className={styles.modalOverlayDispatcher}>
    <div className={styles.modalContentDispatcher} style={{ maxWidth: 520, width: '100%' }}>
      <button className={styles.closeButtonDispatcher} onClick={() => { setShowEditTaskModal(false); setEditTask(null); }}>✕</button>
      <h3>Edit Task</h3>
      <p style={{ opacity: .8, marginTop: -6 }}>Date: <b>{editTask.date}</b></p>

      <div className={styles.formGroupultimateaddload}>
        <label>Title</label>
        <input
          value={taskForm.title}
          onChange={(e) => setTaskForm({ ...taskForm, title: e.target.value })}
          placeholder="Task title"
          className={styles.inputFieldultimateaddload}
        />
      </div>

      <div className={styles.formGroupultimateaddload}>
        <label>Description</label>
        <textarea
          value={taskForm.description}
          onChange={(e) => setTaskForm({ ...taskForm, description: e.target.value })}
          placeholder="Short description..."
          className={styles.textareaFieldultimateaddload}
        />
      </div>

      <div className={styles.formRowultimateaddload}>
        <div className={styles.formGroupultimateaddload}>
          <label>Status</label>
          <select
            value={taskForm.status}
            onChange={(e) => setTaskForm({ ...taskForm, status: e.target.value })}
            className={styles.selectFieldultimateaddload}
          >
            <option value="open">open</option>
            <option value="in_progress">in_progress</option>
            <option value="done">done</option>
            <option value="canceled">canceled</option>
          </select>
        </div>

        <div className={styles.formGroupultimateaddload}>
          <label>Priority</label>
          <select
            value={taskForm.priority}
            onChange={(e) => setTaskForm({ ...taskForm, priority: e.target.value })}
            className={styles.selectFieldultimateaddload}
          >
            <option value="low">low</option>
            <option value="medium">medium</option>
            <option value="high">high</option>
          </select>
        </div>
      </div>

      <div className={styles.formGroupultimateaddload}>
        <label>Assigned To</label>
        <select
          value={taskForm.assignedTo}
          onChange={(e) => setTaskForm({ ...taskForm, assignedTo: e.target.value })}
          className={styles.selectFieldultimateaddload}
        >
          <option value="">Unassigned</option>
          {drivers.map(d => (
            <option key={d._id} value={d._id}>
              {d.firstName} {d.lastName}
            </option>
          ))}
          {dispatchers.map(d => (
            <option key={d._id} value={d._id}>
              {d.firstName} {d.lastName} (dispatcher)
            </option>
          ))}
        </select>
      </div>

      <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
        <button className={styles.addButtonConsigneeultimateaddload} onClick={saveEditTask} disabled={isLoadingTasks}>
          {isLoadingTasks ? 'Saving...' : 'Save'}
        </button>
        <button className={styles.removeButtonConsigneeultimateaddload} onClick={() => deleteTask(editTask._id)} disabled={isLoadingTasks}>
          {isLoadingTasks ? 'Deleting...' : 'Delete'}
        </button>
      </div>
    </div>
  </div>
)}

{/* === KPIs === */}
<div className={styles.kpiContainer}>
  {kpis.map((kpi, i) => (
    <div 
      key={kpi.id || kpi._id || i}   // ✅ asigură key unic
      className={styles.kpiCard}
      onClick={() => setSelectedItem({ type: "kpi", id: kpi.id || kpi._id })}
      style={{ position: "relative", cursor: "pointer" }}
    >
      <h4>{kpi.metric}</h4>
      <p>
        {typeof kpi.value === "object" ? JSON.stringify(kpi.value) : kpi.value}
      </p>

      {selectedItem?.type === "kpi" && selectedItem.id === (kpi.id || kpi._id) && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteKPI(kpi.id || kpi._id);
          }}
          style={{
            position: "absolute",
            top: "5px",
            right: "5px",
            background: "#ef4444",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            padding: "4px 8px",
            cursor: "pointer"
          }}
        >
          Delete
        </button>
      )}
    </div>
  ))}
</div>

{/* === CARDS === */}
<div className={styles.cardContainer}>
  {cards.map((card, i) => (
    <div 
      key={card.id || card._id || i}   // ✅ asigură key unic
      className={styles.card}
      onClick={() => setSelectedItem({ type: "card", id: card.id || card._id })}
      style={{ position: "relative", cursor: "pointer" }}
    >
      <h4>{card.metric}</h4>
      <p>
        {typeof card.value === "object" ? JSON.stringify(card.value) : card.value}
      </p>

      {selectedItem?.type === "card" && selectedItem.id === (card.id || card._id) && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteCard(card.id || card._id);
          }}
          style={{
            position: "absolute",
            top: "5px",
            right: "5px",
            background: "#ef4444",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            padding: "4px 8px",
            cursor: "pointer"
          }}
        >
          Delete
        </button>
      )}
    </div>
  ))}
</div>
{/* === CHARTS === */}
<div className={styles.chartsContainer}>
  {charts.map((chart, i) => (
    <div 
      key={chart.id || chart._id || i}   // ✅ key unic
      className={styles.chartBox} 
      onClick={() => setSelectedItem({ type: "chart", id: chart.id || chart._id })}
      style={{ position: "relative", cursor: "pointer", height: "400px", padding: "15px", margin: "15px" }}
    >
      <h4>{chart.metric} ({chart.chartType})</h4>

      {/* === BAR / COLUMN === */}
      {chart.chartType === "bar" && (
        <Bar
          data={{
            labels: Array.isArray(chart.value)
              ? chart.value.map((c, idx) => c.name || c[0] || `Item ${idx + 1}`)
              : ["Value"],
            datasets: [{
              label: chart.metric,
              data: Array.isArray(chart.value)
                ? chart.value.map(c => c.total || c[1] || 0)
                : [Number(chart.value) || 0],
              backgroundColor: "#3b82f6"
            }]
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            layout: { padding: 20 }, // 🔹 micșorează graficul
            plugins: {
              legend: {
                labels: {
                  boxWidth: 15,
                  font: { size: 12 }
                }
              }
            },
            indexAxis: chart.originalType === "column" ? "y" : "x"
          }}
        />
      )}

      {/* === PIE === */}
      {chart.chartType === "pie" && (
        <Pie
          data={{
            labels: Array.isArray(chart.value) 
              ? chart.value.map((c, idx) => c[0] || c.name || `item-${idx}`) 
              : ["Value"],
            datasets: [{
              data: Array.isArray(chart.value) 
                ? chart.value.map(c => c[1] || c.total) 
                : [chart.value],
              backgroundColor: ["#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#6366f1"]
            }]
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            layout: { padding: 40 },
            plugins: {
              legend: {
                labels: { font: { size: 12 }, boxWidth: 15 }
              }
            },
            radius: "100%" // 🔹 micșorează cercul
          }}
        />
      )}

      {/* === LINE === */}
      {chart.chartType === "line" && (
        <Line
          data={{
            labels: Array.isArray(chart.value) 
              ? chart.value.map((c, idx) => c[0] || c.name || `item-${idx}`) 
              : ["Value"],
            datasets: [{
              label: chart.metric,
              data: Array.isArray(chart.value) 
                ? chart.value.map(c => c[1] || c.total) 
                : [chart.value],
              fill: false,
              borderColor: "#22c55e",
              tension: 0.3
            }]
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            layout: { padding: 40 },
            plugins: {
              legend: {
                labels: { font: { size: 12 }, boxWidth: 15 }
              }
            }
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chart.chartType === "doughnut" && (
        <Doughnut
          data={{
            labels: Array.isArray(chart.value) 
              ? chart.value.map((c, idx) => c[0] || c.name || `item-${idx}`) 
              : ["Value"],
            datasets: [{
              data: Array.isArray(chart.value) 
                ? chart.value.map(c => c[1] || c.total) 
                : [chart.value],
              backgroundColor: ["#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#6366f1"]
            }]
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            layout: { padding: 40 },
            plugins: {
              legend: {
                labels: { font: { size: 12 }, boxWidth: 15 }
              }
            },
            cutout: "70%" // 🔹 face cercul mai mic
          }}
        />
      )}

      {/* === GAUGE === */}
      {chart.chartType === "gauge" && (
        <Doughnut
          data={{
            labels: ["Value", "Remainder"],
            datasets: [{
              data: [Number(chart.value) || 0, 100 - (Number(chart.value) || 0)],
              backgroundColor: ["#f59e0b", "#1e293b"],
              borderWidth: 0
            }]
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            rotation: -90,
            circumference: 180,
            layout: { padding: 40 },
            plugins: { legend: { display: false } }
          }}
        />
      )}

      {/* === DELETE BUTTON === */}
      {selectedItem?.type === "chart" && selectedItem.id === (chart.id || chart._id) && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteChart(chart.id || chart._id);
          }}
          style={{
            position: "absolute",
            top: "5px",
            right: "5px",
            background: "#ef4444",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            padding: "4px 8px",
            cursor: "pointer"
          }}
        >
          Delete
        </button>
      )}
    </div>
  ))}
</div>




   <div className={styles.topPerformanceSection}>
  <h3>Top Performing Drivers / Trucks</h3>
  
  <div className={styles.performanceContainer}>
    <div>
      <h4>Drivers by Revenue</h4>
      <ul>
        {dashboardData.topDriversByRevenue?.map((d, i) => (
          <li key={i}>{d.name} - ${d.totalRevenue.toFixed(2)}</li>
        ))}
      </ul>
    </div>

    <div>
      <h4>Drivers by Completed Loads</h4>
      <ul>
        {dashboardData.topDriversByLoads?.map((d, i) => (
          <li key={i}>{d.name} - {d.completedLoads} loads</li>
        ))}
      </ul>
    </div>

    <div>
      <h4>Trucks by Revenue</h4>
      <ul>
        {dashboardData.topTrucksByRevenue?.map((t, i) => (
          <li key={i}>{t.name} - ${t.totalRevenue.toFixed(2)}</li>
        ))}
      </ul>
    </div>

    <div>
      <h4>Trucks by Completed Loads</h4>
      <ul>
        {dashboardData.topTrucksByLoads?.map((t, i) => (
          <li key={i}>{t.name} - {t.completedLoads} loads</li>
        ))}
      </ul>
    </div>
  </div>
</div>
<div className={styles.dispatcherOverviewFull}>
  <h2 className={styles.sectionTitle}>Dispatchers Overview</h2>

  {/* Selector interval */}
  <div className={styles.dispatcherTimeFilter}>
    <label htmlFor="dispatcherTimeRange">Select Time Range:</label>
    <select
      id="dispatcherTimeRange"
      value={dispatcherTimeRange}
      onChange={(e) => setDispatcherTimeRange(e.target.value)}
    >
      <option value="week">This Week</option>
      <option value="month">This Month</option>
      <option value="year">This Year</option>
      <option value="custom">Custom Range</option>
    </select>

    {dispatcherTimeRange === "custom" && (
      <div className={styles.customDispatcherDatePicker}>
        <label>
          From:
          <input
            type="date"
            value={customDispatcherStartDate}
            onChange={(e) => setCustomDispatcherStartDate(e.target.value)}
          />
        </label>
        <label>
          To:
          <input
            type="date"
            value={customDispatcherEndDate}
            onChange={(e) => setCustomDispatcherEndDate(e.target.value)}
          />
        </label>
      </div>
    )}
  </div>

  {/* Tabel Overview */}
  <table className={styles.dispatcherTable}>
    <thead>
      <tr>
        <th>Dispatcher</th>
        <th>Drivers</th>
        <th>Trucks</th>
        <th>Total Rate ($)</th>
      </tr>
    </thead>
    <tbody>
      {dispatchers.map((dispatcher) => (
        <tr
          key={dispatcher._id}
          onClick={() => setSelectedDispatcher(dispatcher)} // 👉 aici deschidem modalul
          className={styles.dispatcherRow}
        >
          <td>{dispatcher.firstName} {dispatcher.lastName}</td>
          <td>{dispatcher.drivers?.length || 0}</td>
          <td>{dispatcher.trucks?.length || 0}</td>
          <td>
            {loads && loads.length > 0
              ? loads
                  .filter((load) => {
                    if (!dispatcher.drivers || dispatcher.drivers.length === 0) return false;
                    const isDriverAssigned = dispatcher.drivers.some((driver) => driver._id === load.driver);
                    if (!isDriverAssigned) return false;
                    const loadDate = new Date(load.createdAt);
                    return loadDate >= dispatcherStartDate && loadDate <= dispatcherEndDate;
                  })
                  .reduce((acc, load) => acc + (parseFloat(load.rate) || 0), 0)
                  .toFixed(2)
              : "0.00"}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
{/* ═══ DISPATCHER DETAIL MODAL — montat la nivel de pagină ═══ */}
{selectedDispatcher && (
  <div className={styles.modalOverlay} style={{ position: "fixed", inset: 0, zIndex: 3000 }}>
    <div className={styles.modalContentLarge}>
      <div className={styles.modalHeader}>
        <h3>
          {selectedDispatcher.firstName} {selectedDispatcher.lastName} — Details
        </h3>
        <button
          className={styles.closeBtn}
          onClick={() => {
            setSelectedDispatcher(null);
            setSelectedDriver(null);
            setSelectedTruck(null);
            setLastLoads([]);
          }}
        >
          ×
        </button>
      </div>

      <div className={styles.dispatcherDetailBody}>
        {/* Sidebar stânga */}
        <div className={styles.dispatcherSidebar}>
          <h4>Drivers</h4>
          <ul>
            {selectedDispatcher.drivers.map((driver) => (
              <li key={driver._id} onClick={() => setSelectedDriver(driver)}>
                {driver.firstName} {driver.lastName}
              </li>
            ))}
          </ul>

          <h4>Trucks</h4>
          <ul>
            {selectedDispatcher.trucks.map((truck) => (
              <li key={truck._id} onClick={() => setSelectedTruck(truck)}>
                {truck.truckNumber} — {truck.licensePlate}
              </li>
            ))}
          </ul>
        </div>

        {/* Content dreapta */}
        <div className={styles.dispatcherContent}>
          {selectedDriver ? (
            <div className={styles.driverDetails}>
              <h4>
                {selectedDriver.firstName} {selectedDriver.lastName} — Status
              </h4>

              {lastLoad ? (
                <div className={styles.lastLoadStatus}>
                  <p><strong>Last Load:</strong> #{lastLoad.loadNumber}</p>
                  <p><strong>Status:</strong> {lastLoad.status}</p>

                  {lastLoad.status?.toLowerCase() === "completed" ? (
                    <p><strong>Without a load for:</strong> {daysAgo} days</p>
                  ) : lastLoad.status?.toLowerCase() === "open" ? (
                    <p>
                      <strong>Active Load in progress:</strong><br />
                      From <em>{lastLoad.shippers?.[0]?.address || "N/A"}</em> →{" "}
                      <em>{lastLoad.consignees?.[0]?.address || "N/A"}</em><br />
                      For <strong>${lastLoad.rate}</strong><br />
                      Pickup:{" "}
                      <strong>
                        {lastLoad.pickupDate
                          ? new Date(lastLoad.pickupDate).toLocaleDateString()
                          : "N/A"}
                      </strong>
                    </p>
                  ) : (
                    <p><strong>Status:</strong> {lastLoad.status}</p>
                  )}

                  <p>
                    <strong>Route:</strong>{" "}
                    {lastLoad.shippers?.[0]?.address} →{" "}
                    {lastLoad.consignees?.[0]?.address}
                  </p>
                </div>
              ) : (
                <p style={{ color: "var(--db-text-muted)", fontStyle: "italic" }}>
                  No loads found for this driver.
                </p>
              )}

              <button
                onClick={() => fetchLastLoads({ driverId: selectedDriver._id })}
                className={styles.lastLoadsBtn}
              >
                Last 10 Loads
              </button>

              {lastLoads && lastLoads.length > 0 && (
                <div className={styles.lastLoadsList}>
                  <h5>Last 10 Loads</h5>
                  <ul>
                    {lastLoads.map((load) => (
                      <li key={load._id}>
                        <strong>#{load.loadNumber}</strong> — {load.status} — ${load.rate}
                        <br />
                        {load.shippers?.[0]?.address} → {load.consignees?.[0]?.address}
                        <br />
                        <small>
                          {new Date(load.createdAt).toLocaleDateString()}
                        </small>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ) : (
            <p>Select a driver or truck from the left to see details.</p>
          )}
        </div>
      </div>
    </div>
  </div>
)}

{/* Dispatch Efficiency Section */}
<div className={styles.dispatchEfficiencyContainer}>
  <h3>Dispatch Efficiency</h3>
  <table className={styles.dispatchEfficiencyTable}>
    <thead>
      <tr>
        <th>Dispatcher</th>
        <th>Loads Assigned</th>
        <th>Efficiency %</th>
      </tr>
    </thead>
    <tbody>
      {dashboardData.dispatchEfficiency?.map((d, index) => (
        <tr key={index}>
          <td>{d.name}</td>
          <td style={{ textAlign: "center" }}>{d.loadsAssigned}</td>
          <td
            style={{
              textAlign: "center",
              color:
                d.efficiency >= 70
                  ? "#4ade80" // verde
                  : d.efficiency >= 40
                  ? "#facc15" // galben
                  : "#f87171", // roșu
            }}
          >
            {d.efficiency}%
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>


<div className={styles.chartsultimatedashboardoverview}>
  <div className={styles.chartContainerultimatedashboardoverview} id="monthlyRevenue">
    <div className={styles.chartHeaderultimatedashboardoverview}>
    <h4>Rate Evolution Over Time</h4>
      <ChartMenu
        chartKey="monthlyRevenue"
        chartTitle="Rate Evolution Over Time"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
         className="chart-menu"
      />
    </div>

    <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
      {chartTypes.monthlyRevenue === "Line" && (
        <Line
          data={{
            labels: dashboardData.monthlyRevenue.labels || ["No Data"],
            datasets: [
              {
                label: "Revenue ($)",
                data: dashboardData.monthlyRevenue.values || [0],
                borderColor: "#3b82f6",
                backgroundColor: "rgba(59, 130, 246, 0.2)",
                tension: 0.4,
                fill: true,
                pointBackgroundColor: "#3b82f6",
                pointBorderWidth: 2,
                borderWidth: 2,
                cubicInterpolationMode: "monotone",
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: { grid: { display: false } },
              y: {
                beginAtZero: true,
                grid: { color: "rgba(200, 200, 200, 0.2)" },
                ticks: {
                  callback: function (value) {
                    return "$" + value.toLocaleString();
                  },
                },
              },
            },
            elements: {
              line: { borderJoinStyle: "round" },
              point: { radius: 5, hoverRadius: 7 },
            },
            plugins: {
              legend: { display: true, position: "top" },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    return `Revenue: $${context.raw.toLocaleString()}`;
                  },
                },
              },
            },
          }}
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      )}

      {chartTypes.monthlyRevenue === "Bar" && (
        <Bar
          data={{
            labels: dashboardData.monthlyRevenue.labels || ["No Data"],
            datasets: [
              {
                label: "Revenue ($)",
                data: dashboardData.monthlyRevenue.values || [0],
                backgroundColor: "#3b82f6",
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: true, // 🔹 Evită întinderea la infinit
          }}
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      )}

      {chartTypes.monthlyRevenue === "Pie" && (
        <Pie
          data={{
            labels: dashboardData.monthlyRevenue.labels || ["No Data"],
            datasets: [
              {
                data: dashboardData.monthlyRevenue.values || [0],
                backgroundColor: ["#4caf50", "#ff5722", "#ffc107"],
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: true, // 🔹 Evită întinderea la infinit
            plugins: {
              legend: { display: true },
            },
          }}
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      )}

         {/* ✅ Column Chart (folosim Bar Chart cu layout vertical) */}
         {chartTypes.monthlyRevenue === "Column" && (
        <Bar
          data={{
            labels: dashboardData.monthlyRevenue.labels || ["No Data"],
            datasets: [
              {
                label: "Revenue ($)",
                data: dashboardData.monthlyRevenue.values || [0],
                backgroundColor: "#ff9800",
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: true,
            indexAxis: "y", // 🔹 Transformat într-un Column Chart
          }}
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      )}

      {/* ✅ Doughnut Chart */}
      {chartTypes.monthlyRevenue === "Doughnut" && (
        <Doughnut
          data={{
            labels: dashboardData.monthlyRevenue.labels || ["No Data"],
            datasets: [
              {
                data: dashboardData.monthlyRevenue.values || [0],
                backgroundColor: ["#3b82f6", "#ff9800", "#4caf50", "#e91e63"],
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
              legend: { display: true },
            },
          }}
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      )}

  {/* ✅ Gauge Chart */}
  {chartTypes.monthlyRevenue === "Gauge" && (
        <Doughnut
          data={{
            labels: ["Revenue", "Remaining"],
            datasets: [
              {
                data: [
                  dashboardData.totalRevenue,
                  100000 - dashboardData.totalRevenue, // Simulează un obiectiv
                ],
                backgroundColor: ["#4caf50", "#e0e0e0"],
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: true,
            circumference: 180,
            rotation: -90,
            cutout: "80%",
            plugins: {
              legend: { display: false },
            },
          }}
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      )}
    </div>
  </div>
  <div className={styles.chartsultimatedashboardoverview}>
<div className={styles.chartContainerultimatedashboardoverview} id="completeLoads">
  <div className={styles.chartHeaderultimatedashboardoverview}>
    <h4>Loads by Status</h4>
    <ChartMenu
      chartKey="completeLoads"
      chartTitle="Loads by Status (Completed / Canceled / Open)"

        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>

    <div className={styles.chartContentultimatedashboardoverview} style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
      {chartTypes.completeLoads === "Doughnut" && (
  <Doughnut
    data={{
      labels: ["Completed", "Canceled", "Open"],       // ← AICI
      datasets: [
        {
          data: [
            dashboardData.completeLoads,
            dashboardData.canceledLoads,
            dashboardData.incompleteLoads,             // “Open”
          ],
          backgroundColor: ["#4caf50", "#ff5722", "#ffc107"],
        },
      ],
    }}
    options={{
      responsive: true,
      maintainAspectRatio: false,
      plugins: { legend: { display: true } },
    }}
  />
)}

    {chartTypes.completeLoads === "Bar" && (
  <Bar
    data={{
      labels: ["Completed", "Canceled", "Open"],        // ← AICI
      datasets: [
        {
          label: "Load Status",
          data: [
            dashboardData.completeLoads,
            dashboardData.canceledLoads,
            dashboardData.incompleteLoads,
          ],
          backgroundColor: ["#4caf50", "#ff5722", "#ffc107"],
        },
      ],
    }}
    options={{ responsive: true, maintainAspectRatio: false }}
  />
)}

{chartTypes.completeLoads === "Column" && (
  <Bar
    data={{
      labels: ["Completed", "Canceled", "Open"],        // ← AICI
      datasets: [
        {
          label: "Load Status",
          data: [
            dashboardData.completeLoads,
            dashboardData.canceledLoads,
            dashboardData.incompleteLoads,
          ],
          backgroundColor: ["#4caf50", "#ff5722", "#ffc107"],
        },
      ],
    }}
    options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
  />
)}

     {chartTypes.completeLoads === "Pie" && (
  <Pie
    data={{
      labels: ["Completed", "Canceled", "Open"],        // ← AICI
      datasets: [
        {
          data: [
            dashboardData.completeLoads,
            dashboardData.canceledLoads,
            dashboardData.incompleteLoads,
          ],
          backgroundColor: ["#4caf50", "#ff5722", "#ffc107"],
        },
      ],
    }}
    options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: true } } }}
  />
)}
{chartTypes.completeLoads === "Gauge" && (
  <Doughnut
    data={{
      labels: ["Completed", "Remaining"],
      datasets: [
        {
          data: [
            dashboardData.completeLoads,
            (dashboardData.canceledLoads || 0) + (dashboardData.incompleteLoads || 0),
          ],
          backgroundColor: ["#4caf50", "#e0e0e0"],
        },
      ],
    }}
    options={{
      responsive: true,
      maintainAspectRatio: false,
      circumference: 180,
      rotation: -90,
      cutout: "80%",
      plugins: { legend: { display: false } },
    }}
  />
)}

    </div>
  </div>
</div>
  <div className={styles.chartsultimatedashboardoverview}>
  <div className={styles.chartContainerultimatedashboardoverview} id="dispatcherComparison">
    <div className={styles.chartHeaderultimatedashboardoverview}>
      <h4>Compare Dispatchers</h4>
   
    </div>

    <div className={styles.chartContentultimatedashboardoverview}>
      <Bar
        data={{
          labels: dashboardData.dispatcherComparison?.map(d => d.name),
          datasets: [
            {
              label: "Number of Loads",
              data: dashboardData.dispatcherComparison?.map(d => d.loadCount),
              backgroundColor: "rgba(54, 162, 235, 0.7)"
            },
            {
              label: "Total Revenue ($)",
              data: dashboardData.dispatcherComparison?.map(d => d.totalRevenue),
              backgroundColor: "rgba(255, 99, 132, 0.7)"
            }
          ]
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: { beginAtZero: true }
          }
        }}
      />
    </div>
  </div>
</div>

<div className={styles.chartsultimatedashboardoverview}>
  {/* ✅ Loads per Driver */}
  <div className={styles.chartContainerultimatedashboardoverview} id="loadsPerDriver">
    <div className={styles.chartHeaderultimatedashboardoverview}>
      <h4>Loads per Driver</h4>
      <ChartMenu
        chartKey="loadsPerDriver"
        chartTitle="Loads per Driver"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>

    <div className={styles.chartContentultimatedashboardoverview}>
      {/* ✅ Bar Chart */}
      {chartTypes.loadsPerDriver === "Bar" && (
        <Bar
          data={{
            labels: dashboardData.loadsPerDriver.map((d) => d.name),
            datasets: [
              {
                label: "Loads",
                data: dashboardData.loadsPerDriver.map((d) => d.count),
                backgroundColor: "blue",
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Column Chart */}
      {chartTypes.loadsPerDriver === "Column" && (
        <Bar
          data={{
            labels: dashboardData.loadsPerDriver.map((d) => d.name),
            datasets: [
              {
                label: "Loads",
                data: dashboardData.loadsPerDriver.map((d) => d.count),
                backgroundColor: "blue",
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* ✅ Pie Chart */}
      {chartTypes.loadsPerDriver === "Pie" && (
        <Pie
          data={{
            labels: dashboardData.loadsPerDriver.map((d) => d.name),
            datasets: [
              {
                data: dashboardData.loadsPerDriver.map((d) => d.count),
                backgroundColor: ["#3b82f6", "#ff9800", "#4caf50", "#e91e63"],
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Doughnut Chart */}
      {chartTypes.loadsPerDriver === "Doughnut" && (
        <Doughnut
          data={{
            labels: dashboardData.loadsPerDriver.map((d) => d.name),
            datasets: [
              {
                data: dashboardData.loadsPerDriver.map((d) => d.count),
                backgroundColor: ["#3b82f6", "#ff9800", "#4caf50", "#e91e63"],
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Gauge Chart */}
      {chartTypes.loadsPerDriver === "Gauge" && (
        <Doughnut
          data={{
            labels: ["Loads Assigned", "Remaining Capacity"],
            datasets: [
              {
                data: [
                  dashboardData.loadsPerDriver.reduce((acc, d) => acc + d.count, 0),
                  100 - dashboardData.loadsPerDriver.reduce((acc, d) => acc + d.count, 0),
                ],
                backgroundColor: ["#4caf50", "#e0e0e0"],
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            circumference: 180,
            rotation: -90,
            cutout: "80%",
          }}
        />
      )}
    </div>
  </div>
</div>
{/* 🔹 Revenue per Mile Trend */}
<div className={styles.chartContainerultimatedashboardoverview}>
  <div className={styles.chartHeaderultimatedashboardoverview}>
    <h4>Revenue per Mile Trend</h4>
  </div>
  <div className={styles.chartContentultimatedashboardoverview}>
    <Line
      data={{
        labels: (dashboardData.loadsByDate || []).map(d => d.date),
        datasets: [
          {
            label: "Revenue per Mile ($)",
            data: (dashboardData.loadsByDate || []).map(d =>
              d.totalMiles > 0 ? (d.totalRevenue / d.totalMiles).toFixed(2) : 0
            ),
            borderColor: "#00c6ff",
            backgroundColor: "rgba(0, 198, 255, 0.2)",
            tension: 0.3,
            fill: true,
          },
        ],
      }}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: true, labels: { color: "#fff" } },
        },
        scales: {
          x: {
            ticks: { color: "#fff" },
            grid: { color: "rgba(255,255,255,0.1)" },
          },
          y: {
            ticks: { color: "#fff" },
            grid: { color: "rgba(255,255,255,0.1)" },
          },
        },
      }}
    />
  </div>
</div>

<div className={styles.chartsultimatedashboardoverview}>
  {/* ✅ Loads per Truck */}
  <div className={styles.chartContainerultimatedashboardoverview} id="loadsPerTruck">
    <div className={styles.chartHeaderultimatedashboardoverview}>
      <h4>Loads per Truck</h4>
      <ChartMenu
        chartKey="loadsPerTruck"
        chartTitle="Loads per Truck"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>

    <div className={styles.chartContentultimatedashboardoverview}>
      {/* ✅ Bar Chart */}
      {chartTypes.loadsPerTruck === "Bar" && (
        <Bar
          data={{
            labels: dashboardData.loadsPerTruck.map((t) => t.name),
            datasets: [
              {
                label: "Loads",
                data: dashboardData.loadsPerTruck.map((t) => t.count),
                backgroundColor: "orange",
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Column Chart */}
      {chartTypes.loadsPerTruck === "Column" && (
        <Bar
          data={{
            labels: dashboardData.loadsPerTruck.map((t) => t.name),
            datasets: [
              {
                label: "Loads",
                data: dashboardData.loadsPerTruck.map((t) => t.count),
                backgroundColor: "orange",
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* ✅ Pie Chart */}
      {chartTypes.loadsPerTruck === "Pie" && (
        <Pie
          data={{
            labels: dashboardData.loadsPerTruck.map((t) => t.name),
            datasets: [
              {
                data: dashboardData.loadsPerTruck.map((t) => t.count),
                backgroundColor: ["#f4a261", "#264653", "#2a9d8f", "#e76f51"],
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Doughnut Chart */}
      {chartTypes.loadsPerTruck === "Doughnut" && (
        <Doughnut
          data={{
            labels: dashboardData.loadsPerTruck.map((t) => t.name),
            datasets: [
              {
                data: dashboardData.loadsPerTruck.map((t) => t.count),
                backgroundColor: ["#f4a261", "#264653", "#2a9d8f", "#e76f51"],
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Gauge Chart */}
      {chartTypes.loadsPerTruck === "Gauge" && (
        <Doughnut
          data={{
            labels: ["Loads Assigned", "Remaining Capacity"],
            datasets: [
              {
                data: [
                  dashboardData.loadsPerTruck.reduce((acc, t) => acc + t.count, 0),
                  100 - dashboardData.loadsPerTruck.reduce((acc, t) => acc + t.count, 0),
                ],
                backgroundColor: ["#4caf50", "#e0e0e0"],
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            circumference: 180,
            rotation: -90,
            cutout: "80%",
          }}
        />
      )}
    </div>
  </div>
</div>
</div>

<div className={styles.chartsultimatedashboardoverview}>
<div className={styles.chartContainerultimatedashboardoverview} id="fuelCosts">
  <div className={styles.chartHeaderultimatedashboardoverview}>
    <h4 className={styles.chartTitleCenterultimatedashboardoverview}>
      Fuel Costs Over Time
    </h4>
    <div className={styles.chartMenuRightultimatedashboardoverview}>
      <ChartMenu
        chartKey="fuelCosts"
        chartTitle="Fuel Costs Over Time"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>
  </div>

  <div className={styles.chartContentultimatedashboardoverview}>
    {isLoadingFuelAggregated ? (
      <p style={{ textAlign: "center", fontWeight: "bold" }}>⏳ Loading fuel data...</p>
    ) : fuelCostsAggregated.length > 0 ? (
      <>
        {/* ── Line ── */}
        {chartTypes.fuelCosts === "Line" && (
          <Line
            data={{
              labels: fuelCostsAggregated.map(f => f.date),
              datasets: [
                {
                  label: "Fuel Reports",
                  data: fuelCostsAggregated.map(f => f.fuelReportTotal),
                  borderColor: "#3b82f6",
                  backgroundColor: "rgba(59,130,246,0.15)",
                  fill: true,
                  tension: 0.4,
                },
                {
                  label: "DriverPay Fuel",
                  data: fuelCostsAggregated.map(f => f.driverPayFuelTotal),
                  borderColor: "#f59e0b",
                  backgroundColor: "rgba(245,158,11,0.15)",
                  fill: true,
                  tension: 0.4,
                },
                {
                  label: "FleetReport Fuel",
                  data: fuelCostsAggregated.map(f => f.fleetReportFuelTotal),
                  borderColor: "#8b5cf6",
                  backgroundColor: "rgba(139,92,246,0.15)",
                  fill: true,
                  tension: 0.4,
                },
                {
                  label: "Grand Total",
                  data: fuelCostsAggregated.map(f => f.grandTotal),
                  borderColor: "#22c55e",
                  backgroundColor: "rgba(34,197,94,0.1)",
                  fill: false,
                  borderDash: [6, 3],
                  tension: 0.4,
                },
              ],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ── Bar ── */}
        {chartTypes.fuelCosts === "Bar" && (
          <Bar
            data={{
              labels: fuelCostsAggregated.map(f => f.date),
              datasets: [
                {
                  label: "Fuel Reports",
                  data: fuelCostsAggregated.map(f => f.fuelReportTotal),
                  backgroundColor: "#3b82f6",
                },
                {
                  label: "DriverPay Fuel",
                  data: fuelCostsAggregated.map(f => f.driverPayFuelTotal),
                  backgroundColor: "#f59e0b",
                },
                {
                  label: "FleetReport Fuel",
                  data: fuelCostsAggregated.map(f => f.fleetReportFuelTotal),
                  backgroundColor: "#8b5cf6",
                },
              ],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ── Column ── */}
        {chartTypes.fuelCosts === "Column" && (
          <Bar
            data={{
              labels: fuelCostsAggregated.map(f => f.date),
              datasets: [
                {
                  label: "Fuel Reports",
                  data: fuelCostsAggregated.map(f => f.fuelReportTotal),
                  backgroundColor: "#3b82f6",
                },
                {
                  label: "DriverPay Fuel",
                  data: fuelCostsAggregated.map(f => f.driverPayFuelTotal),
                  backgroundColor: "#f59e0b",
                },
                {
                  label: "FleetReport Fuel",
                  data: fuelCostsAggregated.map(f => f.fleetReportFuelTotal),
                  backgroundColor: "#8b5cf6",
                },
              ],
            }}
            options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
          />
        )}

        {/* ── Pie ── */}
        {chartTypes.fuelCosts === "Pie" && (
          <Pie
            data={{
              labels: ["Fuel Reports", "DriverPay Fuel", "FleetReport Fuel"],
              datasets: [{
                data: [
                  fuelCostsAggregated.reduce((s, f) => s + f.fuelReportTotal, 0),
                  fuelCostsAggregated.reduce((s, f) => s + f.driverPayFuelTotal, 0),
                  fuelCostsAggregated.reduce((s, f) => s + f.fleetReportFuelTotal, 0),
                ],
                backgroundColor: ["#3b82f6", "#f59e0b", "#8b5cf6"],
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ── Doughnut ── */}
        {chartTypes.fuelCosts === "Doughnut" && (
          <Doughnut
            data={{
              labels: ["Fuel Reports", "DriverPay Fuel", "FleetReport Fuel"],
              datasets: [{
                data: [
                  fuelCostsAggregated.reduce((s, f) => s + f.fuelReportTotal, 0),
                  fuelCostsAggregated.reduce((s, f) => s + f.driverPayFuelTotal, 0),
                  fuelCostsAggregated.reduce((s, f) => s + f.fleetReportFuelTotal, 0),
                ],
                backgroundColor: ["#3b82f6", "#f59e0b", "#8b5cf6"],
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ── Gauge ── */}
        {chartTypes.fuelCosts === "Gauge" && (
          <Doughnut
            data={{
              labels: ["Total Fuel", "Remaining"],
              datasets: [{
                data: [
                  fuelCostsAggregated.reduce((s, f) => s + f.grandTotal, 0),
                  Math.max(0, 100000 - fuelCostsAggregated.reduce((s, f) => s + f.grandTotal, 0)),
                ],
                backgroundColor: ["#3b82f6", "#1e293b"],
                borderWidth: 0,
              }],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              circumference: 180,
              rotation: -90,
              cutout: "80%",
              plugins: { legend: { display: false } },
            }}
          />
        )}
      </>
    ) : (
      <p style={{ textAlign: "center", fontWeight: "bold" }}>
        No fuel cost data available
      </p>
    )}
  </div>
</div>
  

  </div>
  <div className={styles.chartsultimatedashboardoverview}>
  <div className={styles.chartContainerultimatedashboardoverview} id="estimatedProfit">
    <div className={styles.chartHeaderultimatedashboardoverview}>
      <h4>Estimated Profit Over Time</h4>
  
    </div>

   <div className={styles.chartContentultimatedashboardoverview}>
  {(() => {
    const profit = Number(dashboardData.estimatedProfit) || 0;
    const revenue = Number(dashboardData.totalRevenue) || 0;

    // dacă revenue e 0, punem [0,1] ca să se vadă semidonutul gri
    const remaining = Math.max(0, revenue - profit);
    const dataValues = revenue > 0
      ? [Math.max(0, profit), remaining]
      : [0, 1];

    return (
      <Doughnut
        data={{
          labels: ["Estimated Profit", "Remaining vs Revenue"],
          datasets: [
            {
              data: dataValues,
              backgroundColor: ["#4caf50", "#e0e0e0"],
            },
          ],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180, // semicerc
          rotation: -90,      // începe de sus
          cutout: "80%",      // aspect de gauge
          plugins: { legend: { display: false } },
        }}
      />
    );
  })()}
</div>
</div>
</div>
<div className={styles.chartsultimatedashboardoverview}>
 <div className={styles.chartContainerultimatedashboardoverview} id="driverPayComparison">
  <div className={styles.chartHeaderultimatedashboardoverview}>
    <h4>DriverPay Comparison</h4>
    <ChartMenu
      chartKey="driverPayComparison"
      chartTitle="DriverPay Comparison"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>

  {isLoadingDriverPayAggregated ? (
    <p style={{ textAlign: "center", fontWeight: "bold" }}>⏳ Loading...</p>
  ) : driverPayAggregated.length === 0 ? (
    <p style={{ textAlign: "center", fontWeight: "bold" }}>No DriverPay data available</p>
  ) : (
    <div className={styles.chartContentultimatedashboardoverview}>

      {/* ── Bar ── */}
      {chartTypes.driverPayComparison === "Bar" && (
        <Bar
          data={{
            labels: driverPayAggregated.map(d => d.name),
            datasets: [
              {
                label: "Base Pay ($)",
                data: driverPayAggregated.map(d => d.totalPay),
                backgroundColor: "#3b82f6",
              },
              {
                label: "Additions ($)",
                data: driverPayAggregated.map(d => d.totalAdditions),
                backgroundColor: "#22c55e",
              },
              {
                label: "Deductions ($)",
                data: driverPayAggregated.map(d => d.totalDeductions),
                backgroundColor: "#ef4444",
              },
              {
                label: "Net Pay ($)",
                data: driverPayAggregated.map(d => d.totalWithAdjustments),
                backgroundColor: "#f59e0b",
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { position: "top" },
              tooltip: {
                callbacks: {
                  afterBody: (items) => {
                    const idx = items[0]?.dataIndex;
                    const d = driverPayAggregated[idx];
                    if (!d) return [];
                    return [
                      `Fuel Deductions: $${d.fuelDeductions.toFixed(2)}`,
                      `Settlements: ${d.settlements}`,
                    ];
                  },
                },
              },
            },
            scales: { y: { beginAtZero: true } },
          }}
        />
      )}

      {/* ── Column (horizontal) ── */}
      {chartTypes.driverPayComparison === "Column" && (
        <Bar
          data={{
            labels: driverPayAggregated.map(d => d.name),
            datasets: [
              {
                label: "Base Pay ($)",
                data: driverPayAggregated.map(d => d.totalPay),
                backgroundColor: "#3b82f6",
              },
              {
                label: "Additions ($)",
                data: driverPayAggregated.map(d => d.totalAdditions),
                backgroundColor: "#22c55e",
              },
              {
                label: "Deductions ($)",
                data: driverPayAggregated.map(d => d.totalDeductions),
                backgroundColor: "#ef4444",
              },
              {
                label: "Net Pay ($)",
                data: driverPayAggregated.map(d => d.totalWithAdjustments),
                backgroundColor: "#f59e0b",
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            indexAxis: "y",
            plugins: { legend: { position: "top" } },
            scales: { x: { beginAtZero: true } },
          }}
        />
      )}

      {/* ── Line ── */}
      {chartTypes.driverPayComparison === "Line" && (
        <Line
          data={{
            labels: driverPayAggregated.map(d => d.name),
            datasets: [
              {
                label: "Base Pay ($)",
                data: driverPayAggregated.map(d => d.totalPay),
                borderColor: "#3b82f6",
                fill: false,
                tension: 0.3,
              },
              {
                label: "Additions ($)",
                data: driverPayAggregated.map(d => d.totalAdditions),
                borderColor: "#22c55e",
                fill: false,
                tension: 0.3,
              },
              {
                label: "Deductions ($)",
                data: driverPayAggregated.map(d => d.totalDeductions),
                borderColor: "#ef4444",
                fill: false,
                tension: 0.3,
              },
              {
                label: "Net Pay ($)",
                data: driverPayAggregated.map(d => d.totalWithAdjustments),
                borderColor: "#f59e0b",
                fill: false,
                tension: 0.3,
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { position: "top" } },
          }}
        />
      )}

      {/* ── Pie — Net Pay per driver ── */}
      {chartTypes.driverPayComparison === "Pie" && (
        <Pie
          data={{
            labels: driverPayAggregated.map(d => d.name),
            datasets: [{
              data: driverPayAggregated.map(d => d.totalWithAdjustments),
              backgroundColor: [
                "#3b82f6","#22c55e","#f59e0b",
                "#ef4444","#8b5cf6","#14b8a6",
                "#f43f5e","#84cc16","#0ea5e9",
              ],
            }],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { position: "right" } },
          }}
        />
      )}

      {/* ── Doughnut ── */}
      {chartTypes.driverPayComparison === "Doughnut" && (
        <Doughnut
          data={{
            labels: driverPayAggregated.map(d => d.name),
            datasets: [{
              data: driverPayAggregated.map(d => d.totalWithAdjustments),
              backgroundColor: [
                "#3b82f6","#22c55e","#f59e0b",
                "#ef4444","#8b5cf6","#14b8a6",
                "#f43f5e","#84cc16","#0ea5e9",
              ],
            }],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { position: "right" } },
          }}
        />
      )}

      {/* ── Gauge — total payroll ── */}
      {chartTypes.driverPayComparison === "Gauge" && (
        <Doughnut
          data={{
            labels: ["Total Payroll", ""],
            datasets: [{
              data: [
                driverPayAggregated.reduce((s, d) => s + d.totalWithAdjustments, 0),
                Math.max(0, 500000 - driverPayAggregated.reduce((s, d) => s + d.totalWithAdjustments, 0)),
              ],
              backgroundColor: ["#f59e0b", "#1e293b"],
              borderWidth: 0,
            }],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            circumference: 180,
            rotation: -90,
            cutout: "80%",
            plugins: { legend: { display: false } },
          }}
        />
      )}

      {/* ── Summary table sub chart ── */}
      <div style={{
        marginTop: 20,
        overflowX: "auto",
        fontSize: "12px",
      }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
              <th style={{ textAlign: "left",  padding: "6px 10px", color: "#94a3b8" }}>Driver</th>
              <th style={{ textAlign: "right", padding: "6px 10px", color: "#94a3b8" }}>Base Pay</th>
              <th style={{ textAlign: "right", padding: "6px 10px", color: "#22c55e" }}>+ Additions</th>
              <th style={{ textAlign: "right", padding: "6px 10px", color: "#ef4444" }}>- Deductions</th>
              <th style={{ textAlign: "right", padding: "6px 10px", color: "#ef4444" }}>⛽ Fuel Ded.</th>
              <th style={{ textAlign: "right", padding: "6px 10px", color: "#f59e0b" }}>Net Pay</th>
              <th style={{ textAlign: "right", padding: "6px 10px", color: "#94a3b8" }}>Settlements</th>
            </tr>
          </thead>
          <tbody>
            {driverPayAggregated.map((d, i) => (
              <tr
                key={i}
                style={{
                  borderBottom: "1px solid rgba(255,255,255,0.05)",
                  background: i % 2 === 0 ? "rgba(255,255,255,0.02)" : "transparent",
                }}
              >
                <td style={{ padding: "6px 10px", color: "#f1f5f9", fontWeight: 600 }}>
                  {d.name}
                </td>
                <td style={{ padding: "6px 10px", textAlign: "right", color: "#cbd5e1" }}>
                  ${d.totalPay.toFixed(2)}
                </td>
                <td style={{ padding: "6px 10px", textAlign: "right", color: "#22c55e" }}>
                  +${d.totalAdditions.toFixed(2)}
                </td>
                <td style={{ padding: "6px 10px", textAlign: "right", color: "#ef4444" }}>
                  -${d.totalDeductions.toFixed(2)}
                </td>
                <td style={{ padding: "6px 10px", textAlign: "right", color: "#f87171" }}>
                  -${d.fuelDeductions.toFixed(2)}
                </td>
                <td style={{ padding: "6px 10px", textAlign: "right", color: "#f59e0b", fontWeight: 700 }}>
                  ${d.totalWithAdjustments.toFixed(2)}
                </td>
                <td style={{ padding: "6px 10px", textAlign: "right", color: "#64748b" }}>
                  {d.settlements}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ borderTop: "2px solid rgba(245,158,11,0.3)" }}>
              <td style={{ padding: "8px 10px", color: "#f59e0b", fontWeight: 700 }}>TOTAL</td>
              <td style={{ padding: "8px 10px", textAlign: "right", color: "#cbd5e1", fontWeight: 700 }}>
                ${driverPayAggregated.reduce((s, d) => s + d.totalPay, 0).toFixed(2)}
              </td>
              <td style={{ padding: "8px 10px", textAlign: "right", color: "#22c55e", fontWeight: 700 }}>
                +${driverPayAggregated.reduce((s, d) => s + d.totalAdditions, 0).toFixed(2)}
              </td>
              <td style={{ padding: "8px 10px", textAlign: "right", color: "#ef4444", fontWeight: 700 }}>
                -${driverPayAggregated.reduce((s, d) => s + d.totalDeductions, 0).toFixed(2)}
              </td>
              <td style={{ padding: "8px 10px", textAlign: "right", color: "#f87171", fontWeight: 700 }}>
                -${driverPayAggregated.reduce((s, d) => s + d.fuelDeductions, 0).toFixed(2)}
              </td>
              <td style={{ padding: "8px 10px", textAlign: "right", color: "#f59e0b", fontWeight: 700 }}>
                ${driverPayAggregated.reduce((s, d) => s + d.totalWithAdjustments, 0).toFixed(2)}
              </td>
              <td style={{ padding: "8px 10px", textAlign: "right", color: "#64748b", fontWeight: 700 }}>
                {driverPayAggregated.reduce((s, d) => s + d.settlements, 0)}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

    </div>
  )}
</div>
</div>
  <div className={styles.chartsultimatedashboardoverview}>
  <div className={styles.chartContainerultimatedashboardoverview} id="employeesPayrolls">
    <div className={styles.chartHeaderultimatedashboardoverview}>
      <h4>Payrolls Comparison</h4>
      <ChartMenu
        chartKey="driverPayrolls"             // păstrează cheia ca să nu schimbi meniurile existente
        chartTitle="Payrolls Comparison"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>

    {employeesPayrolls.length === 0 ? (
      <p style={{ textAlign: "center", fontWeight: "bold" }}>
        No payroll data available
      </p>
    ) : (
      <div className={styles.chartContentultimatedashboardoverview}>
        {chartTypes.driverPayrolls === "Bar" && (
          <Bar
            data={{
              labels: employeesPayrolls.map(e => e.name),
              datasets: [{
                label: "Total Pay ($)",
                data: employeesPayrolls.map(e => e.total),
                backgroundColor: "green",
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.driverPayrolls === "Column" && (
          <Bar
            data={{
              labels: employeesPayrolls.map(e => e.name),
              datasets: [{
                label: "Total Pay ($)",
                data: employeesPayrolls.map(e => e.total),
                backgroundColor: "green",
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
          />
        )}

        {chartTypes.driverPayrolls === "Pie" && (
          <Pie
            data={{
              labels: employeesPayrolls.map(e => e.name),
              datasets: [{
                data: employeesPayrolls.map(e => e.total),
                backgroundColor: ["#4caf50", "#ff5722", "#ffc107", "#3b82f6", "#8e44ad", "#2ecc71"],
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.driverPayrolls === "Doughnut" && (
          <Doughnut
            data={{
              labels: employeesPayrolls.map(e => e.name),
              datasets: [{
                data: employeesPayrolls.map(e => e.total),
                backgroundColor: ["#4caf50", "#ff5722", "#ffc107", "#3b82f6", "#8e44ad", "#2ecc71"],
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.driverPayrolls === "Line" && (
          <Line
            data={{
              labels: employeesPayrolls.map(e => e.name),
              datasets: [{
                label: "Total Pay ($)",
                data: employeesPayrolls.map(e => e.total),
                borderColor: "green",
                fill: false
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.driverPayrolls === "Gauge" && (
          <Doughnut
            data={{
              labels: employeesPayrolls.map(e => e.name),
              datasets: [{
                data: employeesPayrolls.map(e => e.total),
                backgroundColor: ["#4caf50", "#ff5722", "#ffc107", "#3b82f6", "#8e44ad", "#2ecc71"],
              }],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              circumference: 180,
              rotation: -90,
              cutout: "80%",
            }}
          />
        )}
      </div>
    )}
  </div>
</div>

 
        <div className={styles.progressSectionultimatedashboardoverview}>
      <h4>Manage Progress Goals</h4>

      {/* Adaugă un nou obiectiv */}
      <div className={styles.addGoalultimatedashboardoverview}>
        <label>Goal Type:</label>
        <select value={newGoalType} onChange={(e) => setNewGoalType(e.target.value)}>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
          <option value="yearly">Yearly</option>
          <option value="custom">Custom Range</option>
        </select>

        {newGoalType === "custom" && (
          <div>
            <label>From:</label>
            <input type="date" value={customStartDate} onChange={(e) => setCustomStartDate(e.target.value)} />
            <label>To:</label>
            <input type="date" value={customEndDate} onChange={(e) => setCustomEndDate(e.target.value)} />
          </div>
        )}

        <label>Target Revenue ($):</label>
        <input type="number" value={newGoalValue} onChange={(e) => setNewGoalValue(Number(e.target.value))} />

        <button onClick={addNewGoal}>Add Goal</button>
      </div>

      {/* Selectează un obiectiv existent */}
      <div className={styles.goalSelectorultimatedashboardoverview}>
        <label>Select a goal:</label>
       <select
  value={selectedGoal?.id || ""}
  onChange={(e) => {
    const val = e.target.value; // string
    const found = progressGoals.find((g) => String(g.id) === String(val));
    setSelectedGoal(found || null);
  }}
>
  <option value="">-- Select --</option>
  {progressGoals.map((goal) => (
    <option key={goal.id} value={goal.id}>
      {goal.type?.toUpperCase()} - ${goal.value}
    </option>
  ))}
</select>

      </div>
{selectedGoal && (() => {
  const achieved = computeAchievedForGoal(selectedGoal);        // 💡 suma reală atinsă
  const target = Number(selectedGoal.value) || 0;
  const pct = target > 0 ? Math.max(0, Math.min(100, (achieved / target) * 100)) : 0;

  const containerStyle = {
    width: "100%",
    height: "20px",
    background: "rgba(0,0,0,0.1)",
    borderRadius: "10px",
    overflow: "hidden",
    position: "relative",
    margin: "8px 0",
  };
  const barStyle = {
    width: `${pct}%`,
    height: "100%",
    background: "linear-gradient(90deg, #22c55e, #16a34a)",
    transition: "width 300ms ease",
  };
  const labelStyle = {
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "20px",
    color: "#111827",
  };

  return (
    <div className={styles.progressContainerultimatedashboardoverview}>
      <h4>Progress for {selectedGoal.type?.toUpperCase()} Goal</h4>

      <div className={styles.progressBarContainer} style={containerStyle}>
        <div className={styles.progressBar} style={barStyle} />
        <span className={styles.progressLabel} style={labelStyle}>
          {pct.toFixed(2)}%
        </span>
      </div>

      <div style={{display:"flex",gap:8,alignItems:"center"}}>
        <small><strong>Tracked:</strong> ${achieved.toLocaleString()} / ${target.toLocaleString()}</small>
      </div>

      <label style={{marginTop:8, display:"block"}}>Update Progress (override):</label>
      <input
        type="number"
        value={Number.isFinite(selectedGoal.progress) ? selectedGoal.progress : 0}
        onChange={(e) => {
          const val = Number(e.target.value) || 0;
          setSelectedGoal((prev) => (prev ? { ...prev, progress: val } : prev)); // UI instant
          updateProgress(selectedGoal.id, val); // trimite la server
        }}
      />
    </div>
  );
})()}


    </div>


      </div>
      <EmailPanel />
    </div>
  );
};

const LoadsDashboard = ({ onNavigate, loads, drivers, trucks }) => {
  const [selectedStatus, setSelectedStatus] = useState("Open");
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedLoad, setSelectedLoad] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  const itemsPerPage = 25;

  useEffect(() => {
    filterLoads();
  }, [selectedStatus, selectedDriver, loads, startDate, endDate]);

  const filterLoads = () => {
    let filtered = loads.filter(
      (load) =>
        (selectedStatus === "Open" && !["Completed"].includes(load.status)) ||
        load.status === selectedStatus
    );
    

    if (selectedDriver) {
      filtered = filtered.filter((load) => load.driver === selectedDriver.value);
    }
    if (startDate && endDate) {
      filtered = filtered.filter(
        (load) =>
          new Date(load.createdAt) >= startDate && new Date(load.createdAt) <= endDate
      );
    }
    setFilteredLoads(filtered);
  };

  const paginatedLoads = filteredLoads.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleStatusChange = (status) => {
    setSelectedStatus(status);
    setCurrentPage(1);
  };

  const handleDriverChange = (driver) => {
    setSelectedDriver(driver);
    setCurrentPage(1);
  };

  const handleLoadClick = (load) => {
    setSelectedLoad(load);
  };

  const closeDetails = () => {
    setSelectedLoad(null);
  };

  const averageRate = (loadsArray) =>
    loadsArray.length
      ? loadsArray.reduce((total, load) => total + load.rate, 0) / loadsArray.length
      : 0;

  const statusDistributionData = {
    labels: ["Open", "Completed", "Cancelled"],
    datasets: [
      {
        label: "Percentage of Loads",
        data: [
          loads.filter((load) => load.status === "Open").length,
          loads.filter((load) => load.status === "Completed").length,
          loads.filter((load) => load.status === "Cancelled").length,
        ],
        backgroundColor: ["#36A2EB", "#4BC0C0", "#FF6384"],
      },
    ],
  };

  const driverPerformanceData = {
    labels: drivers.map((driver) => `${driver.firstName} ${driver.lastName}`),
    datasets: [
      {
        label: "Number of Loads",
        data: drivers.map(
          (driver) => loads.filter((load) => load.driver === driver._id).length
        ),
        backgroundColor: drivers.map(
          (_, index) =>
            `hsl(${(index / drivers.length) * 360}, 70%, 50%)` // Culori dinamice
        ),
      },
    ],
  };
  const completedLoads = loads.filter((load) => load.status === "Completed");
  const cancelledLoads = loads.filter((load) => load.status === "Cancelled");
  const openLoads = loads.filter((load) => !["Completed", "Cancelled"].includes(load.status));
// ── Chart helpers ─────────────────────────────────────────────────────────────
const darkGrid = { color: "rgba(255,255,255,0.06)" };

const tickStyle = {
  color: "#9A9AAF",
  font: { size: 11, family: "'DM Sans', sans-serif" },
};

const legendStyle = {
  labels: {
    color: "#F4F4F6",
    font: { size: 11, family: "'DM Sans', sans-serif" },
    boxWidth: 12,
    padding: 16,
  },
};

// ── 1. Revenue Over Time ──────────────────────────────────────────────────────
const revenueByMonth = {};
loads.forEach(l => {
  const d = new Date(l.createdAt);
  const key = d.toLocaleDateString("en-US", { month: "short", year: "numeric" });
  revenueByMonth[key] = (revenueByMonth[key] || 0) + (parseFloat(l.rate) || 0);
});
const sortedMonths = Object.keys(revenueByMonth).sort(
  (a, b) => new Date(a) - new Date(b)
);
const revenueOverTimeData = {
  labels: sortedMonths,
  datasets: [
    {
      label: "Revenue ($)",
      data: sortedMonths.map(k => revenueByMonth[k]),
      borderColor: "#F59E0B",
      backgroundColor: "rgba(245,158,11,0.12)",
      fill: true,
      tension: 0.45,
      pointBackgroundColor: "#FBBF24",
      pointBorderColor: "#07070C",
      pointBorderWidth: 2,
      pointRadius: 5,
      pointHoverRadius: 8,
      borderWidth: 2,
    },
    {
      label: "Avg Rate ($)",
      data: sortedMonths.map(k => {
        const monthLoads = loads.filter(l => {
          const d = new Date(l.createdAt);
          return d.toLocaleDateString("en-US", { month: "short", year: "numeric" }) === k;
        });
        return monthLoads.length
          ? monthLoads.reduce((s, l) => s + (parseFloat(l.rate) || 0), 0) / monthLoads.length
          : 0;
      }),
      borderColor: "#34D399",
      backgroundColor: "rgba(52,211,153,0.08)",
      fill: true,
      tension: 0.45,
      pointBackgroundColor: "#34D399",
      pointBorderColor: "#07070C",
      pointBorderWidth: 2,
      pointRadius: 4,
      borderWidth: 2,
      borderDash: [6, 3],
    },
  ],
};

// ── 2. Revenue per Driver ─────────────────────────────────────────────────────
const revenuePerDriverData = {
  labels: drivers.map(d => `${d.firstName} ${d.lastName}`),
  datasets: [{
    label: "Total Revenue ($)",
    data: drivers.map(d =>
      loads
        .filter(l => l.driver === d._id)
        .reduce((sum, l) => sum + (parseFloat(l.rate) || 0), 0)
    ),
    backgroundColor: drivers.map((_, i) =>
      `hsl(${(i / Math.max(drivers.length, 1)) * 280 + 30}, 75%, 58%)`
    ),
    borderRadius: 6,
    borderSkipped: false,
  }],
};

// ── 3. Status Doughnut ────────────────────────────────────────────────────────
const statusDoughnutData = {
  labels: ["Open", "Completed", "Cancelled"],
  datasets: [{
    data: [
      loads.filter(l => !["Completed","Cancelled"].includes(l.status)).length,
      loads.filter(l => l.status === "Completed").length,
      loads.filter(l => l.status === "Cancelled").length,
    ],
    backgroundColor: ["#F59E0B", "#34D399", "#F87171"],
    borderColor: ["#D97706", "#059669", "#DC2626"],
    borderWidth: 2,
    hoverOffset: 8,
  }],
};

// ── 4. Miles per Driver ───────────────────────────────────────────────────────
const milesPerDriverData = {
  labels: drivers.map(d => `${d.firstName} ${d.lastName}`),
  datasets: [{
    label: "Total Miles",
    data: drivers.map(d =>
      loads
        .filter(l => l.driver === d._id)
        .reduce((sum, l) => sum + (parseFloat(l.miles) || 0), 0)
    ),
    backgroundColor: "rgba(96,165,250,0.8)",
    borderColor: "#3B82F6",
    borderWidth: 1,
    borderRadius: 4,
  }],
};

  const rateComparisonData = {
    labels: ["Open", "Completed", "Cancelled"],
    datasets: [
      {
        label: "Average Rate",
        data: [
          averageRate(openLoads),
          averageRate(completedLoads),
          averageRate(cancelledLoads),
        ],
        borderColor: "#36A2EB",
        backgroundColor: "rgba(54,162,235,0.2)",
        fill: true,
      },
    ],
  };

       return (
    <div
  className={`${styles.loaddashboard} ${
    theme === "light" ? styles.loaddashboardLight : ""
  }`}
>

      {/* Side Menu */}
      <div className={styles.sidebarToggleLoad} onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
  ☰
</div>

      <aside className={`${styles.sidebarLoadDashboard} ${isSidebarOpen ? styles.sidebarOpenLoad : ''}`}>
  <ul>
    <li onClick={() => onNavigate('dashboard')}>Overview</li>
    <li onClick={() => onNavigate('driver-dashboard')}>Drivers</li>
    <li onClick={() => onNavigate('truck-dashboard')}>Trucks</li>
    <li onClick={() => onNavigate('load-dashboard')}>Loads</li>
  </ul>
</aside>

{/* ✅ Toolbar de filtre pe toată lățimea paginii */}
<div className={styles.filtersloaddashboardContainer}>
  {/* Stânga: Status + Driver */}
  <div className={styles.filtersLeft}>
    <Select
      className={styles.customLoadDashboardSelect}
      classNamePrefix="customLoadDashboardSelect"
      options={[
        { value: "Open", label: "Open" },
        { value: "Completed", label: "Completed" },
        { value: "Cancelled", label: "Cancelled" },
      ]}
      value={{ value: selectedStatus, label: selectedStatus }}
      onChange={(option) => handleStatusChange(option.value)}
      styles={{
        control: (base) => ({
          ...base,
          backgroundColor: "black",
          color: "white",
          border: "1px solid #555",
        }),
        singleValue: (base) => ({ ...base, color: "white" }),
        menu: (base) => ({ ...base, backgroundColor: "black" }),
        option: (base, { isSelected }) => ({
          ...base,
          backgroundColor: isSelected ? "#333" : "black",
          color: "white",
          ":hover": { backgroundColor: "#444" },
        }),
      }}
    />

    <Select
      className={styles.customLoadDashboardSelect}
      classNamePrefix="customLoadDashboardSelect"
      options={drivers.map((driver) => ({
        value: driver._id,
        label: `${driver.firstName} ${driver.lastName}`,
      }))}
      value={selectedDriver}
      onChange={handleDriverChange}
      placeholder="Select Driver"
      styles={{
        control: (base) => ({
          ...base,
          backgroundColor: "black",
          color: "white",
          border: "1px solid #555",
        }),
        singleValue: (base) => ({ ...base, color: "white" }),
        menu: (base) => ({ ...base, backgroundColor: "black" }),
        option: (base, { isSelected }) => ({
          ...base,
          backgroundColor: isSelected ? "#333" : "black",
          color: "white",
          ":hover": { backgroundColor: "#444" },
        }),
      }}
    />
  </div>

  {/* Dreapta: Date Pickers */}
  <div className={styles.filtersRight}>
    <DatePicker
      className={styles.customDatePicker}
      selected={startDate}
      onChange={(date) => setStartDate(date)}
      placeholderText="Start Date"
    />
    <DatePicker
      className={styles.customDatePicker}
      selected={endDate}
      onChange={(date) => setEndDate(date)}
      placeholderText="End Date"
    />
  </div>
</div>


      {/* Tabel cu loads */}
      <div className={styles.tableContainerloaddashboard}>
        <table className={styles.tableloaddashboard}>
          <thead>
            <tr>
              <th>Dispatcher</th>
              <th>Load Number</th>
              <th>Broker</th>
              <th>Equipment</th>
              <th>Driver</th>
              <th>Team Drivers</th>
              <th>Truck</th>
              <th>Shippers & Consignees</th>
              <th>Notes</th>
              <th>Rate</th>
              <th>Added Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {paginatedLoads.map((load) => (
              <tr key={load._id} onClick={() => handleLoadClick(load)}>
                <td>{load.dispatcher}</td>
                <td>{load.loadNumber}</td>
                <td>{load.brokerName}</td>
                <td>{load.equipment}</td>
              <td>
  {drivers.find((driver) => driver._id === load.driver) 
    ? `${drivers.find((driver) => driver._id === load.driver).firstName} ${drivers.find((driver) => driver._id === load.driver).lastName}` 
    : "No data"}
</td>

                <td>
                  {load.teamDrivers
                    .map((id) => drivers.find((driver) => driver._id === id)?.firstName)
                    .join(", ") || "No data"}
                </td>
               <td>
  {trucks.find((truck) => truck._id === load.truck) 
    ? `Truck ${trucks.find((truck) => truck._id === load.truck).truckNumber}` 
    : "No data"}
</td>

                <td>
                  {load.shippers.map((shipper) => shipper.address).join(", ")} to{" "}
                  {load.consignees.map((consignee) => consignee.address).join(", ")}
                </td>
                <td>{load.notes}</td>
                <td>${load.rate}</td>
                <td>{new Date(load.createdAt).toLocaleDateString()}</td>
                <td>{load.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Paginare */}
      <div className={styles.paginationloaddashboard}>
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => prev - 1)}
        >
          Previous
        </button>
        <span>Page {currentPage}</span>
        <button
          disabled={currentPage === Math.ceil(filteredLoads.length / itemsPerPage)}
          onClick={() => setCurrentPage((prev) => prev + 1)}
        >
          Next
        </button>
      </div>
{/* ═══ LOAD DETAILS MODAL — fixed overlay la nivel de pagină ═══ */}
{selectedLoad && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.72)",
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 3000,
      padding: "20px",
    }}
    onClick={(e) => { if (e.target === e.currentTarget) closeDetails(); }}
  >
    <div className={styles.loadDetailsloaddashboard}>
      {/* Close button */}
      <button onClick={closeDetails} className={styles.closeButtonloaddashboard}>
        ✕
      </button>

      {/* Header */}
      <h2>
        Load #{selectedLoad.loadNumber}
        <span style={{
          marginLeft: 12,
          fontSize: "0.85rem",
          fontWeight: 600,
          padding: "4px 12px",
          borderRadius: "100px",
          background: selectedLoad.status === "Completed"
            ? "rgba(34,197,94,0.15)"
            : selectedLoad.status === "Cancelled"
            ? "rgba(239,68,68,0.15)"
            : "rgba(245,158,11,0.15)",
          color: selectedLoad.status === "Completed"
            ? "#34D399"
            : selectedLoad.status === "Cancelled"
            ? "#F87171"
            : "#FBBF24",
          textTransform: "uppercase",
          letterSpacing: "0.05em",
          verticalAlign: "middle",
        }}>
          {selectedLoad.status}
        </span>
      </h2>

      {/* Route + Rate */}
      <p style={{ marginBottom: 20 }}>
        <strong style={{ color: "#F59E0B" }}>From:</strong>{" "}
        {selectedLoad.shippers.map((s) => s.address).join(", ")}
        {" → "}
        <strong style={{ color: "#F59E0B" }}>To:</strong>{" "}
        {selectedLoad.consignees.map((c) => c.address).join(", ")}
        <br />
        <strong style={{ color: "#F59E0B" }}>Rate:</strong> ${selectedLoad.rate}
        {"  "}
        <strong style={{ color: "#F59E0B" }}>Date:</strong>{" "}
        {new Date(selectedLoad.createdAt).toLocaleDateString()}
      </p>

      {/* Divider */}
      <div style={{
        height: 1,
        background: "linear-gradient(90deg,transparent,rgba(245,158,11,0.3),transparent)",
        margin: "0 0 20px",
      }} />

      {/* Two columns */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>

        {/* Load Status Progress */}
        <div>
          <h4 style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontSize: "0.75rem",
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            color: "#F59E0B",
            marginBottom: 12,
          }}>
            Load Status
          </h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {getStatusProgress(selectedLoad.status).map(({ status, completed }) => (
              <li
                key={status}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "7px 0",
                  borderBottom: "1px solid rgba(255,255,255,0.05)",
                  fontSize: "0.875rem",
                  color: completed ? "#F4F4F6" : "#5A5A72",
                  fontWeight: completed ? 600 : 400,
                }}
              >
                <span style={{
                  width: 18, height: 18,
                  borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0,
                  background: completed
                    ? "linear-gradient(135deg,#FBBF24,#F59E0B)"
                    : "rgba(255,255,255,0.06)",
                  border: completed
                    ? "none"
                    : "1px solid rgba(255,255,255,0.12)",
                  fontSize: "0.65rem",
                  color: completed ? "#07070C" : "transparent",
                  fontWeight: 700,
                }}>
                  {completed ? "✓" : ""}
                </span>
                {status}
              </li>
            ))}
          </ul>
        </div>

        {/* Payment Status Progress */}
        <div>
          <h4 style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontSize: "0.75rem",
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            color: "#F59E0B",
            marginBottom: 12,
          }}>
            Payment Status
          </h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {getPaymentProgress(selectedLoad.paymentStatus).map(({ status, completed }) => (
              <li
                key={status}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "7px 0",
                  borderBottom: "1px solid rgba(255,255,255,0.05)",
                  fontSize: "0.875rem",
                  color: completed ? "#F4F4F6" : "#5A5A72",
                  fontWeight: completed ? 600 : 400,
                }}
              >
                <span style={{
                  width: 18, height: 18,
                  borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0,
                  background: completed
                    ? "linear-gradient(135deg,#34D399,#059669)"
                    : "rgba(255,255,255,0.06)",
                  border: completed
                    ? "none"
                    : "1px solid rgba(255,255,255,0.12)",
                  fontSize: "0.65rem",
                  color: completed ? "#ffffff" : "transparent",
                  fontWeight: 700,
                }}>
                  {completed ? "✓" : ""}
                </span>
                {status}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Extra info dacă există */}
      {(selectedLoad.notes || selectedLoad.brokerName) && (
        <>
          <div style={{
            height: 1,
            background: "linear-gradient(90deg,transparent,rgba(245,158,11,0.2),transparent)",
            margin: "20px 0",
          }} />
          <div style={{ display: "flex", gap: 20, flexWrap: "wrap", fontSize: "0.875rem", color: "#9A9AAF" }}>
            {selectedLoad.brokerName && (
              <span>
                <strong style={{ color: "#F59E0B" }}>Broker:</strong> {selectedLoad.brokerName}
              </span>
            )}
            {selectedLoad.equipment && (
              <span>
                <strong style={{ color: "#F59E0B" }}>Equipment:</strong> {selectedLoad.equipment}
              </span>
            )}
            {selectedLoad.notes && (
              <span style={{ width: "100%" }}>
                <strong style={{ color: "#F59E0B" }}>Notes:</strong> {selectedLoad.notes}
              </span>
            )}
          </div>
        </>
      )}
    </div>
  </div>
)}
 {/* === Chart-uri și statistici === */}
{/* === 4 Charts Grid === */}
<div className={styles.chartsGridLoadDashboard}>

  {/* ── 1. Revenue Over Time (full width) ── */}
  <div className={`${styles.chartBoxLoadDashboard} ${styles.fullWidthChartLoadDashboard}`}>
    <h3 className={styles.chartTitleLoadDashboard}>
      Revenue Over Time
      <span style={{ fontSize: "0.72rem", fontWeight: 400, color: "#9A9AAF", marginLeft: 10, textTransform: "none", letterSpacing: 0 }}>
        Monthly total + average rate
      </span>
    </h3>
    <div className={styles.chartWrapperLoadDashboard}>
      <Line
        data={revenueOverTimeData}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          interaction: { mode: "index", intersect: false },
          plugins: {
            legend: legendStyle,
            tooltip: {
              backgroundColor: "rgba(10,10,17,0.95)",
              borderColor: "rgba(245,158,11,0.3)",
              borderWidth: 1,
              titleColor: "#FBBF24",
              bodyColor: "#F4F4F6",
              padding: 12,
              callbacks: {
                label: ctx => ` ${ctx.dataset.label}: $${ctx.raw.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
              },
            },
          },
          scales: {
            x: {
              grid: darkGrid,
              ticks: tickStyle,
              border: { color: "rgba(255,255,255,0.08)" },
            },
            y: {
              grid: darkGrid,
              ticks: {
                ...tickStyle,
                callback: v => `$${(v / 1000).toFixed(0)}k`,
              },
              border: { color: "rgba(255,255,255,0.08)" },
            },
          },
        }}
      />
    </div>
  </div>

  {/* ── 2. Revenue per Driver ── */}
  <div className={styles.chartBoxLoadDashboard}>
    <h3 className={styles.chartTitleLoadDashboard}>
      Revenue per Driver
    </h3>
    {/* KPI summary */}
    <div style={{ display: "flex", gap: 12, marginBottom: 14, flexWrap: "wrap" }}>
      {[
        { label: "Total Revenue", value: `$${loads.reduce((s, l) => s + (parseFloat(l.rate) || 0), 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`, color: "#F59E0B" },
        { label: "Avg per Driver", value: `$${drivers.length ? (loads.reduce((s, l) => s + (parseFloat(l.rate) || 0), 0) / drivers.length).toLocaleString("en-US", { maximumFractionDigits: 0 }) : 0}`, color: "#34D399" },
      ].map((k, i) => (
        <div key={i} style={{
          flex: 1, minWidth: 100,
          background: "rgba(255,255,255,0.035)",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: 8, padding: "8px 12px",
        }}>
          <div style={{ fontSize: 10, color: "#9A9AAF", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 3 }}>{k.label}</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: k.color, fontFamily: "'Barlow Condensed', sans-serif" }}>{k.value}</div>
        </div>
      ))}
    </div>
    <div className={styles.chartWrapperLoadDashboard}>
      <Bar
        data={revenuePerDriverData}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: "rgba(10,10,17,0.95)",
              borderColor: "rgba(245,158,11,0.3)",
              borderWidth: 1,
              titleColor: "#FBBF24",
              bodyColor: "#F4F4F6",
              padding: 12,
              callbacks: {
                label: ctx => ` Revenue: $${ctx.raw.toLocaleString("en-US", { minimumFractionDigits: 2 })}`,
              },
            },
          },
          scales: {
            x: {
              grid: { display: false },
              ticks: { ...tickStyle, maxRotation: 30 },
              border: { color: "rgba(255,255,255,0.08)" },
            },
            y: {
              grid: darkGrid,
              ticks: {
                ...tickStyle,
                callback: v => `$${(v / 1000).toFixed(0)}k`,
              },
              border: { color: "rgba(255,255,255,0.08)" },
            },
          },
        }}
      />
    </div>
  </div>

  {/* ── 3. Load Status Doughnut ── */}
  <div className={styles.chartBoxLoadDashboard}>
    <h3 className={styles.chartTitleLoadDashboard}>
      Load Status Breakdown
    </h3>
    {/* KPI pills */}
    <div style={{ display: "flex", gap: 10, marginBottom: 14, flexWrap: "wrap" }}>
      {[
        { label: "Open",      count: loads.filter(l => !["Completed","Cancelled"].includes(l.status)).length, color: "#F59E0B" },
        { label: "Completed", count: loads.filter(l => l.status === "Completed").length,  color: "#34D399" },
        { label: "Cancelled", count: loads.filter(l => l.status === "Cancelled").length,  color: "#F87171" },
      ].map((s, i) => (
        <div key={i} style={{
          flex: 1, minWidth: 72,
          background: "rgba(255,255,255,0.035)",
          border: `1px solid ${s.color}33`,
          borderRadius: 8, padding: "7px 10px", textAlign: "center",
        }}>
          <div style={{ fontSize: 18, fontWeight: 800, color: s.color, fontFamily: "'Barlow Condensed', sans-serif", lineHeight: 1 }}>{s.count}</div>
          <div style={{ fontSize: 10, color: "#9A9AAF", textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 3 }}>{s.label}</div>
        </div>
      ))}
    </div>
    <div className={styles.chartWrapperLoadDashboard}>
      <Doughnut
        data={statusDoughnutData}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          cutout: "68%",
          plugins: {
            legend: {
              ...legendStyle,
              position: "bottom",
            },
            tooltip: {
              backgroundColor: "rgba(10,10,17,0.95)",
              borderColor: "rgba(245,158,11,0.3)",
              borderWidth: 1,
              titleColor: "#FBBF24",
              bodyColor: "#F4F4F6",
              padding: 12,
              callbacks: {
                label: ctx => {
                  const total = ctx.dataset.data.reduce((a, b) => a + b, 0);
                  const pct = total > 0 ? ((ctx.raw / total) * 100).toFixed(1) : 0;
                  return ` ${ctx.label}: ${ctx.raw} (${pct}%)`;
                },
              },
            },
          },
        }}
      />
    </div>
  </div>

  {/* ── 4. Miles per Driver (Horizontal Bar) ── */}
  <div className={`${styles.chartBoxLoadDashboard} ${styles.fullWidthChartLoadDashboard}`}>
    <h3 className={styles.chartTitleLoadDashboard}>
      Miles per Driver
      <span style={{ fontSize: "0.72rem", fontWeight: 400, color: "#9A9AAF", marginLeft: 10, textTransform: "none", letterSpacing: 0 }}>
        Total miles driven per driver
      </span>
    </h3>
    {/* Total miles summary */}
    <div style={{ display: "flex", gap: 12, marginBottom: 14, flexWrap: "wrap" }}>
      {[
        {
          label: "Total Miles",
          value: loads.reduce((s, l) => s + (parseFloat(l.miles) || 0), 0).toLocaleString("en-US", { maximumFractionDigits: 0 }),
          color: "#60A5FA",
        },
        {
          label: "Avg Miles/Load",
          value: loads.length
            ? (loads.reduce((s, l) => s + (parseFloat(l.miles) || 0), 0) / loads.length).toLocaleString("en-US", { maximumFractionDigits: 0 })
            : "0",
          color: "#A78BFA",
        },
        {
          label: "Top Driver",
          value: (() => {
            const top = drivers.map(d => ({
              name: `${d.firstName} ${d.lastName}`,
              miles: loads.filter(l => l.driver === d._id).reduce((s, l) => s + (parseFloat(l.miles) || 0), 0),
            })).sort((a, b) => b.miles - a.miles)[0];
            return top ? `${top.name.split(" ")[0]} (${top.miles.toLocaleString("en-US", { maximumFractionDigits: 0 })} mi)` : "—";
          })(),
          color: "#34D399",
        },
      ].map((k, i) => (
        <div key={i} style={{
          flex: 1, minWidth: 120,
          background: "rgba(255,255,255,0.035)",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: 8, padding: "8px 14px",
        }}>
          <div style={{ fontSize: 10, color: "#9A9AAF", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 3 }}>{k.label}</div>
          <div style={{ fontSize: 15, fontWeight: 700, color: k.color, fontFamily: "'Barlow Condensed', sans-serif" }}>{k.value}</div>
        </div>
      ))}
    </div>
    <div className={styles.chartWrapperLoadDashboard}>
      <Bar
        data={milesPerDriverData}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: "y",
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: "rgba(10,10,17,0.95)",
              borderColor: "rgba(96,165,250,0.3)",
              borderWidth: 1,
              titleColor: "#60A5FA",
              bodyColor: "#F4F4F6",
              padding: 12,
              callbacks: {
                label: ctx => ` Miles: ${ctx.raw.toLocaleString("en-US", { maximumFractionDigits: 0 })}`,
              },
            },
          },
          scales: {
            x: {
              grid: darkGrid,
              ticks: {
                ...tickStyle,
                callback: v => `${(v / 1000).toFixed(0)}k mi`,
              },
              border: { color: "rgba(255,255,255,0.08)" },
            },
            y: {
              grid: { display: false },
              ticks: tickStyle,
              border: { color: "rgba(255,255,255,0.08)" },
            },
          },
        }}
      />
    </div>
  </div>
</div>
<EmailPanel />
</div>

  );
};

const getStatusProgress = (status) => {
  const statusesMap = {
    Pending: ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered"],
    Open: ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered"],
    Assigned: ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered"],
    Dispatched: ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered"],
    "On Route": ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered"],
    "In Progress": ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered"],
    Delivered: ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered"],
    Completed: ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered", "Completed"],
    Cancelled: ["Pending", "Open", "In Yard", "Refused", "Un-Loading", "Cancelled"],
  };

  const progressStatuses = statusesMap[status] || [];
  const currentIndex = progressStatuses.indexOf(status);

  return progressStatuses.map((s, index) => ({
    status: s,
    completed: index <= currentIndex, // Marchează statusurile completate
  }));
};

const getPaymentProgress = (paymentStatus) => {
  const paymentMap = [
    "Not Paid",
    "Pending Payment",
    "Payment in Progress",
    "Paid"
  ];
  const currentIndex = paymentMap.indexOf(paymentStatus);

  return paymentMap.map((status, index) => ({
    status,
    completed: index <= currentIndex,
  }));
};

const DOC_TYPES = [
  { key: 'rate_confirmation', label: 'Rate Confirmation', tag: 'LOG',  color: '#34D399' },
  { key: 'bill_of_lading',    label: 'Bill of Lading',    tag: 'LOG',  color: '#34D399' },
  { key: 'proof_of_delivery', label: 'Proof of Delivery', tag: 'LOG',  color: '#34D399' },
  { key: 'invoice',           label: 'Invoice',           tag: 'FIN',  color: '#F59E0B' },
  { key: 'driver_document',   label: 'Driver Document',   tag: 'OPS',  color: '#60A5FA' },
  { key: 'insurance',         label: 'Insurance',         tag: 'OPS',  color: '#60A5FA' },
  { key: 'ifta',              label: 'IFTA',              tag: 'COMP', color: '#F87171' },
  { key: 'fuel_receipt',      label: 'Fuel Receipt',      tag: 'COMP', color: '#F87171' },
  { key: 'maintenance',       label: 'Maintenance',       tag: 'OPS',  color: '#60A5FA' },
  { key: 'contract',          label: 'Contract',          tag: 'FIN',  color: '#F59E0B' },
  { key: 'other',             label: 'Other',             tag: 'OPS',  color: '#9499B0' },
];

const ENTITY_TYPES = [
  { key: 'load',     label: 'Load'     },
  { key: 'driver',   label: 'Driver'   },
  { key: 'truck',    label: 'Truck'    },
  { key: 'trailer',  label: 'Trailer'  },
  { key: 'employee', label: 'Employee' },
  { key: 'broker',   label: 'Broker'   },
];

const FILE_ICONS = {
  'application/pdf':  'PDF',
  'image/jpeg':       'IMG',
  'image/png':        'IMG',
  'image/webp':       'IMG',
  'application/msword': 'DOC',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOC',
  'application/vnd.ms-excel': 'XLS',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLS',
};

const formatBytes = (bytes) => {
  if (!bytes) return '—';
  if (bytes < 1024)       return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const formatDate = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

const Imports = ({ theme, drivers = [], trucks = [], trailers = [], loads = [], employees = [], brokers = [] }) => {
  const token  = sessionStorage.getItem('token');
  const config = { headers: { Authorization: `Bearer ${token}` }, withCredentials: true };
const [linkedEntityId, setLinkedEntityId] = useState("");
  // ── State ─────────────────────────────────────────────────
  const [documents,      setDocuments]      = useState([]);
  const [loading,        setLoading]        = useState(false);
  const [uploading,      setUploading]      = useState(false);
  const [searchTerm,     setSearchTerm]     = useState('');
  const [filterDocType,  setFilterDocType]  = useState('');
  const [filterEntity,   setFilterEntity]   = useState('');

  // Upload modal
  const [showUpload,     setShowUpload]     = useState(false);
  const [uploadFile,     setUploadFile]     = useState(null);
  const [uploadDocType,  setUploadDocType]  = useState('');
  const [uploadTitle,    setUploadTitle]    = useState('');
  const [uploadDesc,     setUploadDesc]     = useState('');
  const [uploadEntityType, setUploadEntityType] = useState('');
  const [uploadEntityId,   setUploadEntityId]   = useState('');
  const [dragOver,       setDragOver]       = useState(false);
  const fileInputRef = useRef(null);

  // Detail / share modal
  const [selectedDoc,    setSelectedDoc]    = useState(null);
  const [showDetail,     setShowDetail]     = useState(false);
  const [showShare,      setShowShare]      = useState(false);
  const [shareEmail,     setShareEmail]     = useState('');
  const [shareMsg,       setShareMsg]       = useState('');
  const [shareSending,   setShareSending]   = useState(false);

  // Link modal
  const [showLink,       setShowLink]       = useState(false);
  const [linkEntityType, setLinkEntityType] = useState('');
  const [linkEntityId,   setLinkEntityId]   = useState('');
// Preview modal
  const [showPreview,  setShowPreview]  = useState(false);
  const [previewUrl,   setPreviewUrl]   = useState('');
  const [previewMime,  setPreviewMime]  = useState('');
const [toast, setToast] = useState(null);
const showToast = (msg, type = 'success') => {
  setToast({ msg, type });
  setTimeout(() => setToast(null), 3000);
};
  const isLight = theme === 'light';

  // ── Fetch ─────────────────────────────────────────────────
  const fetchDocuments = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (filterDocType) params.docType = filterDocType;
      if (filterEntity)  params.linkedEntityType = filterEntity;
      if (searchTerm)    params.search = searchTerm;

      const res = await axios.get(`${apiUrl}/documents`, { ...config, params });
      setDocuments(res.data);
    } catch (err) {
      console.error('Fetch documents error:', err);
    } finally {
      setLoading(false);
    }
  }, [filterDocType, filterEntity, searchTerm]);

  useEffect(() => {
    fetchDocuments();
  }, [fetchDocuments]);

  // ── Upload ────────────────────────────────────────────────
  const handleFileDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) { setUploadFile(file); setUploadTitle(file.name); }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) { setUploadFile(file); setUploadTitle(file.name); }
  };

  const handleUpload = async () => {
    if (!uploadFile || !uploadDocType) return;
    setUploading(true);

    try {
      const formData = new FormData();
      formData.append('file',         uploadFile);
      formData.append('docType',      uploadDocType);
      formData.append('title',        uploadTitle || uploadFile.name);
      formData.append('description',  uploadDesc);

      if (uploadEntityType && uploadEntityId) {
        const entityLabel = getEntityLabel(uploadEntityType, uploadEntityId);
        formData.append('linkedEntityType',  uploadEntityType);
        formData.append('linkedEntityId',    uploadEntityId);
        formData.append('linkedEntityLabel', entityLabel);
      }

      await axios.post(`${apiUrl}/documents`, formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
        withCredentials: true,
      });

      setShowUpload(false);
      resetUploadForm();
      fetchDocuments();
    } catch (err) {
      alert('Upload failed: ' + (err.response?.data?.error || err.message));
    } finally {
      setUploading(false);
    }
  };

  const resetUploadForm = () => {
    setUploadFile(null);
    setUploadDocType('');
    setUploadTitle('');
    setUploadDesc('');
    setUploadEntityType('');
    setUploadEntityId('');
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  // ── Entity helpers ────────────────────────────────────────
  const getEntityOptions = (type) => {
    switch (type) {
      case 'load':     return loads.map(l     => ({ id: l._id, label: `Load #${l.loadNumber}` }));
      case 'driver':   return drivers.map(d   => ({ id: d._id, label: `${d.firstName} ${d.lastName}` }));
      case 'truck':    return trucks.map(t    => ({ id: t._id, label: `Truck ${t.truckNumber}` }));
      case 'trailer':  return trailers.map(t  => ({ id: t._id, label: `Trailer ${t.trailerNumber}` }));
      case 'employee': return employees.map(e => ({ id: e._id, label: `${e.firstName} ${e.lastName}` }));
      case 'broker':   return brokers.map(b   => ({ id: b._id, label: b.brokerName }));
      default: return [];
    }
  };

  const getEntityLabel = (type, id) => {
    const opts = getEntityOptions(type);
    const found = opts.find(o => String(o.id) === String(id));
    return found ? found.label : '';
  };

const handleShare = async () => {
  if (!shareEmail || !selectedDoc) return;
  setShareSending(true);

  // ✅ Salvezi emailul înainte să resetezi state-ul
  const recipientEmail = shareEmail;

  // ✅ Închizi modalul IMEDIAT
  setShowShare(false);
  setShareEmail('');
  setShareMsg('');
  showToast(`Sending to ${recipientEmail}...`, 'info');

  try {
    const fileRes = await axios.get(
      `${apiUrl}/documents/${selectedDoc.id}/download`,
      { ...config, responseType: 'arraybuffer', timeout: 60000 } // ✅ timeout 60s
    );

    const base64Data = btoa(
      new Uint8Array(fileRes.data).reduce(
        (data, byte) => data + String.fromCharCode(byte), ''
      )
    );

    await axios.post(
      `${apiUrl}/email/send-with-attachment`,
      {
        to: recipientEmail,
        subject: `Document: ${selectedDoc.title}`,
        body: shareMsg
          ? `<p>${shareMsg}</p><br/><p><small>Sent via Full Trucking Service</small></p>`
          : `<p>Please find attached: <strong>${selectedDoc.title}</strong></p><br/><p><small>Sent via Full Trucking Service</small></p>`,
        attachment: {
          filename: selectedDoc.fileName,
          mimeType: selectedDoc.mimeType || 'application/octet-stream',
          data: base64Data,
        },
      },
      { ...config, timeout: 60000 } // ✅ timeout 60s
    );

    await axios.post(
      `${apiUrl}/documents/${selectedDoc.id}/share`,
      { email: recipientEmail, message: shareMsg },
      config
    );

    fetchDocuments();
    showToast(`Sent to ${recipientEmail}`); // ✅ success toast
  } catch (err) {
    // ✅ Dacă emailul a fost trimis dar înregistrarea a eșuat, nu e o eroare reală
    if (err.code === 'ECONNABORTED' || err.message === 'Network Error') {
      showToast(`Sent to ${recipientEmail}`); // probabil s-a trimis
    } else {
      showToast('Send failed: ' + (err.response?.data?.error || err.message), 'error');
    }
  } finally {
    setShareSending(false);
  }
};

  // ── Link ──────────────────────────────────────────────────
  const handleLink = async () => {
    if (!linkEntityType || !linkEntityId || !selectedDoc) return;
    try {
      const label = getEntityLabel(linkEntityType, linkEntityId);
      await axios.patch(`${apiUrl}/documents/${selectedDoc.id}/link`, {
        linkedEntityType:  linkEntityType,
        linkedEntityId,
        linkedEntityLabel: label,
      }, config);
      setShowLink(false);
      fetchDocuments();
    } catch (err) {
      alert('Link failed: ' + (err.response?.data?.error || err.message));
    }
  };

  // ── Delete ────────────────────────────────────────────────
  const handleDelete = async (docId) => {
    if (!window.confirm('Delete this document permanently?')) return;
    try {
      await axios.delete(`${apiUrl}/documents/${docId}`, config);
      setShowDetail(false);
      fetchDocuments();
    } catch (err) {
      alert('Delete failed: ' + (err.response?.data?.error || err.message));
    }
  };

  // ── Download ──────────────────────────────────────────────
  const handleDownload = (doc) => {
    const url = `${apiUrl}/documents/${doc.id}/download`;
    const a   = document.createElement('a');
    a.href    = url;
    a.setAttribute('download', doc.fileName);
    a.setAttribute('Authorization', `Bearer ${token}`);
    window.open(`${url}?token=${token}`, '_blank');
  };

  // ── Preview ───────────────────────────────────────────
  const handlePreview = async (doc) => {
    try {
      const res = await axios.get(`${apiUrl}/documents/${doc.id}/download`, {
        ...config,
        responseType: 'blob',
      });
      const blobUrl = URL.createObjectURL(res.data);
      setPreviewUrl(blobUrl);
      setPreviewMime(doc.mimeType);
      setShowPreview(true);
    } catch (err) {
      alert('Preview failed: ' + (err.response?.data?.error || err.message));
    }
  };

  const docTypeInfo = (key) => DOC_TYPES.find(d => d.key === key) || DOC_TYPES[DOC_TYPES.length - 1];

  const rootCls = `${styles.ImportsRoot} ${isLight ? styles.ImportsRootLight : ''}`;

  // ── RENDER ────────────────────────────────────────────────
  return (
    <div className={rootCls}>

      {/* ── Page Header ── */}
      <div className={styles.ImportsPageHeader}>
        <div className={styles.ImportsPageHeaderInner}>
          <p className={styles.ImportsPageEyebrow}>Full Trucking Service</p>
          <h1 className={styles.ImportsPageTitle}>Document Center</h1>
          <p className={styles.ImportsPageSubtitle}>
            Upload, organize and distribute documents — link them to loads, drivers, trucks and more.
          </p>
        </div>
        <button
          type="button"
          className={styles.ImportsUploadBtn}
          onClick={() => setShowUpload(true)}
        >
          Upload Document
        </button>
      </div>

      {/* ── Filters bar ── */}
      <div className={styles.ImportsFiltersBar}>
        <input
          type="text"
          className={styles.ImportsSearch}
          placeholder="Search documents..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
        <select
          className={styles.ImportsFilterSelect}
          value={filterDocType}
          onChange={e => setFilterDocType(e.target.value)}
        >
          <option value="">All Types</option>
          {DOC_TYPES.map(d => (
            <option key={d.key} value={d.key}>{d.label}</option>
          ))}
        </select>
        <select
          className={styles.ImportsFilterSelect}
          value={filterEntity}
          onChange={e => setFilterEntity(e.target.value)}
        >
          <option value="">All Entities</option>
          {ENTITY_TYPES.map(e => (
            <option key={e.key} value={e.key}>{e.label}</option>
          ))}
        </select>
        <span className={styles.ImportsDocCount}>
          {documents.length} document{documents.length !== 1 ? 's' : ''}
        </span>
      </div>

      {/* ── Document Grid ── */}
      {loading ? (
        <div className={styles.ImportsLoading}>Loading documents...</div>
      ) : documents.length === 0 ? (
        <div className={styles.ImportsEmpty}>
          <div className={styles.ImportsEmptyIcon}>DOC</div>
          <p className={styles.ImportsEmptyTitle}>No documents yet</p>
          <p className={styles.ImportsEmptyDesc}>Upload your first document to get started.</p>
          <button type="button" className={styles.ImportsUploadBtn} onClick={() => setShowUpload(true)}>
            Upload Document
          </button>
        </div>
      ) : (
        <div className={styles.ImportsGrid}>
          {documents.map(doc => {
            const typeInfo = docTypeInfo(doc.docType);
            const icon     = FILE_ICONS[doc.mimeType] || 'FILE';
            return (
              <div
                key={doc.id}
                className={styles.ImportsDocCard}
                onClick={() => { setSelectedDoc(doc); setShowDetail(true); }}
              >
                {/* File type badge */}
                <div className={styles.ImportsDocIconWrap}>
                  <div className={styles.ImportsDocIcon} style={{ background: typeInfo.color + '18', color: typeInfo.color }}>
                    {icon}
                  </div>
                  <div className={styles.ImportsDocTypeBadge} style={{ background: typeInfo.color + '18', color: typeInfo.color, borderColor: typeInfo.color + '44' }}>
                    {typeInfo.label}
                  </div>
                </div>

                {/* Info */}
                <div className={styles.ImportsDocInfo}>
                  <div className={styles.ImportsDocTitle}>{doc.title}</div>
                  {doc.linkedEntity?.label && (
                    <div className={styles.ImportsDocLinked}>
                     {(doc.linkedEntity.type || doc.linkedEntity.entityType || '').toUpperCase()} — {doc.linkedEntity.label}
                    </div>
                  )}
                  <div className={styles.ImportsDocMeta}>
                    <span>{formatBytes(doc.fileSize)}</span>
                    <span className={styles.ImportsDocMetaDot} />
                    <span>{formatDate(doc.createdAt)}</span>
                    {doc.sharedWith?.length > 0 && (
                      <>
                        <span className={styles.ImportsDocMetaDot} />
                        <span className={styles.ImportsDocShared}>Sent {doc.sharedWith.length}x</span>
                      </>
                    )}
                  </div>
                </div>

                {/* Quick actions */}
              <div className={styles.ImportsDocActions} onClick={e => e.stopPropagation()}>
                  <button
                    type="button"
                    className={styles.ImportsDocActionBtn}
                    title="Preview"
                    onClick={() => handlePreview(doc)}
                  >
                    View
                  </button>
                 
                  <button
                    type="button"
                    className={`${styles.ImportsDocActionBtn} ${styles.ImportsDocActionBtnDanger}`}
                    title="Delete"
                    onClick={() => handleDelete(doc.id)}
                  >
                    Del
                  </button>
                </div>
              </div>
            );
          })}
               {showPreview && createPortal(
<div
  className={`${styles.ImportsOverlay} ${isLight ? styles.ImportsOverlayLight : styles.ImportsOverlayDark}`}
  onClick={e => {
    if (e.target === e.currentTarget) {
      URL.revokeObjectURL(previewUrl);
      setShowPreview(false);
      setPreviewUrl('');
    }
  }}
>
          <div className={styles.ImportsModal} style={{ maxWidth: '900px', width: '90vw' }}>
            <div className={styles.ImportsModalHeader}>
              <h2 className={styles.ImportsModalTitle}>Document Preview</h2>
              <button
                type="button"
                className={styles.ImportsModalClose}
                onClick={() => {
                  URL.revokeObjectURL(previewUrl);
                  setShowPreview(false);
                  setPreviewUrl('');
                }}
              >
                Close
              </button>
            </div>
            <div className={styles.ImportsModalBody} style={{ padding: 0 }}>
              {previewMime === 'application/pdf' || previewMime?.startsWith('image/') ? (
                <iframe
                  src={previewUrl}
                  style={{ width: '100%', height: '70vh', border: 'none', display: 'block' }}
                  title="Document Preview"
                />
              ) : (
                <div style={{ padding: '40px', textAlign: 'center' }}>
                  <p>Preview not available for this file type.</p>
                  <p style={{ opacity: 0.5, fontSize: '0.85rem' }}>Download the file to view it.</p>
                </div>
              )}
            </div>
          </div>
        </div>,
        document.body
      )}

        </div>
      )}

      {/* ═══════════════════════════════════════════════════
          UPLOAD MODAL
      ═══════════════════════════════════════════════════ */}
      {showUpload && createPortal(
        <div
  className={`${styles.ImportsOverlay} ${isLight ? styles.ImportsOverlayLight : styles.ImportsOverlayDark}`}
  onClick={e => { if (e.target === e.currentTarget) { setShowUpload(false); resetUploadForm(); } }}
>
          <div className={styles.ImportsModal}>
            <div className={styles.ImportsModalHeader}>
              <h2 className={styles.ImportsModalTitle}>Upload Document</h2>
              <button type="button" className={styles.ImportsModalClose} onClick={() => { setShowUpload(false); resetUploadForm(); }}>Close</button>
            </div>

            <div className={styles.ImportsModalBody}>

              {/* Drop zone */}
              <div
                className={`${styles.ImportsDropZone} ${dragOver ? styles.ImportsDropZoneActive : ''} ${uploadFile ? styles.ImportsDropZoneFilled : ''}`}
                onDragOver={e => { e.preventDefault(); setDragOver(true); }}
                onDragLeave={() => setDragOver(false)}
                onDrop={handleFileDrop}
                onClick={() => fileInputRef.current?.click()}
              >
                <input
                  ref={fileInputRef}
                  type="file"
                  style={{ display: 'none' }}
                  accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx,.xls,.xlsx"
                  onChange={handleFileSelect}
                />
                {uploadFile ? (
                  <div className={styles.ImportsDropZoneFile}>
                    <span className={styles.ImportsDropZoneFileIcon}>{FILE_ICONS[uploadFile.type] || 'FILE'}</span>
                    <div>
                      <div className={styles.ImportsDropZoneFileName}>{uploadFile.name}</div>
                      <div className={styles.ImportsDropZoneFileSize}>{formatBytes(uploadFile.size)}</div>
                    </div>
                    <button
                      type="button"
                      className={styles.ImportsDropZoneRemove}
                      onClick={e => { e.stopPropagation(); setUploadFile(null); setUploadTitle(''); }}
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <div className={styles.ImportsDropZonePrompt}>
                    <div className={styles.ImportsDropZonePromptIcon}>UPLOAD</div>
                    <p className={styles.ImportsDropZonePromptText}>Drag and drop a file here, or click to browse</p>
                    <p className={styles.ImportsDropZonePromptSub}>PDF, JPG, PNG, DOC, DOCX, XLS, XLSX — max 50MB</p>
                  </div>
                )}
              </div>

              {/* Doc type */}
              <div className={styles.ImportsFormGroup}>
                <label className={styles.ImportsFormLabel}>Document Type *</label>
                <div className={styles.ImportsDocTypeGrid}>
                  {DOC_TYPES.map(d => (
                    <button
                      key={d.key}
                      type="button"
                      className={`${styles.ImportsDocTypeChip} ${uploadDocType === d.key ? styles.ImportsDocTypeChipActive : ''}`}
                      style={uploadDocType === d.key ? { borderColor: d.color, background: d.color + '18', color: d.color } : {}}
                      onClick={() => setUploadDocType(d.key)}
                    >
                      {d.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Title */}
              <div className={styles.ImportsFormGroup}>
                <label className={styles.ImportsFormLabel}>Title</label>
                <input
                  type="text"
                  className={styles.ImportsFormInput}
                  placeholder="Document title..."
                  value={uploadTitle}
                  onChange={e => setUploadTitle(e.target.value)}
                />
              </div>

              {/* Description */}
              <div className={styles.ImportsFormGroup}>
                <label className={styles.ImportsFormLabel}>Description <span className={styles.ImportsFormOptional}>(optional)</span></label>
                <textarea
                  className={styles.ImportsFormTextarea}
                  placeholder="Additional notes..."
                  value={uploadDesc}
                  onChange={e => setUploadDesc(e.target.value)}
                  rows={2}
                />
              </div>

              {/* Link to entity */}
              <div className={styles.ImportsFormGroup}>
                <label className={styles.ImportsFormLabel}>Link to <span className={styles.ImportsFormOptional}>(optional)</span></label>
                <div className={styles.ImportsLinkRow}>
                  <select
                    className={styles.ImportsFormSelect}
                    value={uploadEntityType}
                    onChange={e => { setUploadEntityType(e.target.value); setUploadEntityId(''); }}
                  >
                    <option value="">Select entity type...</option>
                    {ENTITY_TYPES.map(e => (
                      <option key={e.key} value={e.key}>{e.label}</option>
                    ))}
                  </select>
                  {uploadEntityType && (
                    <select
                      className={styles.ImportsFormSelect}
                      value={uploadEntityId}
                      onChange={e => setUploadEntityId(e.target.value)}
                    >
                      <option value="">Select {uploadEntityType}...</option>
                      {getEntityOptions(uploadEntityType).map(opt => (
                        <option key={opt.id} value={opt.id}>{opt.label}</option>
                      ))}
                    </select>
                  )}
                </div>
              </div>
            </div>

            <div className={styles.ImportsModalFooter}>
              <button type="button" className={styles.ImportsModalCancelBtn} onClick={() => { setShowUpload(false); resetUploadForm(); }}>
                Cancel
              </button>
              <button
                type="button"
                className={styles.ImportsModalSubmitBtn}
                onClick={handleUpload}
                disabled={!uploadFile || !uploadDocType || uploading}
              >
                {uploading ? 'Uploading...' : 'Upload Document'}
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* ═══════════════════════════════════════════════════
          DETAIL MODAL
      ═══════════════════════════════════════════════════ */}
      {showDetail && selectedDoc && createPortal(
      <div
  className={`${styles.ImportsOverlay} ${isLight ? styles.ImportsOverlayLight : styles.ImportsOverlayDark}`}
  onClick={e => { if (e.target === e.currentTarget) setShowDetail(false); }}
>
          <div className={styles.ImportsModal}>
            <div className={styles.ImportsModalHeader}>
              <h2 className={styles.ImportsModalTitle}>{selectedDoc.title}</h2>
              <button type="button" className={styles.ImportsModalClose} onClick={() => setShowDetail(false)}>Close</button>
            </div>

            <div className={styles.ImportsModalBody}>
              {/* Info grid */}
              <div className={styles.ImportsDetailGrid}>
                {[
                  ['Type',       docTypeInfo(selectedDoc.docType)?.label],
                  ['File',       selectedDoc.fileName],
                  ['Size',       formatBytes(selectedDoc.fileSize)],
                  ['Uploaded',   formatDate(selectedDoc.createdAt)],
                  ['By',         selectedDoc.uploadedBy || '—'],
                  ['Linked to',  selectedDoc.linkedEntity?.label || '—'],
                  ['Sent',       selectedDoc.sharedWith?.length ? `${selectedDoc.sharedWith.length} time(s)` : 'Not sent'],
                ].map(([l, v]) => (
                  <div key={l} className={styles.ImportsDetailItem}>
                    <div className={styles.ImportsDetailLabel}>{l}</div>
                    <div className={styles.ImportsDetailValue}>{v}</div>
                  </div>
                ))}
              </div>

              {selectedDoc.description && (
                <p className={styles.ImportsDetailDesc}>{selectedDoc.description}</p>
              )}

              {/* Shared history */}
              {selectedDoc.sharedWith?.length > 0 && (
                <div className={styles.ImportsSharedHistory}>
                  <div className={styles.ImportsSharedHistoryTitle}>Share History</div>
                  {selectedDoc.sharedWith.map((s, i) => (
                    <div key={i} className={styles.ImportsSharedHistoryItem}>
                      <span>{s.email}</span>
                      <span>{formatDate(s.sentAt)}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className={styles.ImportsModalFooter}>
             
              <button type="button" className={styles.ImportsDetailActionBtn} onClick={() => { setShowDetail(false); setShowLink(true); }}>
                Link to Entity
              </button>
              <button type="button" className={styles.ImportsDetailActionBtn} onClick={() => { setShowDetail(false); setShowShare(true); }}>
                Share
              </button>
              <button type="button" className={`${styles.ImportsDetailActionBtn} ${styles.ImportsDetailActionBtnDanger}`} onClick={() => handleDelete(selectedDoc.id)}>
                Delete
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* ═══════════════════════════════════════════════════
          SHARE MODAL
      ═══════════════════════════════════════════════════ */}
      {showShare && selectedDoc && createPortal(
     <div
  className={`${styles.ImportsOverlay} ${isLight ? styles.ImportsOverlayLight : styles.ImportsOverlayDark}`}
  onClick={e => { if (e.target === e.currentTarget) setShowShare(false); }}
>
          <div className={`${styles.ImportsModal} ${styles.ImportsModalSm}`}>
            <div className={styles.ImportsModalHeader}>
              <h2 className={styles.ImportsModalTitle}>Share Document</h2>
              <button type="button" className={styles.ImportsModalClose} onClick={() => setShowShare(false)}>Close</button>
            </div>

            <div className={styles.ImportsModalBody}>
              <p className={styles.ImportsShareDocName}>{selectedDoc.title}</p>
              <div className={styles.ImportsFormGroup}>
                <label className={styles.ImportsFormLabel}>Recipient Email *</label>
                <input
                  type="email"
                  className={styles.ImportsFormInput}
                  placeholder="email@example.com"
                  value={shareEmail}
                  onChange={e => setShareEmail(e.target.value)}
                />
              </div>
              <div className={styles.ImportsFormGroup}>
                <label className={styles.ImportsFormLabel}>Message <span className={styles.ImportsFormOptional}>(optional)</span></label>
                <textarea
                  className={styles.ImportsFormTextarea}
                  placeholder="Additional message for the recipient..."
                  value={shareMsg}
                  onChange={e => setShareMsg(e.target.value)}
                  rows={3}
                />
              </div>
            </div>

            <div className={styles.ImportsModalFooter}>
              <button type="button" className={styles.ImportsModalCancelBtn} onClick={() => setShowShare(false)}>
                Cancel
              </button>
              <button
                type="button"
                className={styles.ImportsModalSubmitBtn}
                onClick={handleShare}
                disabled={!shareEmail || shareSending}
              >
                {shareSending ? 'Sending...' : 'Send Document'}
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* ═══════════════════════════════════════════════════
          LINK MODAL
      ═══════════════════════════════════════════════════ */}
      {showLink && selectedDoc && createPortal(
       <div
  className={`${styles.ImportsOverlay} ${isLight ? styles.ImportsOverlayLight : styles.ImportsOverlayDark}`}
  onClick={e => { if (e.target === e.currentTarget) setShowLink(false); }}
>
          <div className={`${styles.ImportsModal} ${styles.ImportsModalSm}`}>
            <div className={styles.ImportsModalHeader}>
              <h2 className={styles.ImportsModalTitle}>Link to Entity</h2>
              <button type="button" className={styles.ImportsModalClose} onClick={() => setShowLink(false)}>Close</button>
            </div>

            <div className={styles.ImportsModalBody}>
              <p className={styles.ImportsShareDocName}>{selectedDoc.title}</p>
              <div className={styles.ImportsFormGroup}>
                <label className={styles.ImportsFormLabel}>Entity Type</label>
                <select
                  className={styles.ImportsFormSelect}
                  value={linkEntityType}
                  onChange={e => { setLinkEntityType(e.target.value); setLinkEntityId(''); }}
                >
                  <option value="">Select type...</option>
                  {ENTITY_TYPES.map(e => (
                    <option key={e.key} value={e.key}>{e.label}</option>
                  ))}
                </select>
              </div>
              {linkEntityType && (
                <div className={styles.ImportsFormGroup}>
                  <label className={styles.ImportsFormLabel}>Select {linkEntityType}</label>
                  <select
                    className={styles.ImportsFormSelect}
                    value={linkEntityId}
                    onChange={e => setLinkEntityId(e.target.value)}
                  >
                    <option value="">Select {linkEntityType}...</option>
                    {getEntityOptions(linkEntityType).map(opt => (
                      <option key={opt.id} value={opt.id}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              )}
            </div>

            <div className={styles.ImportsModalFooter}>
              <button type="button" className={styles.ImportsModalCancelBtn} onClick={() => setShowLink(false)}>
                Cancel
              </button>
              <button
                type="button"
                className={styles.ImportsModalSubmitBtn}
                onClick={handleLink}
                disabled={!linkEntityType || !linkEntityId}
              >
                Link Document
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
      <EmailPanel />

        {toast && (
  <div style={{
    position: 'fixed',
    bottom: 32,
    right: 32,
    zIndex: 999999,
    background: toast.type === 'success' ? '#065f46' : toast.type === 'info' ? '#1e3a5f' : '#7f1d1d',
    border: `1px solid ${toast.type === 'success' ? '#34d399' : toast.type === 'info' ? '#60a5fa' : '#f87171'}`,
    color: toast.type === 'success' ? '#34d399' : toast.type === 'info' ? '#60a5fa' : '#f87171',
    padding: '12px 20px',
    borderRadius: '10px',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '0.85rem',
    fontWeight: 500,
    boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
    animation: 'fadeSlideIn 0.2s ease',
  }}>
    {toast.type === 'success' ? '✓ ' : toast.type === 'info' ? '⟳ ' : '✕ '}{toast.msg}
  </div>
)}
    </div>
  );
};

const ENTITY_FILTERS = {
  driverPays: [
    {
      key:     'driver',
      label:   'Driver Name',
      type:    'text',
      placeholder: 'e.g. John Smith',
    },
    {
      key:     'truck',
      label:   'Truck Number',
      type:    'text',
      placeholder: 'e.g. T-101',
    },
    {
      key:     'settlementNumber',
      label:   'Settlement #',
      type:    'text',
      placeholder: 'e.g. SET-001',
    },
    {
      key:     'startDate',
      label:   'Start Date (from)',
      type:    'date',
    },
    {
      key:     'endDate',
      label:   'End Date (to)',
      type:    'date',
    },
  ],

  fleetReports: [
    {
      key:     'truck',
      label:   'Truck Number',
      type:    'text',
      placeholder: 'e.g. T-101',
    },
    {
      key:     'truckOwner',
      label:   'Truck Owner',
      type:    'text',
      placeholder: 'e.g. John Smith',
    },
    {
      key:     'fleetNumber',
      label:   'Fleet Report #',
      type:    'text',
      placeholder: 'e.g. FR-001',
    },
    {
      key:     'startDate',
      label:   'Start Date (from)',
      type:    'date',
    },
    {
      key:     'endDate',
      label:   'End Date (to)',
      type:    'date',
    },
  ],

  loads: [
    {
      key:     'driver',
      label:   'Driver Name',
      type:    'text',
      placeholder: 'e.g. John Smith',
    },
    {
      key:     'brokerName',
      label:   'Broker Name',
      type:    'text',
      placeholder: 'e.g. Echo Global',
    },
    {
      key:     'equipment',
      label:   'Equipment Type',
      type:    'select',
      options: ['Van', 'Reefer', 'Flatbed', 'Step Deck', 'Power Only', 'Hotshot', 'Other'],
    },
    {
      key:     'status',
      label:   'Load Status',
      type:    'select',
      options: ['Pending', 'Open', 'Assigned', 'Dispatched', 'On Route', 'In Progress', 'Delivered', 'Completed', 'Cancelled'],
    },
    {
      key:     'paymentStatus',
      label:   'Payment Status',
      type:    'select',
      options: ['Not Paid', 'Pending Payment', 'Paid', 'Payment Cancelled'],
    },
  ],

  drivers: [
    {
      key:     'driverType',
      label:   'Driver Type',
      type:    'select',
      options: ['employee', 'owner_operator'],
    },
    {
      key:     'settlement',
      label:   'Settlement Type',
      type:    'select',
      options: ['Per mile pay', 'Hourly pay', 'Fixed salary', 'Percentage of the load', 'Team driver pay'],
    },
    {
      key:     'licenseType',
      label:   'License Type',
      type:    'select',
      options: ['CDL-A', 'CDL-B', 'NonComercial'],
    },
  ],

  fuel: [
    {
      key:     'driver',
      label:   'Driver Name',
      type:    'text',
      placeholder: 'e.g. John Smith',
    },
    {
      key:     'truck',
      label:   'Truck Number',
      type:    'text',
      placeholder: 'e.g. T-101',
    },
    {
      key:     'fuelResponsibility',
      label:   'Responsibility',
      type:    'select',
      options: ['company', 'owner'],
    },
    {
      key:     'fuelPaymentStatus',
      label:   'Payment Status',
      type:    'select',
      options: ['open', 'paid'],
    },
    {
      key:     'merchant',
      label:   'Merchant',
      type:    'text',
      placeholder: 'e.g. Loves, Pilot',
    },
  ],

  invoices: [
    {
      key:     'brokerName',
      label:   'Broker Name',
      type:    'text',
      placeholder: 'e.g. Echo Global',
    },
    {
      key:     'status',
      label:   'Invoice Status',
      type:    'select',
      options: ['Pending', 'In Progress', 'Paid', 'Completed'],
    },
    {
      key:     'isPayed',
      label:   'Is Paid',
      type:    'select',
      options: ['true', 'false'],
    },
    {
      key:     'driver',
      label:   'Driver Name',
      type:    'text',
      placeholder: 'e.g. John Smith',
    },
  ],

  assetCosts: [
    {
      key:     'type',
      label:   'Type',
      type:    'select',
      options: ['deduction', 'addition'],
    },
    {
      key:     'category',
      label:   'Category',
      type:    'select',
      options: ['insurance', 'leasing', 'maintenance', 'trailer_rent', 'maut', 'service', 'other', 'detention_pay', 'layover_pay', 'performance_bonus', 'safety_bonus'],
    },
    {
      key:     'assetType',
      label:   'Asset Type',
      type:    'select',
      options: ['truck', 'trailer', 'driver'],
    },
    {
      key:     'vendor',
      label:   'Vendor',
      type:    'text',
      placeholder: 'e.g. State Farm',
    },
    {
      key:     'active',
      label:   'Active Only',
      type:    'select',
      options: ['true', 'false'],
    },
  ],

  payrolls: [
    {
      key:     'employee',
      label:   'Employee Name',
      type:    'text',
      placeholder: 'e.g. Jane Doe',
    },
  ],

  ifta: [
    {
      key:     'quarter',
      label:   'Quarter',
      type:    'select',
      options: ['Q1', 'Q2', 'Q3', 'Q4'],
    },
    {
      key:     'year',
      label:   'Year',
      type:    'text',
      placeholder: 'e.g. 2024',
    },
    {
      key:     'paidIfta',
      label:   'IFTA Paid',
      type:    'select',
      options: ['Yes', 'No'],
    },
  ],

  employees: [
    {
      key:     'contractType',
      label:   'Contract Type',
      type:    'select',
      options: ['Permanent', 'Temporary', 'Contract', 'Internship'],
    },
    {
      key:     'payType',
      label:   'Pay Type',
      type:    'select',
      options: ['Hourly', 'Fixed salary', 'Commission', 'Weekly', 'Monthly'],
    },
  ],

  fleet: [
    {
      key:     'owner',
      label:   'Owner Name',
      type:    'text',
      placeholder: 'e.g. John Smith',
    },
    {
      key:     'truckType',
      label:   'Truck Type',
      type:    'text',
      placeholder: 'e.g. Semi',
    },
    {
      key:     'fleetDivision',
      label:   'Fleet Division',
      type:    'text',
      placeholder: 'e.g. Division A',
    },
  ],
};

const ENTITY_FIELDS = {
  drivers: [
    { key: 'firstName',         label: 'First Name'          },
    { key: 'lastName',          label: 'Last Name'           },
    { key: 'driverNumber',      label: 'Driver Number'       },
    { key: 'driverType',        label: 'Driver Type'         },
    { key: 'email',             label: 'Email'               },
    { key: 'phone',             label: 'Phone'               },
    { key: 'mobilePhone',       label: 'Mobile Phone'        },
    { key: 'address',           label: 'Address'             },
    { key: 'truckNumber',       label: 'Truck Number'        },
    { key: 'settlement',        label: 'Settlement Type'     },
    { key: 'settlementAmount',  label: 'Settlement Amount'   },
    { key: 'normalMileRate',    label: 'Mile Rate'           },
    { key: 'dhMileRate',        label: 'DH Mile Rate'        },
    { key: 'hourlyRate',        label: 'Hourly Rate'         },
    { key: 'licenseNumber',     label: 'License Number'      },
    { key: 'licenseType',       label: 'License Type'        },
    { key: 'licenseState',      label: 'License State'       },
    { key: 'licenseExpiryDate', label: 'License Expiry Date' },
    { key: 'dateOfBirth',       label: 'Date of Birth'       },
    { key: 'hireDate',          label: 'Hire Date'           },
    { key: 'terminationDate',   label: 'Termination Date'    },
    { key: 'lastDrugTestDate',  label: 'Last Drug Test'      },
    { key: 'bankPayMethod',     label: 'Bank Pay Method'     },
    { key: 'bankAccountHolder', label: 'Account Holder'      },
    { key: 'bankName',          label: 'Bank Name'           },
    { key: 'createdAt',         label: 'Created At'          },
  ],
  fleet: [
    { key: 'truckNumber',           label: 'Truck Number'        },
    { key: 'owner',                 label: 'Owner'               },
    { key: 'licensePlate',          label: 'License Plate'       },
    { key: 'VIN',                   label: 'VIN'                 },
    { key: 'truckType',             label: 'Truck Type'          },
    { key: 'fuelType',              label: 'Fuel Type'           },
    { key: 'miles',                 label: 'Miles'               },
    { key: 'inspectionDate',        label: 'Inspection Date'     },
    { key: 'maintenanceDate',       label: 'Maintenance Date'    },
    { key: 'insurancePolicyNumber', label: 'Insurance Policy #'  },
    { key: 'insuranceExpiryDate',   label: 'Insurance Expiry'    },
    { key: 'fleetDivision',         label: 'Fleet Division'      },
    { key: 'settlement',            label: 'Settlement Type'     },
    { key: 'settlementAmount',      label: 'Settlement Amount'   },
    { key: 'notes',                 label: 'Notes'               },
    { key: 'createdAt',             label: 'Created At'          },
  ],
  trailers: [
    { key: 'trailerNumber',         label: 'Trailer Number'      },
    { key: 'licensePlate',          label: 'License Plate'       },
    { key: 'VIN',                   label: 'VIN'                 },
    { key: 'trailerType',           label: 'Trailer Type'        },
    { key: 'capacity',              label: 'Capacity'            },
    { key: 'length',                label: 'Length'              },
    { key: 'inspectionDate',        label: 'Inspection Date'     },
    { key: 'maintenanceDate',       label: 'Maintenance Date'    },
    { key: 'insurancePolicyNumber', label: 'Insurance Policy #'  },
    { key: 'insuranceExpiryDate',   label: 'Insurance Expiry'    },
    { key: 'fleetDivision',         label: 'Fleet Division'      },
    { key: 'notes',                 label: 'Notes'               },
    { key: 'createdAt',             label: 'Created At'          },
  ],
  brokers: [
    { key: 'brokerName',    label: 'Broker Name'    },
    { key: 'brokerAddress', label: 'Broker Address' },
    { key: 'createdAt',     label: 'Created At'     },
  ],
  shippers: [
    { key: 'name',      label: 'Name'       },
    { key: 'address',   label: 'Address'    },
    { key: 'phone',     label: 'Phone'      },
    { key: 'email',     label: 'Email'      },
    { key: 'createdAt', label: 'Created At' },
  ],
  consignees: [
    { key: 'name',      label: 'Name'       },
    { key: 'address',   label: 'Address'    },
    { key: 'phone',     label: 'Phone'      },
    { key: 'email',     label: 'Email'      },
    { key: 'createdAt', label: 'Created At' },
  ],
  employees: [
    { key: 'firstName',       label: 'First Name'       },
    { key: 'lastName',        label: 'Last Name'        },
    { key: 'employeeId',      label: 'Employee ID'      },
    { key: 'email',           label: 'Email'            },
    { key: 'phone',           label: 'Phone'            },
    { key: 'address',         label: 'Address'          },
    { key: 'jobTitle',        label: 'Job Title'        },
    { key: 'position',        label: 'Position'         },
    { key: 'department',      label: 'Department'       },
    { key: 'contractType',    label: 'Contract Type'    },
    { key: 'payType',         label: 'Pay Type'         },
    { key: 'payAmount',       label: 'Pay Amount'       },
    { key: 'hireDate',        label: 'Hire Date'        },
    { key: 'terminationDate', label: 'Termination Date' },
    { key: 'createdAt',       label: 'Created At'       },
  ],
  loads: [
    { key: 'loadNumber',    label: 'Load Number'    },
    { key: 'dispatcher',    label: 'Dispatcher'     },
    { key: 'brokerName',    label: 'Broker Name'    },
    { key: 'brokerAddress', label: 'Broker Address' },
    { key: 'rate',          label: 'Rate'           },
    { key: 'equipment',     label: 'Equipment'      },
    { key: 'driver',        label: 'Driver'         },
    { key: 'truck',         label: 'Truck'          },
    { key: 'trailer',       label: 'Trailer'        },
    { key: 'status',        label: 'Status'         },
    { key: 'paymentStatus', label: 'Payment Status' },
    { key: 'miles',         label: 'Miles'          },
    { key: 'dh',            label: 'DH Miles'       },
    { key: 'shippers',      label: 'Shippers'       },
    { key: 'consignees',    label: 'Consignees'     },
    { key: 'isInvoiced',    label: 'Invoiced'       },
    { key: 'isPayed',       label: 'Paid'           },
    { key: 'notes',         label: 'Notes'          },
    { key: 'createdAt',     label: 'Created At'     },
  ],
  driverPays: [
    { key: 'settlementNumber',     label: 'Settlement #'          },
    { key: 'driver',               label: 'Driver'                },
    { key: 'driverNumber',         label: 'Driver Number'         },
    { key: 'truck',                label: 'Truck'                 },
    { key: 'startDate',            label: 'Start Date'            },
    { key: 'endDate',              label: 'End Date'              },
    { key: 'paymentDate',          label: 'Payment Date'          },
    { key: 'totalPay',             label: 'Total Pay'             },
    { key: 'totalWithAdjustments', label: 'Total With Adj.'       },
    { key: 'loadsCount',           label: 'Loads Count'           },
    { key: 'totalMiles',           label: 'Total Miles'           },
    { key: 'totalDH',              label: 'Total DH'              },
    { key: 'loads',                label: 'Loads Detail'          },
    { key: 'additions',            label: 'Additions'             },
    { key: 'deductions',           label: 'Deductions'            },
    { key: 'createdAt',            label: 'Created At'            },
  ],
  fleetReports: [
    { key: 'fleetNumber',          label: 'Fleet Number'     },
    { key: 'truck',                label: 'Truck'            },
    { key: 'truckOwner',           label: 'Truck Owner'      },
    { key: 'startDate',            label: 'Start Date'       },
    { key: 'endDate',              label: 'End Date'         },
    { key: 'totalPay',             label: 'Total Pay'        },
    { key: 'totalWithAdjustments', label: 'Total With Adj.'  },
    { key: 'loadsCount',           label: 'Loads Count'      },
    { key: 'additions',            label: 'Additions'        },
    { key: 'deductions',           label: 'Deductions'       },
    { key: 'createdAt',            label: 'Created At'       },
  ],
  payrolls: [
    { key: 'employee',      label: 'Employee'       },
    { key: 'startDate',     label: 'Start Date'     },
    { key: 'endDate',       label: 'End Date'       },
    { key: 'gross',         label: 'Gross Pay'      },
    { key: 'totalTax',      label: 'Total Tax'      },
    { key: 'net',           label: 'Net Pay'        },
    { key: 'paymentMethod', label: 'Payment Method' },
    { key: 'checkNumber',   label: 'Check Number'   },
    { key: 'department',    label: 'Department'     },
    { key: 'additions',     label: 'Additions'      },
    { key: 'deductions',    label: 'Deductions'     },
    { key: 'benefits',      label: 'Benefits'       },
    { key: 'notes',         label: 'Notes'          },
    { key: 'createdAt',     label: 'Created At'     },
  ],
  invoices: [
    { key: 'invoiceNumber', label: 'Invoice Number' },
    { key: 'invoiceDate',   label: 'Invoice Date'   },
    { key: 'loadNumber',    label: 'Load Number'    },
    { key: 'brokerName',    label: 'Broker Name'    },
    { key: 'brokerAddress', label: 'Broker Address' },
    { key: 'rate',          label: 'Rate'           },
    { key: 'driver',        label: 'Driver'         },
    { key: 'status',        label: 'Status'         },
    { key: 'isPayed',       label: 'Paid'           },
    { key: 'notes',         label: 'Notes'          },
    { key: 'createdAt',     label: 'Created At'     },
  ],
  receivedInvoices: [
    { key: 'invoiceNumber', label: 'Invoice Number' },
    { key: 'invoiceDate',   label: 'Invoice Date'   },
    { key: 'vendor',        label: 'Vendor'         },
    { key: 'amount',        label: 'Amount'         },
    { key: 'status',        label: 'Status'         },
    { key: 'notes',         label: 'Notes'          },
    { key: 'createdAt',     label: 'Created At'     },
  ],
  factoringInvoices: [
    { key: 'invoiceNumber', label: 'Invoice Number' },
    { key: 'invoiceDate',   label: 'Invoice Date'   },
    { key: 'loadNumber',    label: 'Load Number'    },
    { key: 'brokerName',    label: 'Broker Name'    },
    { key: 'rate',          label: 'Rate'           },
    { key: 'driverName',    label: 'Driver Name'    },
    { key: 'status',        label: 'Status'         },
    { key: 'notes',         label: 'Notes'          },
    { key: 'createdAt',     label: 'Created At'     },
  ],
  fuel: [
    { key: 'driver',             label: 'Driver'              },
    { key: 'truck',              label: 'Truck'               },
    { key: 'transactionDate',    label: 'Transaction Date'    },
    { key: 'merchant',           label: 'Merchant'            },
    { key: 'state',              label: 'State'               },
    { key: 'location',           label: 'Location'            },
    { key: 'invoiceNumber',      label: 'Invoice Number'      },
    { key: 'cardNumber',         label: 'Card Number'         },
    { key: 'cardName',           label: 'Card Name'           },
    { key: 'fuelQuantity',       label: 'Fuel Qty (gal)'      },
    { key: 'fuelPPG',            label: 'Price Per Gallon'    },
    { key: 'defQuantity',        label: 'DEF Qty'             },
    { key: 'defAmount',          label: 'DEF Amount'          },
    { key: 'reeferQuantity',     label: 'Reefer Qty'          },
    { key: 'reeferPPG',          label: 'Reefer PPG'          },
    { key: 'oil',                label: 'Oil'                 },
    { key: 'otherFees',          label: 'Other Fees'          },
    { key: 'discount',           label: 'Discount'            },
    { key: 'totalToPay',         label: 'Total'               },
    { key: 'fuelResponsibility', label: 'Responsibility'      },
    { key: 'fuelPaymentStatus',  label: 'Payment Status'      },
    { key: 'isOwnerOperator',    label: 'Owner Operator'      },
    { key: 'createdAt',          label: 'Created At'          },
  ],
  ifta: [
    { key: 'quarter',            label: 'Quarter'             },
    { key: 'year',               label: 'Year'                },
    { key: 'fuelPurchasedState', label: 'Fuel Purchase State' },
    { key: 'milesDrivenState',   label: 'Miles Driven State'  },
    { key: 'fuelPrice',          label: 'Fuel Price'          },
    { key: 'fuelConsumed',       label: 'Fuel Consumed'       },
    { key: 'fuelLoaded',         label: 'Fuel Loaded'         },
    { key: 'milesDriven',        label: 'Miles Driven'        },
    { key: 'taxRate',            label: 'Tax Rate'            },
    { key: 'fuelTaxPaid',        label: 'Fuel Tax Paid'       },
    { key: 'dateOfFuelPurchase', label: 'Purchase Date'       },
    { key: 'paidIfta',           label: 'IFTA Paid'           },
    { key: 'createdAt',          label: 'Created At'          },
  ],
  assetCosts: [
    { key: 'assetType',   label: 'Asset Type'   },
    { key: 'type',        label: 'Type'         },
    { key: 'category',    label: 'Category'     },
    { key: 'vendor',      label: 'Vendor'       },
    { key: 'description', label: 'Description'  },
    { key: 'amount',      label: 'Amount'       },
    { key: 'currency',    label: 'Currency'     },
    { key: 'paymentType', label: 'Payment Type' },
    { key: 'startDate',   label: 'Start Date'   },
    { key: 'endDate',     label: 'End Date'     },
    { key: 'status',      label: 'Status'       },
    { key: 'active',      label: 'Active'       },
    { key: 'notes',       label: 'Notes'        },
    { key: 'bankName',    label: 'Bank Name'    },
    { key: 'reference',   label: 'Reference'    },
    { key: 'createdAt',   label: 'Created At'   },
  ],
  additionsDeductions: [
    { key: 'type',        label: 'Type'         },
    { key: 'category',    label: 'Category'     },
    { key: 'description', label: 'Description'  },
    { key: 'amount',      label: 'Amount'       },
    { key: 'vendor',      label: 'Vendor'       },
    { key: 'status',      label: 'Status'       },
    { key: 'startDate',   label: 'Start Date'   },
    { key: 'notes',       label: 'Notes'        },
    { key: 'createdAt',   label: 'Created At'   },
  ],
};

const ENTITIES = [
  { key: 'drivers',             label: 'Drivers',              tag: 'OPS'     },
  { key: 'fleet',               label: 'Fleet',                tag: 'OPS'     },
  { key: 'trailers',            label: 'Trailers',             tag: 'OPS'     },
  { key: 'shippers',            label: 'Shippers',             tag: 'OPS'     },
  { key: 'consignees',          label: 'Consignees',           tag: 'OPS'     },
  { key: 'brokers',             label: 'Brokers',              tag: 'OPS'     },
  { key: 'employees',           label: 'Employees',            tag: 'HR'      },
  { key: 'loads',               label: 'Loads',                tag: 'LOG'     },
  { key: 'driversPays',         label: 'Driver Pays',          tag: 'FIN'     },
  { key: 'payrolls',            label: 'Payrolls',             tag: 'FIN'     },
  { key: 'invoices',            label: 'Invoices',             tag: 'FIN'     },
  { key: 'receivedInvoices',    label: 'Received Invoices',    tag: 'FIN'     },
  { key: 'ifta',                label: 'IFTA',                 tag: 'COMP'    },
  { key: 'fuel',                label: 'Fuel',                 tag: 'COMP'    },
  { key: 'additionsDeductions', label: 'Additions / Deductions', tag: 'FIN'  },
];

const FORMATS = [
  { key: 'csv',          label: 'CSV'          },
  { key: 'excel',        label: 'Excel'        },
  { key: 'pdf',          label: 'PDF'          },
  { key: 'word',         label: 'Word'         },
  { key: 'googlesheets', label: 'Google Sheets'},
];

const TAG_COLORS = {
  OPS:  '#60A5FA',
  HR:   '#A78BFA',
  LOG:  '#34D399',
  FIN:  '#F59E0B',
  COMP: '#F87171',
};

const Exports = () => {
  const token  = sessionStorage.getItem('token');
  const config = { headers: { Authorization: `Bearer ${token}` }, withCredentials: true };

  const [selectedEntities, setSelectedEntities] = useState([]);
  const [entityFields,     setEntityFields]     = useState({});
  const [selectedFormat,   setSelectedFormat]   = useState('csv');
  const [loading,          setLoading]          = useState(false);
  const [previewData,      setPreviewData]      = useState(null);
  const [showPreview,      setShowPreview]      = useState(false);
  const [activeTab,        setActiveTab]        = useState('ALL');
// State nou — adaugă lângă celelalte state-uri
const [entityFilters,    setEntityFilters]    = useState({});
const [activeFieldTab,   setActiveFieldTab]   = useState({}); // 'fields' | 'filters' per entitate
  const [chatMessages, setChatMessages] = useState([
    {
      role: 'assistant',
      content: 'Hello! Describe what you want to export in plain English.\nExample: "Export all loads with rate and status in Excel format"',
    },
  ]);
  const [chatInput,   setChatInput]   = useState('');
  const [chatLoading, setChatLoading] = useState(false);
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatMessages]);

  const TABS = ['ALL', 'OPS', 'FIN', 'LOG', 'HR', 'COMP'];

  const filteredEntities = activeTab === 'ALL'
    ? ENTITIES
    : ENTITIES.filter(e => e.tag === activeTab);

  const toggleEntity = (key) =>
    setSelectedEntities(prev =>
      prev.includes(key) ? prev.filter(e => e !== key) : [...prev, key]
    );

  const selectAll = () => setSelectedEntities(filteredEntities.map(e => e.key));
  const clearAll  = () => setSelectedEntities([]);
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

const buildExportPayload = () => ({
  entities: selectedEntities.map(name => ({
    name,
    fields:  entityFields[name]  || [],
    filters: entityFilters[name] || {},
  })),
  format: selectedFormat,
});
  // ── Data fetch ────────────────────────────────────────────────────────────
  const fetchExportData = async (payload) => {
    const res = await axios.post(`${apiUrl}/exports`, payload, config);
    return res.data.data;
  };

  // ── Export: CSV ───────────────────────────────────────────────────────────
  const exportCSV = (data) => {
    const parts = [];
    for (const [entity, rows] of Object.entries(data)) {
      if (!rows.length) continue;
      const headers = Object.keys(rows[0]);
      parts.push(`=== ${entity.toUpperCase()} ===`);
      parts.push(headers.join(','));
      rows.forEach(row =>
        parts.push(headers.map(h => `"${String(row[h] ?? '').replace(/"/g, '""')}"`).join(','))
      );
      parts.push('');
    }
    const blob = new Blob([parts.join('\n')], { type: 'text/csv' });
    saveAs(blob, 'export.csv');
  };

  // ── Export: Excel ─────────────────────────────────────────────────────────
  const exportExcel = (data) => {
    const wb = XLSX.utils.book_new();
    for (const [entity, rows] of Object.entries(data)) {
      if (!rows.length) continue;
      const ws = XLSX.utils.json_to_sheet(rows);
      XLSX.utils.book_append_sheet(wb, ws, entity.slice(0, 31));
    }
    XLSX.writeFile(wb, 'export.xlsx');
  };

  // ── Export: PDF ───────────────────────────────────────────────────────────
  const exportPDF = (data) => {
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    const W = 210, M = 14;
    let y = 20;

    const c = {
      navy:     [10,  20,  45],
      navyMid:  [18,  32,  70],
      navyLt:   [28,  45,  95],
      amber:    [245, 158, 11],
      white:    [255, 255, 255],
      slate:    [148, 163, 200],
      offWhite: [240, 242, 248],
    };

    const fillC = rgb => doc.setFillColor(rgb[0], rgb[1], rgb[2]);
    const setC  = rgb => doc.setTextColor(rgb[0], rgb[1], rgb[2]);

    fillC(c.navyLt); doc.rect(0, 0, W, 28, 'F');
    fillC(c.amber);  doc.rect(0, 0, 5, 28, 'F');
    setC(c.white); doc.setFont('helvetica', 'bold'); doc.setFontSize(18);
    doc.text('DATA EXPORT REPORT', 12, 16);
    setC(c.slate); doc.setFont('helvetica', 'normal'); doc.setFontSize(7);
    doc.text(
      `Generated: ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`,
      12, 23
    );
    y = 38;

    for (const [entity, rows] of Object.entries(data)) {
      if (!rows.length) continue;
      const headers = Object.keys(rows[0]);

      if (y > 260) { doc.addPage(); fillC(c.navy); doc.rect(0, 0, W, 297, 'F'); y = 20; }

      fillC(c.amber); doc.rect(M, y, W - M * 2, 7, 'F');
      setC(c.navy); doc.setFont('helvetica', 'bold'); doc.setFontSize(8);
      doc.text(entity.toUpperCase(), M + 3, y + 5);
      y += 10;

      const colW = Math.min(40, (W - M * 2) / headers.length);
      fillC(c.navyLt); doc.rect(M, y, W - M * 2, 6, 'F');
      setC(c.slate); doc.setFont('helvetica', 'bold'); doc.setFontSize(5.5);
      headers.forEach((h, i) => doc.text(h.toUpperCase(), M + 2 + i * colW, y + 4.2));
      y += 6;

      rows.slice(0, 500).forEach((row, ri) => {
        if (y > 275) { doc.addPage(); fillC(c.navy); doc.rect(0, 0, W, 297, 'F'); y = 16; }
        fillC(ri % 2 === 0 ? c.navy : c.navyMid);
        doc.rect(M, y, W - M * 2, 5.5, 'F');
        setC(c.offWhite); doc.setFont('helvetica', 'normal'); doc.setFontSize(5.2);
        headers.forEach((h, i) => {
          doc.text(String(row[h] ?? '').slice(0, 20), M + 2 + i * colW, y + 4);
        });
        y += 5.5;
      });
      y += 8;
    }

    const total = doc.getNumberOfPages();
    for (let pg = 1; pg <= total; pg++) {
      doc.setPage(pg);
      fillC(c.navyMid); doc.rect(0, 287, W, 10, 'F');
      fillC(c.amber);   doc.rect(0, 287, W, 1,  'F');
      setC(c.slate); doc.setFont('helvetica', 'normal'); doc.setFontSize(5.5);
      doc.text('Full Trucking Service — Confidential Export', M, 293);
      doc.text(`Page ${pg} of ${total}`, W - M, 293, { align: 'right' });
    }

    doc.save('export.pdf');
  };

  // ── Export: Word ──────────────────────────────────────────────────────────
  const exportWord = async (data) => {
    const children = [];

    for (const [entity, rows] of Object.entries(data)) {
      if (!rows.length) continue;
      const headers = Object.keys(rows[0]);

      children.push(
        new Paragraph({
          text: entity.toUpperCase(),
          heading: HeadingLevel.HEADING_1,
          spacing: { before: 400, after: 200 },
        })
      );

      const tableRows = [
        new DocxTableRow({
          children: headers.map(h =>
            new DocxTableCell({
              children: [new Paragraph({ children: [new TextRun({ text: h, bold: true })] })],
              width: { size: Math.floor(9000 / headers.length), type: WidthType.DXA },
            })
          ),
        }),
        ...rows.slice(0, 500).map(row =>
          new DocxTableRow({
            children: headers.map(h =>
              new DocxTableCell({
                children: [new Paragraph(String(row[h] ?? ''))],
                width: { size: Math.floor(9000 / headers.length), type: WidthType.DXA },
              })
            ),
          })
        ),
      ];

      children.push(new DocxTable({ rows: tableRows, width: { size: 9000, type: WidthType.DXA } }));
    }

    const doc  = new DocxDocument({ sections: [{ children }] });
    const blob = await Packer.toBlob(doc);
    saveAs(blob, 'export.docx');
  };

  // ── Export: Google Sheets ─────────────────────────────────────────────────
  const exportGoogleSheets = (data) => {
    const parts = [];
    for (const [entity, rows] of Object.entries(data)) {
      if (!rows.length) continue;
      const headers = Object.keys(rows[0]);
      parts.push(`=== ${entity.toUpperCase()} ===`);
      parts.push(headers.join(','));
      rows.forEach(row =>
        parts.push(headers.map(h => `"${String(row[h] ?? '').replace(/"/g, '""')}"`).join(','))
      );
      parts.push('');
    }
    const blob = new Blob([parts.join('\n')], { type: 'text/csv' });
    window.open('https://docs.google.com/spreadsheets/d/new', '_blank');
    saveAs(blob, 'export_for_google_sheets.csv');
    alert('CSV downloaded. In Google Sheets: File > Import > Upload to import it.');
  };

  // ── Main export handler ───────────────────────────────────────────────────
  const handleExport = async () => {
    if (!selectedEntities.length) return alert('Please select at least one entity.');
    setLoading(true);
    try {
      const payload = buildExportPayload();
      const data    = await fetchExportData(payload);
      switch (selectedFormat) {
        case 'csv':          exportCSV(data);          break;
        case 'excel':        exportExcel(data);        break;
        case 'pdf':          exportPDF(data);          break;
        case 'word':         await exportWord(data);   break;
        case 'googlesheets': exportGoogleSheets(data); break;
        default:             exportCSV(data);
      }
    } catch (err) {
      alert('Export failed: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  // ── Preview handler ───────────────────────────────────────────────────────
  const handlePreview = async () => {
    if (!selectedEntities.length) return alert('Please select at least one entity.');
    setLoading(true);
    try {
      const payload = buildExportPayload();
      const data    = await fetchExportData(payload);
      setPreviewData(data);
      setShowPreview(true);
    } catch (err) {
      alert('Preview failed: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  // ── AI Chat handler ───────────────────────────────────────────────────────
  const handleAIChat = async () => {
    if (!chatInput.trim()) return;
    const userMsg = chatInput.trim();
    setChatInput('');
    setChatMessages(prev => [...prev, { role: 'user', content: userMsg }]);
    setChatLoading(true);

    try {
      const res = await axios.post(`${apiUrl}/exports/ai-chat`, { message: userMsg }, config);
      const { parsedConfig, data, summary } = res.data;

      setSelectedEntities(parsedConfig.entities.map(e => e.name));
      const fields = {};
      parsedConfig.entities.forEach(e => { fields[e.name] = (e.fields || []).join(', '); });
      setEntityFields(fields);
      setSelectedFormat(parsedConfig.format || 'csv');

      const counts = Object.entries(data)
        .map(([k, v]) => `${k}: ${v.length} records`)
        .join('  |  ');

      setChatMessages(prev => [
        ...prev,
        {
          role:    'assistant',
          content: `${summary}\n\n${counts}\n\nSelection updated. Click Export to download.`,
          config:  parsedConfig,
          data,
        },
      ]);
    } catch (err) {
      setChatMessages(prev => [
        ...prev,
        { role: 'assistant', content: `Error: ${err.response?.data?.error || err.message}` },
      ]);
    } finally {
      setChatLoading(false);
    }
  };

  const handleDownloadFromChat = async (msg) => {
    if (!msg.data) return;
    switch (msg.config?.format || 'csv') {
      case 'csv':          exportCSV(msg.data);          break;
      case 'excel':        exportExcel(msg.data);        break;
      case 'pdf':          exportPDF(msg.data);          break;
      case 'word':         await exportWord(msg.data);   break;
      case 'googlesheets': exportGoogleSheets(msg.data); break;
      default:             exportCSV(msg.data);
    }
  };

  // ── RENDER ────────────────────────────────────────────────────────────────
  return (
     <div className={`${styles.ExportsRoot} ${theme === 'light' ? styles.ExportsRootLight : ''}`}>

      {/* Page header */}
      <div className={styles.ExportsPageHeader}>
        <div className={styles.ExportsPageHeaderInner}>
          <p className={styles.ExportsPageEyebrow}>Full Trucking Service</p>
          <h1 className={styles.ExportsPageTitle}>Data Export Center</h1>
          <p className={styles.ExportsPageSubtitle}>
            Select entities, filter fields, choose a format, and download your data — or let the AI assistant build the export for you.
          </p>
        </div>
        <div className={styles.ExportsPageStats}>
          <div className={styles.ExportsStatPill}>
            <span className={styles.ExportsStatNumber}>{selectedEntities.length}</span>
            <span className={styles.ExportsStatLabel}>Selected</span>
          </div>
          <div className={styles.ExportsStatDivider} />
          <div className={styles.ExportsStatPill}>
            <span className={styles.ExportsStatNumber}>{selectedFormat.toUpperCase()}</span>
            <span className={styles.ExportsStatLabel}>Format</span>
          </div>
        </div>
      </div>

      {/* Main layout */}
      <div className={styles.ExportsLayout}>

        {/* ── LEFT COLUMN ── */}
        <div className={styles.ExportsLeftColumn}>

          {/* Step 1 — Entities */}
          <div className={styles.ExportsCard}>
            <div className={styles.ExportsCardHeader}>
              <div className={styles.ExportsStepBadge}>01</div>
              <div>
                <div className={styles.ExportsCardTitle}>Select Entities</div>
                <div className={styles.ExportsCardDesc}>Choose which data sources to include in your export.</div>
              </div>
            </div>

            {/* Filter tabs */}
            <div className={styles.ExportsTabRow}>
              {TABS.map(tab => (
                <button
                  key={tab}
                  type="button"
                  className={`${styles.ExportsTab} ${activeTab === tab ? styles.ExportsTabActive : ''}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
              <div className={styles.ExportsTabSpacer} />
              <button type="button" className={styles.ExportsMicroBtn} onClick={selectAll}>Select All</button>
              <button type="button" className={styles.ExportsMicroBtn} onClick={clearAll}>Clear</button>
            </div>

            {/* Entity grid */}
            <div className={styles.ExportsEntityGrid}>
              {filteredEntities.map(e => {
                const isActive = selectedEntities.includes(e.key);
                return (
                  <button
                    key={e.key}
                    type="button"
                    className={`${styles.ExportsEntityCard} ${isActive ? styles.ExportsEntityCardActive : ''}`}
                    onClick={() => toggleEntity(e.key)}
                  >
                    <div
                      className={styles.ExportsEntityTag}
                      style={{ color: TAG_COLORS[e.tag], borderColor: TAG_COLORS[e.tag] + '44', background: TAG_COLORS[e.tag] + '11' }}
                    >
                      {e.tag}
                    </div>
                    <div className={styles.ExportsEntityName}>{e.label}</div>
                    <div className={`${styles.ExportsEntityCheck} ${isActive ? styles.ExportsEntityCheckActive : ''}`}>
                      {isActive ? 'SELECTED' : 'ADD'}
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
{/* Step 2 — Fields & Filters */}
{selectedEntities.length > 0 && (
  <div className={styles.ExportsCard}>
    <div className={styles.ExportsCardHeader}>
      <div className={styles.ExportsStepBadge}>02</div>
      <div>
        <div className={styles.ExportsCardTitle}>
          Configure Export <span className={styles.ExportsOptional}>(optional)</span>
        </div>
        <div className={styles.ExportsCardDesc}>
          Select specific fields and apply filters per entity.
        </div>
      </div>
    </div>

    <div className={styles.ExportsFieldList}>
      {selectedEntities.map(key => {
        const entity         = ENTITIES.find(e => e.key === key);
        const availableFields  = ENTITY_FIELDS[key]   || [];
        const availableFilters = ENTITY_FILTERS[key]  || [];
        const selectedFieldKeys = entityFields[key]   || [];
        const currentFilters   = entityFilters[key]   || {};
        const currentTab       = activeFieldTab[key]  || 'fields';

        const toggleField = (fieldKey) => {
          setEntityFields(prev => {
            const current = prev[key] || [];
            const updated = current.includes(fieldKey)
              ? current.filter(f => f !== fieldKey)
              : [...current, fieldKey];
            return { ...prev, [key]: updated };
          });
        };

        const setFilter = (filterKey, value) => {
          setEntityFilters(prev => ({
            ...prev,
            [key]: {
              ...(prev[key] || {}),
              [filterKey]: value,
            },
          }));
        };

        const clearFilter = (filterKey) => {
          setEntityFilters(prev => {
            const updated = { ...(prev[key] || {}) };
            delete updated[filterKey];
            return { ...prev, [key]: updated };
          });
        };

        const setTab = (tab) =>
          setActiveFieldTab(prev => ({ ...prev, [key]: tab }));

        const activeFiltersCount = Object.keys(currentFilters).filter(k => currentFilters[k]).length;
        const activeFieldsCount  = selectedFieldKeys.length;

        return (
          <div key={key} className={styles.ExportsFieldSection}>

            {/* Section header */}
            <div className={styles.ExportsFieldSectionHeader}>
              <div className={styles.ExportsFieldSectionLeft}>
                <span
                  className={styles.ExportsFieldTag}
                  style={{
                    color:       TAG_COLORS[entity?.tag],
                    borderColor: TAG_COLORS[entity?.tag] + '44',
                    background:  TAG_COLORS[entity?.tag] + '11',
                  }}
                >
                  {entity?.tag}
                </span>
                <span className={styles.ExportsFieldSectionName}>{entity?.label}</span>
                {activeFieldsCount > 0 && (
                  <span className={styles.ExportsFieldCount} style={{ color: TAG_COLORS[entity?.tag] }}>
                    {activeFieldsCount} fields
                  </span>
                )}
                {activeFiltersCount > 0 && (
                  <span className={styles.ExportsFilterCount}>
                    {activeFiltersCount} filter{activeFiltersCount > 1 ? 's' : ''}
                  </span>
                )}
              </div>
            </div>

            {/* Sub-tabs: Fields / Filters */}
            <div className={styles.ExportsSubTabRow}>
              <button
                type="button"
                className={`${styles.ExportsSubTab} ${currentTab === 'fields' ? styles.ExportsSubTabActive : ''}`}
                onClick={() => setTab('fields')}
                style={currentTab === 'fields' ? { borderColor: TAG_COLORS[entity?.tag], color: TAG_COLORS[entity?.tag] } : {}}
              >
                Fields
                {activeFieldsCount > 0 && (
                  <span className={styles.ExportsSubTabBadge}>{activeFieldsCount}</span>
                )}
              </button>
              {availableFilters.length > 0 && (
                <button
                  type="button"
                  className={`${styles.ExportsSubTab} ${currentTab === 'filters' ? styles.ExportsSubTabActive : ''}`}
                  onClick={() => setTab('filters')}
                  style={currentTab === 'filters' ? { borderColor: '#F87171', color: '#F87171' } : {}}
                >
                  Filters
                  {activeFiltersCount > 0 && (
                    <span className={styles.ExportsSubTabBadge} style={{ background: '#F87171' }}>{activeFiltersCount}</span>
                  )}
                </button>
              )}
              <div style={{ flex: 1 }} />
              {currentTab === 'fields' && availableFields.length > 0 && (
                <>
                  <button type="button" className={styles.ExportsMicroBtn}
                    onClick={() => setEntityFields(prev => ({ ...prev, [key]: availableFields.map(f => f.key) }))}>
                    All
                  </button>
                  <button type="button" className={styles.ExportsMicroBtn}
                    onClick={() => setEntityFields(prev => ({ ...prev, [key]: [] }))}>
                    None
                  </button>
                </>
              )}
              {currentTab === 'filters' && activeFiltersCount > 0 && (
                <button type="button" className={styles.ExportsMicroBtn}
                  onClick={() => setEntityFilters(prev => ({ ...prev, [key]: {} }))}>
                  Clear All
                </button>
              )}
            </div>

            {/* FIELDS TAB */}
            {currentTab === 'fields' && (
              <div className={styles.ExportsFieldPicker}>
                {availableFields.length > 0 ? availableFields.map(field => {
                  const isSelected = selectedFieldKeys.includes(field.key);
                  return (
                    <button
                      key={field.key}
                      type="button"
                      className={`${styles.ExportsFieldChip} ${isSelected ? styles.ExportsFieldChipActive : ''}`}
                      onClick={() => toggleField(field.key)}
                      style={isSelected ? {
                        borderColor: TAG_COLORS[entity?.tag] + '88',
                        background:  TAG_COLORS[entity?.tag] + '18',
                        color:       TAG_COLORS[entity?.tag],
                      } : {}}
                    >
                      {isSelected && <span className={styles.ExportsFieldChipDot} />}
                      {field.label}
                    </button>
                  );
                }) : (
                  <p className={styles.ExportsNoFields}>All fields will be exported.</p>
                )}
              </div>
            )}

            {/* FILTERS TAB */}
            {currentTab === 'filters' && availableFilters.length > 0 && (
              <div className={styles.ExportsFiltersGrid}>
                {availableFilters.map(filter => {
                  const val = currentFilters[filter.key] || '';
                  return (
                    <div key={filter.key} className={styles.ExportsFilterRow}>
                      <label className={styles.ExportsFilterLabel}>
                        {filter.label}
                        {val && (
                          <button
                            type="button"
                            className={styles.ExportsFilterClear}
                            onClick={() => clearFilter(filter.key)}
                          >
                            ×
                          </button>
                        )}
                      </label>

                      {filter.type === 'select' ? (
                        <select
                          className={styles.ExportsFilterSelect}
                          value={val}
                          onChange={e => e.target.value
                            ? setFilter(filter.key, e.target.value)
                            : clearFilter(filter.key)
                          }
                        >
                          <option value="">— Any —</option>
                          {filter.options.map(opt => (
                            <option key={opt} value={opt}>{opt}</option>
                          ))}
                        </select>
                      ) : filter.type === 'date' ? (
                        <input
                          type="date"
                          className={styles.ExportsFilterInput}
                          value={val}
                          onChange={e => e.target.value
                            ? setFilter(filter.key, e.target.value)
                            : clearFilter(filter.key)
                          }
                        />
                      ) : (
                        <input
                          type="text"
                          className={styles.ExportsFilterInput}
                          placeholder={filter.placeholder || ''}
                          value={val}
                          onChange={e => e.target.value
                            ? setFilter(filter.key, e.target.value)
                            : clearFilter(filter.key)
                          }
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  </div>
)}

          {/* Step 3 — Format */}
          <div className={styles.ExportsCard}>
            <div className={styles.ExportsCardHeader}>
              <div className={styles.ExportsStepBadge}>03</div>
              <div>
                <div className={styles.ExportsCardTitle}>Choose Format</div>
                <div className={styles.ExportsCardDesc}>Select the output format for your export file.</div>
              </div>
            </div>
            <div className={styles.ExportsFormatGrid}>
              {FORMATS.map(f => (
                <button
                  key={f.key}
                  type="button"
                  className={`${styles.ExportsFormatBtn} ${selectedFormat === f.key ? styles.ExportsFormatBtnActive : ''}`}
                  onClick={() => setSelectedFormat(f.key)}
                >
                  <span className={styles.ExportsFormatLabel}>{f.label}</span>
                  {selectedFormat === f.key && <span className={styles.ExportsFormatDot} />}
                </button>
              ))}
            </div>
          </div>

          {/* Action row */}
          <div className={styles.ExportsActionRow}>
            <button
              type="button"
              className={styles.ExportsPreviewBtn}
              onClick={handlePreview}
              disabled={loading || !selectedEntities.length}
            >
              {loading ? 'Loading...' : 'Preview Data'}
            </button>
            <button
              type="button"
              className={styles.ExportsExportBtn}
              onClick={handleExport}
              disabled={loading || !selectedEntities.length}
            >
              {loading ? 'Exporting...' : `Export as ${selectedFormat.toUpperCase()}`}
            </button>
          </div>
        </div>

        {/* ── RIGHT COLUMN — AI Chat ── */}
        <div className={styles.ExportsRightColumn}>
          <div className={styles.ExportsAIPanel}>

            <div className={styles.ExportsAIPanelHeader}>
              <div className={styles.ExportsAITitleRow}>
                <span className={styles.ExportsAITitle}>AI Export Assistant</span>
                <span className={styles.ExportsAIBadge}>PandaHelp</span>
              </div>
              <p className={styles.ExportsAIDesc}>
                Describe in plain English what you need. The AI will configure the export and download it automatically.
              </p>
            </div>

            <div className={styles.ExportsChatWindow}>
              {chatMessages.map((msg, i) => (
                <div
                  key={i}
                  className={`${styles.ExportsChatMsg} ${
                    msg.role === 'user' ? styles.ExportsChatMsgUser : styles.ExportsChatMsgAI
                  }`}
                >
                  {msg.role === 'assistant' && (
                    <div className={styles.ExportsChatAvatar}>AI</div>
                  )}
                  <div className={styles.ExportsChatBubble}>
                    {msg.content.split('\n').map((line, j) => (
                      <div key={j}>{line}</div>
                    ))}
                    {msg.data && (
                      <button
                        type="button"
                        className={styles.ExportsChatDownloadBtn}
                        onClick={() => handleDownloadFromChat(msg)}
                      >
                        Download {msg.config?.format?.toUpperCase() || 'CSV'}
                      </button>
                    )}
                  </div>
                </div>
              ))}

              {chatLoading && (
                <div className={`${styles.ExportsChatMsg} ${styles.ExportsChatMsgAI}`}>
                  <div className={styles.ExportsChatAvatar}>AI</div>
                  <div className={`${styles.ExportsChatBubble} ${styles.ExportsChatTyping}`}>
                    <span /><span /><span />
                  </div>
                </div>
              )}
              <div ref={chatEndRef} />
            </div>

            <div className={styles.ExportsChatInputRow}>
              <input
                type="text"
                className={styles.ExportsChatInput}
                placeholder='e.g. "Export all loads with rate and driver name as Excel"'
                value={chatInput}
                onChange={e => setChatInput(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && !chatLoading && handleAIChat()}
                disabled={chatLoading}
              />
              <button
                type="button"
                className={styles.ExportsChatSendBtn}
                onClick={handleAIChat}
                disabled={chatLoading || !chatInput.trim()}
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ── Preview Modal ── */}
      {showPreview && previewData && createPortal(
        <div
          className={styles.ExportsModalOverlay}
          onClick={e => { if (e.target === e.currentTarget) setShowPreview(false); }}
        >
          <div className={styles.ExportsModalPanel}>
            <div className={styles.ExportsModalHeader}>
              <h2 className={styles.ExportsModalTitle}>Export Preview</h2>
              <button
                type="button"
                className={styles.ExportsModalClose}
                onClick={() => setShowPreview(false)}
              >
                Close
              </button>
            </div>

            {Object.entries(previewData).map(([entity, rows]) => (
              <div key={entity} className={styles.ExportsPreviewSection}>
                <div className={styles.ExportsPreviewSectionHeader}>
                  <span className={styles.ExportsPreviewEntity}>{entity}</span>
                  <span className={styles.ExportsPreviewCount}>{rows.length} records</span>
                </div>

                {rows.length > 0 ? (
                  <div className={styles.ExportsPreviewTableWrap}>
                    <table className={styles.ExportsPreviewTable}>
                      <thead>
                        <tr>
                          {Object.keys(rows[0]).map(h => (
                            <th key={h} className={styles.ExportsPreviewTh}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {rows.slice(0, 10).map((row, i) => (
                          <tr key={i} className={i % 2 === 0 ? styles.ExportsPreviewRowEven : styles.ExportsPreviewRowOdd}>
                            {Object.values(row).map((val, j) => (
                              <td key={j} className={styles.ExportsPreviewTd}>
                                {String(val ?? '—').slice(0, 40)}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {rows.length > 10 && (
                      <p className={styles.ExportsPreviewNote}>
                        Showing first 10 of {rows.length} records.
                      </p>
                    )}
                  </div>
                ) : (
                  <p className={styles.ExportsPreviewEmpty}>No data found for this entity.</p>
                )}
              </div>
            ))}
          </div>
        </div>,
        document.body
      )}
      <EmailPanel />
    </div>
  );
};





const formatDateDisplay = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

const formatDateInput = (d) => (d ? new Date(d).toISOString().split('T')[0] : '');

const isExpired = (dateStr) => {
  if (!dateStr) return false;
  return new Date(dateStr) < new Date();
};


const STATUS_CONFIG = {
  active:     { bg: '#0F6E56', color: '#E1F5EE', label: 'Active' },
  on_leave:   { bg: '#854F0B', color: '#FAEEDA', label: 'On Leave' },
  suspended:  { bg: '#993C1D', color: '#FAECE7', label: 'Suspended' },
  inactive:   { bg: '#5F5E5A', color: '#F1EFE8', label: 'Inactive' },
  terminated: { bg: '#A32D2D', color: '#FCEBEB', label: 'Terminated' },
};

const CHECKLIST_ITEMS = [
  ['copyOfLicense',                'Copy of License'],
  ['preEmploymentDrugTest',        'Pre-Employment Drug Test'],
  ['longMedicalForm',              'Long Medical Form'],
  ['copyOfRoadTest',               'Copy of Road Test'],
  ['enrolledInDrugTestingProgram', 'Enrolled in Drug Testing Program'],
  ['certificateOfCompliance',      'Certificate of Compliance'],
  ['inquiryToPreviousEmployers',   'Inquiry to Previous Employers'],
  ['nonMotorCarrierActivityForm',  'Non-Motor Carrier Activity Form'],
  ['inquiryToStateAgencies',       'Inquiry to State Agencies'],
  ['proofOfReceivingFMCSRHandbook','Proof of Receiving FMCSR Handbook'],
];

// ─── Initial State ───────────────────────────────────────────────────────────

const INITIAL_DATA = {
  firstName: '', lastName: '', dateOfBirth: '', hireDate: '', terminationDate: '',
  truckNumber: '', email: '', mobilePhone: '', phone: '', address: '',
  licenseNumber: '', licenseExpiryDate: '', passportExpiryDate: '',
  lastMedical: '', nextMedical: '', lastDrugTest: '', lastAlcoholTest: '',
  fuelCardNumber: '', fuelCardExpiryDate: '', fleetDivision: '',
  settlement: '', settlementAmount: 0, normalMileRate: 0, dhMileRate: 0,
  hourlyRate: 0, hoursWorked: 0, teamDriver: '', teamPercentage: 50,
  licenseType: '', licenseState: '',
  emergencyContactFirstName: '', emergencyContactLastName: '',
  emergencyContactRelation: '', emergencyContactPhone: '',
  employeeRecordsChecklist: {
    copyOfLicense: false, preEmploymentDrugTest: false, longMedicalForm: false,
    copyOfRoadTest: false, enrolledInDrugTestingProgram: false,
    certificateOfCompliance: false, inquiryToPreviousEmployers: false,
    nonMotorCarrierActivityForm: false, inquiryToStateAgencies: false,
    proofOfReceivingFMCSRHandbook: false,
  },
  recurringDeductions: [], recurringAdditions: [],
  internalNotes: '', annualCertificationOfViolations: '',
  employmentApplication: '', annualMVRReview: '', notes: '',
  payrollDocuments: [],
  location: { latitude: null, longitude: null, updatedAt: null },
  status: 'active', statusNote: '',
  expoPushToken: '', socketId: '',
  driverType: 'employee', driverNumber: '',
};

// ─── StatusBadge ─────────────────────────────────────────────────────────────

const StatusBadge = ({ status }) => {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.inactive;
  return (
    <span style={{
      background: cfg.bg, color: cfg.color,
      padding: '2px 10px', borderRadius: 12,
      fontSize: 11, fontWeight: 500, marginLeft: 8,
      textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap',
    }}>
      {cfg.label}
    </span>
  );
};

// ════════════════════════════════════════════════════════════════════════════
// COMPONENT
// ════════════════════════════════════════════════════════════════════════════

const Drivers = ({ drivers = [], setDrivers, trucks = [] }) => {
  const { notify } = useNotification();
  const apiUrl   = 'https://api-backend.full-trucking-service.com/api';
  const token    = sessionStorage.getItem('token');
  const clientId = localStorage.getItem('clientId');
  const config   = { headers: { Authorization: `Bearer ${token}` }, withCredentials: true };
  const fileInputRef = useRef(null);

  // ── Core state ──
  const [limits, setLimits]             = useState({ numberOfDrivers: 0 });
  const [driverData, setDriverData]     = useState(INITIAL_DATA);
  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery]   = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [statusFilter, setStatusFilter] = useState('all');
  const [activeTab, setActiveTab]       = useState('info');
  const [theme, setTheme]               = useState(() => sessionStorage.getItem('theme') || 'dark');
const [pendingDocuments, setPendingDocuments] = useState([]);

  const [driverDocuments, setDriverDocuments]     = useState([]);
  const [docLoading, setDocLoading]               = useState(false);
  const [docUploadFile, setDocUploadFile]         = useState(null);
  const [docUploadType, setDocUploadType]         = useState('driver_document');
  const [docUploadTitle, setDocUploadTitle]       = useState('');
  const [dragOver, setDragOver]                   = useState(false);

  // ── Modal state ──
  const [selectedDriver, setSelectedDriver]     = useState(null);
  const [modalDocs, setModalDocs]               = useState([]);
  const [modalDocsLoading, setModalDocsLoading] = useState(false);
  const [previewUrl, setPreviewUrl]             = useState('');
  const [previewMime, setPreviewMime]           = useState('');
  const [showPreview, setShowPreview]           = useState(false);

  // ── Theme ──
  useEffect(() => {
    axios.get(`${apiUrl}/settings`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setTheme(r.data.theme || 'dark'))
      .catch(() => setTheme('dark'));
  }, []);

  // ── Fetch limits ──
  useEffect(() => {
    axios.get(`${apiUrl}/clients`, config)
      .then(r => setLimits({ numberOfDrivers: r.data.numberOfDrivers }))
      .catch(() => {});
  }, []);

  // ── Fetch drivers ──
  const fetchDrivers = async () => {
    try {
      const r = await axios.get(`${apiUrl}/drivers`, config);
      setDrivers(r.data);
    } catch {}
  };
  useEffect(() => { fetchDrivers(); }, []);

  // ── Handlers: form ──
  const handleChange = (e) => {
    const { name, value } = e.target;
    setDriverData(p => ({ ...p, [name]: value }));
  };

  const handleCheckboxChange = (e, field) => {
    const [section, key] = field.split('.');
    if (section === 'employeeRecordsChecklist') {
      setDriverData(p => ({
        ...p,
        employeeRecordsChecklist: { ...p.employeeRecordsChecklist, [key]: e.target.checked },
      }));
    }
  };

  const handleSettlementChange = (e) => {
    const s = e.target.value;
    setDriverData(p => ({
      ...p, settlement: s,
      normalMileRate:   s === 'Per mile pay'    ? p.normalMileRate : 0,
      dhMileRate:       s === 'Per mile pay'    ? p.dhMileRate     : 0,
      hourlyRate:       s === 'Hourly pay'      ? p.hourlyRate     : 0,
      hoursWorked:      s === 'Hourly pay'      ? p.hoursWorked    : 0,
      teamDriver:       s === 'Team driver pay' ? p.teamDriver     : '',
      teamPercentage:   s === 'Team driver pay' ? p.teamPercentage : 50,
      settlementAmount: (s !== 'Per mile pay' && s !== 'Hourly pay') ? p.settlementAmount : 0,
    }));
  };

  // ── Handlers: status ──
  const handleStatusChange = async (driverId, newStatus) => {
    try {
      await axios.put(`${apiUrl}/drivers/${driverId}/status`, { status: newStatus }, config);
      fetchDrivers();
      notify(`Status updated to "${STATUS_CONFIG[newStatus]?.label}".`, 'success');
    } catch (err) {
      notify(err.response?.data?.error || 'Failed to update status.', 'error');
    }
  };

  // ── Handlers: documents ──
  const fetchDriverDocuments = async (driverId) => {
    setDocLoading(true);
    try {
      const r = await axios.get(`${apiUrl}/drivers/${driverId}/documents`, config);
      setDriverDocuments(r.data);
    } catch { setDriverDocuments([]); }
    finally { setDocLoading(false); }
  };

const fetchModalDocuments = async (driverId) => {
  setModalDocsLoading(true);
  try {
    // Încearcă endpoint-ul dedicat driver
    const r = await axios.get(`${apiUrl}/drivers/${driverId}/documents`, config);
    setModalDocs(r.data);
  } catch {
    try {
      // Fallback: endpoint-ul general cu filter
      const r = await axios.get(`${apiUrl}/documents`, {
        ...config,
        params: { linkedEntityType: 'driver', linkedEntityId: driverId },
      });
      setModalDocs(r.data);
    } catch {
      setModalDocs([]);
    }
  } finally {
    setModalDocsLoading(false);
  }
};
  const handleFileDrop = (e) => {
    e.preventDefault(); setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) { setDocUploadFile(file); setDocUploadTitle(file.name); }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) { setDocUploadFile(file); setDocUploadTitle(file.name); }
  };

  const handleDocumentUpload = async () => {
    if (!docUploadFile) return notify('Please select a file.', 'error');

    // Driver nou → coada pending
    if (editingIndex === null) {
      setPendingDocuments(p => [...p, {
        file: docUploadFile, docType: docUploadType,
        title: docUploadTitle || docUploadFile.name,
        previewName: docUploadFile.name, size: docUploadFile.size,
      }]);
      setDocUploadFile(null); setDocUploadTitle('');
      if (fileInputRef.current) fileInputRef.current.value = '';
      notify('Document queued — will upload after driver is saved.', 'success');
      return;
    }

    // Driver existent → upload imediat
    const d = drivers[editingIndex];
    const fd = new FormData();
    fd.append('file',               docUploadFile);
    fd.append('docType',            docUploadType);
    fd.append('title',              docUploadTitle || docUploadFile.name);
    fd.append('linkedEntityType',   'driver');
    fd.append('linkedEntityId',     d._id);
    fd.append('linkedEntityLabel',  `${d.firstName} ${d.lastName}`);

    try {
      await axios.post(`${apiUrl}/documents`, fd, {
        headers: { ...config.headers, 'Content-Type': 'multipart/form-data' },
        withCredentials: true,
      });
      notify('Document uploaded!', 'success');
      setDocUploadFile(null); setDocUploadTitle('');
      if (fileInputRef.current) fileInputRef.current.value = '';
      fetchDriverDocuments(d._id);
    } catch (err) {
      notify(err.response?.data?.error || 'Upload failed.', 'error');
    }
  };

  const handleDeleteDocument = async (docId) => {
    if (!window.confirm('Delete this document?')) return;
    try {
      await axios.delete(`${apiUrl}/documents/${docId}`, config);
      notify('Document deleted.', 'success');
      if (editingIndex !== null) fetchDriverDocuments(drivers[editingIndex]._id);
    } catch { notify('Failed to delete document.', 'error'); }
  };

  const handlePreviewDoc = async (doc) => {
    try {
      const r = await axios.get(`${apiUrl}/documents/${doc.id}/download`, {
        ...config, responseType: 'blob',
      });
      setPreviewUrl(URL.createObjectURL(r.data));
      setPreviewMime(doc.mimeType);
      setShowPreview(true);
    } catch { notify('Preview failed.', 'error'); }
  };

  const removePending = (i) => setPendingDocuments(p => p.filter((_, idx) => idx !== i));

 const handleSubmit = async () => {
  if (editingIndex === null && drivers.length >= limits.numberOfDrivers)
    return notify('Driver limit reached.', 'error');

  const dataToSend = {
    ...driverData,
    settlementAmount: Number(driverData.settlementAmount) || 0,
    hourlyRate:       Number(driverData.hourlyRate)       || 0,
    hoursWorked:      Number(driverData.hoursWorked)      || 0,
    normalMileRate:   Number(driverData.normalMileRate)   || 0,
    dhMileRate:       Number(driverData.dhMileRate)       || 0,
    teamPercentage:   Number(driverData.teamPercentage)   || 0,
    licenseExpiryDate:  driverData.licenseExpiryDate  || null,
    hireDate:           driverData.hireDate           || null,
    terminationDate: driverData.terminationDate || null,
driverType:      driverData.driverType      || 'employee',
driverNumber:    driverData.driverNumber    || '',
internalNotes:   driverData.internalNotes   || '',
    dateOfBirth:        driverData.dateOfBirth        || null,
    passportExpires:    driverData.passportExpiryDate || null,
    lastDrugTestDate:   driverData.lastDrugTest       || null,
    lastAlcoholTest:    driverData.lastAlcoholTest    || null,
    fuelCardExpires:    driverData.fuelCardExpiryDate || null,
    medicalInfo: {
      lastMedical:     driverData.lastMedical     || null,
      nextMedical:     driverData.nextMedical     || null,
      lastAlcoholTest: driverData.lastAlcoholTest || null,
    },
    // În dataToSend, adaugă:
emergencyContact: {
  firstName: driverData.emergencyContactFirstName || '',
  lastName:  driverData.emergencyContactLastName  || '',
  relation:  driverData.emergencyContactRelation  || '',
  phone:     driverData.emergencyContactPhone     || '',
},
    corporateInfo: {
      fuelCardNumber:  driverData.fuelCardNumber     || '',
      fuelCardExpires: driverData.fuelCardExpiryDate || null,
      fleetDivision:   driverData.fleetDivision      || '',
    },
   checklist: {
  copyOfLicense:                driverData.employeeRecordsChecklist.copyOfLicense                || false,
  preEmploymentDrugTest:        driverData.employeeRecordsChecklist.preEmploymentDrugTest        || false,
  longMedicalForm:              driverData.employeeRecordsChecklist.longMedicalForm              || false,
  copyOfRoadTest:               driverData.employeeRecordsChecklist.copyOfRoadTest               || false,
  enrolledInDrugTestingProgram: driverData.employeeRecordsChecklist.enrolledInDrugTestingProgram || false,
  certificateOfCompliance:      driverData.employeeRecordsChecklist.certificateOfCompliance      || false,
  inquiryToPreviousEmployers:   driverData.employeeRecordsChecklist.inquiryToPreviousEmployers   || false,
  nonMotorCarrierActivityForm:  driverData.employeeRecordsChecklist.nonMotorCarrierActivityForm  || false,
  inquiryToStateAgencies:       driverData.employeeRecordsChecklist.inquiryToStateAgencies       || false,
  proofOfReceivingFMCSRHandbook: driverData.employeeRecordsChecklist.proofOfReceivingFMCSRHandbook || false,
},
    location:            driverData.location            || {},
    payrollDocuments:    driverData.payrollDocuments    || [],
    recurringDeductions: driverData.recurringDeductions || [],
    recurringAdditions:  driverData.recurringAdditions  || [],
    status:     driverData.status     || 'active',
    statusNote: driverData.statusNote || '',
    clientId,
  };

  try {
    let response;
    if (editingIndex !== null) {
      response = await axios.put(
        `${apiUrl}/drivers/${drivers[editingIndex]._id}`,
        dataToSend,
        config
      );
    } else {
      response = await axios.post(`${apiUrl}/drivers`, dataToSend, config);
    }

    if (response.status === 200 || response.status === 201) {
      const savedDriverId = editingIndex !== null
        ? drivers[editingIndex]._id
        : (response.data.driver?._id || response.data._id);
      const savedDriverName = `${driverData.firstName} ${driverData.lastName}`;

      if (docUploadFile && savedDriverId) {
        const fd = new FormData();
        fd.append('file',              docUploadFile);
        fd.append('docType',           docUploadType);
        fd.append('title',             docUploadTitle || docUploadFile.name);
        fd.append('linkedEntityType',  'driver');
        fd.append('linkedEntityId',    savedDriverId);
        fd.append('linkedEntityLabel', savedDriverName);
        try {
          await axios.post(`${apiUrl}/documents`, fd, {
            headers: { ...config.headers, 'Content-Type': 'multipart/form-data' },
            withCredentials: true,
          });
          notify(editingIndex !== null ? 'Driver updated & document uploaded!' : 'Driver added & document uploaded!', 'success');
        } catch {
          notify('Driver saved but document upload failed.', 'error');
        }
      } else {
        notify(editingIndex !== null ? 'Driver updated!' : 'Driver added!', 'success');
      }

      fetchDrivers();
      setDriverData(INITIAL_DATA);
      setEditingIndex(null);
      setActiveTab('info');
      setDriverDocuments([]);
      setDocUploadFile(null);
      setDocUploadTitle('');
      setDocUploadType('driver_document');
      if (fileInputRef.current) fileInputRef.current.value = '';

    } else {
      notify(response.data.error || 'Failed to save driver.', 'error');
    }
  } catch (err) {
    notify(err.response?.data?.error || 'Failed to save driver.', 'error');
  }
};

  // ── Handlers: edit ──
  const handleEdit = async (index) => {
    try {
      const r = await axios.get(`${apiUrl}/drivers/${drivers[index]._id}`, config);
      const d = r.data;
      setDriverData({
        firstName: d.firstName || '', lastName: d.lastName || '',
        dateOfBirth: formatDateInput(d.dateOfBirth),
        hireDate: formatDateInput(d.hireDate),
        terminationDate: formatDateInput(d.terminationDate),
        truckNumber: d.truckNumber || '', email: d.email || '',
        mobilePhone: d.mobilePhone || '', phone: d.phone || '', address: d.address || '',
        licenseNumber: d.licenseNumber || '',
        licenseExpiryDate: formatDateInput(d.licenseExpiryDate),
        passportExpiryDate: formatDateInput(d.passportExpires),
        lastMedical: formatDateInput(d.medicalInfo?.lastMedical),
        nextMedical: formatDateInput(d.medicalInfo?.nextMedical),
        lastDrugTest: formatDateInput(d.lastDrugTestDate || d.medicalInfo?.lastDrugTest),
        lastAlcoholTest: formatDateInput(d.medicalInfo?.lastAlcoholTest),
        fuelCardNumber: d.corporateInfo?.fuelCardNumber || '',
        fuelCardExpiryDate: formatDateInput(d.corporateInfo?.fuelCardExpires),
        fleetDivision: d.corporateInfo?.fleetDivision || '',
        settlement: d.settlement || '', settlementAmount: d.settlementAmount || '',
        normalMileRate: d.normalMileRate || '', dhMileRate: d.dhMileRate || '',
        hourlyRate: d.hourlyRate || '', hoursWorked: d.hoursWorked || '',
        teamDriver: d.teamDriver || '', teamPercentage: d.teamPercentage || '',
        licenseType: d.licenseType || '', licenseState: d.licenseState || '',
        emergencyContactFirstName: d.emergencyContact?.firstName || '',
        emergencyContactLastName:  d.emergencyContact?.lastName  || '',
        emergencyContactRelation:  d.emergencyContact?.relation  || '',
        emergencyContactPhone:     d.emergencyContact?.phone     || '',
        employeeRecordsChecklist: {
          copyOfLicense:                d.checklist?.copyOfLicense                || false,
          preEmploymentDrugTest:        d.checklist?.preEmploymentDrugTest        || false,
          longMedicalForm:              d.checklist?.longMedicalForm              || false,
          copyOfRoadTest:               d.checklist?.copyOfRoadTest               || false,
          enrolledInDrugTestingProgram: d.checklist?.enrolledInDrugTestingProgram || false,
          certificateOfCompliance:      d.checklist?.certificateOfCompliance      || false,
          inquiryToPreviousEmployers:   d.checklist?.inquiryToPreviousEmployers   || false,
          nonMotorCarrierActivityForm:  d.checklist?.nonMotorCarrierActivityForm  || false,
          inquiryToStateAgencies:       d.checklist?.inquiryToStateAgencies       || false,
          proofOfReceivingFMCSRHandbook: d.checklist?.proofOfReceivingFMCSRHandbook || false,
        },
        recurringDeductions: d.recurringDeductions || [],
        recurringAdditions:  d.recurringAdditions  || [],
        internalNotes: d.internalNotes || '',
        annualCertificationOfViolations: d.annualCertificationOfViolations || '',
        employmentApplication: d.employmentApplication || '',
        annualMVRReview: d.annualMVRReview || '',
        notes: d.notes || '', payrollDocuments: d.payrollDocuments || [],
        location: d.location || {},
        status: d.status || 'active', statusNote: d.statusNote || '',
        expoPushToken: d.expoPushToken || '', socketId: d.socketId || '',
        driverType: d.driverType || 'employee', driverNumber: d.driverNumber || '',
      });
      setEditingIndex(index);
      setActiveTab('info');
      setDriverDocuments([]);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      notify(err.response?.data?.error || 'Failed to fetch driver.', 'error');
    }
  };

  // ── Handlers: delete ──
  const confirmDeleteDriver = async (index) => {
    try {
      await axios.delete(`${apiUrl}/drivers/${drivers[index]._id}`, config);
      setDrivers(p => p.filter((_, i) => i !== index));
      notify('Driver deleted.', 'success');
    } catch { notify('Failed to delete driver.', 'error'); }
    setDeleteTarget(null);
  };

  // ── Handlers: details modal ──
const handleViewDetails = async (driver) => {
  try {
    const r = await axios.get(`${apiUrl}/drivers/${driver._id}`, config);
    setSelectedDriver(r.data);
    fetchModalDocuments(driver._id);
  } catch { notify('Failed to load driver details.', 'error'); }
};

  // ── Filtered lists ──
  const filtered = drivers.filter(d =>
    d.clientId === clientId &&
    `${d.firstName} ${d.lastName}`.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const applyFilter = (list) => statusFilter === 'all' ? list : list.filter(d => d.status === statusFilter);
  const employeeList  = applyFilter(filtered.filter(d => d.driverType === 'employee'));
  const operatorList  = applyFilter(filtered.filter(d => d.driverType === 'owner_operator'));

  // ── Expiry label helper ──
  const expiryLabel = (label, dateStr, required = false) => {
    const exp = isExpired(dateStr);
    return (
      <label className={exp ? styles.expiredLabelultimatedrivers : undefined}>
        {label}{required ? '*' : ''} {exp && '⚠ Expired'}
      </label>
    );
  };

  const expiryInput = (name, value, required = false) => (
    <input
      name={name} type="date" value={value} onChange={handleChange}
      required={required}
      className={`${styles.inputFieldultimatedrivers} ${isExpired(value) ? styles.inputExpiredultimatedrivers : ''}`}
    />
  );

  // ════════════════════════════════════════════════════════════════════════════
  // RENDER
  // ════════════════════════════════════════════════════════════════════════════
  return (
    <div className={`${styles.ultimatedriversSection} ${theme === 'light' ? styles.ultimatedriversSectionLight : ''}`}>

      {/* ══════════════════════════════════════
          HEADER + TABS
      ══════════════════════════════════════ */}
      <h3 className={styles.titleultimatedrivers}>
        {editingIndex !== null ? 'Edit Driver' : 'Add New Driver'}
      </h3>

      <div className={styles.tabBarultimatedrivers}>
        <button
          type="button"
          onClick={() => setActiveTab('info')}
          className={activeTab === 'info' ? styles.tabActiveultimatedrivers : styles.tabultimatedrivers}
        >
          Driver Info
        </button>
        <button
          type="button"
          onClick={() => {
            setActiveTab('documents');
            if (editingIndex !== null) fetchDriverDocuments(drivers[editingIndex]._id);
          }}
          className={activeTab === 'documents' ? styles.tabActiveultimatedrivers : styles.tabultimatedrivers}
        >
          Documents
        
        </button>
      </div>


      {/* ══════════════════════════════════════
          TAB: DRIVER INFO
      ══════════════════════════════════════ */}
      {activeTab === 'info' && (
        <form className={styles.driverFormultimatedrivers}>

          {/* Basic Info */}
          <h4 className={styles.sectionTitleultimatedrivers}>Basic Information</h4>
          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>First Name*</label>
              <input name="firstName" value={driverData.firstName} onChange={handleChange}
                placeholder="First Name" required className={styles.inputFieldultimatedrivers} />
            </div>
            <div className={styles.formGroupultimatedrivers}>
              <label>Last Name*</label>
              <input name="lastName" value={driverData.lastName} onChange={handleChange}
                placeholder="Last Name" required className={styles.inputFieldultimatedrivers} />
            </div>
          </div>

          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>Date of Birth</label>
              <input name="dateOfBirth" type="date" value={driverData.dateOfBirth}
                onChange={handleChange} className={styles.inputFieldultimatedrivers} />
            </div>
            <div className={styles.formGroupultimatedrivers}>
              <label>Hire Date</label>
              <input name="hireDate" type="date" value={driverData.hireDate}
                onChange={handleChange} className={styles.inputFieldultimatedrivers} />
            </div>
          </div>

          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>Driver Type*</label>
              <select name="driverType" value={driverData.driverType} onChange={handleChange}
                required className={styles.selectFieldultimatedrivers}>
                <option value="employee">Employee Driver</option>
                <option value="owner_operator">Owner Operator</option>
              </select>
            </div>
            <div className={styles.formGroupultimatedrivers}>
              <label>Driver Number*</label>
              <input name="driverNumber" value={driverData.driverNumber} onChange={handleChange}
                placeholder="DR-001" required className={styles.inputFieldultimatedrivers} />
            </div>
          </div>

          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>Truck Number*</label>
              <select name="truckNumber" value={driverData.truckNumber} onChange={handleChange}
                required className={styles.selectFieldultimatedrivers}>
                <option value="">Select Truck</option>
                {trucks.map(t => (
                  <option key={t._id} value={t.truckNumber}>{t.truckNumber}</option>
                ))}
              </select>
            </div>
            <div className={styles.formGroupultimatedrivers}>
              <label>Email*</label>
              <input name="email" value={driverData.email} onChange={handleChange}
                placeholder="Email" required className={styles.inputFieldultimatedrivers} />
            </div>
          </div>

          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>Mobile Phone*</label>
              <input name="mobilePhone" value={driverData.mobilePhone} onChange={handleChange}
                placeholder="Mobile Phone" required className={styles.inputFieldultimatedrivers} />
            </div>
            <div className={styles.formGroupultimatedrivers}>
              <label>Phone</label>
              <input name="phone" value={driverData.phone} onChange={handleChange}
                placeholder="Phone" className={styles.inputFieldultimatedrivers} />
            </div>
          </div>

          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>Address*</label>
              <input name="address" value={driverData.address} onChange={handleChange}
                placeholder="Address" required className={styles.inputFieldultimatedrivers} />
            </div>
          </div>

          {/* Driver Status */}
          <h4 className={styles.sectionTitleultimatedrivers}>Driver Status</h4>
          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>Status</label>
              <select name="status" value={driverData.status} onChange={handleChange}
                className={styles.selectFieldultimatedrivers}>
                <option value="active">Active</option>
                <option value="on_leave">On Leave</option>
                <option value="suspended">Suspended</option>
                <option value="inactive">Inactive</option>
                <option value="terminated">Terminated</option>
              </select>
            </div>
            <div className={styles.formGroupultimatedrivers}>
              <label>Status Note</label>
              <input name="statusNote" value={driverData.statusNote} onChange={handleChange}
                placeholder="Reason / note (optional)" className={styles.inputFieldultimatedrivers} />
            </div>
          </div>

          {/* Emergency Contact */}
          <h4 className={styles.sectionTitleultimatedrivers}>Emergency Contact</h4>
          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>First Name</label>
              <input name="emergencyContactFirstName" value={driverData.emergencyContactFirstName}
                onChange={handleChange} placeholder="First Name" className={styles.inputFieldultimatedrivers} />
            </div>
            <div className={styles.formGroupultimatedrivers}>
              <label>Last Name</label>
              <input name="emergencyContactLastName" value={driverData.emergencyContactLastName}
                onChange={handleChange} placeholder="Last Name" className={styles.inputFieldultimatedrivers} />
            </div>
          </div>
          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>Relation</label>
              <input name="emergencyContactRelation" value={driverData.emergencyContactRelation}
                onChange={handleChange} placeholder="Relation" className={styles.inputFieldultimatedrivers} />
            </div>
            <div className={styles.formGroupultimatedrivers}>
              <label>Phone</label>
              <input name="emergencyContactPhone" value={driverData.emergencyContactPhone}
                onChange={handleChange} placeholder="Phone" className={styles.inputFieldultimatedrivers} />
            </div>
          </div>

          {/* Pay Settings */}
          <h4 className={styles.sectionTitleultimatedrivers}>Pay Settings</h4>
          <div className={styles.formGroupultimatedrivers}>
            <label>Settlement*</label>
            <select name="settlement" value={driverData.settlement} onChange={handleSettlementChange}
              required className={styles.selectFieldultimatedrivers}>
              <option value="">Select Payment Method</option>
              <option value="Hourly pay">Hourly pay</option>
              <option value="Per mile pay">Per mile pay</option>
              <option value="Fixed salary">Fixed salary</option>
              <option value="Percentage of the load">Percentage of the load</option>
              <option value="Team driver pay">Team driver pay</option>
            </select>
          </div>

          {driverData.settlement === 'Per mile pay' && (
            <div className={styles.formRowultimatedrivers}>
              <div className={styles.formGroupultimatedrivers}>
                <label>Normal Mile Rate ($)*</label>
                <input name="normalMileRate" type="number" step="0.01"
                  value={driverData.normalMileRate || ''} onChange={handleChange}
                  placeholder="Amount per normal mile" required className={styles.inputFieldultimatedrivers} />
              </div>
              <div className={styles.formGroupultimatedrivers}>
                <label>DH Mile Rate ($)*</label>
                <input name="dhMileRate" type="number" step="0.01"
                  value={driverData.dhMileRate || ''} onChange={handleChange}
                  placeholder="Amount per DH mile" required className={styles.inputFieldultimatedrivers} />
              </div>
            </div>
          )}

          {driverData.settlement === 'Hourly pay' && (
            <div className={styles.formRowultimatedrivers}>
              <div className={styles.formGroupultimatedrivers}>
                <label>Hourly Rate ($)*</label>
                <input name="hourlyRate" type="number" step="0.01"
                  value={driverData.hourlyRate || ''} onChange={handleChange}
                  placeholder="Hourly rate" required className={styles.inputFieldultimatedrivers} />
              </div>
              <div className={styles.formGroupultimatedrivers}>
                <label>Hours Worked*</label>
                <input name="hoursWorked" type="number" step="0.1"
                  value={driverData.hoursWorked || ''} onChange={handleChange}
                  placeholder="Hours worked" required className={styles.inputFieldultimatedrivers} />
              </div>
            </div>
          )}

          {driverData.settlement === 'Team driver pay' && (
            <div className={styles.formRowultimatedrivers}>
              <div className={styles.formGroupultimatedrivers}>
                <label>Co-Driver</label>
                <select name="teamDriver" value={driverData.teamDriver || ''}
                  onChange={handleChange} required className={styles.selectFieldultimatedrivers}>
                  <option value="">Select Co-Driver</option>
                  {drivers.map(d => (
                    <option key={d._id} value={d._id}>{d.firstName} {d.lastName}</option>
                  ))}
                </select>
              </div>
              <div className={styles.formGroupultimatedrivers}>
                <label>Team Pay Percentage (%)</label>
                <input name="teamPercentage" type="number" step="1"
                  value={driverData.teamPercentage || ''} onChange={handleChange}
                  placeholder="e.g. 50" required className={styles.inputFieldultimatedrivers} />
              </div>
              <div className={styles.formGroupultimatedrivers}>
                <label>Main Driver Pay Amount ($)*</label>
                <input name="settlementAmount" type="number" step="0.01"
                  value={driverData.settlementAmount || ''} onChange={handleChange}
                  placeholder="Pay amount" required className={styles.inputFieldultimatedrivers} />
              </div>
            </div>
          )}

          {driverData.settlement === 'Percentage of the load' && (
            <div className={styles.formRowultimatedrivers}>
              <div className={styles.formGroupultimatedrivers}>
                <label>Load Revenue Percentage (%)</label>
                <input name="settlementAmount" type="number" step="1"
                  value={driverData.settlementAmount || ''} onChange={handleChange}
                  placeholder="e.g. 20" required className={styles.inputFieldultimatedrivers} />
              </div>
            </div>
          )}

          {driverData.settlement === 'Fixed salary' && (
            <div className={styles.formRowultimatedrivers}>
              <div className={styles.formGroupultimatedrivers}>
                <label>Fixed Salary Amount ($)</label>
                <input name="settlementAmount" type="number" step="0.01"
                  value={driverData.settlementAmount || ''} onChange={handleChange}
                  placeholder="Fixed salary" required className={styles.inputFieldultimatedrivers} />
              </div>
            </div>
          )}

          {/* Licensing Info */}
          <h4 className={styles.sectionTitleultimatedrivers}>Licensing Info</h4>
          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>License Type</label>
              <select name="licenseType" value={driverData.licenseType} onChange={handleChange}
                className={styles.selectFieldultimatedrivers}>
                <option value="">Select License Type</option>
                <option value="CDL-A">CDL-A</option>
                <option value="CDL-B">CDL-B</option>
                <option value="NonCommercial">NonCommercial</option>
              </select>
            </div>
            <div className={styles.formGroupultimatedrivers}>
              <label>License State</label>
              <input name="licenseState" value={driverData.licenseState} onChange={handleChange}
                placeholder="State" className={styles.inputFieldultimatedrivers} />
            </div>
          </div>

          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>License Number*</label>
              <input name="licenseNumber" value={driverData.licenseNumber} onChange={handleChange}
                placeholder="License Number" required className={styles.inputFieldultimatedrivers} />
            </div>
            <div className={styles.formGroupultimatedrivers}>
              {expiryLabel('License Expires', driverData.licenseExpiryDate, true)}
              {expiryInput('licenseExpiryDate', driverData.licenseExpiryDate, true)}
            </div>
          </div>

          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              {expiryLabel('Passport Expires', driverData.passportExpiryDate)}
              {expiryInput('passportExpiryDate', driverData.passportExpiryDate)}
            </div>
          </div>

          {/* Medical Info */}
          <h4 className={styles.sectionTitleultimatedrivers}>Medical Info</h4>
          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>Last Medical</label>
              <input name="lastMedical" type="date" value={driverData.lastMedical}
                onChange={handleChange} className={styles.inputFieldultimatedrivers} />
            </div>
            <div className={styles.formGroupultimatedrivers}>
              {expiryLabel('Next Medical', driverData.nextMedical)}
              {expiryInput('nextMedical', driverData.nextMedical)}
            </div>
          </div>
          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>Last Drug Test</label>
              <input name="lastDrugTest" type="date" value={driverData.lastDrugTest}
                onChange={handleChange} className={styles.inputFieldultimatedrivers} />
            </div>
            <div className={styles.formGroupultimatedrivers}>
              <label>Last Alcohol Test</label>
              <input name="lastAlcoholTest" type="date" value={driverData.lastAlcoholTest}
                onChange={handleChange} className={styles.inputFieldultimatedrivers} />
            </div>
          </div>

          {/* Corporate Info */}
          <h4 className={styles.sectionTitleultimatedrivers}>Corporate Info</h4>
          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>Fuel Card Number</label>
              <input name="fuelCardNumber" value={driverData.fuelCardNumber} onChange={handleChange}
                placeholder="Fuel Card Number" className={styles.inputFieldultimatedrivers} />
            </div>
            <div className={styles.formGroupultimatedrivers}>
              {expiryLabel('Fuel Card Expires', driverData.fuelCardExpiryDate)}
              {expiryInput('fuelCardExpiryDate', driverData.fuelCardExpiryDate)}
            </div>
          </div>
          <div className={styles.formRowultimatedrivers}>
            <div className={styles.formGroupultimatedrivers}>
              <label>Fleet / Division</label>
              <input name="fleetDivision" value={driverData.fleetDivision} onChange={handleChange}
                placeholder="Fleet / Division" className={styles.inputFieldultimatedrivers} />
            </div>
          </div>

          {/* Employee Records Checklist */}
          <h4 className={styles.sectionTitleultimatedrivers}>Employee Records Checklist</h4>
          <div className={styles.checklistGridultimatedrivers}>
            {CHECKLIST_ITEMS.map(([key, label]) => (
              <label key={key} className={styles.checklistItemultimatedrivers}>
                <input
                  type="checkbox"
                  checked={driverData.employeeRecordsChecklist[key] || false}
                  onChange={e => handleCheckboxChange(e, `employeeRecordsChecklist.${key}`)}
                  className={styles.checkboxultimatedrivers}
                />
                {label}
              </label>
            ))}
          </div>

          {/* Internal Notes */}
          <h4 className={styles.sectionTitleultimatedrivers}>Internal Notes</h4>
          <div className={styles.formGroupultimatedrivers}>
            <textarea name="internalNotes" value={driverData.internalNotes} onChange={handleChange}
              placeholder="Internal notes..." rows={4}
              className={styles.textareaFieldultimatedrivers} />
          </div>

          {/* ── În tab-ul INFO — la final, înainte de </form> ── */}
<button type="button" onClick={handleSubmit} className={styles.submitButtonultimatedrivers}>
  {editingIndex !== null ? 'Update Driver' : 'Add Driver'}
  {editingIndex === null && pendingDocuments.length > 0 && (
    <span className={styles.tabBadgeultimatedrivers}>
      +{pendingDocuments.length} docs
    </span>
  )}
</button>
        </form>
      )}

      {/* ══════════════════════════════════════
          TAB: DOCUMENTS
      ══════════════════════════════════════ */}


      {activeTab === 'documents' && (
        <div className={styles.driverFormultimatedrivers}>

          <div
            className={`${styles.docDropZoneultimatedrivers} ${dragOver ? styles.docDropZoneActiveultimatedrivers : ''} ${docUploadFile ? styles.docDropZoneFilledultimatedrivers : ''}`}
            onDragOver={e => { e.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onDrop={handleFileDrop}
            onClick={() => fileInputRef.current?.click()}
          >
            <input
              ref={fileInputRef} type="file" style={{ display: 'none' }}
              accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx,.xls,.xlsx"
              onChange={handleFileSelect}
            />
            {docUploadFile ? (
              <div className={styles.docDropZoneFileultimatedrivers}>
                <span className={styles.docFileIconultimatedrivers}>
                  {FILE_ICONS[docUploadFile.type] || 'FILE'}
                </span>
                <div>
                  <div className={styles.docFileNameultimatedrivers}>{docUploadFile.name}</div>
                  <div className={styles.docFileSizeultimatedrivers}>{formatBytes(docUploadFile.size)}</div>
                </div>
                <button
                  type="button"
                  className={styles.docDropZoneRemoveultimatedrivers}
                  onClick={e => {
                    e.stopPropagation();
                    setDocUploadFile(null);
                    setDocUploadTitle('');
                    if (fileInputRef.current) fileInputRef.current.value = '';
                  }}
                >
                  ×
                </button>
              </div>
            ) : (
              <div className={styles.docDropZonePromptultimatedrivers}>
                <span className={styles.docDropZoneIconultimatedrivers}>UPLOAD</span>
                <p className={styles.docDropZoneTextultimatedrivers}>Drag and drop a file here, or click to browse</p>
                <p className={styles.docDropZoneSubultimatedrivers}>PDF, JPG, PNG, DOC, DOCX, XLS, XLSX — max 50MB</p>
              </div>
            )}
          </div>

          <div className={styles.formGroupultimatedrivers}>
            <label>Document Type</label>
            <div className={styles.docTypeGridultimatedrivers}>
              {DOC_TYPES.map(d => (
                <button
                  key={d.key} type="button"
                  onClick={() => setDocUploadType(d.key)}
                  className={`${styles.docTypeChipultimatedrivers} ${docUploadType === d.key ? styles.docTypeChipActiveultimatedrivers : ''}`}
                >
                  {d.label}
                </button>
              ))}
            </div>
          </div>

          <div className={styles.formGroupultimatedrivers}>
            <label>Document Title</label>
            <input
              value={docUploadTitle}
              onChange={e => setDocUploadTitle(e.target.value)}
              placeholder="Document title (optional)..."
              className={styles.inputFieldultimatedrivers}
            />
          </div>

          <button type="button" onClick={handleSubmit} className={styles.submitButtonultimatedrivers}>
            {editingIndex !== null
              ? docUploadFile ? `Update Driver & Upload "${docUploadFile.name}"` : 'Update Driver'
              : docUploadFile ? `Add Driver & Upload "${docUploadFile.name}"` : 'Add Driver'}
          </button>

          {editingIndex !== null && (
            <>
              <h4 className={styles.sectionTitleultimatedrivers}>Uploaded Documents</h4>
              {docLoading ? (
                <p className={styles.emptyStateultimatedrivers}>Loading...</p>
              ) : driverDocuments.length === 0 ? (
                <p className={styles.emptyStateultimatedrivers}>No documents uploaded yet.</p>
              ) : (
                <ul className={styles.driverListultimatedrivers}>
                  {driverDocuments.map(doc => (
                    <li key={doc.id} className={styles.driverListItemultimatedrivers}>
                      <span className={styles.docFileIconultimatedrivers}>
                        {FILE_ICONS[doc.mimeType] || 'FILE'}
                      </span>
                      <span className={styles.docItemInfoultimatedrivers}>
                        <strong>{doc.title || doc.fileName}</strong>
                        <span className={styles.docItemMetaultimatedrivers}>
                          {doc.docType.replace(/_/g, ' ')} · {formatBytes(doc.fileSize)} · {formatDateDisplay(doc.createdAt)}
                        </span>
                      </span>
                      <button type="button" onClick={() => handlePreviewDoc(doc)} className={styles.editButtonultimatedrivers}>
                        View
                      </button>
                      <a href={`${apiUrl}/documents/${doc.id}/download`} target="_blank" rel="noreferrer" className={styles.editButtonultimatedrivers}>
                        Download
                      </a>
                      <button type="button" onClick={() => handleDeleteDocument(doc.id)} className={styles.deleteButtonultimatedrivers}>
                        Delete
                     </button>
                    </li>
                  ))}
                </ul>
              )}
            </>
          )}


        </div>
      )}

      {/* ══════════════════════════════════════
          DRIVER LIST
      ══════════════════════════════════════ */}
      <h3 className={styles.titleultimatedrivers}>Driver List</h3>

      <input type="text" placeholder="Search by driver name..."
        value={searchQuery} onChange={e => setSearchQuery(e.target.value)}
        className={styles.searchInputultimatedrivers} />

      {/* Status filter */}
      <div className={styles.statusFilterBarultimatedrivers}>
        {['all', 'active', 'on_leave', 'suspended', 'inactive', 'terminated'].map(s => (
          <button key={s} type="button"
            onClick={() => setStatusFilter(s)}
            className={statusFilter === s ? styles.statusFilterActiveultimatedrivers : styles.statusFilterBtnultimatedrivers}>
            {s === 'all' ? 'All' : s.replace('_', ' ').replace(/^\w/, c => c.toUpperCase())}
          </button>
        ))}
      </div>

      {deleteTarget !== null && (
        <DeleteNotifications
          message="Are you sure you want to delete this driver?"
          onConfirm={() => confirmDeleteDriver(deleteTarget)}
          onCancel={() => setDeleteTarget(null)}
        />
      )}

      {/* Employee Drivers */}
      <h4 className={styles.titleultimatedrivers}>Employee Drivers</h4>
      <ul className={styles.driverListultimatedrivers}>
        {employeeList.length === 0 && (
          <li className={styles.emptyStateultimatedrivers}>No employee drivers found.</li>
        )}
        {employeeList.map(driver => {
          const realIndex = drivers.findIndex(d => d._id === driver._id);
          return (
            <li key={driver._id} className={styles.driverListItemultimatedrivers}>
              <span className={styles.driverInfoColultimatedrivers}>
                <strong>{driver.firstName} {driver.lastName}</strong>
                <span className={styles.driverTag}>EMPLOYEE</span>
                <StatusBadge status={driver.status} />
                {driver.truckNumber && (
                  <span className={styles.driverTruckultimatedrivers}>· Truck {driver.truckNumber}</span>
                )}
              </span>
              <select value={driver.status || 'active'}
                onChange={e => handleStatusChange(driver._id, e.target.value)}
                className={styles.statusSelectultimatedrivers}>
                <option value="active">Active</option>
                <option value="on_leave">On Leave</option>
                <option value="suspended">Suspended</option>
                <option value="inactive">Inactive</option>
                <option value="terminated">Terminated</option>
              </select>
              <button onClick={() => handleViewDetails(driver)} className={styles.editButtonultimatedrivers}>
                See Details
              </button>
              <button onClick={() => handleEdit(realIndex)} className={styles.editButtonultimatedrivers}>
                Edit
              </button>
              <button onClick={() => setDeleteTarget(realIndex)} className={styles.deleteButtonultimatedrivers}>
                Delete
              </button>
            </li>
          );
        })}
      </ul>

      {/* Owner Operators */}
      <h4 className={styles.titleultimatedrivers}>Owner Operators</h4>
      <ul className={styles.driverListultimatedrivers}>
        {operatorList.length === 0 && (
          <li className={styles.emptyStateultimatedrivers}>No owner operators found.</li>
        )}
        {operatorList.map(driver => {
          const realIndex = drivers.findIndex(d => d._id === driver._id);
          return (
            <li key={driver._id} className={styles.driverListItemultimatedrivers}>
              <span className={styles.driverInfoColultimatedrivers}>
                <strong>{driver.firstName} {driver.lastName}</strong>
                <span className={styles.ownerTag}>OWNER OPERATOR</span>
                <StatusBadge status={driver.status} />
                {driver.truckNumber && (
                  <span className={styles.driverTruckultimatedrivers}>· Truck {driver.truckNumber}</span>
                )}
              </span>
              <select value={driver.status || 'active'}
                onChange={e => handleStatusChange(driver._id, e.target.value)}
                className={styles.statusSelectultimatedrivers}>
                <option value="active">Active</option>
                <option value="on_leave">On Leave</option>
                <option value="suspended">Suspended</option>
                <option value="inactive">Inactive</option>
                <option value="terminated">Terminated</option>
              </select>
              <button onClick={() => handleViewDetails(driver)} className={styles.editButtonultimatedrivers}>
                See Details
              </button>
              <button onClick={() => handleEdit(realIndex)} className={styles.editButtonultimatedrivers}>
                Edit
              </button>
              <button onClick={() => setDeleteTarget(realIndex)} className={styles.deleteButtonultimatedrivers}>
                Delete
              </button>
            </li>
          );
        })}
      </ul>

      {/* ══════════════════════════════════════
          MODAL: DRIVER DETAILS
      ══════════════════════════════════════ */}
      {selectedDriver && createPortal(
        <div className={styles.modalOverlayultimatedrivers}
        data-theme={theme}   
          onClick={e => { if (e.target === e.currentTarget) { setSelectedDriver(null); setModalDocs([]); } }}>
          <div className={styles.modalultimatedrivers}>

            {/* Modal header */}
            <div className={styles.modalHeaderultimatedrivers}>
              <div>
                <h2 className={styles.modalTitleultimatedrivers}>
                  {selectedDriver.firstName} {selectedDriver.lastName}
                </h2>
                <div className={styles.modalBadgesultimatedrivers}>
                  <span className={selectedDriver.driverType === 'owner_operator' ? styles.ownerTag : styles.driverTag}>
                    {selectedDriver.driverType === 'owner_operator' ? 'OWNER OPERATOR' : 'EMPLOYEE'}
                  </span>
                  <StatusBadge status={selectedDriver.status} />
                  {selectedDriver.driverNumber && (
                    <span className={styles.modalDriverNumultimatedrivers}>#{selectedDriver.driverNumber}</span>
                  )}
                </div>
                {selectedDriver.statusNote && (
                  <p className={styles.modalStatusNoteultimatedrivers}>Note: {selectedDriver.statusNote}</p>
                )}
              </div>
              <button
                onClick={() => { setSelectedDriver(null); setModalDocs([]); }}
                className={styles.closeButtonultimatedrivers}
              >
                ✕
              </button>
            </div>

            {/* Modal body — two columns */}
            <div className={styles.modalBodyultimatedrivers}>

              {/* LEFT: Driver data */}
              <div className={styles.modalColLeftultimatedrivers}>

                {/* Helper components inside scope */}
                {(() => {
                  const Row = ({ label, value, expired }) => (
                    <div className={styles.detailRowultimatedrivers}>
                      <span className={styles.detailLabelultimatedrivers}>{label}</span>
                      <span className={expired ? styles.detailValueExpiredultimatedrivers : styles.detailValueultimatedrivers}>
                        {expired && '⚠ '}{value || '—'}
                      </span>
                    </div>
                  );
                  const Sec = ({ title }) => (
                    <p className={styles.detailSectionTitleultimatedrivers}>{title}</p>
                  );
                  const fdt = (d) => d ? new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : null;

                  return (
                    <>
                      <Sec title="Personal" />
                      <Row label="Email"          value={selectedDriver.email} />
                      <Row label="Mobile Phone"   value={selectedDriver.mobilePhone} />
                      <Row label="Phone"          value={selectedDriver.phone} />
                      <Row label="Address"        value={selectedDriver.address} />
                      <Row label="Date of Birth"  value={fdt(selectedDriver.dateOfBirth)} />
                      <Row label="Hire Date"      value={fdt(selectedDriver.hireDate)} />
                      {selectedDriver.terminationDate &&
                        <Row label="Termination Date" value={fdt(selectedDriver.terminationDate)} />}
                      <Row label="Truck Number"   value={selectedDriver.truckNumber} />

                      <Sec title="Licensing" />
                      <Row label="License Number" value={selectedDriver.licenseNumber} />
                      <Row label="License Type"   value={selectedDriver.licenseType} />
                      <Row label="License State"  value={selectedDriver.licenseState} />
                      <Row label="License Expires"
                        value={fdt(selectedDriver.licenseExpiryDate)}
                        expired={isExpired(selectedDriver.licenseExpiryDate)} />
                      <Row label="Passport Expires"
                        value={fdt(selectedDriver.passportExpires)}
                        expired={isExpired(selectedDriver.passportExpires)} />

                      <Sec title="Medical" />
                      <Row label="Last Medical"     value={fdt(selectedDriver.medicalInfo?.lastMedical)} />
                      <Row label="Next Medical"
                        value={fdt(selectedDriver.medicalInfo?.nextMedical)}
                        expired={isExpired(selectedDriver.medicalInfo?.nextMedical)} />
                      <Row label="Last Drug Test"   value={fdt(selectedDriver.lastDrugTestDate)} />
                      <Row label="Last Alcohol Test" value={fdt(selectedDriver.medicalInfo?.lastAlcoholTest)} />

                      <Sec title="Corporate" />
                      <Row label="Fuel Card #"      value={selectedDriver.corporateInfo?.fuelCardNumber} />
                      <Row label="Fuel Card Expires"
                        value={fdt(selectedDriver.corporateInfo?.fuelCardExpires)}
                        expired={isExpired(selectedDriver.corporateInfo?.fuelCardExpires)} />
                      <Row label="Fleet / Division" value={selectedDriver.corporateInfo?.fleetDivision} />

                      <Sec title="Pay Settings" />
                      <Row label="Settlement" value={selectedDriver.settlement} />
                      {selectedDriver.settlement === 'Per mile pay' && <>
                        <Row label="Normal Mile Rate" value={selectedDriver.normalMileRate ? `$${selectedDriver.normalMileRate}` : null} />
                        <Row label="DH Mile Rate"     value={selectedDriver.dhMileRate ? `$${selectedDriver.dhMileRate}` : null} />
                      </>}
                      {selectedDriver.settlement === 'Hourly pay' && <>
                        <Row label="Hourly Rate"  value={selectedDriver.hourlyRate ? `$${selectedDriver.hourlyRate}` : null} />
                        <Row label="Hours Worked" value={selectedDriver.hoursWorked} />
                      </>}
                      {(selectedDriver.settlement === 'Fixed salary' || selectedDriver.settlement === 'Percentage of the load') &&
                        <Row label="Amount / %" value={selectedDriver.settlementAmount} />}
                      {selectedDriver.settlement === 'Team driver pay' &&
                        <Row label="Team %" value={selectedDriver.teamPercentage} />}

                      <Sec title="Emergency Contact" />
                      <Row label="Name"
                        value={`${selectedDriver.emergencyContact?.firstName || ''} ${selectedDriver.emergencyContact?.lastName || ''}`.trim() || null} />
                      <Row label="Relation" value={selectedDriver.emergencyContact?.relation} />
                      <Row label="Phone"    value={selectedDriver.emergencyContact?.phone} />

                      <Sec title="Employee Records Checklist" />
                      {CHECKLIST_ITEMS.map(([key, lbl]) => (
                        <div key={key} className={styles.detailRowultimatedrivers}>
                          <span className={styles.detailLabelultimatedrivers}>{lbl}</span>
                          <span className={selectedDriver.checklist?.[key] ? styles.checkYesultimatedrivers : styles.checkNoultimatedrivers}>
                            {selectedDriver.checklist?.[key] ? '✓ Yes' : '✗ No'}
                          </span>
                        </div>
                      ))}

                      {selectedDriver.internalNotes && <>
                        <Sec title="Internal Notes" />
                        <p className={styles.detailNotesultimatedrivers}>{selectedDriver.internalNotes}</p>
                      </>}

                      <Row label="Created At" value={fdt(selectedDriver.createdAt)} />
                    </>
                  );
                })()}
              </div>

              {/* RIGHT: Documents */}
              <div className={styles.modalColRightultimatedrivers}>
                <h4 className={styles.sectionTitleultimatedrivers}>Documents</h4>
                {modalDocsLoading ? (
                  <p className={styles.emptyStateultimatedrivers}>Loading documents...</p>
                ) : modalDocs.length === 0 ? (
                  <p className={styles.emptyStateultimatedrivers}>No documents uploaded.</p>
                ) : (
                  <div className={styles.modalDocListultimatedrivers}>
                    {modalDocs.map(doc => (
                      <div key={doc.id} className={styles.modalDocCardultimatedrivers}>
                        <div className={styles.modalDocCardTopultimatedrivers}>
                          <span className={styles.docFileIconultimatedrivers}>
                            {FILE_ICONS[doc.mimeType] || 'FILE'}
                          </span>
                          <div className={styles.docItemInfoultimatedrivers}>
                            <strong className={styles.modalDocTitleultimatedrivers}>{doc.title || doc.fileName}</strong>
                            <span className={styles.docItemMetaultimatedrivers}>
                              {doc.docType.replace(/_/g, ' ')} · {formatBytes(doc.fileSize)} · {formatDateDisplay(doc.createdAt)}
                            </span>
                          </div>
                        </div>
                        <div className={styles.modalDocActionsultimatedrivers}>
                          <button type="button" onClick={() => handlePreviewDoc(doc)}
                            className={styles.editButtonultimatedrivers}>
                            View
                          </button>
                          <a href={`${apiUrl}/documents/${doc.id}/download`} target="_blank" rel="noreferrer"
                            className={styles.editButtonultimatedrivers}>
                            Download
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* ══════════════════════════════════════
          MODAL: PREVIEW
      ══════════════════════════════════════ */}
      {showPreview && createPortal(
        <div className={styles.modalOverlayultimatedrivers}
        data-theme={theme}
          onClick={e => {
            if (e.target === e.currentTarget) {
              URL.revokeObjectURL(previewUrl);
              setShowPreview(false); setPreviewUrl('');
            }
          }}>
          <div className={styles.previewModalultimatedrivers}>
            <div className={styles.modalHeaderultimatedrivers}>
              <h2 className={styles.modalTitleultimatedrivers}>Document Preview</h2>
              <button type="button" className={styles.closeButtonultimatedrivers}
                onClick={() => { URL.revokeObjectURL(previewUrl); setShowPreview(false); setPreviewUrl(''); }}>
                ✕
              </button>
            </div>
            {previewMime === 'application/pdf' || previewMime?.startsWith('image/') ? (
              <iframe src={previewUrl} className={styles.previewFrameultimatedrivers} title="Preview" />
            ) : (
              <div className={styles.previewUnsupportedultimatedrivers}>
                <p>Preview not available for this file type.</p>
                <p className={styles.docItemMetaultimatedrivers}>Download the file to view it.</p>
              </div>
            )}
          </div>
        </div>,
        document.body
      )}
<EmailPanel />
    </div>
  );
};





const Trucks = ({ trucks, setTrucks, drivers = [], trailers = [] }) => {
  const formatDate = (date) => date ? new Date(date).toISOString().split('T')[0] : '';
  const { notify } = useNotification();
  const [limits, setLimits] = useState({ numberOfTrucks: 0 });
 const [companyName, setCompanyName] = useState('');


  const [truckData, setTruckData] = useState({
    truckNumber: '',
    licensePlate: '',
    VIN: '',
    truckType: '',
    fuelType: '',
    miles: '',
    inspectionDate: '',
    maintenanceDate: '',
    insurancePolicyNumber: '',
    insuranceExpiryDate: '',
    fleetDivision: '',
    driver: '',
    owner: '',
    trailer: '',
    settlement: '',
    settlementAmount: '',
    normalMileRate: '',
    dhMileRate: '',
    hourlyRate: '',
    hoursWorked: '',
    teamDriver: '',
    teamPercentage: '',
    notes: '',
  });
  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

const employeeDrivers = Array.isArray(drivers)
  ? drivers.filter(d => d.driverType === 'employee')
  : [];

const ownerOperators = Array.isArray(drivers)
  ? drivers.filter(d => d.driverType === 'owner_operator')
  : [];


useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
setCompanyName(res.data.companyName);

    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  const token = sessionStorage.getItem('token'); // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId'); // Obține clientId din localStorage
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`, // Adaugă tokenul cu prefixul Bearer
      'Content-Type': 'application/json',
    },
    withCredentials: true, // Trimite cookies pentru autentificare
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTruckData({ ...truckData, [name]: value });
  };

  const handleSettlementChange = (e) => {
    const selectedSettlement = e.target.value;
    const resetData = {
      normalMileRate: selectedSettlement === 'Per mile pay' ? truckData.normalMileRate : undefined,
      dhMileRate: selectedSettlement === 'Per mile pay' ? truckData.dhMileRate : undefined,
      hourlyRate: selectedSettlement === 'Hourly pay' ? truckData.hourlyRate : undefined,
      hoursWorked: selectedSettlement === 'Hourly pay' ? truckData.hoursWorked : undefined,
      teamDriver: selectedSettlement === 'Team driver pay' ? truckData.teamDriver : undefined,
      teamPercentage: selectedSettlement === 'Team driver pay' ? truckData.teamPercentage : undefined,
      settlementAmount: selectedSettlement !== 'Per mile pay' && selectedSettlement !== 'Hourly pay' ? truckData.settlementAmount : undefined,
    };

    setTruckData({
      ...truckData,
      settlement: selectedSettlement,
      ...resetData,
    });
  };

  const handleSubmit = async () => {
  if (editingIndex === null && trucks.length >= limits.numberOfTrucks) {
    notify('You cannot add more trucks than the allowed limit.', 'error');
    return;
  }

  const dataToSend = {
    truckNumber:           truckData.truckNumber,
    licensePlate:          truckData.licensePlate          || '',
    VIN:                   truckData.VIN                   || '',
    owner:                 truckData.owner                 || '',
    truckType:             truckData.truckType             || '',
    fuelType:              truckData.fuelType              || '',
    miles:                 Number(truckData.miles)         || 0,
    inspectionDate:        truckData.inspectionDate        || null,
    maintenanceDate:       truckData.maintenanceDate       || null,
    insurancePolicyNumber: truckData.insurancePolicyNumber || '',
    insuranceExpiryDate:   truckData.insuranceExpiryDate   || null,
    fleetDivision:         truckData.fleetDivision         || '',
    driver:                truckData.driver                || null,
    trailer:               truckData.trailer               || null,
    notes:                 truckData.notes                 || '',
    settlement:            truckData.settlement            || '',
    settlementAmount:      Number(truckData.settlementAmount)  || 0,
    normalMileRate:        Number(truckData.normalMileRate)    || 0,
    dhMileRate:            Number(truckData.dhMileRate)        || 0,
    hourlyRate:            Number(truckData.hourlyRate)        || 0,
    hoursWorked:           Number(truckData.hoursWorked)       || 0,
    teamDriver:            truckData.teamDriver                || '',
    teamPercentage:        Number(truckData.teamPercentage)    || 0,
    recurringDeductions:   truckData.recurringDeductions       || [],
    recurringAdditions:    truckData.recurringAdditions        || [],
    clientId,
  };

  if (editingIndex !== null) {
    try {
      const response = await axios.put(
        `${apiUrl}/trucks/${trucks[editingIndex]._id}`,
        dataToSend,
        config
      );
      const updatedTrucks = [...trucks];
      updatedTrucks[editingIndex] = response.data.truck;
      setTrucks(updatedTrucks);
      setEditingIndex(null);
      notify('Truck updated!', 'success');
    } catch (error) {
      notify(error.response?.data?.error || 'Failed to update truck.', 'error');
    }
  } else {
    try {
      const response = await axios.post(`${apiUrl}/trucks`, dataToSend, config);
      setTrucks([...trucks, response.data.truck]);
      notify('Truck added!', 'success');
    } catch (error) {
      notify(error.response?.data?.error || 'Failed to add truck.', 'error');
    }
  }

  setTruckData({
    truckNumber:           '',
    licensePlate:          '',
    VIN:                   '',
    owner:                 '',
    truckType:             '',
    fuelType:              '',
    miles:                 '',
    inspectionDate:        '',
    maintenanceDate:       '',
    insurancePolicyNumber: '',
    insuranceExpiryDate:   '',
    fleetDivision:         '',
    driver:                '',
    trailer:               '',
    notes:                 '',
    settlement:            '',
    settlementAmount:      '',
    normalMileRate:        '',
    dhMileRate:            '',
    hourlyRate:            '',
    hoursWorked:           '',
    teamDriver:            '',
    teamPercentage:        '',
    recurringDeductions:   [],
    recurringAdditions:    [],
  });
};

  useEffect(() => {
    const fetchTruckLimit = async () => {
      try {
        const response = await axios.get(`${apiUrl}/clients`, config);
        setLimits({
          numberOfTrucks: response.data.numberOfTrucks,
        });
      } catch (error) {
   
      }
    };
    
    fetchTruckLimit();
  }, []);

  const handleEdit = (index) => {
  const truckToEdit = trucks[index];
  setEditingIndex(index);
  setTruckData({
    truckNumber: truckToEdit.truckNumber || '',
    licensePlate: truckToEdit.licensePlate || '',
    VIN: truckToEdit.VIN || '',
    truckType: truckToEdit.truckType || '',
    fuelType: truckToEdit.fuelType || '',
    miles: truckToEdit.miles || '',
    inspectionDate: formatDate(truckToEdit.inspectionDate),
    maintenanceDate: formatDate(truckToEdit.maintenanceDate),
    insurancePolicyNumber: truckToEdit.insurancePolicyNumber || '',
    insuranceExpiryDate: formatDate(truckToEdit.insuranceExpiryDate),
    fleetDivision: truckToEdit.fleetDivision || '',
    driver: truckToEdit.driver || '',
    owner: truckToEdit.owner || '',
    trailer: truckToEdit.trailer || '',
    settlement: truckToEdit.settlement || '',
    settlementAmount: truckToEdit.settlementAmount || '',
    normalMileRate: truckToEdit.normalMileRate || '',
    dhMileRate: truckToEdit.dhMileRate || '',
    hourlyRate: truckToEdit.hourlyRate || '',
    hoursWorked: truckToEdit.hoursWorked || '',
    teamDriver: truckToEdit.teamDriver || '',
    teamPercentage: truckToEdit.teamPercentage || '',
    notes: truckToEdit.notes || '',
  });
  window.scrollTo({ top: 0, behavior: 'smooth' });
};


  const confirmDeleteTruck = async (index) => {
    try {
      const truckId = trucks[index]._id;
      await axios.delete(`${apiUrl}/trucks/${truckId}`, config);
      setTrucks((prevTrucks) => prevTrucks.filter((_, i) => i !== index));
    } catch (error) {

      notify('Failed to delete truck.', 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  

  const filteredTrucks = trucks.filter(truck =>
    truck.truckNumber && truck.truckNumber.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div
  className={`${styles.ultimatetrucksSection} ${
    theme === "light" ? styles.ultimatetrucksSectionLight : ""
  }`}
>

      <h3 className={styles.titleultimatetrucks}>Add or Edit Truck</h3>
      <form className={styles.truckFormultimatetrucks}>
        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Truck Number*</label>
            <input
              name="truckNumber"
              value={truckData.truckNumber}
              onChange={handleChange}
              placeholder="Truck Number"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>License Plate*</label>
            <input
              name="licensePlate"
              value={truckData.licensePlate}
              onChange={handleChange}
              placeholder="License Plate"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
        </div>

        <h4>Pay Settings</h4>
        <div className={styles.formGroupultimatetrucks}>
          <label>Settlement*</label>
          <select
            name="settlement"
            value={truckData.settlement}
            onChange={handleSettlementChange}
            required
            className={styles.selectFieldultimatetrucks}
          >
            <option value="">Select Payment Method</option>
            <option value="Hourly pay">Hourly pay</option>
            <option value="Per mile pay">Per mile pay</option>
            <option value="Fixed salary">Fixed salary</option>
            <option value="Percentage of the load">Percentage of the load</option>
            <option value="Team driver pay">Team driver pay</option>
          </select>
        </div>

        {truckData.settlement === 'Per mile pay' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Enter amount per normal mile ($)*</label>
              <input
                name="normalMileRate"
                type="number"
                step="0.01"
                value={truckData.normalMileRate || ''}
                onChange={handleChange}
                required
                className={styles.inputFieldultimatetrucks}
              />
            </div>
            <div className={styles.formGroupultimatetrucks}>
              <label>Enter amount per DH mile ($)*</label>
              <input
                name="dhMileRate"
                type="number"
                step="0.01"
                value={truckData.dhMileRate || ''}
                onChange={handleChange}
                required
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        {truckData.settlement === 'Hourly pay' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Hourly Rate ($)*</label>
              <input
                name="hourlyRate"
                type="number"
                step="0.01"
                value={truckData.hourlyRate || ''}
                onChange={handleChange}
                required
                className={styles.inputFieldultimatetrucks}
              />
            </div>
            <div className={styles.formGroupultimatetrucks}>
              <label>Hours Worked*</label>
              <input
                name="hoursWorked"
                type="number"
                step="0.1"
                value={truckData.hoursWorked || ''}
                onChange={handleChange}
                required
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        {truckData.settlement === 'Team driver pay' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Select Co-Driver</label>
              <input
                name="teamDriver"
                value={truckData.teamDriver || ''}
                onChange={handleChange}
                className={styles.inputFieldultimatetrucks}
              />
            </div>
            <div className={styles.formGroupultimatetrucks}>
              <label>Enter Team Pay Percentage (%)</label>
              <input
                name="teamPercentage"
                type="number"
                step="1"
                value={truckData.teamPercentage || ''}
                onChange={handleChange}
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        {truckData.settlement === 'Percentage of the load' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Enter Percentage of Load Revenue (%)</label>
              <input
                name="settlementAmount"
                type="number"
                step="1"
                value={truckData.settlementAmount || ''}
                onChange={handleChange}
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        {truckData.settlement === 'Fixed salary' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Fixed Salary Amount ($)</label>
              <input
                name="settlementAmount"
                type="number"
                step="0.01"
                value={truckData.settlementAmount || ''}
                onChange={handleChange}
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>VIN*</label>
            <input
              name="VIN"
              value={truckData.VIN}
              onChange={handleChange}
              placeholder="VIN"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>Truck Type*</label>
            <select
              name="truckType"
              value={truckData.truckType}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrucks}
            >
              <option value="">Select Type</option>
              <option value="Semi-truck">Semi-truck</option>
              <option value="Trailer">Trailer</option>
            </select>
          </div>
        </div>

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Fuel Type*</label>
            <select
              name="fuelType"
              value={truckData.fuelType}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrucks}
            >
              <option value="">Select Fuel Type</option>
              <option value="Diesel">Diesel</option>
              <option value="Gasoline">Gasoline</option>
            </select>
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>Miles*</label>
            <input
              name="miles"
              value={truckData.miles}
              onChange={handleChange}
              placeholder="Miles"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Driver*</label>
            <select
              name="driver"
              value={truckData.driver}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrucks}
            >
              <option value="">Select Driver</option>
            {employeeDrivers.map(driver => (
  <option key={driver._id} value={driver._id}>
    {driver.firstName} {driver.lastName}
  </option>
))}

            </select>
          </div>

<select
  name="owner"
  value={truckData.owner}
  onChange={handleChange}
  className={styles.selectFieldultimatetrucks}
>
  {companyName && (
    <option value={companyName}>
      {companyName} (Company)
    </option>
  )}

  {ownerOperators.map(owner => (
    <option
      key={owner._id}
      value={`${owner.firstName} ${owner.lastName}`}
    >
      {owner.firstName} {owner.lastName} (Owner Operator)
    </option>
  ))}
</select>




          <div className={styles.formGroupultimatetrucks}>
            <label>Trailer*</label>
            <select
              name="trailer"
              value={truckData.trailer}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrucks}
            >
              <option value="">Select Trailer</option>
              {Array.isArray(trailers) && trailers.map((trailer) => (
                <option key={trailer._id} value={trailer._id}>
                  {trailer.trailerNumber}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Inspection Date*</label>
            <input
              name="inspectionDate"
              type="date"
              value={truckData.inspectionDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>Maintenance Date*</label>
            <input
              name="maintenanceDate"
              type="date"
              value={truckData.maintenanceDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Insurance Policy Number*</label>
            <input
              name="insurancePolicyNumber"
              value={truckData.insurancePolicyNumber}
              onChange={handleChange}
              placeholder="Insurance Policy Number"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>Insurance Expiry Date*</label>
            <input
              name="insuranceExpiryDate"
              type="date"
              value={truckData.insuranceExpiryDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
        </div>

        <div className={styles.formGroupultimatetrucks}>
          <label>Fleet Division*</label>
          <input
            name="fleetDivision"
            value={truckData.fleetDivision}
            onChange={handleChange}
            placeholder="Fleet Division"
            required
            className={styles.inputFieldultimatetrucks}
          />
        </div>
        
        <div className={styles.formGroupultimatetrucks}>
          <label>Notes</label>
          <textarea
            name="notes"
            value={truckData.notes}
            onChange={handleChange}
            placeholder="Notes"
            className={styles.textareaFieldultimatetrucks}
          ></textarea>
        </div>

        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimatetrucks}>
          {editingIndex !== null ? 'Update Truck' : 'Add Truck'}
        </button>
      </form>

      <h3 className={styles.titleultimatetrucks}>Search Trucks</h3>
      <input
        type="text"
        placeholder="Search by truck number"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimatetrucks}
      />
           {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this truck?"
    onConfirm={() => confirmDeleteTruck(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}

      <h3 className={styles.titleultimatetrucks}>Existing Trucks</h3>
      <ul className={styles.truckListultimatetrucks}>
        {filteredTrucks.map((truck, index) => (
          <li key={index} className={styles.truckListItemultimatetrucks}>
            {truck.truckNumber}
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimatetrucks}>
              Edit
            </button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimatetrucks}
>
  Delete
</button>

          </li>
        ))}
      </ul>
      <EmailPanel />
    </div>
  );
};


const Trailers = ({ trailers = [], setTrailers }) => {
  const { notify } = useNotification();
  const [trailerData, setTrailerData] = useState({
    trailerNumber: '',
    licensePlate: '',
    VIN: '',
    trailerType: '',
    capacity: '',
    length: '',
    inspectionDate: '',
    maintenanceDate: '',
    insurancePolicyNumber: '',
    insuranceExpiryDate: '',
    fleetDivision: '',
    notes: ''
  });

  const apiUrl = 'https://api-backend.full-trucking-service.com/api'; 
  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [alarms, setAlarms] = useState({ inspectionAlarm: false, maintenanceAlarm: false, insuranceAlarm: false });
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);


  const token = sessionStorage.getItem('token'); 
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    withCredentials: true,
  };

  // Fetch trailers
  const fetchTrailers = async () => {
    try {
      const response = await axios.get(`${apiUrl}/trailers`, config);
      setTrailers(response.data);
    } catch (error) {
    
    }
  };

  useEffect(() => {
    fetchTrailers();
  }, []);

  // Function to check if any date has expired or reached the current date
  const checkAlarms = () => {
    const today = new Date().toISOString().split('T')[0];
    setAlarms({
      inspectionAlarm: trailerData.inspectionDate && trailerData.inspectionDate <= today,
      maintenanceAlarm: trailerData.maintenanceDate && trailerData.maintenanceDate <= today,
      insuranceAlarm: trailerData.insuranceExpiryDate && trailerData.insuranceExpiryDate <= today,
    });
  };

  useEffect(() => {
    checkAlarms();
  }, [trailerData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTrailerData({ ...trailerData, [name]: value });
  };

  const handleSubmit = async () => {
    if (editingIndex !== null) {
      const updatedTrailers = [...trailers];
      updatedTrailers[editingIndex] = { ...trailerData };
      setTrailers(updatedTrailers);
      setEditingIndex(null);
    } else {
      try {
        const response = await axios.post(`${apiUrl}/trailers`, trailerData, config);
        if (response.status === 201) {
          setTrailers([...trailers, response.data]);
        }
      } catch (error) {
        
      }
    }

    setTrailerData({
      trailerNumber: '',
      licensePlate: '',
      VIN: '',
      trailerType: '',
      capacity: '',
      length: '',
      inspectionDate: '',
      maintenanceDate: '',
      insurancePolicyNumber: '',
      insuranceExpiryDate: '',
      fleetDivision: '',
      notes: ''
    });
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setTrailerData(trailers[index]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const confirmDeleteTrailer = async (index) => {
    try {
      const trailerId = trailers[index]._id;
      await axios.delete(`${apiUrl}/trailers/${trailerId}`, config);
      setTrailers((prevTrailers) => prevTrailers.filter((_, i) => i !== index));
    } catch (error) {
 
      notify('Failed to delete trailer.', 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  

  const filteredTrailers = trailers.filter(
    (trailer) => 
      trailer?.trailerNumber?.toLowerCase().includes(searchQuery.toLowerCase()) || 
      trailer?.VIN?.toLowerCase().includes(searchQuery.toLowerCase())
  );
  

  return (
    <div
  className={`${styles.ultimatetrailersSection} ${
    theme === "light" ? styles.ultimatetrailersSectionLight : ""
  }`}
>

      <h3 className={styles.titleultimatetrailers}>Add or Edit Trailer</h3>
      {alarms.inspectionAlarm && <p className={styles.alarmMessageultimatetrailers}>Inspection date has expired!</p>}
      {alarms.maintenanceAlarm && <p className={styles.alarmMessageultimatetrailers}>Maintenance date has expired!</p>}
      {alarms.insuranceAlarm && <p className={styles.alarmMessageultimatetrailers}>Insurance has expired!</p>}

      <form className={styles.trailerFormultimatetrailers}>
        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>Trailer Number*</label>
            <input
              name="trailerNumber"
              value={trailerData.trailerNumber}
              onChange={handleChange}
              placeholder="Trailer Number"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>License Plate*</label>
            <input
              name="licensePlate"
              value={trailerData.licensePlate}
              onChange={handleChange}
              placeholder="License Plate"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>VIN*</label>
            <input
              name="VIN"
              value={trailerData.VIN}
              onChange={handleChange}
              placeholder="VIN"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>Trailer Type*</label>
            <select
              name="trailerType"
              value={trailerData.trailerType}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrailers}
            >
              <option value="">Select Type</option>
              <option value="Platform">Platform</option>
              <option value="Refrigerated">Refrigerated</option>
              <option value="Container">Container</option>
            </select>
          </div>
        </div>

        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>Capacity*</label>
            <input
              name="capacity"
              value={trailerData.capacity}
              onChange={handleChange}
              placeholder="Capacity"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>Length*</label>
            <input
              name="length"
              value={trailerData.length}
              onChange={handleChange}
              placeholder="Length"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>Inspection Date*</label>
            <input
              name="inspectionDate"
              type="date"
              value={trailerData.inspectionDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>Maintenance Date*</label>
            <input
              name="maintenanceDate"
              type="date"
              value={trailerData.maintenanceDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>Insurance Policy Number*</label>
            <input
              name="insurancePolicyNumber"
              value={trailerData.insurancePolicyNumber}
              onChange={handleChange}
              placeholder="Insurance Policy Number"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>Insurance Expiry Date*</label>
            <input
              name="insuranceExpiryDate"
              type="date"
              value={trailerData.insuranceExpiryDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
        </div>

        <div className={styles.formGroupultimatetrailers}>
          <label>Fleet Division*</label>
          <input
            name="fleetDivision"
            value={trailerData.fleetDivision}
            onChange={handleChange}
            placeholder="Fleet Division"
            required
            className={styles.inputFieldultimatetrailers}
          />
        </div>

        <div className={styles.formGroupultimatetrailers}>
          <label>Notes</label>
          <textarea
            name="notes"
            value={trailerData.notes}
            onChange={handleChange}
            placeholder="Notes"
            className={styles.textareaFieldultimatetrailers}
          ></textarea>
        </div>

        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimatetrailers}>
          {editingIndex !== null ? 'Update Trailer' : 'Add Trailer'}
        </button>
      </form>

      <h3 className={styles.titleultimatetrailers}>Search Trailers</h3>
      <input
        type="text"
        placeholder="Search by trailer number or VIN"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimatetrailers}
      />
  {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this trailer?"
    onConfirm={() => confirmDeleteTrailer(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}
      <h3 className={styles.titleultimatetrailers}>Existing Trailers</h3>
      <ul className={styles.trailerListultimatetrailers}>
        {filteredTrailers.map((trailer, index) => (
          <li key={index} className={styles.trailerListItemultimatetrailers}>
            {trailer.trailerNumber} ({trailer.VIN})
    
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimatetrailers}>Edit</button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimatetrailers}
>
  Delete
</button>

          </li>
        ))}
      </ul>
      <EmailPanel />
    </div>
  );
};


const Employees = ({ employees, setEmployees }) => {
  const { notify } = useNotification();
  const [employeeData, setEmployeeData] = useState({
    firstName: '',
    lastName: '',
    employeeId: '',
    email: '',
    phone: '',
    address: '',
    gender: '',
    residenceCountry: '',
    jobTitle: '',
    position: '',
    hireDate: '',
    terminationDate: '',
    contractType: '',
    payType: '',
    payAmount: '',
    commissionPercentage: '',
    notes: '',
  });

  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  const token = sessionStorage.getItem('token');
  const clientId = localStorage.getItem('clientId');
  const config = {
    headers: { 'Authorization': `Bearer ${token}` },
    withCredentials: true,
  };

  const fetchEmployees = async () => {
    try {
      const { data } = await axios.get(`${apiUrl}/employees`, config);
      setEmployees(data);
    } catch (err) {
    
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmployeeData({ ...employeeData, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      const dataToSend = { ...employeeData, clientId };
      if (editingIndex !== null) {
        const employeeId = employees[editingIndex]._id;
        const response = await axios.put(`${apiUrl}/employees/${employeeId}`, dataToSend, config);
        const updatedEmployees = [...employees];
        updatedEmployees[editingIndex] = response.data;
        setEmployees(updatedEmployees);
        setEditingIndex(null);
      } else {
        const response = await axios.post(`${apiUrl}/employees`, dataToSend, config);
        setEmployees([...employees, response.data]);
      }
      setEmployeeData({
        firstName: '',
        lastName: '',
        employeeId: '',
        email: '',
        phone: '',
        address: '',
        gender: '',
        residenceCountry: '',
        jobTitle: '',
        position: '',
        hireDate: '',
        terminationDate: '',
        contractType: '',
        payType: '',
        payAmount: '',
        commissionPercentage: '',
        notes: '',
      });
    } catch (error) {
     
    }
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEmployeeData(employees[index]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const confirmDeleteEmployee = async (index) => {
    try {
      const employeeId = employees[index]._id;
      await axios.delete(`${apiUrl}/employees/${employeeId}`, config);
      setEmployees((prev) => prev.filter((_, i) => i !== index));
    } catch (error) {
    
      notify('Failed to delete employee.', 'error');
    }
    setDeleteTarget(null);
  };

  const filteredEmployees = employees.filter(emp =>
    `${emp.firstName} ${emp.lastName}`.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
   <div
  className={`${styles.employeeSection} ${
    theme === "light" ? styles.employeeSectionLight : ""
  }`}
>

      <h3 className={styles.titleemployeeSection}>Add or Edit Employee</h3>
      <form className={styles.formemployeeSection}>
        <div className={styles.formRowemployeeSection}>
          <input name="firstName" value={employeeData.firstName} onChange={handleChange} placeholder="First Name*" />
          <input name="lastName" value={employeeData.lastName} onChange={handleChange} placeholder="Last Name*" />
        </div>
        <div className={styles.formRowemployeeSection}>
  <input
    name="employeeId"
    value={employeeData.employeeId}
    onChange={handleChange}
    placeholder="Employee ID"
  />
</div>
        <div className={styles.formRowemployeeSection}>
          <input name="email" value={employeeData.email} onChange={handleChange} placeholder="Email" />
          <input name="phone" value={employeeData.phone} onChange={handleChange} placeholder="Phone" />
        </div>
        <div className={styles.formRowemployeeSection}>
          <input name="address" value={employeeData.address} onChange={handleChange} placeholder="Address" />
          <select name="gender" value={employeeData.gender} onChange={handleChange}>
            <option value="">Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
          <select name="residenceCountry" value={employeeData.residenceCountry} onChange={handleChange}>
            <option value="">Residence Country</option>
            <option value="USA">USA</option>
            <option value="Canada">Canada</option>
            <option value="South America">South America</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className={styles.formRowemployeeSection}>
          <input name="jobTitle" value={employeeData.jobTitle} onChange={handleChange} placeholder="Job Title" />
          <input name="position" value={employeeData.position} onChange={handleChange} placeholder="Position" />
        </div>
        <div className={styles.formRowemployeeSection}>
          <input type="date" name="hireDate" value={employeeData.hireDate} onChange={handleChange} />
          <input type="date" name="terminationDate" value={employeeData.terminationDate} onChange={handleChange} />
        </div>
        <div className={styles.formRowemployeeSection}>
          <select name="contractType" value={employeeData.contractType} onChange={handleChange}>
            <option value="">Contract Type</option>
            <option value="Permanent">Permanent</option>
            <option value="Temporary">Temporary</option>
            <option value="Contract">Contract</option>
            <option value="Internship">Internship</option>
          </select>
          <select name="payType" value={employeeData.payType} onChange={handleChange}>
            <option value="">Pay Type</option>
            <option value="Hourly">Hourly</option>
            <option value="Fixed salary">Fixed salary</option>
            <option value="Commission">Commission</option>
            <option value="Weekly">Weekly</option>
            <option value="Monthly">Monthly</option>
          </select>
        </div>
        <div className={styles.formRowemployeeSection}>
  {employeeData.payType !== 'Commission' && (
    <input
      name="payAmount"
      type="number"
      value={employeeData.payAmount}
      onChange={handleChange}
      placeholder="Pay Amount"
    />
  )}
  {employeeData.payType === 'Commission' && (
    <input
      name="commissionPercentage"
      type="number"
      value={employeeData.commissionPercentage}
      onChange={handleChange}
      placeholder="Commission %"
    />
  )}
</div>

        <div className={styles.formRowemployeeSection}>
          <textarea name="notes" value={employeeData.notes} onChange={handleChange} placeholder="Notes" />
        </div>
        <button type="button" onClick={handleSubmit} className={styles.submitButtonemployeeSection}>
          {editingIndex !== null ? 'Update Employee' : 'Add Employee'}
        </button>
      </form>

      <h3 className={styles.titleemployeeSection}>Search Employees</h3>
      <input
        type="text"
        placeholder="Search by name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputemployeeSection}
      />

      {deleteTarget !== null && (
        <DeleteNotifications
          message="Are you sure you want to delete this employee?"
          onConfirm={() => confirmDeleteEmployee(deleteTarget)}
          onCancel={() => setDeleteTarget(null)}
        />
      )}

      <h3 className={styles.titleemployeeSection}>Existing Employees</h3>
      <ul className={styles.employeeListemployeeSection}>
        {filteredEmployees.map((emp, index) => (
          <li key={index} className={styles.employeeListItememployeeSection}>
            {emp.firstName} {emp.lastName} ({emp.jobTitle})
            <button onClick={() => handleEdit(index)} className={styles.editButtonemployeeSection}>
              Edit
            </button>
            <button onClick={() => setDeleteTarget(index)} className={styles.deleteButtonemployeeSection}>
              Delete
            </button>
          </li>
        ))}
      </ul>
      <EmailPanel />
    </div>
  );
};
// Componenta Brokers
const Brokers = ({ brokers, setBrokers }) => {
  const { notify } = useNotification();
  const [brokerData, setBrokerData] = useState({
    brokerName: '',
    brokerAddress: '',
    email: '',
    phone: '',
  });

  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);


  const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,  // Adaugă tokenul cu prefixul Bearer
        // Adaugă Content-Type
    },
    withCredentials: true,  // Trimite cookies pentru autentificare
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setBrokerData({ ...brokerData, [name]: value });
  };

  const handleSubmit = async () => {
    
    const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
    const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json',
      },
      withCredentials: true,  // Trimite și cookies pentru autentificare
    };
    if (editingIndex !== null) {
      // Update existing broker
      const updatedBrokers = [...brokers];
      updatedBrokers[editingIndex] = brokerData;
      setBrokers(updatedBrokers);
      setEditingIndex(null);
    } else {
      // Add new broker
      try {
        const dataToSend = { ...brokerData, clientId };
        const response = await axios.post(`${apiUrl}/brokers`, dataToSend, config);
        setBrokers([...brokers, response.data]);
      } catch (error) {
   
      }
    }
    setBrokerData({
      brokerName: '',
      brokerAddress: '',
      email: '',
      phone: '',
    });
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setBrokerData(brokers[index]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const confirmDeleteBroker = async (index) => {
    try {
      const brokerId = brokers[index]._id;
      await axios.delete(`${apiUrl}/brokers/${brokerId}`, config);
      setBrokers((prevBrokers) => prevBrokers.filter((_, i) => i !== index));
    } catch (error) {
     
      notify('Failed to delete broker.', 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  

  const filteredBrokers = brokers.filter(broker =>
    broker.brokerName && broker.brokerName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  

  return (
    <div
  className={`${styles.ultimatebrokersSection} ${
    theme === "light" ? styles.ultimatebrokersSectionLight : ""
  }`}
>

      <h3 className={styles.titleultimatebrokers}>Add or Edit Broker</h3>
      <form className={styles.brokerFormultimatebrokers}>
        <div className={styles.formRowultimatebrokers}>
          <div className={styles.formGroupultimatebrokers}>
            <label>Broker Name*</label>
            <input
              name="brokerName"
              value={brokerData.brokerName}
              onChange={handleChange}
              placeholder="Broker Name"
              required
              className={styles.inputFieldultimatebrokers}
            />
          </div>
          <div className={styles.formGroupultimatebrokers}>
            <label>Address*</label>
            <input
              name="address"
              value={brokerData.brokerAddress}
              onChange={handleChange}
              placeholder="Address"
              required
              className={styles.inputFieldultimatebrokers}
            />
          </div>
        </div>
  
        <div className={styles.formRowultimatebrokers}>
          <div className={styles.formGroupultimatebrokers}>
            <label>Email*</label>
            <input
              name="email"
              value={brokerData.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className={styles.inputFieldultimatebrokers}
            />
          </div>
          <div className={styles.formGroupultimatebrokers}>
            <label>Phone*</label>
            <input
              name="phone"
              value={brokerData.phone}
              onChange={handleChange}
              placeholder="Phone"
              required
              className={styles.inputFieldultimatebrokers}
            />
          </div>
        </div>
  
        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimatebrokers}>
          {editingIndex !== null ? 'Update Broker' : 'Add Broker'}
        </button>
      </form>
  
      <h3 className={styles.titleultimatebrokers}>Search Brokers</h3>
      <input
        type="text"
        placeholder="Search by broker name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimatebrokers}
      />
              {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this broker?"
    onConfirm={() => confirmDeleteBroker(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}
      <h3 className={styles.titleultimatebrokers}>Existing Brokers</h3>
      <ul className={styles.brokerListultimatebrokers}>
        {filteredBrokers.map((broker, index) => (
          <li key={index} className={styles.brokerListItemultimatebrokers}>
            {broker.brokerName}
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimatebrokers}>
              Edit
            </button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimatebrokers}
>
  Delete
</button>
          </li>
        ))}
      </ul>
      <EmailPanel />
    </div>
  );
  
};



// Componenta Shippers
const Shippers = ({ shippers, setShippers }) => {
  const { notify } = useNotification();
  const [shipperData, setShipperData] = useState({
    shipperName: '',
    shipperAddress: '',
    email: '',
    phone: '',
  });

  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);


  const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,  // Adaugă tokenul cu prefixul Bearer
        // Adaugă Content-Type
    },
    withCredentials: true,  // Trimite cookies pentru autentificare
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setShipperData({ ...shipperData, [name]: value });
  };

  const handleSubmit = async () => { 
    const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
    const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json',
      },
      withCredentials: true,  // Trimite și cookies pentru autentificare
    };
    if (editingIndex !== null) {
      // Update existing shipper
      const updatedShippers = [...shippers];
      updatedShippers[editingIndex] = shipperData;
      setShippers(updatedShippers);
      setEditingIndex(null);
    } else {
      // Add new shipper
      try {
        const dataToSend = { ...shipperData, clientId };  // Adaugă clientId la datele de trimis
        const response = await axios.post(`${apiUrl}/shippers`, shipperData,config);
        setShippers([...shippers, response.data]);
      } catch (error) {
        
      }
    }
    setShipperData({
      shipperName: '',
      shipperAddress: '',
      email: '',
      phone: '',
    });
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setShipperData(shippers[index]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const confirmDeleteShipper = async (index) => {
    try {
      const shipperId = shippers[index]._id;
      await axios.delete(`${apiUrl}/shippers/${shipperId}`, config);
      setShippers((prevShippers) => prevShippers.filter((_, i) => i !== index));
    } catch (error) {
    
      notify('Failed to delete shipper.', 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  
  
  const filteredShippers = shippers.filter(shipper =>
    shipper.shipperName && shipper.shipperName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  
  
  return (
    <div
  className={`${styles.ultimateshippersSection} ${
    theme === "light" ? styles.ultimateshippersSectionLight : ""
  }`}
>

      <h3 className={styles.titleultimateshippers}>Add or Edit Shipper</h3>
      <form className={styles.shipperFormultimateshippers}>
        <div className={styles.formRowultimateshippers}>
          <div className={styles.formGroupultimateshippers}>
            <label>Shipper Name*</label>
            <input
              name="shipperName"
              value={shipperData.shipperName}
              onChange={handleChange}
              placeholder="Shipper Name"
              required
              className={styles.inputFieldultimateshippers}
            />
          </div>
          <div className={styles.formGroupultimateshippers}>
            <label>Address*</label>
            <input
              name="shipperAddress"
              value={shipperData.shipperAddressultimateshippers}
              onChange={handleChange}
              placeholder="Address"
              required
              className={styles.inputFieldultimateshippers}
            />
          </div>
        </div>
  
        <div className={styles.formRowultimateshippers}>
          <div className={styles.formGroupultimateshippers}>
            <label>Email*</label>
            <input
              name="email"
              value={shipperData.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className={styles.inputFieldultimateshippers}
            />
          </div>
          <div className={styles.formGroupultimateshippers}>
            <label>Phone*</label>
            <input
              name="phone"
              value={shipperData.phone}
              onChange={handleChange}
              placeholder="Phone"
              required
              className={styles.inputFieldultimateshippers}
            />
          </div>
        </div>
  
        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimateshippers}>
          {editingIndex !== null ? 'Update Shipper' : 'Add Shipper'}
        </button>
      </form>
  
      <h3 className={styles.titleultimateshippers}>Search Shippers</h3>
      <input
        type="text"
        placeholder="Search by shipper name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimateshippers}
      />
           {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this shipper?"
    onConfirm={() => confirmDeleteShipper(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}
      <h3 className={styles.titleultimateshippers}>Existing Shippers</h3>
      <ul className={styles.shipperListultimateshippers}>
        {filteredShippers.map((shipper, index) => (
          <li key={index} className={styles.shipperListItemultimateshippers}>
            {shipper.shipperName}
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimateshippers}>
              Edit
            </button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimateshippers}
>
  Delete
</button>

          </li>
        ))}
      </ul>
      <EmailPanel />
    </div>
  );
}  

// Componenta Consignees
const Consignees = ({ consignees, setConsignees }) => {
  const { notify } = useNotification();
  const [consigneeData, setConsigneeData] = useState({
    consigneeName: '',
    consigneeAddress: '',
    email: '',
    phone: '',
    notes: '',
  });

  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  
  const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,  // Adaugă tokenul cu prefixul Bearer
        // Adaugă Content-Type
    },
    withCredentials: true,  // Trimite cookies pentru autentificare
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setConsigneeData({ ...consigneeData, [name]: value });
  };

  const handleSubmit = async () => {
    const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
    const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json',
      },
      withCredentials: true,  // Trimite și cookies pentru autentificare
    };
    if (editingIndex !== null) {
      // Update existing consignee
      const updatedConsignees = [...consignees];
      updatedConsignees[editingIndex] = consigneeData;
      setConsignees(updatedConsignees);
      setEditingIndex(null);
    } else {
      // Add new consignee
      try {
        const dataToSend = { ...consigneeData, clientId };
        const response = await axios.post(`${apiUrl}/consignees`, consigneeData, config);
       setConsignees([...consignees, response.data]);
      } catch (error) {
  
      }
    }
    setConsigneeData({
      consigneeName: '',
      consigneeAddress: '',
      email: '',
      phone: '',
    });
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setConsigneeData(consignees[index]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const confirmDeleteConsignee = async (index) => {
    try {
      const consigneeId = consignees[index]._id;
      await axios.delete(`${apiUrl}/consignees/${consigneeId}`, config);
      setConsignees((prevConsignees) => prevConsignees.filter((_, i) => i !== index));
    } catch (error) {
 
      notify('Failed to delete consignee.', 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  

  const filteredConsignees = consignees.filter(consignee =>
    consignee.consigneeName && consignee.consigneeName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  
  return (
    <div
  className={`${styles.ultimateconsigneesSection} ${
    theme === "light" ? styles.ultimateconsigneesSectionLight : ""
  }`}
>

      <h3 className={styles.titleultimateconsignees}>Add or Edit Consignee</h3>
      <form className={styles.consigneeFormultimateconsignees}>
        <div className={styles.formRowultimateconsignees}>
          <div className={styles.formGroupultimateconsignees}>
            <label>Consignee Name*</label>
            <input
              name="consigneeName"
              value={consigneeData.consigneeName}
              onChange={handleChange}
              placeholder="Consignee Name"
              required
              className={styles.inputFieldultimateconsignees}
            />
          </div>
          <div className={styles.formGroupultimateconsignees}>
            <label>Address*</label>
            <input
              name="consigneeAddress"
              value={consigneeData.consigneeAddressultimateconsignees}
              onChange={handleChange}
              placeholder="Address"
              required
              className={styles.inputFieldultimateconsignees}
            />
          </div>
        </div>
  
        <div className={styles.formRowultimateconsignees}>
          <div className={styles.formGroupultimateconsignees}>
            <label>Email*</label>
            <input
              name="email"
              value={consigneeData.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className={styles.inputFieldultimateconsignees}
            />
          </div>
          <div className={styles.formGroupultimateconsignees}>
            <label>Phone*</label>
            <input
              name="phone"
              value={consigneeData.phone}
              onChange={handleChange}
              placeholder="Phone"
              required
              className={styles.inputFieldultimateconsignees}
            />
          </div>
        </div>
  
        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimateconsignees}>
          {editingIndex !== null ? 'Update Consignee' : 'Add Consignee'}
        </button>
      </form>
  
      <h3 className={styles.titleultimateconsignees}>Search Consignees</h3>
      <input
        type="text"
        placeholder="Search by consignee name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimateconsignees}
      />
              {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this consignee?"
    onConfirm={() => confirmDeleteConsignee(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}

      <h3 className={styles.titleultimateconsignees}>Existing Consignees</h3>
      <ul className={styles.consigneeListultimateconsignees}>
        {filteredConsignees.map((consignee, index) => (
          <li key={index} className={styles.consigneeListItemultimateconsignees}>
            {consignee.consigneeName}
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimateconsignees}>
              Edit
            </button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimateconsignees}
>
  Delete
</button>

          </li>
        ))}
      </ul>
      <EmailPanel />
    </div>
  );
  
};
const statusOrder = [
  "Open",
  "Pending",
  "Dispatched",
  "Assigned",
  "In Progress",
  "On Route",
  "Delivered",
  "Completed",
];

const LoadFinder = ({ loads }) => {
  const [search, setSearch] = useState("");
  const [drivers, setDrivers] = useState([]);
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedLoad, setSelectedLoad] = useState(null);
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

  const apiUrl = "https://api-backend.full-trucking-service.com/api";
  const token = sessionStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  };

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const response = await axios.get(`${apiUrl}/drivers`, config);
        setDrivers(response.data);
      } catch (error) {
       
      }
    };

    fetchDrivers();
  }, []);

  useEffect(() => {
    const activeLoads = loads
      .filter((load) => !["Completed", "Cancelled"].includes(load.status))
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    setFilteredLoads(activeLoads);
  }, [loads]);

  // ✅ Corectat funcția pentru a găsi numele șoferului corect
  const getDriverName = (driverId) => {
    if (!driverId) return "No Driver";

    const driver = drivers.find((d) => d._id === driverId);
    return driver ? `${driver.firstName} ${driver.lastName}` : "Unknown Driver";
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    const query = e.target.value.toLowerCase();

    const filtered = loads
      .filter(
        (load) =>
          !["Completed", "Cancelled"].includes(load.status) &&
          (load.loadNumber.toLowerCase().includes(query) ||
            (load.driver && getDriverName(load.driver).toLowerCase().includes(query)) ||
            (load.clientId && load.clientId.toLowerCase().includes(query)))
      )
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    setFilteredLoads(filtered);
  };

  const getNextStatus = (currentStatus) => {
    const index = statusOrder.indexOf(currentStatus);
    return index !== -1 && index < statusOrder.length - 1 ? statusOrder[index + 1] : "Completed";
  };

  const handleNextStatus = async () => {
    if (!selectedLoad) return;

    const nextStatus = getNextStatus(selectedLoad.status);

    try {
      const response = await axios.put(
        `${apiUrl}/loads/${selectedLoad._id}`,
        { status: nextStatus },
        config
      );

      if (response.status === 200) {
        setFilteredLoads((prevLoads) =>
          prevLoads
            .map((load) =>
              load._id === selectedLoad._id ? { ...load, status: nextStatus } : load
            )
            .filter((load) => load.status !== "Completed")
        );
        setSelectedLoad((prev) => (prev ? { ...prev, status: nextStatus } : null));
      }
    } catch (error) {

    }
  };

  return (
   <div
  className={`${styles.loadFinderSection} ${
    theme === "light" ? styles.loadFinderSectionLight : ""
  }`}
>


      <h2>Load Tracker</h2>
      <input
        type="text"
        placeholder="Search by Load #, Driver, Client ID"
        value={search}
        onChange={handleSearch}
        className={styles.searchInputloadFinder}
      />

      <ul className={styles.loadListloadFinder}>
        {filteredLoads.map((load) => (
          <li
            key={load._id}
            className={styles.loadItemloadFinder}
            onClick={() => setSelectedLoad(load)}
          >
            <strong>Load #:</strong> {load.loadNumber} <br />
            <strong>Dispatcher:</strong> {load.dispatcher} <br />
            <strong>Driver:</strong> {getDriverName(load.driver)} <br />
            <strong>Status:</strong> {load.status} <br />
          </li>
        ))}
      </ul>

      {/* 🔥 Modal pentru schimbarea statusului, afișat pe mijlocul ecranului */}
      {selectedLoad && (
        <>
          <div className={styles.modalBackdrop} onClick={() => setSelectedLoad(null)}></div>
          <div className={styles.modalContainer}>
            <h3>Load Details</h3>
            <p>
              <strong>Dispatcher:</strong> {selectedLoad.dispatcher}
            </p>
            <p>
              <strong>Load #:</strong> {selectedLoad.loadNumber}
            </p>
            <p>
              <strong>Driver:</strong> {getDriverName(selectedLoad.driver)}
            </p>
            <p>
              <strong>Status:</strong> {selectedLoad.status}
            </p>
            <p>
              <strong>Payment Status:</strong> {selectedLoad.paymentStatus}
            </p>
            <button className={styles.nextButtonloadFind} onClick={handleNextStatus}>
              Next Status: {getNextStatus(selectedLoad.status)}
            </button>
            <button className={styles.closeButtonloadFinder} onClick={() => setSelectedLoad(null)}>
              Close
            </button>
          </div>
        </>
      )}
      <EmailPanel />
    </div>
  );
};


const LoadManager = ({ loads, setLoads,selectedLoadId }) => {
  const { notify } = useNotification();
  const [editingLoad, setEditingLoad] = useState(null);
  const [search, setSearch] = useState('');
  const [drivers, setDrivers] = useState([]);
  const [trucks, setTrucks] = useState([]);
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState('');
  const [selectedDispatcher, setSelectedDispatcher] = useState('');
  const [loadDocuments, setLoadDocuments]   = useState([]);
const [previewDocUrl, setPreviewDocUrl]   = useState('');
const [previewDocMime, setPreviewDocMime] = useState('');
const [selectedDocPreview, setSelectedDocPreview] = useState(null);

const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

  const [selectedTruck, setSelectedTruck] = useState("");
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [minRate, setMinRate] = useState('');
const [maxRate, setMaxRate] = useState('');
const [pickupStart, setPickupStart] = useState('');
const [pickupEnd, setPickupEnd] = useState('');
const [deliveryStart, setDeliveryStart] = useState('');
const [deliveryEnd, setDeliveryEnd] = useState('');
const [createdStart, setCreatedStart] = useState('');
const [createdEnd, setCreatedEnd] = useState('');

const [selectedStatuses, setSelectedStatuses] = useState([]);
  const editSectionRef = useRef(null);

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);


  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const token = sessionStorage.getItem('token');
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    },
    withCredentials: true
  };
  useEffect(() => {
    if (selectedLoadId) {
      const selectedLoad = loads.find((load) => load._id === selectedLoadId);
      if (selectedLoad) {
        setEditingLoad(selectedLoad); // Setăm `editingLoad` pentru a deschide editorul
      }
    }
  }, [selectedLoadId, loads]);
  useEffect(() => {
  if (editingLoad) {
    setSelectedTruck(editingLoad.truck ? String(editingLoad.truck) : '');
    setSelectedDriver(editingLoad.driver || '');
  }
}, [editingLoad]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const driversRes = await axios.get(`${apiUrl}/drivers`, config);
        setDrivers(driversRes.data);

        const trucksRes = await axios.get(`${apiUrl}/trucks`, config);
setTrucks(trucksRes.data.map(t => ({ ...t, _id: String(t._id) })));
      } catch (error) {
        
      }
    };
    fetchData();
  }, []);

useEffect(() => {
  if (!editingLoad?._id) { setLoadDocuments([]); return; }
  const fetchLoadDocs = async () => {
    try {
      const res = await axios.get(`${apiUrl}/documents`, {
        ...config,
        params: { linkedEntityType: 'load', linkedEntityId: editingLoad._id },
      });
      setLoadDocuments(res.data);
    } catch { setLoadDocuments([]); }
  };
  fetchLoadDocs();
}, [editingLoad?._id]);

const handleDocPreview = async (doc) => {
  try {
    const res = await axios.get(`${apiUrl}/documents/${doc.id}/download`, {
      ...config, responseType: 'blob',
    });
    const url = URL.createObjectURL(res.data);
    setPreviewDocUrl(url);
    setPreviewDocMime(doc.mimeType);
    setSelectedDocPreview(doc);
  } catch { alert('Preview failed'); }
};

  useEffect(() => {
    const filtered = loads.filter((load) => {
      const searchTerm = search.toLowerCase();
      const driverName = drivers.find((d) => d._id === load.driver);
      const truckObj = trucks.find((t) => t._id === String(load.truck));

      const matchesSearch =
        (load.loadNumber && load.loadNumber.toLowerCase().includes(searchTerm)) ||
        (load.brokerName && load.brokerName.toLowerCase().includes(searchTerm)) ||
        (load.brokerAddress && load.brokerAddress.toLowerCase().includes(searchTerm)) ||
        (load.notes && load.notes.toLowerCase().includes(searchTerm)) ||
        (driverName && `${driverName.firstName} ${driverName.lastName}`.toLowerCase().includes(searchTerm)) ||
        (truckObj && truckObj.plate && truckObj.plate.toLowerCase().includes(searchTerm)) ||
        (load.dispatcher && load.dispatcher.toLowerCase().includes(searchTerm));
    
const matchesDriver = selectedDriver ? String(load.driver) === String(selectedDriver) : true;
const matchesTruck = selectedTruck ? String(load.truck) === String(selectedTruck) : true;

      const matchesDispatcher = selectedDispatcher ? load.dispatcher.toLowerCase().includes(selectedDispatcher.toLowerCase()) : true;
    
      const matchesRate =
        (!minRate || parseFloat(load.rate) >= parseFloat(minRate)) &&
        (!maxRate || parseFloat(load.rate) <= parseFloat(maxRate));
    
      const matchesStatus = selectedStatuses.length > 0 ? selectedStatuses.includes(load.status) : true;
    
      const pickupTimes = load.shippers.map(s => new Date(s.pickUpTime));
      const deliveryTimes = load.consignees.map(c => new Date(c.deliveryTime));
      const createdAt = new Date(load.createdAt);
    
      const matchesPickup = (!pickupStart || pickupTimes.some(t => t >= new Date(pickupStart))) &&
                            (!pickupEnd || pickupTimes.some(t => t <= new Date(pickupEnd)));
    
      const matchesDelivery = (!deliveryStart || deliveryTimes.some(t => t >= new Date(deliveryStart))) &&
                              (!deliveryEnd || deliveryTimes.some(t => t <= new Date(deliveryEnd)));
    
      const matchesCreated = (!createdStart || createdAt >= new Date(createdStart)) &&
                             (!createdEnd || createdAt <= new Date(createdEnd));
    
      return matchesSearch && matchesDriver && matchesTruck && matchesDispatcher &&
             matchesRate && matchesStatus && matchesPickup && matchesDelivery && matchesCreated;
    });
    
  
    setFilteredLoads(filtered);
  }, [search, loads, selectedDriver, selectedTruck, minRate, maxRate, selectedStatuses]);
  
{/* Rate Range Filter */}
<div className={styles.filterGroup}>
  <label>Rate From:</label>
  <input type="number" value={minRate} onChange={(e) => setMinRate(e.target.value)} />

  <label>To:</label>
  <input type="number" value={maxRate} onChange={(e) => setMaxRate(e.target.value)} />
</div>

{/* Status Filter */}
<select
  multiple
  value={selectedStatuses}
  onChange={(e) => {
    const options = Array.from(e.target.selectedOptions).map(o => o.value);
    setSelectedStatuses(options);
  }}
>
  <option value="Pending">Pending</option>
  <option value="Open">Open</option>
  <option value="Refused">Refused</option>
  <option value="Assigned">Assigned</option>
  <option value="Dispatched">Dispatched</option>
  <option value="On Route">On Route</option>
  <option value="In Progress">In Progress</option>
  <option value="Delivered">Delivered</option>
  <option value="(Un)Loading">Un-Loading</option>
  <option value="Completed">Completed</option>
  <option value="Cancelled">Cancelled</option>
  <option value="In Yard">In Yard</option>
</select>


  const getDriverName = (driverId) => {
    const driver = drivers.find((d) => d._id === driverId);
    return driver ? `${driver.firstName} ${driver.lastName}` : 'Unknown Driver';
  };

  const handleSelectLoad = (loadIndex) => {
    setEditingLoad(filteredLoads[loadIndex]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditingLoad({ ...editingLoad, [name]: value });
  };

  const handleDriverChange = (e) => {
    const newDriverId = e.target.value;
    setSelectedDriver(newDriverId);
    setEditingLoad({ ...editingLoad, driver: newDriverId });
  };

  const handleTruckChange = (e) => {
    const newTruckId = e.target.value;
    setSelectedTruck(newTruckId);
    setEditingLoad({ ...editingLoad, truck: newTruckId });
  };

  const handleSave = async () => {
    try {
      if (editingLoad && editingLoad._id) {
        await axios.put(`${apiUrl}/loads/${editingLoad._id}`, editingLoad, config);
        setLoads((prevLoads) =>
          prevLoads.map((load) =>
            load._id === editingLoad._id ? editingLoad : load
          )
        );
        notify('Load updated successfully','success');
      }
    } catch (error) {
      
    }
  };

  const handleDelete = (loadId) => {
    setDeleteTarget(loadId); // Setăm ID-ul pentru notificare
  
    // 🔥 Dăm scroll la secțiunea de editare cu un mic delay
    setTimeout(() => {
      if (editSectionRef.current) {
        editSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 200); // Delay pentru a permite UI-ului să se actualizeze
  };
  
  useEffect(() => {
    if (deleteTarget !== null) {
      setTimeout(() => {
        if (editSectionRef.current) {
          editSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 200);
    }
  }, [deleteTarget]);
  
  
  const confirmDeleteLoad = async () => {
    if (!deleteTarget) return;
  
    try {
      await axios.delete(`${apiUrl}/loads/${deleteTarget}`, config);
      setLoads((prevLoads) => prevLoads.filter((load) => load._id !== deleteTarget));
      setEditingLoad(null);
      notify('Load deleted successfully', 'success');
    } catch (error) {
    
      notify('Failed to delete load.', 'error');
    }
    setDeleteTarget(null); // 🔥 Ascundem notificarea după ștergere
  };
  const exportToExcel = () => {
  const data = filteredLoads.map(load => ({
    'Load #': load.loadNumber,
    'Broker Name': load.brokerName,
    'Broker Address': load.brokerAddress,
    'Rate': load.rate,
    'Shippers': load.shippers.map(s => `${s.name}, ${s.address}, ${s.pickUpTime ? new Date(s.pickUpTime).toLocaleString() : ''}`).join('\n'),
    'Consignees': load.consignees.map(c => `${c.name}, ${c.address}, ${c.deliveryTime ? new Date(c.deliveryTime).toLocaleString() : ''}`).join('\n'),
    'Dispatcher': load.dispatcher,
    'Status': load.status,
    'Driver': drivers.find(d => d._id === load.driver) ? `${drivers.find(d => d._id === load.driver).firstName} ${drivers.find(d => d._id === load.driver).lastName}` : '',
    'Truck': (() => {
      const truckId = typeof load.truck === 'object' ? load.truck?._id : load.truck;
      const truck = trucks.find(t => String(t._id) === String(truckId));
      return truck?.truckNumber || '';
    })(),
    'Miles': load.miles,
    'DH': load.dh,
    'Notes': load.notes,
  }));

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Loads');
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, `loads_export_${new Date().toISOString().slice(0,10)}.xlsx`);
};

const labelStyle = {
  display: 'block', marginBottom: 4, fontSize: '0.78rem',
  color: '#9499B0', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5,
};
const inputStyle = (disabled = false) => ({
  width: '100%', padding: '8px 12px', borderRadius: 8, border: '1px solid #2a2d3a',
  background: disabled ? '#1a1d2a' : '#1e2130', color: disabled ? '#555' : '#e0e0e0',
  fontSize: '0.88rem', outline: 'none', boxSizing: 'border-box',
  opacity: disabled ? 0.6 : 1,
});

  return (
   <div
  className={`${styles.ultimateloadManagerSection} ${
    theme === "light" ? styles.ultimateloadManagerSectionLight : ""
  }`}
>

      <h2 className={styles.titleultimateloadManager}>Load Scheduler</h2>
  
      <input
        type="text"
        placeholder="Search by Load Number or Driver"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className={styles.searchInputultimateloadManager}
      />
 

      <div className={styles.filtersContainer}>
        {/* Rate Filter */}
        <div className={styles.filterGroup}>
          <label>Rate:</label>
          <input
            type="number"
            value={minRate}
            onChange={(e) => setMinRate(e.target.value)}
            placeholder="From"
            className={styles.inputFieldultimateloadManager}
          />
          <input
            type="number"
            value={maxRate}
            onChange={(e) => setMaxRate(e.target.value)}
            placeholder="To"
            className={styles.inputFieldultimateloadManager}
          />
        </div>
  
        {/* Dispatcher Filter */}
        <div className={styles.filterGroup}>
          <label>Dispatcher:</label>
          <input
            type="text"
            value={selectedDispatcher}
            onChange={(e) => setSelectedDispatcher(e.target.value)}
            placeholder="Type dispatcher name"
            className={styles.inputFieldultimateloadManager}
          />
        </div>
  
      {/* Truck Filter */}
<div className={styles.filterGroup}>
  <label>Truck:</label>
  <select
    value={typeof selectedTruck === 'object' ? selectedTruck._id : selectedTruck}
    onChange={(e) => setSelectedTruck(e.target.value)}
    className={styles.selectFieldultimateloadManager}
  >
    <option value="">All Trucks</option>
    {trucks.map((truck) => (
      <option key={truck._id} value={truck._id}>
        {truck.truckNumber || "No Truck Number"}
      </option>
    ))}
  </select>
</div>

  
        {/* Driver Filter */}
        <div className={styles.filterGroup}>
          <label>Driver:</label>
          <select
            value={selectedDriver}
            onChange={(e) => setSelectedDriver(e.target.value)}
            className={styles.selectFieldultimateloadManager}
          >
            <option value="">All Drivers</option>
            {drivers.map((driver) => (
              <option key={driver._id} value={driver._id}>
                {driver.firstName} {driver.lastName}
              </option>
            ))}
          </select>
        </div>
  
        {/* Status Filter */}
        <div className={styles.filterGroup}>
          <label>Status:</label>
          <select
            multiple
            value={selectedStatuses}
            onChange={(e) =>
              setSelectedStatuses(Array.from(e.target.selectedOptions).map((o) => o.value))
            }
            className={styles.selectFieldultimateloadManager}
          >
            <option value="Pending">Pending</option>
            <option value="Open">Open</option>
            <option value="Refused">Refused</option>
            <option value="Assigned">Assigned</option>
            <option value="Dispatched">Dispatched</option>
            <option value="On Route">On Route</option>
            <option value="In Progress">In Progress</option>
            <option value="Delivered">Delivered</option>
            <option value="(Un)Loading">Un-Loading</option>
            <option value="Completed">Completed</option>
            <option value="Cancelled">Cancelled</option>
            <option value="In Yard">In Yard</option>
          </select>
        </div>
  
        {/* Pick-up Time Filter */}
        <div className={styles.filterGroup}>
          <label>Pick-up Time:</label>
          <input
            type="datetime-local"
            value={pickupStart}
            onChange={(e) => setPickupStart(e.target.value)}
            className={styles.inputFieldultimateloadManager}
          />
          <input
            type="datetime-local"
            value={pickupEnd}
            onChange={(e) => setPickupEnd(e.target.value)}
            className={styles.inputFieldultimateloadManager}
          />
        </div>
  
        {/* Delivery Time Filter */}
        <div className={styles.filterGroup}>
          <label>Delivery Time:</label>
          <input
            type="datetime-local"
            value={deliveryStart}
            onChange={(e) => setDeliveryStart(e.target.value)}
            className={styles.inputFieldultimateloadManager}
          />
          <input
            type="datetime-local"
            value={deliveryEnd}
            onChange={(e) => setDeliveryEnd(e.target.value)}
            className={styles.inputFieldultimateloadManager}
          />
        </div>
  
        {/* Created Date Filter */}
        <div className={styles.filterGroup}>
          <label>Created Date:</label>
          <input
            type="date"
            value={createdStart}
            onChange={(e) => setCreatedStart(e.target.value)}
            className={styles.inputFieldultimateloadManager}
          />
          <input
            type="date"
            value={createdEnd}
            onChange={(e) => setCreatedEnd(e.target.value)}
            className={styles.inputFieldultimateloadManager}
          />
        </div>
      </div>
   <button onClick={exportToExcel} className={styles.exportButtonultimateloadManager}>
  Export to Excel
</button>
      <div className={styles.tableWrapper}>
      <table className={styles.ultimateloadManagerloadTable}>
        <thead>
          <tr>
            <th>Load #</th>
            <th>Broker Name</th>
            <th>Broker Address</th>
            <th>Rate</th>
            <th>Shippers</th>
            <th>Consignees</th>
            <th>Dispatcher</th>
            <th>Status</th>
            <th>Driver</th>
            <th>Truck</th>
            <th>Miles</th>
            <th>DH</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          {filteredLoads.map((load, index) => (
            <tr key={index} onClick={() => handleSelectLoad(index)} className={styles.ultimateloadManagerloadRow}>
              <td>{load.loadNumber}</td>
              <td>{load.brokerName}</td>
              <td>{load.brokerAddress}</td>
              <td>${load.rate}</td>
              <td>
                {load.shippers.map((shipper, idx) => (
                  <div key={idx}>
                    <strong>Name:</strong> {shipper.name} <br />
                    <strong>Address:</strong> {shipper.address} <br />
                    <strong>Pick-up Time:</strong> {shipper.pickUpTime ? new Date(shipper.pickUpTime).toLocaleString() : 'No data'}
                  </div>
                ))}
              </td>
              <td>
                {load.consignees.map((consignee, idx) => (
                  <div key={idx}>
                    <strong>Name:</strong> {consignee.name} <br />
                    <strong>Address:</strong> {consignee.address} <br />
                    <strong>Delivery Time:</strong> {consignee.deliveryTime ? new Date(consignee.deliveryTime).toLocaleString() : 'No data'}
                  </div>
                ))}
              </td>
              <td>{load.dispatcher}</td>
              <td>{load.status}</td>
              <td>{load.driver ? drivers.find(d => d._id === load.driver)?.firstName || "Unknown" : "No Driver"}</td>
     <td>
  {(() => {
    if (!load.truck) return "No Truck";
    const truckId = typeof load.truck === 'object' ? load.truck?._id : load.truck;
    const truck = trucks.find(t => String(t._id) === String(truckId));
    return truck?.truckNumber || "Unknown";
  })()}
</td>




              <td>{load.miles}</td>
              <td>{load.dh}</td>
              <td>{load.notes}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
  {editingLoad && createPortal(
  <div
      data-theme={theme}
    style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.85)',
      display: 'flex', flexDirection: 'column',
    }}
  >
    {/* ── Header bar ── */}
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '14px 24px',
      background: '#0f1117',
      borderBottom: '1px solid #2a2d3a',
      flexShrink: 0,
    }}>
      <h2 style={{ margin: 0, color: '#fff', fontSize: '1.1rem', fontWeight: 600 }}>
        Edit Load <span style={{ color: '#60A5FA' }}>#{editingLoad.loadNumber}</span>
      </h2>
      <div style={{ display: 'flex', gap: 10 }}>
        <button
          onClick={handleSave}
          style={{
            padding: '8px 20px', borderRadius: 8, border: 'none', cursor: 'pointer',
            background: '#22c55e', color: '#fff', fontWeight: 600, fontSize: '0.9rem',
          }}
        >Save</button>
     
        <button
          onClick={() => { setEditingLoad(null); setPreviewDocUrl(''); setSelectedDocPreview(null); }}
          style={{
            padding: '8px 16px', borderRadius: 8, border: '1px solid #3a3d4a', cursor: 'pointer',
            background: 'transparent', color: '#aaa', fontWeight: 600, fontSize: '0.9rem',
          }}
        >✕ Close</button>
      </div>
    </div>

    {/* ── Body: 40% form | 60% docs ── */}
    <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>

      {/* ── LEFT: Form 40% ── */}
      <div style={{
        width: '40%', overflowY: 'auto', padding: '24px',
        borderRight: '1px solid #2a2d3a',
        background: '#13151f',
        display: 'flex', flexDirection: 'column', gap: 12,
      }}>
        {/* Load Number */}
        <div>
          <label style={labelStyle}>Load #</label>
          <input name="loadNumber" value={editingLoad.loadNumber} disabled style={inputStyle(true)} />
        </div>

        {/* Broker */}
        <div>
          <label style={labelStyle}>Broker Name</label>
          <input name="brokerName" value={editingLoad.brokerName || ''} onChange={handleChange} style={inputStyle()} />
        </div>
        <div>
          <label style={labelStyle}>Broker Address</label>
          <input name="brokerAddress" value={editingLoad.brokerAddress || ''} onChange={handleChange} style={inputStyle()} />
        </div>

        {/* Rate */}
        <div>
          <label style={labelStyle}>Rate ($)</label>
          <input name="rate" type="number" value={editingLoad.rate || ''} onChange={handleChange} style={inputStyle()} />
        </div>

        {/* Status */}
        <div>
          <label style={labelStyle}>Status</label>
          <select name="status" value={editingLoad.status || ''} onChange={handleChange} style={inputStyle()}>
            {['Pending','Open','Refused','Assigned','Dispatched','On Route','In Progress','Delivered','(Un)Loading','Completed','Cancelled','In Yard'].map(s => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>

        {/* Payment Status */}
        <div>
          <label style={labelStyle}>Payment Status</label>
          <select name="paymentStatus" value={editingLoad.paymentStatus || ''} onChange={handleChange} style={inputStyle()}>
            <option value="">Select Payment Status</option>
            {['Not Paid','Pending Payment','Payment in Progress','Payment Cancelled','Paid','Paid in Installments'].map(s => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>

        {/* Driver */}
        <div>
          <label style={labelStyle}>Driver</label>
          <select value={selectedDriver} onChange={handleDriverChange} style={inputStyle()}>
            <option value="">Select Driver</option>
            {drivers.map(d => (
              <option key={d._id} value={d._id}>{d.firstName} {d.lastName}</option>
            ))}
          </select>
        </div>

        {/* Truck */}
        <div>
          <label style={labelStyle}>Truck</label>
          <select value={typeof selectedTruck === 'object' ? selectedTruck._id : selectedTruck} onChange={handleTruckChange} style={inputStyle()}>
            <option value="">Select Truck</option>
            {trucks.map(t => (
              <option key={t._id} value={t._id}>{t.truckNumber}</option>
            ))}
          </select>
        </div>

        {/* Miles / DH */}
        <div style={{ display: 'flex', gap: 12 }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Miles</label>
            <input name="miles" type="number" value={editingLoad.miles || ''} onChange={handleChange} style={inputStyle()} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>DH</label>
            <input name="dh" type="number" value={editingLoad.dh || ''} onChange={handleChange} style={inputStyle()} />
          </div>
        </div>

        {/* Notes */}
        <div>
          <label style={labelStyle}>Notes</label>
          <textarea name="notes" value={editingLoad.notes || ''} onChange={handleChange}
            style={{ ...inputStyle(), resize: 'vertical', minHeight: 70 }} />
        </div>

        {/* Shippers */}
        <div style={{ borderTop: '1px solid #2a2d3a', paddingTop: 12 }}>
          <label style={{ ...labelStyle, fontSize: '0.85rem', color: '#60A5FA', textTransform: 'uppercase', letterSpacing: 1 }}>Shippers</label>
          {editingLoad.shippers.map((shipper, i) => (
            <div key={i} style={{ background: '#1a1d2a', borderRadius: 8, padding: 12, marginTop: 8, display: 'flex', flexDirection: 'column', gap: 8 }}>
              <input placeholder="Name" value={shipper.name || ''} style={inputStyle()}
                onChange={e => { const s=[...editingLoad.shippers]; s[i].name=e.target.value; setEditingLoad({...editingLoad,shippers:s}); }} />
              <input placeholder="Address" value={shipper.address || ''} style={inputStyle()}
                onChange={e => { const s=[...editingLoad.shippers]; s[i].address=e.target.value; setEditingLoad({...editingLoad,shippers:s}); }} />
              <input type="datetime-local" style={inputStyle()}
                value={shipper.pickUpTime ? new Date(shipper.pickUpTime).toISOString().slice(0,-1) : ''}
                onChange={e => { const s=[...editingLoad.shippers]; s[i].pickUpTime=new Date(e.target.value); setEditingLoad({...editingLoad,shippers:s}); }} />
            </div>
          ))}
        </div>

        {/* Consignees */}
        <div style={{ borderTop: '1px solid #2a2d3a', paddingTop: 12 }}>
          <label style={{ ...labelStyle, fontSize: '0.85rem', color: '#34D399', textTransform: 'uppercase', letterSpacing: 1 }}>Consignees</label>
          {editingLoad.consignees.map((consignee, i) => (
            <div key={i} style={{ background: '#1a1d2a', borderRadius: 8, padding: 12, marginTop: 8, display: 'flex', flexDirection: 'column', gap: 8 }}>
              <input placeholder="Name" value={consignee.name || ''} style={inputStyle()}
                onChange={e => { const c=[...editingLoad.consignees]; c[i].name=e.target.value; setEditingLoad({...editingLoad,consignees:c}); }} />
              <input placeholder="Address" value={consignee.address || ''} style={inputStyle()}
                onChange={e => { const c=[...editingLoad.consignees]; c[i].address=e.target.value; setEditingLoad({...editingLoad,consignees:c}); }} />
              <input type="datetime-local" style={inputStyle()}
                value={consignee.deliveryTime ? new Date(consignee.deliveryTime).toISOString().slice(0,-1) : ''}
                onChange={e => { const c=[...editingLoad.consignees]; c[i].deliveryTime=new Date(e.target.value); setEditingLoad({...editingLoad,consignees:c}); }} />
            </div>
          ))}
        </div>

        {/* Delete confirmation */}
        {deleteTarget !== null && (
          <DeleteNotifications
            message="Are you sure you want to delete this load?"
            onConfirm={confirmDeleteLoad}
            onCancel={() => setDeleteTarget(null)}
          />
        )}
      </div>

      {/* ── RIGHT: Documents 60% ── */}
      <div style={{
        width: '60%', display: 'flex', flexDirection: 'column',
        background: '#0f1117', overflow: 'hidden',
      }}>
        {/* Doc list header */}
        <div style={{
          padding: '14px 20px', borderBottom: '1px solid #2a2d3a',
          display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0,
        }}>
          <span style={{ color: '#fff', fontWeight: 600 }}>Linked Documents</span>
          <span style={{
            background: '#60A5FA22', color: '#60A5FA', borderRadius: 20,
            padding: '2px 10px', fontSize: '0.8rem', fontWeight: 600,
          }}>{loadDocuments.length}</span>
        </div>

        {loadDocuments.length === 0 ? (
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#555', flexDirection: 'column', gap: 8 }}>
            
            <span>No documents linked to this load</span>
          </div>
        ) : (
          <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>

            {/* Doc list sidebar */}
            <div style={{
              width: 220, borderRight: '1px solid #2a2d3a',
              overflowY: 'auto', padding: '10px 8px',
              display: 'flex', flexDirection: 'column', gap: 6, flexShrink: 0,
            }}>
              {loadDocuments.map(doc => (
                <button
                  key={doc.id}
                  onClick={() => handleDocPreview(doc)}
                  style={{
                    textAlign: 'left', padding: '10px 12px', borderRadius: 8, border: 'none',
                    cursor: 'pointer', transition: 'background 0.15s',
                    background: selectedDocPreview?.id === doc.id ? '#1e3a5f' : '#1a1d2a',
                    color: selectedDocPreview?.id === doc.id ? '#60A5FA' : '#ccc',
                  }}
                >
                  <div style={{ fontWeight: 600, fontSize: '0.8rem', marginBottom: 3,
                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {doc.title}
                  </div>
                  <div style={{ fontSize: '0.72rem', opacity: 0.6 }}>{doc.docType?.replace(/_/g,' ')}</div>
                </button>
              ))}
            </div>

            {/* Preview area */}
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
              {previewDocUrl ? (
                previewDocMime === 'application/pdf' || previewDocMime?.startsWith('image/') ? (
                  <iframe src={previewDocUrl} style={{ width: '100%', height: '100%', border: 'none' }} title="Doc Preview" />
                ) : (
                  <div style={{ color: '#555', textAlign: 'center' }}>
                    <p>Preview not available</p>
                    <p style={{ fontSize: '0.8rem' }}>Download the file to view it</p>
                  </div>
                )
              ) : (
                <div style={{ color: '#444', textAlign: 'center' }}>
                  
                  <p>Select a document to preview</p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  </div>,
  document.body
)}
<EmailPanel />
    </div>
  );
};


const AccountingManager = () => {
  const { notify } = useNotification();
  const [openInvoices, setOpenInvoices] = useState([]);
  const [sentInvoices, setSentInvoices] = useState([]);
  const [factoringEmail, setFactoringEmail] = useState('');
  const [factoringMessage, setFactoringMessage] = useState('');
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [activeTab, setActiveTab] = useState('open');
  const [isLoading, setIsLoading] = useState(false);
  const [loadDocuments, setLoadDocuments] = useState({});
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const token = sessionStorage.getItem('token');

  const config = {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  };

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  useEffect(() => {
    fetchInvoices();
    fetchFactoringDetails();
  }, []);

const fetchInvoices = async () => {
  setIsLoading(true);
  try {
    const response = await axios.get(`${apiUrl}/invoices`, config);
    const invoices = response.data;

    const sentInvoicesResponse = await axios.get(`${apiUrl}/factoring-invoices`, config);
    const sentIds = new Set(sentInvoicesResponse.data.map(inv => inv.invoiceId.toString()));
    const filteredOpenInvoices = invoices.filter(inv => !sentIds.has(inv._id.toString()));

    setOpenInvoices(filteredOpenInvoices);
    setSentInvoices(sentInvoicesResponse.data);

    // 1. fetch toate load-urile
    const loadsRes = await axios.get(`${apiUrl}/loads`, config);
    const allLoads = loadsRes.data;

    // 2. fetch toate documentele o singura data
    const allDocsRes = await axios.get(`${apiUrl}/documents`, config);
    const allDocs = allDocsRes.data;

    // 3. mapeaza documentele la fiecare invoice dupa loadNumber
    const docsMap = {};
    const allInvoices = [...filteredOpenInvoices, ...sentInvoicesResponse.data];

    allInvoices.forEach((inv) => {
      const invoiceKey = inv._id || inv.invoiceId;

      // gaseste load-ul potrivit
      const matchedLoad = allLoads.find(l =>
        String(l.loadNumber) === String(inv.loadNumber) ||
        String(l._id) === String(inv.loadId) ||
        String(l._id) === String(inv.load)
      );

      if (!matchedLoad) return;

docsMap[invoiceKey] = allDocs.filter(doc =>
  doc.linkedEntity?.entityType === 'load' &&
  String(doc.linkedEntity?.entityId) === String(matchedLoad._id)
);
    });

    setLoadDocuments(docsMap);

  } catch (error) {
    console.error(error);
  } finally {
    setIsLoading(false);
  }
};

  const fetchFactoringDetails = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/factoring`, config);
      if (response.data) {
        setFactoringEmail(response.data.email || '');
        setFactoringMessage(response.data.message || '');
      }
    } catch (error) {
      
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectInvoice = (invoiceId) => {
    setSelectedInvoices((prev) =>
      prev.includes(invoiceId) ? prev.filter((id) => id !== invoiceId) : [...prev, invoiceId]
    );
  };
  const handleDownloadSelectedInvoicesExcel = () => {
    if (selectedInvoices.length === 0) {
      notify("No invoices selected for download!" ,'error');
      return;
    }
  
    const selectedData = openInvoices
      .filter((inv) => selectedInvoices.includes(inv._id))
      .map((inv) => ({
        "Broker Name": inv.brokerName,
        "Invoice Number": inv.invoiceNumber,
        "Invoice Date": inv.invoiceDate ? new Date(inv.invoiceDate).toLocaleDateString() : "Invalid Date",
        "Load Number": inv.loadNumber,
        "Amount": `$${inv.rate ? inv.rate.toFixed(2) : "0.00"}`,
        "Driver Name": inv.driverName || "No data",
        "Notes": inv.notes || "",
      }));
  
    const ws = XLSX.utils.json_to_sheet(selectedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Invoices");
  
    XLSX.writeFile(wb, "Selected_Invoices.xlsx");
  };

const handleSendMultipleFactoringEmails = async () => {
  if (selectedInvoices.length === 0) {
    notify('No invoices selected!', 'error');
    return;
  }

  if (!factoringEmail || !factoringMessage) {
    notify('Factoring email or message missing! Save them first.', 'error');
    return;
  }

  // ✅ Verifică loadDocuments în loc de uploadedFiles
  for (const invoiceId of selectedInvoices) {
    const docs = loadDocuments[invoiceId];
    if (!docs || docs.length === 0) {
      notify(`Invoice ${invoiceId} has no linked documents!`, 'error');
      return;
    }
  }

  setIsLoading(true);

  try {
    for (const invoiceId of selectedInvoices) {
      const invoice = openInvoices.find(inv => inv._id === invoiceId);
      if (!invoice) continue;

      const docs = loadDocuments[invoiceId] || [];

      // ✅ Descarcă fiecare document de pe server și trimite ca atașament
      for (const doc of docs) {
        const downloadUrl = `${apiUrl}/documents/${doc.id}/download?token=${token}`;
        
        const fileResponse = await axios.get(downloadUrl, {
          ...config,
          responseType: 'arraybuffer',
        });

        const base64 = btoa(
          new Uint8Array(fileResponse.data).reduce(
            (data, byte) => data + String.fromCharCode(byte), ''
          )
        );

        await axios.post(`${apiUrl}/email/send-with-attachment`, {
          to: factoringEmail,
          subject: `Invoice #${invoice.invoiceNumber} - Load #${invoice.loadNumber}`,
          body: `<p>${factoringMessage}</p>
                 <p><strong>Invoice #${invoice.invoiceNumber}</strong><br/>
                 Load #${invoice.loadNumber}<br/>
                 Broker: ${invoice.brokerName}<br/>
                 Amount: $${invoice.rate?.toFixed(2)}</p>`,
          attachment: {
            data: base64,
            filename: doc.fileName,
            mimeType: doc.mimeType || 'application/pdf',
          }
        }, config);
      }

      // Marchează invoice-ul ca trimis
      await axios.post(`${apiUrl}/factoring-invoices`, {
        invoiceId: invoice._id,
        brokerName: invoice.brokerName,
        invoiceNumber: invoice.invoiceNumber,
        invoiceDate: invoice.invoiceDate,
        loadNumber: invoice.loadNumber,
        rate: invoice.rate,
        driverName: invoice.driverName,
        notes: invoice.notes,
      }, config);
    }

    setSelectedInvoices([]);
    setUploadedFiles({});
    notify('Invoices sent via Gmail!', 'success');
    fetchInvoices();
  } catch (error) {
    console.error(error);
    notify('Failed to send invoices.', 'error');
  } finally {
    setIsLoading(false);
  }
};

  const handleFileUpload = (event, invoiceId) => {
    const files = event.target.files;
    if (!files.length) return;

    setUploadedFiles((prev) => ({
      ...prev,
      [invoiceId]: [...(prev[invoiceId] || []), ...Array.from(files)],
    }));
  };

  const handleTabChange = async (tab) => {
    setIsLoading(true);
  
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("tab", tab);
    window.history.pushState({}, "", newUrl.toString());
  
    setActiveTab(tab);
  
    if (tab === "open") {
      await fetchInvoices(); // ✅ Reîncarcă ambele liste pentru a evita duplicarea!
    }
  
    setTimeout(() => setIsLoading(false), 1000);
  };
  
  
  

  return (
   <div
  className={`${styles.ultimateaccountingManager} ${
    theme === "light" ? styles.ultimateaccountingManagerLight : ""
  }`}
>

      <h2>Accounting Manager</h2>

      {/* ✅ Loader pentru toate acțiunile */}
      <Loader isLoading={isLoading} text="Loading..." />

      <div className={styles.tabContainerultimateaccountingManager}>
        <button className={activeTab === 'open' ? styles.activeTabultimateaccountingManager : ''} onClick={() => handleTabChange('open')}>
          Open Invoices
        </button>
        <button className={activeTab === 'sent' ? styles.activeTabultimateaccountingManager : ''} onClick={() => handleTabChange('sent')}>
          Sent Invoices
        </button>
      </div>

      <div className={styles.factoringSectionultimateaccountingManager}>
        <h3>Factoring Details</h3>
        <input
          type="email"
          placeholder="Enter Factoring Email"
          value={factoringEmail}
          onChange={(e) => setFactoringEmail(e.target.value)}
          className={styles.inputFieldultimateaccountingManager}
        />
        <textarea
          placeholder="Enter Message"
          value={factoringMessage}
          onChange={(e) => setFactoringMessage(e.target.value)}
          className={styles.textareaFieldultimateaccountingManager}
        />
      </div>

      {/* ✅ Buton pentru trimiterea invoice-urilor selectate */}
<button
  onClick={handleSendMultipleFactoringEmails}
  disabled={selectedInvoices.length === 0 || isLoading}
  className={styles.sendFactoringButtonultimateaccountingManager}
>
  {isLoading ? "Sending..." : "Send Selected Invoices to Factoring"}
</button>

{/* ✅ Buton pentru descărcarea invoice-urilor selectate ca Excel */}
<button
  onClick={handleDownloadSelectedInvoicesExcel}
  disabled={selectedInvoices.length === 0}
  className={styles.downloadExcelButtonultimateaccountingManager}
>
  Download Selected Invoices to Excel
</button>


      {activeTab === 'open' ? (
        <table className={styles.invoiceTableultimateaccountingManager}>
          <thead>
            <tr>
              <th></th>
              <th>DEBNAME</th>
              <th>INV_ID</th>
              <th>INV_DATE</th>
              <th>PO_NO</th>
              <th>INVAMT</th>
              <th>Name</th>
              <th>Additional Note</th>
              <th>Documents</th>
            </tr>
          </thead>
          <tbody>
            {openInvoices.map((invoice) => (
              <tr key={invoice._id}>
                <td>
                  <input type="checkbox" checked={selectedInvoices.includes(invoice._id)} onChange={() => handleSelectInvoice(invoice._id)} />
                </td>
                <td>{invoice.brokerName}</td>
                <td>{invoice.invoiceNumber}</td>
                <td>{invoice.invoiceDate ? new Date(invoice.invoiceDate).toLocaleDateString() : 'Invalid Date'}</td>
                <td>{invoice.loadNumber}</td>
                <td>${invoice.rate ? invoice.rate.toFixed(2) : '0.00'}</td>
                <td>{invoice.driverName || 'No data'}</td>
                <td>{invoice.notes || ''}</td>
                <td>
  {loadDocuments[invoice._id]?.length > 0 ? (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {loadDocuments[invoice._id].map(doc => (
        <div key={doc.id} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '0.78rem' }}>
          <span style={{
            padding: '2px 7px', borderRadius: 4, fontSize: '0.68rem', fontWeight: 700,
            background: 'rgba(96,165,250,0.15)', color: '#60A5FA',
          }}>
            {doc.docType?.replace(/_/g, ' ').toUpperCase()}
          </span>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 130 }}>
            {doc.title}
          </span>
          <button
            type="button"
            onClick={() => window.open(`${apiUrl}/documents/${doc.id}/download?token=${token}`, '_blank')}
            style={{
              padding: '2px 8px', borderRadius: 4, border: 'none', cursor: 'pointer',
              background: 'rgba(52,211,153,0.15)', color: '#34D399',
              fontSize: '0.7rem', fontWeight: 700,
            }}
          >
            View
          </button>
        </div>
      ))}
    </div>
  ) : (
    <span style={{ color: '#444', fontSize: '0.75rem' }}>No documents linked</span>
  )}
</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <table className={styles.invoiceTableultimateaccountingManager}>
          <thead>
            <tr>
              <th>DEBNAME</th>
              <th>INV_ID</th>
              <th>INV_DATE</th>
              <th>PO_NO</th>
              <th>INVAMT</th>
              <th>Name</th>
              <th>Additional Note</th>
            </tr>
          </thead>
          <tbody>
            {sentInvoices.map((invoice) => (
              <tr key={invoice.invoiceId}>
                <td>{invoice.brokerName}</td>
                <td>{invoice.invoiceNumber}</td>
                <td>{new Date(invoice.invoiceDate).toLocaleDateString()}</td>
                <td>{invoice.loadNumber}</td>
                <td>${invoice.rate.toFixed(2)}</td>
                <td>{invoice.driverName || 'No data'}</td>
                <td>{invoice.notes || ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <EmailPanel />
    </div>
  );
};

const DriverPayManager = () => {
  const [driverPays, setDriverPays] = useState([]);
  const [filteredPays, setFilteredPays] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedPays, setSelectedPays] = useState([]);
  const [selectedPay, setSelectedPay] = useState(null);
const [drivers, setDrivers] = useState([]);
const [selectedDriverId, setSelectedDriverId] = useState("");
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);
  const token = sessionStorage.getItem("token");

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  useEffect(() => {
    const fetchAllPays = async () => {
      try {
        const res = await axios.get(
          "https://api-backend.full-trucking-service.com/api/driverpays?limit=200",
          config
        );

        const list = res.data?.data || [];
        setDriverPays(list);
        setFilteredPays(list);
      } catch (err) {
        setDriverPays([]);
        setFilteredPays([]);
      }
    };

    fetchAllPays();
  }, []);

  useEffect(() => {
  const fetchDrivers = async () => {
    try {
      const res = await axios.get(
        "https://api-backend.full-trucking-service.com/api/drivers",
        config
      );
      setDrivers(res.data || []);
    } catch (err) {
      setDrivers([]);
    }
  };

  fetchDrivers();
}, []);
useEffect(() => {
  let data = [...driverPays];

  // Filter by driver
  if (selectedDriverId) {
    data = data.filter(p => p.driverId?._id === selectedDriverId);
  }

  // Filter by date
  if (startDate) {
    data = data.filter(p => new Date(p.startDate) >= new Date(startDate));
  }

  if (endDate) {
    data = data.filter(p => new Date(p.endDate) <= new Date(endDate));
  }

  // Search ONLY settlement number
  if (searchTerm) {
    const term = searchTerm.toLowerCase();
    data = data.filter(p =>
      (p.settlementNumber || "")
        .toLowerCase()
        .includes(term)
    );
  }

  setFilteredPays(data);

}, [searchTerm, startDate, endDate, selectedDriverId, driverPays]);


  const toggleSelect = (id) => {
    setSelectedPays(prev =>
      prev.includes(id)
        ? prev.filter(i => i !== id)
        : [...prev, id]
    );
  };

const generateExistingPDF = (pay) => {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "letter" });

  const {
    payDetails = [],
    totalPay = 0,
    totalWithAdjustments = 0,
    recurringAddition = [],
    recurringDeduction = [],
    pdfSettings = {},
    settlementNumber: settNum = "",
    companyName = "",
    logo: payLogo = null,
  } = pay;

  const driver = pay.driverId || {};

  const {
    settlementSubtitle = "",
    extraHeaderLine = "",
    showSettlementNumber = true,
    showDriverNumber = true,
    showTruckNumber = true,
    showPhone = true,
    showEmail = true,
  } = pdfSettings;

  const today = pay.paymentDate
    ? new Date(pay.paymentDate).toISOString().split("T")[0]
    : new Date().toISOString().split("T")[0];

  // ─── DESIGN TOKENS ────────────────────────────────────────────────────────
  const COLOR = {
    navy:      [10,  31,  68],
    navyLight: [22,  54, 110],
    gold:      [212, 160,  23],
    white:     [255, 255, 255],
    offWhite:  [248, 249, 252],
    lightGray: [230, 234, 241],
    midGray:   [150, 162, 180],
    darkText:  [18,  28,  48],
    greenPay:  [15, 118,  82],
    redDed:    [185,  28,  28],
    blueSub:   [37,  99, 235],
  };

  const PAGE_W = 215.9;
  const PAGE_H = 279.4;
  const MARGIN = 14;

  const setFill  = (c) => doc.setFillColor(...c);
  const setColor = (c) => doc.setTextColor(...c);
  const setFont  = (size, style = "normal") => {
    doc.setFontSize(size);
    doc.setFont("helvetica", style);
  };
  const hRule = (y, color = COLOR.gold, thickness = 0.6) => {
    doc.setDrawColor(...color);
    doc.setLineWidth(thickness);
    doc.line(MARGIN, y, PAGE_W - MARGIN, y);
  };

  // ─── HEADER ───────────────────────────────────────────────────────────────
  const addHeader = () => {
    setFill(COLOR.navy);
    doc.rect(0, 0, PAGE_W, 42, "F");
    setFill(COLOR.gold);
    doc.rect(0, 41, PAGE_W, 1.5, "F");

    // Logo — din pay.logo (salvat la momentul creării)
    if (payLogo && typeof payLogo === "string") {
      doc.addImage(payLogo, "PNG", MARGIN, 7, 48, 22);
    }

    setColor(COLOR.white); setFont(18, "bold");
    doc.text("DRIVER SETTLEMENT", PAGE_W - MARGIN, 17, { align: "right" });

    if (settlementSubtitle) {
      setFont(8); setColor(COLOR.gold);
      doc.text(settlementSubtitle.toUpperCase(), PAGE_W - MARGIN, 23, { align: "right" });
    }

    if (showSettlementNumber && settNum) {
      setFill(COLOR.gold);
      doc.roundedRect(PAGE_W - MARGIN - 52, 27, 52, 10, 2, 2, "F");
      setColor(COLOR.navy); setFont(7, "bold");
      doc.text(`SETTLEMENT #  ${settNum}`, PAGE_W - MARGIN - 26, 33.2, { align: "center" });
    }

    const infoY = 52;
    const col2  = 115;

    const leftRows = [
      ["Driver Name",   `${driver.firstName || ""} ${driver.lastName || ""}`.trim()],
      ["Address",       driver.address || "N/A"],
      ["Pay Period",    `${new Date(pay.startDate).toLocaleDateString()}  –  ${new Date(pay.endDate).toLocaleDateString()}`],
      ["Payment Date",  today],
    ];

    const rightRows = [];
    if (showDriverNumber) rightRows.push(["Driver #", driver.driverNumber || "N/A"]);
    if (showTruckNumber)  rightRows.push(["Truck #",  driver.truckNumber  || "N/A"]);
    if (showPhone)        rightRows.push(["Phone",    driver.phone        || ""]);
    if (showEmail)        rightRows.push(["Email",    driver.email        || ""]);

    let ly = infoY;
    leftRows.forEach(([label, value]) => {
      setFont(7, "bold"); setColor(COLOR.midGray);
      doc.text(label.toUpperCase(), MARGIN, ly);
      setFont(8.5, "normal"); setColor(COLOR.darkText);
      doc.text(String(value), MARGIN, ly + 4.5);
      ly += 11;
    });

    let ry = infoY;
    rightRows.forEach(([label, value]) => {
      setFont(7, "bold"); setColor(COLOR.midGray);
      doc.text(label.toUpperCase(), col2, ry);
      setFont(8.5, "normal"); setColor(COLOR.darkText);
      doc.text(String(value), col2, ry + 4.5);
      ry += 11;
    });

    if (extraHeaderLine) {
      setFont(8); setColor(COLOR.midGray);
      doc.text(extraHeaderLine, MARGIN, ly + 2);
      ly += 8;
    }

    hRule(ly + 2);
    return ly + 8;
  };

  // ─── FOOTER ───────────────────────────────────────────────────────────────
  const addFooter = () => {
    const pageCount = doc.internal.getNumberOfPages();
    const fY = PAGE_H - 18;

    setFill(COLOR.gold);
    doc.rect(0, fY - 2, PAGE_W, 0.8, "F");
    setFill(COLOR.navy);
    doc.rect(0, fY - 1.2, PAGE_W, 20, "F");

setColor(COLOR.white); setFont(7);
    doc.text("Thank you for your business!", PAGE_W / 2, fY + 3, { align: "center" });
    doc.text(
      `${companyName}`,
      PAGE_W / 2, fY + 8, { align: "center" }
    );

    setColor(COLOR.gold); setFont(6);
    doc.text("Powered by Full Trucking Service - FTS", PAGE_W / 2, fY + 13, { align: "center" });

    setColor(COLOR.midGray); setFont(7);
    doc.text(`Page ${pageCount}`, PAGE_W - MARGIN, fY + 4, { align: "right" });
  };

  // ─── BODY ─────────────────────────────────────────────────────────────────
  let startY = addHeader();

  const sectionTitle = (label, y) => {
    setFill(COLOR.navyLight);
    doc.roundedRect(MARGIN, y, PAGE_W - MARGIN * 2, 7, 1.5, 1.5, "F");
    setColor(COLOR.gold); setFont(8, "bold");
    doc.text(label.toUpperCase(), MARGIN + 4, y + 4.8);
    return y + 10;
  };

  // ── LOADS ─────────────────────────────────────────────────────────────────
  startY = sectionTitle("Load Details", startY);

  payDetails.forEach((detail, index) => {
    if (startY > PAGE_H - 60) {
      addFooter(); doc.addPage();
      startY = addHeader();
      startY = sectionTitle("Load Details (continued)", startY);
    }

    const pickupDetails = detail.shippers?.length > 0
      ? detail.shippers.map((s) => {
          const dt = !s.pickUpTime || isNaN(new Date(s.pickUpTime).getTime())
            ? "Unknown Date"
            : new Date(s.pickUpTime).toLocaleString();
          return `${dt}  —  ${s.address || "No data"}`;
        }).join("\n")
      : "No data";

    const deliveryDetails = detail.consignees?.length > 0
      ? detail.consignees.map((c) => {
          const dt = !c.deliveryTime || isNaN(new Date(c.deliveryTime).getTime())
            ? "Unknown Date"
            : new Date(c.deliveryTime).toLocaleString();
          return `${dt}  —  ${c.address || "No data"}`;
        }).join("\n")
      : "No data";

    doc.autoTable({
      startY,
      body: [
        [{ content: `LOAD  #${detail.loadNumber || index + 1}`, colSpan: 3, styles: { fontStyle: "bold", fontSize: 8, fillColor: COLOR.offWhite, textColor: COLOR.navy, cellPadding: { top: 3, bottom: 3, left: 4, right: 4 } } }],
        [{ content: "Pickup",   styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.white, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } }, { content: pickupDetails,   colSpan: 2, styles: { halign: "left", fillColor: COLOR.white, textColor: COLOR.darkText, fontSize: 7.5 } }],
        [{ content: "Delivery", styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.white, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } }, { content: deliveryDetails, colSpan: 2, styles: { halign: "left", fillColor: COLOR.white, textColor: COLOR.darkText, fontSize: 7.5 } }],
        [{ content: "Rate",     styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.white, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } }, { content: `$${Number(detail.rate || 0).toFixed(2)}`, styles: { halign: "left", fillColor: COLOR.white, textColor: COLOR.darkText, fontSize: 7.5 } }, { content: "", styles: { fillColor: COLOR.white } }],
        [{ content: "Notes",    styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.offWhite, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } }, { content: detail.notes || "—", styles: { fillColor: COLOR.offWhite, textColor: COLOR.darkText, fontSize: 7.5 } }, { content: `$${Number(detail.pay || 0).toFixed(2)}`, styles: { fontStyle: "bold", halign: "right", fillColor: COLOR.offWhite, textColor: COLOR.greenPay, fontSize: 9 } }],
      ],
      theme: "plain",
      styles: { lineColor: COLOR.lightGray, lineWidth: 0.35, cellPadding: 2.5 },
      margin: { left: MARGIN, right: MARGIN },
      tableLineColor: COLOR.lightGray, tableLineWidth: 0.35,
    });

    startY = doc.lastAutoTable.finalY + 5;
  });

  // ── SUB-TOTAL ──────────────────────────────────────────────────────────────
  startY += 4;
  doc.autoTable({
    startY,
    body: [[
      { content: "Sub-Total", styles: { fontStyle: "bold", fontSize: 9, textColor: COLOR.darkText } },
      { content: `$${Number(totalPay).toFixed(2)}`, styles: { fontStyle: "bold", halign: "right", fontSize: 10, textColor: COLOR.blueSub } },
    ]],
    theme: "plain",
    styles: { fillColor: COLOR.offWhite, lineColor: COLOR.lightGray, lineWidth: 0.35, cellPadding: { top: 4, bottom: 4, left: 5, right: 5 } },
    margin: { left: MARGIN, right: MARGIN },
    tableLineColor: COLOR.lightGray, tableLineWidth: 0.35,
  });
  startY = doc.lastAutoTable.finalY + 8;

  // ── ADDITIONS ─────────────────────────────────────────────────────────────
  const additionsForPdf = [
    ...(recurringAddition || []),
    ...(pay.manualAdditions || []),
  ].map(a => ({
    type: a.type || "Other",
    description: a.description || "",
    date: a.date || "",
    amount: parseFloat(a.amount || 0),
    notes: a.notes || "",
  }));

  const deductionsForPdf = [
    ...(recurringDeduction || []),
    ...(pay.manualDeductions || []),
  ].map(d => ({
    type: d.type || "Other",
    description: d.description || "",
    date: d.date || "",
    amount: parseFloat(d.amount || 0),
    notes: d.notes || "",
  }));

  if (startY > PAGE_H - 70) { addFooter(); doc.addPage(); startY = addHeader(); }
  startY = sectionTitle("Additions", startY);
  doc.autoTable({
    startY,
    head: [[
      { content: "Type / Description / Date", styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
      { content: "Notes",                     styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
      { content: "Amount",                    styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5, halign: "right" } },
    ]],
    body: additionsForPdf.length > 0
      ? additionsForPdf.map(a => [
          { content: `${a.type}  ·  ${a.description}  ·  ${a.date}`, styles: { fontSize: 7.5, textColor: COLOR.darkText } },
          { content: a.notes, styles: { fontSize: 7.5, textColor: COLOR.midGray } },
          { content: `+$${a.amount.toFixed(2)}`, styles: { fontSize: 7.5, halign: "right", textColor: COLOR.greenPay, fontStyle: "bold" } },
        ])
      : [[{ content: "No additions", colSpan: 3, styles: { halign: "center", textColor: COLOR.midGray, fontSize: 7.5, fontStyle: "italic" } }]],
    theme: "grid",
    styles: { lineColor: COLOR.lightGray, lineWidth: 0.3, cellPadding: 2.5, fontSize: 7.5 },
    alternateRowStyles: { fillColor: COLOR.offWhite },
    headStyles: { fillColor: COLOR.navy },
    margin: { left: MARGIN, right: MARGIN },
  });
  startY = doc.lastAutoTable.finalY + 8;

  // ── DEDUCTIONS ────────────────────────────────────────────────────────────
  if (startY > PAGE_H - 70) { addFooter(); doc.addPage(); startY = addHeader(); }
  startY = sectionTitle("Deductions", startY);
  doc.autoTable({
    startY,
    head: [[
      { content: "Type / Description / Date", styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
      { content: "Notes",                     styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
      { content: "Amount",                    styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5, halign: "right" } },
    ]],
    body: deductionsForPdf.length > 0
      ? deductionsForPdf.map(d => [
          { content: `${d.type}  ·  ${d.description}  ·  ${d.date}`, styles: { fontSize: 7.5, textColor: COLOR.darkText } },
          { content: d.notes, styles: { fontSize: 7.5, textColor: COLOR.midGray } },
          { content: `-$${d.amount.toFixed(2)}`, styles: { fontSize: 7.5, halign: "right", textColor: COLOR.redDed, fontStyle: "bold" } },
        ])
      : [[{ content: "No deductions", colSpan: 3, styles: { halign: "center", textColor: COLOR.midGray, fontSize: 7.5, fontStyle: "italic" } }]],
    theme: "grid",
    styles: { lineColor: COLOR.lightGray, lineWidth: 0.3, cellPadding: 2.5, fontSize: 7.5 },
    alternateRowStyles: { fillColor: [255, 248, 248] },
    headStyles: { fillColor: COLOR.navy },
    margin: { left: MARGIN, right: MARGIN },
  });
  startY = doc.lastAutoTable.finalY + 10;

  // ── GRAND TOTAL ────────────────────────────────────────────────────────────
  if (startY > PAGE_H - 40) { addFooter(); doc.addPage(); startY = addHeader(); }

  setFill(COLOR.gold);
  doc.rect(MARGIN, startY, PAGE_W - MARGIN * 2, 0.8, "F");
  startY += 4;

  doc.autoTable({
    startY,
    body: [[
      { content: "GRAND TOTAL — NET PAY", styles: { fontStyle: "bold", fontSize: 11, textColor: COLOR.white, fillColor: COLOR.navy, cellPadding: { top: 5, bottom: 5, left: 6, right: 6 } } },
      { content: `$${Number(totalWithAdjustments).toFixed(2)}`, styles: { fontStyle: "bold", fontSize: 14, halign: "right", textColor: COLOR.gold, fillColor: COLOR.navy, cellPadding: { top: 4, bottom: 4, left: 6, right: 6 } } },
    ]],
    theme: "plain",
    margin: { left: MARGIN, right: MARGIN },
    tableLineWidth: 0,
  });

  const finalY = doc.lastAutoTable.finalY;
  setFill(COLOR.gold);
  doc.rect(MARGIN, finalY, PAGE_W - MARGIN * 2, 1.2, "F");

  // ── SIGNATURE BLOCK ────────────────────────────────────────────────────────
  const sigY = finalY + 14;
  if (sigY < PAGE_H - 35) {
    setFont(7.5); setColor(COLOR.midGray);
    doc.line(MARGIN + 30, sigY, MARGIN + 95, sigY);
    doc.line(MARGIN + 115, sigY, MARGIN + 155, sigY);
  }

  addFooter();
  doc.save(`Settlement_${settNum || "report"}.pdf`);
};

  return (
   <div className={styles.DriverPayManagerSection} data-theme={theme}>

      {/* HEADER */}
      <div className={styles.DriverPayManagerHeader}>
        <h2 className={styles.DriverPayManagerTitle}>
          Driver Pay Manager
        </h2>
        <span className={styles.DriverPayManagerCount}>
          {filteredPays.length} Settlements
        </span>
      </div>

      {/* FILTER BAR */}
      <div className={styles.DriverPayManagerFilterBar}>
        <input
          className={styles.DriverPayManagerSearchInput}
          placeholder="Search Settlement Number..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
<select
  className={styles.DriverPayManagerSelect}
  value={selectedDriverId}
  onChange={(e) => setSelectedDriverId(e.target.value)}
>
  <option value="">All Drivers</option>
  {drivers.map(d => (
    <option key={d._id} value={d._id}>
      {d.firstName} {d.lastName}
    </option>
  ))}
</select>

        <input
          className={styles.DriverPayManagerDateInput}
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />

        <input
          className={styles.DriverPayManagerDateInput}
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />

        <button
          className={styles.DriverPayManagerExportButton}
          disabled={!selectedPays.length}
        >
          Export Selected
        </button>
      </div>

      {/* TABLE */}
      <div className={styles.DriverPayManagerTableWrapper}>
        <table className={styles.DriverPayManagerTable}>
          <thead>
            <tr>
              <th></th>
              <th>Settlement</th>
              <th>Driver</th>
              <th>Truck</th>
              <th>Start</th>
              <th>End</th>
              <th>Loads</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {filteredPays.map(pay => (
              <tr
                key={pay._id}
                className={styles.DriverPayManagerRow}
                onClick={() => setSelectedPay(pay)}
              >
                <td
                  className={styles.DriverPayManagerCheckboxCell}
                  onClick={(e) => e.stopPropagation()}
                >
                  <input
                    type="checkbox"
                    checked={selectedPays.includes(pay._id)}
                    onChange={() => toggleSelect(pay._id)}
                  />
                </td>

                <td className={styles.DriverPayManagerSettlement}>
                  {pay.settlementNumber}
                </td>

                <td>
                  {pay.driverId
                    ? `${pay.driverId.firstName} ${pay.driverId.lastName}`
                    : ""}
                </td>

                <td>
  {pay.driverId?.truckNumber
    ? pay.driverId.truckNumber
    : pay.truckId?.truckNumber || ""}
</td>


                <td>{new Date(pay.startDate).toLocaleDateString()}</td>
                <td>{new Date(pay.endDate).toLocaleDateString()}</td>

                <td>
                  {Array.isArray(pay.payDetails)
                    ? pay.payDetails.length
                    : 0}
                </td>

                <td className={styles.DriverPayManagerTotal}>
                  ${Number(pay.totalWithAdjustments || 0).toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {selectedPay && (
        <div className={styles.DriverPayManagerModalOverlay}>
          <div className={styles.DriverPayManagerModal}>

            <div className={styles.DriverPayManagerModalHeader}>
              <h3>
                Settlement #{selectedPay.settlementNumber}
              </h3>
              <button
                className={styles.DriverPayManagerCloseButton}
                onClick={() => setSelectedPay(null)}
              >
                ✕
              </button>
            </div>

            <div className={styles.DriverPayManagerModalContent}>

              <div className={styles.DriverPayManagerModalInfo}>
                <button
  className={styles.DriverPayManagerDownloadButton}
  onClick={() => generateExistingPDF(selectedPay)}
>
  Download PDF
</button>

                <p>
                  <strong>Driver:</strong>{" "}
                  {selectedPay.driverId?.firstName}{" "}
                  {selectedPay.driverId?.lastName}
                </p>

               <p>
  <strong>Truck:</strong>{" "}
  {selectedPay.driverId?.truckNumber
    ? selectedPay.driverId.truckNumber
    : selectedPay.truckId?.truckNumber || "-"}
</p>

                <p>
                  <strong>Period:</strong>{" "}
                  {new Date(selectedPay.startDate).toLocaleDateString()}
                  {" - "}
                  {new Date(selectedPay.endDate).toLocaleDateString()}
                </p>

                <p className={styles.DriverPayManagerModalTotal}>
                  <strong>Total:</strong>{" "}
                  ${Number(selectedPay.totalWithAdjustments).toFixed(2)}
                </p>
              </div>

         <h4 className={styles.DriverPayManagerLoadsTitle}>
  Loads
</h4>

{Array.isArray(selectedPay.payDetails) &&
  selectedPay.payDetails.map((l, i) => {

    const pickupList = Array.isArray(l.shippers) ? l.shippers : [];
    const deliveryList = Array.isArray(l.consignees) ? l.consignees : [];

    return (
      <div
        key={i}
        className={styles.DriverPayManagerLoadCard}
      >
        <div className={styles.DriverPayManagerLoadHeader}>
          <strong>Load #:</strong> {l.loadNumber}
        </div>

        <div className={styles.DriverPayManagerLoadGrid}>

          {/* PICKUP */}
          <div>
            <strong>Pickup:</strong>
            {pickupList.length > 0 ? (
              pickupList.map((p, idx) => (
                <div key={idx} className={styles.DriverPayManagerAddressBlock}>
                  <div>{p.address || "-"}</div>
                  <div className={styles.DriverPayManagerDate}>
                    {p.pickUpTime
                      ? new Date(p.pickUpTime).toLocaleString()
                      : "-"}
                  </div>
                </div>
              ))
            ) : (
              <div>-</div>
            )}
          </div>

          {/* DELIVERY */}
          <div>
            <strong>Delivery:</strong>
            {deliveryList.length > 0 ? (
              deliveryList.map((d, idx) => (
                <div key={idx} className={styles.DriverPayManagerAddressBlock}>
                  <div>{d.address || "-"}</div>
                  <div className={styles.DriverPayManagerDate}>
                    {d.deliveryTime
                      ? new Date(d.deliveryTime).toLocaleString()
                      : "-"}
                  </div>
                </div>
              ))
            ) : (
              <div>-</div>
            )}
          </div>

        </div>

        <div className={styles.DriverPayManagerLoadFooter}>
          <span><strong>Rate:</strong> ${l.rate}</span>
          <span><strong>Miles:</strong> {l.miles}</span>
          <span><strong>DH:</strong> {l.dh}</span>
          <span><strong>Pay:</strong> ${l.pay}</span>
        </div>

      </div>
    );
  })}

            </div>

          </div>
        </div>
      )}
      <EmailPanel />
    </div>
  );
};



const DriverPay = ({ drivers, trucks, loads, onAddDriverPay }) => {
  const payrollDrivers = Array.isArray(drivers)
  ? drivers.filter(
      d =>
        d.driverType === 'employee' ||
        d.driverType === 'owner_operator'
    )
  : [];

  const { notify } = useNotification();
  
  const [selectedTruck, setSelectedTruck] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedLoads, setSelectedLoads] = useState([]);
  const [recurringDeductions, setRecurringDeductions] = useState([]);
  const [recurringAdditions, setRecurringAdditions] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState(null);
const [selectedDriver, setSelectedDriver] = useState(null);
const [settlementNumber, setSettlementNumber] = useState("");
const [autoGenerateSettlement, setAutoGenerateSettlement] = useState(true);
// PDF Display Settings
const [showSettlementNumber, setShowSettlementNumber] = useState(true);
const [showDriverNumber, setShowDriverNumber] = useState(true);
const [showTruckNumber, setShowTruckNumber] = useState(true);
const [showPhone, setShowPhone] = useState(true);
const [showEmail, setShowEmail] = useState(true);

const [settlementSubtitle, setSettlementSubtitle] = useState('');
const [extraHeaderLine, setExtraHeaderLine] = useState('');
const [pdfSettingsOpen, setPdfSettingsOpen] = useState(false);
const [pdfSettingsModalOpen, setPdfSettingsModalOpen] = useState(false);
const [paymentDate, setPaymentDate] = useState(
  new Date().toISOString().split("T")[0]
);


const [truckCosts, setTruckCosts] = useState([]);
const itemStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "6px",
  padding: "6px 8px",
  border: "1px solid #333",
  borderRadius: "6px",
  fontSize: "12px",
};

const truckCostDeductions = truckCosts.filter(
  cost => cost.type === "deduction"
);

const truckCostAdditions = truckCosts.filter(
  cost => cost.type === "addition"
);

const [ownerFuelDeductions, setOwnerFuelDeductions] = useState([]);
const [manualDeductions, setManualDeductions] = useState([]);
const [manualAdditions, setManualAdditions] = useState([]);

const manualDeductionTypes = [
  "Fuel",
  "Maintenance",
  "Insurance",
  "Cash Advance",
  "IFTA",
  "Tolls",
  "ELD",
  "Trailer Rent",
  "Truck Payment",
  "Repair",
  "Advance",
  "Other",
];

const manualAdditionTypes = [
  "Bonus",
  "Referral",
  "Reimbursement",
  "Detention",
  "Layover",
  "Extra Stop",
  "Safety Bonus",
  "Clean Inspection Bonus",
  "Other",
];
const isLocked = (item) =>
  item.source === "truck-cost" || item.source === "fuel";

const employerDrivers = Array.isArray(drivers)
  ? drivers.filter(d => d.driverType === 'employee')
  : [];

const ownerOperators = Array.isArray(drivers)
  ? drivers.filter(d => d.driverType === 'owner_operator')
  : [];


  const [clientInfo, setClientInfo] = useState({
    companyName: '',
    companyAddress: '',
    email: '',
    phone: '',
  });

  const [logo, setLogo] = useState(null);
  const [customFooterText, setCustomFooterText] = useState('');
  const [useCustomFooter, setUseCustomFooter] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);
const getNextMonday = (date = new Date()) => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = (8 - day) % 7 || 7; // luni următoare
  d.setDate(d.getDate() + diff);
  return d;
};

useEffect(() => {
  const fetchOwnerAssetCosts = async () => {
    if (
      !selectedDriver ||
      selectedDriver.driverType !== "owner_operator"
    ) {
      setTruckCosts([]);
      return;
    }

    try {
      const res = await axios.get(
        `https://api-backend.full-trucking-service.com/api/asset-costs/by-owner-driver/${selectedDriver._id}`,
        config
      );

      console.log("🧾 OWNER ASSET COSTS:", res.data);
      setTruckCosts(res.data || []);
    } catch (err) {
      console.error("❌ Failed to fetch owner asset costs", err);
      setTruckCosts([]);
    }
  };

  fetchOwnerAssetCosts();
}, [selectedDriver]);



const formatAssetCostProgress = (cost) => {
  if (cost.paymentType !== "recurring") return "";

  const total = cost.recurrence?.occurrences;

  // forever
  if (!total) return "";

  const paid = Array.isArray(cost.payments)
    ? cost.payments.filter(p => p.status === "paid").length
    : 0;

  const current = paid + 1;
  const totalAmount = Number(cost.amount || 0) * total;

  return ` ${current}/${total} from $${totalAmount.toFixed(2)}`;
};


  // Configurația pentru autentificare
  const token = sessionStorage.getItem('token');
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

useEffect(() => {
  const fetchOwnerFuel = async () => {
    console.log("🔥 FETCH OWNER FUEL – EFFECT TRIGGERED", {
      selectedDriver,
      driverType: selectedDriver?.driverType,
      isOwnerOperator: selectedDriver?.isOwnerOperator,
      startDate,
      endDate,
    });

    // GUARD
    if (
      !selectedDriver ||
      !startDate ||
      !endDate ||
      (selectedDriver.driverType !== "owner_operator" &&
        !selectedDriver.isOwnerOperator)
    ) {
      console.log("⛔ GUARD BLOCKED – CONDITIONS NOT MET");
      setOwnerFuelDeductions([]);
      return;
    }

    console.log("✅ PASSED GUARD – FETCHING FUEL");

    try {
      console.log("➡️ SENDING FUEL REQUEST WITH PARAMS:", {
        driverId: selectedDriver._id,
        startDate,
        endDate,
      });

      const res = await axios.get(
        "https://api-backend.full-trucking-service.com/api/fuel-reports/owner/open-by-driver",
        {
          params: {
            driverId: selectedDriver._id,
            startDate,
            endDate,
          },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      console.log("🟢 FUEL RESPONSE FROM BACKEND:", res.data);
      console.log("🟢 FUEL RESPONSE LENGTH:", res.data?.length);

      const fuelRows = (res.data || []).map((f) => ({
        type: "Fuel",
        description: `Fuel – ${f.merchant || "Unknown"} – ${new Date(
          f.transactionDate
        ).toLocaleDateString()}`,
        amount: Number(f.totalToPay || 0),
        date: new Date(f.transactionDate).toISOString().split("T")[0],
        source: "fuel",
        fuelReportId: f._id,
      }));

      console.log("🧩 MAPPED FUEL ROWS:", fuelRows);

      setOwnerFuelDeductions(fuelRows);
      console.log("📦 SET ownerFuelDeductions:", fuelRows.length);
    } catch (err) {
      console.error("❌ FAILED TO FETCH OWNER FUEL", err);
      setOwnerFuelDeductions([]);
    }
  };

  fetchOwnerFuel();
}, [selectedDriver, startDate, endDate]);


useEffect(() => {
  if (autoGenerateSettlement) {
    const generated = `ST-${Date.now()}`;
    setSettlementNumber(generated);
  }
}, [autoGenerateSettlement]);


const markAssetCostsAsPaid = async () => {
  const assetCostIds = [
    ...recurringDeductions,
    ...recurringAdditions,
  ]
    .filter(i => i.source === "truck-cost" && i.assetCostId)
    .map(i => i.assetCostId);

  if (assetCostIds.length === 0) return;

  await axios.put(
    "https://api-backend.full-trucking-service.com/api/asset-costs/mark-paid",
    { assetCostIds },
    config
  );
};


const markFuelAsPaid = async () => {
  const fuelIds = recurringDeductions
    .filter(d => d.source === "fuel" && d.fuelReportId)
    .map(d => d.fuelReportId);

  if (fuelIds.length === 0) return;

  try {
    await axios.put(
      "https://api-backend.full-trucking-service.com/api/fuel-reports/mark-paid",
      { fuelIds },
      config
    );

    console.log("✅ Fuel marked as PAID:", fuelIds);
  } catch (err) {
    console.error("❌ Failed to mark fuel as paid", err);
  }
};

  const saveTotalPay = async () => {
    if (!selectedDriver || !startDate || !endDate) {
  
      return;
    }
  
    const { totalPayWithAdjustments } = calculatePay();
  
    try {
      const response = await axios.post(
        'https://api-backend.full-trucking-service.com/api/totalpays',
        {
          driverId: selectedDriver._id,
          startDate,
          endDate,
          totalWithAdjustments: totalPayWithAdjustments
        },
        config
      );
  
      if (response.status === 201) {
       
      } else {
     
      }
    } catch (error) {

    }
  };
  
  useEffect(() => {
    const fetchClientInfo = async () => {
      try {
        const response = await axios.get('https://api-backend.full-trucking-service.com/api/settings', config);
        const { companyName, companyAddress, email, phone } = response.data;
        setClientInfo({ companyName, companyAddress, email, phone });
        if (customFooterText) setCustomFooterText(customFooterText);
        if (useCustomFooter !== undefined) setUseCustomFooter(useCustomFooter);
      } catch (error) {
    
      }
    };

    const fetchLogo = async () => {
      try {
        const response = await axios.get('https://api-backend.full-trucking-service.com/api/logo', config);
        setLogo(response.data.logo);
      } catch (error) {
       
      }
    };

    fetchClientInfo();
    fetchLogo();
  }, []);
  
  useEffect(() => {
    const fetchFooterText = async () => {
      try {
        const response = await axios.get('https://api-backend.full-trucking-service.com/api/footer', config);
        if (response.status === 200) {
          const { customFooterText, useCustomFooter } = response.data;
          setCustomFooterText(customFooterText || '');
          setUseCustomFooter(useCustomFooter || false);
        }
      } catch (error) {
 
      }
    };

    fetchFooterText();
  }, []);

  // Save Footer
  const handleSaveFooterText = async () => {
    try {
      const response = await axios.put(
        'https://api-backend.full-trucking-service.com/api/footer',
        { customFooterText, useCustomFooter },
        config
      );
      if (response.status === 200) {
        notify('Footer text saved successfully!' ,'success');
      } else {
        throw new Error('Unexpected response structure');
      }
    } catch (error) {
   
      notify('Failed to save footer text.' , 'error');
    }
  };


  const handleDeleteFooterText = () => {
    setDeleteTarget('footer');
  };
  
  const confirmDeleteFooterText = async () => {
    try {
      await axios.delete('https://api-backend.full-trucking-service.com/api/footer', config);
      setCustomFooterText('');
      setUseCustomFooter(false);
      notify('Footer text deleted successfully!' , 'success');
    } catch (error) {
   
      notify('Failed to delete footer text.' , 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  
const handleLogoChange = async (e) => {
  const file = e.target.files[0];
  if (file && file.size > 5000000) { // 5MB limit
    notify("File is too large! Please select a file smaller than 5MB." , 'error');
    return;
  }
  if (file && !file.type.startsWith("image/")) {
   notify("Invalid file type! Please select an image." , 'error');
    return;
  }

  const reader = new FileReader();
  reader.onload = async (event) => {
    const imageData = event.target.result;
    try {
      await axios.put(
        'https://api-backend.full-trucking-service.com/api/logo',
        { logo: imageData },
        config
      );
      setLogo(imageData);
    } catch (error) {
  
    }
  };
  reader.readAsDataURL(file);
};

const handleLogoDelete = () => {
  setDeleteTarget('logo');
};

const confirmDeleteLogo = async () => {
  try {
    await axios.delete('https://api-backend.full-trucking-service.com/api/logo', config);
    setLogo(null);
  } catch (error) {

   notify("Failed to delete logo." , 'error');
  }
  setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
};


const handleDriverSelect = (e) => {
  const driver = drivers.find((driver) => driver._id === e.target.value);
  setSelectedDriver(driver);
  setSelectedTruck(null);
  setFilteredLoads([]);
  setSelectedLoads([]);
  setRecurringAdditions([]);
  setRecurringDeductions([]);
  setManualAdditions([]);
  setManualDeductions([]);
};

const handleTruckSelect = (e) => {
  const truck = trucks.find((truck) => truck._id === e.target.value);
  setSelectedTruck(truck);
  setFilteredLoads([]);
  setSelectedLoads([]);
  setRecurringAdditions([]);
  setRecurringDeductions([]);
  setSelectedDriver(null);
};


const handleAddDriverPay = async () => {
  // Verificare date esențiale
  if ((!selectedDriver && !selectedTruck) || !startDate || !endDate) {

    return false;
  }

const normalize = (items) =>
  items.map((item) => ({
    type: item.type || '',
    description: item.description || '',
    amount: parseFloat(item.amount || 0),
    date: item.date || new Date().toISOString().split('T')[0],

    // 🔥 OBLIGATORIU
    source: item.source || undefined,
    fuelReportId: item.fuelReportId || undefined,
    assetCostId: item.assetCostId || undefined,
  }));

  const transformedAdditions = normalize(recurringAdditions);
const transformedDeductions = normalize(recurringDeductions);

const transformedManualAdditions = normalizeManualItems(manualAdditions);
const transformedManualDeductions = normalizeManualItems(manualDeductions);
  // Calculăm plățile
 const { payDetails, totalRate, totalPay, totalPayWithAdjustments } = calculatePay();


if (isNaN(totalPayWithAdjustments)) {


  return false;
}

  try {
    // Trimitem cererea de salvare
    const response = await axios.post(
      'https://api-backend.full-trucking-service.com/api/driverpays',
      {
  settlementNumber,
  driver: selectedDriver ? selectedDriver._id : null,
  truck: selectedTruck ? selectedTruck._id : null,

  startDate,
  endDate,

  totalPay,
  totalWithAdjustments: totalPayWithAdjustments,

  payDetails,

  recurringAddition: transformedAdditions,
  recurringDeduction: transformedDeductions,
manualAdditions: transformedManualAdditions,
manualDeductions: transformedManualDeductions,
  // 🔥 PDF SETTINGS
  settlementSubtitle,
  extraHeaderLine,
  showSettlementNumber,
  showDriverNumber,
  showTruckNumber,
  showPhone,
  showEmail,

  companyName: clientInfo.companyName,
  logo,
},
      config
    );

if (response.status === 201) {

  // 🔥 RESET UI
  setRecurringAdditions([]);
  setRecurringDeductions([]);
  setSelectedLoads([]);
  setFilteredLoads([]);

  // 🔥 GENERATE NEW SETTLEMENT NUMBER
  if (autoGenerateSettlement) {
    const newNumber = `ST-${Date.now()}`;
    setSettlementNumber(newNumber);
  }

  return true;
}
 else {

      return false;
    }
  } catch (error) {

    return false;
  }
};


  const handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'startDate') setStartDate(value);
    else setEndDate(value);
  };
const searchLoads = () => {
  if (!selectedDriver || !startDate || !endDate) return;

  const filtered = loads.filter(load => {
    if (load.status !== 'Completed') return false;

    const isAssigned =
      load.driver?.toString() === selectedDriver._id.toString() ||
      load.ownerOperator?.toString() === selectedDriver._id.toString() ||
      (Array.isArray(load.teamDrivers) &&
        load.teamDrivers.some(id =>
          id.toString() === selectedDriver._id.toString()
        ));

    if (!isAssigned) return false;

    const hasPickup = load.shippers.some(
      s => s.pickUpTime && new Date(s.pickUpTime) >= new Date(startDate)
    );

    const hasDelivery = load.consignees.some(
      c => c.deliveryTime && new Date(c.deliveryTime) <= new Date(endDate)
    );

    return hasPickup && hasDelivery;
  });

  setFilteredLoads(filtered);
};

  
  

  const handleLoadSelection = (loadNumber) => {
    setSelectedLoads((prevSelected) =>
      prevSelected.includes(loadNumber)
        ? prevSelected.filter((num) => num !== loadNumber)
        : [...prevSelected, loadNumber]
    );
  };
const toNumber = (val) => {
  const num = parseFloat(val);
  return isNaN(num) ? 0 : num;
};

const calculatePay = () => {
  const payDetails = filteredLoads
    .filter(load => selectedLoads.includes(load.loadNumber))
    .map((load) => {
      let pay = 0;

      if (selectedDriver) {
        switch (selectedDriver.settlement) {
          case 'Hourly pay':
            pay = toNumber(selectedDriver.hoursWorked) * toNumber(selectedDriver.settlementAmount);
            break;
          case 'Per mile pay':
            pay = toNumber(load.miles) * toNumber(selectedDriver.normalMileRate) + toNumber(load.dh) * toNumber(selectedDriver.dhMileRate);
            break;
          case 'Fixed salary':
            pay = toNumber(selectedDriver.settlementAmount);
            break;
          case 'Percentage of the load':
            pay = toNumber(load.rate) * toNumber(selectedDriver.settlementAmount) / 100;
            break;
          case 'Team driver pay':
            pay = toNumber(load.rate) / 2;
            break;
        }
      }

      if (selectedTruck) {
        switch (selectedTruck.settlement) {
          case 'Hourly pay':
            pay = toNumber(selectedTruck.hoursWorked) * toNumber(selectedTruck.settlementAmount);
            break;
          case 'Per mile pay':
            pay = toNumber(load.miles) * toNumber(selectedTruck.normalMileRate) + toNumber(load.dh) * toNumber(selectedTruck.dhMileRate);
            break;
          case 'Fixed salary':
            pay = toNumber(selectedTruck.settlementAmount);
            break;
          case 'Percentage of the load':
            pay = toNumber(load.rate) * toNumber(selectedTruck.settlementAmount) / 100;
            break;
          case 'Team driver pay':
            pay = toNumber(load.rate) / 2;
            break;
        }
      }

      return {
        loadNumber: load.loadNumber || '',
        rate: toNumber(load.rate),
        dh: toNumber(load.dh),
        miles: toNumber(load.miles),
        pay,
        payDescription: '',
        shippers: load.shippers || [],
        consignees: load.consignees || []
      };
    });

  const totalRate = payDetails.reduce((sum, d) => sum + toNumber(d.rate), 0);
  const totalPay = payDetails.reduce((sum, d) => sum + toNumber(d.pay), 0);
 const totalRecurringAdditions = recurringAdditions.reduce((sum, a) => sum + toNumber(a.amount), 0);
const totalRecurringDeductions = recurringDeductions.reduce((sum, d) => sum + toNumber(d.amount), 0);

const totalManualAdditions = manualAdditions.reduce((sum, a) => sum + toNumber(a.amount), 0);
const totalManualDeductions = manualDeductions.reduce((sum, d) => sum + toNumber(d.amount), 0);

const totalAdditions = totalRecurringAdditions + totalManualAdditions;
const totalDeductions = totalRecurringDeductions + totalManualDeductions;

let totalPayWithAdjustments = totalPay + totalAdditions - totalDeductions;
  return {
    payDetails,
    totalRate,
    totalPay,
    totalPayWithAdjustments: Number.isFinite(totalPayWithAdjustments) ? totalPayWithAdjustments : 0
  };
};

const formatRecurringDescription = (item) => {
  // baza
  let desc = item.description || "";

  // dacă NU e recurring → nimic extra
  if (item.paymentType !== "recurring") {
    return desc;
  }

  // dacă e recurring FOREVER → nimic extra
  if (!item.totalPayments || item.totalPayments <= 0) {
    return desc;
  }

  // recurring limitat → X / total
  const current = (item.paidPayments || 0) + 1;

  return `${desc} ${current}/${item.totalPayments}`;
};

const formatLimitedRecurringInfo = (item) => {
  if (
    item.paymentType !== "recurring" ||
    !item.totalPayments ||
    item.totalPayments <= 0
  ) {
    return "";
  }

  const paid = Number(item.paidPayments || 0) + 1;
  const total = Number(item.totalPayments);
  const totalAmount = Number(item.totalAmount || 0);

  return ` ${paid}/${total} from $${totalAmount.toFixed(2)}`;
};

const generatePDF = async () => {
  const { payDetails, totalRate, totalPayWithAdjustments, totalPay } = calculatePay();
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "letter" });

  // ─── DESIGN TOKENS ────────────────────────────────────────────────────────
  const COLOR = {
    navy:        [10,  31,  68],   // header bg & accents
    navyLight:   [22,  54, 110],   // secondary header tint
    gold:        [212, 160,  23],   // accent / dividers
    white:       [255, 255, 255],
    offWhite:    [248, 249, 252],
    lightGray:   [230, 234, 241],
    midGray:     [150, 162, 180],
    darkText:    [18,  28,  48],
    greenPay:    [15, 118,  82],
    redDed:      [185,  28,  28],
    blueSub:     [37,  99, 235],
  };

  const PAGE_W    = 215.9;   // Letter width mm
  const PAGE_H    = 279.4;   // Letter height mm
  const MARGIN    = 14;
  const COL_RIGHT = 140;
  const today     = new Date().toISOString().split("T")[0];
  setPaymentDate(today);

  // ─── HELPERS ──────────────────────────────────────────────────────────────
  const rgb  = (arr) => ({ r: arr[0], g: arr[1], b: arr[2] });
  const setFill   = (c) => doc.setFillColor(...c);
  const setStroke = (c) => doc.setDrawColor(...c);
  const setColor  = (c) => doc.setTextColor(...c);
  const setFont   = (size, style = "normal") => { doc.setFontSize(size); doc.setFont("helvetica", style); };

  const hRule = (y, color = COLOR.gold, thickness = 0.6) => {
    doc.setDrawColor(...color);
    doc.setLineWidth(thickness);
    doc.line(MARGIN, y, PAGE_W - MARGIN, y);
  };

  const thinRule = (y) => hRule(y, COLOR.lightGray, 0.25);

  // ─── HEADER ───────────────────────────────────────────────────────────────
  const addHeader = () => {
    // Navy header banner
    setFill(COLOR.navy);
    doc.rect(0, 0, PAGE_W, 42, "F");

    // Gold accent bar at bottom of banner
    setFill(COLOR.gold);
    doc.rect(0, 41, PAGE_W, 1.5, "F");

    // Logo
    if (logo && typeof logo === "string") {
      doc.addImage(logo, "PNG", MARGIN, 7, 48, 22);
    }

    // Title block (right-aligned in header)
    setColor(COLOR.white);
    setFont(18, "bold");
    doc.text("DRIVER SETTLEMENT", PAGE_W - MARGIN, 17, { align: "right" });

    if (settlementSubtitle) {
      setFont(8);
      setColor(COLOR.gold);
      doc.text(settlementSubtitle.toUpperCase(), PAGE_W - MARGIN, 23, { align: "right" });
    }

    // Optional settlement # badge
    if (showSettlementNumber && settlementNumber) {
      setFill(COLOR.gold);
      doc.roundedRect(PAGE_W - MARGIN - 52, 27, 52, 10, 2, 2, "F");
      setColor(COLOR.navy);
      setFont(7, "bold");
      doc.text(`SETTLEMENT #  ${settlementNumber}`, PAGE_W - MARGIN - 26, 33.2, { align: "center" });
    }

    // ── Info grid below banner ────────────────────────────────────────────
    const infoY = 52;
    const col2  = 115;

    // Left column labels + values
    const leftRows = [
      ["Driver Name",    `${selectedDriver?.firstName || ""} ${selectedDriver?.lastName || ""}`.trim()],
      ["Address",        selectedDriver?.address || "N/A"],
      ["Pay Period",     `${startDate}  –  ${endDate}`],
      ["Payment Date",  today],
    ];

    // Right column (optional fields)
    const rightRows = [];
    if (showDriverNumber) rightRows.push(["Driver #",  selectedDriver?.driverNumber || "N/A"]);
    if (showTruckNumber)  rightRows.push(["Truck #",   selectedDriver?.truckNumber  || "N/A"]);
    if (showPhone)        rightRows.push(["Phone",     selectedDriver?.phone        || ""]);
    if (showEmail)        rightRows.push(["Email",     selectedDriver?.email        || ""]);

    let ly = infoY;
    leftRows.forEach(([label, value]) => {
      setFont(7, "bold"); setColor(COLOR.midGray);
      doc.text(label.toUpperCase(), MARGIN, ly);
      setFont(8.5, "normal"); setColor(COLOR.darkText);
      doc.text(value, MARGIN, ly + 4.5);
      ly += 11;
    });

    let ry = infoY;
    rightRows.forEach(([label, value]) => {
      setFont(7, "bold"); setColor(COLOR.midGray);
      doc.text(label.toUpperCase(), col2, ry);
      setFont(8.5, "normal"); setColor(COLOR.darkText);
      doc.text(value, col2, ry + 4.5);
      ry += 11;
    });

    if (extraHeaderLine) {
      setFont(8); setColor(COLOR.midGray);
      doc.text(extraHeaderLine, MARGIN, ly + 2);
      ly += 8;
    }

    if (extraHeaderLine) {
  setFont(8); setColor(COLOR.midGray);
  doc.text(extraHeaderLine, MARGIN, ly + 2);
  ly += 8;
}
    // Separator before body
    hRule(ly + 2);
    return ly + 8; // return startY for body
  };

  // ─── FOOTER ───────────────────────────────────────────────────────────────
  const addFooter = () => {
    const pageCount = doc.internal.getNumberOfPages();
    const fY = PAGE_H - 18;

    // Gold top rule
    setFill(COLOR.gold);
    doc.rect(0, fY - 2, PAGE_W, 0.8, "F");

    // Navy footer bar
    setFill(COLOR.navy);
    doc.rect(0, fY - 1.2, PAGE_W, 20, "F");

setColor(COLOR.white); setFont(7);
    if (useCustomFooter && customFooterText) {
      doc.text(customFooterText, PAGE_W / 2, fY + 4, { align: "center" });
    } else {
      doc.text("Thank you for your business!", PAGE_W / 2, fY + 3, { align: "center" });
      doc.text(
        `${clientInfo.companyName}  ·  ${clientInfo.companyAddress}`,
        PAGE_W / 2, fY + 8, { align: "center" }
      );
    }

    // LINIE NOUĂ:
    setColor(COLOR.gold); setFont(6);
    doc.text("Powered by FleetAcc", PAGE_W / 2, fY + 13, { align: "center" });

    setColor(COLOR.midGray); setFont(7);
    doc.text(`Page ${pageCount}`, PAGE_W - MARGIN, fY + 4, { align: "right" });
  };

  // ─── BODY ─────────────────────────────────────────────────────────────────
  let startY = addHeader();

  // Section title helper
  const sectionTitle = (label, y) => {
    setFill(COLOR.navyLight);
    doc.roundedRect(MARGIN, y, PAGE_W - MARGIN * 2, 7, 1.5, 1.5, "F");
    setColor(COLOR.gold); setFont(8, "bold");
    doc.text(label.toUpperCase(), MARGIN + 4, y + 4.8);
    return y + 10;
  };

  // ── LOADS ────────────────────────────────────────────────────────────────
  startY = sectionTitle("Load Details", startY);

  payDetails.forEach((detail, index) => {
    if (startY > PAGE_H - 60) {
      addFooter();
      doc.addPage();
      startY = addHeader();
      startY = sectionTitle("Load Details (continued)", startY);
    }

    const pickupDetails = detail.shippers.length > 0
      ? detail.shippers.map((s) => {
          const dt = !s.pickUpTime || isNaN(new Date(s.pickUpTime).getTime())
            ? "Unknown Date" : new Date(s.pickUpTime).toLocaleString();
          return `${dt}  —  ${s.address || "No data"}`;
        }).join("\n")
      : "No data";

    const deliveryDetails = detail.consignees.length > 0
      ? detail.consignees.map((c) => {
          const dt = !c.deliveryTime || isNaN(new Date(c.deliveryTime).getTime())
            ? "Unknown Date" : new Date(c.deliveryTime).toLocaleString();
          return `${dt}  —  ${c.address || "No data"}`;
        }).join("\n")
      : "No data";

    doc.autoTable({
      startY,
      body: [
        [
          {
            content: `LOAD  #${index + 1}`,
            colSpan: 3,
            styles: { fontStyle: "bold", fontSize: 8, fillColor: COLOR.offWhite, textColor: COLOR.navy, cellPadding: { top: 3, bottom: 3, left: 4, right: 4 } },
          },
        ],
        [
          { content: "Pickup", styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.white, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } },
          { content: pickupDetails, colSpan: 2, styles: { halign: "left", fillColor: COLOR.white, textColor: COLOR.darkText, fontSize: 7.5 } },
        ],
        [
          { content: "Delivery", styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.white, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } },
          { content: deliveryDetails, colSpan: 2, styles: { halign: "left", fillColor: COLOR.white, textColor: COLOR.darkText, fontSize: 7.5 } },
        ],
        [
          { content: "Rate", styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.white, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } },
          { content: getRateDetail(detail), styles: { halign: "left", fillColor: COLOR.white, textColor: COLOR.darkText, fontSize: 7.5 } },
          { content: "", styles: { fillColor: COLOR.white } },
        ],
        [
          { content: "Notes", styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.offWhite, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } },
          { content: detail.notes || "—", styles: { fillColor: COLOR.offWhite, textColor: COLOR.darkText, fontSize: 7.5 } },
          {
            content: `$${detail.pay.toFixed(2)}`,
            styles: { fontStyle: "bold", halign: "right", fillColor: COLOR.offWhite, textColor: COLOR.greenPay, fontSize: 9 },
          },
        ],
      ],
      theme: "plain",
      styles: { lineColor: COLOR.lightGray, lineWidth: 0.35, cellPadding: 2.5 },
      margin: { left: MARGIN, right: MARGIN },
      tableLineColor: COLOR.lightGray,
      tableLineWidth: 0.35,
    });

    startY = doc.lastAutoTable.finalY + 5;
  });

  // ── SUB-TOTAL ─────────────────────────────────────────────────────────────
  startY += 4;
  doc.autoTable({
    startY,
    body: [[
      { content: selectedDriver?.settlement === "Fixed salary" ? `Fixed Salary` : "Sub-Total", styles: { fontStyle: "bold", fontSize: 9, textColor: COLOR.darkText } },
      { content: `$${totalPay.toFixed(2)}`, styles: { fontStyle: "bold", halign: "right", fontSize: 10, textColor: COLOR.blueSub } },
    ]],
    theme: "plain",
    styles: { fillColor: COLOR.offWhite, lineColor: COLOR.lightGray, lineWidth: 0.35, cellPadding: { top: 4, bottom: 4, left: 5, right: 5 } },
    margin: { left: MARGIN, right: MARGIN },
    tableLineColor: COLOR.lightGray,
    tableLineWidth: 0.35,
  });
  startY = doc.lastAutoTable.finalY + 8;

  // ── ADDITIONS ─────────────────────────────────────────────────────────────
  const additionsForPdf = [
    ...recurringAdditions.map((a) => ({ type: a.type || "Other", description: a.description || "", date: a.date || "", amount: parseFloat(a.amount || 0), notes: a.notes || "" })),
    ...manualAdditions.map((a)     => ({ type: a.type || "Other", description: a.description || "", date: a.date || "", amount: parseFloat(a.amount || 0), notes: a.notes || "" })),
  ];

  const deductionsForPdf = [
    ...recurringDeductions.map((d) => ({ type: d.type || "Other", description: d.description || "", date: d.date || "", amount: parseFloat(d.amount || 0), notes: d.notes || "" })),
    ...manualDeductions.map((d)    => ({ type: d.type || "Other", description: d.description || "", date: d.date || "", amount: parseFloat(d.amount || 0), notes: d.notes || "" })),
  ];

  if (startY > PAGE_H - 70) { addFooter(); doc.addPage(); startY = addHeader(); }
  startY = sectionTitle("Additions", startY);

  doc.autoTable({
    startY,
    head: [[
      { content: "Type / Description / Date", styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
      { content: "Notes",                     styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
      { content: "Amount",                    styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5, halign: "right" } },
    ]],
    body: additionsForPdf.length > 0
      ? additionsForPdf.map((a) => [
          { content: `${a.type}  ·  ${a.description}  ·  ${a.date}`, styles: { fontSize: 7.5, textColor: COLOR.darkText } },
          { content: a.notes, styles: { fontSize: 7.5, textColor: COLOR.midGray } },
          { content: `+$${a.amount.toFixed(2)}`, styles: { fontSize: 7.5, halign: "right", textColor: COLOR.greenPay, fontStyle: "bold" } },
        ])
      : [[{ content: "No additions", colSpan: 3, styles: { halign: "center", textColor: COLOR.midGray, fontSize: 7.5, fontStyle: "italic" } }]],
    theme: "grid",
    styles: { lineColor: COLOR.lightGray, lineWidth: 0.3, cellPadding: 2.5, fontSize: 7.5 },
    alternateRowStyles: { fillColor: COLOR.offWhite },
    headStyles: { fillColor: COLOR.navy },
    margin: { left: MARGIN, right: MARGIN },
  });
  startY = doc.lastAutoTable.finalY + 8;

  // ── DEDUCTIONS ─────────────────────────────────────────────────────────────
  if (startY > PAGE_H - 70) { addFooter(); doc.addPage(); startY = addHeader(); }
  startY = sectionTitle("Deductions", startY);

  doc.autoTable({
    startY,
    head: [[
      { content: "Type / Description / Date", styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
      { content: "Notes",                     styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
      { content: "Amount",                    styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5, halign: "right" } },
    ]],
    body: deductionsForPdf.length > 0
      ? deductionsForPdf.map((d) => [
          { content: `${d.type}  ·  ${d.description}  ·  ${d.date}`, styles: { fontSize: 7.5, textColor: COLOR.darkText } },
          { content: d.notes, styles: { fontSize: 7.5, textColor: COLOR.midGray } },
          { content: `-$${d.amount.toFixed(2)}`, styles: { fontSize: 7.5, halign: "right", textColor: COLOR.redDed, fontStyle: "bold" } },
        ])
      : [[{ content: "No deductions", colSpan: 3, styles: { halign: "center", textColor: COLOR.midGray, fontSize: 7.5, fontStyle: "italic" } }]],
    theme: "grid",
    styles: { lineColor: COLOR.lightGray, lineWidth: 0.3, cellPadding: 2.5, fontSize: 7.5 },
    alternateRowStyles: { fillColor: [255, 248, 248] },
    headStyles: { fillColor: COLOR.navy },
    margin: { left: MARGIN, right: MARGIN },
  });
  startY = doc.lastAutoTable.finalY + 10;

  // ── GRAND TOTAL ────────────────────────────────────────────────────────────
  if (startY > PAGE_H - 40) { addFooter(); doc.addPage(); startY = addHeader(); }

  // Gold accent bar
  setFill(COLOR.gold);
  doc.rect(MARGIN, startY, PAGE_W - MARGIN * 2, 0.8, "F");
  startY += 4;

  doc.autoTable({
    startY,
    body: [[
      { content: "GRAND TOTAL — NET PAY", styles: { fontStyle: "bold", fontSize: 11, textColor: COLOR.white, fillColor: COLOR.navy, cellPadding: { top: 5, bottom: 5, left: 6, right: 6 } } },
      { content: `$${totalPayWithAdjustments.toFixed(2)}`, styles: { fontStyle: "bold", fontSize: 14, halign: "right", textColor: COLOR.gold, fillColor: COLOR.navy, cellPadding: { top: 4, bottom: 4, left: 6, right: 6 } } },
    ]],
    theme: "plain",
    margin: { left: MARGIN, right: MARGIN },
    tableLineColor: COLOR.navy,
    tableLineWidth: 0,
  });

  // Final gold underline
  const finalY = doc.lastAutoTable.finalY;
  setFill(COLOR.gold);
  doc.rect(MARGIN, finalY, PAGE_W - MARGIN * 2, 1.2, "F");

  // ── SIGNATURE BLOCK ────────────────────────────────────────────────────────
  const sigY = finalY + 14;
  if (sigY < PAGE_H - 35) {
    setFont(7.5); setColor(COLOR.midGray);

    doc.line(MARGIN + 30, sigY, MARGIN + 95, sigY);

    doc.line(MARGIN + 115, sigY, MARGIN + 155, sigY);
  }

  // ── FOOTER LAST PAGE ──────────────────────────────────────────────────────
  addFooter();

  // ── SAVE ──────────────────────────────────────────────────────────────────
  await saveTotalPay();
  doc.save("driver_settlement.pdf");
};

        const getRateDetail = (detail) => {
  if (selectedTruck && selectedTruck.settlement) {
    switch (selectedTruck.settlement) {
      case 'Hourly pay':
        return `Truck: ${selectedTruck.hoursWorked || 0} hours * $${selectedTruck.settlementAmount || 0} per hour`;
      case 'Per mile pay':
        return `Truck: Miles ${detail.miles} * $${selectedTruck.normalMileRate || 0} + DH Miles ${detail.dh} * $${selectedTruck.dhMileRate || 0}`;
      case 'Fixed salary':
        return `Fixed Salary (Truck) - $${selectedTruck.settlementAmount || 0}`;
      case 'Percentage of the load':
        return `Truck: ${selectedTruck.settlementAmount}% of $${detail.rate || 0}`;
      case 'Team driver pay':
        return `Truck Team Driver: Load Rate $${detail.rate || 0} / 2 (Each driver receives half)`;
      default:
        return `Truck rate for load: $${detail.rate || 0}`;
    }
  }
  
  if (selectedDriver && selectedDriver.settlement) {
    switch (selectedDriver.settlement) {
      case 'Hourly pay':
        return `Driver: ${selectedDriver.hoursWorked || 0} hours * $${selectedDriver.settlementAmount || 0} per hour`;
      case 'Per mile pay':
        return `Driver: Miles ${detail.miles} * $${selectedDriver.normalMileRate || 0} + DH Miles ${detail.dh} * $${selectedDriver.dhMileRate || 0}`;
      case 'Fixed salary':
        return `Fixed Salary (Driver) - $${selectedDriver.settlementAmount || 0}`;
      case 'Percentage of the load':
        return `Driver: ${selectedDriver.settlementAmount}% of $${detail.rate || 0}`;
      case 'Team driver pay':
        return `Driver Team: Load Rate $${detail.rate || 0} / 2`;
      default:
        return `Driver rate for load: $${detail.rate || 0}`;
    }
  }
  
  return `Rate: $${detail.rate || 0}`;
};


  const removeRecurring = (type, index) => {
    if (type === 'deduction') {
      setRecurringDeductions(recurringDeductions.filter((_, i) => i !== index));
    } else {
      setRecurringAdditions(recurringAdditions.filter((_, i) => i !== index));
    }
  };

  const addDeduction = () => {
  setRecurringDeductions([
    ...recurringDeductions,
    { type: '', description: '', amount: 0, date: new Date().toISOString().slice(0, 10) }
  ]);
};

const addAddition = () => {
  setRecurringAdditions([
    ...recurringAdditions,
    { type: '', description: '', amount: 0, date: new Date().toISOString().slice(0, 10) }
  ]);
};

const addManualDeduction = () => {
  setManualDeductions((prev) => [
    ...prev,
    {
      type: "",
      description: "",
      date: new Date().toISOString().slice(0, 10),
      amount: "",
      notes: "",
    },
  ]);
};

const addManualAddition = () => {
  setManualAdditions((prev) => [
    ...prev,
    {
      type: "",
      description: "",
      date: new Date().toISOString().slice(0, 10),
      amount: "",
      notes: "",
    },
  ]);
};

const updateManualItem = (kind, index, field, value) => {
  if (kind === "deduction") {
    const updated = [...manualDeductions];
    updated[index] = {
      ...updated[index],
      [field]: value,
    };
    setManualDeductions(updated);
  } else {
    const updated = [...manualAdditions];
    updated[index] = {
      ...updated[index],
      [field]: value,
    };
    setManualAdditions(updated);
  }
};

const removeManualItem = (kind, index) => {
  if (kind === "deduction") {
    setManualDeductions((prev) => prev.filter((_, i) => i !== index));
  } else {
    setManualAdditions((prev) => prev.filter((_, i) => i !== index));
  }
};

const normalizeManualItems = (items) =>
  items.map((item) => ({
    type: item.type || "",
    description: item.description || "",
    amount: parseFloat(item.amount || 0),
    date: item.date || new Date().toISOString().split("T")[0],
    notes: item.notes || "",
    source: "manual",
  }));

  return (
    <div
  className={`${styles.ultimatedriverPaySection} ${
    theme === "light" ? styles.ultimatedriverPaySectionLight : ""
  }`}
>

      <h2 className={styles.titledriverPayultimatedriverPay}>Driver Pay</h2>
{/* EMPLOYER DRIVERS */}
<div className={styles.formGroupultimatedriverPay}>
  <label>Driver / Employer</label>
  <select
    value={
      selectedDriver?.driverType === 'employee'
        ? selectedDriver._id
        : ''
    }
    onChange={(e) => {
      const driver = employerDrivers.find(d => d._id === e.target.value);
      setSelectedDriver(driver || null);

      setFilteredLoads([]);
      setSelectedLoads([]);
      setRecurringAdditions([]);
setRecurringDeductions([]);
setManualAdditions([]);
setManualDeductions([]);

    }}
    className={styles.selectFieldultimatedriverPay}
  >
    <option value="">Select Employer Driver</option>
    {employerDrivers.map(d => (
      <option key={d._id} value={d._id}>
        {d.firstName} {d.lastName}
      </option>
    ))}
  </select>
</div>

{/* OWNER OPERATORS */}
<div className={styles.formGroupultimatedriverPay}>
  <label>Owner Operator</label>
  <select
    value={
      selectedDriver?.driverType === 'owner_operator'
        ? selectedDriver._id
        : ''
    }
    onChange={(e) => {
      const driver = ownerOperators.find(d => d._id === e.target.value);
      setSelectedDriver(driver || null);

      setFilteredLoads([]);
      setSelectedLoads([]);
     setRecurringAdditions([]);
setRecurringDeductions([]);
setManualAdditions([]);
setManualDeductions([]);


    }}
    className={styles.selectFieldultimatedriverPay}
  >
    <option value="">Select Owner Operator</option>
    {ownerOperators.map(d => (
      <option key={d._id} value={d._id}>
        {d.firstName} {d.lastName}
      </option>
    ))}
  </select>
</div>



{deleteTarget !== null && (
  <DeleteNotifications
    message={
      deleteTarget === 'logo'
        ? "Are you sure you want to remove the company logo?"
        : "Are you sure you want to delete the footer text?"
    }
    onConfirm={deleteTarget === 'logo' ? confirmDeleteLogo : confirmDeleteFooterText}
    onCancel={() => setDeleteTarget(null)}
  />
)}


      {(selectedDriver || selectedTruck) && (
        <div className={styles.driverDetailsultimatedriverPay}>
          <h3 className={styles.subtitleultimatedriverPay}>
           {selectedDriver && `Driver: ${selectedDriver.firstName} ${selectedDriver.lastName}`}
{selectedOwner && `Owner Operator: ${selectedOwner.firstName} ${selectedOwner.lastName}`}

          </h3>

<button
  onClick={() => setPdfSettingsModalOpen(true)}
  className={styles.openPdfSettingsButton}
>
  Configure PDF Settlement
</button>

    {pdfSettingsModalOpen && (
  <div className={styles.pdfModalOverlay}>
    <div className={styles.pdfModalContainer}>

      {/* HEADER */}
      <div className={styles.pdfModalHeader}>
        <h3>Settlement PDF Settings</h3>
        <button
          onClick={() => setPdfSettingsModalOpen(false)}
          className={styles.pdfModalClose}
        >
          ✕
        </button>
      </div>

      <div className={styles.pdfModalContent}>

        {/* LOGO */}
        <div className={styles.formGroupultimatedriverPay}>
          <label>Company Logo</label>
          <input type="file" onChange={handleLogoChange} />
          {logo && (
            <div className={styles.logoPreview}>
              <img src={logo} alt="Company Logo" />
              <button onClick={handleLogoDelete}>Remove</button>
            </div>
          )}
        </div>

        {/* SETTLEMENT NUMBER */}
        <div className={styles.formGroupultimatedriverPay}>
          <label>Settlement Number</label>
          <div style={{ display: "flex", gap: "10px" }}>
            <input
              type="text"
              value={settlementNumber}
              disabled={autoGenerateSettlement}
              onChange={(e) => setSettlementNumber(e.target.value)}
              className={styles.inputFieldultimatedriverPay}
            />
            <label>
              <input
                type="checkbox"
                checked={autoGenerateSettlement}
                onChange={(e) => setAutoGenerateSettlement(e.target.checked)}
              />
              Auto
            </label>
          </div>
        </div>

        {/* SUBTITLE */}
        <div className={styles.formGroupultimatedriverPay}>
          <label>Subtitle</label>
          <input
            type="text"
            value={settlementSubtitle}
            onChange={(e) => setSettlementSubtitle(e.target.value)}
            className={styles.inputFieldultimatedriverPay}
          />
        </div>

        {/* EXTRA HEADER */}
        <div className={styles.formGroupultimatedriverPay}>
          <label>Extra Header Line</label>
          <input
            type="text"
            value={extraHeaderLine}
            onChange={(e) => setExtraHeaderLine(e.target.value)}
            className={styles.inputFieldultimatedriverPay}
          />
        </div>

        {/* TOGGLES */}
        <div className={styles.formGroupultimatedriverPay}>
          <label>Display On PDF</label>
          <div className={styles.pdfToggleGrid}>
            <label><input type="checkbox" checked={showSettlementNumber} onChange={(e)=>setShowSettlementNumber(e.target.checked)} /> Settlement #</label>
            <label><input type="checkbox" checked={showDriverNumber} onChange={(e)=>setShowDriverNumber(e.target.checked)} /> Driver</label>
            <label><input type="checkbox" checked={showTruckNumber} onChange={(e)=>setShowTruckNumber(e.target.checked)} /> Truck</label>
            <label><input type="checkbox" checked={showPhone} onChange={(e)=>setShowPhone(e.target.checked)} /> Phone</label>
            <label><input type="checkbox" checked={showEmail} onChange={(e)=>setShowEmail(e.target.checked)} /> Email</label>
          </div>
        </div>

        {/* FOOTER */}
        <div className={styles.formGroupultimatedriverPay}>
          <label>Custom Footer</label>
          <textarea
            value={customFooterText}
            onChange={(e) => setCustomFooterText(e.target.value)}
          />
          <label>
            <input
              type="checkbox"
              checked={useCustomFooter}
              onChange={(e) => setUseCustomFooter(e.target.checked)}
            />
            Use Custom Footer
          </label>
        </div>

      </div>
    </div>
  </div>
)}




   
          <div className={styles.formRowultimatedriverPay}>
            <div className={styles.formGroupultimatedriverPay}>
              <label>Start Date</label>
              <input
                type="date"
                name="startDate"
                value={startDate}
                onChange={handleDateChange}
                className={styles.inputFieldultimatedriverPay}
              />
            </div>
            <div className={styles.formGroupultimatedriverPay}>
              <label>End Date</label>
              <input
                type="date"
                name="endDate"
                value={endDate}
                onChange={handleDateChange}
                className={styles.inputFieldultimatedriverPay}
              />
            </div>
          </div>
          <button onClick={searchLoads} className={styles.actionButtonultimatedriverPay}>
            Search
          </button>


          {(filteredLoads.length > 0 || recurringDeductions.length > 0) && (
  <div className={styles.recurringSectionultimatedriverPay}>

              <h3 className={styles.subtitleultimatedriverPay}>Load Details</h3>
              <ul className={styles.loadListultimatedriverPay}>
              {filteredLoads.map((load, index) => (
  <li key={index} className={styles.loadItemultimatedriverPay}>
    <input
      type="checkbox"
      checked={selectedLoads.includes(load.loadNumber)}
      onChange={() => handleLoadSelection(load.loadNumber)}
    />
    <strong>Load #:</strong> {load.loadNumber || 'No data'} <br />
    <strong>Pick Up:</strong> {
  load.shippers.length > 0 && load.shippers[0].pickUpTime
    ? new Date(load.shippers[0].pickUpTime).toLocaleString()
    : 'No data'
} <br />
<strong>Delivery:</strong> {
  load.consignees.length > 0 && load.consignees[0].deliveryTime
    ? new Date(load.consignees[0].deliveryTime).toLocaleString()
    : 'No data'
} <br />
    <strong>Rate:</strong> ${parseFloat(load.rate || 0).toFixed(2)} <br />
  </li>
))}

              </ul>

             
             <div className={styles.recurringSectionultimatedriverPay}>


  {/* DEDUCTIONS */}
  {truckCosts.length > 0 && (
  <div className={styles.formGroupultimatedriverPay}>
            {/* OWNER FUEL – QUICK DEDUCTIONS */}
{selectedDriver?.driverType === "owner_operator" &&
 ownerFuelDeductions.length > 0 && (
  <div className={styles.formGroupultimatedriverPay}>
    <label>Fuel (Owner – Open)</label>

    {ownerFuelDeductions.map(fuel => (
      <div
        key={fuel.fuelReportId}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "6px",
          padding: "6px 8px",
          border: "1px solid #333",
          borderRadius: "6px",
          fontSize: "12px"
        }}
      >
        <div>
          <strong>Fuel</strong>
          <div style={{ color: "#999" }}>
            {fuel.description}
          </div>
        </div>

        <button
          onClick={() => {
            setRecurringDeductions(prev => {
              if (prev.some(d => d.fuelReportId === fuel.fuelReportId)) {
                return prev;
              }
              return [...prev, fuel];
            });
          }}
          className={styles.addButtonultimatedriverPay}
        >
          Add
        </button>
      </div>
    ))}
  </div>
)}
   <label>Truck Costs (Quick Deductions)</label>

{truckCostDeductions.map(cost => (
  <div key={cost._id} style={itemStyle}>
    <div>
      <strong>{cost.category}</strong>
      {cost.vendor && ` – ${cost.vendor}`}
      <div style={{ color: "#999" }}>
        {cost.description || "No description"}
      </div>
    </div>

    <button
      onClick={() => {
 const item = {
  type: cost.category,
  description: `${cost.vendor ? `${cost.vendor} – ` : ""}${cost.description || cost.category || ""}${formatAssetCostProgress(cost)}`,
  amount: Number(cost.amount) || 0,
  date: cost.nextBillingDate
    ? cost.nextBillingDate.split("T")[0]
    : cost.startDate
      ? cost.startDate.split("T")[0]
      : new Date().toISOString().split("T")[0],
  source: "truck-cost",
  assetCostId: cost._id,
};

        setRecurringDeductions(prev =>
          prev.some(d => d.assetCostId === cost._id)
            ? prev
            : [...prev, item]
        );
      }}
      className={styles.addButtonultimatedriverPay}
    >
      Add
    </button>
  </div>
))}
<label>Truck Costs (Quick Additions)</label>

{truckCostAdditions.map(cost => (
  <div key={cost._id} style={itemStyle}>
    <div>
      <strong>{cost.category}</strong>
      {cost.vendor && ` – ${cost.vendor}`}
      <div style={{ color: "#999" }}>
        {cost.description || "No description"}
      </div>
    </div>

    <button
      onClick={() => {
       const item = {
  type: cost.category,
  description: `${cost.vendor ? `${cost.vendor} – ` : ""}${cost.description || cost.category || ""}${formatAssetCostProgress(cost)}`,
  amount: Number(cost.amount) || 0,
  date: cost.nextBillingDate
    ? cost.nextBillingDate.split("T")[0]
    : cost.startDate
      ? cost.startDate.split("T")[0]
      : new Date().toISOString().split("T")[0],
  source: "truck-cost",
  assetCostId: cost._id,
};

        setRecurringAdditions(prev =>
          prev.some(a => a.assetCostId === cost._id)
            ? prev
            : [...prev, item]
        );
      }}
      className={styles.addButtonultimatedriverPay}
    >
      Add
    </button>
  </div>
))}

  </div>
)}

  <div className={styles.formGroupultimatedriverPay}>
    <label>Recurring Deductions</label>
{recurringDeductions.map((item, index) => (
  <div key={index} className={styles.recurringItemultimatedriverPay}>
   <div style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
  {/* TYPE */}
  {isLocked(item) ? (
    <input
      type="text"
      value={item.type}
      disabled
      className={styles.inputFieldultimatedriverPay}
      style={{ flex: 1, opacity: 0.6 }}
    />
  ) : (
    <select
      value={item.type}
      onChange={(e) => {
        const updated = [...recurringDeductions];
        updated[index].type = e.target.value;
        setRecurringDeductions(updated);
      }}
      className={styles.selectFieldultimatedriverPay}
      style={{ flex: 1 }}
    >
      <option value="">Select Type</option>
      <option value="Fuel">Fuel</option>
      <option value="Insurance">Insurance</option>
      <option value="Cash Advance">Cash Advance</option>
      <option value="Maintenance">Maintenance</option>
      <option value="IFTA">IFTA</option>
      <option value="Other">Other</option>
    </select>
  )}

  {/* DESCRIPTION */}
  <input
    type="text"
    value={item.description}
    disabled={isLocked(item)}
    onChange={(e) => {
      if (isLocked(item)) return;
      const updated = [...recurringDeductions];
      updated[index].description = e.target.value;
      setRecurringDeductions(updated);
    }}
    className={styles.inputFieldultimatedriverPay}
    style={{ flex: 1, opacity: isLocked(item) ? 0.6 : 1 }}
  />
</div>

<div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
  {/* DATE */}
  <input
    type="date"
    value={item.date || new Date().toISOString().split("T")[0]}
    disabled={isLocked(item)}
    onChange={(e) => {
      if (isLocked(item)) return;
      const updated = [...recurringDeductions];
      updated[index].date = e.target.value;
      setRecurringDeductions(updated);
    }}
    className={styles.inputFieldultimatedriverPay}
    style={{ flex: 1, opacity: isLocked(item) ? 0.6 : 1 }}
  />

  {/* AMOUNT */}
  <input
    type="number"
    value={item.amount}
    disabled={isLocked(item)}
    onChange={(e) => {
      if (isLocked(item)) return;
      const updated = [...recurringDeductions];
      updated[index].amount = e.target.value;
      setRecurringDeductions(updated);
    }}
    className={styles.inputFieldultimatedriverPay}
    style={{ flex: 1, opacity: isLocked(item) ? 0.6 : 1 }}
  />

  {/* REMOVE – DOAR DACĂ NU E FUEL */}
  {item.source !== "fuel" && (
    <button
      onClick={() => removeRecurring("deduction", index)}
      className={styles.removeButtonultimatedriverPay}
    >
      X
    </button>
  )}
</div>
<div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
  <input
    type="text"
    value={item.notes || ""}
    disabled
    placeholder="Notes"
    className={styles.inputFieldultimatedriverPay}
    style={{ flex: 1, opacity: 0.6 }}
  />
</div>
  </div>
))}

    
  </div>

<div className={styles.formGroupultimatedriverPay}>
  <label>Recurring Additions</label>
  {recurringAdditions.map((item, index) => (
    <div key={index} className={styles.recurringItemultimatedriverPay}>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
        <input
          type="text"
          value={item.type || ""}
          disabled
          className={styles.inputFieldultimatedriverPay}
          style={{ flex: 1, opacity: 0.6 }}
        />

        <input
          type="text"
          value={item.description || ""}
          disabled
          className={styles.inputFieldultimatedriverPay}
          style={{ flex: 1, opacity: 0.6 }}
        />
      </div>

      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <input
          type="date"
          value={item.date || new Date().toISOString().split("T")[0]}
          disabled
          className={styles.inputFieldultimatedriverPay}
          style={{ flex: 1, opacity: 0.6 }}
        />

        <input
          type="number"
          value={item.amount}
          disabled
          className={styles.inputFieldultimatedriverPay}
          style={{ flex: 1, opacity: 0.6 }}
        />

        <button
          onClick={() => removeRecurring("addition", index)}
          className={styles.removeButtonultimatedriverPay}
        >
          X
        </button>
      </div>
      <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
  <input
    type="text"
    value={item.notes || ""}
    disabled
    placeholder="Notes"
    className={styles.inputFieldultimatedriverPay}
    style={{ flex: 1, opacity: 0.6 }}
  />
</div>
    </div>
  ))}
</div>

  <div className={styles.formGroupultimatedriverPay}>
  <label>Manual Deductions</label>

  {manualDeductions.map((item, index) => (
    <div key={index} className={styles.recurringItemultimatedriverPay}>
      <div style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
        <select
          value={item.type}
          onChange={(e) => updateManualItem("deduction", index, "type", e.target.value)}
          className={styles.selectFieldultimatedriverPay}
          style={{ flex: 1 }}
        >
          <option value="">Select Type</option>
          {manualDeductionTypes.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>

        <input
          type="date"
          value={item.date || ""}
          onChange={(e) => updateManualItem("deduction", index, "date", e.target.value)}
          className={styles.inputFieldultimatedriverPay}
          style={{ flex: 1 }}
        />
      </div>

      <div style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
        <input
          type="text"
          placeholder="Service / Description"
          value={item.description}
          onChange={(e) => updateManualItem("deduction", index, "description", e.target.value)}
          className={styles.inputFieldultimatedriverPay}
          style={{ flex: 2 }}
        />

        <input
          type="number"
          placeholder="Amount"
          value={item.amount}
          onChange={(e) => updateManualItem("deduction", index, "amount", e.target.value)}
          className={styles.inputFieldultimatedriverPay}
          style={{ flex: 1 }}
        />
      </div>

      <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "8px" }}>
        <input
          type="text"
          placeholder="Notes (optional)"
          value={item.notes || ""}
          onChange={(e) => updateManualItem("deduction", index, "notes", e.target.value)}
          className={styles.inputFieldultimatedriverPay}
          style={{ flex: 1 }}
        />

        <button
          type="button"
          onClick={() => removeManualItem("deduction", index)}
          className={styles.removeButtonultimatedriverPay}
        >
          X
        </button>
      </div>
    </div>
  ))}

  <button
    onClick={addManualDeduction}
    className={styles.addButtonultimatedriverPay}
  >
    + Add Manual Deduction
  </button>
</div>
<div className={styles.formGroupultimatedriverPay}>
  <label>Manual Additions</label>

  {manualAdditions.map((item, index) => (
    <div key={index} className={styles.recurringItemultimatedriverPay}>
      <div style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
        <select
          value={item.type}
          onChange={(e) => updateManualItem("addition", index, "type", e.target.value)}
          className={styles.selectFieldultimatedriverPay}
          style={{ flex: 1 }}
        >
          <option value="">Select Type</option>
          {manualAdditionTypes.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>

        <input
          type="date"
          value={item.date || ""}
          onChange={(e) => updateManualItem("addition", index, "date", e.target.value)}
          className={styles.inputFieldultimatedriverPay}
          style={{ flex: 1 }}
        />
      </div>

      <div style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
        <input
          type="text"
          placeholder="Service / Description"
          value={item.description}
          onChange={(e) => updateManualItem("addition", index, "description", e.target.value)}
          className={styles.inputFieldultimatedriverPay}
          style={{ flex: 2 }}
        />

        <input
          type="number"
          placeholder="Amount"
          value={item.amount}
          onChange={(e) => updateManualItem("addition", index, "amount", e.target.value)}
          className={styles.inputFieldultimatedriverPay}
          style={{ flex: 1 }}
        />
      </div>

      <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "8px" }}>
        <input
          type="text"
          placeholder="Notes (optional)"
          value={item.notes || ""}
          onChange={(e) => updateManualItem("addition", index, "notes", e.target.value)}
          className={styles.inputFieldultimatedriverPay}
          style={{ flex: 1 }}
        />

        <button
          type="button"
          onClick={() => removeManualItem("addition", index)}
          className={styles.removeButtonultimatedriverPay}
        >
          X
        </button>
      </div>
    </div>
  ))}

  <button
    onClick={addManualAddition}
    className={styles.addButtonultimatedriverPay}
  >
    + Add Manual Addition
  </button>
</div>
</div>

 <button
  onClick={async () => {
    // GUARD 1: driver selectat
    if (!selectedDriver) {
      notify("You must select a driver first.", "error");
      return;
    }

    // GUARD 2: date selectate
    if (!startDate || !endDate) {
      notify("Start date and end date are required.", "error");
      return;
    }

    // GUARD 3: load-uri selectate
    if (!selectedLoads || selectedLoads.length === 0) {
      notify("You must select at least one load to preview the PDF.", "error");
      return;
    }

    try {
      // 📄 DOAR GENERARE + PREVIEW PDF
      await generatePDF();
    } catch (err) {
      console.error("❌ PDF preview failed:", err);
      notify("Failed to generate PDF preview.", "error");
    }
  }}
  className={styles.previewButtonultimatedriverPay}
>
  Preview PDF
</button>

<button
  onClick={async () => {

    if (!selectedDriver) {
      notify("You must select a driver first.", "error");
      return;
    }

    if (!startDate || !endDate) {
      notify("Start date and end date are required.", "error");
      return;
    }

   if (!autoGenerateSettlement && !settlementNumber.trim()) {
  notify("Settlement number is required.", "error");
  return;
}


    const saved = await handleAddDriverPay();
    if (!saved) {
      notify("Saving failed.", "error");
      return;
    }

    await markFuelAsPaid();
    await markAssetCostsAsPaid();

    notify("Settlement saved successfully.", "success");

  }}
  className={styles.saveButtonultimatedriverPay}
>
  Save Settlement
</button>




            </div>
          )}
        </div>
      )}
      <EmailPanel />
    </div>
    
  );
};

const FleetReport = ({
  trucks,
  loads,
  logo: logoProp,
  clientInfo,
}) => {
  const { notify } = useNotification();

  const safeClientInfo = clientInfo || {
    companyName: "",
    companyAddress: "",
  };

  // ─── STATE ────────────────────────────────────────────────────────────────
  const [selectedTruck, setSelectedTruck] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedLoads, setSelectedLoads] = useState([]);
  const [driverPays, setDriverPays] = useState([]);
  const [selectedDriverPayIds, setSelectedDriverPayIds] = useState([]);
  const [recurringDeductions, setRecurringDeductions] = useState([]);
  const [recurringAdditions, setRecurringAdditions] = useState([]);
  const [manualDeductions, setManualDeductions] = useState([]);
  const [manualAdditions, setManualAdditions] = useState([]);
  const [truckFuelDeductions, setTruckFuelDeductions] = useState([]);
  const [truckCosts, setTruckCosts] = useState([]);
  const [fleetNumber, setFleetNumber] = useState("");
  const [autoGenerateSettlement, setAutoGenerateSettlement] = useState(true);

  // PDF Settings state (all internal, no props conflict)
  const [pdfSettingsModalOpen, setPdfSettingsModalOpen] = useState(false);
  const [pdfSubtitle, setPdfSubtitle] = useState("");
  const [pdfExtraHeaderLine, setPdfExtraHeaderLine] = useState("");
  const [showFleetNumber, setShowFleetNumber] = useState(true);
  const [showTruckNumber, setShowTruckNumber] = useState(true);
  const [showDriver, setShowDriver] = useState(true);
  const [showOwner, setShowOwner] = useState(true);
  const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);
const [logo, setLogo] = useState(null);
  const [localCustomFooterText, setLocalCustomFooterText] = useState("");
  const [localUseCustomFooter, setLocalUseCustomFooter] = useState(false);

  // ─── DERIVED ──────────────────────────────────────────────────────────────
  const truckCostDeductions = truckCosts.filter((c) => c.type === "deduction");
  const truckCostAdditions  = truckCosts.filter((c) => c.type === "addition");

  const manualDeductionTypes = [
    "Fuel","Maintenance","Insurance","Cash Advance","IFTA",
    "Tolls","ELD","Trailer Rent","Truck Payment","Repair","Advance","Other",
  ];
  const manualAdditionTypes = [
    "Bonus","Referral","Reimbursement","Detention","Layover",
    "Extra Stop","Safety Bonus","Clean Inspection Bonus","Other",
  ];

 // ─── AUTH — mută tokenul ÎNAINTE de orice useEffect ──────────────────────────
const token = sessionStorage.getItem("token");
const config = useMemo(() => ({
  headers: { Authorization: `Bearer ${token}` },
  withCredentials: true,
}), [token]);

// ─── FETCH TOATE SETĂRILE LA MOUNT ───────────────────────────────────────────
useEffect(() => {
  const fetchSettings = async () => {
    const t = sessionStorage.getItem("token");
    const cfg = {
      headers: { Authorization: `Bearer ${t}` },
      withCredentials: true,
    };

    // ✅ allSettled — fiecare request e independent, eșecul unuia nu blochează restul
    const [footerResult, logoResult, pdfSettingsResult] = await Promise.allSettled([
      axios.get("https://api-backend.full-trucking-service.com/api/footer", cfg),
      axios.get("https://api-backend.full-trucking-service.com/api/logo", cfg),
      axios.get("https://api-backend.full-trucking-service.com/api/fleet-report-pdf-settings", cfg),
    ]);

    // Footer
    if (footerResult.status === "fulfilled" && footerResult.value.status === 200) {
      setLocalCustomFooterText(footerResult.value.data.customFooterText || "");
      setLocalUseCustomFooter(footerResult.value.data.useCustomFooter || false);
    }

    // Logo
    if (logoResult.status === "fulfilled" && logoResult.value.data?.logo) {
      setLogo(logoResult.value.data.logo);
    }

    // PDF Settings
    if (pdfSettingsResult.status === "fulfilled" && pdfSettingsResult.value.status === 200) {
      const s = pdfSettingsResult.value.data;

      setPdfSubtitle(s.pdfSubtitle || "");
      setPdfExtraHeaderLine(s.pdfExtraHeaderLine || "");
      setShowFleetNumber(s.showFleetNumber ?? true);
      setShowTruckNumber(s.showTruckNumber ?? true);
      setShowDriver(s.showDriver ?? true);
      setShowOwner(s.showOwner ?? true);

      const autoGen = s.autoGenerateSettlement ?? true;
      setAutoGenerateSettlement(autoGen);

      if (autoGen) {
        setFleetNumber(`FR-${Date.now()}`);
      } else if (s.fleetNumberPrefix) {
        setFleetNumber(s.fleetNumberPrefix);
      }
    }
  };

  fetchSettings();
}, []); // eslint-disable-line react-hooks/exhaustive-deps


// ─── SAVE PDF SETTINGS TO DB ──────────────────────────────────────────────────
// Adaugă această funcție înainte de return()

const handleSavePdfSettings = async () => {
  try {
    await axios.put(
      "https://api-backend.full-trucking-service.com/api/fleet-report-pdf-settings",
      {
        pdfSubtitle,
        pdfExtraHeaderLine,
        showFleetNumber,
        showTruckNumber,
        showDriver,
        showOwner,
        autoGenerateSettlement,
        // Salvăm prefixul manual dacă autoGenerate e dezactivat
        fleetNumberPrefix: autoGenerateSettlement ? "FR" : fleetNumber,
      },
      config
    );
    notify("PDF settings saved.", "success");
  } catch (err) {
    notify("Failed to save PDF settings.", "error");
  }
};

  // ─── AUTO FLEET NUMBER ────────────────────────────────────────────────────
  useEffect(() => {
    if (autoGenerateSettlement) {
      setFleetNumber(`FR-${Date.now()}`);
    }
  }, [autoGenerateSettlement]);

  // ─── FETCH DRIVER PAYS FOR TRUCK ──────────────────────────────────────────
  useEffect(() => {
    const fetchDriverPays = async () => {
      if (!selectedTruck) { setDriverPays([]); return; }
      try {
        const res = await axios.get(
          `https://api-backend.full-trucking-service.com/api/driverpays/by-truck/${selectedTruck._id}`,
          { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` }, withCredentials: true }
        );
        setDriverPays((res.data || []).filter((p) => !p.includedInFleetReport));
      } catch (err) {
        console.error("❌ Failed to fetch driver pays", err);
        setDriverPays([]);
      }
    };
    fetchDriverPays();
  }, [selectedTruck]);

  // ─── FETCH TRUCK COSTS ────────────────────────────────────────────────────
  useEffect(() => {
    const fetchTruckCosts = async () => {
      if (!selectedTruck) { setTruckCosts([]); return; }
      try {
        const res = await axios.get(
          `https://api-backend.full-trucking-service.com/api/asset-costs/by-truck/${selectedTruck._id}`,
          config
        );
        setTruckCosts(res.data || []);
      } catch (err) {
        console.error("❌ Failed to fetch truck costs", err);
        setTruckCosts([]);
      }
    };
    fetchTruckCosts();
  }, [selectedTruck]);

  // ─── FETCH TRUCK FUEL ─────────────────────────────────────────────────────
  useEffect(() => {
    const fetchTruckFuel = async () => {
      if (!selectedTruck || !startDate || !endDate) { setTruckFuelDeductions([]); return; }
      try {
        const res = await axios.get(
          `https://api-backend.full-trucking-service.com/api/fuel-reports/truck/${selectedTruck._id}`,
          config
        );
        const fuelRows = (res.data || [])
          .filter((f) => f.fuelResponsibility === "owner" && f.fuelPaymentStatus === "open")
          .filter((f) => {
            const d = new Date(f.transactionDate);
            return d >= new Date(startDate) && d <= new Date(endDate);
          })
          .map((f) => ({
            type: "Fuel",
            description: `Fuel – ${f.merchant || "Unknown"} – ${new Date(f.transactionDate).toLocaleDateString()}`,
            amount: Number(f.totalToPay || 0),
            date: new Date(f.transactionDate).toISOString().split("T")[0],
            source: "fuel",
            fuelReportId: f._id,
          }));
        setTruckFuelDeductions(fuelRows);
      } catch (err) {
        console.error("❌ Failed to fetch truck fuel", err);
        setTruckFuelDeductions([]);
      }
    };
    fetchTruckFuel();
  }, [selectedTruck, startDate, endDate]);

  // ─── HELPERS ──────────────────────────────────────────────────────────────
  const toNumber = (val) => { const n = parseFloat(val); return isNaN(n) ? 0 : n; };

  // FIX #2: driver name helper — suportă multiple câmpuri posibile din DB
  const getDriverName = (truck) => {
    if (!truck) return "N/A";
    return (
      truck.driverName ||
      truck.driver ||
      (truck.driverId
        ? `${truck.driverId.firstName || ""} ${truck.driverId.lastName || ""}`.trim()
        : "") ||
      "N/A"
    );
  };

  const formatAssetCostProgress = (cost) => {
    if (cost.paymentType !== "recurring") return "";
    const total = cost.recurrence?.occurrences;
    if (!total) return "";
    const paid = Array.isArray(cost.payments)
      ? cost.payments.filter((p) => p.status === "paid").length : 0;
    const totalAmount = Number(cost.amount || 0) * total;
    return ` ${paid + 1}/${total} from $${totalAmount.toFixed(2)}`;
  };

  // ─── LOGO HANDLER (saves to DB) ───────────────────────────────────────────
const handleLogoChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;
  if (file.size > 5000000) { notify("File too large (max 5MB).", "error"); return; }
  if (!file.type.startsWith("image/")) { notify("Invalid file type.", "error"); return; }
  const reader = new FileReader();
  reader.onload = async (event) => {
    const imageData = event.target.result;
    try {
      await axios.put(
        "https://api-backend.full-trucking-service.com/api/logo",
        { logo: imageData },
        config
      );
      setLogo(imageData); // ← nu mai e setLocalLogo
      notify("Logo saved.", "success");
    } catch (err) {
      notify("Failed to save logo.", "error");
    }
  };
  reader.readAsDataURL(file);
};

const handleLogoRemove = async () => {
  try {
    await axios.delete("https://api-backend.full-trucking-service.com/api/logo", config);
    setLogo(null); // ← nu mai e setLocalLogo
    notify("Logo removed.", "success");
  } catch (err) {
    notify("Failed to remove logo.", "error");
  }
};

  // ─── FOOTER HANDLER (saves to DB) ─────────────────────────────────────────
  const handleSaveFooter = async () => {
    try {
      await axios.put(
        "https://api-backend.full-trucking-service.com/api/footer",
        { customFooterText: localCustomFooterText, useCustomFooter: localUseCustomFooter },
        config
      );
      notify("Footer saved.", "success");
    } catch (err) {
      notify("Failed to save footer.", "error");
    }
  };

  // ─── SELECT TRUCK ─────────────────────────────────────────────────────────
  const handleTruckSelect = (e) => {
    const truck = trucks.find((t) => t._id === e.target.value);
    setSelectedTruck(truck || null);
    setFilteredLoads([]);
    setSelectedLoads([]);
    setRecurringAdditions([]);
    setRecurringDeductions([]);
    setManualAdditions([]);
    setManualDeductions([]);
    setSelectedDriverPayIds([]);
  };

  // ─── SEARCH LOADS ─────────────────────────────────────────────────────────
  const searchLoads = () => {
    if (!selectedTruck || !startDate || !endDate) return;
    const filtered = loads.filter((load) => {
      if (load.status !== "Completed") return false;
      if (load.truck?.toString() !== selectedTruck._id.toString()) return false;
      const hasPickup   = load.shippers.some((s) => s.pickUpTime && new Date(s.pickUpTime) >= new Date(startDate));
      const hasDelivery = load.consignees.some((c) => c.deliveryTime && new Date(c.deliveryTime) <= new Date(endDate));
      return hasPickup && hasDelivery;
    });
    setFilteredLoads(filtered);
  };

  const handleLoadSelection = (loadNumber) => {
    setSelectedLoads((prev) =>
      prev.includes(loadNumber) ? prev.filter((n) => n !== loadNumber) : [...prev, loadNumber]
    );
  };

  // ─── MANUAL ITEMS ─────────────────────────────────────────────────────────
  const addManualDeduction = () =>
    setManualDeductions((prev) => [...prev, { type: "", description: "", date: new Date().toISOString().slice(0, 10), amount: "", notes: "" }]);

  const addManualAddition = () =>
    setManualAdditions((prev) => [...prev, { type: "", description: "", date: new Date().toISOString().slice(0, 10), amount: "", notes: "" }]);

  const updateManualItem = (kind, index, field, value) => {
    if (kind === "deduction") {
      const updated = [...manualDeductions];
      updated[index] = { ...updated[index], [field]: value };
      setManualDeductions(updated);
    } else {
      const updated = [...manualAdditions];
      updated[index] = { ...updated[index], [field]: value };
      setManualAdditions(updated);
    }
  };

  const removeManualItem = (kind, index) => {
    if (kind === "deduction") setManualDeductions((prev) => prev.filter((_, i) => i !== index));
    else setManualAdditions((prev) => prev.filter((_, i) => i !== index));
  };

  const normalizeManualItems = (items) =>
    items.map((item) => ({
      type: item.type || "",
      description: item.description || "",
      amount: parseFloat(item.amount || 0),
      date: item.date || new Date().toISOString().split("T")[0],
      notes: item.notes || "",
      source: "manual",
    }));

  // ─── CALCULATE PAY ────────────────────────────────────────────────────────
  const totalDriverPayrollCost = driverPays
    .filter((pay) => selectedDriverPayIds.includes(pay._id))
    .reduce((sum, pay) => sum + Number(pay.totalWithAdjustments || 0), 0);

  const calculatePay = () => {
    const payDetails = filteredLoads
      .filter((load) => selectedLoads.includes(load.loadNumber))
      .map((load) => {
        let pay = 0;
        switch (selectedTruck?.settlement) {
          case "Hourly pay":      pay = toNumber(selectedTruck.hoursWorked) * toNumber(selectedTruck.settlementAmount); break;
          case "Per mile pay":    pay = toNumber(load.miles) * toNumber(selectedTruck.normalMileRate) + toNumber(load.dh) * toNumber(selectedTruck.dhMileRate); break;
          case "Fixed salary":    pay = toNumber(selectedTruck.settlementAmount); break;
          case "Percentage of the load": pay = toNumber(load.rate) * toNumber(selectedTruck.settlementAmount) / 100; break;
          case "Team driver pay": pay = toNumber(load.rate) / 2; break;
        }
        return {
          loadNumber: load.loadNumber,
          rate: toNumber(load.rate),
          miles: toNumber(load.miles),
          dh: toNumber(load.dh),
          pay,
          shippers: load.shippers || [],
          consignees: load.consignees || [],
        };
      });

    const totalRate = payDetails.reduce((sum, d) => sum + d.rate, 0);
    const totalPay  = payDetails.reduce((sum, d) => sum + d.pay, 0);

    const totalAdditions  = [...recurringAdditions, ...manualAdditions].reduce((sum, a) => sum + toNumber(a.amount), 0);
    const totalDeductions = [...recurringDeductions, ...manualDeductions].reduce((sum, d) => sum + toNumber(d.amount), 0);

    // FIX #1: era -Math.abs(totalDriverPayrollCost) care aplica minus de două ori
    // totalDriverPayrollCost este deja pozitiv, îl scădem o singură dată
    const totalPayWithAdjustments = totalPay + totalAdditions - totalDeductions - totalDriverPayrollCost;

    return {
      payDetails,
      totalRate,
      totalPay,
      totalPayWithAdjustments: Number.isFinite(totalPayWithAdjustments) ? totalPayWithAdjustments : 0,
    };
  };

  const toggleDriverPaySelection = (id) =>
    setSelectedDriverPayIds((prev) =>
      prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id]
    );

  const { totalPay, totalPayWithAdjustments } = calculatePay();

  // ─── GENERATE PDF ─────────────────────────────────────────────────────────
  const generatePDF = async () => {
    const { payDetails, totalPay, totalPayWithAdjustments } = calculatePay();
    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "letter" });

    const COLOR = {
      navy:      [10,  31,  68],
      navyLight: [22,  54, 110],
      gold:      [212, 160,  23],
      white:     [255, 255, 255],
      offWhite:  [248, 249, 252],
      lightGray: [230, 234, 241],
      midGray:   [150, 162, 180],
      darkText:  [18,  28,  48],
      greenPay:  [15, 118,  82],
      redDed:    [185,  28,  28],
      blueSub:   [37,  99, 235],
    };

    const PAGE_W = 215.9;
    const PAGE_H = 279.4;
    const MARGIN = 14;
    const today  = new Date().toISOString().split("T")[0];

    const setFill  = (c) => doc.setFillColor(...c);
    const setColor = (c) => doc.setTextColor(...c);
    const setFont  = (size, style = "normal") => { doc.setFontSize(size); doc.setFont("helvetica", style); };
    const hRule    = (y, color = COLOR.gold, thickness = 0.6) => {
      doc.setDrawColor(...color); doc.setLineWidth(thickness);
      doc.line(MARGIN, y, PAGE_W - MARGIN, y);
    };

    const addHeader = () => {
      setFill(COLOR.navy);
      doc.rect(0, 0, PAGE_W, 42, "F");
      setFill(COLOR.gold);
      doc.rect(0, 41, PAGE_W, 1.5, "F");

if (logo && typeof logo === "string") {
  doc.addImage(logo, "PNG", MARGIN, 7, 48, 22);
}

      setColor(COLOR.white); setFont(18, "bold");
      doc.text("FLEET REPORT", PAGE_W - MARGIN, 17, { align: "right" });

      if (pdfSubtitle) {
        setFont(8); setColor(COLOR.gold);
        doc.text(pdfSubtitle.toUpperCase(), PAGE_W - MARGIN, 23, { align: "right" });
      }

      if (showFleetNumber && fleetNumber) {
        setFill(COLOR.gold);
        doc.roundedRect(PAGE_W - MARGIN - 52, 27, 52, 10, 2, 2, "F");
        setColor(COLOR.navy); setFont(7, "bold");
        doc.text(`FLEET #  ${fleetNumber}`, PAGE_W - MARGIN - 26, 33.2, { align: "center" });
      }

      const infoY = 52;
      const col2  = 115;

      // FIX #2: folosim getDriverName() pentru a obține numele corect al driverului
      const driverDisplayName = getDriverName(selectedTruck);

      const leftRows = [
        ...(showTruckNumber ? [["Truck #", selectedTruck?.truckNumber || "N/A"]] : []),
        ...(showDriver      ? [["Driver",  driverDisplayName]] : []),
        ["Pay Period", `${startDate || "N/A"}  –  ${endDate || "N/A"}`],
      ];
      const rightRows = [
        ...(showOwner ? [["Owner", selectedTruck?.owner || "N/A"]] : []),
        ["Report Date", today],
      ];

      let ly = infoY;
      leftRows.forEach(([label, value]) => {
        setFont(7, "bold"); setColor(COLOR.midGray);
        doc.text(label.toUpperCase(), MARGIN, ly);
        setFont(8.5, "normal"); setColor(COLOR.darkText);
        doc.text(value, MARGIN, ly + 4.5);
        ly += 11;
      });

      let ry = infoY;
      rightRows.forEach(([label, value]) => {
        setFont(7, "bold"); setColor(COLOR.midGray);
        doc.text(label.toUpperCase(), col2, ry);
        setFont(8.5, "normal"); setColor(COLOR.darkText);
        doc.text(value, col2, ry + 4.5);
        ry += 11;
      });

      if (pdfExtraHeaderLine) {
        setFont(8); setColor(COLOR.midGray);
        doc.text(pdfExtraHeaderLine, MARGIN, ly + 2);
        ly += 8;
      }

      hRule(ly + 2);
      return ly + 8;
    };

    const addFooter = () => {
      const pageCount = doc.internal.getNumberOfPages();
      const fY = PAGE_H - 18;
      setFill(COLOR.gold); doc.rect(0, fY - 2, PAGE_W, 0.8, "F");
      setFill(COLOR.navy); doc.rect(0, fY - 1.2, PAGE_W, 20, "F");
      setColor(COLOR.white); setFont(7);
      if (localUseCustomFooter && localCustomFooterText) {
        doc.text(localCustomFooterText, PAGE_W / 2, fY + 4, { align: "center" });
      } else {
      doc.text("Thank you for your business!", PAGE_W / 2, fY + 3, { align: "center" });
        doc.text(
          `${safeClientInfo?.companyName || ""}  ·  ${safeClientInfo?.companyAddress || ""}`,
          PAGE_W / 2, fY + 8, { align: "center" }
        );
      }
      setColor(COLOR.gold); setFont(6);
      doc.text("Powered by FleetAcc", PAGE_W / 2, fY + 13, { align: "center" });

      setColor(COLOR.midGray); setFont(7);
      doc.text(`Page ${pageCount}`, PAGE_W - MARGIN, fY + 4, { align: "right" });
    };
    let startY = addHeader();

    const sectionTitle = (label, y) => {
      setFill(COLOR.navyLight);
      doc.roundedRect(MARGIN, y, PAGE_W - MARGIN * 2, 7, 1.5, 1.5, "F");
      setColor(COLOR.gold); setFont(8, "bold");
      doc.text(label.toUpperCase(), MARGIN + 4, y + 4.8);
      return y + 10;
    };

    startY = sectionTitle("Load Details", startY);

    payDetails.forEach((detail, index) => {
      if (startY > PAGE_H - 60) {
        addFooter(); doc.addPage();
        startY = addHeader();
        startY = sectionTitle("Load Details (continued)", startY);
      }

      const pickupDetails = detail.shippers?.length > 0
        ? detail.shippers.map((s) => {
            const dt = !s.pickUpTime || isNaN(new Date(s.pickUpTime).getTime())
              ? "Unknown Date" : new Date(s.pickUpTime).toLocaleString();
            return `${dt}  —  ${s.address || "No data"}`;
          }).join("\n")
        : "No data";

      const deliveryDetails = detail.consignees?.length > 0
        ? detail.consignees.map((c) => {
            const dt = !c.deliveryTime || isNaN(new Date(c.deliveryTime).getTime())
              ? "Unknown Date" : new Date(c.deliveryTime).toLocaleString();
            return `${dt}  —  ${c.address || "No data"}`;
          }).join("\n")
        : "No data";

      doc.autoTable({
        startY,
        body: [
          [{ content: `LOAD  #${detail.loadNumber || index + 1}`, colSpan: 3, styles: { fontStyle: "bold", fontSize: 8, fillColor: COLOR.offWhite, textColor: COLOR.navy, cellPadding: { top: 3, bottom: 3, left: 4, right: 4 } } }],
          [{ content: "Pickup",   styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.white, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } }, { content: pickupDetails,   colSpan: 2, styles: { halign: "left", fillColor: COLOR.white, textColor: COLOR.darkText, fontSize: 7.5 } }],
          [{ content: "Delivery", styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.white, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } }, { content: deliveryDetails, colSpan: 2, styles: { halign: "left", fillColor: COLOR.white, textColor: COLOR.darkText, fontSize: 7.5 } }],
          [{ content: "Rate",     styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.white, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } }, { content: `$${Number(detail.rate || 0).toFixed(2)}`, styles: { halign: "left", fillColor: COLOR.white, textColor: COLOR.darkText, fontSize: 7.5 } }, { content: "", styles: { fillColor: COLOR.white } }],
          [{ content: "Notes",    styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.offWhite, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } }, { content: detail.notes || "—", styles: { fillColor: COLOR.offWhite, textColor: COLOR.darkText, fontSize: 7.5 } }, { content: `$${Number(detail.pay || 0).toFixed(2)}`, styles: { fontStyle: "bold", halign: "right", fillColor: COLOR.offWhite, textColor: COLOR.greenPay, fontSize: 9 } }],
        ],
        theme: "plain",
        styles: { lineColor: COLOR.lightGray, lineWidth: 0.35, cellPadding: 2.5 },
        margin: { left: MARGIN, right: MARGIN },
        tableLineColor: COLOR.lightGray, tableLineWidth: 0.35,
      });

      startY = doc.lastAutoTable.finalY + 5;
    });

    // Sub-Total
    startY += 4;
    doc.autoTable({
      startY,
      body: [[
        { content: "Sub-Total", styles: { fontStyle: "bold", fontSize: 9, textColor: COLOR.darkText } },
        { content: `$${totalPay.toFixed(2)}`, styles: { fontStyle: "bold", halign: "right", fontSize: 10, textColor: COLOR.blueSub } },
      ]],
      theme: "plain",
      styles: { fillColor: COLOR.offWhite, lineColor: COLOR.lightGray, lineWidth: 0.35, cellPadding: { top: 4, bottom: 4, left: 5, right: 5 } },
      margin: { left: MARGIN, right: MARGIN },
      tableLineColor: COLOR.lightGray, tableLineWidth: 0.35,
    });
    startY = doc.lastAutoTable.finalY + 8;

    // Additions
    const additionsForPdf = [
      ...recurringAdditions.map((item) => ({ type: item.type || "Other", description: item.description || "", date: item.date || "", amount: parseFloat(item.amount || 0), notes: item.notes || "" })),
      ...manualAdditions.map((item)    => ({ type: item.type || "Other", description: item.description || "", date: item.date || "", amount: parseFloat(item.amount || 0), notes: item.notes || "" })),
    ];
    const deductionsForPdf = [
      ...recurringDeductions.map((item) => ({ type: item.type || "Other", description: item.description || "", date: item.date || "", amount: parseFloat(item.amount || 0), notes: item.notes || "" })),
      ...manualDeductions.map((item)    => ({ type: item.type || "Other", description: item.description || "", date: item.date || "", amount: parseFloat(item.amount || 0), notes: item.notes || "" })),
    ];

    if (startY > PAGE_H - 70) { addFooter(); doc.addPage(); startY = addHeader(); }
    startY = sectionTitle("Additions", startY);
    doc.autoTable({
      startY,
      head: [[
        { content: "Type / Description / Date", styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
        { content: "Notes",                     styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
        { content: "Amount",                    styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5, halign: "right" } },
      ]],
      body: additionsForPdf.length > 0
        ? additionsForPdf.map((item) => [
            { content: `${item.type}  ·  ${item.description}  ·  ${item.date}`, styles: { fontSize: 7.5, textColor: COLOR.darkText } },
            { content: item.notes, styles: { fontSize: 7.5, textColor: COLOR.midGray } },
            { content: `+$${item.amount.toFixed(2)}`, styles: { fontSize: 7.5, halign: "right", textColor: COLOR.greenPay, fontStyle: "bold" } },
          ])
        : [[{ content: "No additions", colSpan: 3, styles: { halign: "center", textColor: COLOR.midGray, fontSize: 7.5, fontStyle: "italic" } }]],
      theme: "grid",
      styles: { lineColor: COLOR.lightGray, lineWidth: 0.3, cellPadding: 2.5, fontSize: 7.5 },
      alternateRowStyles: { fillColor: COLOR.offWhite },
      headStyles: { fillColor: COLOR.navy },
      margin: { left: MARGIN, right: MARGIN },
    });
    startY = doc.lastAutoTable.finalY + 8;

    if (startY > PAGE_H - 70) { addFooter(); doc.addPage(); startY = addHeader(); }
    startY = sectionTitle("Deductions", startY);
    doc.autoTable({
      startY,
      head: [[
        { content: "Type / Description / Date", styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
        { content: "Notes",                     styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
        { content: "Amount",                    styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5, halign: "right" } },
      ]],
      body: deductionsForPdf.length > 0
        ? deductionsForPdf.map((item) => [
            { content: `${item.type}  ·  ${item.description}  ·  ${item.date}`, styles: { fontSize: 7.5, textColor: COLOR.darkText } },
            { content: item.notes, styles: { fontSize: 7.5, textColor: COLOR.midGray } },
            { content: `-$${item.amount.toFixed(2)}`, styles: { fontSize: 7.5, halign: "right", textColor: COLOR.redDed, fontStyle: "bold" } },
          ])
        : [[{ content: "No deductions", colSpan: 3, styles: { halign: "center", textColor: COLOR.midGray, fontSize: 7.5, fontStyle: "italic" } }]],
      theme: "grid",
      styles: { lineColor: COLOR.lightGray, lineWidth: 0.3, cellPadding: 2.5, fontSize: 7.5 },
      alternateRowStyles: { fillColor: [255, 248, 248] },
      headStyles: { fillColor: COLOR.navy },
      margin: { left: MARGIN, right: MARGIN },
    });
    startY = doc.lastAutoTable.finalY + 8;

    if (startY > PAGE_H - 50) { addFooter(); doc.addPage(); startY = addHeader(); }
    startY = sectionTitle("Driver Payroll Cost", startY);
    doc.autoTable({
      startY,
      head: [[
        { content: "Description", styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
        { content: "Amount",      styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5, halign: "right" } },
      ]],
      body: [[
        { content: "Selected Driver Payroll Cost", styles: { fontSize: 7.5, textColor: COLOR.darkText } },
        // FIX #1: afișăm direct suma pozitivă cu prefix "-$", fără dublu minus
        { content: `-$${totalDriverPayrollCost.toFixed(2)}`, styles: { fontSize: 7.5, halign: "right", textColor: COLOR.redDed, fontStyle: "bold" } },
      ]],
      theme: "grid",
      styles: { lineColor: COLOR.lightGray, lineWidth: 0.3, cellPadding: 2.5, fontSize: 7.5 },
      headStyles: { fillColor: COLOR.navy },
      margin: { left: MARGIN, right: MARGIN },
    });
    startY = doc.lastAutoTable.finalY + 10;

    if (startY > PAGE_H - 40) { addFooter(); doc.addPage(); startY = addHeader(); }
    setFill(COLOR.gold);
    doc.rect(MARGIN, startY, PAGE_W - MARGIN * 2, 0.8, "F");
    startY += 4;

    doc.autoTable({
      startY,
      body: [[
        { content: "GRAND TOTAL — NET PAY", styles: { fontStyle: "bold", fontSize: 11, textColor: COLOR.white, fillColor: COLOR.navy, cellPadding: { top: 5, bottom: 5, left: 6, right: 6 } } },
        { content: `$${totalPayWithAdjustments.toFixed(2)}`, styles: { fontStyle: "bold", fontSize: 14, halign: "right", textColor: COLOR.gold, fillColor: COLOR.navy, cellPadding: { top: 4, bottom: 4, left: 6, right: 6 } } },
      ]],
      theme: "plain",
      margin: { left: MARGIN, right: MARGIN },
      tableLineWidth: 0,
    });

    const finalY = doc.lastAutoTable.finalY;
    setFill(COLOR.gold);
    doc.rect(MARGIN, finalY, PAGE_W - MARGIN * 2, 1.2, "F");

    addFooter();
    doc.save(`fleet_report_${fleetNumber || "report"}.pdf`);
  };

  // ─── MARK PAID HELPERS ────────────────────────────────────────────────────
  const markTruckCostsAsPaid = async () => {
    const assetCostIds = [...new Set(
      [...recurringDeductions, ...recurringAdditions]
        .filter((item) => item?.source === "truck-cost" && item?.assetCostId)
        .map((item) => item.assetCostId.toString())
    )];
    if (assetCostIds.length === 0) return;
    await axios.put("https://api-backend.full-trucking-service.com/api/asset-costs/mark-paid", { assetCostIds }, config);
  };

  const markFuelAsPaid = async () => {
    const fuelIds = recurringDeductions.filter((d) => d.source === "fuel").map((d) => d.fuelReportId);
    if (fuelIds.length === 0) return;
    await axios.put("https://api-backend.full-trucking-service.com/api/fuel-reports/mark-paid", { fuelIds }, config);
  };

  // ─── SAVE FLEET REPORT ────────────────────────────────────────────────────
  const handleSaveFleetReport = async () => {
    if (!selectedTruck || !startDate || !endDate) return false;
    const { payDetails, totalPay, totalPayWithAdjustments } = calculatePay();
    const transformedManualAdditions  = normalizeManualItems(manualAdditions);
    const transformedManualDeductions = normalizeManualItems(manualDeductions);
    try {
      const res = await axios.post(
        "https://api-backend.full-trucking-service.com/api/fleet-reports",
        {
          fleetNumber,
          truck: selectedTruck._id,
          startDate,
          endDate,
          payDetails,
          recurringAddition:  [...recurringAdditions],
          recurringDeduction: [...recurringDeductions],
          manualAdditions:    transformedManualAdditions,
          manualDeductions:   transformedManualDeductions,
          driverPayIds:       [...selectedDriverPayIds],
          totalPay,
          totalWithAdjustments: totalPayWithAdjustments,
        },
        config
      );
      return res.status === 201;
    } catch {
      return false;
    }
  };

  // FIX #3: resetare completă după save reușit
  const resetForm = () => {
    setSelectedTruck(null);
    setStartDate("");
    setEndDate("");
    setFilteredLoads([]);
    setSelectedLoads([]);
    setRecurringAdditions([]);
    setRecurringDeductions([]);
    setManualAdditions([]);
    setManualDeductions([]);
    setSelectedDriverPayIds([]);
    setDriverPays([]);
    setTruckCosts([]);
    setTruckFuelDeductions([]);
    if (autoGenerateSettlement) {
      setFleetNumber(`FR-${Date.now()}`);
    }
  };

  // ─── UI ───────────────────────────────────────────────────────────────────
  return (
    <div className={styles.ultimatefleetreportSection} data-theme={theme}>
      <h2 className={styles.titlefleetreportultimatedriverPay}>Fleet Report</h2>

      <div className={styles.formGroupultimatefleetreport}>
        <label>Select Truck</label>
        <select
          value={selectedTruck?._id || ""}
          onChange={handleTruckSelect}
          className={styles.selectFieldultimatefleetreport}
        >
          <option value="">Select Truck</option>
          {trucks.map((truck) => (
            <option key={truck._id} value={truck._id}>{truck.truckNumber}</option>
          ))}
        </select>
      </div>

      {selectedTruck && (
        <>
          <div className={styles.formRowultimatefleetreport}>
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className={styles.inputFieldultimatefleetreport} />
            <input type="date" value={endDate}   onChange={(e) => setEndDate(e.target.value)}   className={styles.inputFieldultimatefleetreport} />
          </div>

          <button onClick={searchLoads} className={styles.actionButtonultimatefleetreport}>Search</button>

          <button onClick={() => setPdfSettingsModalOpen(true)} className={styles.openPdfSettingsButton}>
            Configure PDF Fleet Report
          </button>

          {/* ─── PDF SETTINGS MODAL ─────────────────────────────────────── */}
          {pdfSettingsModalOpen && (
            <div className={styles.pdfModalOverlay}>
              <div className={styles.pdfModalContainer}>
                <div className={styles.pdfModalHeader}>
                  <h3>Fleet Report PDF Settings</h3>
                  <button onClick={() => setPdfSettingsModalOpen(false)} className={styles.pdfModalClose}>✕</button>
                </div>
                <div className={styles.pdfModalContent}>

                  {/* LOGO */}
                  <div className={styles.formGroupultimatefleetreport}>
                    <label>Company Logo</label>
                    <input type="file" onChange={handleLogoChange} />
                   {logo && (
  <div className={styles.logoPreview}>
    <img src={logo} alt="Logo" />
    <button onClick={handleLogoRemove}>Remove</button>
  </div>
)}
                  </div>

                  {/* FLEET NUMBER */}
                  <div className={styles.formGroupultimatefleetreport}>
                    <label>Fleet Report Number</label>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <input
                        type="text"
                        value={fleetNumber}
                        disabled={autoGenerateSettlement}
                        onChange={(e) => setFleetNumber(e.target.value)}
                        className={styles.inputFieldultimatefleetreport}
                      />
                      <label>
                        <input
                          type="checkbox"
                          checked={autoGenerateSettlement}
                          onChange={(e) => setAutoGenerateSettlement(e.target.checked)}
                        /> Auto
                      </label>
                    </div>
                  </div>

                  {/* SUBTITLE */}
                  <div className={styles.formGroupultimatefleetreport}>
                    <label>Subtitle</label>
                    <input
                      type="text"
                      value={pdfSubtitle}
                      onChange={(e) => setPdfSubtitle(e.target.value)}
                      className={styles.inputFieldultimatefleetreport}
                    />
                  </div>

                  {/* EXTRA HEADER LINE */}
                  <div className={styles.formGroupultimatefleetreport}>
                    <label>Extra Header Line</label>
                    <input
                      type="text"
                      value={pdfExtraHeaderLine}
                      onChange={(e) => setPdfExtraHeaderLine(e.target.value)}
                      className={styles.inputFieldultimatefleetreport}
                    />
                  </div>

                  {/* TOGGLES */}
                  <div className={styles.formGroupultimatefleetreport}>
                    <label>Display On PDF</label>
                    <div className={styles.pdfToggleGrid}>
                      <label><input type="checkbox" checked={showFleetNumber} onChange={(e) => setShowFleetNumber(e.target.checked)} /> Fleet #</label>
                      <label><input type="checkbox" checked={showTruckNumber} onChange={(e) => setShowTruckNumber(e.target.checked)} /> Truck #</label>
                      <label><input type="checkbox" checked={showDriver}      onChange={(e) => setShowDriver(e.target.checked)}      /> Driver</label>
                      <label><input type="checkbox" checked={showOwner}       onChange={(e) => setShowOwner(e.target.checked)}       /> Owner</label>
                    </div>
                  </div>

                  {/* CUSTOM FOOTER */}
                  <div className={styles.formGroupultimatefleetreport}>
                    <label>Custom Footer</label>
                    <textarea
                      value={localCustomFooterText}
                      onChange={(e) => setLocalCustomFooterText(e.target.value)}
                    />
                    <label>
                      <input
                        type="checkbox"
                        checked={localUseCustomFooter}
                        onChange={(e) => setLocalUseCustomFooter(e.target.checked)}
                      /> Use Custom Footer
                    </label>
                    <button onClick={handleSaveFooter} className={styles.addButtonultimatefleetreport} style={{ marginTop: 8 }}>
                      Save Footer
                    </button>
                  </div>
    <div style={{ borderTop: "1px solid #e5e7eb", paddingTop: 16, marginTop: 8 }}>
          <button
            onClick={handleSavePdfSettings}
            className={styles.saveButtonultimatefleetreport}
          >
            Save PDF Settings
          </button>
          </div>
                </div>
              </div>
            </div>
          )}

          {filteredLoads.length > 0 && (
            <>
              <ul className={styles.loadListultimatefleetreport}>
                {filteredLoads.map((load) => (
                  <li key={load._id}>
                    <input
                      type="checkbox"
                      checked={selectedLoads.includes(load.loadNumber)}
                      onChange={() => handleLoadSelection(load.loadNumber)}
                    />
                    Load #{load.loadNumber} – ${parseFloat(load.rate || 0).toFixed(2)}
                  </li>
                ))}
              </ul>

              {/* Truck Cost Deductions */}
              {truckCostDeductions.map((cost) => (
                <div key={cost._id} className={styles.loadItemultimatefleetreport}>
                  <div className={styles.costLeftFleetReport}>
                    <div className={styles.costTitleFleetReport}>{cost.category}{cost.vendor && ` – ${cost.vendor}`}</div>
                    <div className={styles.costDescriptionFleetReport}>{cost.description || "No description"}{formatAssetCostProgress(cost)}</div>
                    <div className={styles.costMetaFleetReport}>Next Billing: {cost.nextBillingDate ? cost.nextBillingDate.split("T")[0] : cost.startDate ? cost.startDate.split("T")[0] : "-"}</div>
                  </div>
                  <div className={styles.costRightFleetReport}>
                    <div className={styles.costAmountFleetReport}>-${parseFloat(cost.amount || 0).toFixed(2)}</div>
                    <button
                      onClick={() => {
                        const item = { type: cost.category, description: `${cost.description || ""}${formatAssetCostProgress(cost)}`, amount: Number(cost.amount) || 0, date: cost.nextBillingDate ? cost.nextBillingDate.split("T")[0] : cost.startDate ? cost.startDate.split("T")[0] : new Date().toISOString().split("T")[0], source: "truck-cost", assetCostId: cost._id };
                        setRecurringDeductions((prev) => prev.some((d) => d.assetCostId === cost._id) ? prev : [...prev, item]);
                      }}
                      className={styles.addButtonultimatefleetreport}
                    >Add</button>
                  </div>
                </div>
              ))}

              {/* Truck Cost Additions */}
              {truckCostAdditions.length > 0 && (
                <div className={styles.formGroupultimatefleetreport}>
                  <h3>Truck Cost Additions</h3>
                  {truckCostAdditions.map((cost) => {
                    const paid = Array.isArray(cost.payments) ? cost.payments.filter((p) => p.status === "paid").length : 0;
                    const totalOccurrences = cost.recurrence?.occurrences || 0;
                    const isRecurringLimited = cost.paymentType === "recurring" && totalOccurrences > 0;
                    const progressText = isRecurringLimited ? ` ${paid + 1}/${totalOccurrences}` : "";
                    const totalAmountRecurring = isRecurringLimited ? ` from $${(Number(cost.amount || 0) * totalOccurrences).toFixed(2)}` : "";
                    return (
                      <div key={cost._id} className={styles.quickItemFleetReport}>
                        <div className={styles.quickItemLeftFleetReport}>
                          <div className={styles.quickItemTitleFleetReport}>{cost.category}{cost.vendor && ` – ${cost.vendor}`}</div>
                          <div className={styles.quickItemDescriptionFleetReport}>{cost.description || "No description"}{progressText}{totalAmountRecurring}</div>
                        </div>
                        <div className={styles.quickItemRightFleetReport}>
                          <div className={styles.quickItemAmountFleetReport}>+${Number(cost.amount || 0).toFixed(2)}</div>
                          <button
                            onClick={() => {
                              const item = { type: cost.category, description: `${cost.description || ""}${progressText}${totalAmountRecurring}`, amount: Number(cost.amount) || 0, date: cost.nextBillingDate ? cost.nextBillingDate.split("T")[0] : cost.startDate ? cost.startDate.split("T")[0] : new Date().toISOString().split("T")[0], source: "truck-cost", assetCostId: cost._id };
                              setRecurringAdditions((prev) => prev.some((a) => a.assetCostId === cost._id) ? prev : [...prev, item]);
                            }}
                            className={styles.addButtonultimatefleetreport}
                          >Add</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Manual Deductions */}
              <div className={styles.formGroupultimatefleetreport}>
                <label>Manual Deductions</label>
                {manualDeductions.map((item, index) => (
                  <div key={index} className={styles.recurringItemultimatedriverPay}>
                    <div style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
                      <select value={item.type} onChange={(e) => updateManualItem("deduction", index, "type", e.target.value)} className={styles.selectFieldultimatefleetreport} style={{ flex: 1 }}>
                        <option value="">Select Type</option>
                        {manualDeductionTypes.map((type) => <option key={type} value={type}>{type}</option>)}
                      </select>
                      <input type="date" value={item.date || ""} onChange={(e) => updateManualItem("deduction", index, "date", e.target.value)} className={styles.inputFieldultimatefleetreport} style={{ flex: 1 }} />
                    </div>
                    <div style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
                      <input type="text" placeholder="Service / Description" value={item.description} onChange={(e) => updateManualItem("deduction", index, "description", e.target.value)} className={styles.inputFieldultimatefleetreport} style={{ flex: 2 }} />
                      <input type="number" placeholder="Amount" value={item.amount} onChange={(e) => updateManualItem("deduction", index, "amount", e.target.value)} className={styles.inputFieldultimatefleetreport} style={{ flex: 1 }} />
                    </div>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "8px" }}>
                      <input type="text" placeholder="Notes (optional)" value={item.notes || ""} onChange={(e) => updateManualItem("deduction", index, "notes", e.target.value)} className={styles.inputFieldultimatefleetreport} style={{ flex: 1 }} />
                      <button type="button" onClick={() => removeManualItem("deduction", index)} className={styles.removeButtonultimatefleetreport}>X</button>
                    </div>
                  </div>
                ))}
                <button onClick={addManualDeduction} className={styles.addButtonultimatefleetreport}>+ Add Manual Deduction</button>
              </div>

              {/* Manual Additions */}
              <div className={styles.formGroupultimatefleetreport}>
                <label>Manual Additions</label>
                {manualAdditions.map((item, index) => (
                  <div key={index} className={styles.recurringItemultimatedriverPay}>
                    <div style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
                      <select value={item.type} onChange={(e) => updateManualItem("addition", index, "type", e.target.value)} className={styles.selectFieldultimatefleetreport} style={{ flex: 1 }}>
                        <option value="">Select Type</option>
                        {manualAdditionTypes.map((type) => <option key={type} value={type}>{type}</option>)}
                      </select>
                      <input type="date" value={item.date || ""} onChange={(e) => updateManualItem("addition", index, "date", e.target.value)} className={styles.inputFieldultimatefleetreport} style={{ flex: 1 }} />
                    </div>
                    <div style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
                      <input type="text" placeholder="Service / Description" value={item.description} onChange={(e) => updateManualItem("addition", index, "description", e.target.value)} className={styles.inputFieldultimatefleetreport} style={{ flex: 2 }} />
                      <input type="number" placeholder="Amount" value={item.amount} onChange={(e) => updateManualItem("addition", index, "amount", e.target.value)} className={styles.inputFieldultimatefleetreport} style={{ flex: 1 }} />
                    </div>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "8px" }}>
                      <input type="text" placeholder="Notes (optional)" value={item.notes || ""} onChange={(e) => updateManualItem("addition", index, "notes", e.target.value)} className={styles.inputFieldultimatefleetreport} style={{ flex: 1 }} />
                      <button type="button" onClick={() => removeManualItem("addition", index)} className={styles.removeButtonultimatefleetreport}>X</button>
                    </div>
                  </div>
                ))}
                <button onClick={addManualAddition} className={styles.addButtonultimatefleetreport}>+ Add Manual Addition</button>
              </div>

              {/* Fuel (Owner Open) */}
              {truckFuelDeductions.map((fuel) => (
                <div key={fuel.fuelReportId} className={styles.loadItemultimatefleetreport}>
                  <div className={styles.costLeftFleetReport}>
                    <div className={styles.costTitleFleetReport}>Fuel</div>
                    <div className={styles.costDescriptionFleetReport}>{fuel.description}</div>
                    <div className={styles.costMetaFleetReport}>Date: {fuel.date}</div>
                  </div>
                  <div className={styles.costRightFleetReport}>
                    <div className={styles.costAmountFleetReport}>-${parseFloat(fuel.amount || 0).toFixed(2)}</div>
                    <button
                      onClick={() => setRecurringDeductions((prev) => prev.some((d) => d.fuelReportId === fuel.fuelReportId) ? prev : [...prev, fuel])}
                      className={styles.addButtonultimatefleetreport}
                    >Add</button>
                  </div>
                </div>
              ))}

              {/* Driver Payroll */}
              {driverPays.length > 0 && (
                <div className={styles.formGroupultimatefleetreport}>
                  <h3>Driver Payroll (Select to Include)</h3>
                  {driverPays.map((pay) => {
                    const isSelected = selectedDriverPayIds.includes(pay._id);
                    return (
                      <div key={pay._id} className={styles.loadItemultimatefleetreport}>
                        <div className={styles.costLeftFleetReport}>
                          <input type="checkbox" checked={isSelected} onChange={() => toggleDriverPaySelection(pay._id)} style={{ marginRight: 10 }} />
                          <div>
                            <div className={styles.costTitleFleetReport}>{pay.driverId?.firstName} {pay.driverId?.lastName}</div>
                            <div className={styles.costDescriptionFleetReport}>Fleet number #: {pay.fleetNumber}</div>
                            <div className={styles.costMetaFleetReport}>{pay.startDate?.split("T")[0]} → {pay.endDate?.split("T")[0]}</div>
                          </div>
                        </div>
                        <div className={styles.costRightFleetReport}>
                          {/* FIX #1: afișăm suma pozitivă cu prefix "-$", fără a o nega din nou */}
                          <div className={styles.costAmountFleetReport}>-${Number(pay.totalWithAdjustments || 0).toFixed(2)}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Live Totals */}
              <div className={styles.totalsContainerFleetReport}>
                <div className={styles.totalRowFleetReport}>
                  <span>Sub-Total</span>
                  <span>${totalPay.toFixed(2)}</span>
                </div>
                {(recurringAdditions.length > 0 || manualAdditions.length > 0) && (
                  <div className={styles.adjustmentsSectionFleetReport}>
                    <h4>Additions</h4>
                    {[...recurringAdditions, ...manualAdditions].map((a, i) => (
                      <div key={i} className={styles.additionRowFleetReport}>
                        <span>{a.type} – {a.description}</span>
                        <span>+${parseFloat(a.amount || 0).toFixed(2)}</span>
                      </div>
                    ))}
                  </div>
                )}
                {(recurringDeductions.length > 0 || manualDeductions.length > 0) && (
                  <div className={styles.adjustmentsSectionFleetReport}>
                    <h4>Deductions</h4>
                    {[...recurringDeductions, ...manualDeductions].map((d, i) => (
                      <div key={i} className={styles.deductionRowFleetReport}>
                        <span>{d.type} – {d.description}</span>
                        <span>-${parseFloat(d.amount || 0).toFixed(2)}</span>
                      </div>
                    ))}
                  </div>
                )}
                {driverPays.length > 0 && (
                  <div className={styles.adjustmentsSectionFleetReport}>
                    <h4>Driver Payroll</h4>
                    <div className={styles.deductionRowFleetReport}>
                      <span>Total Driver Cost</span>
                      {/* FIX #1: totalDriverPayrollCost este pozitiv, afișăm cu "-$" */}
                      <span>-${totalDriverPayrollCost.toFixed(2)}</span>
                    </div>
                  </div>
                )}
                <div className={styles.grandTotalFleetReport}>
                  <span>Grand Total</span>
                  <span>${totalPayWithAdjustments.toFixed(2)}</span>
                </div>
              </div>

              <button onClick={generatePDF} className={styles.previewButtonultimatefleetreport}>Preview PDF</button>

              <button
                onClick={async () => {
                  const saved = await handleSaveFleetReport();
                  if (!saved) { notify("Save failed.", "error"); return; }
                  try {
                    await markFuelAsPaid();
                    await markTruckCostsAsPaid();
                    if (selectedDriverPayIds.length > 0) {
                      await axios.put(
                        "https://api-backend.full-trucking-service.com/api/driverpays/mark-included",
                        { driverPayIds: selectedDriverPayIds },
                        config
                      );
                    }
                    notify("Fleet report saved.", "success");
                    // FIX #3: resetăm formularul după save reușit
                    resetForm();
                  } catch (err) {
                    console.error("Post-save update error:", err);
                    notify("Fleet report saved but update failed.", "warning");
                    // resetăm oricum, raportul a fost salvat
                    resetForm();
                  }
                }}
                className={styles.saveButtonultimatefleetreport}
              >
                Save Fleet Report
              </button>
            </>
          )}
        </>
      )}
      <EmailPanel />
    </div>
  );
};
// ============================================================
// FleetReportManager.jsx
// ============================================================

const FleetReportManager = ({ trucks }) => {
  const [fleetReports, setFleetReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);
  const [selectedTruckId, setSelectedTruckId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedReport, setSelectedReport] = useState(null);
  const [logo, setLogo] = useState(null);
  const [clientInfo, setClientInfo] = useState({ companyName: "", companyAddress: "" });

  const token = sessionStorage.getItem("token");
  const config = { headers: { Authorization: `Bearer ${token}` }, withCredentials: true };
 const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);
  // ─── FETCH LOGO + CLIENT INFO ────────────────────────────────────────────
  useEffect(() => {
    const fetchMeta = async () => {
      try {
        const [logoRes, settingsRes] = await Promise.allSettled([
          axios.get("https://api-backend.full-trucking-service.com/api/logo", config),
          axios.get("https://api-backend.full-trucking-service.com/api/settings", config),
        ]);
        if (logoRes.status === "fulfilled" && logoRes.value.data?.logo) {
          setLogo(logoRes.value.data.logo);
        }
        if (settingsRes.status === "fulfilled") {
          const { companyName, companyAddress } = settingsRes.value.data;
          setClientInfo({ companyName: companyName || "", companyAddress: companyAddress || "" });
        }
      } catch (err) {
        // silent
      }
    };
    fetchMeta();
  }, []);

  // ─── FETCH FLEET REPORTS ─────────────────────────────────────────────────
  useEffect(() => {
    const fetchReports = async () => {
      try {
        const res = await axios.get(
          "https://api-backend.full-trucking-service.com/api/fleet-reports?limit=200",
          config
        );
        const list = res.data?.data || [];
        setFleetReports(list);
        setFilteredReports(list);
      } catch (err) {
        setFleetReports([]);
        setFilteredReports([]);
      }
    };
    fetchReports();
  }, []);

  // ─── FILTER ───────────────────────────────────────────────────────────────
  useEffect(() => {
    let data = [...fleetReports];

    if (selectedTruckId) {
      data = data.filter(r => r.truckId?._id === selectedTruckId || r.truckId === selectedTruckId);
    }

    if (startDate) {
      data = data.filter(r => new Date(r.startDate) >= new Date(startDate));
    }

    if (endDate) {
      data = data.filter(r => new Date(r.endDate) <= new Date(endDate));
    }

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      data = data.filter(r => (r.fleetNumber || "").toLowerCase().includes(term));
    }

    setFilteredReports(data);
  }, [searchTerm, startDate, endDate, selectedTruckId, fleetReports]);

  // ─── DELETE ───────────────────────────────────────────────────────────────
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this fleet report?")) return;
    try {
      await axios.delete(
        `https://api-backend.full-trucking-service.com/api/fleet-reports/${id}`,
        config
      );
      setFleetReports(prev => prev.filter(r => r._id !== id));
      if (selectedReport?._id === id) setSelectedReport(null);
    } catch (err) {
      alert("Failed to delete fleet report.");
    }
  };

  // ─── GENERATE PDF (same design as FleetReport) ───────────────────────────
const generatePDF = (report) => {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "letter" });

  // ── SAFE TEXT COERCION ──────────────────────────────────────────────────
  // jsPDF acceptă doar string/number. Orice obiect (ex. ref populat din Mongo)
  // ar arunca: "Type of text must be string or Array".
  const txt = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "object") {
      return (
        v.name ?? v.fullName ?? v.companyName ?? v.address ??
        v.label ?? v.truckNumber ?? v.driver ?? v.owner ?? ""
      );
    }
    return String(v);
  };
  const money = (v) => `$${Number(v || 0).toFixed(2)}`;
  const dateStr = (v) => {
    if (!v) return "";
    const d = new Date(v);
    return isNaN(d.getTime()) ? "" : d.toLocaleString();
  };

  const {
    fleetNumber = "",
    truckId,
    startDate: rStart,
    endDate: rEnd,
    payDetails = [],
    recurringAddition = [],
    recurringDeduction = [],
    manualAdditions = [],
    manualDeductions = [],
    totalPay = 0,
    totalWithAdjustments = 0,
  } = report;

  const truck = truckId || {};
  const today = new Date().toISOString().split("T")[0];

  const COLOR = {
    navy:      [10,  31,  68],
    navyLight: [22,  54, 110],
    gold:      [212, 160,  23],
    white:     [255, 255, 255],
    offWhite:  [248, 249, 252],
    lightGray: [230, 234, 241],
    midGray:   [150, 162, 180],
    darkText:  [18,  28,  48],
    greenPay:  [15, 118,  82],
    redDed:    [185,  28,  28],
    blueSub:   [37,  99, 235],
  };

  const PAGE_W = 215.9;
  const PAGE_H = 279.4;
  const MARGIN = 14;

  const setFill  = (c) => doc.setFillColor(...c);
  const setColor = (c) => doc.setTextColor(...c);
  const setFont  = (size, style = "normal") => { doc.setFontSize(size); doc.setFont("helvetica", style); };
  const hRule    = (y, color = COLOR.gold, thickness = 0.6) => {
    doc.setDrawColor(...color); doc.setLineWidth(thickness);
    doc.line(MARGIN, y, PAGE_W - MARGIN, y);
  };

  const addHeader = () => {
    setFill(COLOR.navy);
    doc.rect(0, 0, PAGE_W, 42, "F");
    setFill(COLOR.gold);
    doc.rect(0, 41, PAGE_W, 1.5, "F");

    if (logo && typeof logo === "string") {
      doc.addImage(logo, "PNG", MARGIN, 7, 48, 22);
    }

    setColor(COLOR.white); setFont(18, "bold");
    doc.text("FLEET REPORT", PAGE_W - MARGIN, 17, { align: "right" });

    if (fleetNumber) {
      setFill(COLOR.gold);
      doc.roundedRect(PAGE_W - MARGIN - 52, 27, 52, 10, 2, 2, "F");
      setColor(COLOR.navy); setFont(7, "bold");
      doc.text(`FLEET #  ${txt(fleetNumber)}`, PAGE_W - MARGIN - 26, 33.2, { align: "center" });
    }

    const infoY = 52;
    const col2  = 115;

    const leftRows = [
      ["Truck #",     txt(truck.truckNumber) || "N/A"],
      ["Driver",      txt(truck.driver) || "N/A"],
      ["Pay Period",  `${rStart ? new Date(rStart).toLocaleDateString() : "N/A"}  –  ${rEnd ? new Date(rEnd).toLocaleDateString() : "N/A"}`],
    ];
    const rightRows = [
      ["Owner",       txt(truck.owner) || "N/A"],
      ["Report Date", today],
    ];

    let ly = infoY;
    leftRows.forEach(([label, value]) => {
      setFont(7, "bold"); setColor(COLOR.midGray);
      doc.text(txt(label).toUpperCase(), MARGIN, ly);
      setFont(8.5, "normal"); setColor(COLOR.darkText);
      doc.text(txt(value), MARGIN, ly + 4.5);
      ly += 11;
    });

    let ry = infoY;
    rightRows.forEach(([label, value]) => {
      setFont(7, "bold"); setColor(COLOR.midGray);
      doc.text(txt(label).toUpperCase(), col2, ry);
      setFont(8.5, "normal"); setColor(COLOR.darkText);
      doc.text(txt(value), col2, ry + 4.5);
      ry += 11;
    });

    hRule(ly + 2);
    return ly + 8;
  };

  const addFooter = () => {
    const pageCount = doc.internal.getNumberOfPages();
    const fY = PAGE_H - 18;
    setFill(COLOR.gold); doc.rect(0, fY - 2, PAGE_W, 0.8, "F");
    setFill(COLOR.navy); doc.rect(0, fY - 1.2, PAGE_W, 20, "F");
    setColor(COLOR.white); setFont(7);
    doc.text("Thank you for your business!", PAGE_W / 2, fY + 3, { align: "center" });
    doc.text(
      `${txt(clientInfo.companyName)}  ·  ${txt(clientInfo.companyAddress)}`,
      PAGE_W / 2, fY + 8, { align: "center" }
    );
    setColor(COLOR.gold); setFont(6);
    doc.text("Powered by FleetAcc", PAGE_W / 2, fY + 13, { align: "center" });

    setColor(COLOR.midGray); setFont(7);
    doc.text(`Page ${pageCount}`, PAGE_W - MARGIN, fY + 4, { align: "right" });
  };

  const sectionTitle = (label, y) => {
    setFill(COLOR.navyLight);
    doc.roundedRect(MARGIN, y, PAGE_W - MARGIN * 2, 7, 1.5, 1.5, "F");
    setColor(COLOR.gold); setFont(8, "bold");
    doc.text(txt(label).toUpperCase(), MARGIN + 4, y + 4.8);
    return y + 10;
  };

  let startY = addHeader();
  startY = sectionTitle("Load Details", startY);

  payDetails.forEach((detail, index) => {
    if (startY > PAGE_H - 60) {
      addFooter(); doc.addPage();
      startY = addHeader();
      startY = sectionTitle("Load Details (continued)", startY);
    }

    const pickupDetails = detail.shippers?.length > 0
      ? detail.shippers.map(s => {
          const dt = dateStr(s.pickUpTime) || "Unknown Date";
          return `${dt}  —  ${txt(s.address) || "No data"}`;
        }).join("\n")
      : "No data";

    const deliveryDetails = detail.consignees?.length > 0
      ? detail.consignees.map(c => {
          const dt = dateStr(c.deliveryTime) || "Unknown Date";
          return `${dt}  —  ${txt(c.address) || "No data"}`;
        }).join("\n")
      : "No data";

    doc.autoTable({
      startY,
      body: [
        [{ content: `LOAD  #${txt(detail.loadNumber) || index + 1}`, colSpan: 3, styles: { fontStyle: "bold", fontSize: 8, fillColor: COLOR.offWhite, textColor: COLOR.navy, cellPadding: { top: 3, bottom: 3, left: 4, right: 4 } } }],
        [{ content: "Pickup",   styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.white, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } }, { content: pickupDetails,   colSpan: 2, styles: { halign: "left", fillColor: COLOR.white, textColor: COLOR.darkText, fontSize: 7.5 } }],
        [{ content: "Delivery", styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.white, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } }, { content: deliveryDetails, colSpan: 2, styles: { halign: "left", fillColor: COLOR.white, textColor: COLOR.darkText, fontSize: 7.5 } }],
        [{ content: "Rate",     styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.white, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } }, { content: money(detail.rate), styles: { halign: "left", fillColor: COLOR.white, textColor: COLOR.darkText, fontSize: 7.5 } }, { content: "", styles: { fillColor: COLOR.white } }],
        [{ content: "Pay",      styles: { fontStyle: "bold", halign: "left", fillColor: COLOR.offWhite, textColor: COLOR.midGray, fontSize: 7, cellWidth: 28 } }, { content: "—", styles: { fillColor: COLOR.offWhite, textColor: COLOR.darkText, fontSize: 7.5 } }, { content: money(detail.pay), styles: { fontStyle: "bold", halign: "right", fillColor: COLOR.offWhite, textColor: COLOR.greenPay, fontSize: 9 } }],
      ],
      theme: "plain",
      styles: { lineColor: COLOR.lightGray, lineWidth: 0.35, cellPadding: 2.5 },
      margin: { left: MARGIN, right: MARGIN },
      tableLineColor: COLOR.lightGray, tableLineWidth: 0.35,
    });

    startY = doc.lastAutoTable.finalY + 5;
  });

  // Sub-Total
  startY += 4;
  doc.autoTable({
    startY,
    body: [[
      { content: "Sub-Total", styles: { fontStyle: "bold", fontSize: 9, textColor: COLOR.darkText } },
      { content: money(totalPay), styles: { fontStyle: "bold", halign: "right", fontSize: 10, textColor: COLOR.blueSub } },
    ]],
    theme: "plain",
    styles: { fillColor: COLOR.offWhite, lineColor: COLOR.lightGray, lineWidth: 0.35, cellPadding: { top: 4, bottom: 4, left: 5, right: 5 } },
    margin: { left: MARGIN, right: MARGIN },
    tableLineColor: COLOR.lightGray, tableLineWidth: 0.35,
  });
  startY = doc.lastAutoTable.finalY + 8;

  // Additions
  const additionsAll = [
    ...(recurringAddition || []),
    ...(manualAdditions || []),
  ].map(item => ({
    type: txt(item.type) || "Other",
    description: txt(item.description),
    date: txt(item.date),
    amount: parseFloat(item.amount || 0) || 0,
    notes: txt(item.notes),
  }));

  const deductionsAll = [
    ...(recurringDeduction || []),
    ...(manualDeductions || []),
  ].map(item => ({
    type: txt(item.type) || "Other",
    description: txt(item.description),
    date: txt(item.date),
    amount: parseFloat(item.amount || 0) || 0,
    notes: txt(item.notes),
  }));

  if (startY > PAGE_H - 70) { addFooter(); doc.addPage(); startY = addHeader(); }
  startY = sectionTitle("Additions", startY);
  doc.autoTable({
    startY,
    head: [[
      { content: "Type / Description / Date", styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
      { content: "Notes",                     styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
      { content: "Amount",                    styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5, halign: "right" } },
    ]],
    body: additionsAll.length > 0
      ? additionsAll.map(item => [
          { content: `${item.type}  ·  ${item.description}  ·  ${item.date}`, styles: { fontSize: 7.5, textColor: COLOR.darkText } },
          { content: item.notes, styles: { fontSize: 7.5, textColor: COLOR.midGray } },
          { content: `+${money(item.amount)}`, styles: { fontSize: 7.5, halign: "right", textColor: COLOR.greenPay, fontStyle: "bold" } },
        ])
      : [[{ content: "No additions", colSpan: 3, styles: { halign: "center", textColor: COLOR.midGray, fontSize: 7.5, fontStyle: "italic" } }]],
    theme: "grid",
    styles: { lineColor: COLOR.lightGray, lineWidth: 0.3, cellPadding: 2.5, fontSize: 7.5 },
    alternateRowStyles: { fillColor: COLOR.offWhite },
    headStyles: { fillColor: COLOR.navy },
    margin: { left: MARGIN, right: MARGIN },
  });
  startY = doc.lastAutoTable.finalY + 8;

  if (startY > PAGE_H - 70) { addFooter(); doc.addPage(); startY = addHeader(); }
  startY = sectionTitle("Deductions", startY);
  doc.autoTable({
    startY,
    head: [[
      { content: "Type / Description / Date", styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
      { content: "Notes",                     styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5 } },
      { content: "Amount",                    styles: { fillColor: COLOR.navy, textColor: COLOR.gold, fontStyle: "bold", fontSize: 7.5, halign: "right" } },
    ]],
    body: deductionsAll.length > 0
      ? deductionsAll.map(item => [
          { content: `${item.type}  ·  ${item.description}  ·  ${item.date}`, styles: { fontSize: 7.5, textColor: COLOR.darkText } },
          { content: item.notes, styles: { fontSize: 7.5, textColor: COLOR.midGray } },
          { content: `-${money(item.amount)}`, styles: { fontSize: 7.5, halign: "right", textColor: COLOR.redDed, fontStyle: "bold" } },
        ])
      : [[{ content: "No deductions", colSpan: 3, styles: { halign: "center", textColor: COLOR.midGray, fontSize: 7.5, fontStyle: "italic" } }]],
    theme: "grid",
    styles: { lineColor: COLOR.lightGray, lineWidth: 0.3, cellPadding: 2.5, fontSize: 7.5 },
    alternateRowStyles: { fillColor: [255, 248, 248] },
    headStyles: { fillColor: COLOR.navy },
    margin: { left: MARGIN, right: MARGIN },
  });
  startY = doc.lastAutoTable.finalY + 10;

  // Grand Total
  if (startY > PAGE_H - 40) { addFooter(); doc.addPage(); startY = addHeader(); }
  setFill(COLOR.gold);
  doc.rect(MARGIN, startY, PAGE_W - MARGIN * 2, 0.8, "F");
  startY += 4;

  doc.autoTable({
    startY,
    body: [[
      { content: "GRAND TOTAL — NET PAY", styles: { fontStyle: "bold", fontSize: 11, textColor: COLOR.white, fillColor: COLOR.navy, cellPadding: { top: 5, bottom: 5, left: 6, right: 6 } } },
      { content: money(totalWithAdjustments), styles: { fontStyle: "bold", fontSize: 14, halign: "right", textColor: COLOR.gold, fillColor: COLOR.navy, cellPadding: { top: 4, bottom: 4, left: 6, right: 6 } } },
    ]],
    theme: "plain",
    margin: { left: MARGIN, right: MARGIN },
    tableLineWidth: 0,
  });

  const finalY = doc.lastAutoTable.finalY;
  setFill(COLOR.gold);
  doc.rect(MARGIN, finalY, PAGE_W - MARGIN * 2, 1.2, "F");

  addFooter();
  doc.save(`fleet_report_${txt(fleetNumber) || "report"}.pdf`);
};

  // ─── UI ───────────────────────────────────────────────────────────────────
  return (
    <div className={styles.FleetReportManagerSection} data-theme={theme}>
      {/* HEADER */}
      <div className={styles.FleetReportManagerHeader}>
        <h2 className={styles.FleetReportManagerTitle}>Fleet Report Manager</h2>
        <span className={styles.FleetReportManagerCount}>
          {filteredReports.length} Reports
        </span>
      </div>

      {/* FILTER BAR */}
      <div className={styles.FleetReportManagerFilterBar}>
        <input
          className={styles.FleetReportManagerSearchInput}
          placeholder="Search Fleet Number..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <select
          className={styles.FleetReportManagerSelect}
          value={selectedTruckId}
          onChange={(e) => setSelectedTruckId(e.target.value)}
        >
          <option value="">All Trucks</option>
          {(trucks || []).map(t => (
            <option key={t._id} value={t._id}>
              {t.truckNumber}
            </option>
          ))}
        </select>

        <input
          className={styles.FleetReportManagerDateInput}
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />

        <input
          className={styles.FleetReportManagerDateInput}
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
      </div>

      {/* TABLE */}
      <div className={styles.FleetReportManagerTableWrapper}>
        <table className={styles.FleetReportManagerTable}>
          <thead>
            <tr>
              <th>Fleet #</th>
              <th>Truck</th>
              <th>Owner</th>
              <th>Start</th>
              <th>End</th>
              <th>Loads</th>
              <th>Total</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredReports.map(report => (
              <tr
                key={report._id}
                className={styles.FleetReportManagerRow}
                onClick={() => setSelectedReport(report)}
              >
                <td className={styles.FleetReportManagerFleetNumber}>
                  {report.fleetNumber}
                </td>

                <td>{report.truckId?.truckNumber || "—"}</td>
                <td>{report.truckId?.owner || "—"}</td>

                <td>{new Date(report.startDate).toLocaleDateString()}</td>
                <td>{new Date(report.endDate).toLocaleDateString()}</td>

                <td>{Array.isArray(report.payDetails) ? report.payDetails.length : 0}</td>

                <td className={styles.FleetReportManagerTotal}>
                  ${Number(report.totalWithAdjustments || 0).toFixed(2)}
                </td>

                <td
                  className={styles.FleetReportManagerActionsCell}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className={styles.FleetReportManagerDeleteButton}
                    onClick={() => handleDelete(report._id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}

            {filteredReports.length === 0 && (
              <tr>
                <td colSpan={8} className={styles.FleetReportManagerEmpty}>
                  No fleet reports found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {selectedReport && (
        <div className={styles.FleetReportManagerModalOverlay}>
          <div className={styles.FleetReportManagerModal}>

            <div className={styles.FleetReportManagerModalHeader}>
              <h3>Fleet Report #{selectedReport.fleetNumber}</h3>
              <button
                className={styles.FleetReportManagerCloseButton}
                onClick={() => setSelectedReport(null)}
              >
                ✕
              </button>
            </div>

            <div className={styles.FleetReportManagerModalContent}>

              {/* INFO */}
              <div className={styles.FleetReportManagerModalInfo}>
                <button
                  className={styles.FleetReportManagerDownloadButton}
                  onClick={() => generatePDF(selectedReport)}
                >
                  Download PDF
                </button>

                <p><strong>Truck:</strong> {selectedReport.truckId?.truckNumber || "—"}</p>
                <p><strong>Owner:</strong> {selectedReport.truckId?.owner || "—"}</p>
                <p>
                  <strong>Period:</strong>{" "}
                  {new Date(selectedReport.startDate).toLocaleDateString()}
                  {" – "}
                  {new Date(selectedReport.endDate).toLocaleDateString()}
                </p>
                <p><strong>Loads:</strong> {selectedReport.payDetails?.length || 0}</p>
                <p className={styles.FleetReportManagerModalTotal}>
                  <strong>Grand Total:</strong> ${Number(selectedReport.totalWithAdjustments || 0).toFixed(2)}
                </p>
              </div>

              {/* LOADS */}
              <h4 className={styles.FleetReportManagerLoadsTitle}>Loads</h4>
              {Array.isArray(selectedReport.payDetails) && selectedReport.payDetails.map((l, i) => (
                <div key={i} className={styles.FleetReportManagerLoadCard}>
                  <div className={styles.FleetReportManagerLoadHeader}>
                    <strong>Load #:</strong> {l.loadNumber}
                  </div>
                  <div className={styles.FleetReportManagerLoadGrid}>
                    <div>
                      <strong>Pickup:</strong>
                      {(l.shippers || []).map((s, idx) => (
                        <div key={idx} className={styles.FleetReportManagerAddressBlock}>
                          <div>{s.address || "—"}</div>
                          <div className={styles.FleetReportManagerDate}>
                            {s.pickUpTime ? new Date(s.pickUpTime).toLocaleString() : "—"}
                          </div>
                        </div>
                      ))}
                    </div>
                    <div>
                      <strong>Delivery:</strong>
                      {(l.consignees || []).map((c, idx) => (
                        <div key={idx} className={styles.FleetReportManagerAddressBlock}>
                          <div>{c.address || "—"}</div>
                          <div className={styles.FleetReportManagerDate}>
                            {c.deliveryTime ? new Date(c.deliveryTime).toLocaleString() : "—"}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className={styles.FleetReportManagerLoadFooter}>
                    <span><strong>Rate:</strong> ${Number(l.rate || 0).toFixed(2)}</span>
                    <span><strong>Miles:</strong> {l.miles || 0}</span>
                    <span><strong>DH:</strong> {l.dh || 0}</span>
                    <span><strong>Pay:</strong> ${Number(l.pay || 0).toFixed(2)}</span>
                  </div>
                </div>
              ))}

              {/* ADDITIONS */}
              {([...(selectedReport.recurringAddition || []), ...(selectedReport.manualAdditions || [])]).length > 0 && (
                <>
                  <h4 className={styles.FleetReportManagerSectionTitle}>Additions</h4>
                  {[...(selectedReport.recurringAddition || []), ...(selectedReport.manualAdditions || [])].map((a, i) => (
                    <div key={i} className={styles.FleetReportManagerAdjustmentRow}>
                      <span>{a.type} – {a.description}</span>
                      <span className={styles.FleetReportManagerAddition}>+${Number(a.amount || 0).toFixed(2)}</span>
                    </div>
                  ))}
                </>
              )}

              {/* DEDUCTIONS */}
              {([...(selectedReport.recurringDeduction || []), ...(selectedReport.manualDeductions || [])]).length > 0 && (
                <>
                  <h4 className={styles.FleetReportManagerSectionTitle}>Deductions</h4>
                  {[...(selectedReport.recurringDeduction || []), ...(selectedReport.manualDeductions || [])].map((d, i) => (
                    <div key={i} className={styles.FleetReportManagerAdjustmentRow}>
                      <span>{d.type} – {d.description}</span>
                      <span className={styles.FleetReportManagerDeduction}>-${Number(d.amount || 0).toFixed(2)}</span>
                    </div>
                  ))}
                </>
              )}

              {/* TOTALS */}
              <div className={styles.FleetReportManagerTotalsBlock}>
                <div className={styles.FleetReportManagerTotalRow}>
                  <span>Sub-Total</span>
                  <span>${Number(selectedReport.totalPay || 0).toFixed(2)}</span>
                </div>
                <div className={styles.FleetReportManagerGrandTotal}>
                  <span>Grand Total</span>
                  <span>${Number(selectedReport.totalWithAdjustments || 0).toFixed(2)}</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}
      <EmailPanel />
    </div>
  );
};

const PayrollEmployee = () => {
  const { notify } = useNotification();

  const [employees,        setEmployees]        = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [activeTab,        setActiveTab]        = useState("entry");
  const [payrollHistory,   setPayrollHistory]   = useState([]);
  const [ytdTotals,        setYtdTotals]        = useState({});
  const [logo,             setLogo]             = useState(null);
  const [footer,           setFooter]           = useState('');
  const [useCustomFooter,  setUseCustomFooter]  = useState(false);
  const [theme,            setTheme]            = useState(() => sessionStorage.getItem("theme") || "dark");

  const [startDate,     setStartDate]     = useState('');
  const [endDate,       setEndDate]       = useState('');
  const [checkNumber,   setCheckNumber]   = useState('');
  const [paymentMethod, setPaymentMethod] = useState('Direct Deposit');
  const [notes,         setNotes]         = useState('');
  const [hoursWorked,   setHoursWorked]   = useState('');
  const [businessUnit,  setBusinessUnit]  = useState('');
  const [department,    setDepartment]    = useState('');

  const [earnings,    setEarnings]    = useState([{ type: 'Regular', hours: '', rate: '', amount: '' }]);
  const [commissions, setCommissions] = useState([{ description: '', grossAmount: '' }]);
  const [additions,   setAdditions]   = useState([]);
  const [deductions,  setDeductions]  = useState([]);
  const [otherTaxes,  setOtherTaxes]  = useState([]);

  const [perDiem, setPerDiem] = useState({ days: '', ratePerDay: '', total: '0.00' });
  const [mileage, setMileage] = useState({ miles: '', ratePerMile: '0.67', total: '0.00' });

  const [benefits, setBenefits] = useState([
    { name: '401(k)',      amount: '', preTax: true  },
    { name: 'Health Ins.', amount: '', preTax: true  },
    { name: 'Dental',      amount: '', preTax: false },
    { name: 'Vision',      amount: '', preTax: false },
  ]);

  const [taxes, setTaxes] = useState({
    federalIncome: '22', stateIncome: '5',
    socialSecurity: '6.2', medicare: '1.45',
    stateSUI: '', localTax: '',
  });

  const token  = sessionStorage.getItem('token');
  const config = { headers: { Authorization: `Bearer ${token}` }, withCredentials: true };
  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const isLight = theme === "light";

  // ── FETCH ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    (async () => {
      try { const r = await axios.get(`${apiUrl}/settings`, { headers: { Authorization: `Bearer ${token}` } }); setTheme(r.data.theme || "dark"); }
      catch { setTheme("dark"); }
    })();
    axios.get(`${apiUrl}/employees`, config).then(r => setEmployees(Array.isArray(r.data) ? r.data : [])).catch(() => {});
    axios.get(`${apiUrl}/logo`,   config).then(r => setLogo(r.data.logo)).catch(() => {});
    axios.get(`${apiUrl}/footer`, config).then(r => { setFooter(r.data.customFooterText || ''); setUseCustomFooter(r.data.useCustomFooter || false); }).catch(() => {});
  }, []);

  useEffect(() => {
    if (!selectedEmployee) return;
    axios.get(`${apiUrl}/employees/${selectedEmployee._id}/payrolls`, config).then(r => {
      const data = Array.isArray(r.data) ? r.data : [];
      setPayrollHistory(data);
      const yr = new Date().getFullYear();
      const totals = {};
      data.filter(p => new Date(p.endDate || p.createdAt).getFullYear() === yr).forEach(p => {
        (p.earnings || []).forEach(e => {
          const k = e.type || 'Regular';
          if (!totals[k]) totals[k] = { hours: 0, amount: 0 };
          totals[k].hours  += parseFloat(e.hours  || 0);
          totals[k].amount += parseFloat(e.amount || 0);
        });
      });
      setYtdTotals(totals);
    }).catch(() => {});
  }, [selectedEmployee]);

  useEffect(() => {
    if (!selectedEmployee) return;
    setEarnings(prev => prev.map((e, i) => i === 0 ? { ...e, rate: selectedEmployee.payAmount || '' } : e));
  }, [selectedEmployee]);

  useEffect(() => {
    const t = (parseFloat(perDiem.days) || 0) * (parseFloat(perDiem.ratePerDay) || 0);
    setPerDiem(p => ({ ...p, total: t.toFixed(2) }));
  }, [perDiem.days, perDiem.ratePerDay]);

  useEffect(() => {
    const t = (parseFloat(mileage.miles) || 0) * (parseFloat(mileage.ratePerMile) || 0);
    setMileage(p => ({ ...p, total: t.toFixed(2) }));
  }, [mileage.miles, mileage.ratePerMile]);

  // ── CALCULE ───────────────────────────────────────────────────────────────
  const calcGross = () => {
    if (selectedEmployee?.payType === 'Commission') {
      const r = parseFloat(selectedEmployee.commissionPercentage) || 0;
      return commissions.reduce((s, c) => s + (parseFloat(c.grossAmount) || 0) * r / 100, 0);
    }
    if (selectedEmployee?.payType === 'Fixed salary') return parseFloat(selectedEmployee.payAmount) || 0;
    return earnings.reduce((s, e) => s + (parseFloat(e.amount) || 0), 0);
  };
  const calcPD      = () => parseFloat(perDiem.total) || 0;
  const calcMi      = () => parseFloat(mileage.total) || 0;
  const calcAdd     = () => additions.reduce((s, a) => s + (parseFloat(a.amount) || 0), 0);
  const calcDed     = () => deductions.reduce((s, d) => s + (parseFloat(d.amount) || 0), 0);
  const calcPre     = () => benefits.filter(b => b.preTax).reduce((s, b) => s + (parseFloat(b.amount) || 0), 0);
  const calcPost    = () => benefits.filter(b => !b.preTax).reduce((s, b) => s + (parseFloat(b.amount) || 0), 0);
  const calcTaxable = () => calcGross() + calcAdd() - calcPre();
  const calcTaxes   = () => {
    const base = calcTaxable();
    return (
      base * (parseFloat(taxes.federalIncome)  || 0) / 100 +
      base * (parseFloat(taxes.stateIncome)    || 0) / 100 +
      base * (parseFloat(taxes.socialSecurity) || 0) / 100 +
      base * (parseFloat(taxes.medicare)       || 0) / 100 +
      base * (parseFloat(taxes.stateSUI)       || 0) / 100 +
      base * (parseFloat(taxes.localTax)       || 0) / 100 +
      otherTaxes.reduce((s, ot) => s + base * (parseFloat(ot.percentage) || 0) / 100, 0)
    );
  };
  const calcNet = () => calcGross() + calcPD() + calcMi() + calcAdd() - calcDed() - calcPre() - calcPost() - calcTaxes();

  const updateEarning = (idx, field, val) => {
    const arr = [...earnings];
    arr[idx] = { ...arr[idx], [field]: val };
    if (field === 'hours' || field === 'rate')
      arr[idx].amount = ((parseFloat(arr[idx].hours) || 0) * (parseFloat(arr[idx].rate) || 0)).toFixed(2);
    setEarnings(arr);
  };

  const fmt = n => `$${parseFloat(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  // ── PDF ───────────────────────────────────────────────────────────────────
const handleGeneratePDF = async () => {
  if (!selectedEmployee) { notify("Select an employee first.", "error"); return; }
  if (!startDate || !endDate) { notify("Set pay period dates.", "error"); return; }

  const gross    = calcGross();
  const taxable  = calcTaxable();
  const taxTotal = calcTaxes();
  const net      = calcNet();
  const pdT      = calcPD();
  const miT      = calcMi();
  const addT     = calcAdd();
  const dedT     = calcDed();
  const preT     = calcPre();
  const postT    = calcPost();

  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "letter" });
  const W = 215.9, H = 279.4, M = 14;

  // ── COLOR HELPERS ──────────────────────────────────────────────────────────
  const c = {
    navy:    [10,  20,  45],
    navyMid: [18,  32,  70],
    navyLt:  [28,  45,  95],
    amber:   [245, 158, 11],
    amberLt: [251, 191, 36],
    white:   [255, 255, 255],
    offWhite:[240, 242, 248],
    slate:   [148, 163, 200],
    muted:   [90,  105, 140],
    green:   [34,  197, 100],
    red:     [239, 68,  68],
    blue:    [96,  165, 250],
    purple:  [167, 139, 250],
    divider: [35,  55,  100],
    rowAlt:  [16,  28,  58],
    rowBase: [13,  23,  50],
  };

  const setC  = (rgb) => doc.setTextColor(rgb[0], rgb[1], rgb[2]);
  const fillC = (rgb) => doc.setFillColor(rgb[0], rgb[1], rgb[2]);
  const drawC = (rgb) => doc.setDrawColor(rgb[0], rgb[1], rgb[2]);

  const fmt2 = (n) => parseFloat(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // ── PAGE BACKGROUND ────────────────────────────────────────────────────────
  fillC(c.navy); doc.rect(0, 0, W, H, "F");

  // ── TOP HEADER BAR ─────────────────────────────────────────────────────────
  // Gradient effect via layered rects
  fillC(c.navyLt); doc.rect(0, 0, W, 38, "F");
  fillC(c.navyMid); doc.rect(0, 28, W, 10, "F");

  // Amber accent left bar
  fillC(c.amber); doc.rect(0, 0, 5, 38, "F");

  // Company logo
  if (logo) { try { doc.addImage(logo, 'PNG', W - 46, 5, 32, 13); } catch {} }

  // Title
  setC(c.white);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text("PAYROLL STATEMENT", 12, 16);

  setC(c.amber);
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.text("EMPLOYEE EARNINGS RECORD  ·  CONFIDENTIAL", 12, 22);

  // Sub-bar info
  setC(c.slate);
  doc.setFontSize(7);
  doc.text(
    `Pay Period: ${startDate} – ${endDate}     Check #: ${checkNumber || "N/A"}     Payment Method: ${paymentMethod}     Generated: ${new Date().toLocaleDateString("en-US", { year:"numeric", month:"long", day:"numeric" })}`,
    12, 33
  );

  let y = 46;

  // ── EMPLOYEE INFO BLOCK ────────────────────────────────────────────────────
  // Card background
  fillC(c.navyMid); doc.roundedRect(M, y, W - M * 2, 32, 2, 2, "F");
  drawC(c.divider); doc.setLineWidth(0.4);
  doc.roundedRect(M, y, W - M * 2, 32, 2, 2, "S");

  // Left amber accent
  fillC(c.amber); doc.roundedRect(M, y, 4, 32, 1, 1, "F");

  const empFields = [
    { label: "EMPLOYEE NAME",  value: `${selectedEmployee.firstName} ${selectedEmployee.lastName}` },
    { label: "EMPLOYEE ID",    value: selectedEmployee._id?.toString().slice(-8).toUpperCase() || "—" },
    { label: "POSITION / TITLE", value: selectedEmployee.position || "—" },
    { label: "DEPARTMENT",     value: department || selectedEmployee.department || "—" },
    { label: "PAY TYPE",       value: selectedEmployee.payType || "Fixed Salary" },
    { label: "PAY RATE",       value: selectedEmployee.payType === "Hourly" ? `$${fmt2(selectedEmployee.payAmount)} / hr` : `$${fmt2(selectedEmployee.payAmount)} / period` },
    { label: "BUSINESS UNIT",  value: businessUnit || "—" },
    { label: "PAY PERIOD",     value: `${startDate}  →  ${endDate}` },
  ];

  const colW = (W - M * 2 - 6) / 4;
  empFields.forEach(({ label, value }, i) => {
    const col = i % 4;
    const row = Math.floor(i / 4);
    const x = M + 6 + col * colW;
    const yy = y + 9 + row * 12;

    setC(c.muted);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(5.5);
    doc.text(label, x, yy);

    setC(c.offWhite);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7.5);
    doc.text(String(value), x, yy + 5);
  });

  y += 40;

  // ── SECTION HEADER HELPER ─────────────────────────────────────────────────
  const secHeader = (title, rgb, icon = "") => {
    fillC(rgb);
    doc.rect(M, y, W - M * 2, 7, "F");
    // subtle darker overlay right side
    doc.setFillColor(0, 0, 0);
    doc.setGState(doc.GState({ opacity: 0.15 }));
    doc.rect(M + (W - M * 2) * 0.6, y, (W - M * 2) * 0.4, 7, "F");
    doc.setGState(doc.GState({ opacity: 1 }));

    setC(c.navy);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7.5);
    doc.text((icon ? icon + "  " : "") + title.toUpperCase(), M + 4, y + 5);
    y += 7;
  };

  // ── TABLE HEADER HELPER ───────────────────────────────────────────────────
  const tableHeader = (cols, widths) => {
    fillC(c.navyLt);
    doc.rect(M, y, W - M * 2, 6, "F");
    drawC(c.divider); doc.setLineWidth(0.2);
    doc.line(M, y + 6, M + W - M * 2, y + 6);

    let x = M + 2;
    cols.forEach((col, ci) => {
      const isR = ci >= 2;
      setC(c.slate);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(5.8);
      doc.text(col.toUpperCase(), isR ? x + widths[ci] - 2 : x, y + 4.2, { align: isR ? "right" : "left" });
      x += widths[ci];
    });
    y += 6;
  };

  // ── DATA ROW HELPER ───────────────────────────────────────────────────────
  let rowToggle = false;
  const dataRow = (cols, widths, highlight = false, valueColor = null) => {
    if (y > H - 30) {
      doc.addPage();
      fillC(c.navy); doc.rect(0, 0, W, H, "F");
      // Page header strip
      fillC(c.navyMid); doc.rect(0, 0, W, 10, "F");
      fillC(c.amber); doc.rect(0, 0, 5, 10, "F");
      setC(c.slate); doc.setFont("helvetica", "normal"); doc.setFontSize(6.5);
      doc.text(`${selectedEmployee.firstName} ${selectedEmployee.lastName}  ·  Payroll Statement  ·  ${startDate} – ${endDate}`, 12, 7);
      y = 16;
      rowToggle = false;
    }

    fillC(highlight ? c.navyLt : (rowToggle ? c.rowAlt : c.rowBase));
    doc.rect(M, y, W - M * 2, 6.5, "F");
    rowToggle = !rowToggle;

    let x = M + 2;
    cols.forEach((col, ci) => {
      const isR = ci >= 2;
      const xP = isR ? x + widths[ci] - 2 : x;
      if (ci === 0) setC(c.offWhite);
      else if (valueColor && ci === 3) setC(valueColor);
      else setC(c.slate);
      doc.setFont("helvetica", ci === 0 ? "normal" : (ci >= 4 ? "bold" : "normal"));
      doc.setFontSize(7.2);
      doc.text(String(col ?? "—"), xP, y + 4.5, { align: isR ? "right" : "left" });
      x += widths[ci];
    });

    drawC(c.divider); doc.setLineWidth(0.1);
    doc.line(M, y + 6.5, M + W - M * 2, y + 6.5);
    y += 6.5;
  };

  // ── SUBTOTAL ROW ──────────────────────────────────────────────────────────
  const subtotalRow = (label, value, rgb) => {
    fillC(c.navyMid); doc.rect(M, y, W - M * 2, 7.5, "F");
    drawC(rgb); doc.setLineWidth(0.5);
    doc.line(M, y, M + 4, y);
    doc.setLineWidth(0.1);

    setC(rgb);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.text(label.toUpperCase(), M + 7, y + 5.2);
    doc.text(`$${fmt2(value)}`, W - M - 3, y + 5.2, { align: "right" });
    y += 10;
    rowToggle = false;
  };

  // ══════════════════════════════════════════════════════════════════════════
  // SECTION 1 — EARNINGS
  // ══════════════════════════════════════════════════════════════════════════
  secHeader("Earnings", c.amber);

  const earnW = [62, 22, 26, 28, 24, 26];
  tableHeader(["Pay Description", "Hours", "Rate", "Current Period", "YTD Hours", "YTD Amount"], earnW);
  rowToggle = false;

  if (selectedEmployee.payType === 'Commission') {
    const rate = parseFloat(selectedEmployee.commissionPercentage) || 0;
    commissions.forEach(comm => {
      const earned = (parseFloat(comm.grossAmount) || 0) * rate / 100;
      dataRow([`Commission — ${comm.description || "Load"}  (${rate}%)`, "—", `${rate}%`, `$${fmt2(earned)}`, "—", "—"], earnW, false, c.amberLt);
    });
  } else if (selectedEmployee.payType === 'Fixed salary') {
    const ytd = ytdTotals["Fixed salary"] || {};
    dataRow(["Fixed Salary", "—", "—", `$${fmt2(selectedEmployee.payAmount)}`, "—", `$${fmt2(ytd.amount || 0)}`], earnW);
  } else {
    earnings.forEach(e => {
      const ytd = ytdTotals[e.type] || {};
      const isOT = e.type === "Overtime";
      dataRow([
        e.type,
        e.hours || "—",
        e.rate ? `$${fmt2(e.rate)}` : "—",
        `$${fmt2(e.amount)}`,
        ytd.hours?.toFixed(2) || "—",
        `$${fmt2(ytd.amount || 0)}`,
      ], earnW, isOT, isOT ? c.amberLt : null);
    });
  }

  subtotalRow("Gross Earnings", gross, c.amber);

  // ══════════════════════════════════════════════════════════════════════════
  // SECTION 2 — ALLOWANCES & REIMBURSEMENTS
  // ══════════════════════════════════════════════════════════════════════════
  if (pdT > 0 || miT > 0) {
    secHeader("Allowances & Reimbursements  (Non-Taxable)", c.blue);
    const allowW = [90, 30, 30, 28, 0, 0];
    tableHeader(["Description", "Units", "Rate", "Amount", "", ""], allowW);
    rowToggle = false;

    if (pdT > 0) {
      dataRow([
        `Per Diem — ${perDiem.days} day(s) @ $${fmt2(perDiem.ratePerDay)}/day`,
        `${perDiem.days} days`,
        `$${fmt2(perDiem.ratePerDay)}`,
        `$${fmt2(pdT)}`, "", "",
      ], allowW, false, c.blue);
    }
    if (miT > 0) {
      dataRow([
        `Mileage Reimbursement — ${mileage.miles} mi @ $${mileage.ratePerMile}/mi  (IRS Rate)`,
        `${mileage.miles} mi`,
        `$${mileage.ratePerMile}`,
        `$${fmt2(miT)}`, "", "",
      ], allowW, false, c.blue);
    }

    fillC(c.navyMid); doc.rect(M, y, W - M * 2, 7, "F");
    setC(c.blue);
    doc.setFont("helvetica", "bold"); doc.setFontSize(7.5);
    doc.text("TOTAL NON-TAXABLE REIMBURSEMENTS", M + 7, y + 5);
    doc.text(`$${fmt2(pdT + miT)}`, W - M - 3, y + 5, { align: "right" });
    y += 10;
    rowToggle = false;
  }

  // ══════════════════════════════════════════════════════════════════════════
  // SECTION 3 — ADDITIONS / BONUSES
  // ══════════════════════════════════════════════════════════════════════════
  if (additions.length > 0) {
    secHeader("Additions & Bonuses", c.green);
    const addW = [110, 35, 43];
    tableHeader(["Description", "Type", "Amount"], addW);
    rowToggle = false;

    additions.forEach(a => {
      dataRow([a.name || "Bonus / Addition", "Addition", `$${fmt2(a.amount)}`], addW, false, c.green);
    });

    fillC(c.navyMid); doc.rect(M, y, W - M * 2, 7, "F");
    setC(c.green);
    doc.setFont("helvetica", "bold"); doc.setFontSize(7.5);
    doc.text("TOTAL ADDITIONS", M + 7, y + 5);
    doc.text(`$${fmt2(addT)}`, W - M - 3, y + 5, { align: "right" });
    y += 10;
    rowToggle = false;
  }

  // ══════════════════════════════════════════════════════════════════════════
  // SECTION 4 — BENEFITS
  // ══════════════════════════════════════════════════════════════════════════
  const actBenefits = benefits.filter(b => parseFloat(b.amount) > 0);
  if (actBenefits.length > 0) {
    secHeader("Benefit Deductions", c.purple);
    const benW = [90, 30, 30, 38];
    tableHeader(["Benefit Plan", "Tax Treatment", "Effect on Taxable Income", "Amount Deducted"], benW);
    rowToggle = false;

    actBenefits.forEach(b => {
      dataRow([
        b.name,
        b.preTax ? "Pre-Tax" : "Post-Tax",
        b.preTax ? "Reduces taxable gross" : "No effect on taxable",
        `($${fmt2(b.amount)})`,
      ], benW, false, c.purple);
    });

    fillC(c.navyMid); doc.rect(M, y, W - M * 2, 7, "F");
    setC(c.purple);
    doc.setFont("helvetica", "bold"); doc.setFontSize(7.5);
    doc.text(`TOTAL BENEFITS  (Pre-Tax: $${fmt2(preT)}  |  Post-Tax: $${fmt2(postT)})`, M + 7, y + 5);
    doc.text(`($${fmt2(preT + postT)})`, W - M - 3, y + 5, { align: "right" });
    y += 10;
    rowToggle = false;
  }

  // ══════════════════════════════════════════════════════════════════════════
  // SECTION 5 — OTHER DEDUCTIONS
  // ══════════════════════════════════════════════════════════════════════════
  if (deductions.length > 0) {
    secHeader("Other Deductions", c.red);
    const dedW = [110, 35, 43];
    tableHeader(["Description", "Type", "Amount"], dedW);
    rowToggle = false;

    deductions.forEach(d => {
      dataRow([d.name || "Deduction", "Deduction", `($${fmt2(d.amount)})`], dedW, false, c.red);
    });

    fillC(c.navyMid); doc.rect(M, y, W - M * 2, 7, "F");
    setC(c.red);
    doc.setFont("helvetica", "bold"); doc.setFontSize(7.5);
    doc.text("TOTAL DEDUCTIONS", M + 7, y + 5);
    doc.text(`($${fmt2(dedT)})`, W - M - 3, y + 5, { align: "right" });
    y += 10;
    rowToggle = false;
  }

  // ══════════════════════════════════════════════════════════════════════════
  // SECTION 6 — TAXABLE INCOME RECONCILIATION
  // ══════════════════════════════════════════════════════════════════════════
  if (y > H - 80) {
    doc.addPage();
    fillC(c.navy); doc.rect(0, 0, W, H, "F");
    fillC(c.navyMid); doc.rect(0, 0, W, 10, "F");
    fillC(c.amber); doc.rect(0, 0, 5, 10, "F");
    setC(c.slate); doc.setFont("helvetica", "normal"); doc.setFontSize(6.5);
    doc.text(`${selectedEmployee.firstName} ${selectedEmployee.lastName}  ·  Payroll Statement  ·  ${startDate} – ${endDate}`, 12, 7);
    y = 16;
  }

  secHeader("Federal & State Tax Withholdings", c.red);

  // Taxable income line
  fillC(c.navyLt); doc.rect(M, y, W - M * 2, 7, "F");
  setC(c.amber);
  doc.setFont("helvetica", "bold"); doc.setFontSize(7.5);
  doc.text("TAXABLE GROSS INCOME  =  Gross Earnings + Additions − Pre-Tax Benefits", M + 4, y + 5);
  doc.text(`$${fmt2(taxable)}`, W - M - 3, y + 5, { align: "right" });
  y += 9;
  rowToggle = false;

  const taxW = [70, 28, 30, 60];
  tableHeader(["Tax Type", "Rate", "This Period", "YTD (Estimated)"], taxW);

  const taxList = [
    { name: "Federal Income Tax",     pct: taxes.federalIncome  },
    { name: "State Income Tax",       pct: taxes.stateIncome    },
    { name: "Social Security (OASDI)",pct: taxes.socialSecurity },
    { name: "Medicare (HI)",          pct: taxes.medicare       },
    { name: "State Unemployment (SUI/SDI)", pct: taxes.stateSUI },
    { name: "Local / City Tax",       pct: taxes.localTax       },
    ...otherTaxes.map(ot => ({ name: ot.name, pct: ot.percentage })),
  ].filter(tx => parseFloat(tx.pct) > 0);

  taxList.forEach((tx, idx) => {
    const amt = taxable * parseFloat(tx.pct) / 100;
    // Estimate YTD based on payroll history count
    const periodsCount = payrollHistory.length + 1;
    dataRow([
      tx.name,
      `${tx.pct}%`,
      `($${fmt2(amt)})`,
      `≈ ($${fmt2(amt * periodsCount)})`,
    ], taxW, false, c.red);
  });

  subtotalRow("Total Tax Withholdings", taxTotal, c.red);

  // ══════════════════════════════════════════════════════════════════════════
  // SECTION 7 — NET PAY SUMMARY BOX
  // ══════════════════════════════════════════════════════════════════════════
  if (y > H - 65) {
    doc.addPage();
    fillC(c.navy); doc.rect(0, 0, W, H, "F");
    fillC(c.navyMid); doc.rect(0, 0, W, 10, "F");
    fillC(c.amber); doc.rect(0, 0, 5, 10, "F");
    setC(c.slate); doc.setFont("helvetica", "normal"); doc.setFontSize(6.5);
    doc.text(`${selectedEmployee.firstName} ${selectedEmployee.lastName}  ·  Payroll Statement  ·  ${startDate} – ${endDate}`, 12, 7);
    y = 16;
  }

  y += 4;

  // Summary card
  fillC(c.navyMid); doc.roundedRect(M, y, W - M * 2, 52, 2, 2, "F");
  drawC(c.amber); doc.setLineWidth(0.8);
  doc.roundedRect(M, y, W - M * 2, 52, 2, 2, "S");
  // Top amber accent bar on card
  fillC(c.amber); doc.roundedRect(M, y, W - M * 2, 6, 2, 2, "F");
  doc.rect(M, y + 3, W - M * 2, 3, "F");

  setC(c.navy);
  doc.setFont("helvetica", "bold"); doc.setFontSize(8);
  doc.text("EARNINGS & DEDUCTIONS SUMMARY", M + 5, y + 4.5);

  // Left column — breakdown
  const sumItems = [
    { label: "Gross Earnings",           value: `$${fmt2(gross)}`,         clr: c.white   },
    { label: "Non-Taxable Allowances",   value: `+ $${fmt2(pdT + miT)}`,   clr: c.blue    },
    { label: "Taxable Additions",        value: `+ $${fmt2(addT)}`,        clr: c.green   },
    { label: "Pre-Tax Benefits",         value: `- $${fmt2(preT)}`,        clr: c.purple  },
    { label: "Post-Tax Benefits",        value: `- $${fmt2(postT)}`,       clr: c.purple  },
    { label: "Other Deductions",         value: `- $${fmt2(dedT)}`,        clr: c.red     },
    { label: "Federal & State Taxes",   value: `- $${fmt2(taxTotal)}`,    clr: c.red     },
  ];

  sumItems.forEach(({ label, value, clr }, i) => {
    const yy = y + 13 + i * 5.4;
    setC(c.slate);
    doc.setFont("helvetica", "normal"); doc.setFontSize(6.8);
    doc.text(label, M + 5, yy);
    setC(clr);
    doc.setFont("helvetica", "bold"); doc.setFontSize(7);
    doc.text(value, M + 105, yy, { align: "right" });
  });

  // Divider line
  drawC(c.divider); doc.setLineWidth(0.3);
  doc.line(M + 5, y + 50, M + 110, y + 50);

  // Right side — NET PAY box
  fillC(c.amber);
  doc.roundedRect(M + 118, y + 8, W - M * 2 - 118, 36, 2, 2, "F");

  setC(c.navy);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.text("NET PAY", M + 120, y + 19);

  doc.setFontSize(22);
  doc.text(`$${fmt2(net)}`, M + 186, y + 35, { align: "right" });

  setC(c.navyMid);
  doc.setFont("helvetica", "normal"); doc.setFontSize(6);
  doc.text(`Pay Method: ${paymentMethod}`, M + 120, y + 41);

  y += 62;

  // ══════════════════════════════════════════════════════════════════════════
  // SECTION 8 — TAXABLE INCOME NOTICE
  // ══════════════════════════════════════════════════════════════════════════
  fillC(c.navyMid); doc.roundedRect(M, y, W - M * 2, 14, 1, 1, "F");
  drawC(c.divider); doc.setLineWidth(0.2);
  doc.roundedRect(M, y, W - M * 2, 14, 1, 1, "S");

  setC(c.slate);
  doc.setFont("helvetica", "bold"); doc.setFontSize(6.2);
  doc.text("TAXABLE INCOME SUMMARY:", M + 4, y + 5);
  doc.setFont("helvetica", "normal");
  doc.text(
    `Gross: $${fmt2(gross)}  |  Pre-Tax Deductions: ($${fmt2(preT)})  |  Taxable Gross: $${fmt2(taxable)}  |  Total Taxes Withheld: ($${fmt2(taxTotal)})  |  Effective Tax Rate: ${gross > 0 ? ((taxTotal / gross) * 100).toFixed(1) : "0.0"}%`,
    M + 4, y + 10
  );

  y += 20;

  // ══════════════════════════════════════════════════════════════════════════
  // SECTION 9 — NOTES
  // ══════════════════════════════════════════════════════════════════════════
  if (notes) {
    if (y > H - 35) {
      doc.addPage();
      fillC(c.navy); doc.rect(0, 0, W, H, "F");
      y = 16;
    }
    fillC(c.navyMid); doc.roundedRect(M, y, W - M * 2, 20, 1, 1, "F");
    setC(c.amber);
    doc.setFont("helvetica", "bold"); doc.setFontSize(6.5);
    doc.text("EMPLOYER NOTES / MESSAGES:", M + 4, y + 6);
    setC(c.offWhite);
    doc.setFont("helvetica", "normal"); doc.setFontSize(7);
    const noteLines = doc.splitTextToSize(notes, W - M * 2 - 8);
    doc.text(noteLines, M + 4, y + 12);
    y += 24;
  }

  // ══════════════════════════════════════════════════════════════════════════
  // FOOTER — every page
  // ══════════════════════════════════════════════════════════════════════════
  const totalPages = doc.getNumberOfPages();
  for (let pg = 1; pg <= totalPages; pg++) {
    doc.setPage(pg);

    // Footer bar
    fillC(c.navyMid); doc.rect(0, H - 14, W, 14, "F");
    fillC(c.amber);   doc.rect(0, H - 14, W, 1.5, "F");

    // Left — disclaimer
    setC(c.muted);
    doc.setFont("helvetica", "normal"); doc.setFontSize(5.8);
    doc.text(
      useCustomFooter && footer
        ? footer
        : "This document is confidential and intended solely for the named employee. Unauthorized use or distribution is prohibited.",
      M, H - 7
    );

    // Right — company + page
    setC(c.slate);
    doc.setFont("helvetica", "bold"); doc.setFontSize(6);
    doc.text(
      `Full Trucking Service  ·  Page ${pg} of ${totalPages}`,
      W - M, H - 7, { align: "right" }
    );

    // Right — date + check
    setC(c.amber);
    doc.setFontSize(5.5);
    doc.text(
      `Issue Date: ${new Date().toLocaleDateString("en-US")}   Check #: ${checkNumber || "N/A"}`,
      W - M, H - 3.5, { align: "right" }
    );
  }

  // ── SAVE ──────────────────────────────────────────────────────────────────
  doc.save(`Payroll_${selectedEmployee.firstName}_${selectedEmployee.lastName}_${startDate.replace(/-/g, "")}.pdf`);

  // ── SAVE TO DB ────────────────────────────────────────────────────────────
  try {
    await axios.post(`${apiUrl}/employees/save-payroll`, {
      employeeId: selectedEmployee._id,
      startDate, endDate, checkNumber, paymentMethod,
      earnings, commissions,
      perDiem, mileageReimbursement: mileage,
      additions, deductions, benefits,
      taxes: { ...taxes, otherTaxes },
      notes, businessUnit, department,
      gross:    gross.toFixed(2),
      total:    net.toFixed(2),
      taxable:  taxable.toFixed(2),
      totalTax: taxTotal.toFixed(2),
    }, config);
    notify("Payroll saved and PDF downloaded.", "success");
    const r = await axios.get(`${apiUrl}/employees/${selectedEmployee._id}/payrolls`, config);
    setPayrollHistory(Array.isArray(r.data) ? r.data : []);
  } catch {
    notify("PDF downloaded but failed to save payroll record.", "error");
  }
};
  // ── LIVE ──────────────────────────────────────────────────────────────────
  const gross    = calcGross();
  const taxTotal = calcTaxes();
  const net      = calcNet();

  // ── RENDER ────────────────────────────────────────────────────────────────
  const rootCls = `${styles.payrollEmployeeSection}${isLight?' '+styles.payrollEmployeeSectionLight:''}`;

  return (
    <div className={rootCls}>

      <h3>Employee Payroll</h3>

      {/* ── EMPLOYEE SELECT ── */}
      <select
        className={styles.employeeSelect}
        value={selectedEmployee?._id||''}
        onChange={e => setSelectedEmployee(employees.find(emp=>emp._id===e.target.value)||null)}
      >
        <option value="">— Select Employee —</option>
        {employees.map(emp=>(
          <option key={emp._id} value={emp._id}>
            {emp.firstName} {emp.lastName}{emp.position?` · ${emp.position}`:''}
          </option>
        ))}
      </select>

      {selectedEmployee && (
        <div style={{display:"flex",gap:16,flexWrap:"wrap",marginBottom:16,padding:"10px 14px",background:"rgba(245,158,11,0.06)",border:"1px solid rgba(245,158,11,0.22)",borderRadius:8,fontSize:"0.82rem"}}>
          {[
            ["Pay Type", selectedEmployee.payType||"Fixed salary"],
            ["Rate",     selectedEmployee.payType==="Hourly"?`${fmt(selectedEmployee.payAmount)}/hr`:fmt(selectedEmployee.payAmount)],
            ["Position", selectedEmployee.position||"—"],
            ["Dept",     selectedEmployee.department||"—"],
          ].map(([l,v])=>(
            <span key={l} style={{color:"#9494A8"}}>{l}: <strong style={{color:"#EEEEF2"}}>{v}</strong></span>
          ))}
        </div>
      )}

      {/* ── TABS ── */}
      <div style={{display:"flex",gap:8,marginBottom:20}}>
        {[["entry","New Payroll"],["history","Payroll History"]].map(([id,lbl])=>(
          <button
            key={id}
            type="button"
            onClick={()=>setActiveTab(id)}
            style={{
              padding:"8px 20px", borderRadius:100, cursor:"pointer",
              border:`1px solid ${activeTab===id?"rgba(245,158,11,0.3)":"rgba(255,255,255,0.1)"}`,
              background:activeTab===id?"rgba(245,158,11,0.1)":"transparent",
              color:activeTab===id?"#FBBF24":"#9494A8",
              fontFamily:"'Barlow Condensed',sans-serif",
              fontSize:"0.78rem", fontWeight:700,
              letterSpacing:"0.08em", textTransform:"uppercase",
            }}
          >{lbl}</button>
        ))}
      </div>

      {/* ══ HISTORY ══ */}
      {activeTab==="history" && (
        !selectedEmployee
          ? <p style={{textAlign:"center",color:"#52526A",fontStyle:"italic",padding:"40px 0"}}>Select an employee first.</p>
          : payrollHistory.length===0
            ? <p style={{textAlign:"center",color:"#52526A",fontStyle:"italic",padding:"40px 0"}}>No payroll records found.</p>
            : (
              <div style={{overflowX:"auto"}}>
                <table style={{width:"100%",borderCollapse:"collapse",fontSize:"0.82rem"}}>
                  <thead>
                    <tr style={{background:"rgba(245,158,11,0.06)"}}>
                      {["Pay Period","Check #","Method","Gross","Taxes","Net Pay"].map(h=>(
                        <th key={h} style={{padding:"10px 14px",textAlign:"left",fontFamily:"'Barlow Condensed',sans-serif",fontSize:"0.63rem",fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",color:"#F59E0B",borderBottom:"1px solid rgba(255,255,255,0.07)"}}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {payrollHistory.map((p,i)=>(
                      <tr key={i} style={{borderBottom:"1px solid rgba(255,255,255,0.05)"}}>
                        <td style={{padding:"10px 14px",color:"#EEEEF2"}}>{p.startDate} – {p.endDate}</td>
                        <td style={{padding:"10px 14px",color:"#9494A8"}}>{p.checkNumber||"—"}</td>
                        <td style={{padding:"10px 14px",color:"#9494A8"}}>{p.paymentMethod||"—"}</td>
                        <td style={{padding:"10px 14px",color:"#F59E0B",fontWeight:600,fontFamily:"'Barlow Condensed',sans-serif"}}>{fmt(p.gross)}</td>
                        <td style={{padding:"10px 14px",color:"#F87171",fontFamily:"'Barlow Condensed',sans-serif"}}>{fmt(p.totalTax)}</td>
                        <td style={{padding:"10px 14px",color:"#34D399",fontWeight:700,fontFamily:"'Barlow Condensed',sans-serif"}}>{fmt(p.total)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
      )}

      {/* ══ ENTRY ══ */}
      {activeTab==="entry" && (
        <div style={{display:"grid",gridTemplateColumns:"1fr 300px",gap:24,alignItems:"start"}}>

          {/* ── LEFT ── */}
          <div>

            {/* Pay Period */}
            <h4>Pay Period</h4>
            <div className={styles.itemRowPayrollEmployee}>
              <label>Start Date</label>
              <input type="date" value={startDate} onChange={e=>setStartDate(e.target.value)} />
            </div>
            <div className={styles.itemRowPayrollEmployee}>
              <label>End Date</label>
              <input type="date" value={endDate} onChange={e=>setEndDate(e.target.value)} />
            </div>
            <div className={styles.itemRowPayrollEmployee}>
              <label>Check #</label>
              <input type="text" value={checkNumber} onChange={e=>setCheckNumber(e.target.value)} placeholder="e.g. 1042" />
            </div>
            <div className={styles.itemRowPayrollEmployee}>
              <label>Payment Method</label>
              <select
                value={paymentMethod}
                onChange={e=>setPaymentMethod(e.target.value)}
                style={{flex:2,padding:"10px 12px",borderRadius:6,border:"1px solid rgba(255,255,255,0.11)",background:"rgba(255,255,255,0.055)",color:"#F4F4F6",fontFamily:"'DM Sans',sans-serif",fontSize:"0.875rem",outline:"none",cursor:"pointer",colorScheme:"dark"}}
              >
                <option>Direct Deposit</option>
                <option>Check</option>
                <option>Cash</option>
              </select>
            </div>
            <div className={styles.itemRowPayrollEmployee}>
              <label>Business Unit</label>
              <input type="text" value={businessUnit} onChange={e=>setBusinessUnit(e.target.value)} placeholder="e.g. Fleet Ops" />
            </div>
            <div className={styles.itemRowPayrollEmployee}>
              <label>Department</label>
              <input type="text" value={department} onChange={e=>setDepartment(e.target.value)} placeholder="e.g. Dispatch" />
            </div>

            {/* Earnings */}
            <h4>Earnings</h4>
            {!selectedEmployee && <p style={{color:"#52526A",fontStyle:"italic",fontSize:"0.82rem"}}>Select an employee first.</p>}

            {selectedEmployee?.payType==='Commission' && (
              <>
                <p style={{color:"#9494A8",fontSize:"0.82rem",marginBottom:8}}>
                  Commission rate: <strong style={{color:"#F59E0B"}}>{selectedEmployee.commissionPercentage}%</strong>
                </p>
                {commissions.map((c,i)=>(
                  <div key={i} className={styles.itemRowPayrollEmployee}>
                    <input type="text" value={c.description} onChange={e=>{const a=[...commissions];a[i].description=e.target.value;setCommissions(a);}} placeholder="Description" />
                    <input type="number" value={c.grossAmount} onChange={e=>{const a=[...commissions];a[i].grossAmount=e.target.value;setCommissions(a);}} placeholder="Gross $" />
                    <button type="button" onClick={()=>setCommissions(commissions.filter((_,x)=>x!==i))} className={styles.removeCommissionButton}>X</button>
                  </div>
                ))}
                <button type="button" onClick={()=>setCommissions(p=>[...p,{description:'',grossAmount:''}])} className={styles.addCommissionButton}>+ Add Commission</button>
              </>
            )}

            {selectedEmployee?.payType==='Fixed salary' && (
              <>
                <div className={styles.itemRowPayrollEmployee}>
                  <label>Fixed Salary</label>
                  <input type="text" value={fmt(selectedEmployee.payAmount)} disabled style={{opacity:0.6}} />
                </div>
                <div className={styles.itemRowPayrollEmployee}>
                  <label>Hours (record)</label>
                  <input type="number" value={hoursWorked} onChange={e=>setHoursWorked(e.target.value)} placeholder="80" />
                </div>
              </>
            )}

            {selectedEmployee && selectedEmployee.payType!=='Commission' && selectedEmployee.payType!=='Fixed salary' && (
              <>
                {earnings.map((e,i)=>(
                  <div key={i} className={styles.itemRowPayrollEmployee}>
                    <select
                      value={e.type}
                      onChange={ev=>updateEarning(i,'type',ev.target.value)}
                      style={{flex:2,padding:"10px 12px",borderRadius:6,border:"1px solid rgba(255,255,255,0.11)",background:"rgba(255,255,255,0.055)",color:"#F4F4F6",fontFamily:"'DM Sans',sans-serif",fontSize:"0.875rem",outline:"none",cursor:"pointer",colorScheme:"dark"}}
                    >
                      {["Regular","Overtime","Holiday","Vacation","Sick Leave","Personal Day","FMLA","Bonus","Training","On-Call","Other"].map(o=><option key={o}>{o}</option>)}
                    </select>
                    <input type="number" value={e.hours} onChange={ev=>updateEarning(i,'hours',ev.target.value)} placeholder="Hours" />
                    <input type="number" value={e.rate}  onChange={ev=>updateEarning(i,'rate',ev.target.value)}  placeholder="Rate" />
                    <span style={{minWidth:80,fontFamily:"'Barlow Condensed',sans-serif",fontWeight:700,color:"#34D399",fontSize:"0.9rem"}}>{fmt(e.amount)}</span>
                    {i>0&&<button type="button" onClick={()=>setEarnings(earnings.filter((_,x)=>x!==i))} className={styles.removeCommissionButton}>X</button>}
                  </div>
                ))}
                <button type="button" onClick={()=>setEarnings(p=>[...p,{type:'Overtime',hours:'',rate:'',amount:''}])} className={styles.addCommissionButton}>+ Add Row</button>
              </>
            )}

            {/* Per Diem & Mileage */}
            <h4>Per Diem & Mileage (Non-Taxable)</h4>
            <div className={styles.itemRowPayrollEmployee}>
              <label>Per Diem Days</label>
              <input type="number" value={perDiem.days} onChange={e=>setPerDiem(p=>({...p,days:e.target.value}))} placeholder="5" />
            </div>
            <div className={styles.itemRowPayrollEmployee}>
              <label>Rate / Day ($)</label>
              <input type="number" value={perDiem.ratePerDay} onChange={e=>setPerDiem(p=>({...p,ratePerDay:e.target.value}))} placeholder="75.00" />
            </div>
            <div className={styles.itemRowPayrollEmployee}>
              <label>Per Diem Total</label>
              <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:700,color:"#60A5FA",fontSize:"0.95rem"}}>{fmt(perDiem.total)}</span>
            </div>
            <div className={styles.itemRowPayrollEmployee}>
              <label>Business Miles</label>
              <input type="number" value={mileage.miles} onChange={e=>setMileage(p=>({...p,miles:e.target.value}))} placeholder="500" />
            </div>
            <div className={styles.itemRowPayrollEmployee}>
              <label>IRS Rate ($/mi)</label>
              <input type="number" step="0.01" value={mileage.ratePerMile} onChange={e=>setMileage(p=>({...p,ratePerMile:e.target.value}))} />
            </div>
            <div className={styles.itemRowPayrollEmployee}>
              <label>Mileage Total</label>
              <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:700,color:"#60A5FA",fontSize:"0.95rem"}}>{fmt(mileage.total)}</span>
            </div>

            {/* Additions */}
            <h4>Additions / Bonuses</h4>
            {additions.map((a,i)=>(
              <div key={i} className={styles.itemRowPayrollEmployee}>
                <input type="text" value={a.name} onChange={e=>{const arr=[...additions];arr[i].name=e.target.value;setAdditions(arr);}} placeholder="Description" />
                <input type="number" value={a.amount} onChange={e=>{const arr=[...additions];arr[i].amount=e.target.value;setAdditions(arr);}} placeholder="Amount" />
                <button type="button" onClick={()=>setAdditions(additions.filter((_,x)=>x!==i))} className={styles.removeAdditionButton}>X</button>
              </div>
            ))}
            <button type="button" onClick={()=>setAdditions(p=>[...p,{name:'',amount:''}])} className={styles.addAdditionButton}>+ Add Addition</button>

            {/* Benefits */}
            <h4>Benefits</h4>
            <p style={{color:"#52526A",fontSize:"0.78rem",marginBottom:8}}>Pre-tax reduces taxable income. Post-tax deducted after taxes.</p>
            {benefits.map((b,i)=>(
              <div key={i} className={styles.itemRowPayrollEmployee}>
                <input type="text" value={b.name} onChange={e=>{const a=[...benefits];a[i].name=e.target.value;setBenefits(a);}} placeholder="Benefit Name" />
                <input type="number" value={b.amount} onChange={e=>{const a=[...benefits];a[i].amount=e.target.value;setBenefits(a);}} placeholder="Amount" />
                <select
                  value={b.preTax?"pre":"post"}
                  onChange={e=>{const a=[...benefits];a[i].preTax=e.target.value==="pre";setBenefits(a);}}
                  style={{padding:"10px 12px",borderRadius:6,border:"1px solid rgba(255,255,255,0.11)",background:"rgba(255,255,255,0.055)",color:"#F4F4F6",fontFamily:"'DM Sans',sans-serif",fontSize:"0.875rem",outline:"none",cursor:"pointer",colorScheme:"dark"}}
                >
                  <option value="pre">Pre-Tax</option>
                  <option value="post">Post-Tax</option>
                </select>
                <button type="button" onClick={()=>setBenefits(benefits.filter((_,x)=>x!==i))} className={styles.removeDeductionButton}>X</button>
              </div>
            ))}
            <button type="button" onClick={()=>setBenefits(p=>[...p,{name:'',amount:'',preTax:true}])} className={styles.addDeductionButton}>+ Add Benefit</button>

            {/* Deductions */}
            <h4>Other Deductions</h4>
            {deductions.map((d,i)=>(
              <div key={i} className={styles.itemRowPayrollEmployee}>
                <input type="text" value={d.name} onChange={e=>{const a=[...deductions];a[i].name=e.target.value;setDeductions(a);}} placeholder="Description" />
                <input type="number" value={d.amount} onChange={e=>{const a=[...deductions];a[i].amount=e.target.value;setDeductions(a);}} placeholder="Amount" />
                <button type="button" onClick={()=>setDeductions(deductions.filter((_,x)=>x!==i))} className={styles.removeDeductionButton}>X</button>
              </div>
            ))}
            <button type="button" onClick={()=>setDeductions(p=>[...p,{name:'',amount:''}])} className={styles.addDeductionButton}>+ Add Deduction</button>

            {/* Taxes */}
            <h4>Tax Withholdings</h4>
            <p style={{color:"#52526A",fontSize:"0.78rem",marginBottom:8}}>
              Taxable gross: <strong style={{color:"#F59E0B"}}>{fmt(calcTaxable())}</strong>
            </p>
            {[
              {lbl:"Federal Income Tax (%)", k:"federalIncome"},
              {lbl:"State Income Tax (%)",   k:"stateIncome"},
              {lbl:"Social Security (%)",    k:"socialSecurity"},
              {lbl:"Medicare (%)",           k:"medicare"},
              {lbl:"State SUI/SDI (%)",      k:"stateSUI"},
              {lbl:"Local Tax (%)",          k:"localTax"},
            ].map(({lbl,k})=>(
              <div key={k} className={styles.itemRowPayrollEmployee}>
                <label>{lbl}</label>
                <input type="number" step="0.01" value={taxes[k]} onChange={e=>setTaxes(p=>({...p,[k]:e.target.value}))} />
                {parseFloat(taxes[k])>0 && (
                  <span style={{minWidth:72,fontFamily:"'Barlow Condensed',sans-serif",fontWeight:700,color:"#F87171",fontSize:"0.82rem"}}>
                    {fmt(calcTaxable()*parseFloat(taxes[k])/100)}
                  </span>
                )}
              </div>
            ))}
            {otherTaxes.map((ot,i)=>(
              <div key={i} className={styles.itemRowPayrollEmployee}>
                <input type="text" value={ot.name} onChange={e=>{const a=[...otherTaxes];a[i].name=e.target.value;setOtherTaxes(a);}} placeholder="Tax Name" />
                <input type="number" step="0.01" value={ot.percentage} onChange={e=>{const a=[...otherTaxes];a[i].percentage=e.target.value;setOtherTaxes(a);}} placeholder="%" />
                <button type="button" onClick={()=>setOtherTaxes(otherTaxes.filter((_,x)=>x!==i))} className={styles.removeOtherTaxButton}>X</button>
              </div>
            ))}
            <button type="button" onClick={()=>setOtherTaxes(p=>[...p,{name:'',percentage:''}])} className={styles.addOtherTaxButton}>+ Add Tax</button>

            {/* Notes */}
            <h4>Notes</h4>
            <textarea value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Any notes for this payroll statement..." />

          </div>
          {/* end LEFT */}

          {/* ── RIGHT SUMMARY ── */}
          <div style={{position:"sticky",top:90,overflowAnchor:"none"}}>

            {selectedEmployee && (
              <div style={{background:"rgba(12,12,20,0.92)",border:"1px solid rgba(245,158,11,0.25)",borderTop:"3px solid #F59E0B",borderRadius:12,padding:"14px 16px",marginBottom:14}}>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:"0.6rem",fontWeight:700,letterSpacing:"0.12em",textTransform:"uppercase",color:"#9494A8",marginBottom:6}}>Selected Employee</div>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:"1.2rem",fontWeight:800,color:"#EEEEF2"}}>
                  {selectedEmployee.firstName} {selectedEmployee.lastName}
                </div>
                <div style={{fontSize:"0.77rem",color:"#52526A",marginTop:3}}>
                  {selectedEmployee.position||"—"} · {selectedEmployee.payType||"Fixed salary"}
                </div>
                {startDate&&endDate&&<div style={{fontSize:"0.72rem",color:"#F59E0B",marginTop:5}}>{startDate} – {endDate}</div>}
              </div>
            )}

            {/* Summary card */}
            <div style={{background:"rgba(12,12,20,0.92)",border:"1px solid rgba(255,255,255,0.07)",borderRadius:12,overflow:"hidden",marginBottom:14}}>
              <div style={{padding:"10px 16px",borderBottom:"1px solid rgba(255,255,255,0.07)",background:"rgba(245,158,11,0.06)"}}>
                <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:"0.72rem",fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",color:"#F59E0B"}}>Pay Summary</span>
              </div>
              <div style={{padding:"12px 16px"}}>
                {[
                  {lbl:"Gross Earnings",    val:fmt(gross),                           clr:"#EEEEF2"},
                  {lbl:"Per Diem+Mileage",  val:`+${fmt(calcPD()+calcMi())}`,         clr:"#60A5FA"},
                  {lbl:"Additions",         val:`+${fmt(calcAdd())}`,                 clr:"#34D399"},
                  {lbl:"Pre-Tax Benefits",  val:`(${fmt(calcPre())})`,                clr:"#A78BFA"},
                  {lbl:"Taxable Gross",     val:fmt(calcTaxable()),                   clr:"#F59E0B",bold:true},
                  {lbl:"Post-Tax Benefits", val:`(${fmt(calcPost())})`,               clr:"#A78BFA"},
                  {lbl:"Other Deductions",  val:`(${fmt(calcDed())})`,                clr:"#F87171"},
                  {lbl:"Total Taxes",       val:`(${fmt(taxTotal)})`,                clr:"#F87171"},
                ].map((item,i)=>(
                  <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"5px 0",borderBottom:item.bold?"1px solid rgba(245,158,11,0.2)":"1px solid rgba(255,255,255,0.05)",marginBottom:item.bold?5:0}}>
                    <span style={{fontSize:"0.74rem",color:item.bold?"#9494A8":"#52526A",fontWeight:item.bold?600:400}}>{item.lbl}</span>
                    <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:"0.86rem",fontWeight:item.bold?700:600,color:item.clr}}>{item.val}</span>
                  </div>
                ))}
                <div style={{marginTop:10,background:"linear-gradient(135deg,#FBBF24,#F59E0B)",borderRadius:10,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:"0.77rem",fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",color:"#07070C"}}>NET PAY</span>
                  <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:"1.4rem",fontWeight:800,color:"#07070C"}}>{fmt(net)}</span>
                </div>
              </div>
            </div>

            {/* YTD */}
            {Object.keys(ytdTotals).length>0&&(
              <div style={{background:"rgba(12,12,20,0.92)",border:"1px solid rgba(255,255,255,0.07)",borderRadius:12,overflow:"hidden",marginBottom:14}}>
                <div style={{padding:"10px 16px",borderBottom:"1px solid rgba(255,255,255,0.07)",background:"rgba(96,165,250,0.06)"}}>
                  <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:"0.72rem",fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",color:"#60A5FA"}}>Year-to-Date</span>
                </div>
                <div style={{padding:"10px 16px"}}>
                  {Object.entries(ytdTotals).map(([type,data])=>(
                    <div key={type} style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid rgba(255,255,255,0.05)",fontSize:"0.74rem"}}>
                      <span style={{color:"#52526A"}}>{type}</span>
                      <span style={{color:"#EEEEF2",fontFamily:"'Barlow Condensed',sans-serif",fontWeight:600}}>{fmt(data.amount)}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <button
              type="button"
              onClick={handleGeneratePDF}
              disabled={!selectedEmployee||!startDate||!endDate}
              className={styles.generatePayrollButton}
              style={{opacity:(!selectedEmployee||!startDate||!endDate)?0.45:1,cursor:(!selectedEmployee||!startDate||!endDate)?"not-allowed":"pointer"}}
            >
              Generate & Save Payroll
            </button>

          </div>
          {/* end RIGHT */}

        </div>
      )}

    </div>
    
  );
};

const PayrollManager = () => {
  const { notify } = useNotification();
  const [employees,        setEmployees]        = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [startDate,        setStartDate]        = useState('');
  const [endDate,          setEndDate]          = useState('');
  const [payrolls,         setPayrolls]         = useState([]);
  const [selectedPayroll,  setSelectedPayroll]  = useState(null);
  const [selectedPayrolls, setSelectedPayrolls] = useState([]);
  const [logo,             setLogo]             = useState(null);
  const [footer,           setFooter]           = useState('');
  const [useCustomFooter,  setUseCustomFooter]  = useState(false);
  const [theme,            setTheme]            = useState(() => sessionStorage.getItem("theme") || "dark");

  const token  = sessionStorage.getItem('token');
  const config = { headers: { Authorization: `Bearer ${token}` }, withCredentials: true };
  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const isLight = theme === "light";

  // ── FETCH ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchTheme = async () => {
      try {
        const res = await axios.get(`${apiUrl}/settings`, { headers: { Authorization: `Bearer ${token}` } });
        setTheme(res.data.theme || "dark");
      } catch { setTheme("dark"); }
    };
    fetchTheme();
    axios.get(`${apiUrl}/employees`, config).then(r => setEmployees(Array.isArray(r.data) ? r.data : [])).catch(() => {});
    axios.get(`${apiUrl}/logo`,   config).then(r => setLogo(r.data.logo)).catch(() => {});
    axios.get(`${apiUrl}/footer`, config).then(r => {
      setFooter(r.data.customFooterText || '');
      setUseCustomFooter(r.data.useCustomFooter || false);
    }).catch(() => {});
  }, []);

  const fetchPayrolls = async () => {
    if (!selectedEmployee) return;
    try {
      const { data } = await axios.get(`${apiUrl}/employees`, config);
      const emp = data.find(e => e._id === selectedEmployee._id);
      if (!emp?.payrolls) { setPayrolls([]); return; }

      const filtered = startDate && endDate
        ? emp.payrolls.filter(p => {
            const pS = new Date(p.startDate);
            const pE = new Date(p.endDate);
            return pS >= new Date(startDate) && pE <= new Date(endDate);
          })
        : emp.payrolls;

      const normalized = filtered.map(p => ({
        ...p,
        extraFields:          p.extraFields   || {},
        earnings:             p.earnings      || [],
        additions:            p.additions     || [],
        deductions:           p.deductions    || [],
        benefits:             p.benefits      || [],
        commissions:          p.commissions   || [],
        taxes:                p.taxes         || { federalIncome: 0, stateIncome: 0, socialSecurity: 0, medicare: 0, stateSUI: 0, localTax: 0, otherTaxes: [] },
        perDiem:              p.perDiem       || { days: 0, ratePerDay: 0, total: 0 },
        mileageReimbursement: p.mileageReimbursement || { miles: 0, ratePerMile: 0, total: 0 },
        gross:                parseFloat(p.gross   || 0),
        total:                parseFloat(p.total   || 0),
        taxable:              parseFloat(p.taxable  || 0),
        totalTax:             parseFloat(p.totalTax || 0),
        checkNumber:          p.checkNumber   || '',
        paymentMethod:        p.paymentMethod || 'Direct Deposit',
        businessUnit:         p.businessUnit  || p.extraFields?.businessUnit || '',
        department:           p.department    || p.extraFields?.department    || '',
        notes:                p.notes         || '',
      }));

      setPayrolls(normalized);
    } catch { notify("Failed to fetch payrolls.", "error"); }
  };

  const toggleSelection = (pay) =>
    setSelectedPayrolls(prev =>
      prev.includes(pay) ? prev.filter(p => p !== pay) : [...prev, pay]
    );

  const fmt2 = n => parseFloat(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const fmtDate = (d) => {
    if (!d) return "—";
    const dt = new Date(d);
    return `${dt.getUTCMonth() + 1}/${dt.getUTCDate()}/${dt.getUTCFullYear()}`;
  };

  // ── PDF GENERATOR ─────────────────────────────────────────────────────────
  const buildPDF = (payroll, employee) => {
    const gross    = parseFloat(payroll.gross    || 0);
    const taxable  = parseFloat(payroll.taxable  || 0);
    const taxTotal = parseFloat(payroll.totalTax || 0);
    const net      = parseFloat(payroll.total    || 0);

    const taxes      = payroll.taxes || {};
    const perDiem    = payroll.perDiem || { days: 0, ratePerDay: 0, total: 0 };
    const mileage    = payroll.mileageReimbursement || { miles: 0, ratePerMile: 0, total: 0 };
    const earnings   = payroll.earnings   || [];
    const additions  = payroll.additions  || [];
    const deductions = payroll.deductions || [];
    const benefits   = payroll.benefits   || [];
    const otherTaxes = taxes.otherTaxes   || [];
    const pdT  = parseFloat(perDiem.total || 0);
    const miT  = parseFloat(mileage.total || 0);
    const addT = additions.reduce((s, a)  => s + (parseFloat(a.amount) || 0), 0);
    const dedT = deductions.reduce((s, d) => s + (parseFloat(d.amount) || 0), 0);
    const preT = (benefits || []).filter(b =>  b.preTax).reduce((s, b) => s + (parseFloat(b.amount) || 0), 0);
    const postT= (benefits || []).filter(b => !b.preTax).reduce((s, b) => s + (parseFloat(b.amount) || 0), 0);

    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "letter" });
    const W = 215.9, H = 279.4, M = 14;

    const c = {
      navy:    [10,  20,  45],  navyMid: [18, 32, 70],  navyLt: [28, 45, 95],
      amber:   [245, 158, 11], amberLt: [251, 191, 36],
      white:   [255, 255, 255], offWhite:[240, 242, 248],
      slate:   [148, 163, 200], muted:   [90,  105, 140],
      green:   [34,  197, 100], red:     [239, 68,  68],
      blue:    [96,  165, 250], purple:  [167, 139, 250],
      divider: [35,  55,  100], rowAlt:  [16,  28,  58], rowBase: [13, 23, 50],
    };

    const setC  = rgb => doc.setTextColor(rgb[0], rgb[1], rgb[2]);
    const fillC = rgb => doc.setFillColor(rgb[0], rgb[1], rgb[2]);
    const drawC = rgb => doc.setDrawColor(rgb[0], rgb[1], rgb[2]);

    // BG
    fillC(c.navy); doc.rect(0, 0, W, H, "F");

    // Header
    fillC(c.navyLt); doc.rect(0, 0, W, 38, "F");
    fillC(c.navyMid); doc.rect(0, 28, W, 10, "F");
    fillC(c.amber); doc.rect(0, 0, 5, 38, "F");

    if (logo) { try { doc.addImage(logo, 'PNG', W - 46, 5, 32, 13); } catch {} }

    setC(c.white); doc.setFont("helvetica", "bold"); doc.setFontSize(20);
    doc.text("PAYROLL STATEMENT", 12, 16);
    setC(c.amber); doc.setFontSize(8); doc.setFont("helvetica", "normal");
    doc.text("EMPLOYEE EARNINGS RECORD  ·  CONFIDENTIAL", 12, 22);
    setC(c.slate); doc.setFontSize(7);
    doc.text(
      `Pay Period: ${fmtDate(payroll.startDate)} – ${fmtDate(payroll.endDate)}     Check #: ${payroll.checkNumber || "N/A"}     Payment: ${payroll.paymentMethod}     Generated: ${new Date().toLocaleDateString("en-US", { year:"numeric", month:"long", day:"numeric" })}`,
      12, 33
    );

    let y = 46;

    // Employee info box
    fillC(c.navyMid); doc.roundedRect(M, y, W - M * 2, 32, 2, 2, "F");
    drawC(c.divider); doc.setLineWidth(0.4);
    doc.roundedRect(M, y, W - M * 2, 32, 2, 2, "S");
    fillC(c.amber); doc.roundedRect(M, y, 4, 32, 1, 1, "F");

    const empFields = [
      { label: "EMPLOYEE NAME",    value: `${employee.firstName} ${employee.lastName}` },
      { label: "EMPLOYEE ID",      value: employee._id?.toString().slice(-8).toUpperCase() || "—" },
      { label: "POSITION / TITLE", value: employee.position || "—" },
      { label: "DEPARTMENT",       value: payroll.department || employee.department || "—" },
      { label: "PAY TYPE",         value: employee.payType || "Fixed Salary" },
      { label: "PAY RATE",         value: employee.payType === "Hourly" ? `$${fmt2(employee.payAmount)}/hr` : `$${fmt2(employee.payAmount)}/period` },
      { label: "BUSINESS UNIT",    value: payroll.businessUnit || "—" },
      { label: "PAY PERIOD",       value: `${fmtDate(payroll.startDate)}  →  ${fmtDate(payroll.endDate)}` },
    ];

    const colW = (W - M * 2 - 6) / 4;
    empFields.forEach(({ label, value }, i) => {
      const col = i % 4, row = Math.floor(i / 4);
      const x = M + 6 + col * colW, yy = y + 9 + row * 12;
      setC(c.muted);    doc.setFont("helvetica", "normal"); doc.setFontSize(5.5); doc.text(label, x, yy);
      setC(c.offWhite); doc.setFont("helvetica", "bold");   doc.setFontSize(7.5); doc.text(String(value), x, yy + 5);
    });
    y += 40;

    // Section header
    const secHeader = (title, rgb) => {
      fillC(rgb); doc.rect(M, y, W - M * 2, 7, "F");
      setC(c.navy); doc.setFont("helvetica", "bold"); doc.setFontSize(7.5);
      doc.text(title.toUpperCase(), M + 4, y + 5); y += 7;
    };

    // Table header
    const tableHeader = (cols, widths) => {
      fillC(c.navyLt); doc.rect(M, y, W - M * 2, 6, "F");
      drawC(c.divider); doc.setLineWidth(0.2); doc.line(M, y + 6, M + W - M * 2, y + 6);
      let x = M + 2;
      cols.forEach((col, ci) => {
        const isR = ci >= 2;
        setC(c.slate); doc.setFont("helvetica", "bold"); doc.setFontSize(5.8);
        doc.text(col.toUpperCase(), isR ? x + widths[ci] - 2 : x, y + 4.2, { align: isR ? "right" : "left" });
        x += widths[ci];
      });
      y += 6;
    };

    // Data row
    let rowToggle = false;
    const dataRow = (cols, widths, highlight = false, valueColor = null) => {
      if (y > H - 30) {
        doc.addPage();
        fillC(c.navy); doc.rect(0, 0, W, H, "F");
        fillC(c.navyMid); doc.rect(0, 0, W, 10, "F");
        fillC(c.amber); doc.rect(0, 0, 5, 10, "F");
        setC(c.slate); doc.setFont("helvetica", "normal"); doc.setFontSize(6.5);
        doc.text(`${employee.firstName} ${employee.lastName}  ·  Payroll  ·  ${fmtDate(payroll.startDate)} – ${fmtDate(payroll.endDate)}`, 12, 7);
        y = 16; rowToggle = false;
      }
      fillC(highlight ? c.navyLt : (rowToggle ? c.rowAlt : c.rowBase));
      doc.rect(M, y, W - M * 2, 6.5, "F");
      rowToggle = !rowToggle;
      let x = M + 2;
      cols.forEach((col, ci) => {
        const isR = ci >= 2, xP = isR ? x + widths[ci] - 2 : x;
        if (ci === 0) setC(c.offWhite);
        else if (valueColor && ci === 3) setC(valueColor);
        else setC(c.slate);
        doc.setFont("helvetica", ci === 0 ? "normal" : (ci >= 4 ? "bold" : "normal"));
        doc.setFontSize(7.2);
        doc.text(String(col ?? "—"), xP, y + 4.5, { align: isR ? "right" : "left" });
        x += widths[ci];
      });
      drawC(c.divider); doc.setLineWidth(0.1); doc.line(M, y + 6.5, M + W - M * 2, y + 6.5);
      y += 6.5;
    };

    const subtotalRow = (label, value, rgb) => {
      fillC(c.navyMid); doc.rect(M, y, W - M * 2, 7.5, "F");
      drawC(rgb); doc.setLineWidth(0.5); doc.line(M, y, M + 4, y); doc.setLineWidth(0.1);
      setC(rgb); doc.setFont("helvetica", "bold"); doc.setFontSize(8);
      doc.text(label.toUpperCase(), M + 7, y + 5.2);
      doc.text(`$${fmt2(value)}`, W - M - 3, y + 5.2, { align: "right" });
      y += 10; rowToggle = false;
    };

    // EARNINGS
    secHeader("Earnings", c.amber);
    const earnW = [62, 22, 26, 28, 24, 26];
    tableHeader(["Pay Description", "Hours", "Rate", "Current Period", "YTD Hours", "YTD Amount"], earnW);
    rowToggle = false;

    if (employee.payType === 'Commission') {
      const rate = parseFloat(employee.commissionPercentage) || 0;
      (payroll.commissions || []).forEach(comm => {
        const earned = (parseFloat(comm.grossAmount) || 0) * rate / 100;
        dataRow([`Commission — ${comm.description || "Load"}  (${rate}%)`, "—", `${rate}%`, `$${fmt2(earned)}`, "—", "—"], earnW, false, c.amberLt);
      });
    } else if (employee.payType === 'Fixed salary') {
      dataRow(["Fixed Salary", "—", "—", `$${fmt2(employee.payAmount)}`, "—", "—"], earnW);
    } else if (earnings.length > 0) {
      earnings.forEach(e => {
        const isOT = e.type === "Overtime";
        dataRow([e.type, e.hours || "—", e.rate ? `$${fmt2(e.rate)}` : "—", `$${fmt2(e.amount)}`, "—", "—"], earnW, isOT, isOT ? c.amberLt : null);
      });
    } else {
      const ex = payroll.extraFields || {};
      const legacyRows = [
        ["Regular",      ex.regularHours,     ex.regularPay],
        ["Overtime",     ex.overtimeHours,    ex.overtimePay],
        ["Holiday",      ex.holidayHours,     ex.holidayPay],
        ["Personal Day", ex.personalDayHours, ex.personalDayPay],
        ["Vacation",     ex.vacationHours,    ex.vacationPay],
        ["Sick Leave",   ex.sickLeaveHours,   ex.sickLeavePay],
        ["FMLA",         ex.fmlaHours,        ex.fmlaPay],
        ["Bonus",        ex.bonusHours,       ex.bonusPay],
      ].filter(([, , pay]) => parseFloat(pay) > 0);
      legacyRows.forEach(([type, hours, pay]) => {
        dataRow([type, hours || "—", "—", `$${fmt2(pay)}`, "—", "—"], earnW);
      });
    }

    subtotalRow("Gross Earnings", gross, c.amber);

    // ALLOWANCES
    if (pdT > 0 || miT > 0) {
      secHeader("Allowances & Reimbursements  (Non-Taxable)", c.blue);
      const allowW = [90, 30, 30, 38, 0, 0];
      tableHeader(["Description", "Units", "Rate", "Amount", "", ""], allowW);
      rowToggle = false;
      if (pdT > 0) dataRow([`Per Diem — ${perDiem.days} day(s) @ $${fmt2(perDiem.ratePerDay)}/day`, `${perDiem.days}d`, `$${fmt2(perDiem.ratePerDay)}`, `$${fmt2(pdT)}`, "", ""], allowW, false, c.blue);
      if (miT > 0) dataRow([`Mileage — ${mileage.miles} mi @ $${mileage.ratePerMile}/mi (IRS)`, `${mileage.miles} mi`, `$${mileage.ratePerMile}`, `$${fmt2(miT)}`, "", ""], allowW, false, c.blue);
      fillC(c.navyMid); doc.rect(M, y, W - M * 2, 7, "F");
      setC(c.blue); doc.setFont("helvetica", "bold"); doc.setFontSize(7.5);
      doc.text("TOTAL NON-TAXABLE REIMBURSEMENTS", M + 7, y + 5);
      doc.text(`$${fmt2(pdT + miT)}`, W - M - 3, y + 5, { align: "right" });
      y += 10; rowToggle = false;
    }

    // ADDITIONS
    if (additions.length > 0) {
      secHeader("Additions & Bonuses", c.green);
      const addW = [110, 35, 43];
      tableHeader(["Description", "Type", "Amount"], addW);
      rowToggle = false;
      additions.forEach(a => dataRow([a.name || "Bonus / Addition", "Addition", `$${fmt2(a.amount)}`], addW, false, c.green));
      fillC(c.navyMid); doc.rect(M, y, W - M * 2, 7, "F");
      setC(c.green); doc.setFont("helvetica", "bold"); doc.setFontSize(7.5);
      doc.text("TOTAL ADDITIONS", M + 7, y + 5);
      doc.text(`$${fmt2(addT)}`, W - M - 3, y + 5, { align: "right" });
      y += 10; rowToggle = false;
    }

    // BENEFITS
    const actBen = benefits.filter(b => parseFloat(b.amount) > 0);
    if (actBen.length > 0) {
      secHeader("Benefit Deductions", c.purple);
      const benW = [90, 30, 30, 38];
      tableHeader(["Benefit Plan", "Tax Treatment", "Effect on Taxable", "Amount Deducted"], benW);
      rowToggle = false;
      actBen.forEach(b => dataRow([b.name, b.preTax ? "Pre-Tax" : "Post-Tax", b.preTax ? "Reduces taxable" : "No effect", `($${fmt2(b.amount)})`], benW, false, c.purple));
      fillC(c.navyMid); doc.rect(M, y, W - M * 2, 7, "F");
      setC(c.purple); doc.setFont("helvetica", "bold"); doc.setFontSize(7.5);
      doc.text(`TOTAL BENEFITS  (Pre-Tax: $${fmt2(preT)}  |  Post-Tax: $${fmt2(postT)})`, M + 7, y + 5);
      doc.text(`($${fmt2(preT + postT)})`, W - M - 3, y + 5, { align: "right" });
      y += 10; rowToggle = false;
    }

    // DEDUCTIONS
    if (deductions.length > 0) {
      secHeader("Other Deductions", c.red);
      const dedW = [110, 35, 43];
      tableHeader(["Description", "Type", "Amount"], dedW);
      rowToggle = false;
      deductions.forEach(d => dataRow([d.name || "Deduction", "Deduction", `($${fmt2(d.amount)})`], dedW, false, c.red));
      fillC(c.navyMid); doc.rect(M, y, W - M * 2, 7, "F");
      setC(c.red); doc.setFont("helvetica", "bold"); doc.setFontSize(7.5);
      doc.text("TOTAL DEDUCTIONS", M + 7, y + 5);
      doc.text(`($${fmt2(dedT)})`, W - M - 3, y + 5, { align: "right" });
      y += 10; rowToggle = false;
    }

    // TAXES
    if (y > H - 80) {
      doc.addPage(); fillC(c.navy); doc.rect(0, 0, W, H, "F");
      fillC(c.navyMid); doc.rect(0, 0, W, 10, "F");
      fillC(c.amber); doc.rect(0, 0, 5, 10, "F");
      setC(c.slate); doc.setFontSize(6.5);
      doc.text(`${employee.firstName} ${employee.lastName}  ·  ${fmtDate(payroll.startDate)} – ${fmtDate(payroll.endDate)}`, 12, 7);
      y = 16;
    }

    secHeader("Federal & State Tax Withholdings", c.red);
    fillC(c.navyLt); doc.rect(M, y, W - M * 2, 7, "F");
    setC(c.amber); doc.setFont("helvetica", "bold"); doc.setFontSize(7.5);
    doc.text("TAXABLE GROSS INCOME  =  Gross Earnings + Additions − Pre-Tax Benefits", M + 4, y + 5);
    doc.text(`$${fmt2(taxable)}`, W - M - 3, y + 5, { align: "right" });
    y += 9; rowToggle = false;

    const taxW = [70, 28, 30, 60];
    tableHeader(["Tax Type", "Rate", "This Period", "YTD (Est.)"], taxW);

    const taxList = [
      { name: "Federal Income Tax",      pct: taxes.federalIncome  },
      { name: "State Income Tax",        pct: taxes.stateIncome    },
      { name: "Social Security (OASDI)", pct: taxes.socialSecurity },
      { name: "Medicare (HI)",           pct: taxes.medicare       },
      { name: "State Unemployment",      pct: taxes.stateSUI       },
      { name: "Local / City Tax",        pct: taxes.localTax       },
      ...otherTaxes.map(ot => ({ name: ot.name, pct: ot.percentage })),
    ].filter(tx => parseFloat(tx.pct) > 0);

    taxList.forEach(tx => {
      const amt = taxable * parseFloat(tx.pct) / 100;
      dataRow([tx.name, `${tx.pct}%`, `($${fmt2(amt)})`, `≈ ($${fmt2(amt * (payrolls.length + 1))})`], taxW, false, c.red);
    });

    subtotalRow("Total Tax Withholdings", taxTotal, c.red);

    // NET PAY SUMMARY BOX
    if (y > H - 65) {
      doc.addPage(); fillC(c.navy); doc.rect(0, 0, W, H, "F");
      fillC(c.navyMid); doc.rect(0, 0, W, 10, "F");
      fillC(c.amber); doc.rect(0, 0, 5, 10, "F");
      setC(c.slate); doc.setFontSize(6.5);
      doc.text(`${employee.firstName} ${employee.lastName}  ·  ${fmtDate(payroll.startDate)} – ${fmtDate(payroll.endDate)}`, 12, 7);
      y = 16;
    }

    y += 4;
    fillC(c.navyMid); doc.roundedRect(M, y, W - M * 2, 52, 2, 2, "F");
    drawC(c.amber); doc.setLineWidth(0.8);
    doc.roundedRect(M, y, W - M * 2, 52, 2, 2, "S");
    fillC(c.amber); doc.roundedRect(M, y, W - M * 2, 6, 2, 2, "F");
    doc.rect(M, y + 3, W - M * 2, 3, "F");
    setC(c.navy); doc.setFont("helvetica", "bold"); doc.setFontSize(8);
    doc.text("EARNINGS & DEDUCTIONS SUMMARY", M + 5, y + 4.5);

    const sumItems = [
      { label: "Gross Earnings",         value: `$${fmt2(gross)}`,       clr: c.white  },
      { label: "Non-Taxable Allowances", value: `+ $${fmt2(pdT + miT)}`, clr: c.blue   },
      { label: "Taxable Additions",      value: `+ $${fmt2(addT)}`,      clr: c.green  },
      { label: "Pre-Tax Benefits",       value: `- $${fmt2(preT)}`,      clr: c.purple },
      { label: "Post-Tax Benefits",      value: `- $${fmt2(postT)}`,     clr: c.purple },
      { label: "Other Deductions",       value: `- $${fmt2(dedT)}`,      clr: c.red    },
      { label: "Federal & State Taxes",  value: `- $${fmt2(taxTotal)}`,  clr: c.red    },
    ];

    sumItems.forEach(({ label, value, clr }, i) => {
      const yy = y + 13 + i * 5.4;
      setC(c.slate); doc.setFont("helvetica", "normal"); doc.setFontSize(6.8); doc.text(label, M + 5, yy);
      setC(clr);     doc.setFont("helvetica", "bold");   doc.setFontSize(7);   doc.text(value, M + 105, yy, { align: "right" });
    });

    drawC(c.divider); doc.setLineWidth(0.3); doc.line(M + 5, y + 50, M + 110, y + 50);

    fillC(c.amber); doc.roundedRect(M + 118, y + 8, W - M * 2 - 118, 36, 2, 2, "F");
    setC(c.navy); doc.setFont("helvetica", "bold");
    doc.setFontSize(8);  doc.text("NET PAY", M + 120, y + 19);
    doc.setFontSize(22); doc.text(`$${fmt2(net)}`, M + 186, y + 35, { align: "right" });
    setC(c.navyMid); doc.setFont("helvetica", "normal"); doc.setFontSize(6);
    doc.text(`Pay Method: ${payroll.paymentMethod || "—"}`, M + 120, y + 41);
    y += 62;

    // Taxable summary strip
    fillC(c.navyMid); doc.roundedRect(M, y, W - M * 2, 14, 1, 1, "F");
    drawC(c.divider); doc.setLineWidth(0.2); doc.roundedRect(M, y, W - M * 2, 14, 1, 1, "S");
    setC(c.slate); doc.setFont("helvetica", "bold"); doc.setFontSize(6.2);
    doc.text("TAXABLE INCOME SUMMARY:", M + 4, y + 5);
    doc.setFont("helvetica", "normal");
    doc.text(
      `Gross: $${fmt2(gross)}  |  Pre-Tax Deductions: ($${fmt2(preT)})  |  Taxable Gross: $${fmt2(taxable)}  |  Total Taxes: ($${fmt2(taxTotal)})  |  Effective Tax Rate: ${gross > 0 ? ((taxTotal / gross) * 100).toFixed(1) : "0.0"}%`,
      M + 4, y + 10
    );
    y += 20;

    // Notes
    if (payroll.notes) {
      if (y > H - 35) {
        doc.addPage(); fillC(c.navy); doc.rect(0, 0, W, H, "F"); y = 16;
      }
      fillC(c.navyMid); doc.roundedRect(M, y, W - M * 2, 20, 1, 1, "F");
      setC(c.amber);    doc.setFont("helvetica", "bold");   doc.setFontSize(6.5);
      doc.text("EMPLOYER NOTES / MESSAGES:", M + 4, y + 6);
      setC(c.offWhite); doc.setFont("helvetica", "normal"); doc.setFontSize(7);
      doc.text(doc.splitTextToSize(payroll.notes, W - M * 2 - 8), M + 4, y + 12);
      y += 24;
    }

    // Footer
    const totalPages = doc.getNumberOfPages();
    for (let pg = 1; pg <= totalPages; pg++) {
      doc.setPage(pg);
      fillC(c.navyMid); doc.rect(0, H - 14, W, 14, "F");
      fillC(c.amber);   doc.rect(0, H - 14, W, 1.5, "F");
      setC(c.muted); doc.setFont("helvetica", "normal"); doc.setFontSize(5.8);
      doc.text(
        useCustomFooter && footer ? footer : "This document is confidential and intended solely for the named employee.",
        M, H - 7
      );
      setC(c.slate); doc.setFont("helvetica", "bold"); doc.setFontSize(6);
      doc.text(`Full Trucking Service  ·  Page ${pg} of ${totalPages}`, W - M, H - 7, { align: "right" });
      setC(c.amber); doc.setFontSize(5.5);
      doc.text(`Issue Date: ${new Date().toLocaleDateString("en-US")}   Check #: ${payroll.checkNumber || "N/A"}`, W - M, H - 3.5, { align: "right" });
    }

    doc.save(`Payroll_${employee.firstName}_${employee.lastName}_${fmtDate(payroll.startDate).replace(/\//g, "-")}.pdf`);
  };

  const handleDownloadPDF      = pay  => buildPDF(pay, selectedEmployee);
  const handleDownloadMultiple = pays => pays.forEach(p => buildPDF(p, selectedEmployee));

  const rootCls = `${styles.payrollManagerSection || styles.payrollEmployeeSection}${isLight ? ' ' + (styles.payrollManagerSectionLight || styles.payrollEmployeeSectionLight) : ''}`;

  // ── PORTAL pentru modal — montat direct pe document.body ─────────────────
  const modalPortal = selectedPayroll
    ? ReactDOM.createPortal(
        <div
          style={{
            position:       "fixed",
            inset:          0,
            background:     "rgba(0,0,0,0.80)",
            backdropFilter: "blur(8px)",
            display:        "flex",
            alignItems:     "center",
            justifyContent: "center",
            zIndex:         99999,
            padding:        "24px 16px",
            overflowY:      "auto",
          }}
          onClick={e => { if (e.target === e.currentTarget) setSelectedPayroll(null); }}
        >
          <div
            className={styles.payrollDetailsContainer}
            style={{
              width:     "100%",
              maxWidth:  700,
              maxHeight: "88vh",
              overflowY: "auto",
              position:  "relative",
              margin:    "auto",
            }}
          >
            {/* Close button */}
            <button
              type="button"
              onClick={() => setSelectedPayroll(null)}
              style={{
                position:       "absolute",
                top:            14,
                right:          14,
                width:          32,
                height:         32,
                borderRadius:   "50%",
                border:         "1px solid rgba(239,68,68,0.3)",
                background:     "rgba(239,68,68,0.08)",
                color:          "#F87171",
                cursor:         "pointer",
                display:        "flex",
                alignItems:     "center",
                justifyContent: "center",
                fontSize:       "1.1rem",
                fontWeight:     700,
                lineHeight:     1,
                zIndex:         1,
              }}
            >
              ×
            </button>

            <h4>Payroll Details</h4>

            {/* Info grid */}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
              {[
                ["Pay Period",    `${fmtDate(selectedPayroll.startDate)} – ${fmtDate(selectedPayroll.endDate)}`],
                ["Check #",       selectedPayroll.checkNumber || "—"],
                ["Method",        selectedPayroll.paymentMethod || "—"],
                ["Business Unit", selectedPayroll.businessUnit || selectedPayroll.extraFields?.businessUnit || "—"],
                ["Gross Pay",    `$${fmt2(selectedPayroll.gross)}`],
                ["Taxable Gross",`$${fmt2(selectedPayroll.taxable)}`],
                ["Total Taxes",  `$${fmt2(selectedPayroll.totalTax)}`],
                ["Net Pay",      `$${fmt2(selectedPayroll.total)}`],
              ].map(([l, v]) => (
                <div key={l} style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:8, padding:"10px 12px" }}>
                  <div style={{ fontSize:"0.58rem", fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, letterSpacing:"0.1em", textTransform:"uppercase", color:"#52526A", marginBottom:4 }}>{l}</div>
                  <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:"0.95rem", fontWeight:700, color:"#EEEEF2" }}>{v}</div>
                </div>
              ))}
            </div>

            {/* Earnings */}
            {selectedPayroll.earnings?.length > 0 && (
              <>
                <h5>Earnings</h5>
                <ul>
                  {selectedPayroll.earnings.map((e, i) => (
                    <li key={i}>{e.type}: {e.hours || "—"} hrs @ ${fmt2(e.rate)} = <strong style={{ color:"#F59E0B" }}>${fmt2(e.amount)}</strong></li>
                  ))}
                </ul>
              </>
            )}

            {/* Allowances */}
            {(parseFloat(selectedPayroll.perDiem?.total) > 0 || parseFloat(selectedPayroll.mileageReimbursement?.total) > 0) && (
              <>
                <h5>Allowances (Non-Taxable)</h5>
                <ul>
                  {parseFloat(selectedPayroll.perDiem?.total) > 0 && (
                    <li>Per Diem: {selectedPayroll.perDiem.days} days × ${fmt2(selectedPayroll.perDiem.ratePerDay)} = <strong style={{ color:"#60A5FA" }}>${fmt2(selectedPayroll.perDiem.total)}</strong></li>
                  )}
                  {parseFloat(selectedPayroll.mileageReimbursement?.total) > 0 && (
                    <li>Mileage: {selectedPayroll.mileageReimbursement.miles} mi × ${selectedPayroll.mileageReimbursement.ratePerMile} = <strong style={{ color:"#60A5FA" }}>${fmt2(selectedPayroll.mileageReimbursement.total)}</strong></li>
                  )}
                </ul>
              </>
            )}

            {/* Additions */}
            {selectedPayroll.additions?.length > 0 && (
              <>
                <h5>Additions</h5>
                <ul>
                  {selectedPayroll.additions.map((a, i) => (
                    <li key={i}>{a.name}: <strong style={{ color:"#34D399" }}>${fmt2(a.amount)}</strong></li>
                  ))}
                </ul>
              </>
            )}

            {/* Benefits */}
            {selectedPayroll.benefits?.filter(b => parseFloat(b.amount) > 0).length > 0 && (
              <>
                <h5>Benefits</h5>
                <ul>
                  {selectedPayroll.benefits.filter(b => parseFloat(b.amount) > 0).map((b, i) => (
                    <li key={i}>{b.name} ({b.preTax ? "Pre-Tax" : "Post-Tax"}): <strong style={{ color:"#A78BFA" }}>${fmt2(b.amount)}</strong></li>
                  ))}
                </ul>
              </>
            )}

            {/* Deductions */}
            {selectedPayroll.deductions?.length > 0 && (
              <>
                <h5>Deductions</h5>
                <ul>
                  {selectedPayroll.deductions.map((d, i) => (
                    <li key={i}>{d.name}: <strong style={{ color:"#F87171" }}>${fmt2(d.amount)}</strong></li>
                  ))}
                </ul>
              </>
            )}

            {/* Taxes */}
            <h5>Tax Withholdings</h5>
            <ul>
              {[
                { name: "Federal Income Tax", pct: selectedPayroll.taxes?.federalIncome  },
                { name: "State Income Tax",   pct: selectedPayroll.taxes?.stateIncome    },
                { name: "Social Security",    pct: selectedPayroll.taxes?.socialSecurity },
                { name: "Medicare",           pct: selectedPayroll.taxes?.medicare       },
                { name: "State SUI/SDI",      pct: selectedPayroll.taxes?.stateSUI       },
                { name: "Local Tax",          pct: selectedPayroll.taxes?.localTax       },
                ...(selectedPayroll.taxes?.otherTaxes || []).map(t => ({ name: t.name, pct: t.percentage })),
              ].filter(tx => parseFloat(tx.pct) > 0).map((tx, i) => {
                const amt = parseFloat(selectedPayroll.taxable || 0) * parseFloat(tx.pct) / 100;
                return (
                  <li key={i}>{tx.name} ({tx.pct}%): <strong style={{ color:"#F87171" }}>${fmt2(amt)}</strong></li>
                );
              })}
            </ul>

            {/* Notes */}
            {selectedPayroll.notes && (
              <>
                <h5>Notes</h5>
                <p>{selectedPayroll.notes}</p>
              </>
            )}

            <button type="button" onClick={() => handleDownloadPDF(selectedPayroll)}>
              Download PDF
            </button>
          </div>
        </div>,
        document.body   // ← montat direct pe body, scapă de orice stacking context
      )
    : null;

  // ── RENDER ────────────────────────────────────────────────────────────────
  return (
    <>
      <div className={rootCls}>
        <h3>Payroll Manager</h3>

        {/* Employee select */}
        <select
          className={styles.employeeSelect}
          value={selectedEmployee?._id || ''}
          onChange={e => {
            const emp = employees.find(emp => emp._id === e.target.value);
            setSelectedEmployee(emp || null);
            setPayrolls([]);
            setSelectedPayrolls([]);
            setSelectedPayroll(null);
          }}
        >
          <option value="">Select Employee</option>
          {employees.map(emp => (
            <option key={emp._id} value={emp._id}>
              {emp.firstName} {emp.lastName}
            </option>
          ))}
        </select>

        {/* Date filter */}
        {selectedEmployee && (
          <div className={styles.dateInputsRow}>
            <input
              type="date"
              value={startDate}
              onChange={e => setStartDate(e.target.value)}
            />
            <input
              type="date"
              value={endDate}
              onChange={e => setEndDate(e.target.value)}
            />
            <button type="button" onClick={fetchPayrolls} className={styles.searchButton}>
              Search Payrolls
            </button>
            {selectedPayrolls.length > 1 && (
              <button
                type="button"
                onClick={() => handleDownloadMultiple(selectedPayrolls)}
                className={styles.downloadPDFButton}
              >
                Download {selectedPayrolls.length} PDFs
              </button>
            )}
          </div>
        )}

        {/* Payroll table */}
        {payrolls.length > 0 && (
          <div style={{ overflowX:"auto", marginBottom:20 }}>
            <table className={styles.payrollTable}>
              <thead>
                <tr className={styles.tableHeader}>
                  {["", "Pay Period", "Gross", "Taxes", "Net Pay", "Method", "Actions"].map(h => (
                    <th key={h}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className={styles.tableBody}>
                {payrolls.map((pay, idx) => (
                  <tr
                    key={idx}
                    style={{ background: selectedPayrolls.includes(pay) ? "rgba(245,158,11,0.06)" : "transparent" }}
                  >
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedPayrolls.includes(pay)}
                        onChange={() => toggleSelection(pay)}
                      />
                    </td>
                    <td style={{ color:"#EEEEF2" }}>
                      {fmtDate(pay.startDate)} – {fmtDate(pay.endDate)}
                    </td>
                    <td style={{ color:"#F59E0B", fontWeight:600, fontFamily:"'Barlow Condensed',sans-serif" }}>
                      ${fmt2(pay.gross)}
                    </td>
                    <td style={{ color:"#F87171", fontFamily:"'Barlow Condensed',sans-serif" }}>
                      ${fmt2(pay.totalTax)}
                    </td>
                    <td style={{ color:"#34D399", fontWeight:700, fontFamily:"'Barlow Condensed',sans-serif" }}>
                      ${fmt2(pay.total)}
                    </td>
                    <td style={{ color:"#9494A8" }}>
                      {pay.paymentMethod || "—"}
                    </td>
                    <td style={{ display:"flex", gap:8 }}>
                      <button type="button" onClick={() => setSelectedPayroll(pay)} className={styles.seeMoreButton}>
                        Details
                      </button>
                      <button type="button" onClick={() => handleDownloadPDF(pay)} className={styles.downloadPDFButton}>
                        PDF
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {payrolls.length === 0 && selectedEmployee && (
          <p style={{ textAlign:"center", color:"#52526A", fontStyle:"italic", padding:"30px 0" }}>
            No payrolls found. Select a date range and click Search.
          </p>
        )}
        
      </div>

      {/* Modalul — în afara div-ului cu position:relative, montat pe body */}
      {modalPortal}
      <EmailPanel />
    </>
  );
};



const FuelReport = ({ drivers, trucks }) => {
  const { notify } = useNotification();
  const [filterDriver, setFilterDriver] = useState('');
const [filterTruck, setFilterTruck] = useState('');
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);
const [csvFile, setCsvFile] = useState(null);
const [importLoading, setImportLoading] = useState(false);
const [importResult, setImportResult] = useState(null);
const [previewRows, setPreviewRows] = useState([]);
const [showPreview, setShowPreview] = useState(false);
const [fuelResponsibilityFilter, setFuelResponsibilityFilter] = useState('');
const [aiText, setAiText] = useState("");
const [aiLoading, setAiLoading] = useState(false);

const [fuelData, setFuelData] = useState({
  driverId: '',
  truckId: '',
  transactionDate: '',
  merchant: '',
  state: '',
  cardNumber: '',
  cardName: '',
  paymentId: '',
  invoiceNumber: '',
  location: '',

  fuelQuantity: 0,
  fuelPPG: 0,
  fuelAmount: 0,

  defQuantity: 0,
  defAmount: 0,

  reeferQuantity: 0,
  reeferPPG: 0,
  reeferAmount: 0,

  additives: 0,
  oil: 0,
  otherFees: 0,

  discount: 0,
  totalToPay: 0
});

  const [fuelReports, setFuelReports] = useState([]);
  const [selectedReports, setSelectedReports] = useState([]);
  const [isEditing, setIsEditing] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteTarget, setDeleteTarget] = useState(null);
const driverByTruckNumber = useMemo(() => {
  const map = {};
  drivers.forEach(d => {
    if (d.truckNumber) {
      map[d.truckNumber] = d;
    }
  });
  return map;
}, [drivers]);

const truckByTruckNumber = useMemo(() => {
  const map = {};
  trucks.forEach(t => {
    if (t.truckNumber) {
      map[t.truckNumber] = t;
    }
  });
  return map;
}, [trucks]);


  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const token = sessionStorage.getItem('token');

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  useEffect(() => {
    fetchFuelReports();
  }, []);

  useEffect(() => {
  if (showPreview) document.body.classList.add('csvModalOpen');
  else document.body.classList.remove('csvModalOpen');
  return () => document.body.classList.remove('csvModalOpen');
}, [showPreview]);
  
  const handleAIParse = async () => {
  if (!aiText) {
    notify("Paste receipt text first", "error");
    return;
  }

  try {
    setAiLoading(true);

    const res = await axios.post(
      `${apiUrl}/fuel-reports/ai-parse`,
      { rawText: aiText },
      config
    );

    setFuelData((prev) => ({
      ...prev,
      ...res.data,
    }));

    notify("Fuel data extracted by AI", "success");
  } catch (err) {
    notify("AI parsing failed", "error");
  } finally {
    setAiLoading(false);
  }
};

const handleCSVImport = async () => {
  if (!csvFile) {
    notify("Please select a CSV file", "error");
    return;
  }

  try {
    setImportLoading(true);

    const text = await csvFile.text();

    const startRes = await axios.post(
      `${apiUrl}/fuel-reports/ai-parse-full-csv`,
      { csvText: text },
      config
    );

    const jobId = startRes.data.jobId;

    pollJobStatus(jobId);

  } catch (err) {
    notify("Failed to start CSV import", "error");
    setImportLoading(false);
  }
};

const pollJobStatus = (jobId) => {

  const interval = setInterval(async () => {
    try {
      const res = await axios.get(
        `${apiUrl}/fuel-reports/job-status/${jobId}`,
        config
      );

      if (res.data.status === "processing") {
        console.log("Progress:", res.data.progress);
      }

      if (res.data.status === "done") {
        clearInterval(interval);

        setPreviewRows(res.data.result);
        setShowPreview(true);
        setImportLoading(false);
      }

      if (res.data.status === "failed") {
        clearInterval(interval);
        notify("CSV import failed", "error");
        setImportLoading(false);
      }

    } catch (err) {
      clearInterval(interval);
      setImportLoading(false);
    }
  }, 2000);
};

const confirmCSVImport = async () => {
  try {
    const res = await axios.post(
      `${apiUrl}/fuel-reports/import-csv/confirm`,
      { rows: previewRows },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    // ✅ FULL SUCCESS
    if (res.status === 200 || res.status === 201) {
      notify(
        `CSV imported successfully. Imported: ${res.data.imported}`,
        "success"
      );
    }

    setShowPreview(false);
    setPreviewRows([]);
    setCsvFile(null);
    fetchFuelReports();

  } catch (err) {
    const status = err.response?.status;
    const data = err.response?.data;

    // 🔴 TOATE RÂNDURILE SUNT DUPLICATE
    if (status === 409) {
      notify(
        "CSV import failed. All rows already exist (duplicate Payment IDs).",
        "error"
      );
    }

    // 🟡 IMPORT PARȚIAL (UNELE DUPLICATE)
    else if (status === 207) {
      notify(
        `CSV partially imported. Imported: ${data.imported}, Skipped: ${data.failed}`,
        "warning"
      );

      setShowPreview(false);
      setPreviewRows([]);
      setCsvFile(null);
      fetchFuelReports();
    }

    // ❌ EROARE REALĂ
    else {
      notify("CSV import failed due to server error.", "error");
      console.error("CSV IMPORT ERROR:", err);
    }
  }
};


  const fetchFuelReports = async () => {
    try {
      const response = await axios.get(`${apiUrl}/fuel-reports`, config);
      setFuelReports(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
     
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFuelData((prev) => ({
        ...prev,
        [name]: value,
        grandTotal:
            name === 'fuelSubtotal' || name === 'otherCosts'
                ? parseFloat(prev.fuelSubtotal || 0) + parseFloat(prev.otherCosts || 0)
                : prev.grandTotal,
    }));
};

useEffect(() => {
  const fuelAmount = fuelData.fuelQuantity * fuelData.fuelPPG;
  const reeferAmount = fuelData.reeferQuantity * fuelData.reeferPPG;

  const total =
    fuelAmount +
    reeferAmount +
    Number(fuelData.defAmount || 0) +
    Number(fuelData.additives || 0) +
    Number(fuelData.oil || 0) +
    Number(fuelData.otherFees || 0) -
    Number(fuelData.discount || 0);

  setFuelData(prev => ({
    ...prev,
    fuelAmount,
    reeferAmount,
    totalToPay: Number(total.toFixed(2))
  }));
}, [
  fuelData.fuelQuantity,
  fuelData.fuelPPG,
  fuelData.reeferQuantity,
  fuelData.reeferPPG,
  fuelData.defAmount,
  fuelData.additives,
  fuelData.oil,
  fuelData.otherFees,
  fuelData.discount
]);


  const addFuelEntry = async () => {
    try {
        const entry = {
            ...fuelData,
            grandTotal: parseFloat(fuelData.fuelSubtotal || 0) + parseFloat(fuelData.otherCosts || 0),
        };

        const response = await axios.post(`${apiUrl}/fuel-reports`, entry, config);
        if (response.status === 201 && response.data?.data) {
            notify('Fuel entry added successfully' , 'success');
            setFuelReports((prev) => [...prev, response.data.data]);
            setFuelData({
  driverId: '',
  truckId: '',
  transactionDate: '',
  merchant: '',
  state: '',
  cardNumber: '',
  cardName: '',
  paymentId: '',
  invoiceNumber: '',
  location: '',
  fuelQuantity: 0,
  fuelPPG: 0,
  fuelAmount: 0,
  defQuantity: 0,
  defAmount: 0,
  reeferQuantity: 0,
  reeferPPG: 0,
  reeferAmount: 0,
  additives: 0,
  oil: 0,
  otherFees: 0,
  discount: 0,
  totalToPay: 0
});
        } else {
          notify('Failed to add fuel entry.' , 'error');
        }
    } catch (error) {
  if (error.response?.status === 409) {
    notify(
      "This Payment ID already exists for this client. Entry was not added.",
      "error"
    );
  } else {
    notify("Failed to add fuel entry.", "error");
  }
}

};


  const editFuelEntry = async () => {
    try {
      const response = await axios.put(`${apiUrl}/fuel-reports/${isEditing}`, fuelData, config);
      if (response.status === 200) {
        notify('Fuel entry updated successfully', 'success');
        setFuelReports((prev) =>
          prev.map((entry) => (entry._id === isEditing ? response.data.data : entry))
        );
        setIsEditing(null); // Resetează modul de editare
        setFuelData({
          driverId: '',
          truckId: '',
          paymentMethod: '',
          location: '',
          fuelSubtotal: 0,
          otherCosts: 0,
          grandTotal: 0,
        });
      }
    } catch (error) {
   
     notify('Failed to edit fuel entry.' , 'error');
    }
  };

  const handlePreviewChange = (index, field, value) => {
  setPreviewRows(prev => {
    const updated = [...prev];
    updated[index] = {
      ...updated[index],
      [field]: value
    };

    // recalcul automat total
    const fuelAmount =
      Number(updated[index].fuelQuantity || 0) *
      Number(updated[index].fuelPPG || 0);

    const total =
      fuelAmount +
      Number(updated[index].defAmount || 0) +
      Number(updated[index].reeferAmount || 0) +
      Number(updated[index].additives || 0) +
      Number(updated[index].oil || 0) +
      Number(updated[index].otherFees || 0) -
      Number(updated[index].discount || 0);

    updated[index].fuelAmount = fuelAmount;
    updated[index].totalToPay = Number(total.toFixed(2));

    return updated;
  });
};
  
  const handleEditClick = (entry) => {
    setIsEditing(entry._id); // Setează ID-ul raportului pentru editare
    setFuelData({
      driverId: entry.driverId?._id || '', // ID-ul șoferului
      truckId: entry.truckId?._id || '', // ID-ul camionului
      paymentMethod: entry.paymentMethod || '',
      location: entry.location || '',
      fuelSubtotal: entry.fuelSubtotal || 0,
      otherCosts: entry.otherCosts || 0,
      grandTotal: entry.grandTotal || 0,
      
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  

  const confirmDeleteFuelEntry = async (id) => {
    try {
      await axios.delete(`${apiUrl}/fuel-reports/${id}`, config);
      setFuelReports((prev) => prev.filter((entry) => entry._id !== id));
    } catch (error) {

     notify('Failed to delete fuel entry.' , 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  
  const handleExport = () => {
  const selectedData = fuelReports
    .filter((report) => selectedReports.includes(report._id))
    .map((entry) => {
      const driver = entry.driverId;
      const truck = entry.truckId;

      return {
        "Driver Name": driver
          ? `${driver.firstName} ${driver.lastName}`
          : "",

        "Truck Number": truck?.truckNumber || "",

        "Transaction Date": entry.transactionDate
          ? new Date(entry.transactionDate).toLocaleString()
          : "",

        "Merchant": entry.merchant || "",
        "State": entry.state || "",
        "Location": entry.location || "",

        "Invoice Number": entry.invoiceNumber || "",
        "Card Number": entry.cardNumber || "",
        "Card Name": entry.cardName || "",
        "Payment ID": entry.paymentId || "",

        "Fuel Quantity": Number(entry.fuelQuantity || 0),
        "Fuel PPG": Number(entry.fuelPPG || 0),
        "Fuel Amount": Number(entry.fuelAmount || 0),

        "DEF Quantity": Number(entry.defQuantity || 0),
        "DEF Amount": Number(entry.defAmount || 0),

        "Reefer Quantity": Number(entry.reeferQuantity || 0),
        "Reefer PPG": Number(entry.reeferPPG || 0),
        "Reefer Amount": Number(entry.reeferAmount || 0),

        "Additives": Number(entry.additives || 0),
        "Oil": Number(entry.oil || 0),
        "Other Fees": Number(entry.otherFees || 0),
        "Discount": Number(entry.discount || 0),

        "Total To Pay": Number(entry.totalToPay || 0),

        "Fuel Responsibility":
          entry.fuelResponsibility === "owner"
            ? "Owner Paid"
            : "Company Expense",

        "Fuel Payment Status": entry.fuelPaymentStatus || "open",

        "Created At": entry.createdAt
          ? new Date(entry.createdAt).toLocaleString()
          : ""
      };
    });

  if (selectedData.length === 0) {
    notify("No reports selected for export!", "error");
    return;
  }

  // Total calculation
  const totalAmount = selectedData.reduce(
    (sum, r) => sum + Number(r["Total To Pay"] || 0),
    0
  );

  selectedData.push({
    "Driver Name": "",
    "Truck Number": "",
    "Transaction Date": "",
    "Merchant": "",
    "State": "",
    "Location": "",
    "Invoice Number": "",
    "Card Number": "",
    "Card Name": "",
    "Payment ID": "",
    "Fuel Quantity": "",
    "Fuel PPG": "",
    "Fuel Amount": "",
    "DEF Quantity": "",
    "DEF Amount": "",
    "Reefer Quantity": "",
    "Reefer PPG": "",
    "Reefer Amount": "",
    "Additives": "",
    "Oil": "",
    "Other Fees": "",
    "Discount": "",
    "Total To Pay": totalAmount,
    "Fuel Responsibility": "",
    "Fuel Payment Status": "",
    "Created At": "TOTAL"
  });

  const worksheet = XLSX.utils.json_to_sheet(selectedData, {
    header: [
      "Driver Name",
      "Truck Number",
      "Transaction Date",
      "Merchant",
      "State",
      "Location",
      "Invoice Number",
      "Card Number",
      "Card Name",
      "Payment ID",
      "Fuel Quantity",
      "Fuel PPG",
      "Fuel Amount",
      "DEF Quantity",
      "DEF Amount",
      "Reefer Quantity",
      "Reefer PPG",
      "Reefer Amount",
      "Additives",
      "Oil",
      "Other Fees",
      "Discount",
      "Total To Pay",
      "Fuel Responsibility",
      "Fuel Payment Status",
      "Created At"
    ]
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Fuel Report");

  XLSX.writeFile(workbook, "Fuel_Report_Full_Export.xlsx");
};

  
  

  const handleSelect = (id) => {
    setSelectedReports((prev) =>
      prev.includes(id) ? prev.filter((reportId) => reportId !== id) : [...prev, id]
    );
  };

 const selectAll = () => {
  const filteredIds = filteredReports.map((r) => r._id);

  if (filteredIds.every((id) => selectedReports.includes(id))) {
    // dacă TOATE cele filtrate sunt deja selectate → deselectăm DOAR filtratele
    setSelectedReports((prev) =>
      prev.filter((id) => !filteredIds.includes(id))
    );
  } else {
    // selectăm toate rândurile filtrate
    setSelectedReports((prev) => [
      ...new Set([...prev, ...filteredIds])
    ]);
  }
};

const filteredReports = fuelReports.filter((report) => {
  const driver = drivers.find((d) => String(d._id) === String(report.driverId?._id || report.driverId));
  const truck = trucks.find((t) => String(t._id) === String(report.truckId?._id || report.truckId));

  const matchesSearch =
    (driver ? `${driver.firstName} ${driver.lastName}`.toLowerCase() : '').includes(searchTerm.toLowerCase()) ||
    (truck ? truck.truckNumber.toString() : '').includes(searchTerm.toLowerCase()) ||
    report.location.toLowerCase().includes(searchTerm.toLowerCase());

  const matchesDriverFilter = filterDriver ? String(report.driverId?._id || report.driverId) === filterDriver : true;
  const matchesTruckFilter = filterTruck ? String(report.truckId?._id || report.truckId) === filterTruck : true;
const matchesFuelResponsibility =
  fuelResponsibilityFilter
    ? report.fuelResponsibility === fuelResponsibilityFilter
    : true;

  return (
  matchesSearch &&
  matchesDriverFilter &&
  matchesTruckFilter &&
  matchesFuelResponsibility
);

});


  const currentReports = filteredReports.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div
      className={`${styles.fuelReportContainer} ${
        theme === "light" ? styles.fuelReportContainerLight : ""
      }`}
    >

      {/* ═══════════════════════════════════════════════════════
          MODAL CSV PREVIEW
          OBLIGATORIU: direct în fuelReportContainer, NU în csvImportBox
          Motivul: csvImportBox are backdrop-filter:blur care rupe position:fixed
      ════════════════════════════════════════════════════════ */}
      {showPreview && (
        <div className={styles.csvPreviewModalfuelReport}>

          <div className={styles.modalHeaderCSV}>
            <h3>
              CSV Import Preview
              <span className={styles.rowCountBadge}>{previewRows.length} rows</span>
            </h3>
           
          </div>

          <div className={styles.modalStatsBarCSV}>
            <span className={styles.statItemCSV}>
              Rows: <strong>{previewRows.length}</strong>
            </span>
            <span className={styles.statItemCSV}>
              Total Fuel $:{" "}
              <strong>
                ${previewRows.reduce((s, r) => s + Number(r.fuelAmount || 0), 0).toFixed(2)}
              </strong>
            </span>
            <span className={styles.statItemCSV}>
              Total To Pay:{" "}
              <strong>
                ${previewRows.reduce((s, r) => s + Number(r.totalToPay || 0), 0).toFixed(2)}
              </strong>
            </span>
          </div>
 <div className={styles.modalActionsCSV}>
              <button className={styles.confirmImportBtn} onClick={confirmCSVImport}>
                Confirm Import
              </button>
              <button className={styles.cancelImportBtn} onClick={() => setShowPreview(false)}>
                Cancel
              </button>
            </div>
          <div className={styles.tableWrapperCSV}>
            <table className={styles.previewTablefuelReport}>
              <thead>
                <tr>
                  <th className={styles.rowIndexCSV}>#</th>
                  <th>Driver</th>
                  <th>Truck</th>
                  <th>Date</th>
                  <th>Invoice</th>
                  <th>Card</th>
                  <th>Card Name</th>
                  <th>Payment ID</th>
                  <th>Merchant</th>
                  <th>State</th>
                  <th>Fuel Qty</th>
                  <th>PPG</th>
                  <th>Fuel $</th>
                  <th>DEF Qty</th>
                  <th>DEF $</th>
                  <th>Reefer Qty</th>
                  <th>Reefer PPG</th>
                  <th>Reefer $</th>
                  <th>Additives</th>
                  <th>Oil</th>
                  <th>Other Fees</th>
                  <th>Discount</th>
                  <th>Total $</th>
                  <th>Responsibility</th>
                </tr>
              </thead>

              <tbody>
                {previewRows.map((r, i) => {
                  const dateValue = r.transactionDate
                    ? new Date(r.transactionDate).toISOString().slice(0, 16)
                    : "";
                  const hasWarning = !r.driverName || !r.truckNumber;

                  return (
                    <tr key={i} className={hasWarning ? styles.rowWarningCSV : ""}>
                      <td className={styles.rowIndexCSV}>{i + 1}</td>

                      <td>
                        <input
                          value={r.driverName || ""}
                          onChange={(e) => handlePreviewChange(i, "driverName", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          value={r.truckNumber || ""}
                          onChange={(e) => handlePreviewChange(i, "truckNumber", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          type="datetime-local"
                          value={dateValue}
                          onChange={(e) => handlePreviewChange(i, "transactionDate", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          value={r.invoiceNumber || ""}
                          onChange={(e) => handlePreviewChange(i, "invoiceNumber", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          value={r.cardNumber || ""}
                          onChange={(e) => handlePreviewChange(i, "cardNumber", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          value={r.cardName || ""}
                          onChange={(e) => handlePreviewChange(i, "cardName", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          value={r.paymentId || ""}
                          onChange={(e) => handlePreviewChange(i, "paymentId", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          value={r.merchant || ""}
                          onChange={(e) => handlePreviewChange(i, "merchant", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          value={r.state || ""}
                          onChange={(e) => handlePreviewChange(i, "state", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          type="number"
                          value={r.fuelQuantity || 0}
                          onChange={(e) => handlePreviewChange(i, "fuelQuantity", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          type="number"
                          value={r.fuelPPG || 0}
                          onChange={(e) => handlePreviewChange(i, "fuelPPG", e.target.value)}
                        />
                      </td>

                      <td className={styles.readOnlyCSV}>
                        ${Number(r.fuelAmount || 0).toFixed(2)}
                      </td>

                      <td>
                        <input
                          type="number"
                          value={r.defQuantity || 0}
                          onChange={(e) => handlePreviewChange(i, "defQuantity", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          type="number"
                          value={r.defAmount || 0}
                          onChange={(e) => handlePreviewChange(i, "defAmount", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          type="number"
                          value={r.reeferQuantity || 0}
                          onChange={(e) => handlePreviewChange(i, "reeferQuantity", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          type="number"
                          value={r.reeferPPG || 0}
                          onChange={(e) => handlePreviewChange(i, "reeferPPG", e.target.value)}
                        />
                      </td>

                      <td className={styles.readOnlyCSV}>
                        ${Number(r.reeferAmount || 0).toFixed(2)}
                      </td>

                      <td>
                        <input
                          type="number"
                          value={r.additives || 0}
                          onChange={(e) => handlePreviewChange(i, "additives", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          type="number"
                          value={r.oil || 0}
                          onChange={(e) => handlePreviewChange(i, "oil", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          type="number"
                          value={r.otherFees || 0}
                          onChange={(e) => handlePreviewChange(i, "otherFees", e.target.value)}
                        />
                      </td>

                      <td>
                        <input
                          type="number"
                          value={r.discount || 0}
                          onChange={(e) => handlePreviewChange(i, "discount", e.target.value)}
                        />
                      </td>

                      <td className={styles.readOnlyCSV}>
                        ${Number(r.totalToPay || 0).toFixed(2)}
                      </td>

                      <td>
                        <select
                          value={r.fuelResponsibility ?? "company"}
                          onChange={(e) => handlePreviewChange(i, "fuelResponsibility", e.target.value)}
                        >
                          <option value="company">Company</option>
                          <option value="owner">Owner</option>
                        </select>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

        </div>
      )}
      {/* ═══════════════════════════════════════════════════════
          END MODAL
      ════════════════════════════════════════════════════════ */}

      <h2 className={styles.titlefuelReport}>Fuel Report</h2>

      {/* ── CSV Import Box — fără modal înăuntru ── */}
      <div className={styles.csvImportBoxfuelReport}>
        <h3>Import Fuel CSV</h3>

        <input
          type="file"
          accept=".csv"
          onChange={(e) => setCsvFile(e.target.files[0])}
        />

        <button
          onClick={handleCSVImport}
          disabled={importLoading}
          className={styles.submitButtonfuelReport}
        >
          {importLoading ? "Importing..." : "Import CSV"}
        </button>

        {importResult && (
          <div style={{ marginTop: "10px", fontSize: "14px" }}>
            <div>✅ Imported: {importResult.imported}</div>
            <div>❌ Failed: {importResult.failed}</div>
          </div>
        )}
      </div>

      {/* ── Form ── */}
      <div className={styles.formContainerfuelReport}>

        <label>Driver</label>
        <select
          value={fuelData.driverId}
          onChange={(e) => {
            const driverId = e.target.value;
            const driver = drivers.find(d => d._id === driverId);
            let truckId = '';
            if (driver?.truckNumber) {
              const truck = truckByTruckNumber[driver.truckNumber];
              truckId = truck?._id || '';
            }
            setFuelData(prev => ({ ...prev, driverId, truckId }));
          }}
          className={styles.customSelectFuelReport}
        >
          <option value="">Select Driver</option>
          {drivers.map(d => (
            <option key={d._id} value={d._id}>
              {d.firstName} {d.lastName}
            </option>
          ))}
        </select>

        <label>Truck (Unit)</label>
        <select
          value={fuelData.truckId}
          onChange={(e) => {
            const truckId = e.target.value;
            const truck = trucks.find(t => t._id === truckId);
            let driverId = '';
            if (truck?.truckNumber) {
              const driver = driverByTruckNumber[truck.truckNumber];
              driverId = driver?._id || '';
            }
            setFuelData(prev => ({ ...prev, truckId, driverId }));
          }}
          className={styles.customSelectFuelReport}
        >
          <option value="">Select Truck</option>
          {trucks.map(t => (
            <option key={t._id} value={t._id}>
              {t.truckNumber}
            </option>
          ))}
        </select>

        <label>Transaction Date & Time</label>
        <input
          type="datetime-local"
          name="transactionDate"
          value={fuelData.transactionDate}
          onChange={handleInputChange}
        />

        <label>Merchant</label>
        <input
          type="text"
          name="merchant"
          placeholder="Love's"
          value={fuelData.merchant}
          onChange={handleInputChange}
        />

        <label>State</label>
        <input
          type="text"
          name="state"
          placeholder="KY"
          value={fuelData.state}
          onChange={handleInputChange}
        />

        <label>Location</label>
        <input
          type="text"
          name="location"
          placeholder="Loves, Shepherdsville, KY"
          value={fuelData.location}
          onChange={handleInputChange}
        />

        <label>Invoice Number</label>
        <input
          type="text"
          name="invoiceNumber"
          value={fuelData.invoiceNumber}
          onChange={handleInputChange}
        />

        <label>Card Number</label>
        <input
          type="text"
          name="cardNumber"
          placeholder="*19765"
          value={fuelData.cardNumber}
          onChange={handleInputChange}
        />

        <label>Card Group</label>
        <input
          type="text"
          name="cardName"
          placeholder="COMDATA / EFS / WEX"
          value={fuelData.cardName}
          onChange={handleInputChange}
        />

        <label>Payment ID</label>
        <input
          type="text"
          name="paymentId"
          placeholder="Transaction / Auth ID"
          value={fuelData.paymentId}
          onChange={handleInputChange}
        />

        <label>Fuel Quantity (Gallons)</label>
        <input
          type="number"
          step="0.001"
          name="fuelQuantity"
          value={fuelData.fuelQuantity}
          onChange={handleInputChange}
        />

        <label>Fuel Price per Gallon (PPG)</label>
        <input
          type="number"
          step="0.001"
          name="fuelPPG"
          value={fuelData.fuelPPG}
          onChange={handleInputChange}
        />

        <label>Fuel Amount ($)</label>
        <input type="number" value={fuelData.fuelAmount} readOnly />

        <label>DEF Quantity</label>
        <input
          type="number"
          step="0.001"
          name="defQuantity"
          value={fuelData.defQuantity}
          onChange={handleInputChange}
        />

        <label>DEF Amount ($)</label>
        <input
          type="number"
          step="0.01"
          name="defAmount"
          value={fuelData.defAmount}
          onChange={handleInputChange}
        />

        <label>Reefer Quantity</label>
        <input
          type="number"
          step="0.001"
          name="reeferQuantity"
          value={fuelData.reeferQuantity}
          onChange={handleInputChange}
        />

        <label>Reefer PPG</label>
        <input
          type="number"
          step="0.001"
          name="reeferPPG"
          value={fuelData.reeferPPG}
          onChange={handleInputChange}
        />

        <label>Reefer Amount ($)</label>
        <input type="number" value={fuelData.reeferAmount} readOnly />

        <label>Additives</label>
        <input
          type="number"
          step="0.01"
          name="additives"
          value={fuelData.additives}
          onChange={handleInputChange}
        />

        <label>Oil</label>
        <input
          type="number"
          step="0.01"
          name="oil"
          value={fuelData.oil}
          onChange={handleInputChange}
        />

        <label>Other Fees</label>
        <input
          type="number"
          step="0.01"
          name="otherFees"
          value={fuelData.otherFees}
          onChange={handleInputChange}
        />

        <label>Discount</label>
        <input
          type="number"
          step="0.01"
          name="discount"
          value={fuelData.discount}
          onChange={handleInputChange}
        />

        <label>Total To Pay ($)</label>
        <input type="number" value={fuelData.totalToPay} readOnly />

        <button
          onClick={isEditing ? editFuelEntry : addFuelEntry}
          className={styles.submitButtonfuelReport}
        >
          {isEditing ? 'Update Fuel Entry' : 'Add Fuel Entry'}
        </button>

        {isEditing && (
          <button
            onClick={() => setIsEditing(null)}
            className={styles.cancelButtonfuelReport}
          >
            Cancel
          </button>
        )}
      </div>

      {/* ── Action Bar ── */}
      <div className={styles.buttonGroupfuelReport}>
        <button onClick={handleExport} className={styles.exportButtonfuelReport}>
          Export to Excel
        </button>
        <button onClick={selectAll} className={styles.selectAllButtonfuelReport}>
          Select All
        </button>

        <div style={{ display: "flex", gap: "10px" }}>
          <select
            value={filterDriver}
            onChange={(e) => setFilterDriver(e.target.value)}
            className={styles.customSelectFuelReport}
          >
            <option value="">Filter by Driver</option>
            {drivers.map(d => (
              <option key={d._id} value={d._id}>
                {d.firstName} {d.lastName}
              </option>
            ))}
          </select>

          <select
            value={filterTruck}
            onChange={(e) => setFilterTruck(e.target.value)}
            className={styles.customSelectFuelReport}
          >
            <option value="">Filter by Truck</option>
            {trucks.map(t => (
              <option key={t._id} value={t._id}>
                {t.truckNumber}
              </option>
            ))}
          </select>
        </div>

        <select
          value={fuelResponsibilityFilter}
          onChange={(e) => setFuelResponsibilityFilter(e.target.value)}
          className={styles.customSelectFuelReport}
        >
          <option value="">All Fuel</option>
          <option value="company">Company Fuel</option>
          <option value="owner">Owner Operator Fuel</option>
        </select>
      </div>

      {/* ── Table ── */}
      <div className={styles.tableScrollfuelReport}>
        <table className={styles.fuelReportTablefuelReport}>
          <thead className={styles.tableHeaderfuelReport}>
            <tr>
              <th>Select</th>
              <th>Driver</th>
              <th>Truck</th>
              <th>Transaction Date</th>
              <th>Merchant</th>
              <th>State</th>
              <th>Location</th>
              <th>Invoice</th>
              <th>Card</th>
              <th>Card Name</th>
              <th>Payment ID</th>
              <th>Fuel Qty</th>
              <th>Fuel PPG</th>
              <th>Fuel $</th>
              <th>DEF Qty</th>
              <th>DEF $</th>
              <th>Reefer Qty</th>
              <th>Reefer PPG</th>
              <th>Reefer $</th>
              <th>Additives</th>
              <th>Oil</th>
              <th>Other Fees</th>
              <th>Discount</th>
              <th>Total</th>
              <th>Fuel Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody className={styles.tableBodyfuelReport}>
            {currentReports.map((entry) => (
              <tr key={entry._id} className={styles.tableRowfuelReport}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedReports.includes(entry._id)}
                    onChange={() => handleSelect(entry._id)}
                  />
                </td>
                <td>
                  {entry.driverId
                    ? `${entry.driverId.firstName} ${entry.driverId.lastName}`
                    : "—"}
                </td>
                <td>{entry.truckId?.truckNumber || "—"}</td>
                <td>
                  {entry.transactionDate
                    ? new Date(entry.transactionDate).toLocaleString()
                    : "—"}
                </td>
                <td>{entry.merchant || "—"}</td>
                <td>{entry.state || "—"}</td>
                <td>{entry.location || "—"}</td>
                <td>{entry.invoiceNumber || "—"}</td>
                <td>{entry.cardNumber || "—"}</td>
                <td>{entry.cardName || "—"}</td>
                <td>{entry.paymentId || "—"}</td>
                <td>{entry.fuelQuantity}</td>
                <td>{entry.fuelPPG}</td>
                <td>${Number(entry.fuelAmount || 0).toFixed(2)}</td>
                <td>{entry.defQuantity}</td>
                <td>${Number(entry.defAmount || 0).toFixed(2)}</td>
                <td>{entry.reeferQuantity}</td>
                <td>{entry.reeferPPG}</td>
                <td>${Number(entry.reeferAmount || 0).toFixed(2)}</td>
                <td>${Number(entry.additives || 0).toFixed(2)}</td>
                <td>${Number(entry.oil || 0).toFixed(2)}</td>
                <td>${Number(entry.otherFees || 0).toFixed(2)}</td>
                <td>${Number(entry.discount || 0).toFixed(2)}</td>
                <td>
                  <strong>${Number(entry.totalToPay || 0).toFixed(2)}</strong>
                </td>
                <td>
                  {entry.fuelResponsibility === 'owner' ? (
                    <span style={{ color: '#22c55e', fontWeight: 600 }}>Owner Paid</span>
                  ) : (
                    <span style={{ color: '#ef4444', fontWeight: 600 }}>Company Expense</span>
                  )}
                </td>
                <td>
                  {deleteTarget === entry._id && (
                    <DeleteNotifications
                      message="Are you sure you want to delete this fuel report?"
                      onConfirm={() => confirmDeleteFuelEntry(deleteTarget)}
                      onCancel={() => setDeleteTarget(null)}
                    />
                  )}
                  <button
                    onClick={() => handleEditClick(entry)}
                    className={styles.editButtonfuelReport}
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => setDeleteTarget(entry._id)}
                    className={styles.deleteButtonfuelReport}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ── Pagination ── */}
      <div className={styles.paginationContainerfuelReport}>
        <button
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          className={styles.prevButtonfuelReport}
        >
          Previous
        </button>
        <button
          onClick={() => setCurrentPage(prev => prev + 1)}
          disabled={currentPage * rowsPerPage >= filteredReports.length}
          className={styles.nextButtonfuelReport}
        >
          Next
        </button>
          <EmailPanel />
      </div>

    </div>
  

  );
};

const Invoice = ({ loads, settings, setLoads, drivers, trucks, brokers, consignee, shippers }) => {
  const { notify } = useNotification();

  const [search, setSearch]               = useState('');
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedLoads, setSelectedLoads] = useState([]);
  const [invoices, setInvoices]           = useState([]);
  const [showPDFPreview, setShowPDFPreview] = useState(false);
  const [activeTab, setActiveTab]         = useState('open');
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [editedInvoiceNumber, setEditedInvoiceNumber] = useState('');
  const [invoiceNotes, setInvoiceNotes]   = useState('');
  const [taxRate, setTaxRate]             = useState(0);
  const [fuelSurcharge, setFuelSurcharge] = useState(0);
  const [detentionFee, setDetentionFee]   = useState(0);
  const [linehaul, setLinehaul]           = useState(0);
  const [discount, setDiscount]           = useState(0);
  const [paymentTerms, setPaymentTerms]   = useState('Net 30');
  const [poNumber, setPoNumber]           = useState('');
  const [showChargesPanel, setShowChargesPanel] = useState(false);
  const [emailDetails, setEmailDetails]   = useState({ subject: '', message: '', brokerEmail: '' });
  const [theme, setTheme] = useState(() => sessionStorage.getItem('theme') || 'dark');

  const apiUrl   = 'https://api-backend.full-trucking-service.com/api';
  const token    = sessionStorage.getItem('token');
  const clientId = localStorage.getItem('clientId');
  const config   = { headers: { Authorization: `Bearer ${token}` }, withCredentials: true };

  useEffect(() => {
    axios.get(`${apiUrl}/settings`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setTheme(r.data.theme || 'dark')).catch(() => setTheme('dark'));
  }, []);

  useEffect(() => {
    axios.get(`${apiUrl}/invoices`, config)
      .then(r => setInvoices(r.data))
      .catch(() => notify('Failed to fetch invoices.', 'error'));
  }, []);

  useEffect(() => {
    const q = search.toLowerCase();
    if (activeTab === 'open') {
      setFilteredLoads(loads.filter(l =>
        l.status === 'Completed' && !l.isInvoiced &&
        (l.loadNumber?.toLowerCase().includes(q) || l.brokerName?.toLowerCase().includes(q))
      ));
    } else if (activeTab === 'invoiced') {
      setFilteredLoads(invoices.filter(i =>
        !i.isPayed &&
        (i.loadNumber?.toLowerCase().includes(q) || i.brokerName?.toLowerCase().includes(q))
      ));
    } else {
      setFilteredLoads(invoices.filter(i =>
        i.isPayed === true &&
        (i.loadNumber?.toLowerCase().includes(q) || i.brokerName?.toLowerCase().includes(q))
      ));
    }
  }, [search, loads, invoices, activeTab]);

  const getDriverName = (driverId) => {
    const d = drivers.find(d => d._id === driverId);
    return d ? `${d.firstName} ${d.lastName}` : '—';
  };

  const calcTotals = (baseRate) => {
    const base     = parseFloat(baseRate) || 0;
    const fuel     = parseFloat(fuelSurcharge) || 0;
    const det      = parseFloat(detentionFee) || 0;
    const lh       = parseFloat(linehaul) || 0;
    const disc     = parseFloat(discount) || 0;
    const subtotal = base + fuel + det + lh - disc;
    const taxAmt   = subtotal * ((parseFloat(taxRate) || 0) / 100);
    const total    = subtotal + taxAmt;
    return { base, fuel, det, lh, disc, subtotal, taxAmt, total };
  };

  const handleGenerateInvoice = async () => {
    if (selectedLoads.length === 0) { notify('No loads selected!', 'error'); return; }
    try {
      const invRes = await axios.post(`${apiUrl}/generate-invoice`, {}, config);
      const invoiceNumber = invRes.data.invoiceNumber;
      const invoicesData = selectedLoads.map(loadId => {
        const load   = loads.find(l => l._id === loadId);
        const totals = calcTotals(load.rate);
        return {
          loadId: load._id, loadNumber: load.loadNumber||'—',
          brokerName: load.brokerName||'—', brokerAddress: load.brokerAddress||'—',
          invoiceNumber, invoiceDate: new Date(), rate: load.rate||0,
          fuelSurcharge: totals.fuel, detentionFee: totals.det,
          linehaul: totals.lh, discount: totals.disc,
          taxRate: parseFloat(taxRate)||0, taxAmount: totals.taxAmt,
          totalAmount: totals.total, paymentTerms, poNumber,
          driverId: load.driver||null, shippers: load.shippers||[],
          consignees: load.consignees||[], notes: invoiceNotes, status: 'Pending',
        };
      });
      const saveRes = await axios.post(`${apiUrl}/invoices`, { invoices: invoicesData }, config);
      const saved = saveRes.data.invoices;
      setInvoices(prev => [...prev, ...saved]);
      setSelectedInvoice(saved[0]);
      setShowPDFPreview(true);
    } catch { notify('Failed to generate invoice.', 'error'); }
  };

  const handleSelectLoad  = id => setSelectedLoads(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id]);
  const handleSelectAll   = () => setSelectedLoads(filteredLoads.map(l => l._id));
  const handleDeselectAll = () => setSelectedLoads([]);

  const handleSaveInvoice = async () => {
    if (!selectedInvoice) return;
    try {
      await axios.put(`${apiUrl}/invoices/${selectedInvoice._id}`, { isInvoiced: true }, config);
      setInvoices(p => p.map(i => i._id === selectedInvoice._id ? { ...i, isInvoiced: true } : i));
      setShowPDFPreview(false); setActiveTab('invoiced');
      notify('Invoice saved!', 'success');
    } catch { notify('Failed to save invoice.', 'error'); }
  };

  const handleSaveInvoiceNumber = async () => {
    if (!selectedInvoice?._id || !editedInvoiceNumber?.trim()) { notify('Invoice number cannot be empty!', 'error'); return; }
    try {
      await axios.put(`${apiUrl}/invoices/${selectedInvoice._id}`, { invoiceNumber: editedInvoiceNumber }, config);
      setInvoices(p => p.map(i => i._id === selectedInvoice._id ? { ...i, invoiceNumber: editedInvoiceNumber } : i));
      setSelectedInvoice(p => ({ ...p, invoiceNumber: editedInvoiceNumber }));
      notify('Invoice number updated!', 'success');
    } catch { notify('Failed to update invoice number.', 'error'); }
  };

  const handleMarkAsPayed = async (invoiceId) => {
    try {
      await axios.put(`${apiUrl}/invoices/${invoiceId}`, { isPayed: true }, config);
      setInvoices(p => p.map(i => i._id === invoiceId ? { ...i, isPayed: true } : i));
      setFilteredLoads(p => p.filter(i => i._id !== invoiceId));
      notify('Marked as paid!', 'success');
    } catch { notify('Failed to mark as paid.', 'error'); }
  };

  const handlePreviewFromTable = (invoice) => {
    setSelectedInvoice(invoice);
    setTaxRate(invoice.taxRate||0); setFuelSurcharge(invoice.fuelSurcharge||0);
    setDetentionFee(invoice.detentionFee||0); setLinehaul(invoice.linehaul||0);
    setDiscount(invoice.discount||0); setPaymentTerms(invoice.paymentTerms||'Net 30');
    setPoNumber(invoice.poNumber||''); setInvoiceNotes(invoice.notes||'');
    setShowPDFPreview(true);
  };

 const handleSendEmail = async () => {
  if (!emailDetails.brokerEmail) { notify('Enter broker email!', 'error'); return; }
  
  try {
    // Generează PDF ca base64
    const blob = await pdf(PDFContent).toBlob();
    const reader = new FileReader();
    
    reader.onloadend = async () => {
      const base64 = reader.result.split(',')[1];
      
      try {
        await axios.post(`${apiUrl}/email/send-with-attachment`, {
          to: emailDetails.brokerEmail,
          subject: emailDetails.subject || `Invoice #${selectedInvoice?.invoiceNumber}`,
          body: emailDetails.message || 'Please find the attached invoice.',
          attachment: {
            data: base64,
            filename: `Invoice_${selectedInvoice?.invoiceNumber || 'draft'}.pdf`,
            mimeType: 'application/pdf',
          }
        }, config);
        
        notify('Invoice sent successfully!', 'success');
      } catch {
        notify('Failed to send email', 'error');
      }
    };
    
    reader.readAsDataURL(blob);
  } catch {
    notify('Failed to generate PDF for sending', 'error');
  }
};

  // ── PDF ────────────────────────────────────────────────────────────────
  const PDFContent = (() => {
    const loadObjects = activeTab === 'open'
      ? selectedLoads.map(id => loads.find(l => l._id === id)).filter(Boolean)
      : [selectedInvoice].filter(Boolean);
    const inv      = selectedInvoice;
    const baseRate = loadObjects.reduce((s, l) => s + (parseFloat(l?.rate)||0), 0);
    const totals   = inv
      ? { base:inv.rate||0, fuel:inv.fuelSurcharge||0, det:inv.detentionFee||0, lh:inv.linehaul||0, disc:inv.discount||0, subtotal:(inv.rate||0)+(inv.fuelSurcharge||0)+(inv.detentionFee||0)+(inv.linehaul||0)-(inv.discount||0), taxAmt:inv.taxAmount||0, total:inv.totalAmount||inv.rate||0 }
      : calcTotals(baseRate);
    const pTerms = inv?.paymentTerms || paymentTerms;
    const pNum   = inv?.poNumber || poNumber;
    const notes  = inv?.notes || invoiceNotes;
    const iNum   = inv?.invoiceNumber || '—';
    const iDate  = inv?.invoiceDate ? new Date(inv.invoiceDate).toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'}) : new Date().toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'});
    const dueDate = (() => {
      const d = new Date(inv?.invoiceDate||new Date());
      d.setDate(d.getDate() + (parseInt(pTerms.replace(/\D/g,''))||30));
      return d.toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'});
    })();
    const S = {
      page:{padding:0,fontFamily:'Helvetica',backgroundColor:'#FFFFFF'},
      header:{backgroundColor:'#1a1f2e',padding:'32pt 40pt 24pt'},
      compName:{fontSize:22,fontWeight:'bold',color:'#FFFFFF',marginBottom:4},
      compSub:{fontSize:9,color:'#94a3b8',marginBottom:2},
      invLabel:{fontSize:36,fontWeight:'bold',color:'#f59e0b',letterSpacing:2},
      invNum:{fontSize:11,color:'#94a3b8',marginTop:4},
      body:{padding:'24pt 40pt'},
      row:{flexDirection:'row',justifyContent:'space-between',marginBottom:20},
      label:{fontSize:7,fontWeight:'bold',color:'#94a3b8',textTransform:'uppercase',letterSpacing:1,marginBottom:4},
      value:{fontSize:10,color:'#1a1f2e',marginBottom:2},
      valueBold:{fontSize:11,fontWeight:'bold',color:'#1a1f2e',marginBottom:2},
      divider:{height:1,backgroundColor:'#e2e8f0',marginBottom:16},
      thRow:{flexDirection:'row',backgroundColor:'#1a1f2e',paddingVertical:8,paddingHorizontal:10},
      th:{fontSize:8,fontWeight:'bold',color:'#94a3b8',textTransform:'uppercase',letterSpacing:0.5},
      tdRow:{flexDirection:'row',paddingVertical:10,paddingHorizontal:10,borderBottomWidth:1,borderBottomColor:'#f1f5f9'},
      td:{fontSize:10,color:'#334155'},altRow:{backgroundColor:'#f8fafc'},
      totWrap:{marginTop:16,alignItems:'flex-end'},
      totRow:{flexDirection:'row',justifyContent:'space-between',width:240,paddingVertical:4},
      totLbl:{fontSize:10,color:'#64748b'},totVal:{fontSize:10,color:'#334155'},
      grandRow:{flexDirection:'row',justifyContent:'space-between',width:240,paddingVertical:8,backgroundColor:'#1a1f2e',paddingHorizontal:12,borderRadius:4,marginTop:4},
      grandLbl:{fontSize:11,fontWeight:'bold',color:'#f59e0b'},grandVal:{fontSize:11,fontWeight:'bold',color:'#FFFFFF'},
      footer:{marginTop:28,paddingTop:16,borderTopWidth:1,borderTopColor:'#e2e8f0'},
      footerTxt:{fontSize:8,color:'#94a3b8',textAlign:'center',marginBottom:2},
      notesBox:{backgroundColor:'#f8fafc',padding:12,borderRadius:4,marginTop:16,borderLeftWidth:3,borderLeftColor:'#f59e0b'},
      notesLbl:{fontSize:8,fontWeight:'bold',color:'#f59e0b',textTransform:'uppercase',letterSpacing:1,marginBottom:4},
      notesTxt:{fontSize:9,color:'#475569'},
      badge:{backgroundColor:'#fef3c7',paddingHorizontal:8,paddingVertical:3,borderRadius:3},
      badgeTxt:{fontSize:9,color:'#92400e',fontWeight:'bold'},
    };
    return (
      <Document title={`Invoice ${iNum}`} author={settings.companyName||'Trucking Co'}>
        <Page size="LETTER" style={S.page}>
          <View style={S.header}>
            <View style={{flexDirection:'row',justifyContent:'space-between',alignItems:'flex-start'}}>
              <View>
                <Text style={S.compName}>{settings.companyName||'YOUR COMPANY NAME'}</Text>
                <Text style={S.compSub}>{settings.companyAddress||'123 Main St, City, State ZIP'}</Text>
                <Text style={S.compSub}>Tel: {settings.phone||'—'} · Email: {settings.email||'—'}</Text>
                {settings.dotNumber&&<Text style={S.compSub}>DOT #{settings.dotNumber} · MC #{settings.mcNumber||'—'}</Text>}
              </View>
              <View style={{alignItems:'flex-end'}}>
                <Text style={S.invLabel}>INVOICE</Text>
                <Text style={S.invNum}>#{iNum}</Text>
                {pNum?<View style={{...S.badge,marginTop:6}}><Text style={S.badgeTxt}>P.O. #{pNum}</Text></View>:null}
              </View>
            </View>
          </View>
          <View style={S.body}>
            <View style={S.row}>
              <View style={{flex:1}}>
                <Text style={S.label}>Bill To</Text>
                <Text style={S.valueBold}>{loadObjects[0]?.brokerName||inv?.brokerName||'—'}</Text>
                <Text style={S.value}>{loadObjects[0]?.brokerAddress||inv?.brokerAddress||'—'}</Text>
              </View>
              <View style={{flex:1,alignItems:'flex-end'}}>
                <View style={{alignItems:'flex-end',marginBottom:8}}><Text style={S.label}>Invoice Date</Text><Text style={S.value}>{iDate}</Text></View>
                <View style={{alignItems:'flex-end',marginBottom:8}}><Text style={S.label}>Due Date</Text><Text style={{...S.valueBold,color:'#dc2626'}}>{dueDate}</Text></View>
                <View style={{alignItems:'flex-end'}}><Text style={S.label}>Payment Terms</Text><Text style={S.value}>{pTerms}</Text></View>
              </View>
            </View>
            <View style={S.divider}/>
            {loadObjects.map((load,i)=>{
              const shipper=load?.shippers?.[0];const consignee=load?.consignees?.[load?.consignees?.length-1];
              return(
                <View key={i} style={{marginBottom:10,backgroundColor:'#f8fafc',padding:10,borderRadius:4,borderLeftWidth:2,borderLeftColor:'#3b82f6'}}>
                  <View style={{flexDirection:'row',justifyContent:'space-between'}}>
                    <View><Text style={{...S.label,color:'#3b82f6'}}>Load #{load?.loadNumber||'—'}</Text><Text style={{fontSize:9,color:'#475569',marginTop:2}}>{shipper?.address||'—'} → {consignee?.address||'—'}</Text></View>
                    <View style={{alignItems:'flex-end'}}><Text style={S.label}>Driver</Text><Text style={{fontSize:9,color:'#475569'}}>{getDriverName(load?.driver||load?.driverId)}</Text></View>
                  </View>
                  {shipper?.pickUpTime&&<Text style={{fontSize:8,color:'#94a3b8',marginTop:3}}>Pickup: {new Date(shipper.pickUpTime).toLocaleString('en-US')}{consignee?.deliveryTime?`  ·  Delivery: ${new Date(consignee.deliveryTime).toLocaleString('en-US')}`:''}</Text>}
                </View>
              );
            })}
            <View style={{marginTop:12}}>
              <View style={S.thRow}>
                <Text style={{...S.th,flex:3}}>Description</Text>
                <Text style={{...S.th,flex:1,textAlign:'center'}}>Qty</Text>
                <Text style={{...S.th,flex:2,textAlign:'right'}}>Unit Price</Text>
                <Text style={{...S.th,flex:2,textAlign:'right'}}>Amount</Text>
              </View>
              {loadObjects.map((load,i)=>(
                <View key={i} style={{...S.tdRow,...(i%2===1?S.altRow:{})}}>
                  <Text style={{...S.td,flex:3}}>Freight Transportation — Load #{load?.loadNumber||'—'}{'\n'}<Text style={{fontSize:8,color:'#94a3b8'}}>{load?.shippers?.[0]?.address||'—'} to {load?.consignees?.[0]?.address||'—'}</Text></Text>
                  <Text style={{...S.td,flex:1,textAlign:'center'}}>1</Text>
                  <Text style={{...S.td,flex:2,textAlign:'right'}}>${parseFloat(load?.rate||0).toFixed(2)}</Text>
                  <Text style={{...S.td,flex:2,textAlign:'right'}}>${parseFloat(load?.rate||0).toFixed(2)}</Text>
                </View>
              ))}
              {totals.fuel>0&&<View style={S.tdRow}><Text style={{...S.td,flex:3,color:'#64748b'}}>Fuel Surcharge</Text><Text style={{...S.td,flex:1,textAlign:'center'}}>1</Text><Text style={{...S.td,flex:2,textAlign:'right'}}>${totals.fuel.toFixed(2)}</Text><Text style={{...S.td,flex:2,textAlign:'right'}}>${totals.fuel.toFixed(2)}</Text></View>}
              {totals.det>0&&<View style={S.tdRow}><Text style={{...S.td,flex:3,color:'#64748b'}}>Detention Fee</Text><Text style={{...S.td,flex:1,textAlign:'center'}}>1</Text><Text style={{...S.td,flex:2,textAlign:'right'}}>${totals.det.toFixed(2)}</Text><Text style={{...S.td,flex:2,textAlign:'right'}}>${totals.det.toFixed(2)}</Text></View>}
              {totals.lh>0&&<View style={S.tdRow}><Text style={{...S.td,flex:3,color:'#64748b'}}>Additional Linehaul</Text><Text style={{...S.td,flex:1,textAlign:'center'}}>1</Text><Text style={{...S.td,flex:2,textAlign:'right'}}>${totals.lh.toFixed(2)}</Text><Text style={{...S.td,flex:2,textAlign:'right'}}>${totals.lh.toFixed(2)}</Text></View>}
              {totals.disc>0&&<View style={S.tdRow}><Text style={{...S.td,flex:3,color:'#dc2626'}}>Discount</Text><Text style={{...S.td,flex:1,textAlign:'center'}}>1</Text><Text style={{...S.td,flex:2,textAlign:'right',color:'#dc2626'}}>-${totals.disc.toFixed(2)}</Text><Text style={{...S.td,flex:2,textAlign:'right',color:'#dc2626'}}>-${totals.disc.toFixed(2)}</Text></View>}
            </View>
            <View style={S.totWrap}>
              <View style={S.totRow}><Text style={S.totLbl}>Subtotal</Text><Text style={S.totVal}>${totals.subtotal.toFixed(2)}</Text></View>
              {totals.taxAmt>0&&<View style={S.totRow}><Text style={S.totLbl}>Tax ({taxRate}%)</Text><Text style={S.totVal}>${totals.taxAmt.toFixed(2)}</Text></View>}
              <View style={S.grandRow}><Text style={S.grandLbl}>TOTAL DUE</Text><Text style={S.grandVal}>${totals.total.toFixed(2)}</Text></View>
            </View>
            {notes&&<View style={S.notesBox}><Text style={S.notesLbl}>Notes</Text><Text style={S.notesTxt}>{notes}</Text></View>}
            <View style={S.footer}>
              <Text style={S.footerTxt}>Payment due {pTerms} from invoice date · Make checks payable to {settings.companyName||'Company Name'}</Text>
              <Text style={S.footerTxt}>{settings.bankName?`Bank: ${settings.bankName} · Account: ${settings.bankAccount||'—'} · Routing: ${settings.routingNumber||'—'}`:''}</Text>
              <Text style={{...S.footerTxt,marginTop:6}}>Thank you for your business! Questions? {settings.email||'—'} · {settings.phone||'—'}</Text>
            </View>
          </View>
        </Page>
      </Document>
    );
  })();

  const isLight = theme === 'light';
  const rootCls = `${styles.invoiceRoot} ${isLight ? styles.invoiceRootLight : ''}`;

  return (
    <div className={rootCls}>

      {/* Header */}
      <div className={styles.invoicePageHeader}>
        <div className={styles.invoicePageHeaderInner}>
          <p className={styles.invoiceEyebrow}>Full Trucking Service</p>
          <h1 className={styles.invoicePageTitle}>Invoice Manager</h1>
          <p className={styles.invoicePageSubtitle}>Generate, manage and send professional freight invoices</p>
        </div>
        {activeTab === 'open' && selectedLoads.length > 0 && (
          <button className={styles.invoiceBtnGenerate} onClick={handleGenerateInvoice}>
            ⚡ Generate Invoice ({selectedLoads.length})
          </button>
        )}
      </div>

      {/* Tabs */}
      <div className={styles.invoiceTabBar}>
        {[['open','Open Loads'],['invoiced','Invoiced'],['payed','Paid']].map(([tab,label]) => (
          <button key={tab} className={`${styles.invoiceTabBtn} ${activeTab===tab?styles.invoiceTabBtnActive:''}`} onClick={()=>setActiveTab(tab)}>
            {label}
          </button>
        ))}
      </div>

      {/* Toolbar */}
      <div className={styles.invoiceToolbar}>
        <input className={styles.invoiceSearch} placeholder="Search loads or brokers..." value={search} onChange={e=>setSearch(e.target.value)} />
        {activeTab === 'open' && (
          <div className={styles.invoiceToolbarActions}>
            <button className={styles.invoiceBtnSecondary} onClick={handleSelectAll}>Select All</button>
            <button className={styles.invoiceBtnSecondary} onClick={handleDeselectAll}>Deselect All</button>
            <button className={`${styles.invoiceBtnSecondary} ${styles.invoiceBtnAccent}`} onClick={()=>setShowChargesPanel(p=>!p)}>
              {showChargesPanel?'▲':'▼'} Extra Charges & Tax
            </button>
          </div>
        )}
        <span className={styles.invoiceCount}>
          {filteredLoads.length} record{filteredLoads.length!==1?'s':''}{selectedLoads.length>0?` · ${selectedLoads.length} selected`:''}
        </span>
      </div>

      {/* Charges Panel */}
      {showChargesPanel && activeTab === 'open' && (
        <div className={styles.invoiceChargesPanel}>
          <div className={styles.invoiceChargesPanelHeader}>
            <p className={styles.invoiceChargesPanelTitle}>Invoice Configuration</p>
            <p className={styles.invoiceChargesPanelSub}>These charges apply to all selected loads</p>
          </div>
          {[
            {label:'Fuel Surcharge ($)',val:fuelSurcharge,set:setFuelSurcharge},
            {label:'Detention Fee ($)', val:detentionFee, set:setDetentionFee},
            {label:'Extra Linehaul ($)',val:linehaul,      set:setLinehaul},
            {label:'Discount ($)',      val:discount,      set:setDiscount},
            {label:'Tax Rate (%)',      val:taxRate,       set:setTaxRate},
          ].map(({label,val,set})=>(
            <div key={label} className={styles.invoiceChargesField}>
              <label className={styles.invoiceFieldLabel}>{label}</label>
              <input type="number" min="0" step="0.01" value={val} onChange={e=>set(e.target.value)} className={styles.invoiceInput}/>
            </div>
          ))}
          <div className={styles.invoiceChargesField}>
            <label className={styles.invoiceFieldLabel}>Payment Terms</label>
            <select value={paymentTerms} onChange={e=>setPaymentTerms(e.target.value)} className={styles.invoiceSelect}>
              {['Net 15','Net 30','Net 45','Net 60','Due on Receipt','COD'].map(t=><option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div className={styles.invoiceChargesField}>
            <label className={styles.invoiceFieldLabel}>P.O. Number</label>
            <input type="text" placeholder="Optional" value={poNumber} onChange={e=>setPoNumber(e.target.value)} className={styles.invoiceInput}/>
          </div>
          <div className={`${styles.invoiceChargesField} ${styles.invoiceChargesFieldFull}`}>
            <label className={styles.invoiceFieldLabel}>Invoice Notes</label>
            <textarea value={invoiceNotes} onChange={e=>setInvoiceNotes(e.target.value)} placeholder="Payment instructions, bank details, special notes..." rows={2} className={styles.invoiceTextarea}/>
          </div>
        </div>
      )}

      {/* Table */}
      <div className={styles.invoiceTableWrap}>
        <div className={styles.invoiceTableScroll}>
          <table className={styles.invoiceTable}>
            <thead>
              <tr className={styles.invoiceTableHead}>
                {activeTab==='open'&&(
                  <th className={styles.invoiceTh} style={{width:44}}>
                    <input type="checkbox" className={styles.invoiceCheckbox}
                      checked={selectedLoads.length===filteredLoads.length&&filteredLoads.length>0}
                      onChange={selectedLoads.length===filteredLoads.length?handleDeselectAll:handleSelectAll}/>
                  </th>
                )}
                {['#','Status','Load No.','Broker','Rate','Driver','Pickup','Delivery',
                  ...(activeTab!=='open'?['Invoice No.']:[]),'Actions'].map(h=>(
                  <th key={h} className={styles.invoiceTh}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredLoads.length===0?(
                <tr><td colSpan={20} className={styles.invoiceEmptyCell}>
                  <div className={styles.invoiceEmpty}>
                 
                    <p className={styles.invoiceEmptyTitle}>No records found</p>
                    <p className={styles.invoiceEmptyDesc}>{activeTab==='open'?'Completed loads ready for invoicing will appear here':'No invoices in this category'}</p>
                  </div>
                </td></tr>
              ):filteredLoads.map((load,i)=>{
                const isSelected=selectedLoads.includes(load._id);
                const stClass=load.isPayed?styles.invoiceStatusPaid:load.status==='Completed'?styles.invoiceStatusCompleted:styles.invoiceStatusPending;
                return(
                  <tr key={load._id} className={`${styles.invoiceTr} ${isSelected?styles.invoiceTrSelected:''}`}>
                    {activeTab==='open'&&<td className={styles.invoiceTd}><input type="checkbox" checked={isSelected} onChange={()=>handleSelectLoad(load._id)} className={styles.invoiceCheckbox}/></td>}
                    <td className={`${styles.invoiceTd} ${styles.invoiceTdMuted}`}>{i+1}</td>
                    <td className={styles.invoiceTd}><span className={`${styles.invoiceStatusBadge} ${stClass}`}>{load.isPayed?'Paid':load.status||'—'}</span></td>
                    <td className={`${styles.invoiceTd} ${styles.invoiceTdBold}`}>{load.loadNumber||'—'}</td>
                    <td className={styles.invoiceTd}>
                      <div className={styles.invoiceBrokerName}>{load.brokerName||'—'}</div>
                      <div className={styles.invoiceBrokerAddr}>{load.brokerAddress||''}</div>
                    </td>
                    <td className={`${styles.invoiceTd} ${styles.invoiceTdRate}`}>
                      ${parseFloat(load.rate||0).toFixed(2)}
                      {(load.totalAmount&&load.totalAmount!==load.rate)&&<div className={styles.invoiceTdRateTotal}>Total: ${parseFloat(load.totalAmount).toFixed(2)}</div>}
                    </td>
                    <td className={`${styles.invoiceTd} ${styles.invoiceTdMuted}`}>{getDriverName(load.driver||load.driverId)}</td>
                    <td className={`${styles.invoiceTd} ${styles.invoiceTdMuted}`}>{load.shippers?.[0]?.pickUpTime?new Date(load.shippers[0].pickUpTime).toLocaleDateString('en-US'):'—'}</td>
                    <td className={`${styles.invoiceTd} ${styles.invoiceTdMuted}`}>{load.consignees?.[load.consignees.length-1]?.deliveryTime?new Date(load.consignees[load.consignees.length-1].deliveryTime).toLocaleDateString('en-US'):'—'}</td>
                    {activeTab!=='open'&&<td className={`${styles.invoiceTd} ${styles.invoiceTdInvNum}`}>{load.invoiceNumber||'—'}</td>}
                    <td className={styles.invoiceTd}>
                      <div className={styles.invoiceRowActions}>
                        {activeTab==='open'&&<button className={styles.invoiceBtnGenerate} onClick={handleGenerateInvoice}>Generate</button>}
                        {activeTab==='invoiced'&&<><button className={styles.invoiceBtnBlue} onClick={()=>handlePreviewFromTable(load)}>Preview</button><button className={styles.invoiceBtnGreen} onClick={()=>handleMarkAsPayed(load._id)}>Mark Paid</button></>}
                        {activeTab==='payed'&&<button className={styles.invoiceBtnSecondary} onClick={()=>handlePreviewFromTable(load)}>Preview PDF</button>}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {showPDFPreview && createPortal(
        <div className={styles.invoiceModalOverlay} onClick={e=>{if(e.target===e.currentTarget)setShowPDFPreview(false);}}>
         <div className={styles.invoiceModal} data-theme={theme}>

            <div className={styles.invoiceModalHeader}>
              <div className={styles.invoiceModalHeaderLeft}>
                
                <div>
                  <div className={styles.invoiceModalTitle}>
                    Invoice Preview
                    {selectedInvoice?.invoiceNumber&&<span className={styles.invoiceModalTitleNum}>#{selectedInvoice.invoiceNumber}</span>}
                  </div>
                  <div className={styles.invoiceModalSubtitle}>
                    {selectedInvoice?.brokerName||'Draft'} · {selectedInvoice?.invoiceDate?new Date(selectedInvoice.invoiceDate).toLocaleDateString('en-US'):new Date().toLocaleDateString('en-US')}
                  </div>
                </div>
              </div>
              <button className={styles.invoiceModalClose} onClick={()=>setShowPDFPreview(false)}>✕</button>
            </div>

            <div className={styles.invoiceModalBody}>
             <div className={styles.invoiceModalPdfPane} style={{display:'flex',flexDirection:'column'}}>
               <PDFViewer width="100%" height="100%" style={{border:'none',borderRadius:8,minHeight:'640px',display:'block'}}>{PDFContent}</PDFViewer>
              </div>
              <div className={styles.invoiceModalControls}>

                <div className={styles.invoiceControlCard}>
                  <p className={styles.invoiceControlCardTitle}>Invoice Number</p>
                  <input type="text" value={editedInvoiceNumber||selectedInvoice?.invoiceNumber||''} onChange={e=>setEditedInvoiceNumber(e.target.value)} className={styles.invoiceInput}/>
                  <button className={`${styles.invoiceBtnGenerate} ${styles.invoiceBtnFull}`} onClick={handleSaveInvoiceNumber}>Update Number</button>
                </div>

                <div className={styles.invoiceControlCard}>
                  <p className={styles.invoiceControlCardTitle}>Charges & Tax</p>
                  {[
                    {label:'Fuel Surcharge ($)',val:fuelSurcharge,set:setFuelSurcharge},
                    {label:'Detention Fee ($)', val:detentionFee, set:setDetentionFee},
                    {label:'Extra Linehaul ($)',val:linehaul,      set:setLinehaul},
                    {label:'Discount ($)',      val:discount,      set:setDiscount},
                    {label:'Tax Rate (%)',      val:taxRate,       set:setTaxRate},
                  ].map(({label,val,set})=>(
                    <div key={label} className={styles.invoiceControlField}>
                      <label className={styles.invoiceFieldLabel}>{label}</label>
                      <input type="number" min="0" step="0.01" value={val} onChange={e=>set(e.target.value)} className={styles.invoiceInput}/>
                    </div>
                  ))}
                  <div className={styles.invoiceControlField}>
                    <label className={styles.invoiceFieldLabel}>Payment Terms</label>
                    <select value={paymentTerms} onChange={e=>setPaymentTerms(e.target.value)} className={styles.invoiceSelect}>
                      {['Net 15','Net 30','Net 45','Net 60','Due on Receipt','COD'].map(t=><option key={t} value={t}>{t}</option>)}
                    </select>
                  </div>
                  <div className={styles.invoiceControlField}>
                    <label className={styles.invoiceFieldLabel}>P.O. Number</label>
                    <input type="text" placeholder="Optional" value={poNumber} onChange={e=>setPoNumber(e.target.value)} className={styles.invoiceInput}/>
                  </div>
                  <div className={styles.invoiceControlField}>
                    <label className={styles.invoiceFieldLabel}>Notes</label>
                    <textarea rows={3} value={invoiceNotes} onChange={e=>setInvoiceNotes(e.target.value)} className={styles.invoiceTextarea}/>
                  </div>
                </div>

                {(()=>{
                  const base=selectedInvoice?.rate||selectedLoads.reduce((s,id)=>{const l=loads.find(x=>x._id===id);return s+(parseFloat(l?.rate)||0);},0);
                  const t=calcTotals(base);
                  return(
                    <div className={styles.invoiceTotalCard}>
                      <p className={styles.invoiceTotalCardTitle}>Live Total</p>
                      {[
                        ['Base Rate',`$${t.base.toFixed(2)}`],
                        t.fuel>0?['+ Fuel Surcharge',`$${t.fuel.toFixed(2)}`]:null,
                        t.det>0?['+ Detention',`$${t.det.toFixed(2)}`]:null,
                        t.lh>0?['+ Linehaul',`$${t.lh.toFixed(2)}`]:null,
                        t.disc>0?['− Discount',`-$${t.disc.toFixed(2)}`]:null,
                        ['Subtotal',`$${t.subtotal.toFixed(2)}`],
                        t.taxAmt>0?[`Tax (${taxRate}%)`,`$${t.taxAmt.toFixed(2)}`]:null,
                      ].filter(Boolean).map(([lbl,val])=>(
                        <div key={lbl} className={styles.invoiceTotalRow}><span>{lbl}</span><span>{val}</span></div>
                      ))}
                      <div className={styles.invoiceTotalGrand}>
                        <span>TOTAL DUE</span>
                        <span className={styles.invoiceTotalGrandVal}>${t.total.toFixed(2)}</span>
                      </div>
                    </div>
                  );
                })()}

                <div className={styles.invoiceControlCard}>
                  <p className={`${styles.invoiceControlCardTitle} ${styles.invoiceControlCardTitleBlue}`}>Send via Email</p>
                  {[
                    {placeholder:'Broker email address',name:'brokerEmail',type:'email'},
                    {placeholder:'Subject line',         name:'subject',    type:'text'},
                  ].map(f=>(
                    <input key={f.name} type={f.type} placeholder={f.placeholder} name={f.name}
                      value={emailDetails[f.name]} onChange={e=>setEmailDetails(p=>({...p,[f.name]:e.target.value}))}
                      className={`${styles.invoiceInput} ${styles.invoiceInputSpaced}`}/>
                  ))}
                  <textarea placeholder="Message..." name="message" rows={2}
                    value={emailDetails.message} onChange={e=>setEmailDetails(p=>({...p,message:e.target.value}))}
                    className={`${styles.invoiceTextarea} ${styles.invoiceTextareaSpaced}`}/>
                  <button className={`${styles.invoiceBtnBlue} ${styles.invoiceBtnFull}`} onClick={handleSendEmail}>Send Email</button>
                </div>

              </div>
            </div>

            <div className={styles.invoiceModalFooter}>
              <button className={styles.invoiceBtnGreen} onClick={handleSaveInvoice}>✓ Save Invoice</button>
              {activeTab==='invoiced'&&selectedInvoice&&(
                <button className={styles.invoiceBtnBlue} onClick={()=>handleMarkAsPayed(selectedInvoice._id)}>$ Mark as Paid</button>
              )}
              <button className={`${styles.invoiceBtnSecondary} ${styles.invoiceModalCloseBtn}`} onClick={()=>setShowPDFPreview(false)}>✕ Close</button>
            </div>

          </div>
        </div>,
        document.body
      )}
      <EmailPanel />
    </div>
  );
};



const ReceivedInvoices = () => {
  const { notify } = useNotification();
const [activeTab, setActiveTab] = useState('archiving');
const [recordedInvoices, setRecordedInvoices] = useState([]);
const [paidInvoices, setPaidInvoices] = useState([]);
const [editingInvoice, setEditingInvoice] = useState(false);
const [editedInvoice, setEditedInvoice] = useState({});
const [showConfirmation, setShowConfirmation] = useState(false);
const [selectedRecordedInvoice, setSelectedRecordedInvoice] = useState(null);
const [invoiceDocuments, setInvoiceDocuments] = useState([]);
const [previewDocUrl, setPreviewDocUrl]       = useState('');
const [previewDocMime, setPreviewDocMime]     = useState('');
const [selectedDocPreview, setSelectedDocPreview] = useState(null);
const [showArchivingModal, setShowArchivingModal] = useState(false);

const resetInvoiceAndNext = () => {
  setInvoiceData({
    invoiceNumber: '',
    invoiceDate: '',
    internalInvoiceNumber: '',
    companyName: '',
    companyAddress: '',
    mcNumber: '',
    description: '',
    rate: '',
    dueDate: '',
    earlyPaymentDiscount: 'No',
    paymentMethod: '',
    status: 'Pending',
  });
  setPdfQueue(prev => prev.slice(1));
  };

const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

const [selectedPaidInvoice, setSelectedPaidInvoice] = useState(null);
  const [pdfQueue, setPdfQueue] = useState([]); // o listă cu TOATE fișierele uploadate
const currentPdf = pdfQueue[0] || null; // fișierul curent
  const [invoiceData, setInvoiceData] = useState({
    invoiceNumber: '',
    invoiceDate: '',
    internalInvoiceNumber: '',
    companyName: '',
    companyAddress: '',
    mcNumber: '',
    description: '',
    rate: '',
    dueDate: '',
    earlyPaymentDiscount: 'No',
    paymentMethod: '',
    status: 'Pending',
  });

  const [pdfUrl, setPdfUrl] = useState(null);
  const [currentPickingField, setCurrentPickingField] = useState(null);
  const iframeRef = useRef(null);

  const [leftWidth, setLeftWidth] = useState(50);
  const token = sessionStorage.getItem('token');
  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  };

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInvoiceData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      const newQueue = files.map(file => ({
        file,
        url: URL.createObjectURL(file),
      }));
      setPdfQueue(prev => [...prev, ...newQueue]); // adaugă la coadă
    }
  };
  
  const handleMouseUp = () => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    const selectedText = iframe.contentWindow?.getSelection()?.toString().trim();
    if (selectedText && currentPickingField) {
      setInvoiceData((prev) => ({
        ...prev,
        [currentPickingField]: selectedText,
      }));
      const input = document.querySelector(`input[name="${currentPickingField}"], select[name="${currentPickingField}"]`);
      if (input) {
        input.focus();
        input.select?.();
      }
    }
  };

const fetchInvoiceDocuments = async (invoiceId) => {
  try {
    const res = await axios.get(`${apiUrl}/documents`, {
      ...config,
      params: { linkedEntityType: 'received_invoice', linkedEntityId: invoiceId },
    });

    setInvoiceDocuments(res.data);
  } catch { setInvoiceDocuments([]); }
};

const handleInvoiceDocPreview = async (doc) => {
  try {
    const res = await axios.get(`${apiUrl}/documents/${doc.id}/download`, {
      ...config, responseType: 'blob',
    });
    const url = URL.createObjectURL(res.data);
    setPreviewDocUrl(url);
    setPreviewDocMime(doc.mimeType);
    setSelectedDocPreview(doc);
  } catch { alert('Preview failed'); }
};

  useEffect(() => {
    if (!pdfUrl || !iframeRef.current) return;
    const iframeDoc = iframeRef.current.contentDocument || iframeRef.current.contentWindow?.document;
    iframeDoc?.addEventListener('mouseup', handleMouseUp);
    return () => {
      iframeDoc?.removeEventListener('mouseup', handleMouseUp);
    };
  }, [pdfUrl, currentPickingField]);

  

const handleRecordInvoice = async () => {
  try {
    // 1. Salvează invoice-ul
    const invoiceRes = await axios.post(`${apiUrl}/received-invoices`, invoiceData, config);
    const savedInvoice = invoiceRes.data.invoice; 

    // 2. Dacă există PDF în coadă, uploadează-l în Document Center
    if (currentPdf?.file) {
      try {
        const formData = new FormData();
        formData.append('file',              currentPdf.file);
        formData.append('docType',           'invoice');
        formData.append('title',             `Invoice - ${invoiceData.invoiceNumber || invoiceData.companyName}`);
        formData.append('description',       `Received invoice from ${invoiceData.companyName}`);
        formData.append('linkedEntityType',  'received_invoice');
        formData.append('linkedEntityId',    savedInvoice._id);
        formData.append('linkedEntityLabel', `${invoiceData.companyName} — ${invoiceData.invoiceNumber}`);

        await axios.post(`${apiUrl}/documents`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
          withCredentials: true,
        });
      } catch (docErr) {
        console.error('Document upload failed:', docErr);
        // Nu blocăm flow-ul — invoice-ul e deja salvat
      }
    }

    notify('Invoice recorded successfully!', 'success');

    // 3. Reset form și treci la următorul PDF
    setInvoiceData({
      invoiceNumber: '',
      invoiceDate: '',
      internalInvoiceNumber: '',
      companyName: '',
      companyAddress: '',
      mcNumber: '',
      description: '',
      rate: '',
      dueDate: '',
      earlyPaymentDiscount: 'No',
      paymentMethod: '',
      status: 'Recorded',
    });
    setPdfQueue(prev => prev.slice(1));

  } catch (err) {
    notify('Failed to record invoice.', 'error');
  }
};
  
  const fetchPaidInvoices = async () => {
    try {
      const response = await axios.get(`${apiUrl}/received-invoices`, config);
      const onlyPaid = response.data.filter(inv => inv.status === 'Paid');
      setPaidInvoices(onlyPaid);
    } catch (err) {
     
    }
  };
  
  // Split logic
  const startDragging = (e) => {
    e.preventDefault();
    document.addEventListener('mousemove', onDragging);
    document.addEventListener('mouseup', stopDragging);
  };

  const onDragging = (e) => {
    const container = document.querySelector(`.${styles.archivingSection}`);
    if (!container) return;
    const containerRect = container.getBoundingClientRect();
    const newLeftWidth = ((e.clientX - containerRect.left) / containerRect.width) * 100;
    if (newLeftWidth > 10 && newLeftWidth < 90) {
      setLeftWidth(newLeftWidth);
    }
  };

  const stopDragging = () => {
    document.removeEventListener('mousemove', onDragging);
    document.removeEventListener('mouseup', stopDragging);
  };
  useEffect(() => {
    if (activeTab === 'recorded') {
      fetchRecordedInvoices();
    }
    if (activeTab === 'paid') {
      fetchPaidInvoices();
    }
  }, [activeTab]);
  
  
  const fetchRecordedInvoices = async () => {
    try {
      const response = await axios.get(`${apiUrl}/received-invoices`, config);
      const onlyRecorded = response.data.filter(inv => inv.status === 'Recorded');
      setRecordedInvoices(onlyRecorded);
    } catch (err) {
   
    }
  };
  
  return (
    <div
  className={`${styles.receivedInvoicesContainer} ${
    theme === "light" ? styles.receivedInvoicesContainerLight : ""
  }`}
>

      <h2>Received Invoices</h2>

      {/* Tab buttons */}
      <div className={styles.tabButtons}>
        {['archiving', 'recorded', 'paid'].map((tab) => (
          <button
            key={tab}
            className={activeTab === tab ? styles.activeTab : ''}
            onClick={() => setActiveTab(tab)}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>

{activeTab === 'paid' && (
  <div className={styles.paidSection}>

    {/* Modal full screen */}
    {selectedPaidInvoice && createPortal(
      <div className={styles.riModalOverlay}>
        <div className={styles.riModal} data-theme={theme}>

          {/* Header */}
          <div className={styles.riModalHeader}>
            <div className={styles.riModalHeaderLeft}>
              
              <div>
                <div className={styles.riModalTitle}>
                  Paid Invoice
                  <span className={styles.riModalTitleNum}>#{selectedPaidInvoice.invoiceNumber}</span>
                </div>
                <div className={styles.riModalSubtitle}>{selectedPaidInvoice.companyName}</div>
              </div>
            </div>
            <button
              className={styles.riModalClose}
              onClick={() => {
                setSelectedPaidInvoice(null);
                setPreviewDocUrl('');
                setSelectedDocPreview(null);
                setInvoiceDocuments([]);
              }}
            >✕</button>
          </div>

          {/* Body */}
          <div className={styles.riModalBody}>

            {/* LEFT — Details */}
            <div className={styles.riModalLeft}>
              <div className={styles.riFieldsList}>
                {Object.entries(selectedPaidInvoice).map(([key, value]) => {
                  if (['_id','clientId','__v','createdAt'].includes(key)) return null;
                  const niceLabel = key.replace(/([A-Z])/g,' $1').replace(/^./,s=>s.toUpperCase());
                  return (
                    <div key={key} className={styles.riFieldItem}>
                      <span className={styles.riFieldLabel}>{niceLabel}</span>
                      <span className={styles.riFieldValue}>{value ?? '—'}</span>
                    </div>
                  );
                })}
                {selectedPaidInvoice.paidAt && (
                  <div className={styles.riFieldItem}>
                    <span className={styles.riFieldLabel}>Paid At</span>
                    <span className={styles.riFieldValue}>
                      {new Date(selectedPaidInvoice.paidAt).toLocaleString()}
                    </span>
                  </div>
                )}
              </div>

              <div className={styles.riModalActions}>
                <button
                  className={styles.riBtnSecondary}
                  onClick={() => {
                    setSelectedPaidInvoice(null);
                    setPreviewDocUrl('');
                    setSelectedDocPreview(null);
                    setInvoiceDocuments([]);
                  }}
                >✕ Close</button>
              </div>
            </div>

            {/* RIGHT — Documents */}
            <div className={styles.riModalRight}>
              <div className={styles.riDocsHeader}>
                <span className={styles.riDocsTitle}>Linked Documents</span>
                <span className={styles.riDocsBadge}>{invoiceDocuments.length}</span>
              </div>

              {invoiceDocuments.length === 0 ? (
                <div className={styles.riDocsEmpty}>
                  <span className={styles.riDocsEmptyIcon}>📄</span>
                  <span>No documents linked to this invoice</span>
                </div>
              ) : (
                <div className={styles.riDocsSplit}>
                  <div className={styles.riDocsList}>
                    {invoiceDocuments.map(doc => (
                      <button
                        key={doc.id}
                        className={`${styles.riDocItem} ${selectedDocPreview?.id===doc.id ? styles.riDocItemActive : ''}`}
                        onClick={() => handleInvoiceDocPreview(doc)}
                      >
                        <div className={styles.riDocItemTitle}>{doc.title}</div>
                        <div className={styles.riDocItemType}>{doc.docType?.replace(/_/g,' ')}</div>
                      </button>
                    ))}
                  </div>
                  <div className={styles.riDocsPreview}>
                    {previewDocUrl ? (
                      (previewDocMime==='application/pdf' || previewDocMime?.startsWith('image/')) ? (
                        <iframe src={previewDocUrl} className={styles.riDocsIframe} title="Doc Preview"/>
                      ) : (
                        <div className={styles.riDocsNoPreview}>Preview not available</div>
                      )
                    ) : (
                      <div className={styles.riDocsNoPreview}>
                        <span>Select a document to preview</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
      </div>,
      document.body
    )}

    {/* Tabel */}
    <table className={styles.invoiceTable}>
      <thead>
        <tr>
          <th>Invoice #</th>
          <th>Company</th>
          <th>Amount</th>
          <th>Paid At</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {paidInvoices.map(inv => (
          <tr
            key={inv._id}
            className={`${styles.invoiceRow} ${styles.paidRow}`}
            onClick={() => {
              setSelectedPaidInvoice(inv);
              setPreviewDocUrl('');
              setSelectedDocPreview(null);
              fetchInvoiceDocuments(inv._id);
            }}
          >
            <td>{inv.invoiceNumber}</td>
            <td>{inv.companyName}</td>
            <td>${inv.rate}</td>
            <td>{inv.paidAt ? new Date(inv.paidAt).toLocaleDateString() : 'No data'}</td>
            <td>{inv.status}</td>
          </tr>
        ))}
      </tbody>
    </table>

  </div>
)}

{activeTab === 'recorded' && (
  <div className={styles.recordedSection}>

    {/* Modal full screen */}
    {selectedRecordedInvoice && createPortal(
      <div className={styles.riModalOverlay}>
       <div className={styles.riModal} data-theme={theme}>

          {/* Header */}
          <div className={styles.riModalHeader}>
            <div className={styles.riModalHeaderLeft}>
              
              <div>
                <div className={styles.riModalTitle}>
                  Invoice Details
                  <span className={styles.riModalTitleNum}>#{selectedRecordedInvoice.invoiceNumber}</span>
                </div>
                <div className={styles.riModalSubtitle}>{selectedRecordedInvoice.companyName}</div>
              </div>
            </div>
            <button
              className={styles.riModalClose}
              onClick={() => {
                setSelectedRecordedInvoice(null);
                setEditingInvoice(false);
                setShowConfirmation(false);
                setPreviewDocUrl('');
                setSelectedDocPreview(null);
                setInvoiceDocuments([]);
              }}
            >✕</button>
          </div>

          {/* Body */}
          <div className={styles.riModalBody}>

            {/* LEFT — Details */}
            <div className={styles.riModalLeft}>
              <div className={styles.riFieldsList}>
                {Object.entries(selectedRecordedInvoice).map(([key, value]) => {
                  if (['_id','clientId','__v','createdAt'].includes(key)) return null;
                  const niceLabel = key.replace(/([A-Z])/g,' $1').replace(/^./,s=>s.toUpperCase());
                  return (
                    <div key={key} className={styles.riFieldItem}>
                      <span className={styles.riFieldLabel}>{niceLabel}</span>
                      {editingInvoice ? (
                        <input
                          className={styles.riFieldInput}
                          type="text"
                          value={editedInvoice[key] ?? ''}
                          onChange={e => setEditedInvoice(prev => ({...prev,[key]:e.target.value}))}
                        />
                      ) : (
                        <span className={styles.riFieldValue}>{value ?? '—'}</span>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Actions */}
              {!showConfirmation ? (
                <div className={styles.riModalActions}>
                  <button
                    className={styles.riBtnSecondary}
                    onClick={() => { setEditedInvoice(selectedRecordedInvoice); setEditingInvoice(p=>!p); }}
                  >
                    {editingInvoice ? 'Cancel Edit' : 'Edit'}
                  </button>
                  <button
                    className={styles.riBtnPrimary}
                    onClick={async () => {
                      if (editingInvoice) {
                        try {
                          await axios.put(`${apiUrl}/received-invoices/${selectedRecordedInvoice._id}`, editedInvoice, config);
                          notify('Invoice updated!','success');
                          setSelectedRecordedInvoice(p=>({...p,...editedInvoice}));
                          setEditingInvoice(false);
                        } catch { notify('Failed to update.','error'); return; }
                      }
                      setShowConfirmation(true);
                    }}
                  >Next →</button>
                </div>
              ) : (
                <div className={styles.riConfirmBox}>
                  <p className={styles.riConfirmText}>Mark this invoice as Paid?</p>
                  <div className={styles.riConfirmActions}>
                    <button
                      className={styles.riBtnSecondary}
                      onClick={() => { setShowConfirmation(false); setEditingInvoice(false); }}
                    >No</button>
                    <button
                      className={styles.riBtnGreen}
                      onClick={async () => {
                        try {
                          await axios.put(`${apiUrl}/received-invoices/${selectedRecordedInvoice._id}/mark-paid`,{},config);
                          notify('Invoice marked as paid!','success');
                          setSelectedRecordedInvoice(null);
                          setEditingInvoice(false);
                          setShowConfirmation(false);
                          setInvoiceDocuments([]);
                          setPreviewDocUrl('');
                          fetchRecordedInvoices();
                        } catch { notify('Failed to mark as paid.','error'); }
                      }}
                    >✓ Yes, Paid</button>
                  </div>
                </div>
              )}
            </div>

            {/* RIGHT — Documents */}
            <div className={styles.riModalRight}>
              <div className={styles.riDocsHeader}>
                <span className={styles.riDocsTitle}>Linked Documents</span>
                <span className={styles.riDocsBadge}>{invoiceDocuments.length}</span>
              </div>

              {invoiceDocuments.length === 0 ? (
                <div className={styles.riDocsEmpty}>
                  <span className={styles.riDocsEmptyIcon}>📄</span>
                  <span>No documents linked to this invoice</span>
                </div>
              ) : (
                <div className={styles.riDocsSplit}>
                  <div className={styles.riDocsList}>
                    {invoiceDocuments.map(doc => (
                      <button
                        key={doc.id}
                        className={`${styles.riDocItem} ${selectedDocPreview?.id===doc.id ? styles.riDocItemActive : ''}`}
                        onClick={() => handleInvoiceDocPreview(doc)}
                      >
                        <div className={styles.riDocItemTitle}>{doc.title}</div>
                        <div className={styles.riDocItemType}>{doc.docType?.replace(/_/g,' ')}</div>
                      </button>
                    ))}
                  </div>
                  <div className={styles.riDocsPreview}>
                    {previewDocUrl ? (
                      (previewDocMime==='application/pdf' || previewDocMime?.startsWith('image/')) ? (
                        <iframe src={previewDocUrl} className={styles.riDocsIframe} title="Doc Preview"/>
                      ) : (
                        <div className={styles.riDocsNoPreview}>Preview not available</div>
                      )
                    ) : (
                      <div className={styles.riDocsNoPreview}>
                      
                        <span>Select a document to preview</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
      </div>,
      document.body
    )}

    {/* Tabel */}
    <table className={styles.invoiceTable}>
      <thead>
        <tr>
          <th>Invoice #</th>
          <th>Company</th>
          <th>Amount</th>
          <th>Due Date</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {recordedInvoices.map(inv => {
          const dueDate  = new Date(inv.dueDate);
          const daysLeft = Math.ceil((dueDate - new Date()) / (1000*60*60*24));
          return (
            <tr
              key={inv._id}
              className={styles.invoiceRow}
              onClick={() => {
                setSelectedRecordedInvoice(inv);
                setShowConfirmation(false);
                setEditingInvoice(false);
                setPreviewDocUrl('');
                setSelectedDocPreview(null);
                fetchInvoiceDocuments(inv._id);
              }}
            >
              <td>{inv.invoiceNumber}</td>
              <td>{inv.companyName}</td>
              <td>${inv.rate}</td>
              <td>
                {inv.dueDate ? new Date(inv.dueDate).toLocaleDateString() : 'No data'}
                {daysLeft <= 3 && <span className={styles.expiringBadge}>Expiring Soon</span>}
              </td>
              <td>{inv.status}</td>
            </tr>
          );
        })}
      </tbody>
    </table>

  </div>
)}
   {activeTab === 'archiving' && (
  <div className={styles.recordedSection}>

    {/* Buton deschide modal */}
    <div className={styles.riArchivingOpenWrap}>
      <button
        className={styles.riBtnPrimary}
        onClick={() => setShowArchivingModal(true)}
      >
        + Archive New Invoice
      </button>
    </div>

    {/* Modal archiving */}
    {showArchivingModal && createPortal(
      <div className={styles.riModalOverlay}>
        <div className={styles.riModal} data-theme={theme}>

          {/* Header */}
          <div className={styles.riModalHeader}>
            <div className={styles.riModalHeaderLeft}>
              
              <div>
                <div className={styles.riModalTitle}>Archive Invoice</div>
                <div className={styles.riModalSubtitle}>Fill in the details and upload the PDF</div>
              </div>
            </div>
            <button
              className={styles.riModalClose}
              onClick={() => setShowArchivingModal(false)}
            >✕</button>
          </div>

          {/* Body — 40% form | 60% PDF */}
          <div className={styles.riModalBody}>

            {/* LEFT — Form */}
            <div className={styles.riModalLeft}>
              <div className={styles.riFieldsList}>
                {[
                  { label: 'Invoice Number',          name: 'invoiceNumber',         type: 'text'   },
                  { label: 'Invoice Date',             name: 'invoiceDate',           type: 'date'   },
                  { label: 'Internal Invoice Number',  name: 'internalInvoiceNumber', type: 'text'   },
                  { label: 'Company Name',             name: 'companyName',           type: 'text'   },
                  { label: 'Company Address',          name: 'companyAddress',        type: 'text'   },
                  { label: 'MC Number',                name: 'mcNumber',              type: 'text'   },
                  { label: 'Description',              name: 'description',           type: 'text'   },
                  { label: 'Rate',                     name: 'rate',                  type: 'number' },
                  { label: 'Due Date',                 name: 'dueDate',               type: 'date'   },
                ].map(({ label, name, type }) => (
                  <div key={name} className={styles.riFieldItem}>
                    <span className={styles.riFieldLabel}>{label}</span>
                    <input
                      className={`${styles.riFieldInput} ${currentPickingField === name ? styles.riFieldInputActive : ''}`}
                      type={type}
                      name={name}
                      value={invoiceData[name]}
                      onChange={handleChange}
                      onClick={() => setCurrentPickingField(name)}
                      placeholder={label}
                    />
                  </div>
                ))}

                <div className={styles.riFieldItem}>
                  <span className={styles.riFieldLabel}>Early Payment Discount</span>
                  <select
                    className={`${styles.riFieldInput} ${currentPickingField === 'earlyPaymentDiscount' ? styles.riFieldInputActive : ''}`}
                    name="earlyPaymentDiscount"
                    value={invoiceData.earlyPaymentDiscount}
                    onChange={handleChange}
                    onClick={() => setCurrentPickingField('earlyPaymentDiscount')}
                  >
                    <option value="No">No</option>
                    <option value="Yes">Yes</option>
                  </select>
                </div>

                <div className={styles.riFieldItem}>
                  <span className={styles.riFieldLabel}>Payment Method</span>
                  <select
                    className={`${styles.riFieldInput} ${currentPickingField === 'paymentMethod' ? styles.riFieldInputActive : ''}`}
                    name="paymentMethod"
                    value={invoiceData.paymentMethod}
                    onChange={handleChange}
                    onClick={() => setCurrentPickingField('paymentMethod')}
                  >
                    <option value="">Select Method</option>
                    <option value="Wire">Wire</option>
                    <option value="ACH">ACH</option>
                    <option value="Check">Check</option>
                    <option value="Credit Card">Credit Card</option>
                  </select>
                </div>
              </div>

              {/* Butoane */}
              <div className={styles.riModalActions}>
                <button
                  className={styles.riBtnSecondary}
                  onClick={() => {
                    resetInvoiceAndNext();
                    notify('Invoice skipped.', 'success');
                  }}
                >Skip</button>
                <button
                  className={styles.riBtnPrimary}
                  onClick={async () => {
                    await handleRecordInvoice();
                    if (pdfQueue.length <= 1) setShowArchivingModal(false);
                  }}
                >✓ Record Invoice</button>
              </div>
            </div>

            {/* RIGHT — PDF */}
            <div className={styles.riModalRight}>
              <div className={styles.riDocsHeader}>
                {pdfQueue.length > 0 && (
                  <span className={styles.riDocsBadge}>{pdfQueue.length} in queue</span>
                )}
              </div>

              {!currentPdf ? (
                <div className={styles.riArchivingUploadArea}>
                  <label className={styles.riArchivingUploadLabel}>
                    <span className={styles.riArchivingUploadIcon}>📂</span>
                    <strong>Drop PDFs here or click to browse</strong>
                    <span className={styles.riArchivingUploadSub}>Supports PDF · Multiple files</span>
                    <input
                      type="file"
                      accept="application/pdf"
                      multiple
                      onChange={handleFileUpload}
                      className={styles.riArchivingUploadInput}
                    />
                  </label>
                </div>
              ) : (
                <div className={styles.riDocsPreview}>
                  <PdfViewerWithSelect
                    fileUrl={currentPdf.url}
                    onSelectText={(selectedText) => {
                      if (!currentPickingField) return;
                      setInvoiceData(prev => ({ ...prev, [currentPickingField]: selectedText }));
                    }}
                  />
                </div>
              )}
            </div>

          </div>
        </div>
      </div>,
      document.body
    )}
  </div>
)}

       <EmailPanel />  
    </div>
  );
};

const BalanceSheet = () => {
  const { notify } = useNotification();
  const [balanceData, setBalanceData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [activeSection, setActiveSection] = useState('overview');
  const [showAddModal, setShowAddModal] = useState(null);
  const [addForm, setAddForm] = useState({ name: '', value: '', note: '' });
  const [manualEntries, setManualEntries] = useState({
    income: [], expense: [], asset: [], liability: []
  });
  const [theme, setTheme] = useState(() => sessionStorage.getItem("theme") || "dark");

  const token = sessionStorage.getItem('token');
  const apiUrl = "https://api-backend.full-trucking-service.com/api";
  const config = { headers: { Authorization: `Bearer ${token}` } };

  useEffect(() => {
    const fetchTheme = async () => {
      try {
        const res = await axios.get(`${apiUrl}/settings`, { headers: { Authorization: `Bearer ${token}` } });
        setTheme(res.data.theme || "dark");
      } catch { setTheme("dark"); }
    };
    fetchTheme();
  }, []);

  const fetchBalanceSheet = async () => {
    setIsLoading(true);
    const query = startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : '';
    try {
      const res = await axios.get(`${apiUrl}/balance-sheet/summary${query}`, config);
      setBalanceData(res.data);
    } catch { notify("Failed to load balance sheet", "error"); }
    finally { setIsLoading(false); }
  };

  useEffect(() => { fetchBalanceSheet(); }, []);

  const isLight = theme === "light";

  const t = {
    bg:          isLight ? "#F1F0EB" : "#07070C",
    card:        isLight ? "#FFFFFF" : "#0C0C18",
    card2:       isLight ? "#F9F8F5" : "#0F0F1C",
    border:      isLight ? "rgba(0,0,0,0.08)" : "rgba(255,255,255,0.07)",
    text:        isLight ? "#111827" : "#EEEEF2",
    text2:       isLight ? "#6B7280" : "#9494A8",
    muted:       isLight ? "#9CA3AF" : "#52526A",
    amber:       "#F59E0B",
    amberBright: "#FBBF24",
    amberDim:    isLight ? "rgba(245,158,11,0.08)" : "rgba(245,158,11,0.10)",
    amberBorder: "rgba(245,158,11,0.25)",
    green:       "#34D399",
    red:         "#F87171",
    blue:        "#60A5FA",
    purple:      "#A78BFA",
    orange:      "#FB923C",
  };

  // ── CALCULE CORECTE ──────────────────────────────────────────────────────────

  const d = balanceData || {};

  // ── VENITURI (INCOME) ────────────────────────────────────────────────────────
  // Toate veniturile din loads/invoices sunt ale companiei
  const paidInvoices        = d.paidInvoicesTotal || 0;
  const paidLoads           = d.incomeLoadsTotal || 0;
  const invoicedUnpaid      = d.invoicedUnpaidTotal || 0;
  const openInvoicesTotal   = d.openInvoicesTotal || 0;
  const manualIncomeTotal   = manualEntries.income.reduce((s, e) => s + parseFloat(e.value || 0), 0);

  const totalRevenuePaid    = paidInvoices + paidLoads + manualIncomeTotal;
  const totalRevenueUnpaid  = invoicedUnpaid + openInvoicesTotal;
  const totalRevenue        = totalRevenuePaid + totalRevenueUnpaid;

  // ── COMPANY DRIVERS (employee) ───────────────────────────────────────────────
  // Cheltuielile company drivers = 100% cheltuieli ale companiei
  const companyDriverPayroll  = d.companyDriverPayTotal || 0;
  // Additions din DriverPay pentru company drivers = bonus platit de companie
  const companyDriverAdditions = d.companyDriverAdditionsTotal || 0;
  // Deductions din DriverPay pt company drivers = bani retinuti de companie (reduc cheltuiala neta)
  const companyDriverDeductions = d.companyDriverDeductionsTotal || 0;

  // Fuel pentru company trucks (owner = compania)
  const companyTruckFuel    = d.companyTruckFuelTotal || d.fuelTotal || 0;

  // Cheltuieli directe pe truck/trailer al companiei (din AssetCosts tip deduction)
  const companyTruckCosts   = d.companyTruckAssetCosts || 0;
  const companyTrailerCosts  = d.companyTrailerAssetCosts || 0;
  const companyDriverCosts  = d.companyDriverAssetCosts || 0;

  // Maintenance companie (din serviceHistory pe trucks al companiei)
  const companyMaintenance  = d.companyMaintenanceTotal || 0;

  // Employee payroll (non-driver staff)
  const employeePayroll     = d.employerPayrollTotal || 0;

  // IFTA platit pentru vehiculele companiei
  const iftaPaid            = d.iftaPaidTotal || 0;

  const manualExpenseTotal  = manualEntries.expense.reduce((s, e) => s + parseFloat(e.value || 0), 0);

  const totalCompanyExpenses =
    companyDriverPayroll +
    companyDriverAdditions -
    companyDriverDeductions +
    companyTruckFuel +
    companyTruckCosts +
    companyTrailerCosts +
    companyDriverCosts +
    companyMaintenance +
    employeePayroll +
    iftaPaid +
    manualExpenseTotal;

  // ── OWNER OPERATORS ──────────────────────────────────────────────────────────
  // OO au settlement-ul lor (ex: 90% din load) = bani care ies din venituri la OO
  // Compania retine diferenta (ex: 10%) = venitul companiei din OO
  // Cheltuielile OO (fuel, assetCosts pe truckul lor) sunt ALE LOR, nu ale companiei

  const ooGrossRevenue      = d.ownerOperatorGrossRevenue || 0; // total loads facturate de OO
  const ooSettlementPaid    = d.ownerOperatorSettlementTotal || 0; // cat platim OO (ex: 90%)
  const ooCompanyRetained   = d.ownerOperatorCompanyRetained || 0; // cat retine compania (ex: 10%)
  const ooSettlementPercent = d.ownerOperatorSettlementPercent || 90; // % platit OO

  // Deductions si additions pe OO (din DriverPay, din AssetCosts) = ale OO, nu ale companiei
  const ooDeductions        = d.ownerOperatorDeductionsTotal || 0;
  const ooAdditions         = d.ownerOperatorAdditionsTotal || 0;
  const ooFuelCosts         = d.ownerOperatorFuelTotal || 0; // fuel pe truckurile OO
  const ooAssetCosts        = d.ownerOperatorAssetCosts || 0; // assetcosts pe truckurile OO

  // Net OO (dupa deductions/additions) — informativ, nu e cheltuiala companiei
  const ooNetPaid           = ooSettlementPaid - ooDeductions + ooAdditions;

  // ── ASSETS ──────────────────────────────────────────────────────────────────
  // Doar activele companiei
  const companyTruckValue   = d.companyTrucksTotalCost || d.trucksTotalCost || 0;
  const companyTrailerValue = d.companyTrailersTotalCost || d.trailersTotalCost || 0;
  const receivablesTotal    = d.receivedPaidTotal || 0;
  const manualAssetTotal    = manualEntries.asset.reduce((s, e) => s + parseFloat(e.value || 0), 0);

  const totalAssets         = companyTruckValue + companyTrailerValue + receivablesTotal + totalRevenuePaid + manualAssetTotal;

  // ── LIABILITIES ─────────────────────────────────────────────────────────────
  const iftaUnpaid          = d.iftaUnpaidTotal || 0;
  const brokerDebts         = d.liabilitiesTotal || 0;
  const manualLiabilityTotal = manualEntries.liability.reduce((s, e) => s + parseFloat(e.value || 0), 0);

  const totalLiabilities    = iftaUnpaid + brokerDebts + manualLiabilityTotal;

  // ── PROFIT & LOSS ────────────────────────────────────────────────────────────
  // Venitul companiei = totalRevenuePaid (loads/invoices platite)
  //                   + ooCompanyRetained (retentia din OO)
  //                   - ooSettlementPaid (ce platim OO)
  const companyNetRevenue   = totalRevenuePaid + ooCompanyRetained - ooSettlementPaid;

  const grossProfit         = companyNetRevenue - totalCompanyExpenses;
  const netWorth            = totalAssets - totalLiabilities;
  const projectedBalance    = grossProfit + totalRevenueUnpaid;

  const profitMargin        = companyNetRevenue > 0
    ? ((grossProfit / companyNetRevenue) * 100).toFixed(1) : "0.0";
  const operatingRatio      = companyNetRevenue > 0
    ? ((totalCompanyExpenses / companyNetRevenue) * 100).toFixed(1) : "0.0";

  // ── FORMAT ──────────────────────────────────────────────────────────────────
  const fmt = (n) => `$${parseFloat(n || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2, maximumFractionDigits: 2
  })}`;

  const pct = (n, total) => total > 0
    ? `${((parseFloat(n || 0) / total) * 100).toFixed(1)}%` : "—";

  // ── COMPONENTE UI ────────────────────────────────────────────────────────────

  const KPICard = ({ label, value, color, sub, note }) => (
    <div style={{
      background: t.card,
      border: `1px solid ${t.border}`,
      borderTop: `3px solid ${color}`,
      borderRadius: 12,
      padding: "16px 18px",
      flex: 1,
      minWidth: 150,
    }}>
      <div style={{ fontSize: 9, fontFamily: "'Barlow Condensed',sans-serif", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: t.text2, marginBottom: 8 }}>{label}</div>
      <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "1.7rem", fontWeight: 800, color, lineHeight: 1 }}>{value}</div>
      {sub && <div style={{ fontSize: 11, color: t.muted, marginTop: 6 }}>{sub}</div>}
      {note && <div style={{ fontSize: 10, color: color, marginTop: 4, fontWeight: 600 }}>{note}</div>}
    </div>
  );

  const Divider = ({ label }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 10, margin: "20px 0 14px" }}>
      <div style={{ flex: 1, height: 1, background: t.border }} />
      <span style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "0.65rem", fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: t.muted }}>{label}</span>
      <div style={{ flex: 1, height: 1, background: t.border }} />
    </div>
  );

  const InfoBox = ({ color, label, children }) => (
    <div style={{
      background: `${color}08`,
      border: `1px solid ${color}22`,
      borderLeft: `3px solid ${color}`,
      borderRadius: 10,
      padding: "12px 16px",
      marginBottom: 16,
      fontSize: "0.82rem",
      color: t.text2,
      lineHeight: 1.7,
    }}>
      {label && <strong style={{ color, display: "block", marginBottom: 4, fontFamily: "'Barlow Condensed',sans-serif", fontSize: "0.75rem", letterSpacing: "0.08em", textTransform: "uppercase" }}>{label}</strong>}
      {children}
    </div>
  );

  const SectionTable = ({ title, color, rows, total, onAdd, note }) => (
    <div style={{
      background: t.card,
      border: `1px solid ${t.border}`,
      borderRadius: 14,
      overflow: "hidden",
      marginBottom: 16,
    }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "13px 20px",
        borderBottom: `1px solid ${t.border}`,
        background: `${color}06`,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ width: 3, height: 14, background: color, borderRadius: 2, display: "inline-block" }} />
          <span style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "0.82rem", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color }}>
            {title}
          </span>
          {note && <span style={{ fontSize: 10, color: t.muted, fontStyle: "italic" }}>— {note}</span>}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "1rem", fontWeight: 800, color }}>{fmt(total)}</span>
          {onAdd && (
            <button onClick={onAdd} style={{
              padding: "4px 12px", borderRadius: 100, border: `1px solid ${color}44`,
              background: `${color}11`, color, fontFamily: "'Barlow Condensed',sans-serif",
              fontSize: "0.68rem", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", cursor: "pointer",
            }}>+ Add</button>
          )}
        </div>
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: isLight ? "rgba(0,0,0,0.018)" : "rgba(255,255,255,0.018)" }}>
            {["Description", "Source / Note", "Amount", "% of Total"].map(h => (
              <th key={h} style={{
                padding: "7px 18px",
                textAlign: h === "Amount" || h === "% of Total" ? "right" : "left",
                fontFamily: "'Barlow Condensed',sans-serif",
                fontSize: "0.62rem", fontWeight: 700, letterSpacing: "0.1em",
                textTransform: "uppercase", color: t.muted,
                borderBottom: `1px solid ${t.border}`,
              }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} style={{
              borderBottom: i < rows.length - 1 ? `1px solid ${t.border}` : "none",
              background: row.highlight ? `${color}05` : row.subtotal ? (isLight ? "rgba(0,0,0,0.025)" : "rgba(255,255,255,0.025)") : "transparent",
            }}>
              <td style={{ padding: "9px 18px", color: row.subtotal ? t.text : t.text, fontSize: row.subtotal ? "0.8rem" : "0.855rem", fontWeight: row.bold || row.subtotal ? 700 : 400 }}>
                {row.name}
                {row.badge && (
                  <span style={{
                    marginLeft: 7, padding: "1px 7px", borderRadius: 100, fontSize: "0.6rem",
                    fontWeight: 700, background: `${row.badgeColor || color}20`,
                    color: row.badgeColor || color, textTransform: "uppercase", letterSpacing: "0.06em",
                  }}>{row.badge}</span>
                )}
              </td>
              <td style={{ padding: "9px 18px", color: t.muted, fontSize: "0.78rem" }}>{row.source || "—"}</td>
              <td style={{ padding: "9px 18px", textAlign: "right", fontFamily: "'Barlow Condensed',sans-serif", fontSize: row.subtotal ? "0.9rem" : "0.9rem", fontWeight: row.bold || row.subtotal ? 700 : 600, color: row.valueColor || t.text }}>
                {row.negative ? `(${fmt(Math.abs(row.value))})` : fmt(row.value)}
              </td>
              <td style={{ padding: "9px 18px", textAlign: "right", color: t.muted, fontSize: "0.78rem" }}>
                {row.subtotal ? "" : pct(Math.abs(row.value || 0), total)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  // ── ROWS DATA ────────────────────────────────────────────────────────────────

  const incomeRows = [
    { name: "Paid Invoices", source: "Invoices module", value: paidInvoices, badge: "Confirmed", badgeColor: t.green },
    { name: "Direct Paid Loads", source: "Loads module", value: paidLoads, badge: "Confirmed", badgeColor: t.green },
    { name: "Invoiced — Awaiting Payment", source: "Invoices module", value: invoicedUnpaid, badge: "Pending", badgeColor: t.amber },
    { name: "Open Loads — Not Yet Invoiced", source: "Loads module", value: openInvoicesTotal, badge: "Projected", badgeColor: t.blue },
    { name: "Owner Operator — Company Retained", source: `${100 - ooSettlementPercent}% of OO loads`, value: ooCompanyRetained, badge: "OO Retention", badgeColor: t.purple },
    ...manualEntries.income.map(e => ({ name: e.name, source: e.note || "Manual entry", value: e.value, badge: "Manual", badgeColor: t.orange })),
  ];

  const companyExpenseRows = [
    // Company Drivers
    { name: "Company Driver Payroll (Gross)", source: "DriverPay — employee drivers", value: companyDriverPayroll, badge: "Company Driver", badgeColor: t.amber },
    { name: "Company Driver Additions", source: "DriverPay additions", value: companyDriverAdditions, badge: "Bonus/Addition", badgeColor: t.orange },
    { name: "Company Driver Deductions (credit)", source: "DriverPay deductions", value: companyDriverDeductions, negative: true, valueColor: t.green, badge: "Deduction", badgeColor: t.green },
    // Fuel
    { name: "Fuel — Company Trucks", source: "Fuel Reports (company-owned trucks)", value: companyTruckFuel, badge: "Fuel", badgeColor: t.red },
    // Asset Costs
    { name: "Truck Asset Costs (deductions)", source: "AssetCosts — company trucks", value: companyTruckCosts, badge: "Asset Cost", badgeColor: t.red },
    { name: "Trailer Asset Costs (deductions)", source: "AssetCosts — company trailers", value: companyTrailerCosts, badge: "Asset Cost", badgeColor: t.red },
    { name: "Driver Asset Costs (deductions)", source: "AssetCosts — company drivers", value: companyDriverCosts, badge: "Asset Cost", badgeColor: t.red },
    // Maintenance
    { name: "Maintenance — Company Fleet", source: "Truck service history (company owner)", value: companyMaintenance, badge: "Maintenance", badgeColor: t.orange },
    // Staff
    { name: "Employee / Staff Payroll", source: "Payroll — non-driver employees", value: employeePayroll, badge: "Staff", badgeColor: t.blue },
    // IFTA
    { name: "IFTA Tax Paid", source: "IFTA — company vehicles", value: iftaPaid, badge: "Tax", badgeColor: t.purple },
    // OO Settlement
    { name: "Owner Operator Settlement Paid", source: `${ooSettlementPercent}% of OO loads paid out`, value: ooSettlementPaid, badge: "OO Payout", badgeColor: t.purple },
    ...manualEntries.expense.map(e => ({ name: e.name, source: e.note || "Manual entry", value: e.value, badge: "Manual", badgeColor: t.orange })),
  ];

  const assetRows = [
    { name: "Company Trucks (Book Value / Purchase Cost)", source: "Trucks — owner = company", value: companyTruckValue },
    { name: "Company Trailers (Book Value / Purchase Cost)", source: "Trailers — owner = company", value: companyTrailerValue },
    { name: "Accounts Receivable (Received Invoices Paid)", source: "Received Invoices", value: receivablesTotal },
    { name: "Confirmed Revenue (Paid Invoices + Loads)", source: "Realized cash inflow", value: totalRevenuePaid, highlight: true, bold: true, valueColor: t.green },
    ...manualEntries.asset.map(e => ({ name: e.name, source: e.note || "Manual entry", value: e.value, badge: "Manual", badgeColor: t.orange })),
  ];

  const liabilityRows = [
    { name: "IFTA Tax Unpaid", source: "IFTA — unpaid returns", value: iftaUnpaid, badge: "Tax Due", badgeColor: t.red },
    { name: "Broker / Supplier Debts", source: "Received Invoices (recorded obligations)", value: brokerDebts },
    ...manualEntries.liability.map(e => ({ name: e.name, source: e.note || "Manual entry", value: e.value, badge: "Manual", badgeColor: t.orange })),
  ];

  const ooInfoRows = [
    { name: "OO Gross Revenue (all OO loads)", source: "Loads — owner operator drivers", value: ooGrossRevenue },
    { name: `OO Settlement Paid (${ooSettlementPercent}%)`, source: "DriverPay — OO drivers", value: ooSettlementPaid, valueColor: t.red },
    { name: `Company Retained (${100 - ooSettlementPercent}%)`, source: "Retained by company from OO loads", value: ooCompanyRetained, valueColor: t.green, bold: true },
    { name: "OO Deductions (charged to OO)", source: "DriverPay deductions — OO", value: ooDeductions, badge: "OO Charge" },
    { name: "OO Additions (paid to OO extra)", source: "DriverPay additions — OO", value: ooAdditions, badge: "OO Extra" },
    { name: "OO Fuel Costs (their expense)", source: "Fuel Reports — OO trucks", value: ooFuelCosts, badge: "OO Expense", badgeColor: t.orange },
    { name: "OO Asset Costs (their expense)", source: "AssetCosts — OO trucks/drivers", value: ooAssetCosts, badge: "OO Expense", badgeColor: t.orange },
    { name: "OO Net Paid (after adjustments)", source: "Settlement - Deductions + Additions", value: ooNetPaid, bold: true, valueColor: t.purple },
  ];

  // ── TABS ─────────────────────────────────────────────────────────────────────
  const tabs = [
    { id: "overview", label: "Overview" },
    { id: "income", label: "Revenue & Income" },
    { id: "expenses", label: "Company Expenses" },
    { id: "ownerops", label: "Owner Operators" },
    { id: "assets", label: "Assets" },
    { id: "liabilities", label: "Liabilities" },
  ];

  // ── EXPORT PDF ───────────────────────────────────────────────────────────────
  const exportToPDF = () => {
    const doc = new jsPDF();
    const W = 210, M = 14;
    let y = 0;

    // Background
    doc.setFillColor(7, 7, 12);
    doc.rect(0, 0, W, 297, "F");

    // Header bar
    doc.setFillColor(245, 158, 11);
    doc.rect(0, 0, W, 24, "F");
    doc.setTextColor(7, 7, 12);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("BALANCE SHEET — FULL TRUCKING SERVICE", W / 2, 15, { align: "center" });

    doc.setFillColor(18, 18, 30);
    doc.rect(0, 24, W, 10, "F");
    doc.setTextColor(148, 163, 184);
    doc.setFontSize(7.5);
    doc.text(
      `Period: ${startDate || "All time"} to ${endDate || "Present"}   |   Generated: ${new Date().toLocaleDateString("en-US")}`,
      W / 2, 30, { align: "center" }
    );

    y = 40;

    // KPI Grid
    const kpis = [
      ["Gross Revenue", fmt(totalRevenue)],
      ["Company Net Revenue", fmt(companyNetRevenue)],
      ["Total Expenses", fmt(totalCompanyExpenses)],
      ["Net Profit", fmt(grossProfit)],
      ["Profit Margin", `${profitMargin}%`],
      ["Operating Ratio", `${operatingRatio}%`],
      ["Total Assets", fmt(totalAssets)],
      ["Total Liabilities", fmt(totalLiabilities)],
      ["Net Worth", fmt(netWorth)],
    ];

    const cols = 3;
    const boxW = (W - M * 2 - (cols - 1) * 4) / cols;
    const boxH = 16;

    kpis.forEach(([label, val], i) => {
      const col = i % cols;
      const row = Math.floor(i / cols);
      const x = M + col * (boxW + 4);
      const yy = y + row * (boxH + 3);
      doc.setFillColor(16, 16, 26);
      doc.roundedRect(x, yy, boxW, boxH, 1.5, 1.5, "F");
      doc.setTextColor(100, 100, 120);
      doc.setFontSize(6);
      doc.setFont("helvetica", "normal");
      doc.text(label.toUpperCase(), x + 3, yy + 6);
      doc.setTextColor(245, 158, 11);
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.text(val, x + 3, yy + 13);
    });

    y += Math.ceil(kpis.length / cols) * (boxH + 3) + 8;

    // Section helper
    const addSection = (title, rows, total, rgb) => {
      if (y > 240) { doc.addPage(); doc.setFillColor(7, 7, 12); doc.rect(0, 0, W, 297, "F"); y = 14; }
      doc.setFillColor(...rgb);
      doc.rect(M, y, W - M * 2, 6, "F");
      doc.setTextColor(7, 7, 12);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7.5);
      doc.text(title.toUpperCase(), M + 3, y + 4.5);
      doc.setTextColor(7, 7, 12);
      doc.text(fmt(total), W - M - 3, y + 4.5, { align: "right" });

      doc.autoTable({
        startY: y + 6,
        head: [["Description", "Source", "Amount", "%"]],
        body: rows.map(r => [
          r.name,
          r.source || "—",
          r.negative ? `(${fmt(Math.abs(r.value))})` : fmt(r.value),
          total > 0 ? pct(Math.abs(r.value || 0), total) : "—",
        ]),
        theme: "plain",
        styles: { fontSize: 7, textColor: [190, 190, 205], fillColor: [11, 11, 20], cellPadding: 2 },
        headStyles: { fillColor: [18, 18, 32], textColor: [90, 90, 110], fontSize: 6, fontStyle: "bold" },
        alternateRowStyles: { fillColor: [14, 14, 24] },
        columnStyles: { 2: { halign: "right" }, 3: { halign: "right" } },
        margin: { left: M, right: M },
      });
      y = doc.lastAutoTable.finalY + 7;
    };

    addSection("Revenue & Income", incomeRows, totalRevenue, [245, 158, 11]);
    addSection("Company Expenses", companyExpenseRows, totalCompanyExpenses, [239, 68, 68]);
    addSection("Owner Operator Detail (Informational)", ooInfoRows, ooGrossRevenue, [167, 139, 250]);
    addSection("Assets (Company)", assetRows, totalAssets, [52, 211, 153]);
    addSection("Liabilities", liabilityRows, totalLiabilities, [248, 113, 113]);

    // Net summary box
    if (y > 220) { doc.addPage(); doc.setFillColor(7, 7, 12); doc.rect(0, 0, W, 297, "F"); y = 14; }
    doc.setFillColor(14, 14, 26);
    doc.roundedRect(M, y, W - M * 2, 40, 2, 2, "F");
    doc.setDrawColor(245, 158, 11);
    doc.setLineWidth(0.5);
    doc.roundedRect(M, y, W - M * 2, 40, 2, 2, "S");

    const netItems = [
      ["Company Net Revenue", fmt(companyNetRevenue), [245, 158, 11]],
      ["Total Company Expenses", fmt(totalCompanyExpenses), [248, 113, 113]],
      ["Net Profit (Realized)", fmt(grossProfit), grossProfit >= 0 ? [52, 211, 153] : [248, 113, 113]],
      ["Projected (If All Paid)", fmt(projectedBalance), [96, 165, 250]],
      ["Net Worth (Assets - Liabilities)", fmt(netWorth), netWorth >= 0 ? [52, 211, 153] : [248, 113, 113]],
    ];

    netItems.forEach(([label, val, rgb], i) => {
      const x = M + 5;
      const yy = y + 7 + i * 7;
      doc.setTextColor(110, 110, 130);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text(label, x, yy);
      doc.setTextColor(...rgb);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(val, W - M - 5, yy, { align: "right" });
    });

    // Footer
    const pH = doc.internal.pageSize.height;
    doc.setFillColor(245, 158, 11);
    doc.rect(0, pH - 9, W, 9, "F");
    doc.setTextColor(7, 7, 12);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(6.5);
    doc.text("Full Trucking Service — Confidential Financial Report", W / 2, pH - 3.5, { align: "center" });

    doc.save(`FTS_BalanceSheet_${Date.now()}.pdf`);
  };

 const exportFullDetailsToExcel = async () => {
  const query = startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : '';
  try {
    const res = await axios.get(`${apiUrl}/balance-sheet/full-details${query}`, config);
    const data = res.data;
    const wb = XLSX.utils.book_new();

    // ── Summary sheet ────────────────────────────────────────────────────────
    const summaryWs = XLSX.utils.aoa_to_sheet([
      ["FTS Balance Sheet — Full Report"],
      ["Period", `${startDate || "All time"} to ${endDate || "Present"}`],
      ["Generated", new Date().toLocaleDateString("en-US")],
      [],
      ["METRIC", "VALUE", "NOTES"],
      ["Gross Revenue (all loads + invoices)", totalRevenue.toFixed(2), "Includes unconfirmed"],
      ["Company Net Revenue", companyNetRevenue.toFixed(2), "After OO settlement paid out"],
      ["Paid Revenue (confirmed)", totalRevenuePaid.toFixed(2), ""],
      ["Unpaid / Projected Revenue", totalRevenueUnpaid.toFixed(2), "Pending invoices + open loads"],
      [],
      ["COMPANY EXPENSES", "", ""],
      ["Company Driver Payroll", (d.companyDriverPayTotal || 0).toFixed(2), "Employee drivers only"],
      ["Company Driver Additions", (d.companyDriverAdditionsTotal || 0).toFixed(2), "Bonuses etc."],
      ["Company Driver Deductions (credit)", `(${(d.companyDriverDeductionsTotal || 0).toFixed(2)})`, "Reduces net payroll"],
      ["Fuel — Company Trucks", (d.companyTruckFuelTotal || d.fuelTotal || 0).toFixed(2), "Owner = company"],
      ["Truck Asset Costs", (d.companyTruckAssetCosts || 0).toFixed(2), "AssetCosts on company trucks"],
      ["Trailer Asset Costs", (d.companyTrailerAssetCosts || 0).toFixed(2), ""],
      ["Driver Asset Costs", (d.companyDriverAssetCosts || 0).toFixed(2), ""],
      ["Maintenance — Company Fleet", (d.companyMaintenanceTotal || 0).toFixed(2), "Service history"],
      ["Employee / Staff Payroll", (d.employerPayrollTotal || 0).toFixed(2), "Non-driver staff"],
      ["IFTA Tax Paid", (d.iftaPaidTotal || 0).toFixed(2), ""],
      ["OO Settlement Paid", (d.ownerOperatorSettlementTotal || 0).toFixed(2), `${d.ownerOperatorSettlementPercent || 90}% paid to OO`],
      ["TOTAL COMPANY EXPENSES", totalCompanyExpenses.toFixed(2), ""],
      [],
      ["OWNER OPERATOR (Informational)", "", ""],
      ["OO Gross Revenue", (d.ownerOperatorGrossRevenue || 0).toFixed(2), "Total loads by OO drivers"],
      ["OO Settlement Paid", (d.ownerOperatorSettlementTotal || 0).toFixed(2), "Paid to OO"],
      ["Company Retained from OO", (d.ownerOperatorCompanyRetained || 0).toFixed(2), "Company income from OO"],
      ["OO Deductions (charged to OO)", (d.ownerOperatorDeductionsTotal || 0).toFixed(2), "Not company expense"],
      ["OO Additions (to OO)", (d.ownerOperatorAdditionsTotal || 0).toFixed(2), "Not company expense"],
      ["OO Fuel (OO expense)", (d.ownerOperatorFuelTotal || 0).toFixed(2), "Not company expense"],
      ["OO Asset Costs (OO expense)", (d.ownerOperatorAssetCosts || 0).toFixed(2), "Not company expense"],
      [],
      ["PROFIT & LOSS", "", ""],
      ["Net Profit (Realized)", grossProfit.toFixed(2), ""],
      ["Projected Balance", projectedBalance.toFixed(2), "If all pending invoices paid"],
      ["Profit Margin %", profitMargin + "%", ""],
      ["Operating Ratio %", operatingRatio + "%", ""],
      [],
      ["BALANCE SHEET", "", ""],
      ["Total Assets", totalAssets.toFixed(2), "Company assets only"],
      ["Total Liabilities", totalLiabilities.toFixed(2), ""],
      ["Net Worth", netWorth.toFixed(2), "Assets - Liabilities"],
    ]);
    XLSX.utils.book_append_sheet(wb, summaryWs, "Summary");

    const addSheet = (title, items) => {
      if (!items?.length) return;
      const ws = XLSX.utils.json_to_sheet(items);
      const cols = Object.keys(items[0]).map(k => ({ wch: Math.max(k.length, 14) }));
      ws['!cols'] = cols;
      XLSX.utils.book_append_sheet(wb, ws, title.slice(0, 31));
    };

    addSheet("Loads",            data.loads);
    addSheet("Invoices",         data.invoices);
    addSheet("ReceivedInvoices", data.receivedInvoices);
    addSheet("FuelReports",      data.fuelReports);
    addSheet("DriverPays",       data.driverPays);
    addSheet("Drivers",          data.drivers);
    addSheet("IFTA",             data.ifta);
    addSheet("Employees",        data.employees);
    addSheet("Trucks",           data.trucks);
    addSheet("Trailers",         data.trailers);
    if (data.assetCosts?.length) addSheet("AssetCosts", data.assetCosts);

    XLSX.writeFile(wb, `FTS_BalanceSheet_${Date.now()}.xlsx`);
  } catch (err) {
    console.error("Export failed:", err);
    notify("Export failed", "error");
  }
};

  // ── ADD MANUAL ───────────────────────────────────────────────────────────────
  const handleAddManual = () => {
    const val = parseFloat(addForm.value);
    if (!addForm.name || isNaN(val) || val <= 0) {
      notify("Please complete all fields with valid values.", "error");
      return;
    }
    setManualEntries(prev => ({
      ...prev,
      [showAddModal]: [...prev[showAddModal], { name: addForm.name, value: val, note: addForm.note }],
    }));
    setAddForm({ name: '', value: '', note: '' });
    setShowAddModal(null);
    notify("Manual entry added.", "success");
  };

  // ── RENDER ───────────────────────────────────────────────────────────────────
  return (
    <div style={{
      minHeight: "100vh",
      background: t.bg,
      paddingTop: 90,
      paddingBottom: 60,
      fontFamily: "'DM Sans', sans-serif",
      color: t.text,
      boxSizing: "border-box",
    }}>

      {/* HEADER */}
      <div style={{ maxWidth: 1160, margin: "0 auto", padding: "0 24px 24px" }}>
        <p style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "0.7rem", fontWeight: 700, letterSpacing: "0.16em", textTransform: "uppercase", color: t.amber, margin: "0 0 4px" }}>
          Financial Statement
        </p>
        <h1 style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "2.6rem", fontWeight: 800, letterSpacing: "0.04em", textTransform: "uppercase", color: t.text, margin: 0, lineHeight: 1 }}>
          Balance Sheet
        </h1>
        <div style={{ width: 48, height: 3, background: `linear-gradient(90deg,${t.amber},transparent)`, marginTop: 10, borderRadius: 2 }} />

        {/* Controls */}
        <div style={{ display: "flex", gap: 12, marginTop: 20, alignItems: "flex-end", flexWrap: "wrap" }}>
          {[["Start Date", startDate, setStartDate], ["End Date", endDate, setEndDate]].map(([label, val, setter]) => (
            <div key={label}>
              <div style={{ fontSize: "0.62rem", fontFamily: "'Barlow Condensed',sans-serif", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: t.text2, marginBottom: 4 }}>{label}</div>
              <input type="date" value={val} onChange={e => setter(e.target.value)} style={{
                padding: "8px 12px", borderRadius: 8, border: `1px solid ${t.border}`,
                background: t.card, color: t.text, fontFamily: "'DM Sans',sans-serif",
                fontSize: "0.875rem", outline: "none", colorScheme: isLight ? "light" : "dark",
              }} />
            </div>
          ))}
          {[
            { label: "Refresh", onClick: fetchBalanceSheet, style: { border: `1px solid ${t.amberBorder}`, background: t.amberDim, color: t.amberBright } },
            { label: "Export PDF", onClick: exportToPDF, style: { border: "none", background: "linear-gradient(135deg,#FBBF24,#F59E0B)", color: "#07070C", boxShadow: "0 4px 14px rgba(245,158,11,0.3)" } },
            { label: "Full Excel", onClick: exportFullDetailsToExcel, style: { border: `1px solid rgba(52,211,153,0.3)`, background: `rgba(52,211,153,0.1)`, color: t.green } },
          ].map(btn => (
            <button key={btn.label} onClick={btn.onClick} style={{
              padding: "9px 20px", borderRadius: 100, cursor: "pointer",
              fontFamily: "'Barlow Condensed',sans-serif", fontSize: "0.8rem",
              fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", ...btn.style,
            }}>{btn.label}</button>
          ))}
        </div>
      </div>

      {isLoading ? (
        <div style={{ textAlign: "center", padding: "80px 0", color: t.text2, fontStyle: "italic" }}>
          Loading financial data...
        </div>
      ) : (
        <div style={{ maxWidth: 1160, margin: "0 auto", padding: "0 24px" }}>

          {/* KPI CARDS */}
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 24 }}>
            <KPICard label="Gross Revenue" value={fmt(totalRevenue)} color={t.amber} sub={`Confirmed: ${fmt(totalRevenuePaid)}`} />
            <KPICard label="Company Net Revenue" value={fmt(companyNetRevenue)} color={t.green} sub="After OO payouts" />
            <KPICard label="Total Expenses" value={fmt(totalCompanyExpenses)} color={t.red} sub={`OR: ${operatingRatio}%`} />
            <KPICard label="Net Profit" value={fmt(grossProfit)} color={grossProfit >= 0 ? t.green : t.red} sub={`Margin: ${profitMargin}%`} note={grossProfit < 0 ? "Operating at a loss" : ""} />
            <KPICard label="Projected" value={fmt(projectedBalance)} color={t.blue} sub="If all invoices paid" />
            <KPICard label="Net Worth" value={fmt(netWorth)} color={t.purple} sub="Assets minus Liabilities" />
          </div>

          {/* P&L SUMMARY */}
          <div style={{ background: t.card, border: `1px solid ${t.border}`, borderRadius: 14, padding: "20px 22px", marginBottom: 22, position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: "10%", width: "80%", height: 1, background: `linear-gradient(90deg,transparent,${t.amber},transparent)`, opacity: 0.4 }} />
            <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "0.68rem", fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: t.text2, marginBottom: 14 }}>
              Profit & Loss Summary
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(190px,1fr))", gap: 12 }}>
              {[
                { label: "Gross Revenue", value: fmt(totalRevenue), note: "All invoiced loads + invoices", color: t.amber },
                { label: "Confirmed Income", value: fmt(totalRevenuePaid), note: "Actually paid / received", color: t.green },
                { label: "Pending Income", value: fmt(totalRevenueUnpaid), note: "Awaiting payment", color: t.blue },
                { label: "Company Net Revenue", value: fmt(companyNetRevenue), note: "After OO settlement paid out", color: t.green },
                { label: "Company Expenses ", value: fmt(totalCompanyExpenses), note: "All company costs", color: t.red },
                { label: "Net Profit", value: fmt(grossProfit), note: `Margin: ${profitMargin}% | OR: ${operatingRatio}%`, color: grossProfit >= 0 ? t.green : t.red },
              ].map((item, i) => (
                <div key={i} style={{ padding: "12px 14px", background: isLight ? "rgba(0,0,0,0.02)" : "rgba(255,255,255,0.022)", border: `1px solid ${t.border}`, borderLeft: `3px solid ${item.color}`, borderRadius: 9 }}>
                  <div style={{ fontSize: 9, color: t.muted, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 4 }}>{item.label}</div>
                  <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "1.25rem", fontWeight: 800, color: item.color }}>{item.value}</div>
                  <div style={{ fontSize: 9.5, color: t.muted, marginTop: 3 }}>{item.note}</div>
                </div>
              ))}
            </div>
          </div>

          {/* TABS */}
          <div style={{ display: "flex", gap: 6, marginBottom: 18, flexWrap: "wrap" }}>
            {tabs.map(tab => (
              <button key={tab.id} onClick={() => setActiveSection(tab.id)} style={{
                padding: "7px 16px", borderRadius: 100, cursor: "pointer",
                border: `1px solid ${activeSection === tab.id ? t.amberBorder : t.border}`,
                background: activeSection === tab.id ? t.amberDim : "transparent",
                color: activeSection === tab.id ? t.amberBright : t.text2,
                fontFamily: "'Barlow Condensed',sans-serif", fontSize: "0.78rem",
                fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase",
                transition: "all 0.16s ease",
              }}>{tab.label}</button>
            ))}
          </div>

          {/* REVENUE TAB */}
          {(activeSection === "overview" || activeSection === "income") && (
            <>
              <SectionTable
                title="Revenue & Income"
                color={t.green}
                rows={incomeRows}
                total={totalRevenue}
                onAdd={() => setShowAddModal("income")}
                note="All sources including OO"
              />
              <InfoBox color={t.blue} label="Revenue Note">
                <strong>Confirmed income</strong> ({fmt(totalRevenuePaid)}) = paid invoices + paid loads.
                <br />
                <strong>Pending</strong> ({fmt(totalRevenueUnpaid)}) = invoiced but unpaid + open loads not yet invoiced.
                <br />
                <strong>OO Retained</strong> ({fmt(ooCompanyRetained)}) = the company portion from Owner Operator loads ({100 - ooSettlementPercent}%).
              </InfoBox>
            </>
          )}

          {/* EXPENSES TAB */}
          {(activeSection === "overview" || activeSection === "expenses") && (
            <>
              <SectionTable
                title="Company Expenses"
                color={t.red}
                rows={companyExpenseRows}
                total={totalCompanyExpenses}
                onAdd={() => setShowAddModal("expense")}
                note="Company-owned drivers, trucks, trailers only"
              />
              <InfoBox color={t.amber} label="Expense Boundaries">
                Only expenses on <strong>company-owned assets</strong> appear here. Owner Operator fuel, insurance, maintenance, and asset costs are <strong>the OO's responsibility</strong> and are not company expenses. The OO settlement payout ({fmt(ooSettlementPaid)}) is included as a company cost because it is cash leaving the company to the OO.
              </InfoBox>
            </>
          )}

          {/* OWNER OPERATORS TAB */}
          {(activeSection === "overview" || activeSection === "ownerops") && (
            <>
              <Divider label="Owner Operator Detail — Informational Only" />
              <SectionTable
                title="Owner Operator Financial Detail"
                color={t.purple}
                rows={ooInfoRows}
                total={ooGrossRevenue}
                note="Not included in company P&L except retained amount"
              />
              <InfoBox color={t.purple} label="Owner Operator Logic">
                OO loads generate revenue for the company. The company pays out <strong>{ooSettlementPercent}%</strong> ({fmt(ooSettlementPaid)}) to the OO and retains <strong>{100 - ooSettlementPercent}%</strong> ({fmt(ooCompanyRetained)}).
                <br />
                All OO costs (fuel: {fmt(ooFuelCosts)}, asset costs: {fmt(ooAssetCosts)}, deductions: {fmt(ooDeductions)}) are <strong>charged to the OO, not the company</strong>. They reduce what the OO earns, not what the company spends.
                <br />
                OO deductions charged to the OO ({fmt(ooDeductions)}) flow back to the company as revenue and should appear on their settlement statements.
              </InfoBox>
            </>
          )}

          {/* ASSETS TAB */}
          {(activeSection === "overview" || activeSection === "assets") && (
            <>
              <SectionTable
                title="Assets — Company Owned"
                color={t.blue}
                rows={assetRows}
                total={totalAssets}
                onAdd={() => setShowAddModal("asset")}
                note="Trucks and trailers where owner = company only"
              />
              <InfoBox color={t.orange} label="Asset Note">
                Only trucks and trailers <strong>owned by the company</strong> are counted as assets. OO-owned equipment is not a company asset. Asset values are based on purchase cost / book value recorded in the system.
              </InfoBox>
            </>
          )}

          {/* LIABILITIES TAB */}
          {(activeSection === "overview" || activeSection === "liabilities") && (
            <>
              <SectionTable
                title="Liabilities"
                color={t.red}
                rows={liabilityRows}
                total={totalLiabilities}
                onAdd={() => setShowAddModal("liability")}
              />
            </>
          )}

          {/* BOTTOM SUMMARY — Overview only */}
          {activeSection === "overview" && (
            <>
              <Divider label="Financial Summary" />
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: 14, marginBottom: 20 }}>
                {[
                  { label: "Net Profit (Realized)", value: fmt(grossProfit), sub: `Profit Margin: ${profitMargin}%  |  Operating Ratio: ${operatingRatio}%`, color: grossProfit >= 0 ? t.green : t.red },
                  { label: "Projected Balance (All Paid)", value: fmt(projectedBalance), sub: `Pending revenue: ${fmt(totalRevenueUnpaid)}`, color: t.blue },
                  { label: "Total Assets (Company)", value: fmt(totalAssets), sub: `Fleet + Receivables + Revenue`, color: t.blue },
                  { label: "Net Worth", value: fmt(netWorth), sub: `Assets ${fmt(totalAssets)} minus Liabilities ${fmt(totalLiabilities)}`, color: netWorth >= 0 ? t.green : t.red },
                ].map((item, i) => (
                  <div key={i} style={{
                    background: t.card, border: `1px solid ${t.border}`,
                    borderLeft: `4px solid ${item.color}`, borderRadius: 12, padding: "18px 20px",
                  }}>
                    <div style={{ fontSize: 9, color: t.muted, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>{item.label}</div>
                    <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "1.9rem", fontWeight: 800, color: item.color, lineHeight: 1 }}>{item.value}</div>
                    <div style={{ fontSize: 11, color: t.muted, marginTop: 8 }}>{item.sub}</div>
                  </div>
                ))}
              </div>
            </>
          )}

        </div>
      )}

      {/* ADD MANUAL MODAL */}
      {showAddModal && (
        <div
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.72)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}
          onClick={e => { if (e.target === e.currentTarget) setShowAddModal(null); }}
        >
          <div style={{ background: isLight ? "#FFFFFF" : "#0C0C18", border: `1px solid rgba(245,158,11,0.25)`, borderRadius: 16, padding: "28px 26px", width: "100%", maxWidth: 420 }}>
            <h3 style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "1.1rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", color: t.amber, margin: "0 0 18px" }}>
              Add {showAddModal.charAt(0).toUpperCase() + showAddModal.slice(1)} Entry
            </h3>
            {[
              { label: "Description", key: "name", placeholder: "e.g. Office Rent" },
              { label: "Amount ($)", key: "value", placeholder: "1500.00", type: "number" },
              { label: "Note / Source (optional)", key: "note", placeholder: "Where does this come from?" },
            ].map(f => (
              <div key={f.key} style={{ marginBottom: 12 }}>
                <div style={{ fontSize: "0.62rem", fontFamily: "'Barlow Condensed',sans-serif", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: t.text2, marginBottom: 5 }}>{f.label}</div>
                <input
                  type={f.type || "text"}
                  value={addForm[f.key]}
                  onChange={e => setAddForm(prev => ({ ...prev, [f.key]: e.target.value }))}
                  placeholder={f.placeholder}
                  style={{ width: "100%", boxSizing: "border-box", padding: "9px 12px", borderRadius: 8, border: `1px solid ${t.border}`, background: isLight ? "#F9F8F5" : "rgba(255,255,255,0.05)", color: t.text, fontFamily: "'DM Sans',sans-serif", fontSize: "0.875rem", outline: "none" }}
                />
              </div>
            ))}
            <div style={{ display: "flex", gap: 8, marginTop: 18 }}>
              <button onClick={handleAddManual} style={{ flex: 1, padding: "10px", borderRadius: 9, border: "none", background: "linear-gradient(135deg,#FBBF24,#F59E0B)", color: "#07070C", fontFamily: "'Barlow Condensed',sans-serif", fontSize: "0.88rem", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", cursor: "pointer" }}>
                Add Entry
              </button>
              <button onClick={() => setShowAddModal(null)} style={{ padding: "10px 18px", borderRadius: 9, border: `1px solid rgba(239,68,68,0.3)`, background: "rgba(239,68,68,0.08)", color: "#F87171", fontFamily: "'Barlow Condensed',sans-serif", fontSize: "0.88rem", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", cursor: "pointer" }}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');`}</style>
    <EmailPanel />
    </div>
  );
};

const WEEK_DAYS = [
  "Monday", "Tuesday", "Wednesday",
  "Thursday", "Friday", "Saturday", "Sunday"
];
const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const TruckAndTrailers = () => {
  const { notify } = useNotification();
  const apiUrl = "https://api-backend.full-trucking-service.com/api";
  const token = sessionStorage.getItem("token");

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  const [theme, setTheme] = useState(
    () => sessionStorage.getItem("theme") || "dark"
  );
  const [trucks, setTrucks] = useState([]);
  const [trailers, setTrailers] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [selectedTruck, setSelectedTruck] = useState("");
  const [selectedTrailer, setSelectedTrailer] = useState("");
  const [selectedDriver, setSelectedDriver] = useState("");

  const [assetCosts, setAssetCosts] = useState([]);
  const [loadingReports, setLoadingReports] = useState(false);
  const [selectedCost, setSelectedCost] = useState(null);

  /* ── SINGLE MODAL STATE ──
     showModal: whether the big modal is open
     modalView: "reports" | "detail" | "preview"
  */
  const [showModal, setShowModal] = useState(false);
  const [modalView, setModalView] = useState("reports");
  const [detailTab, setDetailTab] = useState("payments");

  const [costDocuments, setCostDocuments] = useState([]);
  const [costDocLoading, setCostDocLoading] = useState(false);
  const [costDocFile, setCostDocFile] = useState(null);
  const [costDocType, setCostDocType] = useState("cost_document");
  const [costDocTitle, setCostDocTitle] = useState("");
  const [costDocDragOver, setCostDocDragOver] = useState(false);
  const [costPreviewUrl, setCostPreviewUrl] = useState("");
  const [costPreviewMime, setCostPreviewMime] = useState("");
  const costDocFileRef = useRef(null);

  const isDriver = Boolean(selectedDriver);

  const isCostFullyPaid = (c) => {
    if (!c || !c.installments) return false;
    if (c.installments.total === Infinity) return false;
    return c.installments.paid >= c.installments.total;
  };

  const fullyPaid = selectedCost ? isCostFullyPaid(selectedCost) : false;

  const [costData, setCostData] = useState({
    type: "deduction",
    category: "",
    vendor: "",
    description: "",
    amount: "",
    paymentType: "one_time",
    repeatInterval: 1,
    repeatUnit: "week",
    onWeekDay: "",
    onMonthDay: "",
    onYearMonth: "",
    onYearDay: "",
    occurrences: 1,
    forever: false,
    startDate: "",
    endDate: "",
    status: "planned",
    notes: "",
  });

  const formatRecurrence = (c) => {
    if (c.paymentType !== "recurring" || !c.recurrence || !c.recurrence.every) {
      return "One-time";
    }

    const every = c.recurrence.every;
    const on = c.recurrence.on || {};
    const occurrences = c.recurrence.occurrences;

    let text = `Every ${every.interval} ${every.unit}`;
    if (every.interval > 1) text += "s";
    if (on.weekDay) text += ` on ${on.weekDay}`;
    if (on.monthDay) text += ` on day ${on.monthDay}`;
    if (on.yearMonth && on.yearDay) text += ` on ${on.yearMonth} ${on.yearDay}`;
    if (occurrences === null) {
      text += " • Forever";
    } else if (occurrences) {
      text += ` • ${occurrences} times`;
    }

    return text;
  };

  /* ================= THEME ================= */
  useEffect(() => {
    axios
      .get(`${apiUrl}/settings`, config)
      .then((res) => setTheme(res.data.theme || "dark"))
      .catch(() => setTheme("dark"));
  }, []);

  /* ================= ASSETS ================= */
  useEffect(() => {
    Promise.all([
      axios.get(`${apiUrl}/trucks`, config),
      axios.get(`${apiUrl}/trailers`, config),
      axios.get(`${apiUrl}/drivers`, config),
    ])
      .then(([t, tr, d]) => {
        setTrucks(t.data);
        setTrailers(tr.data);
        setDrivers(d.data);
      })
      .catch(() => notify("Failed to load assets", "error"));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCostData((prev) => ({ ...prev, [name]: value }));
  };

  /* ================= MODAL NAVIGATION ================= */
  const closeModal = () => {
    if (costPreviewUrl) URL.revokeObjectURL(costPreviewUrl);
    setCostPreviewUrl("");
    setCostPreviewMime("");
    setShowModal(false);
    setModalView("reports");
    setSelectedCost(null);
  };

  const goBack = () => {
    if (modalView === "preview") {
      if (costPreviewUrl) URL.revokeObjectURL(costPreviewUrl);
      setCostPreviewUrl("");
      setCostPreviewMime("");
      setModalView("detail");
    } else if (modalView === "detail") {
      setSelectedCost(null);
      setModalView("reports");
    }
  };

  const openCostDetail = (c) => {
    if (c.active === false) return;
    if (isCostFullyPaid(c)) return;
    setSelectedCost(JSON.parse(JSON.stringify(c)));
    setDetailTab("payments");
    setCostDocuments([]);
    setCostDocFile(null);
    setCostDocTitle("");
    setModalView("detail");
    fetchCostDocuments(c._id);
  };

  const headerTitle = () => {
    if (modalView === "preview") return "Document Preview";
    if (modalView === "detail" && selectedCost) {
      return `${selectedCost.category.toUpperCase()} – ${selectedCost.amount} ${
        selectedCost.currency || ""
      }`;
    }
    if (selectedTruck)
      return `Truck ${trucks.find((t) => t._id === selectedTruck)?.truckNumber}`;
    if (selectedTrailer)
      return `Trailer ${
        trailers.find((t) => t._id === selectedTrailer)?.trailerNumber
      }`;
    if (selectedDriver) {
      const d = drivers.find((dr) => dr._id === selectedDriver);
      return `Driver ${d?.firstName || ""} ${d?.lastName || ""}`;
    }
    return "Reports";
  };

  /* ================= DOCUMENT FUNCTIONS ================= */
  const fetchCostDocuments = async (costId) => {
    setCostDocLoading(true);
    try {
      const res = await axios.get(`${apiUrl}/documents`, {
        ...config,
        params: { linkedEntityType: "asset_cost", linkedEntityId: costId },
      });
      setCostDocuments(res.data);
    } catch {
      setCostDocuments([]);
    } finally {
      setCostDocLoading(false);
    }
  };

  const handleCostDocUpload = async () => {
    if (!costDocFile || !selectedCost)
      return notify("Please select a file.", "error");
    const fd = new FormData();
    fd.append("file", costDocFile);
    fd.append("docType", costDocType);
    fd.append("title", costDocTitle || costDocFile.name);
    fd.append("linkedEntityType", "asset_cost");
    fd.append("linkedEntityId", selectedCost._id);
    fd.append(
      "linkedEntityLabel",
      `${selectedCost.category} - ${selectedCost.amount}`
    );
    try {
      await axios.post(`${apiUrl}/documents`, fd, {
        headers: { ...config.headers, "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });
      notify("Document uploaded!", "success");
      setCostDocFile(null);
      setCostDocTitle("");
      if (costDocFileRef.current) costDocFileRef.current.value = "";
      fetchCostDocuments(selectedCost._id);
    } catch (err) {
      notify(err.response?.data?.error || "Upload failed.", "error");
    }
  };

  const handleCostDocDelete = async (docId) => {
    if (!window.confirm("Delete this document?")) return;
    try {
      await axios.delete(`${apiUrl}/documents/${docId}`, config);
      notify("Document deleted.", "success");
      fetchCostDocuments(selectedCost._id);
    } catch {
      notify("Failed to delete document.", "error");
    }
  };

  const handleCostDocPreview = async (doc) => {
    try {
      const r = await axios.get(`${apiUrl}/documents/${doc.id}/download`, {
        ...config,
        responseType: "blob",
      });
      setCostPreviewUrl(URL.createObjectURL(r.data));
      setCostPreviewMime(doc.mimeType);
      setModalView("preview");
    } catch {
      notify("Preview failed.", "error");
    }
  };

  /* ================= PAYLOAD ================= */
  const buildPayload = () => {
    const payload = {
      type: costData.type,
      category: costData.category,
      vendor: costData.vendor,
      amount: Number(costData.amount),
      description: costData.description,
      paymentType: costData.paymentType,
      startDate: costData.startDate,
      endDate: costData.endDate || undefined,
      status: costData.status,
      notes: costData.notes || "",
    };

    if (costData.paymentType === "recurring") {
      payload.recurrence = {
        every: {
          interval: Number(costData.repeatInterval),
          unit: costData.repeatUnit,
        },
        on: {
          weekDay: costData.onWeekDay || null,
          monthDay: costData.onMonthDay || null,
          yearMonth: costData.onYearMonth || null,
          yearDay: costData.onYearDay || null,
        },
        occurrences: costData.forever ? null : Number(costData.occurrences),
      };
    }

    return payload;
  };

  const calculateEndDate = (startDate, interval, unit, occurrences) => {
    if (!startDate || !interval || !unit || !occurrences) return "";
    const d = new Date(startDate);
    const total = interval * occurrences;
    switch (unit) {
      case "day": d.setDate(d.getDate() + total); break;
      case "week": d.setDate(d.getDate() + total * 7); break;
      case "month": d.setMonth(d.getMonth() + total); break;
      case "year": d.setFullYear(d.getFullYear() + total); break;
    }
    return d.toISOString().split("T")[0];
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async () => {
    let assetType = "";
    let assetId = "";

    if (selectedTruck) {
      assetType = "truck";
      assetId = selectedTruck;
    } else if (selectedTrailer) {
      assetType = "trailer";
      assetId = selectedTrailer;
    } else if (selectedDriver) {
      assetType = "driver";
      assetId = selectedDriver;
    } else {
      notify("Select a Truck, Trailer or Driver", "error");
      return;
    }

    if (!costData.category || !costData.amount || !costData.startDate) {
      notify("Category, amount and start date are required", "error");
      return;
    }

    try {
      const payload = buildPayload();
      await axios.post(
        `${apiUrl}/asset-costs`,
        { assetType, assetId, ...payload },
        config
      );
      notify("Cost saved successfully", "success");
    } catch (err) {
      notify("Failed to save cost", "error");
    }
  };

  /* ================= REPORTS ================= */
  const openReports = async () => {
    let assetType = "";
    let assetId = "";

    if (selectedTruck) {
      assetType = "truck";
      assetId = selectedTruck;
    } else if (selectedTrailer) {
      assetType = "trailer";
      assetId = selectedTrailer;
    } else if (selectedDriver) {
      assetType = "driver";
      assetId = selectedDriver;
    } else {
      return;
    }

    setSelectedCost(null);
    setModalView("reports");
    setShowModal(true);
    setLoadingReports(true);

    try {
      const res = await axios.get(`${apiUrl}/asset-costs`, {
        params: { assetType, assetId },
        ...config,
      });
      setAssetCosts(res.data);
    } catch {
      notify("Failed to load reports", "error");
    } finally {
      setLoadingReports(false);
    }
  };

  /* ================= UI ================= */
  return (
    <div
      className={`${styles.wrapperTruckandTrailer} ${
        theme === "light" ? styles.lightTruckandTrailer : ""
      }`}
    >
      <h2 className={styles.titleTruckandTrailer}>
        Truck & Trailer Cost Manager
      </h2>

      {/* ── Asset selectors ── */}
      <div className={styles.assetRowTruckandTrailer}>
        <select
          value={selectedTruck}
          onChange={(e) => {
            setSelectedTruck(e.target.value);
            setSelectedTrailer("");
            setSelectedDriver("");
          }}
        >
          <option value="">Select Truck</option>
          {trucks.map((t) => (
            <option key={t._id} value={t._id}>
              {t.truckNumber}
            </option>
          ))}
        </select>

        <select
          value={selectedTrailer}
          onChange={(e) => {
            setSelectedTrailer(e.target.value);
            setSelectedTruck("");
            setSelectedDriver("");
          }}
        >
          <option value="">Select Trailer</option>
          {trailers.map((t) => (
            <option key={t._id} value={t._id}>
              {t.trailerNumber}
            </option>
          ))}
        </select>

        <select
          value={selectedDriver}
          onChange={(e) => {
            setSelectedDriver(e.target.value);
            setSelectedTruck("");
            setSelectedTrailer("");
          }}
        >
          <option value="">Select Driver</option>
          {drivers.map((d) => (
            <option key={d._id} value={d._id}>
              {d.firstName} {d.lastName}
            </option>
          ))}
        </select>
      </div>

      {/* ── See Reports button ── */}
      {(selectedTruck || selectedTrailer || selectedDriver) && (
        <button
          className={styles.seeReportsBtnTruckandTrailer}
          onClick={openReports}
        >
          See Reports
        </button>
      )}

      {/* ══════════════════════════════════════════
          SINGLE FULL-SCREEN MODAL
          views: reports → detail → preview
      ══════════════════════════════════════════ */}
      {showModal && (
        <div
          className={styles.modalBackdrop}
          onClick={(e) => {
            if (e.target === e.currentTarget) closeModal();
          }}
        >
          <div className={styles.megaModalTruckandTrailer}>
            {/* ── Header with navigation ── */}
            <div className={styles.megaHeaderTruckandTrailer}>
              <div className={styles.megaHeaderLeftTruckandTrailer}>
                {modalView !== "reports" && (
                  <button
                    className={styles.megaBackBtnTruckandTrailer}
                    onClick={goBack}
                  >
                    ← Back
                  </button>
                )}
                <h3 className={styles.megaTitleTruckandTrailer}>
                  {headerTitle()}
                </h3>
              </div>
              <button
                className={styles.megaCloseBtnTruckandTrailer}
                onClick={closeModal}
              >
                ✕
              </button>
            </div>

            {/* ── Body ── */}
            <div className={styles.megaBodyTruckandTrailer}>
              {/* ─────────── VIEW: REPORTS ─────────── */}
              {modalView === "reports" &&
                (loadingReports ? (
                  <p>Loading...</p>
                ) : assetCosts.length === 0 ? (
                  <p>No costs found</p>
                ) : (
                  <table className={styles.reportsTableTruckandTrailer}>
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Category</th>
                        <th>Vendor</th>
                        <th>Description</th>
                        <th>Notes</th>
                        <th>Amount</th>
                        <th>Billing</th>
                        <th>Installments</th>
                        <th>Start</th>
                        <th>Next</th>
                        <th>End</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assetCosts.map((c) => (
                        <tr
                          key={c._id}
                          className={`${styles.clickableRow} ${
                            c.active === false ? styles.inactiveRow : ""
                          }`}
                          onClick={() => openCostDetail(c)}
                        >
                          <td
                            className={
                              c.type === "addition"
                                ? styles.additionLabel
                                : styles.deductionLabel
                            }
                          >
                            {c.type === "addition" ? "Addition" : "Deduction"}
                          </td>
                          <td
                            className={`${styles.badgeTruckandTrailer} ${
                              c.type === "addition"
                                ? styles.addition
                                : styles.deduction
                            }`}
                          >
                            {c.category}
                          </td>
                          <td>{c.vendor || "-"}</td>
                          <td className={styles.descTruckandTrailer}>
                            {c.description || "-"}
                          </td>
                          <td className={styles.descTruckandTrailer}>
                            {c.notes || "-"}
                          </td>
                          <td className={styles.amountTruckandTrailer}>
                            {c.amount} {c.currency}
                          </td>
                          <td className={styles.recurrenceTruckandTrailer}>
                            {formatRecurrence(c)}
                          </td>
                          <td className={styles.installmentsTruckandTrailer}>
                            <strong>
                              {c.installments?.paid ?? 0}/
                              {c.installments?.total === Infinity
                                ? "∞"
                                : c.installments?.total ?? 1}
                            </strong>
                            <div
                              className={styles.installmentsSubTruckandTrailer}
                            >
                              Due by now: {c.installments?.dueByNow ?? 0}
                            </div>
                            <div
                              className={styles.installmentsOpenTruckandTrailer}
                            >
                              Open: {c.installments?.open ?? 0}
                            </div>
                          </td>
                          <td>{new Date(c.startDate).toLocaleDateString()}</td>
                          <td>
                            {new Date(c.nextBillingDate).toLocaleDateString()}
                          </td>
                          <td>
                            {c.endDate
                              ? new Date(c.endDate).toLocaleDateString()
                              : "—"}
                          </td>
                          <td
                            className={`${styles.statusTruckandTrailer} ${
                              styles[c.status]
                            }`}
                          >
                            {c.status}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ))}

              {/* ─────────── VIEW: DETAIL (payments + documents) ─────────── */}
              {modalView === "detail" && selectedCost && (
                <>
                  {/* Tab Bar */}
                  <div className={styles.modalTabBarTruckandTrailer}>
                    {["payments", "documents"].map((tab) => (
                      <button
                        key={tab}
                        className={
                          detailTab === tab
                            ? styles.modalTabActiveTruckandTrailer
                            : styles.modalTabTruckandTrailer
                        }
                        onClick={() => {
                          setDetailTab(tab);
                          if (tab === "documents")
                            fetchCostDocuments(selectedCost._id);
                        }}
                      >
                        {tab.charAt(0).toUpperCase() + tab.slice(1)}
                        {tab === "documents" && costDocuments.length > 0 && (
                          <span className={styles.tabBadgeTruckandTrailer}>
                            {costDocuments.length}
                          </span>
                        )}
                      </button>
                    ))}
                  </div>

                  {/* ── TAB: PAYMENTS ── */}
                  {detailTab === "payments" && (
                    <>
                      <table className={styles.paymentsTable}>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Due Date</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(selectedCost.payments) &&
                            selectedCost.payments.map((p) => (
                              <tr key={p.index}>
                                <td>{p.index}</td>
                                <td>
                                  {new Date(p.dueDate).toLocaleDateString()}
                                </td>
                                <td>
                                  <select
                                    value={p.status}
                                    disabled={
                                      selectedCost.active === false || fullyPaid
                                    }
                                    onChange={async (e) => {
                                      if (
                                        selectedCost.active === false ||
                                        fullyPaid
                                      )
                                        return;
                                      const newStatus = e.target.value;
                                      try {
                                        const res = await axios.put(
                                          `${apiUrl}/asset-costs/${selectedCost._id}/payments/${p.index}`,
                                          { status: newStatus },
                                          config
                                        );
                                        setSelectedCost(res.data);
                                        setAssetCosts((prev) =>
                                          prev.map((c) =>
                                            c._id === res.data._id
                                              ? res.data
                                              : c
                                          )
                                        );
                                      } catch {
                                        notify(
                                          "Failed to update payment",
                                          "error"
                                        );
                                      }
                                    }}
                                  >
                                    <option value="open">Open</option>
                                    <option value="paid">Paid</option>
                                    <option value="overdue">Overdue</option>
                                  </select>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>

                      <div className={styles.modalActions}>
                        {selectedCost.active !== false && !fullyPaid && (
                          <button
                            className={styles.deactivateBtn}
                            onClick={async () => {
                              try {
                                const res = await axios.put(
                                  `${apiUrl}/asset-costs/${selectedCost._id}/deactivate`,
                                  {},
                                  config
                                );
                                setAssetCosts((prev) =>
                                  prev.map((c) =>
                                    c._id === res.data._id ? res.data : c
                                  )
                                );
                                setSelectedCost(null);
                                setModalView("reports");
                              } catch {
                                notify("Failed to deactivate cost", "error");
                              }
                            }}
                          >
                            Deactivate Cost
                          </button>
                        )}
                        <button onClick={goBack}>Back to Reports</button>
                      </div>
                    </>
                  )}

                  {/* ── TAB: DOCUMENTS ── */}
                  {detailTab === "documents" && (
                    <div>
                      {/* Drop Zone */}
                      <div
                        className={`${styles.docDropZoneTruckandTrailer} ${
                          costDocDragOver
                            ? styles.docDropZoneActiveTruckandTrailer
                            : ""
                        } ${
                          costDocFile
                            ? styles.docDropZoneFilledTruckandTrailer
                            : ""
                        }`}
                        onDragOver={(e) => {
                          e.preventDefault();
                          setCostDocDragOver(true);
                        }}
                        onDragLeave={() => setCostDocDragOver(false)}
                        onDrop={(e) => {
                          e.preventDefault();
                          setCostDocDragOver(false);
                          const file = e.dataTransfer.files[0];
                          if (file) {
                            setCostDocFile(file);
                            setCostDocTitle(file.name);
                          }
                        }}
                        onClick={() => costDocFileRef.current?.click()}
                      >
                        <input
                          ref={costDocFileRef}
                          type="file"
                          style={{ display: "none" }}
                          accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx,.xls,.xlsx"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              setCostDocFile(file);
                              setCostDocTitle(file.name);
                            }
                          }}
                        />

                        {costDocFile ? (
                          <div
                            className={styles.docDropZoneFileTruckandTrailer}
                          >
                            <span
                              className={styles.docFileIconTruckandTrailer}
                            >
                              📄
                            </span>
                            <div>
                              <div
                                className={
                                  styles.docFileNameTruckandTrailer
                                }
                              >
                                {costDocFile.name}
                              </div>
                              <div
                                className={
                                  styles.docFileSizeTruckandTrailer
                                }
                              >
                                {(costDocFile.size / 1024).toFixed(0)} KB
                              </div>
                            </div>
                            <button
                              type="button"
                              className={
                                styles.docDropZoneRemoveTruckandTrailer
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                setCostDocFile(null);
                                setCostDocTitle("");
                                if (costDocFileRef.current)
                                  costDocFileRef.current.value = "";
                              }}
                            >
                              ×
                            </button>
                          </div>
                        ) : (
                          <div
                            className={
                              styles.docDropZonePromptTruckandTrailer
                            }
                          >
                            <p
                              className={
                                styles.docDropZoneTextTruckandTrailer
                              }
                            >
                              Drag & drop or click to upload
                            </p>
                            <p
                              className={
                                styles.docDropZoneSubTruckandTrailer
                              }
                            >
                              PDF, JPG, PNG, DOC, DOCX, XLS — max 50MB
                            </p>
                          </div>
                        )}
                      </div>

                      {/* Document Type chips */}
                      <div className={styles.docTypeGridTruckandTrailer}>
                        {[
                          { key: "cost_document", label: "Cost Document" },
                          { key: "invoice", label: "Invoice" },
                          { key: "receipt", label: "Receipt" },
                          { key: "contract", label: "Contract" },
                          { key: "other", label: "Other" },
                        ].map((d) => (
                          <button
                            key={d.key}
                            type="button"
                            onClick={() => setCostDocType(d.key)}
                            className={`${styles.docTypeChipTruckandTrailer} ${
                              costDocType === d.key
                                ? styles.docTypeChipActiveTruckandTrailer
                                : ""
                            }`}
                          >
                            {d.label}
                          </button>
                        ))}
                      </div>

                      {/* Title input */}
                      <input
                        className={styles.docTitleInputTruckandTrailer}
                        value={costDocTitle}
                        onChange={(e) => setCostDocTitle(e.target.value)}
                        placeholder="Document title (optional)"
                      />

                      {/* Upload button */}
                      <button
                        type="button"
                        className={styles.docUploadBtnTruckandTrailer}
                        disabled={!costDocFile}
                        onClick={handleCostDocUpload}
                      >
                        Upload Document
                      </button>

                      {/* Documents list */}
                      <div className={styles.docListTruckandTrailer}>
                        <p className={styles.docListLabelTruckandTrailer}>
                          Uploaded Documents
                        </p>

                        {costDocLoading ? (
                          <p className={styles.docListEmptyTruckandTrailer}>
                            Loading...
                          </p>
                        ) : costDocuments.length === 0 ? (
                          <p className={styles.docListEmptyTruckandTrailer}>
                            No documents yet.
                          </p>
                        ) : (
                          costDocuments.map((doc) => (
                            <div
                              key={doc.id}
                              className={styles.docListItemTruckandTrailer}
                            >
                              <div
                                className={
                                  styles.docListItemInfoTruckandTrailer
                                }
                              >
                                <span
                                  className={
                                    styles.docListItemNameTruckandTrailer
                                  }
                                >
                                  {doc.title || doc.fileName}
                                </span>
                                <span
                                  className={
                                    styles.docListItemMetaTruckandTrailer
                                  }
                                >
                                  {doc.docType.replace(/_/g, " ")} ·{" "}
                                  {(doc.fileSize / 1024).toFixed(0)} KB
                                </span>
                              </div>
                              <div
                                className={
                                  styles.docListItemActionsTruckandTrailer
                                }
                              >
                                <button
                                  type="button"
                                  className={
                                    styles.docViewBtnTruckandTrailer
                                  }
                                  onClick={() => handleCostDocPreview(doc)}
                                >
                                  View
                                </button>

                                <a
                                  href={`${apiUrl}/documents/${doc.id}/download`}
                                  target="_blank"
                                  rel="noreferrer"
                                  className={
                                    styles.docDownloadBtnTruckandTrailer
                                  }
                                >
                                  Download
                                </a>
                                <button
                                  type="button"
                                  className={
                                    styles.docDeleteBtnTruckandTrailer
                                  }
                                  onClick={() => handleCostDocDelete(doc.id)}
                                >
                                  Delete
                                </button>
                              </div>
                            </div>
                          ))
                        )}
                      </div>

                      <div className={styles.modalActions}>
                        <button onClick={goBack}>Back to Reports</button>
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* ─────────── VIEW: PREVIEW ─────────── */}
              {modalView === "preview" &&
                (costPreviewMime === "application/pdf" ||
                costPreviewMime?.startsWith("image/") ? (
                  <iframe
                    src={costPreviewUrl}
                    className={styles.megaPreviewFrameTruckandTrailer}
                    title="Document Preview"
                  />
                ) : (
                  <div className={styles.costPreviewUnsupportedTruckandTrailer}>
                    <p>Preview not available for this file type.</p>
                    <p>Download the file to view it.</p>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}

      {/* ── Add Cost Form ── */}
      {(selectedTruck || selectedTrailer || selectedDriver) && (
        <div className={styles.formCardTruckandTrailer}>
          <select
            name="type"
            value={costData.type}
            onChange={(e) =>
              setCostData((prev) => ({
                ...prev,
                type: e.target.value,
                category: "",
              }))
            }
          >
            <option value="deduction">Deduction</option>
            <option value="addition">Addition</option>
          </select>

          <select
            name="category"
            value={costData.category}
            onChange={handleChange}
          >
            <option value="">
              {costData.type === "deduction"
                ? "Deduction Category"
                : "Addition Category"}
            </option>

            {isDriver && costData.type === "deduction" && (
              <>
                <option value="late_arrival">Late Arrival</option>
                <option value="missed_pickup">Missed Pickup</option>
                <option value="missed_delivery">Missed Delivery</option>
                <option value="damage">Cargo / Equipment Damage</option>
                <option value="violation">Violation / Fine</option>
                <option value="fuel_misuse">Fuel Misuse</option>
                <option value="advance">Cash Advance</option>
                <option value="other_driver_deduction">
                  Other Driver Deduction
                </option>
              </>
            )}

            {isDriver && costData.type === "addition" && (
              <>
                <option value="detention_pay">Detention Pay</option>
                <option value="layover_pay">Layover Pay</option>
                <option value="bonus">Bonus</option>
                <option value="performance_bonus">Performance Bonus</option>
                <option value="extra_stop">Extra Stop</option>
                <option value="safety_bonus">Safety Bonus</option>
                <option value="other_driver_addition">
                  Other Driver Addition
                </option>
              </>
            )}

            {!isDriver && costData.type === "deduction" && (
              <>
                <option value="insurance">Insurance</option>
                <option value="leasing">Leasing</option>
                <option value="maintenance">Maintenance</option>
                <option value="maut">Maut / Toll</option>
                <option value="trailer_rent">Trailer Rent</option>
                <option value="service">Service</option>
                <option value="other">Other</option>
              </>
            )}

            {!isDriver && costData.type === "addition" && (
              <>
                <option value="lumper">Lumper</option>
                <option value="extra_pickup">Extra Pick-up</option>
                <option value="extra_delivery">Extra Delivery</option>
                <option value="detention">Detention</option>
                <option value="layover">Layover</option>
                <option value="bonus">Bonus</option>
                <option value="other_addition">Other Addition</option>
              </>
            )}
          </select>

          <input
            name="vendor"
            placeholder="Vendor / Company"
            onChange={handleChange}
          />

          <label>Description</label>
          <input
            name="description"
            placeholder="Description"
            value={costData.description}
            onChange={handleChange}
          />

          <input
            name="amount"
            type="number"
            placeholder="Amount"
            onChange={handleChange}
          />

          <select name="paymentType" onChange={handleChange}>
            <option value="one_time">One-time payment</option>
            <option value="recurring">Recurring payment</option>
          </select>

          {costData.paymentType === "recurring" && (
            <div className={styles.recurrenceSectionTruckandTrailer}>
              <label>Repeat</label>

              <div className={styles.row}>
                <span>Every</span>
                <input
                  type="number"
                  min="1"
                  name="repeatInterval"
                  value={costData.repeatInterval}
                  onChange={handleChange}
                />
                <select
                  name="repeatUnit"
                  value={costData.repeatUnit}
                  onChange={handleChange}
                >
                  <option value="day">Day(s)</option>
                  <option value="week">Week(s)</option>
                  <option value="month">Month(s)</option>
                  <option value="year">Year(s)</option>
                </select>
              </div>

              {costData.repeatUnit === "week" && (
                <select name="onWeekDay" onChange={handleChange}>
                  <option value="">On which weekday?</option>
                  {WEEK_DAYS.map((d) => (
                    <option key={d} value={d}>
                      {d}
                    </option>
                  ))}
                </select>
              )}

              {costData.repeatUnit === "month" && (
                <input
                  type="number"
                  min="1"
                  max="31"
                  name="onMonthDay"
                  placeholder="Day of month"
                  onChange={handleChange}
                />
              )}

              {costData.repeatUnit === "year" && (
                <div>
                  <select name="onYearMonth" onChange={handleChange}>
                    <option value="">Month</option>
                    {MONTHS.map((m) => (
                      <option key={m} value={m}>
                        {m}
                      </option>
                    ))}
                  </select>
                  <input
                    type="number"
                    min="1"
                    max="31"
                    name="onYearDay"
                    placeholder="Day"
                    onChange={handleChange}
                  />
                </div>
              )}

              <label>Duration</label>

              <div className={styles.row}>
                <label>
                  <input
                    type="radio"
                    name="durationType"
                    checked={!costData.forever}
                    onChange={() =>
                      setCostData((prev) => ({
                        ...prev,
                        forever: false,
                        occurrences: prev.occurrences || 1,
                      }))
                    }
                  />
                  Limited
                </label>
                <label>
                  <input
                    type="radio"
                    name="durationType"
                    checked={costData.forever}
                    onChange={() =>
                      setCostData((prev) => ({
                        ...prev,
                        forever: true,
                        occurrences: null,
                      }))
                    }
                  />
                  Forever
                </label>
              </div>

              {!costData.forever && (
                <input
                  type="number"
                  min="1"
                  name="occurrences"
                  value={costData.occurrences}
                  onChange={handleChange}
                  placeholder="Number of occurrences"
                />
              )}
            </div>
          )}

          <div className={styles.dateRowTruckandTrailer}>
            <div>
              <label>Start date</label>
              <input type="date" name="startDate" onChange={handleChange} />
            </div>
            <div>
              <label>End date</label>
              <input type="date" name="endDate" onChange={handleChange} />
            </div>
          </div>

          <label>Notes</label>
          <textarea
            name="notes"
            placeholder="Notes"
            value={costData.notes}
            onChange={handleChange}
          />

          <button
            className={styles.saveBtnTruckandTrailer}
            onClick={handleSubmit}
          >
            Save Cost
          </button>
        </div>
      )}
    </div>
  );
};



const AddLoad = ({
  
  onClose,
  onAddLoad,
  drivers,
  trucks,
  trailers,
  handleUploadRC,
  brokers,
  shippers,
  consignees,
  dispatchers,
  currentUserId,
  currentUserRole
}) => {
  const { notify } = useNotification();
  const [loadData, setLoadData] = useState({
    loadNumber: "",
    dispatcher: "",
    brokerName: "",
    brokerAddress: "",
    rate: "",
    shippers: [],
    consignees: [],
    dispatcher: "",
    driver: "",
    teamDrivers: [],
    truck: "",
    trailers: "",
    status: "",
    paymentStatus: "Not Paid", 
    miles: "",
    dh: "",
    notes: "",
  });

  const [shippersSuggestions, setShippersSuggestions] = useState([]);
  const [consigneesSuggestions, setConsigneesSuggestions] = useState([]);
  const [showMultiLoadSection, setShowMultiLoadSection] = useState(false);
  const [rcFiles, setRcFiles] = useState([]);
  const [isPickingLoadNumber, setIsPickingLoadNumber] = useState(false);
  const [showPickingBanner, setShowPickingBanner] = useState(false);
  const iframeRef = useRef(null);
  const loadNumberInputRef = useRef(null);
const [currentRCIndex, setCurrentRCIndex] = useState(0);
const [isMultiRCMode, setIsMultiRCMode] = useState(false);
const [currentPdfUrl, setCurrentPdfUrl] = useState(null);
const [zoom, setZoom] = useState(1.5); 
const [currentPickingField, setCurrentPickingField] = useState(null);
const leftRef = useRef(null);
const [leftWidth, setLeftWidth] = useState(50); 
const [availableDocs, setAvailableDocs]   = useState([]);
const [selectedDocIds, setSelectedDocIds] = useState([]);
// Adaugă state nou lângă celelalte state-uri din AddLoad
const [emailDroppedDocs, setEmailDroppedDocs] = useState([]);
const [docSectionDragOver, setDocSectionDragOver] = useState(false);
const [theme, setTheme] = useState(
  () => sessionStorage.getItem("theme") || "dark"
);

const startDragging = (e) => {
  e.preventDefault();
  document.addEventListener("mousemove", onDragging);
  document.addEventListener("mouseup", stopDragging);
};

const onDragging = (e) => {
  const container = document.querySelector(`.${styles.addLoadContentWrapper}`);
  const containerRect = container.getBoundingClientRect();
  const newLeftWidth = ((e.clientX - containerRect.left) / containerRect.width) * 100;

  if (newLeftWidth > 10 && newLeftWidth < 90) {
    setLeftWidth(newLeftWidth);
  }
};



const stopDragging = () => {
  document.removeEventListener("mousemove", onDragging);
  document.removeEventListener("mouseup", stopDragging);
};


const fieldOrder = [
  "loadNumber",          // 1. Load Number
  "brokerName",          // 2. Broker Name
  "brokerAddress",       // 3. Broker Address
  "rate",                // 4. Rate
  "miles",               // 5. Miles
  "dh",                  // 6. DH
  "notes",               // 7. Notes
  // Shippers (primul shipper)
  "shipperName-0",       // 8. Shipper Name
  "shipperAddress-0",    // 9. Shipper Address
  "pickUpTime-0",        // 10. PickUp Time
  // Consignees (primul consignee)
  "consigneeName-0",     // 11. Consignee Name
  "consigneeAddress-0",  // 12. Consignee Address
  "deliveryTime-0",      // 13. Delivery Time
];

const initialEmptyLoadData = {
  loadNumber: "",
  dispatcher: "",
  brokerName: "",
  brokerAddress: "",
  rate: "",
  shippers: [],
  consignees: [],
  driver: "",
  teamDrivers: [],
  truck: "",
  trailers: "",
  status: "",
  paymentStatus: "Not Paid",
  miles: "",
  dh: "",
  notes: "",
  equipment: ""
};


  const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
  const apiUrl = 'https://api-backend.full-trucking-service.com/api'; // URL-ul backend-ului
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,  // Adaugă tokenul cu prefixul Bearer
      'Content-Type': 'application/json',
    },
    withCredentials: true,  // Trimite cookies pentru autentificare
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoadData((prevState) => ({
      ...prevState,
      [name]: value || "",
    }));
  };

const handleDriverChange = (e) => {
  const driverId = e.target.value;
  const driverObj = drivers.find((d) => d._id === driverId);

  console.log("Driver selectat:", driverObj);

  let matchedTruck = "";
  if (driverObj?.truckNumber) {
    const truckObj = trucks.find((t) => t.truckNumber === driverObj.truckNumber);
    console.log("Truck găsit:", truckObj);

    if (truckObj?._id) {
      matchedTruck = truckObj._id;
    }
  }

  setLoadData((prevState) => {
    console.log("Setez loadData cu driver+truck:", {
      driver: driverId,
      truck: matchedTruck,
    });
    return {
      ...prevState,
      driver: driverId,
      truck: matchedTruck,
    };
  });
};


const handleTruckChange = (truckId) => {
  const truckObj = trucks.find((t) => t._id === truckId);

  let matchedDriver = "";
  if (truckObj?.truckNumber) {
    const driverObj = drivers.find((d) => d.truckNumber === truckObj.truckNumber);
    if (driverObj?._id) matchedDriver = driverObj._id;
  }

  setLoadData((prev) => ({
    ...prev,
    truck: truckId,
    driver: matchedDriver || prev.driver, // dacă găsim driver, îl suprascriem
  }));
};

  // Selectare șoferi pentru echipă (Team Drivers)
  const handleTeamDriverChange = (selectedOptions) => {
    setLoadData((prevState) => ({
      ...prevState,
      teamDrivers: selectedOptions ? selectedOptions.map((option) => option.value) : [],
    }));
  };

  const handleBrokerSelect = (e) => {
    const selectedBrokerName = e.target.value;
    const selectedBroker = brokers.find(
      (b) => b.brokerName === selectedBrokerName
    );
    setLoadData((prevState) => ({
      ...prevState,
      brokerName: selectedBrokerName,
      brokerAddress: selectedBroker ? selectedBroker.address : "",
    }));
  };
  useEffect(() => {
    const fetchSuggestions = async () => {
      try {
        const shippersResponse = await axios.get(`${apiUrl}/shippers`, config);
        const consigneesResponse = await axios.get(`${apiUrl}/consignees`, config);
        setShippersSuggestions(shippersResponse.data);
        setConsigneesSuggestions(consigneesResponse.data);
      } catch (error) {
       
      }
    };

    fetchSuggestions();
  }, []);
useEffect(() => {
  const fetchAiPreference = async () => {
    try {
      const res = await axios.get(`${apiUrl}/morehelpfromai`, config);
      setLoadData((prev) => ({
        ...prev,
        moreHelpFromAI: res.data.enabled || false
      }));
    } catch (err) {
      console.error("Error fetching AI preference:", err);
    }
  };
  fetchAiPreference();
}, []);

useEffect(() => {
  const fetchDocs = async () => {
    try {
      const res = await axios.get(`${apiUrl}/documents`, config);
      setAvailableDocs(res.data);
    } catch { /* silent */ }
  };
  fetchDocs();
}, []);

useEffect(() => {
  const fetchDocs = async () => {
    try {
      const res = await axios.get(`${apiUrl}/documents`, config);
      setAvailableDocs(res.data);
    } catch { /* silent */ }
  };
  fetchDocs();
}, []);

// ← ADAUGĂ EXACT DUPĂ CEL DE SUS:
useEffect(() => {
  const handler = (e) => {
    const { file } = e.detail;
    if (!file) return;
    setRcFiles([file]);
    setCurrentRCIndex(0);
    setIsMultiRCMode(false);
    processRCFile(file);
  };
  window.addEventListener('email-attachment-as-file', handler);
  return () => window.removeEventListener('email-attachment-as-file', handler);
}, []);

useEffect(() => {
  if (!loadData.moreHelpFromAI) return;

  let newLoad = { ...loadData };

  // 1. Status Completed dacă deliveryTime < azi
  const earliestConsignee = newLoad.consignees[0];
  if (earliestConsignee?.deliveryTime && new Date(earliestConsignee.deliveryTime) < new Date()) {
    newLoad.status = "Completed";
  }

// 2. Auto-match driver ↔ truck prin truckNumber
if (newLoad.driver && !newLoad.truck) {
  const driverObj = drivers.find((d) => d._id === newLoad.driver);
  if (driverObj?.truckNumber) {
    const truckObj = trucks.find((t) => t.truckNumber === driverObj.truckNumber);
    if (truckObj?._id) {
      newLoad.truck = truckObj._id; // salvăm ObjectId-ul Truckului
    }
  }
}

if (newLoad.truck && !newLoad.driver) {
  const truckObj = trucks.find((t) => t._id === newLoad.truck);
  if (truckObj?.truckNumber) {
    const driverObj = drivers.find((d) => d.truckNumber === truckObj.truckNumber);
    if (driverObj?._id) {
      newLoad.driver = driverObj._id; // salvăm ObjectId-ul Driverului
    }
  }
}


const calcDH = async () => {
  if (!newLoad.driver) return;

  try {

    const lastLoad = await axios.get(
      `${apiUrl}/loads/by-assignment?driverId=${newLoad.driver}`,
      config
    );

    if (lastLoad.data.length > 0) {

      const previousLoad = lastLoad.data[0];

      const prevConsignee = [...(previousLoad.consignees || [])]
        .reverse()
        .find(c => c.address?.trim());

      const newShipper = newLoad.shippers
        .find(s => s.address?.trim());

      if (prevConsignee?.address && newShipper?.address) {

        const url =
          `${apiUrl}/calculate-distance?origins=${encodeURIComponent(prevConsignee.address)}&destinations=${encodeURIComponent(newShipper.address)}`;

        const dhRes = await axios.get(url, config);

        if (dhRes.data?.distance?.value) {

          const miles = Math.round(
            dhRes.data.distance.value * 0.000621371
          );

          setLoadData(prev => ({ ...prev, dh: miles }));
        }
      }
    }

  } catch (err) {
    console.error("Error calculating DH:", err);
  }
};

  calcDH();

  // 🔥 aplică modificările în state
  setLoadData(prev => ({
  ...prev,
  ...newLoad
}));
}, [loadData.moreHelpFromAI, loadData.driver, loadData.truck, loadData.shippers, loadData.consignees]);

// ✅ Dicționar echivalențe echipamente
const equipmentMap = {
  "VAN": "Van",
  "DRY VAN": "Dry Van",
  "53 VAN": "53 Van",
  "53 REEFER": "53 Reefer",
  "REEFER": "53 Reefer",
  "FLATBED": "Flatbed",
  "STEP DECK": "Step Deck"
  // 🔧 mai adaugi aici ce variante mai vezi în PDF-uri
};

// ✅ Funcția care normalizează
const normalizeEquipment = (raw) => {
  if (!raw) return "";
  const key = raw.trim().toUpperCase();
  return equipmentMap[key] || raw; 
};

  const handleShipperSelect = (index, selectedName) => {
    const selectedShipper = shippersSuggestions.find(
      (shipper) => shipper.shipperName === selectedName
    );
    
    if (selectedShipper) {
      const newShippers = [...loadData.shippers];
      newShippers[index] = {
        ...newShippers[index],
        name: selectedShipper.shipperName,
        address: selectedShipper.shipperAddress, // setează adresa corectă
      };
      setLoadData((prevState) => ({ ...prevState, shippers: newShippers }));
    }
  };
  const processRCFile = async (file) => {
    setIsLoading(true);
    setCurrentPdfUrl(URL.createObjectURL(file));
  
    const fileContent = await fileToBase64(file);
    try {
  const response = await axios.post(`${apiUrl}/upload-rc`, {
  fileContent,
  fileType: file.type
}, config);
      const extractedData = response.data.extractedData;
  
      if (!extractedData) return;
  
      const formatDateTimeLocal = (dateTime) => {
        const date = new Date(dateTime);
        return !isNaN(date.getTime()) ? date.toISOString().slice(0, 16) : "";
      };
  
      const formattedShippers = extractedData.shippers.map(shipper => ({
        name: shipper.name || "",
        address: shipper.address || "",
        pickUpTime: formatDateTimeLocal(shipper.pickUpTime),
      }));
  
      const formattedConsignees = extractedData.consignees.map(consignee => ({
        name: consignee.name || "",
        address: consignee.address || "",
        deliveryTime: formatDateTimeLocal(consignee.deliveryTime),
      }));
  
      setLoadData(prevState => ({
        ...prevState,
        loadNumber: extractedData.loadNumber || "",
        brokerName: extractedData.brokerName || "",
        brokerAddress: extractedData.brokerAddress || "",
        rate: extractedData.rate || "",
        shippers: formattedShippers,
        consignees: formattedConsignees,
        equipment: normalizeEquipment(extractedData.equipment)
      }));
    } catch (err) {
     
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleConsigneeSelect = (index, selectedName) => {
    const selectedConsignee = consigneesSuggestions.find(
      (consignee) => consignee.consigneeName === selectedName
    );
  
    if (selectedConsignee) {
      const newConsignees = [...loadData.consignees];
      newConsignees[index] = {
        ...newConsignees[index],
        name: selectedConsignee.consigneeName,
        address: selectedConsignee.consigneeAddress, // setează adresa corectă
      };
      setLoadData((prevState) => ({ ...prevState, consignees: newConsignees }));
    }
  };
  
  
  

  const handleAddShipper = () => {
    setLoadData((prevState) => ({
      ...prevState,
      shippers: [...prevState.shippers, { name: "", address: "", pickUpTime: "" }], // folosește 'name' și 'address'
    }));
  };
  
  const handleAddConsignee = () => {
    setLoadData((prevState) => ({
      ...prevState,
      consignees: [...prevState.consignees, { name: "", address: "", deliveryTime: "" }], // folosește 'name' și 'address'
    }));
  };
  

  const handleRemoveShipper = (index) => {
    setLoadData((prevState) => ({
      ...prevState,
      shippers: prevState.shippers.filter((_, i) => i !== index),
    }));
  };

  const handleRemoveConsignee = (index) => {
    setLoadData((prevState) => ({
      ...prevState,
      consignees: prevState.consignees.filter((_, i) => i !== index),
    }));
  };

  const handleShipperChange = (index, e) => {
    const { name, value } = e.target;
    const newShippers = [...loadData.shippers];
    newShippers[index][name] = value;
    setLoadData((prevState) => ({ ...prevState, shippers: newShippers }));
  };

  const handleConsigneeChange = (index, e) => {
    const { name, value } = e.target;
    const newConsignees = [...loadData.consignees];
    newConsignees[index][name] = value;
    setLoadData((prevState) => ({ ...prevState, consignees: newConsignees }));
  };

const calculateMiles = async () => {

  const stops = [
    ...loadData.shippers
      .map(s => s.address?.trim())
      .filter(Boolean),

    ...loadData.consignees
      .map(c => c.address?.trim())
      .filter(Boolean)
  ];

  if (stops.length < 2) return;

  try {

    const response = await axios.post(
      `${apiUrl}/calculate-multi-distance`,
      { stops },
      config
    );

    if (typeof response.data?.miles === "number") {

      const roundedMiles = Math.round(response.data.miles);

      setLoadData(prev => {
        const currentMiles = Number(prev.miles) || 0;

        if (currentMiles === roundedMiles) {
          return prev;
        }

        return {
          ...prev,
          miles: roundedMiles
        };
      });

    }

  } catch (error) {
    console.error("Miles calculation error:", error);
  }
};

useEffect(() => {
  const timeout = setTimeout(() => {
    const hasValidShipper = loadData.shippers.some(s => s.address?.trim());
    const hasValidConsignee = loadData.consignees.some(c => c.address?.trim());

    if (hasValidShipper && hasValidConsignee) {
      calculateMiles();
    }
  }, 800);

  return () => clearTimeout(timeout);
}, [loadData.shippers, loadData.consignees]);

  useEffect(() => {
    // Căutăm dispatcher-ul curent bazat pe clientId, în cazul în care utilizatorul autentificat este client
  
  
    if (
      currentUserRole === 'dispatcher' &&
      Array.isArray(dispatchers) &&
      dispatchers.length > 0 &&
      currentUserId
    ) {
      // Dacă `currentUserId` este al clientului, găsim dispatcher-ul bazat pe `clientId`
      const currentDispatcher = dispatchers.find(d => d.clientId === currentUserId);
     
  
      if (currentDispatcher) {
        setLoadData(prev => ({
          ...prev,
          dispatcher: currentDispatcher._id
        }));
      }
    }
  }, [currentUserId, dispatchers, currentUserRole]);

 const handleSubmit = async () => {
  if (isLoading) return;

  try {
    setIsLoading(true);

    let newLoad = { ...loadData };

    /* =========================================================
       1️⃣ STATUS AUTO (AI only)
    ========================================================== */
    if (newLoad.moreHelpFromAI) {
      const earliestConsignee = newLoad.consignees?.[0];
      if (
        earliestConsignee?.deliveryTime &&
        new Date(earliestConsignee.deliveryTime) < new Date()
      ) {
        newLoad.status = "Completed";
      }
    }

    /* =========================================================
       2️⃣ CALCUL DH (INDEPENDENT DE AI)
    ========================================================== */
/* =========================================================
   2️⃣ CALCUL DH (MULTI-STOP SAFE)
========================================================= */
if (newLoad.driver && newLoad.shippers?.length > 0) {

  const lastLoadRes = await axios.get(
    `${apiUrl}/loads/by-assignment?driverId=${newLoad.driver}`,
    config
  );

  if (Array.isArray(lastLoadRes.data) && lastLoadRes.data.length > 0) {

    const previousLoad = lastLoadRes.data[0];

    const prevConsignee = [...(previousLoad.consignees || [])]
      .reverse()
      .find(c => c.address?.trim());

    const newShipper = newLoad.shippers
      .find(s => s.address?.trim());

    if (prevConsignee?.address && newShipper?.address) {

   let calculatedDH = 0;

try {
  const dhRes = await axios.get(
    `${apiUrl}/calculate-distance?origins=${encodeURIComponent(prevConsignee.address)}&destinations=${encodeURIComponent(newShipper.address)}`,
    config
  );

  if (dhRes.data?.distance?.value) {
    calculatedDH = Math.round(
      dhRes.data.distance.value * 0.000621371
    );
  }

} catch (err) {
  console.error("DH calculation failed. Continuing without DH.");
}

newLoad.dh = calculatedDH;

    }
  }
}

    /* =========================================================
       3️⃣ CALCUL MILES MULTI-STOP (INDEPENDENT DE AI)
    ========================================================== */
   /* =========================================================
   3️⃣ CALCUL MILES MULTI-STOP (ORDER FIXED)
========================================================== */
if (newLoad.shippers?.length && newLoad.consignees?.length) {

  const stops = [
    ...newLoad.shippers
      .map(s => s.address?.trim())
      .filter(Boolean),

    ...newLoad.consignees
      .map(c => c.address?.trim())
      .filter(Boolean)
  ];

  if (stops.length > 1) {

    const milesRes = await axios.post(
      `${apiUrl}/calculate-multi-distance`,
      { stops },
      config
    );

    if (typeof milesRes.data?.miles === "number") {
      newLoad.miles = Math.round(milesRes.data.miles);
    }
  }
}

    /* =========================================================
       4️⃣ AUTO MATCH DRIVER ↔ TRUCK (AI only)
    ========================================================== */
    if (newLoad.moreHelpFromAI) {
      if (newLoad.driver && !newLoad.truck) {
        const driverObj = drivers.find(
          (d) => d._id === newLoad.driver
        );
        if (driverObj?.assignedTruck) {
          newLoad.truck = driverObj.assignedTruck;
        }
      }

      if (newLoad.truck && !newLoad.driver) {
        const truckObj = trucks.find(
          (t) => t._id === newLoad.truck
        );
        if (truckObj?.assignedDriver) {
          newLoad.driver = truckObj.assignedDriver;
        }
      }
    }

    /* =========================================================
       5️⃣ VALIDĂRI
    ========================================================== */
    if (!newLoad.driver && !newLoad.truck) {
      notify(
        "You must select either a Driver or a Truck before submitting.",
        "error"
      );
      setIsLoading(false);
      return;
    }

    if (
      !newLoad.loadNumber?.trim() ||
      newLoad.shippers.length === 0 ||
      newLoad.consignees.length === 0
    ) {
      notify(
        "Load Number, Driver or Truck, Shipper, and Consignee are mandatory fields.",
        "error"
      );
      setIsLoading(false);
      return;
    }

    if (
      newLoad.rate &&
      !/^\d+(\.\d{1,2})?$/.test(newLoad.rate)
    ) {
      notify(
        "Rate must be a valid number (e.g., 200 or 200.00).",
        "error"
      );
      setIsLoading(false);
      return;
    }

    if (
      newLoad.truck &&
      !/^[0-9a-fA-F]{24}$/.test(newLoad.truck)
    ) {
      notify("Invalid Truck ID.", "error");
      setIsLoading(false);
      return;
    }

    /* =========================================================
       6️⃣ VERIFICARE LOAD ACTIV
    ========================================================== */
    const incompleteLoadsResponse = await axios.get(
      `${apiUrl}/loads/incomplete`,
      config
    );

    const incompleteLoads =
      incompleteLoadsResponse.data || [];

    if (newLoad.driver) {
      const driverHasActiveLoad = incompleteLoads.some(
        (load) => load.driver === newLoad.driver
      );

      if (driverHasActiveLoad) {
        notify(
          "This driver already has an active load! Please complete the existing load first.",
          "error"
        );
        setIsLoading(false);
        return;
      }
    }

    if (newLoad.truck) {
      const truckHasActiveLoad = incompleteLoads.some(
        (load) => load.truck === newLoad.truck
      );

      if (truckHasActiveLoad) {
        notify(
          "This truck already has an active load! Please complete the existing load first.",
          "error"
        );
        setIsLoading(false);
        return;
      }
    }

    /* =========================================================
       7️⃣ SALVARE SHIPPERS
    ========================================================== */
    for (const shipper of newLoad.shippers) {
      const existingShipper =
        shippersSuggestions.find(
          (s) =>
            s.shipperName === shipper.name &&
            s.shipperAddress === shipper.address
        );

      if (!existingShipper) {
        await axios.post(
          `${apiUrl}/shippers`,
          {
            shipperName: shipper.name,
            shipperAddress: shipper.address,
          },
          config
        );
      }
    }

    /* =========================================================
       8️⃣ SALVARE CONSIGNEES
    ========================================================== */
    for (const consignee of newLoad.consignees) {
      const existingConsignee =
        consigneesSuggestions.find(
          (c) =>
            c.consigneeName === consignee.name &&
            c.consigneeAddress === consignee.address
        );

      if (!existingConsignee) {
        await axios.post(
          `${apiUrl}/consignees`,
          {
            consigneeName: consignee.name,
            consigneeAddress: consignee.address,
          },
          config
        );
      }
    }

    /* =========================================================
       9️⃣ TRIMITERE LOAD
    ========================================================== */
    const dataToSend = {
      ...newLoad,
      clientId,
      truck: newLoad.truck || null,
      trailers: newLoad.trailers || null,
      paymentStatus:
        newLoad.paymentStatus || "Not Paid",
    };

    const response = await axios.post(
      `${apiUrl}/loads`,
      dataToSend,
      config
    );
if (response.status === 201) {
  const newLoadId     = response.data._id;
  const newLoadNumber = response.data.loadNumber;

  /* ── Link documente selectate din Document Center ── */
  if (selectedDocIds.length > 0) {
    await Promise.all(
      selectedDocIds.map(docId =>
        axios.patch(`${apiUrl}/documents/${docId}/link`, {
          linkedEntityType:  'load',
          linkedEntityId:    newLoadId,
          linkedEntityLabel: `Load #${newLoadNumber}`,
        }, config)
      )
    );
    setSelectedDocIds([]);
  }

  /* ── Upload automat RC/BOL PDF ca document linkat ── */
  const currentRCFile = rcFiles[currentRCIndex];
  if (currentRCFile) {
    try {
      const formData = new FormData();
      formData.append('file',              currentRCFile);
      formData.append('docType',           'rate_confirmation');
      formData.append('title',             `RC - Load #${newLoadNumber}`);
      formData.append('description',       'Auto-uploaded from Add Load');
      formData.append('linkedEntityType',  'load');
      formData.append('linkedEntityId',    newLoadId);
      formData.append('linkedEntityLabel', `Load #${newLoadNumber}`);

      await axios.post(`${apiUrl}/documents`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      });
    } catch (err) {
      console.error('RC auto-upload failed:', err);
      // Nu blocăm flow-ul — load-ul e deja salvat
    }
  }
      
      setLoadData({
        loadNumber: "",
        dispatcher: "",
        brokerName: "",
        brokerAddress: "",
        rate: "",
        equipment: "",
        driver: "",
        teamDrivers: [],
        truck: "",
        trailers: "",
        status: "",
        shippers: [],
        consignees: [],
        miles: "",
        dh: "",
        notes: "",
      });

      window.location.href = "?tab=add-new-load";
    }
  } catch (error) {
    notify(
      error.response?.data?.error ||
        "There was an error saving the load.",
      "error"
    );
  } finally {
    setIsLoading(false);
  }
};

  const handleRateChange = (e) => {
    const value = e.target.value;
    // Păstrează doar numerele și punctul
    const filteredValue = value.replace(/[^0-9.]/g, "");
    setLoadData((prevState) => ({
      ...prevState,
      rate: filteredValue,
    }));
  };
  

  const saveBrokersShippersConsignees = async () => {
    try {
      const brokerExists = brokers.some(
        (broker) => broker.brokerName === loadData.brokerName
      );
      if (!brokerExists) {
        await axios.post(`${apiUrl}/brokers`, {
          brokerName: loadData.brokerName,
          brokerAddress: loadData.brokerAddress,
        }, config);
      }

      const shipperExists = shippers.some(
        (shipper) => shipper.shipperName === loadData.shipperName
      );
      if (!shipperExists) {
        await axios.post(`${apiUrl}/shippers`, {
          shipperName: loadData.shipperName,
          shipperAddress: loadData.shipperAddress,
        }, config);
      }

      const consigneeExists = consignees.some(
        (consignee) => consignee.consigneeName === loadData.consigneeName
      );
      if (!consigneeExists) {
        await axios.post(`${apiUrl}/consignees`, {
          consigneeName: loadData.consigneeName,
          consigneeAddress: loadData.consigneeAddress,
        }, config);
      }

   
    } catch (error) {
    
      throw error;
    }
  };

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTheme(res.data.theme || "dark");
    } catch {
      setTheme("dark");
    }
  };
  fetchTheme();
}, []);

  const [isLoading, setIsLoading] = useState(false);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
  
    if (!file) {
    notify("No file selected" , 'error');
      return;
    }
  
    setIsLoading(true);
    const fileContent = await fileToBase64(file);
  
    try {
const response = await axios.post(`${apiUrl}/upload-rc`, {
  fileContent,
  fileType: file.type
}, config);

      const extractedData = response.data.extractedData;
     
  
      if (!extractedData || Object.keys(extractedData).length === 0) {
        notify("No relevant data found in the uploaded document. Please check the document format." , 'error');
        setIsLoading(false);
        return;
      }
  
      const formatDateTimeLocal = (dateTime) => {
        const date = new Date(dateTime);
        return !isNaN(date.getTime()) ? date.toISOString().slice(0, 16) : ""; // Validăm data
      };
  
      setLoadData((prevState) => {
        const formattedShippers = extractedData.shippers.map(shipper => ({
          name: shipper.name || "",
          address: shipper.address || "",
          pickUpTime: formatDateTimeLocal(shipper.pickUpTime)
        }));

        const formattedConsignees = extractedData.consignees.map(consignee => ({
          name: consignee.name || "",
          address: consignee.address || "",
          deliveryTime: formatDateTimeLocal(consignee.deliveryTime)
        }));

        const updatedData = {
          ...prevState,
          loadNumber: extractedData.loadNumber || prevState.loadNumber,
          rate: extractedData.rate || prevState.rate,
          brokerName: extractedData.brokerName || prevState.brokerName,
          brokerAddress: extractedData.brokerAddress || prevState.brokerAddress,
          shippers: formattedShippers,
          consignees: formattedConsignees,
        };

        // 🔍 AUTO-MATCH driver
        if (extractedData.driverName) {
          const match = drivers.find(d =>
            `${d.firstName} ${d.lastName}`.toLowerCase().includes(extractedData.driverName.toLowerCase())
          );
          if (match) updatedData.driver = match._id;
        }

        // 🔍 AUTO-MATCH dispatcher
        if (extractedData.dispatcherName) {
          const match = dispatchers.find(d =>
            `${d.firstName} ${d.lastName}`.toLowerCase().includes(extractedData.dispatcherName.toLowerCase())
          );
          if (match) updatedData.dispatcher = match._id;
        }

        // 🔍 AUTO-MATCH truck
        if (extractedData.truckNumber) {
          const match = trucks.find(t =>
            t.truckNumber.toLowerCase().includes(extractedData.truckNumber.toLowerCase())
          );
          if (match) updatedData.truck = match._id;
        }

        // 🔍 AUTO-MATCH trailer
        if (extractedData.trailerNumber) {
          const match = trailers.find(t =>
            t.trailerNumber.toLowerCase().includes(extractedData.trailerNumber.toLowerCase())
          );
          if (match) updatedData.trailer = match._id;
        }

        // 🔍 AUTO-MATCH equipment
        if (extractedData.equipment) {
          const eqOptions = [
            "Van", "53 Van", "Dry Van", "53' Reefer", "Flatbed", "Step Deck", "Reefer", "Flat or Step Deck",
            "Air Freight", "Power Only", "RGN Extendable", "Curtain Van"
          ];
          const match = eqOptions.find(eq =>
            eq.toLowerCase() === extractedData.equipment.toLowerCase()
          );
          if (match) updatedData.equipment = match;
        }

        return updatedData;
      });

    } catch (error) {
      
notify("Error processing the file." , 'error');
    } finally {
      setIsLoading(false);
    }
  };
  

const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = error => reject(error);
  });
};
  
  
  const handleCancel = () => {
    onClose();
  };

  const toDatetimeLocalFormat = (text) => {
    const date = new Date(text);
    if (isNaN(date.getTime())) {
      return "";
    }
    return date.toISOString().slice(0, 16);
  };
  

  useEffect(() => {
    if (!isPickingLoadNumber || !iframeRef.current) return;
  
    const iframe = iframeRef.current;
    const iframeWin = iframe.contentWindow;
    const iframeDoc = iframe.contentDocument || iframeWin?.document;
  
    if (!iframeDoc || !iframeWin) return;
  
    const handleMouseUp = () => {
      const selectedText = iframeWin.getSelection()?.toString().trim();
      if (selectedText) {
        setLoadData((prev) => ({
          ...prev,
          loadNumber: selectedText,
        }));
        setIsPickingLoadNumber(false);
  
        // Focus input după ce selectezi
        loadNumberInputRef.current?.focus();
        loadNumberInputRef.current?.select();
      }
    };
  
    iframeDoc.addEventListener("mouseup", handleMouseUp);
  
    // cleanup
    return () => {
      iframeDoc.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isPickingLoadNumber, currentPdfUrl]);
  useEffect(() => {
    if (isPickingLoadNumber) {
      setShowPickingBanner(true);
    } else {
      setShowPickingBanner(false);
    }
  }, [isPickingLoadNumber]);
  return (
  <>
    {/* Picking banner */}
    {showPickingBanner && (
      <div className={styles.pickingBanner}>
        Click a field on the left, then select text from the PDF to fill it
      </div>
    )}

    <Loader isLoading={isLoading} />

   <div className={`${styles.ultimateaddloadsectionContainer} ${theme === "light" ? styles.ultimateaddloadsectionContainerLight : ""}`}>

      {/* ── PAGE HEADER ────────────────────────────────────────────── */}
      <div className={styles.pageHeaderAddLoad}>
        <div>
          <h2 className={styles.titleultimateaddload}>
            Add New Load
            <span />
          </h2>
        </div>

        {/* AI toggle */}
        <label className={styles.aiTogglePill}>
          <input
            type="checkbox"
            checked={loadData.moreHelpFromAI || false}
            onChange={async (e) => {
              const checked = e.target.checked;
              setLoadData(prev => ({ ...prev, moreHelpFromAI: checked }));
              try {
                await axios.post(`${apiUrl}/morehelpfromai`, { clientId, enabled: checked }, config);
                notify(`AI assistance ${checked ? "enabled" : "disabled"}`, "success");
              } catch {
                notify("Error saving AI preference", "error");
              }
            }}
          />
          <span>AI Assistance</span>
        </label>
      </div>

      {/* ── SPLIT LAYOUT ───────────────────────────────────────────── */}
      <div className={styles.addLoadContentWrapper}>

        {/* ════ LEFT — FORM ════════════════════════════════════════ */}
        <div
          ref={leftRef}
          className={styles.leftFormContainer}
          style={{
            width: `calc(${leftWidth}% - 3px)`,
            maxHeight: 'calc(100vh - 160px)',
            overflowY: 'auto',
          }}
        >

          {/* ── Load Info ──────────────────────────────────────── */}
          <div className={styles.formSectionBlock}>
            <p className={styles.formSectionTitle}>Load Information</p>

            <div className={styles.formRowultimateaddload}>
              <div className={styles.formGroupultimateaddload}>
                <label>Load Number</label>
                <input
                  ref={loadNumberInputRef}
                  name="loadNumber"
                  value={loadData.loadNumber}
                  onChange={handleChange}
                  placeholder="e.g. 1234567"
                  required
                  className={styles.inputFieldultimateaddload}
                  style={{
                    borderColor: currentPickingField === "loadNumber" ? "rgba(245,158,11,0.7)" : undefined,
                    boxShadow: currentPickingField === "loadNumber" ? "0 0 0 3px rgba(245,158,11,0.12)" : undefined,
                  }}
                  onClick={() => setCurrentPickingField("loadNumber")}
                />
              </div>

              <div className={styles.formGroupultimateaddload}>
                <label>Dispatcher</label>
                <select
                  name="dispatcher"
                  value={loadData.dispatcher}
                  onChange={handleChange}
                  className={styles.selectFieldultimateaddload}
                  disabled={currentUserRole === 'dispatcher'}
                  required
                >
                  {currentUserRole === 'dispatcher' ? (
                    dispatchers.length > 0 ? (
                      <option value={currentUserId}>
                        {dispatchers.find(d => d.clientId === currentUserId)?.firstName}{' '}
                        {dispatchers.find(d => d.clientId === currentUserId)?.lastName}
                      </option>
                    ) : <option>Loading...</option>
                  ) : (
                    <>
                      <option value="">Select Dispatcher</option>
                      {dispatchers.map(d => (
                        <option key={d._id} value={d._id}>{d.firstName} {d.lastName}</option>
                      ))}
                    </>
                  )}
                </select>
              </div>
            </div>

            <div className={styles.formRowultimateaddload}>
              <div className={styles.formGroupultimateaddload}>
                <label>Broker Name</label>
                <input
                  list="brokers-list"
                  name="brokerName"
                  value={loadData.brokerName}
                  onChange={handleBrokerSelect}
                  placeholder="Broker Name"
                  required
                  className={styles.inputFieldultimateaddload}
                  style={{
                    borderColor: currentPickingField === "brokerName" ? "rgba(245,158,11,0.7)" : undefined,
                    boxShadow: currentPickingField === "brokerName" ? "0 0 0 3px rgba(245,158,11,0.12)" : undefined,
                  }}
                  onClick={() => setCurrentPickingField("brokerName")}
                />
                <datalist id="brokers-list">
                  {brokers.map(b => <option key={b._id} value={b.brokerName} />)}
                </datalist>
              </div>

              <div className={styles.formGroupultimateaddload}>
                <label>Broker Address</label>
                <input
                  name="brokerAddress"
                  value={loadData.brokerAddress}
                  onChange={handleChange}
                  placeholder="Broker Address"
                  required
                  className={styles.inputFieldultimateaddload}
                  style={{
                    borderColor: currentPickingField === "brokerAddress" ? "rgba(245,158,11,0.7)" : undefined,
                    boxShadow: currentPickingField === "brokerAddress" ? "0 0 0 3px rgba(245,158,11,0.12)" : undefined,
                  }}
                  onClick={() => setCurrentPickingField("brokerAddress")}
                />
              </div>
            </div>

            <div className={styles.formRowultimateaddload}>
              <div className={styles.formGroupultimateaddload}>
                <label>Rate ($)</label>
                <input
                  name="rate"
                  value={loadData.rate}
                  onChange={handleRateChange}
                  placeholder="e.g. 2500.00"
                  required
                  className={styles.inputFieldultimateaddload}
                  style={{
                    borderColor: currentPickingField === "rate" ? "rgba(245,158,11,0.7)" : undefined,
                    boxShadow: currentPickingField === "rate" ? "0 0 0 3px rgba(245,158,11,0.12)" : undefined,
                  }}
                  onClick={() => setCurrentPickingField("rate")}
                />
              </div>

              <div className={styles.formGroupultimateEquipmentaddload}>
                <label>Equipment</label>
                <select name="equipment" value={loadData.equipment} onChange={handleChange} className={styles.selectFieldEquipmentultimateaddload}>
                  <option value="">Select Equipment</option>
                  {["Dry Van","53 Van","53' Reefer","Air Freight","Airride/Logistical Van","Any Equipment","Beam","Cargo Van (1 Ton)","Conestoga","Convertible Hopper","Conveyor Belt","Curtain Siders","Curtain Van","Double Drop","Drive Away","Flat Intermodal","Flat or Step Deck","Flat with Tarps","Flatbed","Flatbed Air-Ride","Flatbed Blanket Wrapped","Flatbed or Van","Haul and Tow Unit","Hazardous Material Load","Landoll Flatbed","Live Bottom Trailer","Load-Out","Lowboy","Lowboy over-dimension load","Maxi or Double Flat Trailers","Maxi/Double Flat Trailer","Moving Van","Multi-Axle Heavy Hauler","Pneumatic","Power Only","Reefer Pallet Exchange","Refrigerated Carrier","Removable Goose Neck","RGN Extendable","Step Deck","Straight Van","Tandem Van","Tanker","Team Driver Needed","Van","Van Air-Ride","Van intermodal","Van or Flatbed","Van or Reefer","Van Pallet Exchange","Vented Insulated Van","Vented Van","Walking Floor"].map(eq => (
                    <option key={eq} value={eq}>{eq}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className={styles.formRowultimateaddload}>
              <div className={styles.formGroupultimateaddload}>
                <label>Miles</label>
                <input
                  name="miles"
                  value={loadData.miles}
                  onChange={handleChange}
                  placeholder="Auto-calculated"
                  className={styles.inputFieldultimateaddload}
                  style={{
                    borderColor: currentPickingField === "miles" ? "rgba(245,158,11,0.7)" : undefined,
                    boxShadow: currentPickingField === "miles" ? "0 0 0 3px rgba(245,158,11,0.12)" : undefined,
                  }}
                  onClick={() => setCurrentPickingField("miles")}
                />
              </div>

              <div className={styles.formGroupultimateaddload}>
                <label>DH (Deadhead)</label>
                <input
                  name="dh"
                  value={loadData.dh}
                  onChange={handleChange}
                  placeholder="Auto-calculated"
                  className={styles.inputFieldultimateaddload}
                  style={{
                    borderColor: currentPickingField === "dh" ? "rgba(245,158,11,0.7)" : undefined,
                    boxShadow: currentPickingField === "dh" ? "0 0 0 3px rgba(245,158,11,0.12)" : undefined,
                  }}
                  onClick={() => setCurrentPickingField("dh")}
                />
              </div>
            </div>
          </div>

          {/* ── Driver / Truck ─────────────────────────────────── */}
          <div className={styles.formSectionBlock}>
            <p className={styles.formSectionTitle}>Driver & Equipment</p>

            <div className={styles.formRowultimateaddload}>
              <div className={styles.formGroupultimateDriveraddload}>
                <label>Driver</label>
                <select name="driver" value={loadData.driver} onChange={handleChange} required className={styles.selectFieldultimateaddload}>
                  <option value="">Select Driver</option>
                  {drivers.map(d => (
                    <option key={d._id} value={d._id}>{d.firstName} {d.lastName}</option>
                  ))}
                </select>
              </div>

              <div className={styles.formGroupultimateTruckaddload}>
                <label>Truck</label>
                <select name="truck" value={loadData.truck} onChange={handleChange} className={styles.selectFieldultimateaddload}>
                  <option value="">Select Truck</option>
                  {trucks.map(t => (
                    <option key={t._id} value={t._id}>{t.truckNumber}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className={styles.formRowultimateaddload}>
              <div className={styles.formGroupultimateTeamDriversaddload}>
                <label>Team Drivers</label>
                <Select
                  isMulti
                  options={drivers.map(d => ({ value: d._id, label: `${d.firstName} ${d.lastName}` }))}
                  onChange={handleTeamDriverChange}
                  className={styles.selectFieldultimateaddload}
                  placeholder="Select Team Drivers"
                  styles={{
                    control: (b) => ({ ...b, background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.10)", borderRadius: 10, minHeight: 42 }),
                    menu: (b) => ({ ...b, background: "#0E0E1A" }),
                    option: (b, s) => ({ ...b, background: s.isFocused ? "rgba(245,158,11,0.12)" : "#0E0E1A", color: "#EEEEF2" }),
                    multiValue: (b) => ({ ...b, background: "rgba(245,158,11,0.15)", borderRadius: 6 }),
                    multiValueLabel: (b) => ({ ...b, color: "#FBBF24" }),
                    multiValueRemove: (b) => ({ ...b, color: "#F59E0B" }),
                    singleValue: (b) => ({ ...b, color: "#EEEEF2" }),
                    input: (b) => ({ ...b, color: "#EEEEF2" }),
                    placeholder: (b) => ({ ...b, color: "#52526A" }),
                  }}
                />
              </div>

              <div className={styles.formGroupultimateTraileraddload}>
                <label>Trailer</label>
                <select name="trailer" value={loadData.trailer} onChange={handleChange} className={styles.selectFieldultimateaddload}>
                  <option value="">Select Trailer</option>
                  {Array.isArray(trailers) && trailers.map(t => (
                    <option key={t._id} value={t._id}>{t.trailerNumber}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* ── Status ─────────────────────────────────────────── */}
          <div className={styles.formSectionBlock}>
            <p className={styles.formSectionTitle}>Status & Payment</p>

            <div className={styles.formRowultimateaddload}>
              <div className={styles.formGroupultimateStatusaddload}>
                <label>Load Status</label>
                <select name="status" value={loadData.status} onChange={handleChange} required className={styles.selectFieldultimateStatusaddload}>
                  <option value="">Select Status</option>
                  {["Pending","Open","Refused","Assigned","Dispatched","On Route","In Progress","Delivered","(Un)Loading","Completed","Cancelled","In Yard"].map(s => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
              </div>

              <div className={styles.formGroupultimatePaymentStatusaddload}>
                <label>Payment Status</label>
                <select name="paymentStatus" value={loadData.paymentStatus} onChange={handleChange} required className={styles.selectFieldultimatePaymentStatusaddload}>
                  <option value="">Select Payment Status</option>
                  {["Not Paid","Pending Payment","Payment in Progress","Payment Cancelled","Paid","Paid in Installments"].map(s => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* ── Shippers ───────────────────────────────────────── */}
          <div className={styles.sectionultimateaddload}>
            <h3>Shippers</h3>
            {loadData.shippers.map((shipper, index) => (
              <div key={index} className={styles.shipperEntryCard}>
                <div className={styles.formGroupultimateaddload}>
                  <label>Shipper Name</label>
                  <input
                    name="name"
                    list={`shipper-suggestions-${index}`}
                    value={shipper.name}
                    onChange={(e) => { handleShipperChange(index, e); handleShipperSelect(index, e.target.value); }}
                    placeholder="Shipper Name"
                    className={styles.inputFieldultimateaddload}
                    style={{
                      borderColor: currentPickingField === `shipperName-${index}` ? "rgba(245,158,11,0.7)" : undefined,
                      boxShadow: currentPickingField === `shipperName-${index}` ? "0 0 0 3px rgba(245,158,11,0.12)" : undefined,
                    }}
                    onClick={() => setCurrentPickingField(`shipperName-${index}`)}
                  />
                  <datalist id={`shipper-suggestions-${index}`}>
                    {shippersSuggestions.map(s => <option key={s._id} value={s.shipperName} />)}
                  </datalist>
                </div>

                <div className={styles.formGroupultimateaddload}>
                  <label>Address</label>
                  <input
                    name="address"
                    value={shipper.address}
                    onChange={(e) => handleShipperChange(index, e)}
                    placeholder="Shipper Address"
                    className={styles.inputFieldultimateaddload}
                    style={{
                      borderColor: currentPickingField === `shipperAddress-${index}` ? "rgba(245,158,11,0.7)" : undefined,
                      boxShadow: currentPickingField === `shipperAddress-${index}` ? "0 0 0 3px rgba(245,158,11,0.12)" : undefined,
                    }}
                    onClick={() => setCurrentPickingField(`shipperAddress-${index}`)}
                  />
                </div>

                <div className={styles.formGroupultimateaddload}>
                  <label>Pickup Time</label>
                  <input
                    name="pickUpTime"
                    type="datetime-local"
                    value={shipper.pickUpTime}
                    onChange={(e) => handleShipperChange(index, e)}
                    className={styles.inputFieldultimateaddload}
                    style={{
                      borderColor: currentPickingField === `pickUpTime-${index}` ? "rgba(245,158,11,0.7)" : undefined,
                      boxShadow: currentPickingField === `pickUpTime-${index}` ? "0 0 0 3px rgba(245,158,11,0.12)" : undefined,
                    }}
                    onClick={() => setCurrentPickingField(`pickUpTime-${index}`)}
                  />
                </div>

                <button
                  type="button"
                  onClick={() => handleRemoveShipper(index)}
                  className={styles.removeButtonShipperultimateaddload}
                  title="Remove shipper"
                >
                  ✕
                </button>
              </div>
            ))}
            <button type="button" onClick={handleAddShipper} className={styles.addButtonShipperultimateaddload}>
              + Add Shipper
            </button>
          </div>

          {/* ── Consignees ─────────────────────────────────────── */}
          <div className={styles.sectionultimateaddload}>
            <h3>Consignees</h3>
            {loadData.consignees.map((consignee, index) => (
              <div key={index} className={styles.consigneeEntryCard}>
                <div className={styles.formGroupultimateaddload}>
                  <label>Consignee Name</label>
                  <input
                    name="name"
                    list={`consignee-suggestions-${index}`}
                    value={consignee.name}
                    onChange={(e) => { handleConsigneeChange(index, e); handleConsigneeSelect(index, e.target.value); }}
                    placeholder="Consignee Name"
                    className={styles.inputFieldultimateaddload}
                    style={{
                      borderColor: currentPickingField === `consigneeName-${index}` ? "rgba(245,158,11,0.7)" : undefined,
                      boxShadow: currentPickingField === `consigneeName-${index}` ? "0 0 0 3px rgba(245,158,11,0.12)" : undefined,
                    }}
                    onClick={() => setCurrentPickingField(`consigneeName-${index}`)}
                  />
                  <datalist id={`consignee-suggestions-${index}`}>
                    {consigneesSuggestions.map(c => <option key={c._id} value={c.consigneeName} />)}
                  </datalist>
                </div>

                <div className={styles.formGroupultimateaddload}>
                  <label>Address</label>
                  <input
                    name="address"
                    value={consignee.address}
                    onChange={(e) => handleConsigneeChange(index, e)}
                    placeholder="Consignee Address"
                    className={styles.inputFieldultimateaddload}
                    style={{
                      borderColor: currentPickingField === `consigneeAddress-${index}` ? "rgba(245,158,11,0.7)" : undefined,
                      boxShadow: currentPickingField === `consigneeAddress-${index}` ? "0 0 0 3px rgba(245,158,11,0.12)" : undefined,
                    }}
                    onClick={() => setCurrentPickingField(`consigneeAddress-${index}`)}
                  />
                </div>

                <div className={styles.formGroupultimateaddload}>
                  <label>Delivery Time</label>
                  <input
                    name="deliveryTime"
                    type="datetime-local"
                    value={consignee.deliveryTime}
                    onChange={(e) => handleConsigneeChange(index, e)}
                    className={styles.inputFieldultimateaddload}
                    style={{
                      borderColor: currentPickingField === `deliveryTime-${index}` ? "rgba(245,158,11,0.7)" : undefined,
                      boxShadow: currentPickingField === `deliveryTime-${index}` ? "0 0 0 3px rgba(245,158,11,0.12)" : undefined,
                    }}
                    onClick={() => setCurrentPickingField(`deliveryTime-${index}`)}
                  />
                </div>

                <button
                  type="button"
                  onClick={() => handleRemoveConsignee(index)}
                  className={styles.removeButtonConsigneeultimateaddload}
                  title="Remove consignee"
                >
                  ✕
                </button>
              </div>
            ))}
            <button type="button" onClick={handleAddConsignee} className={styles.addButtonConsigneeultimateaddload}>
              + Add Consignee
            </button>
          </div>

{/* ── Attach Documents ───────────────────────────────── */}
<div
  className={styles.formSectionBlock}
  onDragOver={(e) => {
    if (e.dataTransfer.types.includes('application/fts-attachment')) {
      e.preventDefault();
      setDocSectionDragOver(true);
    }
  }}
  onDragLeave={(e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setDocSectionDragOver(false);
    }
  }}
  onDrop={async (e) => {
    const attData = e.dataTransfer.getData('application/fts-attachment');
    if (!attData) return;
    e.preventDefault();
    e.stopPropagation();
    setDocSectionDragOver(false);

    const att = JSON.parse(attData);
    try {
      const res = await axios.post(`${apiUrl}/email/import-attachment`, {
        messageId: att.messageId,
        attachmentId: att.attachmentId,
        filename: att.filename,
        mimeType: att.mimeType,
        docType: 'other',
      }, config);

      const newDoc = res.data.document || res.data;
      const docId = newDoc._id || newDoc.id;

      setEmailDroppedDocs(prev => [...prev, {
        id: docId,
        title: att.filename,
        docType: 'other',
        fileName: att.filename,
      }]);
      setSelectedDocIds(prev => [...prev, docId]);
      notify(`"${att.filename}" attached to this load!`, 'success');
    } catch {
      notify('Failed to attach document', 'error');
    }
  }}
  style={{
    border: docSectionDragOver
      ? '2px dashed rgba(245,158,11,0.7)'
      : '2px dashed transparent',
    borderRadius: 12,
    transition: 'border 0.2s, background 0.2s',
    background: docSectionDragOver ? 'rgba(245,158,11,0.04)' : 'transparent',
  }}
>
  <p className={styles.formSectionTitle}>
    Attach Documents
    <span style={{
      fontSize: '0.7rem', fontWeight: 400,
      color: '#5A5A72', marginLeft: 8,
      textTransform: 'none', letterSpacing: 0,
    }}>
      — drag attachments from Email panel
    </span>
  </p>

  {/* Drop hint activ */}
  {docSectionDragOver && (
    <div style={{
      textAlign: 'center', padding: '14px 0',
      color: '#F59E0B', fontWeight: 700, fontSize: '0.9rem',
      pointerEvents: 'none',
    }}>
      📎 Drop here to attach to this load
    </div>
  )}

  {/* Documente droppate din email */}
  {emailDroppedDocs.length > 0 && (
    <div style={{ marginBottom: 10 }}>
      <p style={{
        fontSize: '0.68rem', color: '#F59E0B',
        fontWeight: 700, marginBottom: 5,
        textTransform: 'uppercase', letterSpacing: '0.08em',
      }}>
        📨 From Email
      </p>
      {emailDroppedDocs.map(doc => (
        <div key={doc.id} style={{
          display: 'flex', alignItems: 'center', gap: 8,
          padding: '7px 10px', borderRadius: 8, marginBottom: 5,
          background: 'rgba(245,158,11,0.08)',
          border: '1px solid rgba(245,158,11,0.25)',
        }}>
          <input
            type="checkbox"
            checked={selectedDocIds.includes(doc.id)}
            onChange={() =>
              setSelectedDocIds(prev =>
                prev.includes(doc.id)
                  ? prev.filter(id => id !== doc.id)
                  : [...prev, doc.id]
              )
            }
            style={{ accentColor: '#F59E0B', width: 15, height: 15, flexShrink: 0 }}
          />
          <span style={{
            fontSize: '0.82rem', color: '#FBBF24',
            fontWeight: 600, flex: 1,
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          }}>
            📎 {doc.title}
          </span>
          {selectedDocIds.includes(doc.id) && (
            <span style={{ fontSize: '0.68rem', color: '#F59E0B', fontWeight: 700, flexShrink: 0 }}>
              ✓
            </span>
          )}
          <button
            type="button"
            onClick={() => {
              setEmailDroppedDocs(prev => prev.filter(d => d.id !== doc.id));
              setSelectedDocIds(prev => prev.filter(id => id !== doc.id));
            }}
            style={{
              background: 'none', border: 'none',
              color: '#F87171', cursor: 'pointer',
              fontSize: '1rem', padding: '0 2px', flexShrink: 0,
            }}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  )}

  {/* Lista din Document Center */}
  {availableDocs.filter(doc => !doc.linkedEntity?.label).length === 0 && emailDroppedDocs.length === 0 ? (
    <p style={{ color: '#555', fontSize: '0.82rem' }}>
      No documents in Document Center yet.
    </p>
  ) : availableDocs.filter(doc => !doc.linkedEntity?.label).length > 0 && (
    <div style={{
      display: 'flex', flexDirection: 'column', gap: 6,
      maxHeight: 220, overflowY: 'auto',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: 10, padding: '8px 10px',
    }}>
      {availableDocs.filter(doc => !doc.linkedEntity?.label).map(doc => {
        const isSelected = selectedDocIds.includes(doc.id);
        return (
          <label
            key={doc.id}
            style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '8px 10px', borderRadius: 8, cursor: 'pointer',
              background: isSelected ? 'rgba(96,165,250,0.12)' : 'rgba(255,255,255,0.03)',
              border: isSelected ? '1px solid rgba(96,165,250,0.35)' : '1px solid transparent',
              transition: 'all 0.15s',
            }}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={() =>
                setSelectedDocIds(prev =>
                  isSelected
                    ? prev.filter(id => id !== doc.id)
                    : [...prev, doc.id]
                )
              }
              style={{ accentColor: '#60A5FA', width: 15, height: 15, flexShrink: 0 }}
            />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{
                fontSize: '0.83rem', fontWeight: 600, color: '#e0e0e0',
                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
              }}>
                {doc.title}
              </div>
              <div style={{ fontSize: '0.72rem', color: '#666', marginTop: 1 }}>
                {doc.docType?.replace(/_/g, ' ')}
                {doc.linkedEntity?.label ? ` · ${doc.linkedEntity.label}` : ' · Unlinked'}
              </div>
            </div>
            {isSelected && (
              <span style={{ fontSize: '0.7rem', color: '#60A5FA', fontWeight: 700, flexShrink: 0 }}>
                ✓ Selected
              </span>
            )}
          </label>
        );
      })}
    </div>
  )}

  {selectedDocIds.length > 0 && (
    <p style={{ marginTop: 8, fontSize: '0.78rem', color: '#60A5FA' }}>
      {selectedDocIds.length} document{selectedDocIds.length > 1 ? 's' : ''} will be linked on submit.
    </p>
  )}
</div>


          {/* ── Notes ──────────────────────────────────────────── */}
          <div className={styles.formSectionBlock}>
            <p className={styles.formSectionTitle}>Notes</p>
            <textarea
              name="notes"
              value={loadData.notes}
              onChange={handleChange}
              placeholder="Additional notes about this load..."
              className={styles.textareaFieldultimateaddload}
              style={{
                borderColor: currentPickingField === "notes" ? "rgba(245,158,11,0.7)" : undefined,
                boxShadow: currentPickingField === "notes" ? "0 0 0 3px rgba(245,158,11,0.12)" : undefined,
              }}
              onClick={() => setCurrentPickingField("notes")}
            />
          </div>

          {/* ── Actions ────────────────────────────────────────── */}
          <div className={styles.formActionsRow}>
            <button
              type="button"
              onClick={handleSubmit}
              className={styles.submitButtonultimateaddload}
              disabled={isLoading}
            >
              {isLoading ? "⏳ Saving Load..." : "✓ Add New Load"}
            </button>
            <button type="button" onClick={handleCancel} className={styles.closeBtnultimateaddload}>
              Cancel
            </button>
          </div>

        </div>
        {/* end leftFormContainer */}

        {/* ── SPLITTER ─────────────────────────────────────────── */}
        <div
          className={styles.splitter}
          onMouseDown={startDragging}
          style={{ left: `calc(${leftWidth}% - 2.5px)` }}
        />
{/* ════ RIGHT — PDF PREVIEW ════ */}
<div
  className={styles.rightPreviewContainer}
  style={{ width: `calc(${100 - leftWidth}% - 3px)` }}
>
  {!currentPdfUrl ? (
  <div
    className={styles.uploadArea}
    onDragOver={(e) => e.preventDefault()}
onDrop={(e) => {
  e.preventDefault();
  if (e.dataTransfer.types.includes('application/fts-attachment')) return; // ← adaugă asta
  const files = Array.from(e.dataTransfer.files).filter(f =>
    f.type === 'application/pdf' || f.type.startsWith('image/')
  );
  if (files.length > 0) {
    setRcFiles(files);
    setCurrentRCIndex(0);
    setIsMultiRCMode(true);
    processRCFile(files[0]);
  }
}}
    onClick={() => document.getElementById('file-upload-main').click()}
    style={{ cursor: "pointer" }}
  >
    <input
      type="file"
      accept="application/pdf,image/*"
      multiple
      style={{ display: "none" }}
      id="file-upload-main"
      onChange={(e) => {
        const files = Array.from(e.target.files).filter(f =>
          f.type === 'application/pdf' || f.type.startsWith('image/')
        );
        if (files.length > 0) {
          setRcFiles(files);
          setCurrentRCIndex(0);
          setIsMultiRCMode(true);
          processRCFile(files[0]);
        }
      }}
    />
    <div className={styles.uploadIconBox}>📄</div>
    <div className={styles.uploadLabel}>
      <strong>Drop RC / BOL Here</strong>
      Click to browse or drag & drop PDFs<br />
      <span style={{ fontSize: "0.78rem", color: "var(--al-text-muted)" }}>
        Supports PDF · PNG · JPG
      </span>
    </div>
  </div>

  ) : (
    /* PDF viewer — flex column, umple tot */
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>

      {/* Toolbar sus */}
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 16px",
        borderBottom: "1px solid var(--al-border)",
        flexShrink: 0,
        background: "rgba(255,255,255,0.02)",
      }}>
        <span style={{
          fontFamily: "'Barlow Condensed', sans-serif",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          color: "var(--al-text-2)",
        }}>
          RC Preview — {currentRCIndex + 1} / {rcFiles.length}
        </span>

        {/* Re-upload button în toolbar */}
        <label
          htmlFor="file-upload-2"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            padding: "6px 14px",
            borderRadius: 100,
            border: "1px solid var(--al-amber-border)",
            background: "var(--al-amber-dim)",
            color: "var(--al-amber-bright)",
            fontFamily: "'Barlow Condensed', sans-serif",
            fontSize: "0.72rem",
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            cursor: "pointer",
          }}
        >
          Change RC
        </label>
        <input
          type="file"
          accept="application/pdf,image/*"
          multiple
          style={{ display: "none" }}
          id="file-upload-2"
          onChange={(e) => {
            const files = Array.from(e.target.files).filter(f => f.type === 'application/pdf');
            if (files.length > 0) {
              setRcFiles(files);
              setCurrentRCIndex(0);
              setIsMultiRCMode(true);
              processRCFile(files[0]);
            }
          }}
        />
      </div>

      {/* PDF viewer — flex: 1 umple tot spațiul rămas */}
      <div style={{ flex: 1, overflow: "auto", position: "relative" }}>
        <PdfViewerWithSelect
          fileUrl={currentPdfUrl}
          onSelectText={(selectedText) => {
            if (!currentPickingField) return;
            setLoadData((prev) => {
              const updated = { ...prev };
              if (currentPickingField.startsWith("shipper")) {
                const [field, idx] = currentPickingField.split("-");
                const index = parseInt(idx, 10);
                if (!updated.shippers[index]) updated.shippers[index] = { name: "", address: "", pickUpTime: "" };
                if (field === "shipperName") updated.shippers[index].name = selectedText;
                else if (field === "shipperAddress") updated.shippers[index].address = selectedText;
                else if (field === "pickUpTime") updated.shippers[index].pickUpTime = toDatetimeLocalFormat(selectedText);
              } else if (currentPickingField.startsWith("consignee")) {
                const [field, idx] = currentPickingField.split("-");
                const index = parseInt(idx, 10);
                if (!updated.consignees[index]) updated.consignees[index] = { name: "", address: "", deliveryTime: "" };
                if (field === "consigneeName") updated.consignees[index].name = selectedText;
                else if (field === "consigneeAddress") updated.consignees[index].address = selectedText;
                else if (field === "deliveryTime") updated.consignees[index].deliveryTime = toDatetimeLocalFormat(selectedText);
              } else {
                updated[currentPickingField] = selectedText;
              }
              return updated;
            });
            const currentIndex = fieldOrder.indexOf(currentPickingField);
            if (currentIndex !== -1 && currentIndex < fieldOrder.length - 1) {
              setCurrentPickingField(fieldOrder[currentIndex + 1]);
            } else {
              setCurrentPickingField(null);
            }
          }}
        />
      </div>

      {/* Footer butoane — jos fix */}
      <div style={{
        display: "flex",
        gap: 10,
        padding: "12px 16px",
        borderTop: "1px solid var(--al-border)",
        background: "rgba(255,255,255,0.02)",
        flexShrink: 0,
        justifyContent: "center",
      }}>
        <button
          type="button"
          className={styles.skipButton}
          onClick={() => {
            const nextIndex = currentRCIndex + 1;
            if (nextIndex < rcFiles.length) {
              setCurrentRCIndex(nextIndex);
              setLoadData({ ...initialEmptyLoadData });
              processRCFile(rcFiles[nextIndex]);
            } else {
              notify("All loads processed.", "success");
              setRcFiles([]);
              setIsMultiRCMode(false);
              setShowMultiLoadSection(false);
              setCurrentRCIndex(0);
              setCurrentPdfUrl(null);
            }
          }}
        >
          Skip
        </button>

        <button
          type="button"
          className={styles.addButtonAddLoad}
          onClick={async () => {
            const initialRcIndex = currentRCIndex;
            await handleSubmit();
            if (initialRcIndex === currentRCIndex) return;
            const nextIndex = currentRCIndex + 1;
            if (nextIndex < rcFiles.length) {
              setCurrentRCIndex(nextIndex);
              setLoadData({ ...initialEmptyLoadData });
              processRCFile(rcFiles[nextIndex]);
            } else {
              notify("All loads added.", "success");
              setRcFiles([]);
              setIsMultiRCMode(false);
              setShowMultiLoadSection(false);
              setCurrentRCIndex(0);
              setCurrentPdfUrl(null);
            }
          }}
        >
          ✓ Add Load
        </button>
      </div>
    </div>
  )}
</div>
        {/* end rightPreviewContainer */}

      </div>
      {/* end addLoadContentWrapper */}
<EmailPanel />
    </div>
    
    {/* end container */}
  </>
);

};

// ─── IFTA.jsx — rescris complet ───────────────────────────────────────────────
// Păstrează toată logica existentă, rescrie doar UI + PDF

const IFTA = () => {
  const { notify } = useNotification();

  // ── State ──────────────────────────────────────────────────────────────────
  const [showReportContainer, setShowReportContainer] = useState(false);
  const [showSuccess, setShowSuccess]   = useState(false);
  const [activeEditId, setActiveEditId] = useState(null);
  const [iftaData, setIftaData] = useState({
    fuelPurchasedState: "", fuelPrice: "", milesDrivenState: "",
    milesDriven: "", fuelLoaded: "", fuelConsumed: "", taxRate: "",
    quarter: "", year: "", dateOfFuelPurchase: "", fuelTaxPaid: "", paidIfta: "No"
  });
  const [reports, setReports]               = useState([]);
  const [selectedReports, setSelectedReports] = useState([]);
  const [searchQuery, setSearchQuery]       = useState("");
  const [selectAll, setSelectAll]           = useState(false);
  const [activeTab, setActiveTab]           = useState("entry"); // "entry" | "reports"
  const [theme, setTheme] = useState(() => sessionStorage.getItem("theme") || "dark");

  const apiUrl = "https://api-backend.full-trucking-service.com/api";
  const token  = sessionStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    withCredentials: true,
  };

  // ── US + Canada states ──────────────────────────────────────────────────────
  const states = [
    "Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut",
    "Delaware","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa",
    "Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan",
    "Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada",
    "New Hampshire","New Jersey","New Mexico","New York","North Carolina",
    "North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island",
    "South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont",
    "Virginia","Washington","West Virginia","Wisconsin","Wyoming",
    "Alberta","British Columbia","Manitoba","New Brunswick",
    "Newfoundland and Labrador","Nova Scotia","Ontario",
    "Prince Edward Island","Quebec","Saskatchewan",
  ];

  // ── IFTA tax rates per state (cents/gallon) — 2024 ─────────────────────────
  const STATE_TAX_RATES = {
    Alabama:14.5,Alaska:8,Arizona:26,Arkansas:21.5,California:66,Colorado:22,
    Connecticut:40.1,Delaware:23,Florida:35.425,Georgia:31.9,Hawaii:16,
    Idaho:32,Illinois:59.6,Indiana:53,Iowa:32.5,Kansas:24,Kentucky:26,
    Louisiana:20,Maine:30,Maryland:36.85,Massachusetts:24,Michigan:30.3,
    Minnesota:28.5,Mississippi:18,Missouri:17,Montana:27.75,Nebraska:24.6,
    Nevada:23,NewHampshire:22.2,NewJersey:41.4,NewMexico:18.875,NewYork:44.1,
    NorthCarolina:36.1,NorthDakota:23,Ohio:38.5,Oklahoma:19,Oregon:38,
    Pennsylvania:77.7,RhodeIsland:34,SouthCarolina:26,SouthDakota:28,
    Tennessee:27,Texas:20,Utah:31.9,Vermont:32,Virginia:27.8,
    Washington:49.4,WestVirginia:35.7,Wisconsin:30.9,Wyoming:24,
    Ontario:14.3,Quebec:19.2,Alberta:13,BritishColumbia:17.7,
    Manitoba:14,Saskatchewan:15,
  };

  const getTaxRate = (state) => {
    const key = state?.replace(/\s+/g,"");
    return STATE_TAX_RATES[key] || 0;
  };

  // ── Effects ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchTheme = async () => {
      try {
        const res = await axios.get(`${apiUrl}/settings`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTheme(res.data.theme || "dark");
      } catch { setTheme("dark"); }
    };
    fetchTheme();
  }, []);

  useEffect(() => { fetchReports(); }, []);

  // Auto-fill tax rate when state changes
  useEffect(() => {
    if (iftaData.fuelPurchasedState && !iftaData._id) {
      const rate = getTaxRate(iftaData.fuelPurchasedState);
      if (rate > 0) setIftaData(prev => ({ ...prev, taxRate: rate }));
    }
  }, [iftaData.fuelPurchasedState]);

  // Auto-calculate fuel consumed & tax
  useEffect(() => {
    const mpg        = 6.5; // avg diesel truck
    const miles      = parseFloat(iftaData.milesDriven) || 0;
    const loaded     = parseFloat(iftaData.fuelLoaded)  || 0;
    const consumed   = miles > 0 ? (miles / mpg).toFixed(2) : loaded;
    const taxRate    = parseFloat(iftaData.taxRate) || getTaxRate(iftaData.fuelPurchasedState);
    const netGallons = (loaded - parseFloat(consumed)).toFixed(2);
    const taxOwed    = ((parseFloat(consumed) * taxRate) / 100).toFixed(2);

    if (!iftaData._id) {
      setIftaData(prev => ({
        ...prev,
        fuelConsumed: consumed,
        fuelTaxPaid: taxOwed > 0 ? taxOwed : prev.fuelTaxPaid,
      }));
    }
  }, [iftaData.milesDriven, iftaData.fuelLoaded, iftaData.taxRate]);

  // ── Fetch ───────────────────────────────────────────────────────────────────
  const fetchReports = async () => {
    try {
      const res = await axios.get(`${apiUrl}/ifta`, config);
      setReports(res.data);
    } catch {}
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIftaData(prev => ({ ...prev, [name]: value }));
  };

  // ── Save ────────────────────────────────────────────────────────────────────
  const handleSaveAndDownload = async () => {
    const { fuelPurchasedState, milesDrivenState, fuelPrice, fuelLoaded, milesDriven, quarter, year, dateOfFuelPurchase } = iftaData;
    if (!iftaData._id) {
      if (!fuelPurchasedState || !milesDrivenState || !fuelPrice || !fuelLoaded || !milesDriven || !quarter || !year || !dateOfFuelPurchase) {
        notify("All required fields must be completed!", "error");
        return;
      }
    }
    const payload = {
      ...iftaData,
      fuelPrice:    parseFloat(iftaData.fuelPrice)    || 0,
      fuelLoaded:   parseFloat(iftaData.fuelLoaded)   || 0,
      milesDriven:  parseFloat(iftaData.milesDriven)  || 0,
      fuelConsumed: parseFloat(iftaData.fuelConsumed) || null,
      taxRate:      parseFloat(iftaData.taxRate)      || null,
      fuelTaxPaid:  parseFloat(iftaData.fuelTaxPaid)  || 0,
      paidIfta:     iftaData.paidIfta || "No",
    };
    try {
      if (iftaData._id) {
        await axios.put(`${apiUrl}/ifta/${iftaData._id}`, payload, config);
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 2500);
        setActiveEditId(null);
        fetchReports();
      } else {
        const res = await axios.post(`${apiUrl}/ifta`, payload, config);
        if (res.status === 201) {
          generatePDF(res.data.result);
          setShowSuccess(true);
          setTimeout(() => setShowSuccess(false), 2500);
          fetchReports();
          // Reset form
          setIftaData({ fuelPurchasedState:"",fuelPrice:"",milesDrivenState:"",milesDriven:"",fuelLoaded:"",fuelConsumed:"",taxRate:"",quarter:"",year:"",dateOfFuelPurchase:"",fuelTaxPaid:"",paidIfta:"No" });
        }
      }
    } catch {}
  };

  const handleEditReport = (report) => {
    setIftaData({ ...report });
    setActiveEditId(report._id);
  };

  // ── PDF Generation — professional IFTA form ────────────────────────────────
  const generatePDF = (data) => {
    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "letter" });
    const W = 215.9, M = 15;
    const amber = [245, 158, 11];
    const navy  = [7, 7, 12];
    const slate = [148, 163, 184];
    const white = [244, 244, 246];

    // ── Background ────────────────────────────────────────────────────────────
    doc.setFillColor(...navy);
    doc.rect(0, 0, W, 279.4, "F");

    // ── Header bar ───────────────────────────────────────────────────────────
    doc.setFillColor(...amber);
    doc.rect(0, 0, W, 32, "F");

    doc.setFillColor(200, 120, 0);
    doc.rect(0, 28, W, 4, "F");

    doc.setTextColor(7, 7, 12);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(22);
    doc.text("IFTA FUEL TAX RETURN", W / 2, 14, { align: "center" });
    doc.setFontSize(10);
    doc.text("International Fuel Tax Agreement", W / 2, 22, { align: "center" });
    doc.setFontSize(9);
    doc.text(`Quarter: ${data.quarter || "-"}   |   Year: ${data.year || "-"}`, W / 2, 29, { align: "center" });

    // ── Carrier Info box ─────────────────────────────────────────────────────
    let y = 42;
    doc.setFillColor(18, 18, 28);
    doc.roundedRect(M, y, W - M * 2, 28, 3, 3, "F");
    doc.setDrawColor(...amber);
    doc.setLineWidth(0.4);
    doc.roundedRect(M, y, W - M * 2, 28, 3, 3, "S");

    doc.setTextColor(...amber);
    doc.setFontSize(7);
    doc.setFont("helvetica", "bold");
    doc.text("CARRIER INFORMATION", M + 4, y + 7);

    const carrierFields = [
      ["IFTA License Number", "AUTO-GENERATED"],
      ["Report Date", new Date().toLocaleDateString("en-US")],
      ["Reporting Period", `${data.quarter} ${data.year}`],
      ["Date Submitted", new Date().toLocaleDateString("en-US")],
    ];

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8.5);
    carrierFields.forEach(([label, val], i) => {
      const col = i < 2 ? M + 4 : W / 2 + 4;
      const row = i < 2 ? y + 13 + (i * 8) : y + 13 + ((i - 2) * 8);
      doc.setTextColor(...slate);
      doc.text(label + ":", col, row);
      doc.setTextColor(...white);
      doc.text(String(val), col + 45, row);
    });

    // ── Section header helper ─────────────────────────────────────────────────
    const sectionHeader = (title, yPos) => {
      doc.setFillColor(...amber);
      doc.rect(M, yPos, W - M * 2, 7, "F");
      doc.setTextColor(7, 7, 12);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text(title, M + 3, yPos + 5);
      return yPos + 7;
    };

    // ── Row helper ────────────────────────────────────────────────────────────
    const dataRow = (label, value, yPos, highlight = false) => {
      if (highlight) {
        doc.setFillColor(245, 158, 11, 20);
        doc.rect(M, yPos - 3, W - M * 2, 9, "F");
      }
      doc.setTextColor(...slate);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      doc.text(label, M + 3, yPos);
      doc.setTextColor(...white);
      doc.setFont("helvetica", "bold");
      doc.text(String(value ?? "-"), W - M - 3, yPos, { align: "right" });
      doc.setDrawColor(255, 255, 255, 10);
      doc.setLineWidth(0.2);
      doc.line(M, yPos + 2, W - M, yPos + 2);
      return yPos + 9;
    };

    // ── Section 1: Fuel Purchases ─────────────────────────────────────────────
    y = 78;
    y = sectionHeader("SECTION 1 — FUEL PURCHASES", y);
    y = dataRow("State/Province of Purchase",      data.fuelPurchasedState || "-",  y + 5);
    y = dataRow("Fuel Price ($/gallon)",           `$${parseFloat(data.fuelPrice || 0).toFixed(3)}`,  y);
    y = dataRow("Total Gallons Purchased",         `${parseFloat(data.fuelLoaded || 0).toFixed(3)} gal`,  y);
    y = dataRow("Date of Purchase",                data.dateOfFuelPurchase ? new Date(data.dateOfFuelPurchase).toLocaleDateString("en-US") : "-",  y);
    const fuelCost = (parseFloat(data.fuelLoaded || 0) * parseFloat(data.fuelPrice || 0)).toFixed(2);
    y = dataRow("Total Fuel Cost",                 `$${fuelCost}`,  y, true);

    // ── Section 2: Miles Driven ───────────────────────────────────────────────
    y += 6;
    y = sectionHeader("SECTION 2 — MILES / KILOMETERS DRIVEN", y);
    y = dataRow("State/Province of Operation",    data.milesDrivenState || "-",  y + 5);
    y = dataRow("Total Miles Driven",             `${parseFloat(data.milesDriven || 0).toLocaleString("en-US")} mi`,  y);
    const mpg = data.fuelConsumed > 0 && data.milesDriven > 0
      ? (parseFloat(data.milesDriven) / parseFloat(data.fuelConsumed)).toFixed(2)
      : "N/A";
    y = dataRow("Fuel Economy (MPG)",             mpg !== "N/A" ? `${mpg} MPG` : "N/A",  y);

    // ── Section 3: Fuel Consumption ───────────────────────────────────────────
    y += 6;
    y = sectionHeader("SECTION 3 — FUEL CONSUMPTION & TAX CALCULATION", y);
    y = dataRow("Total Gallons Consumed",         `${parseFloat(data.fuelConsumed || 0).toFixed(3)} gal`,  y + 5);
    y = dataRow("Net Taxable Gallons",            `${(parseFloat(data.fuelLoaded || 0) - parseFloat(data.fuelConsumed || 0)).toFixed(3)} gal`,  y);
    y = dataRow("Applicable Tax Rate",            `${parseFloat(data.taxRate || 0).toFixed(2)} ¢/gal`,  y);

    // ── Tax Due box ───────────────────────────────────────────────────────────
    y += 4;
    doc.setFillColor(245, 158, 11, 30);
    doc.roundedRect(M, y, W - M * 2, 18, 3, 3, "F");
    doc.setDrawColor(...amber);
    doc.setLineWidth(0.8);
    doc.roundedRect(M, y, W - M * 2, 18, 3, 3, "S");

    doc.setTextColor(...amber);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("TOTAL FUEL TAX DUE / (CREDIT)", M + 5, y + 8);
    doc.setFontSize(16);
    doc.text(`$${parseFloat(data.fuelTaxPaid || 0).toFixed(2)}`, W - M - 5, y + 11, { align: "right" });

    doc.setFontSize(8);
    doc.setTextColor(data.paidIfta === "Yes" ? 52 : 248, data.paidIfta === "Yes" ? 211 : 113, data.paidIfta === "Yes" ? 153 : 113);
    doc.text(`Payment Status: ${data.paidIfta === "Yes" ? "✓ PAID" : "⚠ UNPAID"}`, M + 5, y + 15);

    // ── Summary table ─────────────────────────────────────────────────────────
    y += 26;
    doc.autoTable({
      startY: y,
      head: [["Field", "Value"]],
      body: [
        ["Fuel Purchased State",  data.fuelPurchasedState || "-"],
        ["Fuel Price ($/gal)",    `$${parseFloat(data.fuelPrice || 0).toFixed(3)}`],
        ["Gallons Purchased",     `${parseFloat(data.fuelLoaded || 0).toFixed(3)}`],
        ["Miles Driven State",    data.milesDrivenState || "-"],
        ["Miles Driven",          parseFloat(data.milesDriven || 0).toLocaleString("en-US")],
        ["Gallons Consumed",      parseFloat(data.fuelConsumed || 0).toFixed(3)],
        ["Tax Rate (¢/gal)",      parseFloat(data.taxRate || 0).toFixed(2)],
        ["Quarter / Year",        `${data.quarter} / ${data.year}`],
        ["Tax Paid",              `$${parseFloat(data.fuelTaxPaid || 0).toFixed(2)}`],
        ["IFTA Status",           data.paidIfta === "Yes" ? "PAID" : "UNPAID"],
      ],
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 3,
        textColor: [244, 244, 246],
        fillColor: [12, 12, 20],
        lineColor: [40, 40, 60],
        lineWidth: 0.3,
      },
      headStyles: {
        fillColor: [245, 158, 11],
        textColor: [7, 7, 12],
        fontStyle: "bold",
        fontSize: 9,
      },
      alternateRowStyles: { fillColor: [18, 18, 30] },
      columnStyles: { 1: { halign: "right", fontStyle: "bold" } },
      margin: { left: M, right: M },
    });

    // ── Footer ────────────────────────────────────────────────────────────────
    const pageH = doc.internal.pageSize.height;
    doc.setFillColor(...amber);
    doc.rect(0, pageH - 14, W, 14, "F");
    doc.setTextColor(7, 7, 12);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7.5);
    doc.text("IFTA Report — Generated by Full Trucking Service", W / 2, pageH - 8, { align: "center" });
    doc.text(`Generated: ${new Date().toLocaleString("en-US")}`, W / 2, pageH - 4, { align: "center" });

    doc.save(`IFTA_${data.quarter}_${data.year}_${Date.now()}.pdf`);
  };

  // ── Export ──────────────────────────────────────────────────────────────────
  const exportToExcel = () => {
    const data = reports
      .filter(r => selectedReports.includes(r._id))
      .map(({ fuelPurchasedState, milesDrivenState, fuelPrice, fuelConsumed, fuelLoaded, milesDriven, taxRate, quarter, year, dateOfFuelPurchase, fuelTaxPaid, paidIfta, createdAt }) => ({
        fuelPurchasedState, milesDrivenState, fuelPrice, fuelConsumed,
        fuelLoaded, milesDriven, taxRate, quarter, year,
        dateOfFuelPurchase, fuelTaxPaid, paidIfta, createdAt,
      }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "IFTA Reports");
    XLSX.writeFile(wb, "IFTA_Reports.xlsx");
  };

  const exportSelectedToPDF = () => {
    const doc = new jsPDF("landscape");
    doc.setFontSize(14);
    doc.text("IFTA Reports Export", 14, 16);
    doc.autoTable({
      startY: 22,
      head: [["State","Miles State","$/gal","Miles","Gal Loaded","Gal Consumed","Tax Rate","Qtr","Year","Paid","Tax Paid","Date"]],
      body: reports
        .filter(r => selectedReports.includes(r._id))
        .map(r => [
          r.fuelPurchasedState, r.milesDrivenState,
          `$${parseFloat(r.fuelPrice||0).toFixed(3)}`,
          parseFloat(r.milesDriven||0).toLocaleString(),
          parseFloat(r.fuelLoaded||0).toFixed(2),
          parseFloat(r.fuelConsumed||0).toFixed(2),
          `${parseFloat(r.taxRate||0).toFixed(2)}¢`,
          r.quarter, r.year, r.paidIfta,
          `$${parseFloat(r.fuelTaxPaid||0).toFixed(2)}`,
          r.dateOfFuelPurchase ? new Date(r.dateOfFuelPurchase).toLocaleDateString("en-US") : "-",
        ]),
      styles: { fontSize: 7.5, cellPadding: 2 },
      headStyles: { fillColor: [245,158,11], textColor: [7,7,12], fontStyle: "bold" },
      alternateRowStyles: { fillColor: [240,240,245] },
    });
    doc.save("IFTA_Export.pdf");
  };

  const toggleSelectAll = () => {
    const next = !selectAll;
    setSelectAll(next);
    setSelectedReports(next ? reports.map(r => r._id) : []);
  };

  const handleCheckboxChange = (id) => {
    setSelectedReports(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  // ── Computed stats ──────────────────────────────────────────────────────────
  const totalTaxOwed   = reports.reduce((s, r) => s + (parseFloat(r.fuelTaxPaid) || 0), 0);
  const totalMiles     = reports.reduce((s, r) => s + (parseFloat(r.milesDriven)  || 0), 0);
  const totalGallons   = reports.reduce((s, r) => s + (parseFloat(r.fuelLoaded)   || 0), 0);
  const unpaidCount    = reports.filter(r => r.paidIfta !== "Yes").length;
  const fleetMPG       = totalGallons > 0 ? (totalMiles / totalGallons).toFixed(2) : "—";

  const isLight = theme === "light";

  // ── CSS-in-JS tokens ────────────────────────────────────────────────────────
  const t = {
    bg:        isLight ? "#F1F0EB" : "#07070C",
    card:      isLight ? "#FFFFFF" : "rgba(12,12,20,0.95)",
    surface:   isLight ? "rgba(0,0,0,0.03)" : "rgba(255,255,255,0.03)",
    input:     isLight ? "#FFFFFF" : "rgba(255,255,255,0.06)",
    inputBorder: isLight ? "rgba(0,0,0,0.14)" : "rgba(255,255,255,0.11)",
    text:      isLight ? "#111827" : "#F4F4F6",
    muted:     isLight ? "#6B7280" : "#9A9AAF",
    accent:    "#F59E0B",
    accentDim: isLight ? "rgba(245,158,11,0.09)" : "rgba(245,158,11,0.11)",
    accentBorder: "rgba(245,158,11,0.28)",
    border:    isLight ? "rgba(0,0,0,0.08)" : "rgba(255,255,255,0.08)",
    tableHead: isLight ? "rgba(245,158,11,0.08)" : "rgba(245,158,11,0.06)",
    tableRow:  isLight ? "rgba(0,0,0,0.02)"  : "rgba(255,255,255,0.02)",
    tableHover: isLight ? "rgba(245,158,11,0.05)" : "rgba(245,158,11,0.06)",
  };

const inputStyle = {
  width: "100%",
  boxSizing: "border-box",
  padding: "10px 14px",
  borderRadius: 8,
  border: `1px solid ${t.inputBorder}`,
  background: t.input,
  backgroundColor: isLight ? "#FFFFFF" : "#0F0F18", // ← explicit
  color: t.text,
  fontFamily: "'DM Sans', sans-serif",
  fontSize: "0.875rem",
  outline: "none",
  colorScheme: isLight ? "light" : "dark",
};

const selectStyle = {
  ...inputStyle,
  appearance: "none",
  WebkitAppearance: "none",
  MozAppearance: "none",
  backgroundImage: `url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L6 7L11 1' stroke='%23F59E0B' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right 12px center",
  backgroundSize: "12px 8px",
  paddingRight: 36,
  cursor: "pointer",
  // ── fix culoare fundal nativ select ──────────────────
  backgroundColor: isLight ? "#FFFFFF" : "#0F0F18",
  colorScheme: isLight ? "light" : "dark",
};
  const labelStyle = {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: "0.7rem",
    fontWeight: 700,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: t.accent,
    marginBottom: 5,
    display: "block",
  };

  const btnPrimary = {
    display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8,
    padding: "11px 28px",
    borderRadius: 100,
    border: "none",
    background: "linear-gradient(135deg,#FBBF24 0%,#F59E0B 60%,#D97706 100%)",
    color: "#07070C",
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: "0.95rem", fontWeight: 700, letterSpacing: "0.09em", textTransform: "uppercase",
    cursor: "pointer",
    boxShadow: "0 4px 20px rgba(245,158,11,0.42)",
  };

  const btnGhost = (color = "#F59E0B") => ({
    display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6,
    padding: "9px 20px",
    borderRadius: 100,
    border: `1px solid ${color}44`,
    background: `${color}11`,
    color: color,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: "0.82rem", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase",
    cursor: "pointer",
  });

  // ── Form fields config ──────────────────────────────────────────────────────
  const formFields = [
    { name: "fuelPurchasedState", label: "Fuel Purchased State *", type: "select" },
    { name: "fuelPrice",          label: "Fuel Price ($/gallon) *", type: "number", step: "0.001", placeholder: "e.g. 3.459" },
    { name: "milesDrivenState",   label: "Miles Driven State *",    type: "select" },
    { name: "milesDriven",        label: "Total Miles Driven *",    type: "number", placeholder: "e.g. 12500" },
    { name: "fuelLoaded",         label: "Gallons Purchased *",     type: "number", step: "0.001", placeholder: "e.g. 150.000" },
    { name: "fuelConsumed",       label: "Gallons Consumed (auto)", type: "number", step: "0.001", placeholder: "Auto-calculated" },
    { name: "taxRate",            label: "Tax Rate ¢/gal (auto)",   type: "number", step: "0.01",  placeholder: "Auto-filled by state" },
    { name: "fuelTaxPaid",        label: "Fuel Tax Due ($)",        type: "number", step: "0.01",  placeholder: "Auto-calculated" },
    { name: "quarter",            label: "Quarter *",               type: "select-quarter" },
    { name: "year",               label: "Year *",                  type: "number", placeholder: new Date().getFullYear() },
    { name: "dateOfFuelPurchase", label: "Date of Fuel Purchase *", type: "date" },
    { name: "paidIfta",           label: "IFTA Status",             type: "select-paid" },
  ];

  return (
    <>
      {/* ── PAGE WRAPPER ────────────────────────────────────────────────────── */}
      <div style={{
        minHeight: "100vh",
        background: t.bg,
        paddingTop: 90,
        paddingBottom: 60,
        fontFamily: "'DM Sans', sans-serif",
        color: t.text,
        boxSizing: "border-box",
      }}>

        {/* ── HEADER ────────────────────────────────────────────────────────── */}
        <div style={{
          maxWidth: 1100,
          margin: "0 auto",
          padding: "0 24px 28px",
        }}>
          <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", flexWrap: "wrap", gap: 16 }}>
            <div>
              <p style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "0.72rem", fontWeight: 700, letterSpacing: "0.15em", textTransform: "uppercase", color: t.accent, margin: "0 0 4px" }}>
                International Fuel Tax Agreement
              </p>
              <h1 style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "2.8rem", fontWeight: 800, letterSpacing: "0.04em", textTransform: "uppercase", color: t.text, margin: 0, lineHeight: 1 }}>
                IFTA Reporting
              </h1>
              <div style={{ width: 52, height: 3, background: `linear-gradient(90deg,${t.accent},transparent)`, marginTop: 10, borderRadius: 2 }} />
            </div>
            <button style={btnPrimary} onClick={() => setShowReportContainer(true)}>
              View All Reports ({reports.length})
            </button>
          </div>
        </div>

        {/* ── KPI CARDS ─────────────────────────────────────────────────────── */}
        <div style={{
          maxWidth: 1100, margin: "0 auto", padding: "0 24px 28px",
          display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))", gap: 14,
        }}>
          {[
            { label: "Total Tax Owed",    value: `$${totalTaxOwed.toFixed(2)}`,                  color: "#F59E0B" },
            { label: "Total Miles",       value: totalMiles.toLocaleString("en-US") + " mi",      color: "#60A5FA" },
            { label: "Total Gallons",     value: totalGallons.toFixed(0) + " gal",                color: "#A78BFA" },
            { label: "Fleet Avg MPG",     value: fleetMPG,                                        color: "#34D399" },
            { label: "Unpaid Returns",    value: unpaidCount,                                     color: unpaidCount > 0 ? "#F87171" : "#34D399" },
          ].map((k, i) => (
            <div key={i} style={{
              background: t.card,
              border: `1px solid ${t.border}`,
              borderTop: `2px solid ${k.color}`,
              borderRadius: 12,
              padding: "16px 20px",
              boxShadow: isLight ? "0 2px 8px rgba(0,0,0,0.06)" : "0 8px 24px rgba(0,0,0,0.4)",
            }}>
              <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: t.muted, marginBottom: 6 }}>{k.label}</div>
              <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "1.9rem", fontWeight: 800, color: k.color, lineHeight: 1 }}>{k.value}</div>
            </div>
          ))}
        </div>

        {/* ── FORM CARD ─────────────────────────────────────────────────────── */}
        <div style={{
          maxWidth: 1100, margin: "0 auto", padding: "0 24px",
        }}>
          <div style={{
            background: t.card,
            border: `1px solid ${t.border}`,
            borderRadius: 18,
            padding: "32px 36px",
            boxShadow: isLight ? "0 4px 24px rgba(0,0,0,0.08)" : "0 16px 48px rgba(0,0,0,0.6)",
            position: "relative",
            overflow: "hidden",
          }}>
            {/* top accent line */}
            <div style={{ position: "absolute", top: 0, left: "10%", width: "80%", height: 1, background: `linear-gradient(90deg,transparent,${t.accent},transparent)`, opacity: 0.5 }} />

            <h2 style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "1.3rem", fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", color: t.text, margin: "0 0 24px", display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ display: "inline-block", width: 3, height: 18, background: t.accent, borderRadius: 2 }} />
              New IFTA Return Entry
            </h2>

            {/* Grid form */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))", gap: "16px 24px" }}>
              {formFields.map(field => (
                <div key={field.name}>
                  <label style={labelStyle}>{field.label}</label>
                  {field.type === "select" ? (
                    <select
                      name={field.name}
                      value={iftaData[field.name]}
                      onChange={handleChange}
                      style={selectStyle}
                    >
                      <option value="">— Select State / Province —</option>
                      {states.map((s, i) => <option key={i} value={s}>{s}</option>)}
                    </select>
                  ) : field.type === "select-quarter" ? (
                    <select name="quarter" value={iftaData.quarter} onChange={handleChange} style={selectStyle}>
                      <option value="">— Select Quarter —</option>
                      <option value="Q1">Q1 (Jan – Mar)</option>
                      <option value="Q2">Q2 (Apr – Jun)</option>
                      <option value="Q3">Q3 (Jul – Sep)</option>
                      <option value="Q4">Q4 (Oct – Dec)</option>
                    </select>
                  ) : field.type === "select-paid" ? (
                    <select name="paidIfta" value={iftaData.paidIfta || "No"} onChange={handleChange} style={selectStyle}>
                      <option value="No">⚠ Unpaid</option>
                      <option value="Yes">✓ Paid</option>
                    </select>
                  ) : (
                    <input
                      type={field.type}
                      name={field.name}
                      value={iftaData[field.name]}
                      onChange={handleChange}
                      placeholder={field.placeholder}
                      step={field.step}
                      style={{
                        ...inputStyle,
                        ...(["fuelConsumed","taxRate","fuelTaxPaid"].includes(field.name) ? {
                          borderColor: `${t.accent}44`,
                          background: isLight ? "rgba(245,158,11,0.04)" : "rgba(245,158,11,0.06)",
                        } : {}),
                      }}
                    />
                  )}
                </div>
              ))}
            </div>

            {/* Auto-calc info */}
            {iftaData.milesDriven && iftaData.fuelLoaded && (
              <div style={{
                marginTop: 20,
                padding: "12px 16px",
                background: "rgba(245,158,11,0.08)",
                border: "1px solid rgba(245,158,11,0.22)",
                borderRadius: 10,
                fontSize: "0.82rem",
                color: t.muted,
                display: "flex", flexWrap: "wrap", gap: 20,
              }}>
                <span><strong style={{ color: t.accent }}>Auto-calculated:</strong></span>
                <span>Consumed: <strong style={{ color: t.text }}>{iftaData.fuelConsumed} gal</strong></span>
                <span>Tax Rate: <strong style={{ color: t.text }}>{iftaData.taxRate} ¢/gal</strong></span>
                <span>Tax Due: <strong style={{ color: "#F87171" }}>${iftaData.fuelTaxPaid}</strong></span>
                <span>MPG: <strong style={{ color: "#34D399" }}>
                  {iftaData.fuelConsumed > 0 ? (parseFloat(iftaData.milesDriven) / parseFloat(iftaData.fuelConsumed)).toFixed(2) : "—"}
                </strong></span>
              </div>
            )}

            {/* Save button */}
            <div style={{ marginTop: 24, display: "flex", gap: 12, justifyContent: "flex-end" }}>
              <button
                style={btnPrimary}
                onClick={handleSaveAndDownload}
              >
                Save & Download PDF
              </button>
            </div>
          </div>
        </div>

        {/* ── SUCCESS TOAST ────────────────────────────────────────────────── */}
        {showSuccess && (
          <div style={{
            position: "fixed", top: 90, right: 24, zIndex: 10001,
            background: "linear-gradient(135deg,#FBBF24,#F59E0B)",
            color: "#07070C",
            padding: "14px 24px",
            borderRadius: 12,
            fontFamily: "'Barlow Condensed',sans-serif",
            fontSize: "0.95rem", fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase",
            boxShadow: "0 8px 24px rgba(245,158,11,0.5)",
            animation: "slideInRight 0.3s ease",
          }}>
            ✓ IFTA Return Saved & PDF Downloaded
          </div>
        )}
      </div>

      {/* ── REPORTS MODAL — fixed, full screen ─────────────────────────────── */}
      {showReportContainer && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: isLight ? "rgba(241,240,235,0.97)" : "rgba(7,7,12,0.97)",
            backdropFilter: "blur(8px)",
            WebkitBackdropFilter: "blur(8px)",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            paddingTop: 70, // under header
          }}
        >
          {/* Modal header */}
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "14px 24px",
            borderBottom: `1px solid ${t.border}`,
            background: t.card,
            flexShrink: 0,
            flexWrap: "wrap",
            gap: 12,
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <h2 style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "1.4rem", fontWeight: 800, letterSpacing: "0.05em", textTransform: "uppercase", color: t.text, margin: 0 }}>
                IFTA Reports
                <span style={{ marginLeft: 10, fontSize: "0.8rem", color: t.accent, fontWeight: 600 }}>
                  {reports.length} records
                </span>
              </h2>
            </div>

            {/* Search in modal */}
            <input
              type="text"
              placeholder="Search by state..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              style={{ ...inputStyle, width: 220, padding: "8px 14px" }}
            />

            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <button style={btnGhost("#60A5FA")} onClick={exportToExcel}>
                Excel ({selectedReports.length})
              </button>
              <button style={btnGhost("#34D399")} onClick={exportSelectedToPDF}>
                PDF ({selectedReports.length})
              </button>
              <button
                onClick={() => setShowReportContainer(false)}
                style={{
                  width: 36, height: 36,
                  borderRadius: "50%",
                  border: "1px solid rgba(239,68,68,0.35)",
                  background: "rgba(239,68,68,0.1)",
                  color: "#F87171",
                  fontSize: "1.1rem",
                  cursor: "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}
              >
                ✕
              </button>
            </div>
          </div>

          {/* Summary bar */}
          <div style={{
            display: "flex", gap: 24, padding: "10px 24px",
            background: isLight ? "rgba(245,158,11,0.06)" : "rgba(245,158,11,0.04)",
            borderBottom: `1px solid ${t.border}`,
            flexShrink: 0, flexWrap: "wrap",
            fontSize: "0.8rem",
          }}>
            {[
              { label: "Total Tax", value: `$${totalTaxOwed.toFixed(2)}`, color: "#F59E0B" },
              { label: "Total Miles", value: `${totalMiles.toLocaleString()} mi`, color: "#60A5FA" },
              { label: "Total Gallons", value: `${totalGallons.toFixed(0)} gal`, color: "#A78BFA" },
              { label: "Fleet MPG", value: fleetMPG, color: "#34D399" },
              { label: "Unpaid", value: unpaidCount, color: unpaidCount > 0 ? "#F87171" : "#34D399" },
            ].map((s, i) => (
              <span key={i}>
                <span style={{ color: t.muted }}>{s.label}: </span>
                <strong style={{ color: s.color }}>{s.value}</strong>
              </span>
            ))}
          </div>

          {/* Table */}
          <div style={{ flex: 1, overflowY: "auto", overflowX: "auto", padding: "0 0 20px" }}>
            <table style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "0.82rem",
              minWidth: 1100,
            }}>
              <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                <tr style={{ background: isLight ? "rgba(245,158,11,0.08)" : "rgba(245,158,11,0.06)" }}>
                  <th style={{ padding: "11px 14px", textAlign: "center" }}>
                    <input type="checkbox" checked={selectAll} onChange={toggleSelectAll} style={{ accentColor: t.accent }} />
                  </th>
                  {["State","$/gal","Miles State","Miles","Gal Bought","Gal Used","Tax Rate","Tax Due","Qtr","Year","Status","Purchase Date","Saved At","Actions"].map(h => (
                    <th key={h} style={{
                      padding: "11px 12px",
                      textAlign: "center",
                      fontFamily: "'Barlow Condensed',sans-serif",
                      fontSize: "0.7rem",
                      fontWeight: 700,
                      letterSpacing: "0.08em",
                      textTransform: "uppercase",
                      color: t.accent,
                      borderBottom: `2px solid ${t.accentBorder}`,
                      whiteSpace: "nowrap",
                    }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {reports
                  .filter(r =>
                    r.fuelPurchasedState?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    r.milesDrivenState?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    r.quarter?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    String(r.year).includes(searchQuery)
                  )
                  .map((report, idx) => (
                    <>
                      <tr
                        key={report._id}
                        onClick={() => handleEditReport(report)}
                        style={{
                          background: idx % 2 === 0 ? t.tableRow : "transparent",
                          cursor: "pointer",
                          borderBottom: `1px solid ${t.border}`,
                          transition: "background 0.15s",
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = t.tableHover}
                        onMouseLeave={e => e.currentTarget.style.background = idx % 2 === 0 ? t.tableRow : "transparent"}
                      >
                        <td style={{ padding: "9px 14px", textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={selectedReports.includes(report._id)}
                            onChange={() => handleCheckboxChange(report._id)}
                            onClick={e => e.stopPropagation()}
                            style={{ accentColor: t.accent }}
                          />
                        </td>
                        <td style={{ padding: "9px 12px", textAlign: "center", color: t.text, fontWeight: 600 }}>{report.fuelPurchasedState}</td>
                        <td style={{ padding: "9px 12px", textAlign: "center", color: t.text }}>${parseFloat(report.fuelPrice||0).toFixed(3)}</td>
                        <td style={{ padding: "9px 12px", textAlign: "center", color: t.muted }}>{report.milesDrivenState}</td>
                        <td style={{ padding: "9px 12px", textAlign: "center", color: t.text }}>{parseFloat(report.milesDriven||0).toLocaleString()}</td>
                        <td style={{ padding: "9px 12px", textAlign: "center", color: t.muted }}>{parseFloat(report.fuelLoaded||0).toFixed(2)}</td>
                        <td style={{ padding: "9px 12px", textAlign: "center", color: t.muted }}>{parseFloat(report.fuelConsumed||0).toFixed(2)}</td>
                        <td style={{ padding: "9px 12px", textAlign: "center", color: t.muted }}>{parseFloat(report.taxRate||0).toFixed(2)}¢</td>
                        <td style={{ padding: "9px 12px", textAlign: "center", color: "#F59E0B", fontWeight: 700 }}>${parseFloat(report.fuelTaxPaid||0).toFixed(2)}</td>
                        <td style={{ padding: "9px 12px", textAlign: "center", color: t.text }}>{report.quarter}</td>
                        <td style={{ padding: "9px 12px", textAlign: "center", color: t.text }}>{report.year}</td>
                        <td style={{ padding: "9px 12px", textAlign: "center" }}>
                          <span style={{
                            padding: "3px 10px", borderRadius: 100,
                            fontSize: "0.7rem", fontWeight: 700,
                            background: report.paidIfta === "Yes" ? "rgba(52,211,153,0.15)" : "rgba(248,113,113,0.15)",
                            color: report.paidIfta === "Yes" ? "#34D399" : "#F87171",
                          }}>
                            {report.paidIfta === "Yes" ? "✓ PAID" : "⚠ UNPAID"}
                          </span>
                        </td>
                        <td style={{ padding: "9px 12px", textAlign: "center", color: t.muted, fontSize: "0.78rem" }}>
                          {report.dateOfFuelPurchase ? new Date(report.dateOfFuelPurchase).toLocaleDateString("en-US") : "-"}
                        </td>
                        <td style={{ padding: "9px 12px", textAlign: "center", color: t.muted, fontSize: "0.75rem" }}>
                          {report.createdAt ? new Date(report.createdAt).toLocaleDateString("en-US") : "-"}
                        </td>
                        <td style={{ padding: "9px 12px", textAlign: "center" }}>
                          <button
                            style={{ ...btnGhost("#34D399"), padding: "5px 12px", fontSize: "0.72rem" }}
                            onClick={e => { e.stopPropagation(); generatePDF(report); }}
                          >
                            ⬇ PDF
                          </button>
                        </td>
                      </tr>

                      {/* Inline edit */}
                      {activeEditId === report._id && (
                        <tr key={`edit-${report._id}`}>
                          <td colSpan={15} style={{ padding: 0 }}>
                            <div style={{
                              background: isLight ? "#F9F8F5" : "rgba(255,255,255,0.03)",
                              border: `1px solid rgba(245,158,11,0.22)`,
                              borderRadius: 12,
                              padding: 24,
                              margin: "4px 8px",
                              position: "relative",
                            }}>
                              <button
                                onClick={() => { setActiveEditId(null); setIftaData({ fuelPurchasedState:"",fuelPrice:"",milesDrivenState:"",milesDriven:"",fuelLoaded:"",fuelConsumed:"",taxRate:"",quarter:"",year:"",dateOfFuelPurchase:"",fuelTaxPaid:"",paidIfta:"No" }); }}
                                style={{ position: "absolute", top: 12, right: 12, width: 28, height: 28, borderRadius: "50%", border: "1px solid rgba(239,68,68,0.3)", background: "rgba(239,68,68,0.08)", color: "#F87171", cursor: "pointer", fontSize: "0.85rem" }}
                              >✕</button>

                              <p style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: "0.72rem", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: t.accent, margin: "0 0 16px" }}>
                                Editing Return
                              </p>

                              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))", gap: "12px 20px" }}>
                                {formFields.map(field => (
                                  <div key={field.name}>
                                    <label style={{ ...labelStyle, fontSize: "0.65rem" }}>{field.label}</label>
                                    {field.type === "select" ? (
                                      <select name={field.name} value={iftaData[field.name]} onChange={handleChange} style={{ ...selectStyle, padding: "8px 12px", fontSize: "0.82rem" }}>
                                        <option value="">— Select —</option>
                                        {states.map((s, i) => <option key={i} value={s}>{s}</option>)}
                                      </select>
                                    ) : field.type === "select-quarter" ? (
                                      <select name="quarter" value={iftaData.quarter} onChange={handleChange} style={{ ...selectStyle, padding: "8px 12px", fontSize: "0.82rem" }}>
                                        <option value="">— Quarter —</option>
                                        <option value="Q1">Q1 (Jan–Mar)</option>
                                        <option value="Q2">Q2 (Apr–Jun)</option>
                                        <option value="Q3">Q3 (Jul–Sep)</option>
                                        <option value="Q4">Q4 (Oct–Dec)</option>
                                      </select>
                                    ) : field.type === "select-paid" ? (
                                      <select name="paidIfta" value={iftaData.paidIfta || "No"} onChange={handleChange} style={{ ...selectStyle, padding: "8px 12px", fontSize: "0.82rem" }}>
                                        <option value="No">⚠ Unpaid</option>
                                        <option value="Yes">✓ Paid</option>
                                      </select>
                                    ) : (
                                      <input type={field.type} name={field.name} value={iftaData[field.name]} onChange={handleChange} step={field.step} style={{ ...inputStyle, padding: "8px 12px", fontSize: "0.82rem" }} />
                                    )}
                                  </div>
                                ))}
                              </div>

                              <div style={{ display: "flex", gap: 10, marginTop: 18, justifyContent: "flex-end" }}>
                                <button style={btnPrimary} onClick={handleSaveAndDownload}>Save Changes</button>
                                <button
                                  style={{ ...btnGhost("#F87171"), padding: "10px 20px" }}
                                  onClick={async () => {
                                    try {
                                      await axios.delete(`${apiUrl}/ifta/${report._id}`, config);
                                      setIftaData({ fuelPurchasedState:"",fuelPrice:"",milesDrivenState:"",milesDriven:"",fuelLoaded:"",fuelConsumed:"",taxRate:"",quarter:"",year:"",dateOfFuelPurchase:"",fuelTaxPaid:"",paidIfta:"No" });
                                      setActiveEditId(null);
                                      fetchReports();
                                    } catch {}
                                  }}
                                >
                                  Delete
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  ))}
              </tbody>
            </table>

            {reports.length === 0 && (
              <div style={{ textAlign: "center", padding: "60px 0", color: t.muted, fontStyle: "italic" }}>
                No IFTA reports yet. Add your first return above.
              </div>
            )}
          </div>
          
        </div>
      )}

      <style>{`
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(20px); }
          to   { opacity: 1; transform: translateX(0); }
        }
      `}</style>
      <EmailPanel />
    </>
  );
 
};

const Settings = ({ updateUserSettings, drivers = [], handleUpdateDriver }) => {
  const [billingInfo, setBillingInfo] = useState(null);
const [showInvoices, setShowInvoices] = useState(false);
  const { notify } = useNotification();
  const [updatedSettings, setUpdatedSettings] = useState({
    companyName: '',
    companyAddress: '',
    firstName: '',
    lastName: '',
    mcNumber: '',
    phone: '',
    fax: '',
    email: '',
    password: '',
    subscriptionType: '',
    contractStart: '',
    package: '',
    contractEnd: '',
    notes: '',
     theme: localStorage.getItem("theme") || "dark"
  });

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedTrucks, setSelectedTrucks] = useState([]);
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [trucks, setTrucks] = useState([]);
  const [driverEmail, setDriverEmail] = useState('');
  const [twoFactorMethod, setTwoFactorMethod] = useState('email');
const [qrCodeUrl, setQrCodeUrl] = useState('');
const [authenticatorSecret, setAuthenticatorSecret] = useState('');
const [verificationCode, setVerificationCode] = useState('');
const [isVerifying2FA, setIsVerifying2FA] = useState(false);
const [selectedPDFType, setSelectedPDFType] = useState('DriverPay');
const [pdfTemplates, setPdfTemplates] = useState([]);
const [editingTemplate, setEditingTemplate] = useState(null);
const [templateName, setTemplateName] = useState('');
const [templateContent, setTemplateContent] = useState({}); // conținutul JSON
const [selectedTheme, setSelectedTheme] = useState([]);
const [payrollWeekSettings, setPayrollWeekSettings] = useState({
  enabled: false,
  baseWeek: '',
  baseWeekDate: ''
});



  const [driverPassword, setDriverPassword] = useState('');
  const [subscriptionInfo, setSubscriptionInfo] = useState({
    paymentType: '',
    expirationDate: ''
  });

  const [isTwoFactorEnabled, setIsTwoFactorEnabled] = useState(false);
  const [twoFactorWarning, setTwoFactorWarning] = useState(false);
  

   
  const [dispatchers, setDispatchers] = useState([]);
  const [accountings, setAccountings] = useState([]);
  const [selectedRole, setSelectedRole] = useState('dispatcher');
  const [newAccountFirstName, setNewAccountFirstName] = useState('');
  const [newAccountLastName, setNewAccountLastName] = useState('');
  const [newAccountEmail, setNewAccountEmail] = useState('');
  const [newAccountPhone, setNewAccountPhone] = useState('');
  const [newAccountAddress, setNewAccountAddress] = useState('');
  const [newAccountDOB, setNewAccountDOB] = useState('');
  const [newAccountSalary, setNewAccountSalary] = useState('');
  const [newAccountPassword, setNewAccountPassword] = useState('');
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [emailStatus, setEmailStatus] = useState({ connected: false });
const [emailInbox, setEmailInbox] = useState([]);
const [loadingInbox, setLoadingInbox] = useState(false);
const [showInbox, setShowInbox] = useState(false);
const [inboxSearch, setInboxSearch] = useState('');
const [selectedEmail, setSelectedEmail] = useState(null);
const [theme, setTheme] = useState(
  () => localStorage.getItem("theme") || sessionStorage.getItem("theme") || "dark"
);
  const token = sessionStorage.getItem('token');
  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  useEffect(() => {
  fetchPayrollWeekSettings();
}, []);

// ✅ Adaugă asta imediat în componenta Settings, la mount
useEffect(() => {
  const savedTheme = localStorage.getItem("theme") || "dark";
  document.body.setAttribute("data-theme", savedTheme);
  document.documentElement.setAttribute("data-theme", savedTheme);
  document.body.style.background = savedTheme === "light" ? "#F1F0EB" : "#07070C";
  document.documentElement.style.background = savedTheme === "light" ? "#F1F0EB" : "#07070C";
}, []); // se execută sincron la mount, înainte de orice fetch

const fetchPayrollWeekSettings = async () => {
  try {
    const res = await axios.get(`${apiUrl}/payroll-week`, config);

    setPayrollWeekSettings({
      enabled: !!res.data.enabled,
      baseWeek: res.data.baseWeek || '',
      baseWeekDate: res.data.baseWeekDate
        ? res.data.baseWeekDate.split('T')[0]
        : ''
    });
  } catch (err) {
    console.warn('Payroll week not configured yet');
  }
};


const fetchSettings = async () => {
  try {
    const response = await axios.get(`${apiUrl}/settings`, config);
    const settings = response.data;
    const savedTheme = settings.theme || "dark";

    // ✅ Salvează în ambele storages cu cheia corectă "theme"
    localStorage.setItem("theme", savedTheme);
    sessionStorage.setItem("theme", savedTheme);

    // ✅ Aplică imediat pe body — elimină flash-ul negru
    document.body.setAttribute("data-theme", savedTheme);
    document.documentElement.setAttribute("data-theme", savedTheme);
    document.body.style.background = savedTheme === "light" ? "#F1F0EB" : "#07070C";
    document.documentElement.style.background = savedTheme === "light" ? "#F1F0EB" : "#07070C";

    setUpdatedSettings({
      companyName:      settings.companyName || '',
      companyAddress:   settings.companyAddress || '',
      firstName:        settings.firstName || '',
      lastName:         settings.lastName || '',
      mcNumber:         settings.mcNumber || '',
      phone:            settings.phone || '',
      fax:              settings.fax || '',
      email:            settings.email || '',
      password:         settings.password || '',
      subscriptionType: settings.subscriptionType || '',
      contractStart:    settings.contractStart ? settings.contractStart.split('T')[0] : '',
      contractEnd:      settings.contractEnd ? settings.contractEnd.split('T')[0] : '',
      package:          settings.package || '',
      notes:            settings.notes || '',
      theme:            savedTheme,
    });

    setSubscriptionInfo({
      subscriptionType: settings.subscriptionType || 'No data',
      contractEnd:      settings.contractEnd ? settings.contractEnd.split('T')[0] : 'No data',
      package:          settings.package || 'No data',
    });

    setIsTwoFactorEnabled(settings.twoFactorAuthEnabled || false);
    setTwoFactorWarning(!settings.twoFactorAuthEnabled);
  } catch (error) {
    // silent
  }
};

  useEffect(() => {
  fetchEmailStatus();
  // Verifică dacă tocmai s-a conectat
  const params = new URLSearchParams(window.location.search);
  if (params.get('emailConnected')) {
    notify(`${params.get('emailConnected').toUpperCase()} connected successfully!`, 'success');
    fetchEmailStatus();
  }
}, []);

const fetchEmailStatus = async () => {
  try {
    const res = await axios.get(`${apiUrl}/email/status`, config);
    setEmailStatus(res.data);
  } catch {}
};

const handleConnectGmail = async () => {
  try {
    const res = await axios.get(`${apiUrl}/email/gmail/connect`, config);
    window.location.href = res.data.url;
  } catch {
    notify('Failed to start Gmail connection', 'error');
  }
};

const handleConnectOutlook = async () => {
  try {
    const res = await axios.get(`${apiUrl}/email/outlook/connect`, config);
    window.location.href = res.data.url;
  } catch {
    notify('Failed to start Outlook connection', 'error');
  }
};

const handleDisconnectEmail = async () => {
  try {
    await axios.delete(`${apiUrl}/email/disconnect`, config);
    setEmailStatus({ connected: false });
    setEmailInbox([]);
    notify('Email disconnected', 'success');
  } catch {
    notify('Failed to disconnect', 'error');
  }
};


const fetchInbox = async (searchQuery = '') => {
  setLoadingInbox(true);
  setShowInbox(true);
  try {
    const res = await axios.get(`${apiUrl}/email/inbox`, {
      ...config,
      params: { search: searchQuery, maxResults: 30 }
    });
    setEmailInbox(res.data);
  } catch {
    notify('Failed to load inbox', 'error');
  } finally {
    setLoadingInbox(false);
  }
};

// Handler search cu debounce
const handleInboxSearch = (e) => {
  const val = e.target.value;
  setInboxSearch(val);
  clearTimeout(window._inboxSearchTimer);
  window._inboxSearchTimer = setTimeout(() => {
    fetchInbox(val);
  }, 500);
};

const handleImportAttachment = async (messageId, attachmentId, filename, mimeType) => {
  try {
    await axios.post(`${apiUrl}/email/import-attachment`, {
      messageId, attachmentId, filename, mimeType, docType: 'other',
    }, config);
    notify(`"${filename}" imported to Documents!`, 'success');
  } catch {
    notify('Failed to import attachment', 'error');
  }
};

const handleChange = (e) => {
  const { name, value } = e.target;

  // 🔥 Salvează tema instant în localStorage
  if (name === "theme") {
    const finalTheme = value === "light" ? "light" : "dark";
    localStorage.setItem("fts-theme", finalTheme);
  }

  setUpdatedSettings(prev => ({
    ...prev,
    [name]: value
  }));
};

const handleSaveSettings = async () => {
  if (password && password !== confirmPassword) {
    notify('Passwords do not match!', 'error');
    return;
  }

  const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@!#$%^&*])[A-Za-z\d@!#$%^&*]{12,}$/;
  if (password && !passwordRegex.test(password)) {
    notify('Password must be at least 12 characters long, contain an uppercase letter, a number, and a special character (@!#$%^&*).', 'error');
    return;
  }

  setIsSaving(true);

  try {
    const updatedData = {
      ...updatedSettings,
      theme: updatedSettings.theme || 'dark'
    };

    // 🔥 1. Salvăm tema instant în localStorage → fără flicker la reload
localStorage.setItem("fts-theme", updatedData.theme);
sessionStorage.setItem("theme", updatedData.theme); // ✅ ADAUGĂ ASTA

    // Include parola doar dacă e setată
    if (password) {
      updatedData.password = password;
    }

    // 🔥 2. Trimitem către backend
    await updateUserSettings(updatedData);

    // 🔥 3. Refetch pentru UI stabil
    await fetchSettings();

    if (password) {
      notify('Password changed successfully. Please log in again.', 'success');
      sessionStorage.removeItem('token');
      window.location.href = '/login';
    } else {
      notify('Settings updated successfully', 'success');
      window.location.reload();
    }

  } catch (error) {
    notify('Failed to update settings. Please try again.', 'error');
  } finally {
    setIsSaving(false);
  }
};


const fetchBilling = async () => {
  try {
    const clientId = localStorage.getItem("clientId");
    const response = await axios.get(`${apiUrl}/billing/${clientId}`, config);
    setBillingInfo(response.data);
  } catch (err) {
    notify("Failed to fetch billing info", "error");
  }
};

const openBillingPortal = async () => {
  try {
    const clientId = localStorage.getItem("clientId");
    const response = await axios.post(`${apiUrl}/billing/portal`, { clientId }, config);
    window.location.href = response.data.url;
  } catch (err) {
    notify("Failed to open billing portal", "error");
  }
};

useEffect(() => {
  fetchBilling();
}, []);

const handleDriverSelection = (driverId) => {
  setSelectedDrivers((prevSelected) =>
    prevSelected.includes(driverId)
      ? prevSelected.filter((id) => id !== driverId)
      : [...prevSelected, driverId]
  );
};

const handleTruckSelection = (truckId) => {
  setSelectedTrucks((prevSelected) =>
    prevSelected.includes(truckId)
      ? prevSelected.filter((id) => id !== truckId)
      : [...prevSelected, truckId]
  );
};

const handleEnableAuthenticator = async () => {
  try {
    const response = await axios.post(`${apiUrl}/two-factor/setup`, {}, config);
    const { otpauthUrl, secret } = response.data;

    setQrCodeUrl(otpauthUrl);
    setAuthenticatorSecret(secret);
    setIsVerifying2FA(true); // ✨ Afișează formularul de confirmare
  } catch (error) {
   
   notify('Failed to generate Authenticator QR code.' , 'error');
  }
};


const handleVerifyAuthenticatorCode = async () => {
  try {
    const response = await axios.post(`${apiUrl}/two-factor/verify`, {
      code: verificationCode,
      secret: authenticatorSecret,
    }, config);

   notify('2FA via Authenticator enabled successfully!' , 'succes');
    setIsTwoFactorEnabled(true);
    setTwoFactorWarning(false);
    setQrCodeUrl('');
    setAuthenticatorSecret('');
    setVerificationCode('');
    setIsVerifying2FA(false);
  } catch (error) {
  
    notify('Invalid code. Please try again.' , 'error');
  }
};

// ── STATE NOU (adaugă lângă celelalte useState) ──
const [notifPrefs, setNotifPrefs] = useState({
  enabled: true,
  categories: { driver: true, truck: true, load: true, task: true },
  emailEnabled: false,
});
const [savingNotif, setSavingNotif] = useState(false);

// ── FETCH (adaugă în useEffect de la mount) ──
useEffect(() => {
  const fetchNotifPrefs = async () => {
    try {
      const res = await axios.get(`${apiUrl}/notification-preferences`, config);
      setNotifPrefs(res.data);
    } catch {}
  };
  fetchNotifPrefs();
}, []);

// ── SAVE ──
const handleSaveNotifPrefs = async () => {
  setSavingNotif(true);
  try {
    await axios.put(`${apiUrl}/notification-preferences`, notifPrefs, config);
    notify('Notification preferences saved!', 'success');
  } catch {
    notify('Failed to save preferences', 'error');
  } finally {
    setSavingNotif(false);
  }
};
    
const handleDriverUpdate = () => {
  if (!selectedDriver) return;

  const updatePayload = {
    email: driverEmail,
    password: driverPassword
  };

  axios.put(`${apiUrl}/drivers/${selectedDriver._id}/updateCredentials`, updatePayload, config)
    .then(() => {
      notify('Driver credentials updated successfully!' , 'success');
    })
    .catch(error => {
      notify('Failed to update driver credentials.' , 'error');
    });
};


  const handleBlockDriver = () => {
    if (!selectedDriver) return;

    const updatedDriver = { ...selectedDriver, isBlocked: true };
    handleUpdateDriver(updatedDriver);
   notify('Driver account has been blocked!' , 'succes');
  };

  const handleSelectDriver = (driverId) => {
    const driver = drivers.find((d) => d._id === driverId);
    setSelectedDriver(driver);
    setDriverEmail(driver?.email || '');
    setDriverPassword('');
  };


  const handleEnableTwoFactorAuth = () => {
    axios.post(`${apiUrl}/enable-two-factor`, { method: 'email' }, config)
      .then(() => {
       notify('Two-Factor Authentication via Email enabled. You will receive a code during login.' , 'success');
        setIsTwoFactorEnabled(true);
        setTwoFactorWarning(false);
      })
      .catch(error => {
       
        notify('Failed to enable Two-Factor Authentication.' , 'error');
      });
  };

  const handleDisableTwoFactorAuth = () => {
    axios.post(`${apiUrl}/disable-two-factor`, {}, config)
      .then(() => {
        notify('Two-Factor Authentication has been disabled!' , 'success');
        setIsTwoFactorEnabled(false);
        setTwoFactorWarning(true);
      })
      .catch(error => {
      
        notify('Failed to disable Two-Factor Authentication.' , 'error');
      });
  };

  useEffect(() => {
    fetchClientData();  
    fetchDispatchers();
    fetchAccountings();
  }, []);

  const [clientData, setClientData] = useState({});

  const fetchClientData = async () => {
    try {
      const clientId = localStorage.getItem('clientId'); // ✅ Asigură-te că este corect
      if (!clientId) {
       
        return;
      }
  
     
  
      const response = await axios.get(`${apiUrl}/clients/${clientId}`, config); // 🔥 Schimbăm endpoint-ul
      setClientData(response.data);
      
    
  
    } catch (error) {
      
    }
  };
  

const fetchDispatchers = async () => {
  try {
    const clientId = localStorage.getItem('clientId'); // ✅ Ia clientId corect
    if (!clientId) {
      
      return;
    }

    const response = await axios.get(`${apiUrl}/dispatchers?clientId=${clientId}`, config);
    // ✅ Asigură-te că șoferii, camioanele și permisiunile sunt incluse
    const dispatchersWithDetails = response.data.map(dispatcher => ({
      ...dispatcher,
      drivers: dispatcher.drivers || [], // Asigură că avem array
      trucks: dispatcher.trucks || [], // Asigură că avem array
      permissions: dispatcher.permissions || [] // Asigură că avem array
    }));

    setDispatchers(dispatchersWithDetails);
  } catch (error) {
  
  }
};

const fetchAccountings = async () => {
  try {
    const clientId = localStorage.getItem('clientId'); // ✅ Ia clientId corect
    if (!clientId) {
     
      return;
    }

    const response = await axios.get(`${apiUrl}/accountings?clientId=${clientId}`, config);
    const accountingsWithDetails = response.data.map(accounting => ({
      ...accounting,
      drivers: accounting.drivers || [], // Asigură că avem array
      trucks: accounting.trucks || [], // Asigură că avem array
      permissions: accounting.permissions || [] // Asigură că avem array
    }));

    setAccountings(accountingsWithDetails);
  } catch (error) {
  
  }
};


const handleSelectAccount = (account) => {
  setSelectedAccount(account);
  setPermissions(account.permissions || []);
};

const handlePermissionChange = (module) => {
  setPermissions((prevPermissions) =>
    prevPermissions.includes(module)
      ? prevPermissions.filter((perm) => perm !== module)
      : [...prevPermissions, module]
  );
};

const handleSavePermissions = async () => {
  if (!selectedAccount) return;

  try {
    await axios.put(`${apiUrl}/set-permissions/${selectedAccount._id}`, {
      permissions,
      role: selectedAccount.role,
    }, config);

   notify(`${selectedAccount.role} permissions updated successfully!` , 'success');
    selectedAccount.role === 'dispatcher' ? fetchDispatchers() : fetchAccountings();
  } catch (error) {
   
    notify('Failed to update permissions.' , 'error');
  }
};

const handleCreateDispatcherOrAccounting = async () => {
  const clientId = localStorage.getItem("clientId");

  const newAccountData = {
    firstName: newAccountFirstName,
    lastName: newAccountLastName,
    email: newAccountEmail,
    phone: newAccountPhone,
    address: newAccountAddress,
    dateOfBirth: newAccountDOB,
    salaryDetails: newAccountSalary,
    password: newAccountPassword,
    role: selectedRole,
    clientId,
    permissions: permissions,
    drivers: selectedDrivers, // ✅ Adaugă șoferii direct la creare
    trucks: selectedTrucks, // ✅ Adaugă camioanele direct la creare
  };

  

  try {
    const response = await axios.post(
      `${apiUrl}/${selectedRole === "dispatcher" ? "dispatchers" : "accountings"}`,
      newAccountData,
      config
    );
  
    notify(`${selectedRole} created successfully!` , 'succes');
    selectedRole === "dispatcher" ? fetchDispatchers() : fetchAccountings();
    clearAccountForm();
  } catch (error) {
   
    notify(`Failed to create ${selectedRole}. Check console for details.` , 'error');
  }
};

  const handleEditAccount = (account) => {
    setSelectedAccount(account);
    setNewAccountFirstName(account.firstName);
    setNewAccountLastName(account.lastName);
    setNewAccountEmail(account.email);
    setNewAccountPhone(account.phone);
    setNewAccountAddress(account.address);
    setNewAccountDOB(account.dateOfBirth);
    setNewAccountSalary({
  payType: account.salaryDetails?.payType || '',
  payAmount: account.salaryDetails?.payAmount || 0,
});
    setSelectedRole(account.role);
    setSelectedDrivers(account.drivers ? account.drivers.map(driver => driver._id) : []);

    // ✅ Preselectează camioanele existente
    setSelectedTrucks(account.trucks ? account.trucks.map(truck => truck._id) : []);
  
    // ✅ Preselectează permisiunile existente
    setPermissions(account.permissions || []);
  };


const handleUpdateAccount = async () => {
  if (!selectedAccount) return;

  const updatedData = {
    firstName: newAccountFirstName,
    lastName: newAccountLastName,
    email: newAccountEmail,
    phone: newAccountPhone,
    address: newAccountAddress,
    dateOfBirth: newAccountDOB,
    salaryDetails: newAccountSalary,
    permissions,
    drivers: selectedDrivers,
    trucks: selectedTrucks,
   
  };

  // 🔥 dacă user-ul a completat un câmp parolă nouă, trimitem și parola
  if (newAccountPassword && newAccountPassword.trim() !== "") {
    updatedData.password = newAccountPassword;
  }

  try {
    await axios.put(
      `${apiUrl}/${selectedRole === "dispatcher" ? "dispatchers" : "accountings"}/${selectedAccount._id}`,
      updatedData,
      config
    );
    notify(`${selectedRole === "dispatcher" ? "Dispatcher" : "Accounting"} updated successfully!`, "success");
    selectedRole === "dispatcher" ? fetchDispatchers() : fetchAccountings();
    clearAccountForm();
  } catch (error) {
    console.error("❌ Update error:", error.response?.data || error.message);
    notify(`Failed to update ${selectedRole}`, "error");
  }
};


  const requestDeleteAccount = (account) => {
    setDeleteTarget(account); // Stocăm contul pentru confirmare
  };
  
  const confirmDeleteAccount = async () => {
    if (!deleteTarget) return;
  
    const accountId = deleteTarget._id;
    const accountType = deleteTarget.role === 'dispatcher' ? 'dispatchers' : 'accountings';
  
    try {
      await axios.delete(`${apiUrl}/${accountType}/${accountId}`, config);
     notify(`${deleteTarget.role} deleted successfully!`, 'success');
      deleteTarget.role === 'dispatcher' ? fetchDispatchers() : fetchAccountings();
    } catch (error) {
     
      notify(`Failed to delete ${deleteTarget.role}` , 'error');
    }
    setDeleteTarget(null); // 🔥 Ascundem notificarea după ștergere
  };
  
  const clearAccountForm = () => {
    setNewAccountFirstName('');
    setNewAccountLastName('');
    setNewAccountEmail('');
    setNewAccountPhone('');
    setNewAccountAddress('');
    setNewAccountDOB('');
    setNewAccountSalary({ payType: '', payAmount: 0 });
    setNewAccountPassword('');
    setSelectedAccount(null);
  };

 return (
  <div
    className={`${styles.settingsSection} ${
      updatedSettings.theme === 'light' ? styles.settingsSectionLight : ''
    }`}
  >
      {twoFactorWarning && (
        <div className={styles.twoFactorWarningsettings}>
          <p style={{ color: 'red' }}>Please set up Two-Factor Authentication to enhance your account security!</p>
        </div>
      )}



      <h2 className={styles.titlesettings}>Settings</h2>
      {clientData.customerNumber && (
  <div className={styles.customerNumberBox}>
    <span className={styles.customerNumberLabel}>Customer Number</span>
    <span className={styles.customerNumberValue}>{clientData.customerNumber}</span>
  </div>
)}

      <form className={styles.settingsFormsettings}>

        <label>Company Name</label>
        <input
          name="companyName"
          value={updatedSettings.companyName || ''}
          onChange={handleChange}
          placeholder="Company Name"
          className={styles.inputFieldsettings}
        />

        <label>Company Address</label>
        <input
          name="companyAddress"
          value={updatedSettings.companyAddress || ''}
          onChange={handleChange}
          placeholder="Company Address"
          className={styles.inputFieldsettings}
        />

        <label>First Name</label>
        <input
          name="firstName"
          value={updatedSettings.firstName || ''}
          onChange={handleChange}
          placeholder="First Name"
          className={styles.inputFieldsettings}
        />

        <label>Last Name</label>
        <input
          name="lastName"
          value={updatedSettings.lastName || ''}
          onChange={handleChange}
          placeholder="Last Name"
          className={styles.inputFieldsettings}
        />

        <label>MC Number</label>
        <input
          name="mcNumber"
          value={updatedSettings.mcNumber || ''}
          onChange={handleChange}
          placeholder="MC Number"
          className={styles.inputFieldsettings}
        />

        <label>Phone Number</label>
        <input
          name="phone"
          value={updatedSettings.phone || ''}
          onChange={handleChange}
          placeholder="Phone Number"
          className={styles.inputFieldsettings}
        />

<label>Fax Number</label>
<input
  name="fax"
  value={updatedSettings.fax || ''}
  onChange={handleChange}
  placeholder="Fax Number"
  className={styles.inputFieldsettings}
/>

        <label>Email</label>
        <input
          name="email"
          value={updatedSettings.email || ''}
          onChange={handleChange}
          placeholder="Email"
          className={styles.inputFieldsettings}
        />
 
        <label>New Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="New Password"
          className={styles.inputFieldsettings}
        />

        <label>Confirm Password</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm Password"
          className={styles.inputFieldsettings}
        />

        <button type="button" onClick={handleSaveSettings} className={styles.submitButtonClientsettings}>
          Save Settings
        </button>
 {/* 🔥 NOU – SELECTOR TEMA */}
        <label>Theme</label>
        <select
          name="theme"
          value={updatedSettings.theme || 'dark'}
          onChange={handleChange}
          className={styles.inputFieldsettings}
        >
          <option value="dark">Dark (Black)</option>
          <option value="light">Light (White)</option>
        </select>
      {/* ================== BILLING ================== */}
<h3 className={styles.billingSettingsTitle}>Billing</h3>

{billingInfo ? (
  <div className={styles.billingSettings}>
    <div className={styles.billingCardBox}>
      <p className={styles.billingSettingsText}>
        <strong>Card:</strong> {billingInfo.card.brand?.toUpperCase()} **** **** **** {billingInfo.card.last4}
      </p>
      <p className={styles.billingSettingsText}>
        <strong>Exp:</strong> {billingInfo.card.expMonth}/{billingInfo.card.expYear}
      </p>

<button
  type="button" // ✅ împiedică refresh-ul
  className={styles.billingSettingsButton}
  onClick={async () => {
    try {
      const clientId = localStorage.getItem("clientId");
      const res = await axios.post(`${apiUrl}/billing/portal`, { clientId }, config);
      if (res.data.url) {
        window.open(res.data.url, "_blank"); // 🔥 deschide direct portalul Stripe
      }
    } catch (err) {
      console.error("Stripe portal error:", err);
      notify("Unable to open billing portal", "error");
    }
  }}
>
  Update Payment Method
</button>

</div>
     <button 
  type="button"
  onClick={() => setShowInvoices(true)} 
  className={styles.billingSettingsButtonSecondary}
>
  View Invoices
</button>
    </div>
) : (
  <p className={styles.billingSettingsLoading}>Loading billing info...</p>
)}



{/* ================== INVOICES MODAL ================== */}
{showInvoices && (
  <div className={styles.billingSettingsModalOverlay}>
    <div className={styles.billingSettingsModal}>
      <h4 className={styles.billingSettingsModalTitle}>Invoices</h4>

      {billingInfo.invoices.length === 0 ? (
        <p className={styles.billingSettingsText}>No invoices yet</p>
      ) : (
        <ul className={styles.billingSettingsInvoiceList}>
          {billingInfo.invoices.map(inv => (
            <li key={inv.id} className={styles.billingSettingsInvoiceItem}>
              <span>#{inv.number}</span>
              <span>{(inv.amount_paid / 100).toFixed(2)} {inv.currency.toUpperCase()}</span>
              <span>{new Date(inv.created * 1000).toLocaleDateString()}</span>
              <a 
                href={inv.hosted_invoice_url} 
                target="_blank" 
                rel="noreferrer" 
                className={styles.billingSettingsInvoiceLink}
              >
                View
              </a>
            </li>
          ))}
        </ul>
      )}

      <button 
        onClick={() => setShowInvoices(false)} 
        className={styles.billingSettingsClose}
      >
        Close
      </button>
    </div>
  </div>
)}

{/* ================== EMAIL CONNECTION ================== */}
<h3 className={styles.subtitlesettings}>Email Integration</h3>

{emailStatus.connected ? (
  <div className={styles.emailConnectedBox}>
    <div className={styles.emailConnectedInfo}>
      <span className={styles.emailConnectedDot} />
      <div>
        <p className={styles.emailConnectedLabel}>Connected</p>
        <p className={styles.emailConnectedAddress}>{emailStatus.email}</p>
        <p className={styles.emailConnectedProvider}>
          via {emailStatus.provider?.toUpperCase()}
        </p>
      </div>
    </div>
    <div className={styles.emailConnectedActions}>
      
      <button
        type="button"
        className={styles.emailDisconnectBtn}
        onClick={handleDisconnectEmail}
      >
        Disconnect
      </button>
    </div>
  </div>
) : (
  <div className={styles.emailConnectBox}>
    <p className={styles.emailConnectDesc}>
      Connect your email to send documents directly from FTS and import attachments.
    </p>
    <div className={styles.emailProviderBtns}>
      <button
        type="button"
        className={styles.emailGmailBtn}
        onClick={handleConnectGmail}
      >
        Connect Gmail
      </button>
    <button
  type="button"
  className={styles.emailOutlookBtn}
  onClick={handleConnectOutlook}
>
  Connect Outlook
</button>
    </div>
  </div>
)}

{showInbox && (
  <div className={styles.emailInboxOverlay}>
    <div className={styles.emailInboxModal}>

      {/* Header */}
      <div className={styles.emailInboxHeader}>
        <h4>📬 Inbox — {emailStatus.email}</h4>
        <button onClick={() => { setShowInbox(false); setSelectedEmail(null); }}>✕</button>
      </div>

      {/* Search */}
      <div className={styles.emailInboxSearchBar}>
        <input
          type="text"
          placeholder="Search emails..."
          value={inboxSearch}
          onChange={handleInboxSearch}
          className={styles.emailInboxSearchInput}
        />
        <button
          className={styles.emailInboxRefreshBtn}
          onClick={() => fetchInbox(inboxSearch)}
        >
          🔄 Refresh
        </button>
      </div>

      {/* Layout split: list + detail */}
      <div className={styles.emailInboxBody}>

        {/* Lista emailuri */}
        <div className={styles.emailInboxList}>
          {loadingInbox ? (
            <p className={styles.emailInboxLoading}>Loading...</p>
          ) : emailInbox.length === 0 ? (
            <p className={styles.emailInboxEmpty}>No emails found.</p>
          ) : (
            emailInbox.map(msg => (
              <div
                key={msg.id}
                className={`${styles.emailInboxItem} ${
                  selectedEmail?.id === msg.id ? styles.emailInboxItemActive : ''
                } ${!msg.isRead ? styles.emailInboxItemUnread : ''}`}
                onClick={() => setSelectedEmail(msg)}
              >
                <div className={styles.emailInboxItemFrom}>
                  {msg.from.replace(/<.*?>/, '').trim() || msg.from}
                </div>
                <div className={styles.emailInboxItemSubject}>
                  {!msg.isRead && <span className={styles.emailUnreadDot} />}
                  {msg.subject}
                </div>
                <div className={styles.emailInboxItemSnippet}>{msg.snippet}</div>
                <div className={styles.emailInboxItemMeta}>
                  <span>{new Date(msg.date).toLocaleDateString()}</span>
                  {msg.attachments.length > 0 && (
                    <span className={styles.emailAttachBadge}>
                      📎 {msg.attachments.length}
                    </span>
                  )}
                </div>
              </div>
            ))
          )}
        </div>

        {/* Email detail */}
        <div className={styles.emailInboxDetail}>
          {!selectedEmail ? (
            <div className={styles.emailInboxDetailEmpty}>
              <p>Select an email to read</p>
            </div>
          ) : (
            <>
              <div className={styles.emailDetailHeader}>
                <h4 className={styles.emailDetailSubject}>{selectedEmail.subject}</h4>
                <p className={styles.emailDetailFrom}><strong>From:</strong> {selectedEmail.from}</p>
                <p className={styles.emailDetailDate}>{new Date(selectedEmail.date).toLocaleString()}</p>
              </div>

              <div className={styles.emailDetailBody}>
                {selectedEmail.body ? (
                  <iframe
                    srcDoc={selectedEmail.body}
                    className={styles.emailDetailIframe}
                    title="Email content"
                    sandbox="allow-same-origin"
                  />
                ) : (
                  <p className={styles.emailDetailSnippet}>{selectedEmail.snippet}</p>
                )}
              </div>

              {/* Atașamente */}
              {selectedEmail.attachments.length > 0 && (
                <div className={styles.emailDetailAttachments}>
                  <p className={styles.emailDetailAttachTitle}>
                    📎 Attachments ({selectedEmail.attachments.length})
                  </p>
                  {selectedEmail.attachments.map(att => (
                    <div key={att.attachmentId} className={styles.emailAttachmentItem}>
                      <span className={styles.emailAttachmentName}>
                        {att.filename}
                        <span className={styles.emailAttachmentSize}>
                          {att.size ? ` (${(att.size / 1024).toFixed(0)} KB)` : ''}
                        </span>
                      </span>
                      <button
                        type="button"
                        className={styles.emailImportBtn}
                        onClick={() => handleImportAttachment(
                          att.messageId,
                          att.attachmentId,
                          att.filename,
                          att.mimeType
                        )}
                      >
                        Import to Documents
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>

    </div>
  </div>
)}

      </form>
       {/* ================== NOTIFICATIONS ================== */}
<h3 className={styles.subtitlesettings}>Notification Preferences</h3>

<div className={styles.notifPrefsBox}>

  {/* Master toggle */}
  <div className={styles.notifRow}>
    <label className={styles.notifLabel}>
      <span>Enable all notifications</span>
      <input
        type="checkbox"
        checked={notifPrefs.enabled}
        onChange={e => setNotifPrefs(p => ({ ...p, enabled: e.target.checked }))}
      />
    </label>
  </div>

  {/* Categorii — disabled dacă master e off */}
  <div className={styles.notifCategories} style={{ opacity: notifPrefs.enabled ? 1 : 0.4, pointerEvents: notifPrefs.enabled ? 'all' : 'none' }}>
    {[
      { key: 'driver', label: 'Driver alerts (license, passport, medical...)' },
      { key: 'truck',  label: 'Truck alerts (inspection, insurance...)' },
      { key: 'load',   label: 'Load alerts (open too long)' },
      { key: 'task',   label: 'Task reminders' },
    ].map(({ key, label }) => (
      <div key={key} className={styles.notifRow}>
        <label className={styles.notifLabel}>
          <span>{label}</span>
          <input
            type="checkbox"
            checked={notifPrefs.categories?.[key] ?? true}
            onChange={e => setNotifPrefs(p => ({
              ...p,
              categories: { ...p.categories, [key]: e.target.checked }
            }))}
          />
        </label>
      </div>
    ))}

    {/* Email toggle */}
    <div className={styles.notifRow} style={{ marginTop: '12px', borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: '12px' }}>
      <label className={styles.notifLabel}>
        <span>
          📧 Send urgent alerts to email
          {emailStatus.connected
            ? <small style={{ opacity: 0.6, marginLeft: 8 }}>({emailStatus.email})</small>
            : <small style={{ color: '#f5a623', marginLeft: 8 }}>(no email connected)</small>
          }
        </span>
        <input
          type="checkbox"
          checked={notifPrefs.emailEnabled}
          disabled={!emailStatus.connected}
          onChange={e => setNotifPrefs(p => ({ ...p, emailEnabled: e.target.checked }))}
        />
      </label>
    </div>
  </div>

  <button
    type="button"
    onClick={handleSaveNotifPrefs}
    disabled={savingNotif}
    className={styles.submitButtonClientsettings}
  >
    {savingNotif ? 'Saving...' : 'Save Notification Preferences'}
  </button>

</div>

<h3 className={styles.subtitleAccountultimateAccount}>Account Management</h3>
<select onChange={e => setSelectedRole(e.target.value)} className={styles.selectFieldAccountsettings}>
  <option value="dispatcher">Dispatcher</option>
  <option value="accounting">Accounting</option>
</select>

<form className={styles.accountFormsettings}>
  <label>First Name</label>
  <input
    type="text"
    value={newAccountFirstName}
    onChange={e => setNewAccountFirstName(e.target.value)}
    placeholder="First Name"
    className={styles.inputFieldAccountsettings}
  />

  <label>Last Name</label>
  <input
    type="text"
    value={newAccountLastName}
    onChange={e => setNewAccountLastName(e.target.value)}
    placeholder="Last Name"
    className={styles.inputFieldAccountsettings}
  />

  <label>Email</label>
  <input
    type="email"
    value={newAccountEmail}
    onChange={e => setNewAccountEmail(e.target.value)}
    placeholder="Email"
    className={styles.inputFieldAccountsettings}
  />

  <label>Phone</label>
  <input
    type="text"
    value={newAccountPhone}
    onChange={e => setNewAccountPhone(e.target.value)}
    placeholder="Phone"
    className={styles.inputFieldAccountsettings}
  />

  <label>Address</label>
  <input
    type="text"
    value={newAccountAddress}
    onChange={e => setNewAccountAddress(e.target.value)}
    placeholder="Address"
    className={styles.inputFieldAccountsettings}
  />

  <label>Date of Birth</label>
  <input
    type="date"
    value={newAccountDOB}
    onChange={e => setNewAccountDOB(e.target.value)}
    placeholder="Date of Birth"
    className={styles.inputFieldAccountsettings}
  />

 <label>Payment Type</label>
<select
  value={newAccountSalary.payType}
  onChange={e => setNewAccountSalary(prev => ({ ...prev, payType: e.target.value }))}
  className={styles.inputFieldAccountsettings}
>
  <option value="">-- Select --</option>
  <option value="Hourly">Hourly</option>
  <option value="Fixed salary">Fixed salary</option>
  <option value="Commission">Commission</option>
  <option value="Weekly">Weekly</option>
  <option value="Monthly">Monthly</option>
</select>

<label>Pay Amount ($)</label>
<input
  type="number"
  value={newAccountSalary.payAmount}
  onChange={e => setNewAccountSalary(prev => ({ ...prev, payAmount: parseFloat(e.target.value) || 0 }))}
  placeholder="0.00"
  className={styles.inputFieldAccountsettings}
/>

  <label>Password</label>
  <input
    type="password"
    value={newAccountPassword}
    onChange={e => setNewAccountPassword(e.target.value)}
    placeholder="Password"
    className={styles.inputFieldAccountsettings}
  />

<h4>Select Drivers</h4>
<div>
  {drivers.map((driver) => (
    <label key={driver._id} style={{ display: "block" }}>
      <input
        type="checkbox"
        checked={selectedDrivers.includes(driver._id)}
        onChange={() => handleDriverSelection(driver._id)}
      />
      {driver.firstName} {driver.lastName}
    </label>
  ))}
</div>

<h4>Select Trucks</h4>
<div>
  {trucks.map((truck) => (
    <label key={truck._id} style={{ display: "block" }}>
      <input
        type="checkbox"
        checked={selectedTrucks.includes(truck._id)}
        onChange={() => handleTruckSelection(truck._id)}
      />
      {truck.truckNumber} - {truck.licensePlate}
    </label>
  ))}
</div>



<h3>Set Permissions</h3>
<div className={styles.permissionsGrid}>
  {[
    { label: 'Dashboard', value: 'dashboard' },
    { label: 'Driver Dashboard', value: 'driver-dashboard' },
    { label: 'Truck Dashboard', value: 'truck-dashboard' },

    { label: 'Accounting Manager', value: 'accounting-manager' },
    { label: 'Driver Pay', value: 'driver-pay' },
    { label: 'Driver Pay Manager', value: 'driverpay-manager' },
    { label: 'Fleet Report', value: 'fleet-report' },
    { label: 'Payroll Employee', value: 'payroll-employee' },
    { label: 'Payroll Manager', value: 'payroll-manager' },
    { label: 'Invoice', value: 'invoice' },
    { label: 'Received Invoices', value: 'receivedInvoices' },
    { label: 'Balance Sheet', value: 'balanceSheet' },
    { label: 'IFTA Manual', value: 'ifta' },
    { label: 'Fuel Report', value: 'fuel-report' },
    { label: 'Additions and Deductions', value: 'truckandtrailer' },

    { label: 'Drivers', value: 'drivers' },
    { label: 'Fleet', value: 'trucks' },
    { label: 'Trailers', value: 'trailers' },
    { label: 'Shippers', value: 'shippers' },
    { label: 'Consignees', value: 'consignee' },
    { label: 'Brokers', value: 'brokers' },
    { label: 'Employees', value: 'employees' },

    { label: 'Load Scheduler', value: 'load-manager' },
    { label: 'Load Tracker', value: 'load-finder' },
 
    { label: 'Settings', value: 'settings' },
    { label: 'Load Entry', value: 'add-new-load' },
  ].map((module) => (
    <label key={module.value} className={styles.permissionLabel}>
      <input
        type="checkbox"
        checked={permissions.includes(module.value)}
        onChange={() => handlePermissionChange(module.value)}
      />
      {module.label}
    </label>
  ))}
</div>


  {deleteTarget !== null && (
  <DeleteNotifications
    message={`Are you sure you want to delete ${deleteTarget.firstName} ${deleteTarget.lastName}'s account?`}
    onConfirm={confirmDeleteAccount}
    onCancel={() => setDeleteTarget(null)}
  />
)}

  <button type="button" onClick={selectedAccount ? handleUpdateAccount : handleCreateDispatcherOrAccounting} className={styles.submitButtonAccountsettings}>
    {selectedAccount ? 'Update Account' : 'Create Account'}
  </button>
  {selectedAccount && (
    <button type="button" onClick={clearAccountForm} className={styles.cancelButtonAccountsettings}>
      Cancel Edit
    </button>
  )}
</form>

<h3 className={styles.subtitleaccountsettings}>Existing Accounts</h3>
<div>
  {[...dispatchers, ...accountings].map((account) => (
    <div key={account._id} className={styles.accountItemsettings}>
      <p>{account.firstName} {account.lastName} - {account.role}</p>
      <div className={styles.accountItemsettingsButtons}>
        <button onClick={() => handleEditAccount(account)} className={styles.editButtonAccountnsettings}>Edit</button>
        <button onClick={() => requestDeleteAccount(account)} className={styles.deleteButtonAccountsettings}>Delete</button>
      </div>
    </div>
  ))}
</div>


<h3 className={styles.subtitlesettings}>Subscription</h3>
<p className={styles.blackTextsettings}>Subscription Type: {subscriptionInfo.subscriptionType}</p>
<p className={styles.blackTextsettings}>Expiration Date: {subscriptionInfo.contractEnd}</p>
<p className={styles.blackTextsettings}>Package: {subscriptionInfo.package}</p>

<h3 className={styles.subtitleTwoFactorsettings}>Two-Factor Authentication</h3>

{/* Selector metodă 2FA */}
<div style={{ marginBottom: '10px' }}>
  <label>Select 2FA Method:</label>
  <select
    value={twoFactorMethod}
    onChange={(e) => setTwoFactorMethod(e.target.value)}
    className={styles.inputFieldsettings}
  >
    <option value="email">Email Code</option>
    <option value="authenticator">Authenticator App</option>
  </select>
</div>

{isTwoFactorEnabled ? (
  <div>
    <p style={{ color: 'green' }}>Two-Factor Authentication is Enabled</p>
    <button onClick={handleDisableTwoFactorAuth} className={styles.deleteButtonTwoFactorsettings}>
      Disable 2FA
    </button>
  </div>
) : (
  <div>
    {twoFactorMethod === 'email' ? (
      <button onClick={handleEnableTwoFactorAuth} className={styles.submitButtonTwoFactorsettings}>
        Enable 2FA via Email
      </button>
    ) : (
      <button onClick={handleEnableAuthenticator} className={styles.submitButtonTwoFactorsettings}>
        Enable 2FA via Authenticator App
      </button>
    )}

{qrCodeUrl && isVerifying2FA && (
  <div style={{ marginTop: '15px', textAlign: 'center' }}>
    <p>Scan this QR Code with your Authenticator App:</p>
    <div style={{ background: 'white', padding: '10px', display: 'inline-block' }}>
      <QRCode value={qrCodeUrl} size={180} />
    </div>
    <p style={{ fontSize: '12px', wordBreak: 'break-word' }}>
      Manual Code: <strong>{authenticatorSecret}</strong>
    </p>
    <input
      type="text"
      placeholder="Enter code from Authenticator app"
      value={verificationCode}
      onChange={(e) => setVerificationCode(e.target.value)}
      className={styles.inputFieldsettings}
      style={{ marginTop: '10px', width: '250px' }}
    />
    <button onClick={handleVerifyAuthenticatorCode} className={styles.submitButtonTwoFactorsettings} style={{ marginTop: '10px' }}>
      Confirm 2FA
    </button>
  </div>
)}

  </div>
)}

<button
  type="button"
  onClick={() => window.location.href = '/client/ITTicket'}
  className={styles.actionButtonfaqsettings}
>
  Submit IT Ticket
</button>
<button onClick={() => window.location.href = '/FaqPage'} className={styles.actionButtonfaqsettings}>
  FAQ
</button>
<EmailPanel />
    </div>
  );
};

export default PremiumPage;